/**
 * THIS FILE IS AUTO-GENERATED by graphql-codegen.
 *
 * Source of truth:
 *   - schema:     https://yglkatpyqlhllsqtpluu.supabase.co/graphql/v1
 *   - operations: apps/hub/src/operations/*.graphql
 *   - config:     apps/hub/codegen.ts
 *
 * Do NOT edit by hand. Run `npm run codegen` from apps/hub to regenerate.
 *
 * Editing a single .graphql operation file produces a localized diff in
 * this file (only the operation result types and *Document constant for
 * that operation change). Apparent large diffs are usually schema drift
 * from new Supabase columns — not unrelated churn.
 *
 * Tagged `linguist-generated=true` in .gitattributes so PR tools collapse it.
 */
/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A high precision floating point value represented as a string */
  BigFloat: { input: number; output: number };
  /** An arbitrary size integer represented as a string */
  BigInt: { input: string; output: string };
  /** An opaque string using for tracking a position in results during pagination */
  Cursor: { input: string; output: string };
  /** A date without time information */
  Date: { input: string; output: string };
  /** A date and time */
  Datetime: { input: string; output: string };
  /** A Javascript Object Notation value serialized as a string */
  JSON: { input: Record<string, any>; output: Record<string, any> };
  /** Any type not handled by the type system */
  Opaque: { input: any; output: any };
  /** A time without date information */
  Time: { input: string; output: string };
  /** A universally unique identifier */
  UUID: { input: string; output: string };
};

/** Boolean expression comparing fields on type "BigFloat" */
export type BigFloatFilter = {
  eq?: InputMaybe<Scalars["BigFloat"]["input"]>;
  gt?: InputMaybe<Scalars["BigFloat"]["input"]>;
  gte?: InputMaybe<Scalars["BigFloat"]["input"]>;
  in?: InputMaybe<Array<Scalars["BigFloat"]["input"]>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars["BigFloat"]["input"]>;
  lte?: InputMaybe<Scalars["BigFloat"]["input"]>;
  neq?: InputMaybe<Scalars["BigFloat"]["input"]>;
};

/** Boolean expression comparing fields on type "BigFloatList" */
export type BigFloatListFilter = {
  containedBy?: InputMaybe<Array<Scalars["BigFloat"]["input"]>>;
  contains?: InputMaybe<Array<Scalars["BigFloat"]["input"]>>;
  eq?: InputMaybe<Array<Scalars["BigFloat"]["input"]>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars["BigFloat"]["input"]>>;
};

/** Boolean expression comparing fields on type "BigInt" */
export type BigIntFilter = {
  eq?: InputMaybe<Scalars["BigInt"]["input"]>;
  gt?: InputMaybe<Scalars["BigInt"]["input"]>;
  gte?: InputMaybe<Scalars["BigInt"]["input"]>;
  in?: InputMaybe<Array<Scalars["BigInt"]["input"]>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars["BigInt"]["input"]>;
  lte?: InputMaybe<Scalars["BigInt"]["input"]>;
  neq?: InputMaybe<Scalars["BigInt"]["input"]>;
};

/** Boolean expression comparing fields on type "BigIntList" */
export type BigIntListFilter = {
  containedBy?: InputMaybe<Array<Scalars["BigInt"]["input"]>>;
  contains?: InputMaybe<Array<Scalars["BigInt"]["input"]>>;
  eq?: InputMaybe<Array<Scalars["BigInt"]["input"]>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars["BigInt"]["input"]>>;
};

/** Boolean expression comparing fields on type "Boolean" */
export type BooleanFilter = {
  eq?: InputMaybe<Scalars["Boolean"]["input"]>;
  is?: InputMaybe<FilterIs>;
};

/** Boolean expression comparing fields on type "BooleanList" */
export type BooleanListFilter = {
  containedBy?: InputMaybe<Array<Scalars["Boolean"]["input"]>>;
  contains?: InputMaybe<Array<Scalars["Boolean"]["input"]>>;
  eq?: InputMaybe<Array<Scalars["Boolean"]["input"]>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars["Boolean"]["input"]>>;
};

/** Boolean expression comparing fields on type "Date" */
export type DateFilter = {
  eq?: InputMaybe<Scalars["Date"]["input"]>;
  gt?: InputMaybe<Scalars["Date"]["input"]>;
  gte?: InputMaybe<Scalars["Date"]["input"]>;
  in?: InputMaybe<Array<Scalars["Date"]["input"]>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars["Date"]["input"]>;
  lte?: InputMaybe<Scalars["Date"]["input"]>;
  neq?: InputMaybe<Scalars["Date"]["input"]>;
};

/** Boolean expression comparing fields on type "DateList" */
export type DateListFilter = {
  containedBy?: InputMaybe<Array<Scalars["Date"]["input"]>>;
  contains?: InputMaybe<Array<Scalars["Date"]["input"]>>;
  eq?: InputMaybe<Array<Scalars["Date"]["input"]>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars["Date"]["input"]>>;
};

/** Boolean expression comparing fields on type "Datetime" */
export type DatetimeFilter = {
  eq?: InputMaybe<Scalars["Datetime"]["input"]>;
  gt?: InputMaybe<Scalars["Datetime"]["input"]>;
  gte?: InputMaybe<Scalars["Datetime"]["input"]>;
  in?: InputMaybe<Array<Scalars["Datetime"]["input"]>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars["Datetime"]["input"]>;
  lte?: InputMaybe<Scalars["Datetime"]["input"]>;
  neq?: InputMaybe<Scalars["Datetime"]["input"]>;
};

/** Boolean expression comparing fields on type "DatetimeList" */
export type DatetimeListFilter = {
  containedBy?: InputMaybe<Array<Scalars["Datetime"]["input"]>>;
  contains?: InputMaybe<Array<Scalars["Datetime"]["input"]>>;
  eq?: InputMaybe<Array<Scalars["Datetime"]["input"]>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars["Datetime"]["input"]>>;
};

export type FilterIs = "NOT_NULL" | "NULL";

/** Boolean expression comparing fields on type "Float" */
export type FloatFilter = {
  eq?: InputMaybe<Scalars["Float"]["input"]>;
  gt?: InputMaybe<Scalars["Float"]["input"]>;
  gte?: InputMaybe<Scalars["Float"]["input"]>;
  in?: InputMaybe<Array<Scalars["Float"]["input"]>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars["Float"]["input"]>;
  lte?: InputMaybe<Scalars["Float"]["input"]>;
  neq?: InputMaybe<Scalars["Float"]["input"]>;
};

/** Boolean expression comparing fields on type "FloatList" */
export type FloatListFilter = {
  containedBy?: InputMaybe<Array<Scalars["Float"]["input"]>>;
  contains?: InputMaybe<Array<Scalars["Float"]["input"]>>;
  eq?: InputMaybe<Array<Scalars["Float"]["input"]>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars["Float"]["input"]>>;
};

/** Boolean expression comparing fields on type "ID" */
export type IdFilter = {
  eq?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Boolean expression comparing fields on type "Int" */
export type IntFilter = {
  eq?: InputMaybe<Scalars["Int"]["input"]>;
  gt?: InputMaybe<Scalars["Int"]["input"]>;
  gte?: InputMaybe<Scalars["Int"]["input"]>;
  in?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars["Int"]["input"]>;
  lte?: InputMaybe<Scalars["Int"]["input"]>;
  neq?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Boolean expression comparing fields on type "IntList" */
export type IntListFilter = {
  containedBy?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  contains?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  eq?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

/** The root type for creating and mutating data */
export type Mutation = {
  __typename?: "Mutation";
  append_meridian_tool_rollup_entry?: Maybe<Scalars["JSON"]["output"]>;
  assign_user_to_document?: Maybe<Scalars["Boolean"]["output"]>;
  assign_user_to_task?: Maybe<Scalars["Boolean"]["output"]>;
  bump_meridian_memory_usage?: Maybe<Scalars["Opaque"]["output"]>;
  calculate_ticket_cost?: Maybe<Scalars["BigFloat"]["output"]>;
  can_access_contact_for_task?: Maybe<Scalars["Boolean"]["output"]>;
  can_access_entity_for_task?: Maybe<Scalars["Boolean"]["output"]>;
  can_manage_tasks?: Maybe<Scalars["Boolean"]["output"]>;
  claim_slack_event?: Maybe<Scalars["Boolean"]["output"]>;
  clear_user_data?: Maybe<Scalars["Opaque"]["output"]>;
  client_can_create_ticket_for_contact?: Maybe<Scalars["Boolean"]["output"]>;
  consume_rate_token?: Maybe<Scalars["Float"]["output"]>;
  create_app_user_for_verified_user?: Maybe<Scalars["Opaque"]["output"]>;
  /** Deletes zero or more records from the `address_geocode_cache` collection */
  deleteFromaddress_geocode_cacheCollection: Address_Geocode_CacheDeleteResponse;
  /** Deletes zero or more records from the `app_user_skills` collection */
  deleteFromapp_user_skillsCollection: App_User_SkillsDeleteResponse;
  /** Deletes zero or more records from the `app_users` collection */
  deleteFromapp_usersCollection: App_UsersDeleteResponse;
  /** Deletes zero or more records from the `audit_log` collection */
  deleteFromaudit_logCollection: Audit_LogDeleteResponse;
  /** Deletes zero or more records from the `automation_rules` collection */
  deleteFromautomation_rulesCollection: Automation_RulesDeleteResponse;
  /** Deletes zero or more records from the `booking_history` collection */
  deleteFrombooking_historyCollection: Booking_HistoryDeleteResponse;
  /** Deletes zero or more records from the `calendar_cache` collection */
  deleteFromcalendar_cacheCollection: Calendar_CacheDeleteResponse;
  /** Deletes zero or more records from the `communication_types` collection */
  deleteFromcommunication_typesCollection: Communication_TypesDeleteResponse;
  /** Deletes zero or more records from the `communications` collection */
  deleteFromcommunicationsCollection: CommunicationsDeleteResponse;
  /** Deletes zero or more records from the `companies` collection */
  deleteFromcompaniesCollection: CompaniesDeleteResponse;
  /** Deletes zero or more records from the `company_quickbooks_customers` collection */
  deleteFromcompany_quickbooks_customersCollection: Company_Quickbooks_CustomersDeleteResponse;
  /** Deletes zero or more records from the `company_slack_channel_link_ignores` collection */
  deleteFromcompany_slack_channel_link_ignoresCollection: Company_Slack_Channel_Link_IgnoresDeleteResponse;
  /** Deletes zero or more records from the `company_user_access` collection */
  deleteFromcompany_user_accessCollection: Company_User_AccessDeleteResponse;
  /** Deletes zero or more records from the `connection_shares` collection */
  deleteFromconnection_sharesCollection: Connection_SharesDeleteResponse;
  /** Deletes zero or more records from the `contact_files` collection */
  deleteFromcontact_filesCollection: Contact_FilesDeleteResponse;
  /** Deletes zero or more records from the `contact_meetings` collection */
  deleteFromcontact_meetingsCollection: Contact_MeetingsDeleteResponse;
  /** Deletes zero or more records from the `contact_merge_ignores` collection */
  deleteFromcontact_merge_ignoresCollection: Contact_Merge_IgnoresDeleteResponse;
  /** Deletes zero or more records from the `contact_messages` collection */
  deleteFromcontact_messagesCollection: Contact_MessagesDeleteResponse;
  /** Deletes zero or more records from the `contact_method_claims` collection */
  deleteFromcontact_method_claimsCollection: Contact_Method_ClaimsDeleteResponse;
  /** Deletes zero or more records from the `contact_notes` collection */
  deleteFromcontact_notesCollection: Contact_NotesDeleteResponse;
  /** Deletes zero or more records from the `contact_proposals` collection */
  deleteFromcontact_proposalsCollection: Contact_ProposalsDeleteResponse;
  /** Deletes zero or more records from the `contact_tasks` collection */
  deleteFromcontact_tasksCollection: Contact_TasksDeleteResponse;
  /** Deletes zero or more records from the `contact_user_access` collection */
  deleteFromcontact_user_accessCollection: Contact_User_AccessDeleteResponse;
  /** Deletes zero or more records from the `contacts` collection */
  deleteFromcontactsCollection: ContactsDeleteResponse;
  /** Deletes zero or more records from the `contract_previews` collection */
  deleteFromcontract_previewsCollection: Contract_PreviewsDeleteResponse;
  /** Deletes zero or more records from the `contracts` collection */
  deleteFromcontractsCollection: ContractsDeleteResponse;
  /** Deletes zero or more records from the `crm_remediation_backup` collection */
  deleteFromcrm_remediation_backupCollection: Crm_Remediation_BackupDeleteResponse;
  /** Deletes zero or more records from the `cron_job_runs` collection */
  deleteFromcron_job_runsCollection: Cron_Job_RunsDeleteResponse;
  /** Deletes zero or more records from the `customer_feedback` collection */
  deleteFromcustomer_feedbackCollection: Customer_FeedbackDeleteResponse;
  /** Deletes zero or more records from the `deals` collection */
  deleteFromdealsCollection: DealsDeleteResponse;
  /** Deletes zero or more records from the `device_push_tokens` collection */
  deleteFromdevice_push_tokensCollection: Device_Push_TokensDeleteResponse;
  /** Deletes zero or more records from the `document_embeddings` collection */
  deleteFromdocument_embeddingsCollection: Document_EmbeddingsDeleteResponse;
  /** Deletes zero or more records from the `drive_nodes` collection */
  deleteFromdrive_nodesCollection: Drive_NodesDeleteResponse;
  /** Deletes zero or more records from the `drive_user_roots` collection */
  deleteFromdrive_user_rootsCollection: Drive_User_RootsDeleteResponse;
  /** Deletes zero or more records from the `email_audiences` collection */
  deleteFromemail_audiencesCollection: Email_AudiencesDeleteResponse;
  /** Deletes zero or more records from the `email_campaign_recipients` collection */
  deleteFromemail_campaign_recipientsCollection: Email_Campaign_RecipientsDeleteResponse;
  /** Deletes zero or more records from the `email_campaigns` collection */
  deleteFromemail_campaignsCollection: Email_CampaignsDeleteResponse;
  /** Deletes zero or more records from the `email_events` collection */
  deleteFromemail_eventsCollection: Email_EventsDeleteResponse;
  /** Deletes zero or more records from the `email_forwarding_log` collection */
  deleteFromemail_forwarding_logCollection: Email_Forwarding_LogDeleteResponse;
  /** Deletes zero or more records from the `email_signatures` collection */
  deleteFromemail_signaturesCollection: Email_SignaturesDeleteResponse;
  /** Deletes zero or more records from the `email_template_favorites` collection */
  deleteFromemail_template_favoritesCollection: Email_Template_FavoritesDeleteResponse;
  /** Deletes zero or more records from the `email_template_files` collection */
  deleteFromemail_template_filesCollection: Email_Template_FilesDeleteResponse;
  /** Deletes zero or more records from the `email_template_folders` collection */
  deleteFromemail_template_foldersCollection: Email_Template_FoldersDeleteResponse;
  /** Deletes zero or more records from the `email_template_shares` collection */
  deleteFromemail_template_sharesCollection: Email_Template_SharesDeleteResponse;
  /** Deletes zero or more records from the `email_templates` collection */
  deleteFromemail_templatesCollection: Email_TemplatesDeleteResponse;
  /** Deletes zero or more records from the `email_tracking_open_events` collection */
  deleteFromemail_tracking_open_eventsCollection: Email_Tracking_Open_EventsDeleteResponse;
  /** Deletes zero or more records from the `email_tracking_tokens` collection */
  deleteFromemail_tracking_tokensCollection: Email_Tracking_TokensDeleteResponse;
  /** Deletes zero or more records from the `email_unsubscribes` collection */
  deleteFromemail_unsubscribesCollection: Email_UnsubscribesDeleteResponse;
  /** Deletes zero or more records from the `embedding_jobs` collection */
  deleteFromembedding_jobsCollection: Embedding_JobsDeleteResponse;
  /** Deletes zero or more records from the `employee_contact_access` collection */
  deleteFromemployee_contact_accessCollection: Employee_Contact_AccessDeleteResponse;
  /** Deletes zero or more records from the `entity_automation_config` collection */
  deleteFromentity_automation_configCollection: Entity_Automation_ConfigDeleteResponse;
  /** Deletes zero or more records from the `gemini_notes_sync` collection */
  deleteFromgemini_notes_syncCollection: Gemini_Notes_SyncDeleteResponse;
  /** Deletes zero or more records from the `generic_email_domains` collection */
  deleteFromgeneric_email_domainsCollection: Generic_Email_DomainsDeleteResponse;
  /** Deletes zero or more records from the `google_drive_access_grants` collection */
  deleteFromgoogle_drive_access_grantsCollection: Google_Drive_Access_GrantsDeleteResponse;
  /** Deletes zero or more records from the `google_group_enrollments` collection */
  deleteFromgoogle_group_enrollmentsCollection: Google_Group_EnrollmentsDeleteResponse;
  /** Deletes zero or more records from the `inbound_sender_rules` collection */
  deleteFrominbound_sender_rulesCollection: Inbound_Sender_RulesDeleteResponse;
  /** Deletes zero or more records from the `invoice_dunning_log` collection */
  deleteFrominvoice_dunning_logCollection: Invoice_Dunning_LogDeleteResponse;
  /** Deletes zero or more records from the `ios_metric_payloads` collection */
  deleteFromios_metric_payloadsCollection: Ios_Metric_PayloadsDeleteResponse;
  /** Deletes zero or more records from the `mail_user_settings` collection */
  deleteFrommail_user_settingsCollection: Mail_User_SettingsDeleteResponse;
  /** Deletes zero or more records from the `marketing_brands` collection */
  deleteFrommarketing_brandsCollection: Marketing_BrandsDeleteResponse;
  /** Deletes zero or more records from the `mcp_server_connections` collection */
  deleteFrommcp_server_connectionsCollection: Mcp_Server_ConnectionsDeleteResponse;
  /** Deletes zero or more records from the `meridian_chat_summaries` collection */
  deleteFrommeridian_chat_summariesCollection: Meridian_Chat_SummariesDeleteResponse;
  /** Deletes zero or more records from the `meridian_chats` collection */
  deleteFrommeridian_chatsCollection: Meridian_ChatsDeleteResponse;
  /** Deletes zero or more records from the `meridian_messages` collection */
  deleteFrommeridian_messagesCollection: Meridian_MessagesDeleteResponse;
  /** Deletes zero or more records from the `meridian_skill_activations` collection */
  deleteFrommeridian_skill_activationsCollection: Meridian_Skill_ActivationsDeleteResponse;
  /** Deletes zero or more records from the `meridian_skills` collection */
  deleteFrommeridian_skillsCollection: Meridian_SkillsDeleteResponse;
  /** Deletes zero or more records from the `meridian_skills_sync_state` collection */
  deleteFrommeridian_skills_sync_stateCollection: Meridian_Skills_Sync_StateDeleteResponse;
  /** Deletes zero or more records from the `meridian_tool_approval_overrides` collection */
  deleteFrommeridian_tool_approval_overridesCollection: Meridian_Tool_Approval_OverridesDeleteResponse;
  /** Deletes zero or more records from the `meridian_tool_approvals` collection */
  deleteFrommeridian_tool_approvalsCollection: Meridian_Tool_ApprovalsDeleteResponse;
  /** Deletes zero or more records from the `meridian_tool_io` collection */
  deleteFrommeridian_tool_ioCollection: Meridian_Tool_IoDeleteResponse;
  /** Deletes zero or more records from the `meridian_tool_results` collection */
  deleteFrommeridian_tool_resultsCollection: Meridian_Tool_ResultsDeleteResponse;
  /** Deletes zero or more records from the `meridian_tool_rollups` collection */
  deleteFrommeridian_tool_rollupsCollection: Meridian_Tool_RollupsDeleteResponse;
  /** Deletes zero or more records from the `meridian_usage_events` collection */
  deleteFrommeridian_usage_eventsCollection: Meridian_Usage_EventsDeleteResponse;
  /** Deletes zero or more records from the `meridian_user_memories` collection */
  deleteFrommeridian_user_memoriesCollection: Meridian_User_MemoriesDeleteResponse;
  /** Deletes zero or more records from the `mrr_snapshots` collection */
  deleteFrommrr_snapshotsCollection: Mrr_SnapshotsDeleteResponse;
  /** Deletes zero or more records from the `msp_documents` collection */
  deleteFrommsp_documentsCollection: Msp_DocumentsDeleteResponse;
  /** Deletes zero or more records from the `notetaker_summary_log` collection */
  deleteFromnotetaker_summary_logCollection: Notetaker_Summary_LogDeleteResponse;
  /** Deletes zero or more records from the `notification_preferences` collection */
  deleteFromnotification_preferencesCollection: Notification_PreferencesDeleteResponse;
  /** Deletes zero or more records from the `offerings` collection */
  deleteFromofferingsCollection: OfferingsDeleteResponse;
  /** Deletes zero or more records from the `pending_approvals` collection */
  deleteFrompending_approvalsCollection: Pending_ApprovalsDeleteResponse;
  /** Deletes zero or more records from the `plaid_accounts` collection */
  deleteFromplaid_accountsCollection: Plaid_AccountsDeleteResponse;
  /** Deletes zero or more records from the `plaid_items` collection */
  deleteFromplaid_itemsCollection: Plaid_ItemsDeleteResponse;
  /** Deletes zero or more records from the `plaid_statements` collection */
  deleteFromplaid_statementsCollection: Plaid_StatementsDeleteResponse;
  /** Deletes zero or more records from the `plaid_transaction_attributions` collection */
  deleteFromplaid_transaction_attributionsCollection: Plaid_Transaction_AttributionsDeleteResponse;
  /** Deletes zero or more records from the `plaid_transactions` collection */
  deleteFromplaid_transactionsCollection: Plaid_TransactionsDeleteResponse;
  /** Deletes zero or more records from the `post_audit_cron_logs` collection */
  deleteFrompost_audit_cron_logsCollection: Post_Audit_Cron_LogsDeleteResponse;
  /** Deletes zero or more records from the `post_audit_documents` collection */
  deleteFrompost_audit_documentsCollection: Post_Audit_DocumentsDeleteResponse;
  /** Deletes zero or more records from the `post_audit_invoice_feedback` collection */
  deleteFrompost_audit_invoice_feedbackCollection: Post_Audit_Invoice_FeedbackDeleteResponse;
  /** Deletes zero or more records from the `post_audit_invoices` collection */
  deleteFrompost_audit_invoicesCollection: Post_Audit_InvoicesDeleteResponse;
  /** Deletes zero or more records from the `project_chat_subscriptions` collection */
  deleteFromproject_chat_subscriptionsCollection: Project_Chat_SubscriptionsDeleteResponse;
  /** Deletes zero or more records from the `queue_event_log` collection */
  deleteFromqueue_event_logCollection: Queue_Event_LogDeleteResponse;
  /** Deletes zero or more records from the `quickbooks_company_customer_acks` collection */
  deleteFromquickbooks_company_customer_acksCollection: Quickbooks_Company_Customer_AcksDeleteResponse;
  /** Deletes zero or more records from the `quickbooks_customer_link_ignores` collection */
  deleteFromquickbooks_customer_link_ignoresCollection: Quickbooks_Customer_Link_IgnoresDeleteResponse;
  /** Deletes zero or more records from the `quickbooks_realm_labels` collection */
  deleteFromquickbooks_realm_labelsCollection: Quickbooks_Realm_LabelsDeleteResponse;
  /** Deletes zero or more records from the `quo_sync_op_failures` collection */
  deleteFromquo_sync_op_failuresCollection: Quo_Sync_Op_FailuresDeleteResponse;
  /** Deletes zero or more records from the `rate_limit_buckets` collection */
  deleteFromrate_limit_bucketsCollection: Rate_Limit_BucketsDeleteResponse;
  /** Deletes zero or more records from the `recurring_charges` collection */
  deleteFromrecurring_chargesCollection: Recurring_ChargesDeleteResponse;
  /** Deletes zero or more records from the `recurring_transactions` collection */
  deleteFromrecurring_transactionsCollection: Recurring_TransactionsDeleteResponse;
  /** Deletes zero or more records from the `revenue_targets` collection */
  deleteFromrevenue_targetsCollection: Revenue_TargetsDeleteResponse;
  /** Deletes zero or more records from the `roles` collection */
  deleteFromrolesCollection: RolesDeleteResponse;
  /** Deletes zero or more records from the `sales_sequence_enrollments` collection */
  deleteFromsales_sequence_enrollmentsCollection: Sales_Sequence_EnrollmentsDeleteResponse;
  /** Deletes zero or more records from the `sales_sequence_step_events` collection */
  deleteFromsales_sequence_step_eventsCollection: Sales_Sequence_Step_EventsDeleteResponse;
  /** Deletes zero or more records from the `sales_sequence_steps` collection */
  deleteFromsales_sequence_stepsCollection: Sales_Sequence_StepsDeleteResponse;
  /** Deletes zero or more records from the `sales_sequences` collection */
  deleteFromsales_sequencesCollection: Sales_SequencesDeleteResponse;
  /** Deletes zero or more records from the `saved_view_favorites` collection */
  deleteFromsaved_view_favoritesCollection: Saved_View_FavoritesDeleteResponse;
  /** Deletes zero or more records from the `saved_views` collection */
  deleteFromsaved_viewsCollection: Saved_ViewsDeleteResponse;
  /** Deletes zero or more records from the `scheduled_emails` collection */
  deleteFromscheduled_emailsCollection: Scheduled_EmailsDeleteResponse;
  /** Deletes zero or more records from the `scheduled_sms` collection */
  deleteFromscheduled_smsCollection: Scheduled_SmsDeleteResponse;
  /** Deletes zero or more records from the `secure_links` collection */
  deleteFromsecure_linksCollection: Secure_LinksDeleteResponse;
  /** Deletes zero or more records from the `skills_catalog` collection */
  deleteFromskills_catalogCollection: Skills_CatalogDeleteResponse;
  /** Deletes zero or more records from the `slack_channel_provisioning` collection */
  deleteFromslack_channel_provisioningCollection: Slack_Channel_ProvisioningDeleteResponse;
  /** Deletes zero or more records from the `slack_processed_events` collection */
  deleteFromslack_processed_eventsCollection: Slack_Processed_EventsDeleteResponse;
  /** Deletes zero or more records from the `social_brand_channels` collection */
  deleteFromsocial_brand_channelsCollection: Social_Brand_ChannelsDeleteResponse;
  /** Deletes zero or more records from the `social_brand_credentials` collection */
  deleteFromsocial_brand_credentialsCollection: Social_Brand_CredentialsDeleteResponse;
  /** Deletes zero or more records from the `social_hashtag_groups` collection */
  deleteFromsocial_hashtag_groupsCollection: Social_Hashtag_GroupsDeleteResponse;
  /** Deletes zero or more records from the `social_media_posts` collection */
  deleteFromsocial_media_postsCollection: Social_Media_PostsDeleteResponse;
  /** Deletes zero or more records from the `task_notes` collection */
  deleteFromtask_notesCollection: Task_NotesDeleteResponse;
  /** Deletes zero or more records from the `ticket_attachments` collection */
  deleteFromticket_attachmentsCollection: Ticket_AttachmentsDeleteResponse;
  /** Deletes zero or more records from the `ticket_templates` collection */
  deleteFromticket_templatesCollection: Ticket_TemplatesDeleteResponse;
  /** Deletes zero or more records from the `ticket_updates` collection */
  deleteFromticket_updatesCollection: Ticket_UpdatesDeleteResponse;
  /** Deletes zero or more records from the `tickets` collection */
  deleteFromticketsCollection: TicketsDeleteResponse;
  /** Deletes zero or more records from the `time_entries` collection */
  deleteFromtime_entriesCollection: Time_EntriesDeleteResponse;
  /** Deletes zero or more records from the `user_oauth_connections` collection */
  deleteFromuser_oauth_connectionsCollection: User_Oauth_ConnectionsDeleteResponse;
  /** Deletes zero or more records from the `user_preferences` collection */
  deleteFromuser_preferencesCollection: User_PreferencesDeleteResponse;
  delete_company?: Maybe<Scalars["JSON"]["output"]>;
  generate_uuid?: Maybe<Scalars["UUID"]["output"]>;
  get_accessible_companies_count?: Maybe<Scalars["Int"]["output"]>;
  get_company_billing_rate?: Maybe<Scalars["BigFloat"]["output"]>;
  has_permission?: Maybe<Scalars["Boolean"]["output"]>;
  increment_msp_document_access?: Maybe<Scalars["Opaque"]["output"]>;
  /** Adds one or more `address_geocode_cache` records to the collection */
  insertIntoaddress_geocode_cacheCollection?: Maybe<Address_Geocode_CacheInsertResponse>;
  /** Adds one or more `app_user_skills` records to the collection */
  insertIntoapp_user_skillsCollection?: Maybe<App_User_SkillsInsertResponse>;
  /** Adds one or more `app_users` records to the collection */
  insertIntoapp_usersCollection?: Maybe<App_UsersInsertResponse>;
  /** Adds one or more `audit_log` records to the collection */
  insertIntoaudit_logCollection?: Maybe<Audit_LogInsertResponse>;
  /** Adds one or more `automation_rules` records to the collection */
  insertIntoautomation_rulesCollection?: Maybe<Automation_RulesInsertResponse>;
  /** Adds one or more `booking_history` records to the collection */
  insertIntobooking_historyCollection?: Maybe<Booking_HistoryInsertResponse>;
  /** Adds one or more `calendar_cache` records to the collection */
  insertIntocalendar_cacheCollection?: Maybe<Calendar_CacheInsertResponse>;
  /** Adds one or more `communication_types` records to the collection */
  insertIntocommunication_typesCollection?: Maybe<Communication_TypesInsertResponse>;
  /** Adds one or more `communications` records to the collection */
  insertIntocommunicationsCollection?: Maybe<CommunicationsInsertResponse>;
  /** Adds one or more `companies` records to the collection */
  insertIntocompaniesCollection?: Maybe<CompaniesInsertResponse>;
  /** Adds one or more `company_quickbooks_customers` records to the collection */
  insertIntocompany_quickbooks_customersCollection?: Maybe<Company_Quickbooks_CustomersInsertResponse>;
  /** Adds one or more `company_slack_channel_link_ignores` records to the collection */
  insertIntocompany_slack_channel_link_ignoresCollection?: Maybe<Company_Slack_Channel_Link_IgnoresInsertResponse>;
  /** Adds one or more `company_user_access` records to the collection */
  insertIntocompany_user_accessCollection?: Maybe<Company_User_AccessInsertResponse>;
  /** Adds one or more `connection_shares` records to the collection */
  insertIntoconnection_sharesCollection?: Maybe<Connection_SharesInsertResponse>;
  /** Adds one or more `contact_files` records to the collection */
  insertIntocontact_filesCollection?: Maybe<Contact_FilesInsertResponse>;
  /** Adds one or more `contact_meetings` records to the collection */
  insertIntocontact_meetingsCollection?: Maybe<Contact_MeetingsInsertResponse>;
  /** Adds one or more `contact_merge_ignores` records to the collection */
  insertIntocontact_merge_ignoresCollection?: Maybe<Contact_Merge_IgnoresInsertResponse>;
  /** Adds one or more `contact_messages` records to the collection */
  insertIntocontact_messagesCollection?: Maybe<Contact_MessagesInsertResponse>;
  /** Adds one or more `contact_method_claims` records to the collection */
  insertIntocontact_method_claimsCollection?: Maybe<Contact_Method_ClaimsInsertResponse>;
  /** Adds one or more `contact_notes` records to the collection */
  insertIntocontact_notesCollection?: Maybe<Contact_NotesInsertResponse>;
  /** Adds one or more `contact_proposals` records to the collection */
  insertIntocontact_proposalsCollection?: Maybe<Contact_ProposalsInsertResponse>;
  /** Adds one or more `contact_tasks` records to the collection */
  insertIntocontact_tasksCollection?: Maybe<Contact_TasksInsertResponse>;
  /** Adds one or more `contact_user_access` records to the collection */
  insertIntocontact_user_accessCollection?: Maybe<Contact_User_AccessInsertResponse>;
  /** Adds one or more `contacts` records to the collection */
  insertIntocontactsCollection?: Maybe<ContactsInsertResponse>;
  /** Adds one or more `contract_previews` records to the collection */
  insertIntocontract_previewsCollection?: Maybe<Contract_PreviewsInsertResponse>;
  /** Adds one or more `contracts` records to the collection */
  insertIntocontractsCollection?: Maybe<ContractsInsertResponse>;
  /** Adds one or more `crm_remediation_backup` records to the collection */
  insertIntocrm_remediation_backupCollection?: Maybe<Crm_Remediation_BackupInsertResponse>;
  /** Adds one or more `cron_job_runs` records to the collection */
  insertIntocron_job_runsCollection?: Maybe<Cron_Job_RunsInsertResponse>;
  /** Adds one or more `customer_feedback` records to the collection */
  insertIntocustomer_feedbackCollection?: Maybe<Customer_FeedbackInsertResponse>;
  /** Adds one or more `deals` records to the collection */
  insertIntodealsCollection?: Maybe<DealsInsertResponse>;
  /** Adds one or more `device_push_tokens` records to the collection */
  insertIntodevice_push_tokensCollection?: Maybe<Device_Push_TokensInsertResponse>;
  /** Adds one or more `document_embeddings` records to the collection */
  insertIntodocument_embeddingsCollection?: Maybe<Document_EmbeddingsInsertResponse>;
  /** Adds one or more `drive_nodes` records to the collection */
  insertIntodrive_nodesCollection?: Maybe<Drive_NodesInsertResponse>;
  /** Adds one or more `drive_user_roots` records to the collection */
  insertIntodrive_user_rootsCollection?: Maybe<Drive_User_RootsInsertResponse>;
  /** Adds one or more `email_audiences` records to the collection */
  insertIntoemail_audiencesCollection?: Maybe<Email_AudiencesInsertResponse>;
  /** Adds one or more `email_campaign_recipients` records to the collection */
  insertIntoemail_campaign_recipientsCollection?: Maybe<Email_Campaign_RecipientsInsertResponse>;
  /** Adds one or more `email_campaigns` records to the collection */
  insertIntoemail_campaignsCollection?: Maybe<Email_CampaignsInsertResponse>;
  /** Adds one or more `email_events` records to the collection */
  insertIntoemail_eventsCollection?: Maybe<Email_EventsInsertResponse>;
  /** Adds one or more `email_forwarding_log` records to the collection */
  insertIntoemail_forwarding_logCollection?: Maybe<Email_Forwarding_LogInsertResponse>;
  /** Adds one or more `email_signatures` records to the collection */
  insertIntoemail_signaturesCollection?: Maybe<Email_SignaturesInsertResponse>;
  /** Adds one or more `email_template_favorites` records to the collection */
  insertIntoemail_template_favoritesCollection?: Maybe<Email_Template_FavoritesInsertResponse>;
  /** Adds one or more `email_template_files` records to the collection */
  insertIntoemail_template_filesCollection?: Maybe<Email_Template_FilesInsertResponse>;
  /** Adds one or more `email_template_folders` records to the collection */
  insertIntoemail_template_foldersCollection?: Maybe<Email_Template_FoldersInsertResponse>;
  /** Adds one or more `email_template_shares` records to the collection */
  insertIntoemail_template_sharesCollection?: Maybe<Email_Template_SharesInsertResponse>;
  /** Adds one or more `email_templates` records to the collection */
  insertIntoemail_templatesCollection?: Maybe<Email_TemplatesInsertResponse>;
  /** Adds one or more `email_tracking_open_events` records to the collection */
  insertIntoemail_tracking_open_eventsCollection?: Maybe<Email_Tracking_Open_EventsInsertResponse>;
  /** Adds one or more `email_tracking_tokens` records to the collection */
  insertIntoemail_tracking_tokensCollection?: Maybe<Email_Tracking_TokensInsertResponse>;
  /** Adds one or more `email_unsubscribes` records to the collection */
  insertIntoemail_unsubscribesCollection?: Maybe<Email_UnsubscribesInsertResponse>;
  /** Adds one or more `embedding_jobs` records to the collection */
  insertIntoembedding_jobsCollection?: Maybe<Embedding_JobsInsertResponse>;
  /** Adds one or more `employee_contact_access` records to the collection */
  insertIntoemployee_contact_accessCollection?: Maybe<Employee_Contact_AccessInsertResponse>;
  /** Adds one or more `entity_automation_config` records to the collection */
  insertIntoentity_automation_configCollection?: Maybe<Entity_Automation_ConfigInsertResponse>;
  /** Adds one or more `gemini_notes_sync` records to the collection */
  insertIntogemini_notes_syncCollection?: Maybe<Gemini_Notes_SyncInsertResponse>;
  /** Adds one or more `generic_email_domains` records to the collection */
  insertIntogeneric_email_domainsCollection?: Maybe<Generic_Email_DomainsInsertResponse>;
  /** Adds one or more `google_drive_access_grants` records to the collection */
  insertIntogoogle_drive_access_grantsCollection?: Maybe<Google_Drive_Access_GrantsInsertResponse>;
  /** Adds one or more `google_group_enrollments` records to the collection */
  insertIntogoogle_group_enrollmentsCollection?: Maybe<Google_Group_EnrollmentsInsertResponse>;
  /** Adds one or more `inbound_sender_rules` records to the collection */
  insertIntoinbound_sender_rulesCollection?: Maybe<Inbound_Sender_RulesInsertResponse>;
  /** Adds one or more `invoice_dunning_log` records to the collection */
  insertIntoinvoice_dunning_logCollection?: Maybe<Invoice_Dunning_LogInsertResponse>;
  /** Adds one or more `ios_metric_payloads` records to the collection */
  insertIntoios_metric_payloadsCollection?: Maybe<Ios_Metric_PayloadsInsertResponse>;
  /** Adds one or more `mail_user_settings` records to the collection */
  insertIntomail_user_settingsCollection?: Maybe<Mail_User_SettingsInsertResponse>;
  /** Adds one or more `marketing_brands` records to the collection */
  insertIntomarketing_brandsCollection?: Maybe<Marketing_BrandsInsertResponse>;
  /** Adds one or more `mcp_server_connections` records to the collection */
  insertIntomcp_server_connectionsCollection?: Maybe<Mcp_Server_ConnectionsInsertResponse>;
  /** Adds one or more `meridian_chat_summaries` records to the collection */
  insertIntomeridian_chat_summariesCollection?: Maybe<Meridian_Chat_SummariesInsertResponse>;
  /** Adds one or more `meridian_chats` records to the collection */
  insertIntomeridian_chatsCollection?: Maybe<Meridian_ChatsInsertResponse>;
  /** Adds one or more `meridian_messages` records to the collection */
  insertIntomeridian_messagesCollection?: Maybe<Meridian_MessagesInsertResponse>;
  /** Adds one or more `meridian_skill_activations` records to the collection */
  insertIntomeridian_skill_activationsCollection?: Maybe<Meridian_Skill_ActivationsInsertResponse>;
  /** Adds one or more `meridian_skills` records to the collection */
  insertIntomeridian_skillsCollection?: Maybe<Meridian_SkillsInsertResponse>;
  /** Adds one or more `meridian_skills_sync_state` records to the collection */
  insertIntomeridian_skills_sync_stateCollection?: Maybe<Meridian_Skills_Sync_StateInsertResponse>;
  /** Adds one or more `meridian_tool_approval_overrides` records to the collection */
  insertIntomeridian_tool_approval_overridesCollection?: Maybe<Meridian_Tool_Approval_OverridesInsertResponse>;
  /** Adds one or more `meridian_tool_approvals` records to the collection */
  insertIntomeridian_tool_approvalsCollection?: Maybe<Meridian_Tool_ApprovalsInsertResponse>;
  /** Adds one or more `meridian_tool_io` records to the collection */
  insertIntomeridian_tool_ioCollection?: Maybe<Meridian_Tool_IoInsertResponse>;
  /** Adds one or more `meridian_tool_results` records to the collection */
  insertIntomeridian_tool_resultsCollection?: Maybe<Meridian_Tool_ResultsInsertResponse>;
  /** Adds one or more `meridian_tool_rollups` records to the collection */
  insertIntomeridian_tool_rollupsCollection?: Maybe<Meridian_Tool_RollupsInsertResponse>;
  /** Adds one or more `meridian_usage_events` records to the collection */
  insertIntomeridian_usage_eventsCollection?: Maybe<Meridian_Usage_EventsInsertResponse>;
  /** Adds one or more `meridian_user_memories` records to the collection */
  insertIntomeridian_user_memoriesCollection?: Maybe<Meridian_User_MemoriesInsertResponse>;
  /** Adds one or more `mrr_snapshots` records to the collection */
  insertIntomrr_snapshotsCollection?: Maybe<Mrr_SnapshotsInsertResponse>;
  /** Adds one or more `msp_documents` records to the collection */
  insertIntomsp_documentsCollection?: Maybe<Msp_DocumentsInsertResponse>;
  /** Adds one or more `notetaker_summary_log` records to the collection */
  insertIntonotetaker_summary_logCollection?: Maybe<Notetaker_Summary_LogInsertResponse>;
  /** Adds one or more `notification_preferences` records to the collection */
  insertIntonotification_preferencesCollection?: Maybe<Notification_PreferencesInsertResponse>;
  /** Adds one or more `offerings` records to the collection */
  insertIntoofferingsCollection?: Maybe<OfferingsInsertResponse>;
  /** Adds one or more `pending_approvals` records to the collection */
  insertIntopending_approvalsCollection?: Maybe<Pending_ApprovalsInsertResponse>;
  /** Adds one or more `plaid_accounts` records to the collection */
  insertIntoplaid_accountsCollection?: Maybe<Plaid_AccountsInsertResponse>;
  /** Adds one or more `plaid_items` records to the collection */
  insertIntoplaid_itemsCollection?: Maybe<Plaid_ItemsInsertResponse>;
  /** Adds one or more `plaid_statements` records to the collection */
  insertIntoplaid_statementsCollection?: Maybe<Plaid_StatementsInsertResponse>;
  /** Adds one or more `plaid_transaction_attributions` records to the collection */
  insertIntoplaid_transaction_attributionsCollection?: Maybe<Plaid_Transaction_AttributionsInsertResponse>;
  /** Adds one or more `plaid_transactions` records to the collection */
  insertIntoplaid_transactionsCollection?: Maybe<Plaid_TransactionsInsertResponse>;
  /** Adds one or more `post_audit_cron_logs` records to the collection */
  insertIntopost_audit_cron_logsCollection?: Maybe<Post_Audit_Cron_LogsInsertResponse>;
  /** Adds one or more `post_audit_documents` records to the collection */
  insertIntopost_audit_documentsCollection?: Maybe<Post_Audit_DocumentsInsertResponse>;
  /** Adds one or more `post_audit_invoice_feedback` records to the collection */
  insertIntopost_audit_invoice_feedbackCollection?: Maybe<Post_Audit_Invoice_FeedbackInsertResponse>;
  /** Adds one or more `post_audit_invoices` records to the collection */
  insertIntopost_audit_invoicesCollection?: Maybe<Post_Audit_InvoicesInsertResponse>;
  /** Adds one or more `project_chat_subscriptions` records to the collection */
  insertIntoproject_chat_subscriptionsCollection?: Maybe<Project_Chat_SubscriptionsInsertResponse>;
  /** Adds one or more `queue_event_log` records to the collection */
  insertIntoqueue_event_logCollection?: Maybe<Queue_Event_LogInsertResponse>;
  /** Adds one or more `quickbooks_company_customer_acks` records to the collection */
  insertIntoquickbooks_company_customer_acksCollection?: Maybe<Quickbooks_Company_Customer_AcksInsertResponse>;
  /** Adds one or more `quickbooks_customer_link_ignores` records to the collection */
  insertIntoquickbooks_customer_link_ignoresCollection?: Maybe<Quickbooks_Customer_Link_IgnoresInsertResponse>;
  /** Adds one or more `quickbooks_realm_labels` records to the collection */
  insertIntoquickbooks_realm_labelsCollection?: Maybe<Quickbooks_Realm_LabelsInsertResponse>;
  /** Adds one or more `quo_sync_op_failures` records to the collection */
  insertIntoquo_sync_op_failuresCollection?: Maybe<Quo_Sync_Op_FailuresInsertResponse>;
  /** Adds one or more `rate_limit_buckets` records to the collection */
  insertIntorate_limit_bucketsCollection?: Maybe<Rate_Limit_BucketsInsertResponse>;
  /** Adds one or more `recurring_charges` records to the collection */
  insertIntorecurring_chargesCollection?: Maybe<Recurring_ChargesInsertResponse>;
  /** Adds one or more `recurring_transactions` records to the collection */
  insertIntorecurring_transactionsCollection?: Maybe<Recurring_TransactionsInsertResponse>;
  /** Adds one or more `revenue_targets` records to the collection */
  insertIntorevenue_targetsCollection?: Maybe<Revenue_TargetsInsertResponse>;
  /** Adds one or more `roles` records to the collection */
  insertIntorolesCollection?: Maybe<RolesInsertResponse>;
  /** Adds one or more `sales_sequence_enrollments` records to the collection */
  insertIntosales_sequence_enrollmentsCollection?: Maybe<Sales_Sequence_EnrollmentsInsertResponse>;
  /** Adds one or more `sales_sequence_step_events` records to the collection */
  insertIntosales_sequence_step_eventsCollection?: Maybe<Sales_Sequence_Step_EventsInsertResponse>;
  /** Adds one or more `sales_sequence_steps` records to the collection */
  insertIntosales_sequence_stepsCollection?: Maybe<Sales_Sequence_StepsInsertResponse>;
  /** Adds one or more `sales_sequences` records to the collection */
  insertIntosales_sequencesCollection?: Maybe<Sales_SequencesInsertResponse>;
  /** Adds one or more `saved_view_favorites` records to the collection */
  insertIntosaved_view_favoritesCollection?: Maybe<Saved_View_FavoritesInsertResponse>;
  /** Adds one or more `saved_views` records to the collection */
  insertIntosaved_viewsCollection?: Maybe<Saved_ViewsInsertResponse>;
  /** Adds one or more `scheduled_emails` records to the collection */
  insertIntoscheduled_emailsCollection?: Maybe<Scheduled_EmailsInsertResponse>;
  /** Adds one or more `scheduled_sms` records to the collection */
  insertIntoscheduled_smsCollection?: Maybe<Scheduled_SmsInsertResponse>;
  /** Adds one or more `secure_links` records to the collection */
  insertIntosecure_linksCollection?: Maybe<Secure_LinksInsertResponse>;
  /** Adds one or more `skills_catalog` records to the collection */
  insertIntoskills_catalogCollection?: Maybe<Skills_CatalogInsertResponse>;
  /** Adds one or more `slack_channel_provisioning` records to the collection */
  insertIntoslack_channel_provisioningCollection?: Maybe<Slack_Channel_ProvisioningInsertResponse>;
  /** Adds one or more `slack_processed_events` records to the collection */
  insertIntoslack_processed_eventsCollection?: Maybe<Slack_Processed_EventsInsertResponse>;
  /** Adds one or more `social_brand_channels` records to the collection */
  insertIntosocial_brand_channelsCollection?: Maybe<Social_Brand_ChannelsInsertResponse>;
  /** Adds one or more `social_brand_credentials` records to the collection */
  insertIntosocial_brand_credentialsCollection?: Maybe<Social_Brand_CredentialsInsertResponse>;
  /** Adds one or more `social_hashtag_groups` records to the collection */
  insertIntosocial_hashtag_groupsCollection?: Maybe<Social_Hashtag_GroupsInsertResponse>;
  /** Adds one or more `social_media_posts` records to the collection */
  insertIntosocial_media_postsCollection?: Maybe<Social_Media_PostsInsertResponse>;
  /** Adds one or more `task_notes` records to the collection */
  insertIntotask_notesCollection?: Maybe<Task_NotesInsertResponse>;
  /** Adds one or more `ticket_attachments` records to the collection */
  insertIntoticket_attachmentsCollection?: Maybe<Ticket_AttachmentsInsertResponse>;
  /** Adds one or more `ticket_templates` records to the collection */
  insertIntoticket_templatesCollection?: Maybe<Ticket_TemplatesInsertResponse>;
  /** Adds one or more `ticket_updates` records to the collection */
  insertIntoticket_updatesCollection?: Maybe<Ticket_UpdatesInsertResponse>;
  /** Adds one or more `tickets` records to the collection */
  insertIntoticketsCollection?: Maybe<TicketsInsertResponse>;
  /** Adds one or more `time_entries` records to the collection */
  insertIntotime_entriesCollection?: Maybe<Time_EntriesInsertResponse>;
  /** Adds one or more `user_oauth_connections` records to the collection */
  insertIntouser_oauth_connectionsCollection?: Maybe<User_Oauth_ConnectionsInsertResponse>;
  /** Adds one or more `user_preferences` records to the collection */
  insertIntouser_preferencesCollection?: Maybe<User_PreferencesInsertResponse>;
  log_queue_event?: Maybe<Scalars["Opaque"]["output"]>;
  record_secure_link_use?: Maybe<Scalars["Opaque"]["output"]>;
  refresh_company_contact_count?: Maybe<Scalars["Opaque"]["output"]>;
  refresh_company_contract_status?: Maybe<Scalars["Opaque"]["output"]>;
  refresh_company_deal_status?: Maybe<Scalars["Opaque"]["output"]>;
  refresh_company_last_contacted_at?: Maybe<Scalars["Opaque"]["output"]>;
  refresh_company_ticket_status?: Maybe<Scalars["Opaque"]["output"]>;
  refresh_contact_last_contacted_at?: Maybe<Scalars["Opaque"]["output"]>;
  refresh_deals_last_communication_for_company?: Maybe<Scalars["Opaque"]["output"]>;
  refresh_deals_search_for_company?: Maybe<Scalars["Opaque"]["output"]>;
  refresh_employee_contact_access_denorm?: Maybe<Scalars["Opaque"]["output"]>;
  set_app_user_config?: Maybe<Scalars["JSON"]["output"]>;
  set_app_user_tags?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  set_cognito_user_context?: Maybe<Scalars["Opaque"]["output"]>;
  set_meridian_tool_rollup_anchor?: Maybe<Scalars["Boolean"]["output"]>;
  sweep_slack_processed_events?: Maybe<Scalars["Int"]["output"]>;
  unassign_user_from_document?: Maybe<Scalars["Boolean"]["output"]>;
  unassign_user_from_task?: Maybe<Scalars["Boolean"]["output"]>;
  update_time_entry_quickbooks_refs?: Maybe<Scalars["Boolean"]["output"]>;
  update_user_prefs?: Maybe<Scalars["JSON"]["output"]>;
  /** Updates zero or more records in the `address_geocode_cache` collection */
  updateaddress_geocode_cacheCollection: Address_Geocode_CacheUpdateResponse;
  /** Updates zero or more records in the `app_user_skills` collection */
  updateapp_user_skillsCollection: App_User_SkillsUpdateResponse;
  /** Updates zero or more records in the `app_users` collection */
  updateapp_usersCollection: App_UsersUpdateResponse;
  /** Updates zero or more records in the `audit_log` collection */
  updateaudit_logCollection: Audit_LogUpdateResponse;
  /** Updates zero or more records in the `automation_rules` collection */
  updateautomation_rulesCollection: Automation_RulesUpdateResponse;
  /** Updates zero or more records in the `booking_history` collection */
  updatebooking_historyCollection: Booking_HistoryUpdateResponse;
  /** Updates zero or more records in the `calendar_cache` collection */
  updatecalendar_cacheCollection: Calendar_CacheUpdateResponse;
  /** Updates zero or more records in the `communication_types` collection */
  updatecommunication_typesCollection: Communication_TypesUpdateResponse;
  /** Updates zero or more records in the `communications` collection */
  updatecommunicationsCollection: CommunicationsUpdateResponse;
  /** Updates zero or more records in the `companies` collection */
  updatecompaniesCollection: CompaniesUpdateResponse;
  /** Updates zero or more records in the `company_quickbooks_customers` collection */
  updatecompany_quickbooks_customersCollection: Company_Quickbooks_CustomersUpdateResponse;
  /** Updates zero or more records in the `company_slack_channel_link_ignores` collection */
  updatecompany_slack_channel_link_ignoresCollection: Company_Slack_Channel_Link_IgnoresUpdateResponse;
  /** Updates zero or more records in the `company_user_access` collection */
  updatecompany_user_accessCollection: Company_User_AccessUpdateResponse;
  /** Updates zero or more records in the `connection_shares` collection */
  updateconnection_sharesCollection: Connection_SharesUpdateResponse;
  /** Updates zero or more records in the `contact_files` collection */
  updatecontact_filesCollection: Contact_FilesUpdateResponse;
  /** Updates zero or more records in the `contact_meetings` collection */
  updatecontact_meetingsCollection: Contact_MeetingsUpdateResponse;
  /** Updates zero or more records in the `contact_merge_ignores` collection */
  updatecontact_merge_ignoresCollection: Contact_Merge_IgnoresUpdateResponse;
  /** Updates zero or more records in the `contact_messages` collection */
  updatecontact_messagesCollection: Contact_MessagesUpdateResponse;
  /** Updates zero or more records in the `contact_method_claims` collection */
  updatecontact_method_claimsCollection: Contact_Method_ClaimsUpdateResponse;
  /** Updates zero or more records in the `contact_notes` collection */
  updatecontact_notesCollection: Contact_NotesUpdateResponse;
  /** Updates zero or more records in the `contact_proposals` collection */
  updatecontact_proposalsCollection: Contact_ProposalsUpdateResponse;
  /** Updates zero or more records in the `contact_tasks` collection */
  updatecontact_tasksCollection: Contact_TasksUpdateResponse;
  /** Updates zero or more records in the `contact_user_access` collection */
  updatecontact_user_accessCollection: Contact_User_AccessUpdateResponse;
  /** Updates zero or more records in the `contacts` collection */
  updatecontactsCollection: ContactsUpdateResponse;
  /** Updates zero or more records in the `contract_previews` collection */
  updatecontract_previewsCollection: Contract_PreviewsUpdateResponse;
  /** Updates zero or more records in the `contracts` collection */
  updatecontractsCollection: ContractsUpdateResponse;
  /** Updates zero or more records in the `crm_remediation_backup` collection */
  updatecrm_remediation_backupCollection: Crm_Remediation_BackupUpdateResponse;
  /** Updates zero or more records in the `cron_job_runs` collection */
  updatecron_job_runsCollection: Cron_Job_RunsUpdateResponse;
  /** Updates zero or more records in the `customer_feedback` collection */
  updatecustomer_feedbackCollection: Customer_FeedbackUpdateResponse;
  /** Updates zero or more records in the `deals` collection */
  updatedealsCollection: DealsUpdateResponse;
  /** Updates zero or more records in the `device_push_tokens` collection */
  updatedevice_push_tokensCollection: Device_Push_TokensUpdateResponse;
  /** Updates zero or more records in the `document_embeddings` collection */
  updatedocument_embeddingsCollection: Document_EmbeddingsUpdateResponse;
  /** Updates zero or more records in the `drive_nodes` collection */
  updatedrive_nodesCollection: Drive_NodesUpdateResponse;
  /** Updates zero or more records in the `drive_user_roots` collection */
  updatedrive_user_rootsCollection: Drive_User_RootsUpdateResponse;
  /** Updates zero or more records in the `email_audiences` collection */
  updateemail_audiencesCollection: Email_AudiencesUpdateResponse;
  /** Updates zero or more records in the `email_campaign_recipients` collection */
  updateemail_campaign_recipientsCollection: Email_Campaign_RecipientsUpdateResponse;
  /** Updates zero or more records in the `email_campaigns` collection */
  updateemail_campaignsCollection: Email_CampaignsUpdateResponse;
  /** Updates zero or more records in the `email_events` collection */
  updateemail_eventsCollection: Email_EventsUpdateResponse;
  /** Updates zero or more records in the `email_forwarding_log` collection */
  updateemail_forwarding_logCollection: Email_Forwarding_LogUpdateResponse;
  /** Updates zero or more records in the `email_signatures` collection */
  updateemail_signaturesCollection: Email_SignaturesUpdateResponse;
  /** Updates zero or more records in the `email_template_favorites` collection */
  updateemail_template_favoritesCollection: Email_Template_FavoritesUpdateResponse;
  /** Updates zero or more records in the `email_template_files` collection */
  updateemail_template_filesCollection: Email_Template_FilesUpdateResponse;
  /** Updates zero or more records in the `email_template_folders` collection */
  updateemail_template_foldersCollection: Email_Template_FoldersUpdateResponse;
  /** Updates zero or more records in the `email_template_shares` collection */
  updateemail_template_sharesCollection: Email_Template_SharesUpdateResponse;
  /** Updates zero or more records in the `email_templates` collection */
  updateemail_templatesCollection: Email_TemplatesUpdateResponse;
  /** Updates zero or more records in the `email_tracking_open_events` collection */
  updateemail_tracking_open_eventsCollection: Email_Tracking_Open_EventsUpdateResponse;
  /** Updates zero or more records in the `email_tracking_tokens` collection */
  updateemail_tracking_tokensCollection: Email_Tracking_TokensUpdateResponse;
  /** Updates zero or more records in the `email_unsubscribes` collection */
  updateemail_unsubscribesCollection: Email_UnsubscribesUpdateResponse;
  /** Updates zero or more records in the `embedding_jobs` collection */
  updateembedding_jobsCollection: Embedding_JobsUpdateResponse;
  /** Updates zero or more records in the `employee_contact_access` collection */
  updateemployee_contact_accessCollection: Employee_Contact_AccessUpdateResponse;
  /** Updates zero or more records in the `entity_automation_config` collection */
  updateentity_automation_configCollection: Entity_Automation_ConfigUpdateResponse;
  /** Updates zero or more records in the `gemini_notes_sync` collection */
  updategemini_notes_syncCollection: Gemini_Notes_SyncUpdateResponse;
  /** Updates zero or more records in the `generic_email_domains` collection */
  updategeneric_email_domainsCollection: Generic_Email_DomainsUpdateResponse;
  /** Updates zero or more records in the `google_drive_access_grants` collection */
  updategoogle_drive_access_grantsCollection: Google_Drive_Access_GrantsUpdateResponse;
  /** Updates zero or more records in the `google_group_enrollments` collection */
  updategoogle_group_enrollmentsCollection: Google_Group_EnrollmentsUpdateResponse;
  /** Updates zero or more records in the `inbound_sender_rules` collection */
  updateinbound_sender_rulesCollection: Inbound_Sender_RulesUpdateResponse;
  /** Updates zero or more records in the `invoice_dunning_log` collection */
  updateinvoice_dunning_logCollection: Invoice_Dunning_LogUpdateResponse;
  /** Updates zero or more records in the `ios_metric_payloads` collection */
  updateios_metric_payloadsCollection: Ios_Metric_PayloadsUpdateResponse;
  /** Updates zero or more records in the `mail_user_settings` collection */
  updatemail_user_settingsCollection: Mail_User_SettingsUpdateResponse;
  /** Updates zero or more records in the `marketing_brands` collection */
  updatemarketing_brandsCollection: Marketing_BrandsUpdateResponse;
  /** Updates zero or more records in the `mcp_server_connections` collection */
  updatemcp_server_connectionsCollection: Mcp_Server_ConnectionsUpdateResponse;
  /** Updates zero or more records in the `meridian_chat_summaries` collection */
  updatemeridian_chat_summariesCollection: Meridian_Chat_SummariesUpdateResponse;
  /** Updates zero or more records in the `meridian_chats` collection */
  updatemeridian_chatsCollection: Meridian_ChatsUpdateResponse;
  /** Updates zero or more records in the `meridian_messages` collection */
  updatemeridian_messagesCollection: Meridian_MessagesUpdateResponse;
  /** Updates zero or more records in the `meridian_skill_activations` collection */
  updatemeridian_skill_activationsCollection: Meridian_Skill_ActivationsUpdateResponse;
  /** Updates zero or more records in the `meridian_skills` collection */
  updatemeridian_skillsCollection: Meridian_SkillsUpdateResponse;
  /** Updates zero or more records in the `meridian_skills_sync_state` collection */
  updatemeridian_skills_sync_stateCollection: Meridian_Skills_Sync_StateUpdateResponse;
  /** Updates zero or more records in the `meridian_tool_approval_overrides` collection */
  updatemeridian_tool_approval_overridesCollection: Meridian_Tool_Approval_OverridesUpdateResponse;
  /** Updates zero or more records in the `meridian_tool_approvals` collection */
  updatemeridian_tool_approvalsCollection: Meridian_Tool_ApprovalsUpdateResponse;
  /** Updates zero or more records in the `meridian_tool_io` collection */
  updatemeridian_tool_ioCollection: Meridian_Tool_IoUpdateResponse;
  /** Updates zero or more records in the `meridian_tool_results` collection */
  updatemeridian_tool_resultsCollection: Meridian_Tool_ResultsUpdateResponse;
  /** Updates zero or more records in the `meridian_tool_rollups` collection */
  updatemeridian_tool_rollupsCollection: Meridian_Tool_RollupsUpdateResponse;
  /** Updates zero or more records in the `meridian_usage_events` collection */
  updatemeridian_usage_eventsCollection: Meridian_Usage_EventsUpdateResponse;
  /** Updates zero or more records in the `meridian_user_memories` collection */
  updatemeridian_user_memoriesCollection: Meridian_User_MemoriesUpdateResponse;
  /** Updates zero or more records in the `mrr_snapshots` collection */
  updatemrr_snapshotsCollection: Mrr_SnapshotsUpdateResponse;
  /** Updates zero or more records in the `msp_documents` collection */
  updatemsp_documentsCollection: Msp_DocumentsUpdateResponse;
  /** Updates zero or more records in the `notetaker_summary_log` collection */
  updatenotetaker_summary_logCollection: Notetaker_Summary_LogUpdateResponse;
  /** Updates zero or more records in the `notification_preferences` collection */
  updatenotification_preferencesCollection: Notification_PreferencesUpdateResponse;
  /** Updates zero or more records in the `offerings` collection */
  updateofferingsCollection: OfferingsUpdateResponse;
  /** Updates zero or more records in the `pending_approvals` collection */
  updatepending_approvalsCollection: Pending_ApprovalsUpdateResponse;
  /** Updates zero or more records in the `plaid_accounts` collection */
  updateplaid_accountsCollection: Plaid_AccountsUpdateResponse;
  /** Updates zero or more records in the `plaid_items` collection */
  updateplaid_itemsCollection: Plaid_ItemsUpdateResponse;
  /** Updates zero or more records in the `plaid_statements` collection */
  updateplaid_statementsCollection: Plaid_StatementsUpdateResponse;
  /** Updates zero or more records in the `plaid_transaction_attributions` collection */
  updateplaid_transaction_attributionsCollection: Plaid_Transaction_AttributionsUpdateResponse;
  /** Updates zero or more records in the `plaid_transactions` collection */
  updateplaid_transactionsCollection: Plaid_TransactionsUpdateResponse;
  /** Updates zero or more records in the `post_audit_cron_logs` collection */
  updatepost_audit_cron_logsCollection: Post_Audit_Cron_LogsUpdateResponse;
  /** Updates zero or more records in the `post_audit_documents` collection */
  updatepost_audit_documentsCollection: Post_Audit_DocumentsUpdateResponse;
  /** Updates zero or more records in the `post_audit_invoice_feedback` collection */
  updatepost_audit_invoice_feedbackCollection: Post_Audit_Invoice_FeedbackUpdateResponse;
  /** Updates zero or more records in the `post_audit_invoices` collection */
  updatepost_audit_invoicesCollection: Post_Audit_InvoicesUpdateResponse;
  /** Updates zero or more records in the `project_chat_subscriptions` collection */
  updateproject_chat_subscriptionsCollection: Project_Chat_SubscriptionsUpdateResponse;
  /** Updates zero or more records in the `queue_event_log` collection */
  updatequeue_event_logCollection: Queue_Event_LogUpdateResponse;
  /** Updates zero or more records in the `quickbooks_company_customer_acks` collection */
  updatequickbooks_company_customer_acksCollection: Quickbooks_Company_Customer_AcksUpdateResponse;
  /** Updates zero or more records in the `quickbooks_customer_link_ignores` collection */
  updatequickbooks_customer_link_ignoresCollection: Quickbooks_Customer_Link_IgnoresUpdateResponse;
  /** Updates zero or more records in the `quickbooks_realm_labels` collection */
  updatequickbooks_realm_labelsCollection: Quickbooks_Realm_LabelsUpdateResponse;
  /** Updates zero or more records in the `quo_sync_op_failures` collection */
  updatequo_sync_op_failuresCollection: Quo_Sync_Op_FailuresUpdateResponse;
  /** Updates zero or more records in the `rate_limit_buckets` collection */
  updaterate_limit_bucketsCollection: Rate_Limit_BucketsUpdateResponse;
  /** Updates zero or more records in the `recurring_charges` collection */
  updaterecurring_chargesCollection: Recurring_ChargesUpdateResponse;
  /** Updates zero or more records in the `recurring_transactions` collection */
  updaterecurring_transactionsCollection: Recurring_TransactionsUpdateResponse;
  /** Updates zero or more records in the `revenue_targets` collection */
  updaterevenue_targetsCollection: Revenue_TargetsUpdateResponse;
  /** Updates zero or more records in the `roles` collection */
  updaterolesCollection: RolesUpdateResponse;
  /** Updates zero or more records in the `sales_sequence_enrollments` collection */
  updatesales_sequence_enrollmentsCollection: Sales_Sequence_EnrollmentsUpdateResponse;
  /** Updates zero or more records in the `sales_sequence_step_events` collection */
  updatesales_sequence_step_eventsCollection: Sales_Sequence_Step_EventsUpdateResponse;
  /** Updates zero or more records in the `sales_sequence_steps` collection */
  updatesales_sequence_stepsCollection: Sales_Sequence_StepsUpdateResponse;
  /** Updates zero or more records in the `sales_sequences` collection */
  updatesales_sequencesCollection: Sales_SequencesUpdateResponse;
  /** Updates zero or more records in the `saved_view_favorites` collection */
  updatesaved_view_favoritesCollection: Saved_View_FavoritesUpdateResponse;
  /** Updates zero or more records in the `saved_views` collection */
  updatesaved_viewsCollection: Saved_ViewsUpdateResponse;
  /** Updates zero or more records in the `scheduled_emails` collection */
  updatescheduled_emailsCollection: Scheduled_EmailsUpdateResponse;
  /** Updates zero or more records in the `scheduled_sms` collection */
  updatescheduled_smsCollection: Scheduled_SmsUpdateResponse;
  /** Updates zero or more records in the `secure_links` collection */
  updatesecure_linksCollection: Secure_LinksUpdateResponse;
  /** Updates zero or more records in the `skills_catalog` collection */
  updateskills_catalogCollection: Skills_CatalogUpdateResponse;
  /** Updates zero or more records in the `slack_channel_provisioning` collection */
  updateslack_channel_provisioningCollection: Slack_Channel_ProvisioningUpdateResponse;
  /** Updates zero or more records in the `slack_processed_events` collection */
  updateslack_processed_eventsCollection: Slack_Processed_EventsUpdateResponse;
  /** Updates zero or more records in the `social_brand_channels` collection */
  updatesocial_brand_channelsCollection: Social_Brand_ChannelsUpdateResponse;
  /** Updates zero or more records in the `social_brand_credentials` collection */
  updatesocial_brand_credentialsCollection: Social_Brand_CredentialsUpdateResponse;
  /** Updates zero or more records in the `social_hashtag_groups` collection */
  updatesocial_hashtag_groupsCollection: Social_Hashtag_GroupsUpdateResponse;
  /** Updates zero or more records in the `social_media_posts` collection */
  updatesocial_media_postsCollection: Social_Media_PostsUpdateResponse;
  /** Updates zero or more records in the `task_notes` collection */
  updatetask_notesCollection: Task_NotesUpdateResponse;
  /** Updates zero or more records in the `ticket_attachments` collection */
  updateticket_attachmentsCollection: Ticket_AttachmentsUpdateResponse;
  /** Updates zero or more records in the `ticket_templates` collection */
  updateticket_templatesCollection: Ticket_TemplatesUpdateResponse;
  /** Updates zero or more records in the `ticket_updates` collection */
  updateticket_updatesCollection: Ticket_UpdatesUpdateResponse;
  /** Updates zero or more records in the `tickets` collection */
  updateticketsCollection: TicketsUpdateResponse;
  /** Updates zero or more records in the `time_entries` collection */
  updatetime_entriesCollection: Time_EntriesUpdateResponse;
  /** Updates zero or more records in the `user_oauth_connections` collection */
  updateuser_oauth_connectionsCollection: User_Oauth_ConnectionsUpdateResponse;
  /** Updates zero or more records in the `user_preferences` collection */
  updateuser_preferencesCollection: User_PreferencesUpdateResponse;
};

/** The root type for creating and mutating data */
export type MutationAppend_Meridian_Tool_Rollup_EntryArgs = {
  p_chat_id: Scalars["String"]["input"];
  p_entry: Scalars["JSON"]["input"];
  p_now: Scalars["BigInt"]["input"];
  p_thread_ts: Scalars["String"]["input"];
  p_window_ms?: InputMaybe<Scalars["BigInt"]["input"]>;
};

/** The root type for creating and mutating data */
export type MutationAssign_User_To_DocumentArgs = {
  document_id_param: Scalars["String"]["input"];
  user_id_param: Scalars["String"]["input"];
};

/** The root type for creating and mutating data */
export type MutationAssign_User_To_TaskArgs = {
  assigned_by_param: Scalars["String"]["input"];
  task_id_param: Scalars["UUID"]["input"];
  user_id_param: Scalars["String"]["input"];
};

/** The root type for creating and mutating data */
export type MutationBump_Meridian_Memory_UsageArgs = {
  p_ids: Array<InputMaybe<Scalars["UUID"]["input"]>>;
};

/** The root type for creating and mutating data */
export type MutationCalculate_Ticket_CostArgs = {
  ticket_uuid: Scalars["UUID"]["input"];
};

/** The root type for creating and mutating data */
export type MutationCan_Access_Contact_For_TaskArgs = {
  task_contact_id: Scalars["UUID"]["input"];
};

/** The root type for creating and mutating data */
export type MutationCan_Access_Entity_For_TaskArgs = {
  task_contact_id: Scalars["UUID"]["input"];
  task_entity_id: Scalars["UUID"]["input"];
  task_entity_type: Scalars["String"]["input"];
};

/** The root type for creating and mutating data */
export type MutationClaim_Slack_EventArgs = {
  p_dedup_key: Scalars["String"]["input"];
  p_payload_type: Scalars["String"]["input"];
  p_ttl_seconds: Scalars["Int"]["input"];
};

/** The root type for creating and mutating data */
export type MutationClear_User_DataArgs = {
  user_email: Scalars["String"]["input"];
};

/** The root type for creating and mutating data */
export type MutationClient_Can_Create_Ticket_For_ContactArgs = {
  contact_uuid: Scalars["UUID"]["input"];
};

/** The root type for creating and mutating data */
export type MutationConsume_Rate_TokenArgs = {
  p_bucket: Scalars["String"]["input"];
  p_burst: Scalars["Float"]["input"];
  p_rate_per_sec: Scalars["Float"]["input"];
};

/** The root type for creating and mutating data */
export type MutationCreate_App_User_For_Verified_UserArgs = {
  auth_user_id: Scalars["UUID"]["input"];
};

/** The root type for creating and mutating data */
export type MutationDeleteFromaddress_Geocode_CacheCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Address_Geocode_CacheFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromapp_User_SkillsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<App_User_SkillsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromapp_UsersCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<App_UsersFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromaudit_LogCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Audit_LogFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromautomation_RulesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Automation_RulesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrombooking_HistoryCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Booking_HistoryFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromcalendar_CacheCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Calendar_CacheFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromcommunication_TypesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Communication_TypesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromcommunicationsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<CommunicationsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromcompaniesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<CompaniesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromcompany_Quickbooks_CustomersCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Company_Quickbooks_CustomersFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromcompany_Slack_Channel_Link_IgnoresCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Company_Slack_Channel_Link_IgnoresFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromcompany_User_AccessCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Company_User_AccessFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromconnection_SharesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Connection_SharesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromcontact_FilesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Contact_FilesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromcontact_MeetingsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Contact_MeetingsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromcontact_Merge_IgnoresCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Contact_Merge_IgnoresFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromcontact_MessagesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Contact_MessagesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromcontact_Method_ClaimsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Contact_Method_ClaimsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromcontact_NotesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Contact_NotesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromcontact_ProposalsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Contact_ProposalsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromcontact_TasksCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Contact_TasksFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromcontact_User_AccessCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Contact_User_AccessFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromcontactsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<ContactsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromcontract_PreviewsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Contract_PreviewsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromcontractsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<ContractsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromcrm_Remediation_BackupCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Crm_Remediation_BackupFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromcron_Job_RunsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Cron_Job_RunsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromcustomer_FeedbackCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Customer_FeedbackFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromdealsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<DealsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromdevice_Push_TokensCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Device_Push_TokensFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromdocument_EmbeddingsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Document_EmbeddingsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromdrive_NodesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Drive_NodesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromdrive_User_RootsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Drive_User_RootsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromemail_AudiencesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_AudiencesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromemail_Campaign_RecipientsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_Campaign_RecipientsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromemail_CampaignsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_CampaignsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromemail_EventsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_EventsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromemail_Forwarding_LogCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_Forwarding_LogFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromemail_SignaturesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_SignaturesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromemail_Template_FavoritesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_Template_FavoritesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromemail_Template_FilesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_Template_FilesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromemail_Template_FoldersCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_Template_FoldersFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromemail_Template_SharesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_Template_SharesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromemail_TemplatesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_TemplatesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromemail_Tracking_Open_EventsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_Tracking_Open_EventsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromemail_Tracking_TokensCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_Tracking_TokensFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromemail_UnsubscribesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_UnsubscribesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromembedding_JobsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Embedding_JobsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromemployee_Contact_AccessCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Employee_Contact_AccessFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromentity_Automation_ConfigCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Entity_Automation_ConfigFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromgemini_Notes_SyncCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Gemini_Notes_SyncFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromgeneric_Email_DomainsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Generic_Email_DomainsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromgoogle_Drive_Access_GrantsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Google_Drive_Access_GrantsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromgoogle_Group_EnrollmentsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Google_Group_EnrollmentsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrominbound_Sender_RulesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Inbound_Sender_RulesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrominvoice_Dunning_LogCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Invoice_Dunning_LogFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromios_Metric_PayloadsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Ios_Metric_PayloadsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrommail_User_SettingsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Mail_User_SettingsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrommarketing_BrandsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Marketing_BrandsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrommcp_Server_ConnectionsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Mcp_Server_ConnectionsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrommeridian_Chat_SummariesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_Chat_SummariesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrommeridian_ChatsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_ChatsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrommeridian_MessagesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_MessagesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrommeridian_Skill_ActivationsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_Skill_ActivationsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrommeridian_SkillsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_SkillsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrommeridian_Skills_Sync_StateCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_Skills_Sync_StateFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrommeridian_Tool_Approval_OverridesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_Tool_Approval_OverridesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrommeridian_Tool_ApprovalsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_Tool_ApprovalsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrommeridian_Tool_IoCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_Tool_IoFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrommeridian_Tool_ResultsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_Tool_ResultsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrommeridian_Tool_RollupsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_Tool_RollupsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrommeridian_Usage_EventsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_Usage_EventsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrommeridian_User_MemoriesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_User_MemoriesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrommrr_SnapshotsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Mrr_SnapshotsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrommsp_DocumentsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Msp_DocumentsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromnotetaker_Summary_LogCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Notetaker_Summary_LogFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromnotification_PreferencesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Notification_PreferencesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromofferingsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<OfferingsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrompending_ApprovalsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Pending_ApprovalsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromplaid_AccountsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Plaid_AccountsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromplaid_ItemsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Plaid_ItemsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromplaid_StatementsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Plaid_StatementsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromplaid_Transaction_AttributionsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Plaid_Transaction_AttributionsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromplaid_TransactionsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Plaid_TransactionsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrompost_Audit_Cron_LogsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Post_Audit_Cron_LogsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrompost_Audit_DocumentsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Post_Audit_DocumentsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrompost_Audit_Invoice_FeedbackCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Post_Audit_Invoice_FeedbackFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFrompost_Audit_InvoicesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Post_Audit_InvoicesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromproject_Chat_SubscriptionsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Project_Chat_SubscriptionsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromqueue_Event_LogCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Queue_Event_LogFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromquickbooks_Company_Customer_AcksCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Quickbooks_Company_Customer_AcksFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromquickbooks_Customer_Link_IgnoresCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Quickbooks_Customer_Link_IgnoresFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromquickbooks_Realm_LabelsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Quickbooks_Realm_LabelsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromquo_Sync_Op_FailuresCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Quo_Sync_Op_FailuresFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromrate_Limit_BucketsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Rate_Limit_BucketsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromrecurring_ChargesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Recurring_ChargesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromrecurring_TransactionsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Recurring_TransactionsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromrevenue_TargetsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Revenue_TargetsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromrolesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<RolesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromsales_Sequence_EnrollmentsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Sales_Sequence_EnrollmentsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromsales_Sequence_Step_EventsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Sales_Sequence_Step_EventsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromsales_Sequence_StepsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Sales_Sequence_StepsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromsales_SequencesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Sales_SequencesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromsaved_View_FavoritesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Saved_View_FavoritesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromsaved_ViewsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Saved_ViewsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromscheduled_EmailsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Scheduled_EmailsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromscheduled_SmsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Scheduled_SmsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromsecure_LinksCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Secure_LinksFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromskills_CatalogCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Skills_CatalogFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromslack_Channel_ProvisioningCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Slack_Channel_ProvisioningFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromslack_Processed_EventsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Slack_Processed_EventsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromsocial_Brand_ChannelsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Social_Brand_ChannelsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromsocial_Brand_CredentialsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Social_Brand_CredentialsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromsocial_Hashtag_GroupsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Social_Hashtag_GroupsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromsocial_Media_PostsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Social_Media_PostsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromtask_NotesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Task_NotesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromticket_AttachmentsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Ticket_AttachmentsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromticket_TemplatesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Ticket_TemplatesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromticket_UpdatesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Ticket_UpdatesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromticketsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<TicketsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromtime_EntriesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Time_EntriesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromuser_Oauth_ConnectionsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<User_Oauth_ConnectionsFilter>;
};

/** The root type for creating and mutating data */
export type MutationDeleteFromuser_PreferencesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<User_PreferencesFilter>;
};

/** The root type for creating and mutating data */
export type MutationDelete_CompanyArgs = {
  company_id_to_delete: Scalars["UUID"]["input"];
};

/** The root type for creating and mutating data */
export type MutationGet_Accessible_Companies_CountArgs = {
  p_filter_search?: InputMaybe<Scalars["String"]["input"]>;
  p_filter_status?: InputMaybe<Scalars["String"]["input"]>;
};

/** The root type for creating and mutating data */
export type MutationGet_Company_Billing_RateArgs = {
  company_uuid: Scalars["UUID"]["input"];
};

/** The root type for creating and mutating data */
export type MutationHas_PermissionArgs = {
  permission_name: Scalars["String"]["input"];
};

/** The root type for creating and mutating data */
export type MutationIncrement_Msp_Document_AccessArgs = {
  document_id: Scalars["UUID"]["input"];
};

/** The root type for creating and mutating data */
export type MutationInsertIntoaddress_Geocode_CacheCollectionArgs = {
  objects: Array<Address_Geocode_CacheInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoapp_User_SkillsCollectionArgs = {
  objects: Array<App_User_SkillsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoapp_UsersCollectionArgs = {
  objects: Array<App_UsersInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoaudit_LogCollectionArgs = {
  objects: Array<Audit_LogInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoautomation_RulesCollectionArgs = {
  objects: Array<Automation_RulesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntobooking_HistoryCollectionArgs = {
  objects: Array<Booking_HistoryInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntocalendar_CacheCollectionArgs = {
  objects: Array<Calendar_CacheInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntocommunication_TypesCollectionArgs = {
  objects: Array<Communication_TypesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntocommunicationsCollectionArgs = {
  objects: Array<CommunicationsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntocompaniesCollectionArgs = {
  objects: Array<CompaniesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntocompany_Quickbooks_CustomersCollectionArgs = {
  objects: Array<Company_Quickbooks_CustomersInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntocompany_Slack_Channel_Link_IgnoresCollectionArgs = {
  objects: Array<Company_Slack_Channel_Link_IgnoresInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntocompany_User_AccessCollectionArgs = {
  objects: Array<Company_User_AccessInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoconnection_SharesCollectionArgs = {
  objects: Array<Connection_SharesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntocontact_FilesCollectionArgs = {
  objects: Array<Contact_FilesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntocontact_MeetingsCollectionArgs = {
  objects: Array<Contact_MeetingsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntocontact_Merge_IgnoresCollectionArgs = {
  objects: Array<Contact_Merge_IgnoresInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntocontact_MessagesCollectionArgs = {
  objects: Array<Contact_MessagesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntocontact_Method_ClaimsCollectionArgs = {
  objects: Array<Contact_Method_ClaimsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntocontact_NotesCollectionArgs = {
  objects: Array<Contact_NotesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntocontact_ProposalsCollectionArgs = {
  objects: Array<Contact_ProposalsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntocontact_TasksCollectionArgs = {
  objects: Array<Contact_TasksInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntocontact_User_AccessCollectionArgs = {
  objects: Array<Contact_User_AccessInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntocontactsCollectionArgs = {
  objects: Array<ContactsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntocontract_PreviewsCollectionArgs = {
  objects: Array<Contract_PreviewsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntocontractsCollectionArgs = {
  objects: Array<ContractsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntocrm_Remediation_BackupCollectionArgs = {
  objects: Array<Crm_Remediation_BackupInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntocron_Job_RunsCollectionArgs = {
  objects: Array<Cron_Job_RunsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntocustomer_FeedbackCollectionArgs = {
  objects: Array<Customer_FeedbackInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntodealsCollectionArgs = {
  objects: Array<DealsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntodevice_Push_TokensCollectionArgs = {
  objects: Array<Device_Push_TokensInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntodocument_EmbeddingsCollectionArgs = {
  objects: Array<Document_EmbeddingsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntodrive_NodesCollectionArgs = {
  objects: Array<Drive_NodesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntodrive_User_RootsCollectionArgs = {
  objects: Array<Drive_User_RootsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoemail_AudiencesCollectionArgs = {
  objects: Array<Email_AudiencesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoemail_Campaign_RecipientsCollectionArgs = {
  objects: Array<Email_Campaign_RecipientsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoemail_CampaignsCollectionArgs = {
  objects: Array<Email_CampaignsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoemail_EventsCollectionArgs = {
  objects: Array<Email_EventsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoemail_Forwarding_LogCollectionArgs = {
  objects: Array<Email_Forwarding_LogInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoemail_SignaturesCollectionArgs = {
  objects: Array<Email_SignaturesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoemail_Template_FavoritesCollectionArgs = {
  objects: Array<Email_Template_FavoritesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoemail_Template_FilesCollectionArgs = {
  objects: Array<Email_Template_FilesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoemail_Template_FoldersCollectionArgs = {
  objects: Array<Email_Template_FoldersInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoemail_Template_SharesCollectionArgs = {
  objects: Array<Email_Template_SharesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoemail_TemplatesCollectionArgs = {
  objects: Array<Email_TemplatesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoemail_Tracking_Open_EventsCollectionArgs = {
  objects: Array<Email_Tracking_Open_EventsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoemail_Tracking_TokensCollectionArgs = {
  objects: Array<Email_Tracking_TokensInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoemail_UnsubscribesCollectionArgs = {
  objects: Array<Email_UnsubscribesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoembedding_JobsCollectionArgs = {
  objects: Array<Embedding_JobsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoemployee_Contact_AccessCollectionArgs = {
  objects: Array<Employee_Contact_AccessInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoentity_Automation_ConfigCollectionArgs = {
  objects: Array<Entity_Automation_ConfigInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntogemini_Notes_SyncCollectionArgs = {
  objects: Array<Gemini_Notes_SyncInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntogeneric_Email_DomainsCollectionArgs = {
  objects: Array<Generic_Email_DomainsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntogoogle_Drive_Access_GrantsCollectionArgs = {
  objects: Array<Google_Drive_Access_GrantsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntogoogle_Group_EnrollmentsCollectionArgs = {
  objects: Array<Google_Group_EnrollmentsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoinbound_Sender_RulesCollectionArgs = {
  objects: Array<Inbound_Sender_RulesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoinvoice_Dunning_LogCollectionArgs = {
  objects: Array<Invoice_Dunning_LogInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoios_Metric_PayloadsCollectionArgs = {
  objects: Array<Ios_Metric_PayloadsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntomail_User_SettingsCollectionArgs = {
  objects: Array<Mail_User_SettingsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntomarketing_BrandsCollectionArgs = {
  objects: Array<Marketing_BrandsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntomcp_Server_ConnectionsCollectionArgs = {
  objects: Array<Mcp_Server_ConnectionsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntomeridian_Chat_SummariesCollectionArgs = {
  objects: Array<Meridian_Chat_SummariesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntomeridian_ChatsCollectionArgs = {
  objects: Array<Meridian_ChatsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntomeridian_MessagesCollectionArgs = {
  objects: Array<Meridian_MessagesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntomeridian_Skill_ActivationsCollectionArgs = {
  objects: Array<Meridian_Skill_ActivationsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntomeridian_SkillsCollectionArgs = {
  objects: Array<Meridian_SkillsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntomeridian_Skills_Sync_StateCollectionArgs = {
  objects: Array<Meridian_Skills_Sync_StateInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntomeridian_Tool_Approval_OverridesCollectionArgs = {
  objects: Array<Meridian_Tool_Approval_OverridesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntomeridian_Tool_ApprovalsCollectionArgs = {
  objects: Array<Meridian_Tool_ApprovalsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntomeridian_Tool_IoCollectionArgs = {
  objects: Array<Meridian_Tool_IoInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntomeridian_Tool_ResultsCollectionArgs = {
  objects: Array<Meridian_Tool_ResultsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntomeridian_Tool_RollupsCollectionArgs = {
  objects: Array<Meridian_Tool_RollupsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntomeridian_Usage_EventsCollectionArgs = {
  objects: Array<Meridian_Usage_EventsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntomeridian_User_MemoriesCollectionArgs = {
  objects: Array<Meridian_User_MemoriesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntomrr_SnapshotsCollectionArgs = {
  objects: Array<Mrr_SnapshotsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntomsp_DocumentsCollectionArgs = {
  objects: Array<Msp_DocumentsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntonotetaker_Summary_LogCollectionArgs = {
  objects: Array<Notetaker_Summary_LogInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntonotification_PreferencesCollectionArgs = {
  objects: Array<Notification_PreferencesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoofferingsCollectionArgs = {
  objects: Array<OfferingsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntopending_ApprovalsCollectionArgs = {
  objects: Array<Pending_ApprovalsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoplaid_AccountsCollectionArgs = {
  objects: Array<Plaid_AccountsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoplaid_ItemsCollectionArgs = {
  objects: Array<Plaid_ItemsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoplaid_StatementsCollectionArgs = {
  objects: Array<Plaid_StatementsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoplaid_Transaction_AttributionsCollectionArgs = {
  objects: Array<Plaid_Transaction_AttributionsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoplaid_TransactionsCollectionArgs = {
  objects: Array<Plaid_TransactionsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntopost_Audit_Cron_LogsCollectionArgs = {
  objects: Array<Post_Audit_Cron_LogsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntopost_Audit_DocumentsCollectionArgs = {
  objects: Array<Post_Audit_DocumentsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntopost_Audit_Invoice_FeedbackCollectionArgs = {
  objects: Array<Post_Audit_Invoice_FeedbackInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntopost_Audit_InvoicesCollectionArgs = {
  objects: Array<Post_Audit_InvoicesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoproject_Chat_SubscriptionsCollectionArgs = {
  objects: Array<Project_Chat_SubscriptionsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoqueue_Event_LogCollectionArgs = {
  objects: Array<Queue_Event_LogInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoquickbooks_Company_Customer_AcksCollectionArgs = {
  objects: Array<Quickbooks_Company_Customer_AcksInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoquickbooks_Customer_Link_IgnoresCollectionArgs = {
  objects: Array<Quickbooks_Customer_Link_IgnoresInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoquickbooks_Realm_LabelsCollectionArgs = {
  objects: Array<Quickbooks_Realm_LabelsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoquo_Sync_Op_FailuresCollectionArgs = {
  objects: Array<Quo_Sync_Op_FailuresInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntorate_Limit_BucketsCollectionArgs = {
  objects: Array<Rate_Limit_BucketsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntorecurring_ChargesCollectionArgs = {
  objects: Array<Recurring_ChargesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntorecurring_TransactionsCollectionArgs = {
  objects: Array<Recurring_TransactionsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntorevenue_TargetsCollectionArgs = {
  objects: Array<Revenue_TargetsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntorolesCollectionArgs = {
  objects: Array<RolesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntosales_Sequence_EnrollmentsCollectionArgs = {
  objects: Array<Sales_Sequence_EnrollmentsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntosales_Sequence_Step_EventsCollectionArgs = {
  objects: Array<Sales_Sequence_Step_EventsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntosales_Sequence_StepsCollectionArgs = {
  objects: Array<Sales_Sequence_StepsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntosales_SequencesCollectionArgs = {
  objects: Array<Sales_SequencesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntosaved_View_FavoritesCollectionArgs = {
  objects: Array<Saved_View_FavoritesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntosaved_ViewsCollectionArgs = {
  objects: Array<Saved_ViewsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoscheduled_EmailsCollectionArgs = {
  objects: Array<Scheduled_EmailsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoscheduled_SmsCollectionArgs = {
  objects: Array<Scheduled_SmsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntosecure_LinksCollectionArgs = {
  objects: Array<Secure_LinksInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoskills_CatalogCollectionArgs = {
  objects: Array<Skills_CatalogInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoslack_Channel_ProvisioningCollectionArgs = {
  objects: Array<Slack_Channel_ProvisioningInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoslack_Processed_EventsCollectionArgs = {
  objects: Array<Slack_Processed_EventsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntosocial_Brand_ChannelsCollectionArgs = {
  objects: Array<Social_Brand_ChannelsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntosocial_Brand_CredentialsCollectionArgs = {
  objects: Array<Social_Brand_CredentialsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntosocial_Hashtag_GroupsCollectionArgs = {
  objects: Array<Social_Hashtag_GroupsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntosocial_Media_PostsCollectionArgs = {
  objects: Array<Social_Media_PostsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntotask_NotesCollectionArgs = {
  objects: Array<Task_NotesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoticket_AttachmentsCollectionArgs = {
  objects: Array<Ticket_AttachmentsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoticket_TemplatesCollectionArgs = {
  objects: Array<Ticket_TemplatesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoticket_UpdatesCollectionArgs = {
  objects: Array<Ticket_UpdatesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntoticketsCollectionArgs = {
  objects: Array<TicketsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntotime_EntriesCollectionArgs = {
  objects: Array<Time_EntriesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntouser_Oauth_ConnectionsCollectionArgs = {
  objects: Array<User_Oauth_ConnectionsInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationInsertIntouser_PreferencesCollectionArgs = {
  objects: Array<User_PreferencesInsertInput>;
};

/** The root type for creating and mutating data */
export type MutationLog_Queue_EventArgs = {
  p_disposition: Scalars["String"]["input"];
  p_duration_ms: Scalars["Int"]["input"];
  p_error?: InputMaybe<Scalars["String"]["input"]>;
  p_event_type: Scalars["String"]["input"];
  p_message_id?: InputMaybe<Scalars["String"]["input"]>;
  p_meta?: InputMaybe<Scalars["JSON"]["input"]>;
  p_queue_name: Scalars["String"]["input"];
  p_receive_count: Scalars["Int"]["input"];
  p_version: Scalars["Int"]["input"];
};

/** The root type for creating and mutating data */
export type MutationRecord_Secure_Link_UseArgs = {
  p_at: Scalars["Datetime"]["input"];
  p_id: Scalars["UUID"]["input"];
};

/** The root type for creating and mutating data */
export type MutationRefresh_Company_Contact_CountArgs = {
  p_company_id: Scalars["UUID"]["input"];
};

/** The root type for creating and mutating data */
export type MutationRefresh_Company_Contract_StatusArgs = {
  p_company_id: Scalars["UUID"]["input"];
};

/** The root type for creating and mutating data */
export type MutationRefresh_Company_Deal_StatusArgs = {
  p_company_id: Scalars["UUID"]["input"];
};

/** The root type for creating and mutating data */
export type MutationRefresh_Company_Last_Contacted_AtArgs = {
  p_company_id: Scalars["UUID"]["input"];
};

/** The root type for creating and mutating data */
export type MutationRefresh_Company_Ticket_StatusArgs = {
  p_company_id: Scalars["UUID"]["input"];
};

/** The root type for creating and mutating data */
export type MutationRefresh_Contact_Last_Contacted_AtArgs = {
  p_contact_id: Scalars["UUID"]["input"];
};

/** The root type for creating and mutating data */
export type MutationRefresh_Deals_Last_Communication_For_CompanyArgs = {
  p_company_id: Scalars["UUID"]["input"];
};

/** The root type for creating and mutating data */
export type MutationRefresh_Deals_Search_For_CompanyArgs = {
  p_company_id: Scalars["UUID"]["input"];
};

/** The root type for creating and mutating data */
export type MutationSet_App_User_ConfigArgs = {
  p_patch: Scalars["JSON"]["input"];
  p_user_id: Scalars["UUID"]["input"];
};

/** The root type for creating and mutating data */
export type MutationSet_App_User_TagsArgs = {
  p_add?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  p_remove?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  p_user_id: Scalars["UUID"]["input"];
};

/** The root type for creating and mutating data */
export type MutationSet_Cognito_User_ContextArgs = {
  user_id: Scalars["String"]["input"];
};

/** The root type for creating and mutating data */
export type MutationSet_Meridian_Tool_Rollup_AnchorArgs = {
  p_anchor_ts: Scalars["String"]["input"];
  p_chat_id: Scalars["String"]["input"];
  p_started_at: Scalars["BigInt"]["input"];
  p_thread_ts: Scalars["String"]["input"];
};

/** The root type for creating and mutating data */
export type MutationUnassign_User_From_DocumentArgs = {
  document_id_param: Scalars["String"]["input"];
  user_id_param: Scalars["String"]["input"];
};

/** The root type for creating and mutating data */
export type MutationUnassign_User_From_TaskArgs = {
  task_id_param: Scalars["UUID"]["input"];
  user_id_param: Scalars["String"]["input"];
};

/** The root type for creating and mutating data */
export type MutationUpdate_Time_Entry_Quickbooks_RefsArgs = {
  customer_ref?: InputMaybe<Scalars["String"]["input"]>;
  employee_ref?: InputMaybe<Scalars["String"]["input"]>;
  time_entry_id: Scalars["UUID"]["input"];
};

/** The root type for creating and mutating data */
export type MutationUpdate_User_PrefsArgs = {
  p_patch: Scalars["JSON"]["input"];
  p_user_id: Scalars["UUID"]["input"];
};

/** The root type for creating and mutating data */
export type MutationUpdateaddress_Geocode_CacheCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Address_Geocode_CacheFilter>;
  set: Address_Geocode_CacheUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateapp_User_SkillsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<App_User_SkillsFilter>;
  set: App_User_SkillsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateapp_UsersCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<App_UsersFilter>;
  set: App_UsersUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateaudit_LogCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Audit_LogFilter>;
  set: Audit_LogUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateautomation_RulesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Automation_RulesFilter>;
  set: Automation_RulesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatebooking_HistoryCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Booking_HistoryFilter>;
  set: Booking_HistoryUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatecalendar_CacheCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Calendar_CacheFilter>;
  set: Calendar_CacheUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatecommunication_TypesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Communication_TypesFilter>;
  set: Communication_TypesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatecommunicationsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<CommunicationsFilter>;
  set: CommunicationsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatecompaniesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<CompaniesFilter>;
  set: CompaniesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatecompany_Quickbooks_CustomersCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Company_Quickbooks_CustomersFilter>;
  set: Company_Quickbooks_CustomersUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatecompany_Slack_Channel_Link_IgnoresCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Company_Slack_Channel_Link_IgnoresFilter>;
  set: Company_Slack_Channel_Link_IgnoresUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatecompany_User_AccessCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Company_User_AccessFilter>;
  set: Company_User_AccessUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateconnection_SharesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Connection_SharesFilter>;
  set: Connection_SharesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatecontact_FilesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Contact_FilesFilter>;
  set: Contact_FilesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatecontact_MeetingsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Contact_MeetingsFilter>;
  set: Contact_MeetingsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatecontact_Merge_IgnoresCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Contact_Merge_IgnoresFilter>;
  set: Contact_Merge_IgnoresUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatecontact_MessagesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Contact_MessagesFilter>;
  set: Contact_MessagesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatecontact_Method_ClaimsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Contact_Method_ClaimsFilter>;
  set: Contact_Method_ClaimsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatecontact_NotesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Contact_NotesFilter>;
  set: Contact_NotesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatecontact_ProposalsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Contact_ProposalsFilter>;
  set: Contact_ProposalsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatecontact_TasksCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Contact_TasksFilter>;
  set: Contact_TasksUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatecontact_User_AccessCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Contact_User_AccessFilter>;
  set: Contact_User_AccessUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatecontactsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<ContactsFilter>;
  set: ContactsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatecontract_PreviewsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Contract_PreviewsFilter>;
  set: Contract_PreviewsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatecontractsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<ContractsFilter>;
  set: ContractsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatecrm_Remediation_BackupCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Crm_Remediation_BackupFilter>;
  set: Crm_Remediation_BackupUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatecron_Job_RunsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Cron_Job_RunsFilter>;
  set: Cron_Job_RunsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatecustomer_FeedbackCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Customer_FeedbackFilter>;
  set: Customer_FeedbackUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatedealsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<DealsFilter>;
  set: DealsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatedevice_Push_TokensCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Device_Push_TokensFilter>;
  set: Device_Push_TokensUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatedocument_EmbeddingsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Document_EmbeddingsFilter>;
  set: Document_EmbeddingsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatedrive_NodesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Drive_NodesFilter>;
  set: Drive_NodesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatedrive_User_RootsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Drive_User_RootsFilter>;
  set: Drive_User_RootsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateemail_AudiencesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_AudiencesFilter>;
  set: Email_AudiencesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateemail_Campaign_RecipientsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_Campaign_RecipientsFilter>;
  set: Email_Campaign_RecipientsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateemail_CampaignsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_CampaignsFilter>;
  set: Email_CampaignsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateemail_EventsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_EventsFilter>;
  set: Email_EventsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateemail_Forwarding_LogCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_Forwarding_LogFilter>;
  set: Email_Forwarding_LogUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateemail_SignaturesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_SignaturesFilter>;
  set: Email_SignaturesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateemail_Template_FavoritesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_Template_FavoritesFilter>;
  set: Email_Template_FavoritesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateemail_Template_FilesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_Template_FilesFilter>;
  set: Email_Template_FilesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateemail_Template_FoldersCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_Template_FoldersFilter>;
  set: Email_Template_FoldersUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateemail_Template_SharesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_Template_SharesFilter>;
  set: Email_Template_SharesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateemail_TemplatesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_TemplatesFilter>;
  set: Email_TemplatesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateemail_Tracking_Open_EventsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_Tracking_Open_EventsFilter>;
  set: Email_Tracking_Open_EventsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateemail_Tracking_TokensCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_Tracking_TokensFilter>;
  set: Email_Tracking_TokensUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateemail_UnsubscribesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Email_UnsubscribesFilter>;
  set: Email_UnsubscribesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateembedding_JobsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Embedding_JobsFilter>;
  set: Embedding_JobsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateemployee_Contact_AccessCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Employee_Contact_AccessFilter>;
  set: Employee_Contact_AccessUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateentity_Automation_ConfigCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Entity_Automation_ConfigFilter>;
  set: Entity_Automation_ConfigUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdategemini_Notes_SyncCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Gemini_Notes_SyncFilter>;
  set: Gemini_Notes_SyncUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdategeneric_Email_DomainsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Generic_Email_DomainsFilter>;
  set: Generic_Email_DomainsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdategoogle_Drive_Access_GrantsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Google_Drive_Access_GrantsFilter>;
  set: Google_Drive_Access_GrantsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdategoogle_Group_EnrollmentsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Google_Group_EnrollmentsFilter>;
  set: Google_Group_EnrollmentsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateinbound_Sender_RulesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Inbound_Sender_RulesFilter>;
  set: Inbound_Sender_RulesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateinvoice_Dunning_LogCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Invoice_Dunning_LogFilter>;
  set: Invoice_Dunning_LogUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateios_Metric_PayloadsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Ios_Metric_PayloadsFilter>;
  set: Ios_Metric_PayloadsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatemail_User_SettingsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Mail_User_SettingsFilter>;
  set: Mail_User_SettingsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatemarketing_BrandsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Marketing_BrandsFilter>;
  set: Marketing_BrandsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatemcp_Server_ConnectionsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Mcp_Server_ConnectionsFilter>;
  set: Mcp_Server_ConnectionsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatemeridian_Chat_SummariesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_Chat_SummariesFilter>;
  set: Meridian_Chat_SummariesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatemeridian_ChatsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_ChatsFilter>;
  set: Meridian_ChatsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatemeridian_MessagesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_MessagesFilter>;
  set: Meridian_MessagesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatemeridian_Skill_ActivationsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_Skill_ActivationsFilter>;
  set: Meridian_Skill_ActivationsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatemeridian_SkillsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_SkillsFilter>;
  set: Meridian_SkillsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatemeridian_Skills_Sync_StateCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_Skills_Sync_StateFilter>;
  set: Meridian_Skills_Sync_StateUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatemeridian_Tool_Approval_OverridesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_Tool_Approval_OverridesFilter>;
  set: Meridian_Tool_Approval_OverridesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatemeridian_Tool_ApprovalsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_Tool_ApprovalsFilter>;
  set: Meridian_Tool_ApprovalsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatemeridian_Tool_IoCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_Tool_IoFilter>;
  set: Meridian_Tool_IoUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatemeridian_Tool_ResultsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_Tool_ResultsFilter>;
  set: Meridian_Tool_ResultsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatemeridian_Tool_RollupsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_Tool_RollupsFilter>;
  set: Meridian_Tool_RollupsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatemeridian_Usage_EventsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_Usage_EventsFilter>;
  set: Meridian_Usage_EventsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatemeridian_User_MemoriesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Meridian_User_MemoriesFilter>;
  set: Meridian_User_MemoriesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatemrr_SnapshotsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Mrr_SnapshotsFilter>;
  set: Mrr_SnapshotsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatemsp_DocumentsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Msp_DocumentsFilter>;
  set: Msp_DocumentsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatenotetaker_Summary_LogCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Notetaker_Summary_LogFilter>;
  set: Notetaker_Summary_LogUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatenotification_PreferencesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Notification_PreferencesFilter>;
  set: Notification_PreferencesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateofferingsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<OfferingsFilter>;
  set: OfferingsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatepending_ApprovalsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Pending_ApprovalsFilter>;
  set: Pending_ApprovalsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateplaid_AccountsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Plaid_AccountsFilter>;
  set: Plaid_AccountsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateplaid_ItemsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Plaid_ItemsFilter>;
  set: Plaid_ItemsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateplaid_StatementsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Plaid_StatementsFilter>;
  set: Plaid_StatementsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateplaid_Transaction_AttributionsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Plaid_Transaction_AttributionsFilter>;
  set: Plaid_Transaction_AttributionsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateplaid_TransactionsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Plaid_TransactionsFilter>;
  set: Plaid_TransactionsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatepost_Audit_Cron_LogsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Post_Audit_Cron_LogsFilter>;
  set: Post_Audit_Cron_LogsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatepost_Audit_DocumentsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Post_Audit_DocumentsFilter>;
  set: Post_Audit_DocumentsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatepost_Audit_Invoice_FeedbackCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Post_Audit_Invoice_FeedbackFilter>;
  set: Post_Audit_Invoice_FeedbackUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatepost_Audit_InvoicesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Post_Audit_InvoicesFilter>;
  set: Post_Audit_InvoicesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateproject_Chat_SubscriptionsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Project_Chat_SubscriptionsFilter>;
  set: Project_Chat_SubscriptionsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatequeue_Event_LogCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Queue_Event_LogFilter>;
  set: Queue_Event_LogUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatequickbooks_Company_Customer_AcksCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Quickbooks_Company_Customer_AcksFilter>;
  set: Quickbooks_Company_Customer_AcksUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatequickbooks_Customer_Link_IgnoresCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Quickbooks_Customer_Link_IgnoresFilter>;
  set: Quickbooks_Customer_Link_IgnoresUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatequickbooks_Realm_LabelsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Quickbooks_Realm_LabelsFilter>;
  set: Quickbooks_Realm_LabelsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatequo_Sync_Op_FailuresCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Quo_Sync_Op_FailuresFilter>;
  set: Quo_Sync_Op_FailuresUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdaterate_Limit_BucketsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Rate_Limit_BucketsFilter>;
  set: Rate_Limit_BucketsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdaterecurring_ChargesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Recurring_ChargesFilter>;
  set: Recurring_ChargesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdaterecurring_TransactionsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Recurring_TransactionsFilter>;
  set: Recurring_TransactionsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdaterevenue_TargetsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Revenue_TargetsFilter>;
  set: Revenue_TargetsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdaterolesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<RolesFilter>;
  set: RolesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatesales_Sequence_EnrollmentsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Sales_Sequence_EnrollmentsFilter>;
  set: Sales_Sequence_EnrollmentsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatesales_Sequence_Step_EventsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Sales_Sequence_Step_EventsFilter>;
  set: Sales_Sequence_Step_EventsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatesales_Sequence_StepsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Sales_Sequence_StepsFilter>;
  set: Sales_Sequence_StepsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatesales_SequencesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Sales_SequencesFilter>;
  set: Sales_SequencesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatesaved_View_FavoritesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Saved_View_FavoritesFilter>;
  set: Saved_View_FavoritesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatesaved_ViewsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Saved_ViewsFilter>;
  set: Saved_ViewsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatescheduled_EmailsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Scheduled_EmailsFilter>;
  set: Scheduled_EmailsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatescheduled_SmsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Scheduled_SmsFilter>;
  set: Scheduled_SmsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatesecure_LinksCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Secure_LinksFilter>;
  set: Secure_LinksUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateskills_CatalogCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Skills_CatalogFilter>;
  set: Skills_CatalogUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateslack_Channel_ProvisioningCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Slack_Channel_ProvisioningFilter>;
  set: Slack_Channel_ProvisioningUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateslack_Processed_EventsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Slack_Processed_EventsFilter>;
  set: Slack_Processed_EventsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatesocial_Brand_ChannelsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Social_Brand_ChannelsFilter>;
  set: Social_Brand_ChannelsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatesocial_Brand_CredentialsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Social_Brand_CredentialsFilter>;
  set: Social_Brand_CredentialsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatesocial_Hashtag_GroupsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Social_Hashtag_GroupsFilter>;
  set: Social_Hashtag_GroupsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatesocial_Media_PostsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Social_Media_PostsFilter>;
  set: Social_Media_PostsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatetask_NotesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Task_NotesFilter>;
  set: Task_NotesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateticket_AttachmentsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Ticket_AttachmentsFilter>;
  set: Ticket_AttachmentsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateticket_TemplatesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Ticket_TemplatesFilter>;
  set: Ticket_TemplatesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateticket_UpdatesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Ticket_UpdatesFilter>;
  set: Ticket_UpdatesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateticketsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<TicketsFilter>;
  set: TicketsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdatetime_EntriesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<Time_EntriesFilter>;
  set: Time_EntriesUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateuser_Oauth_ConnectionsCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<User_Oauth_ConnectionsFilter>;
  set: User_Oauth_ConnectionsUpdateInput;
};

/** The root type for creating and mutating data */
export type MutationUpdateuser_PreferencesCollectionArgs = {
  atMost?: Scalars["Int"]["input"];
  filter?: InputMaybe<User_PreferencesFilter>;
  set: User_PreferencesUpdateInput;
};

export type Node = {
  /** Retrieves a record by `ID` */
  nodeId: Scalars["ID"]["output"];
};

/** Boolean expression comparing fields on type "Opaque" */
export type OpaqueFilter = {
  eq?: InputMaybe<Scalars["Opaque"]["input"]>;
  is?: InputMaybe<FilterIs>;
};

/** Defines a per-field sorting order */
export type OrderByDirection =
  /** Ascending order, nulls first */
  | "AscNullsFirst"
  /** Ascending order, nulls last */
  | "AscNullsLast"
  /** Descending order, nulls first */
  | "DescNullsFirst"
  /** Descending order, nulls last */
  | "DescNullsLast";

export type PageInfo = {
  __typename?: "PageInfo";
  endCursor?: Maybe<Scalars["String"]["output"]>;
  hasNextPage: Scalars["Boolean"]["output"];
  hasPreviousPage: Scalars["Boolean"]["output"];
  startCursor?: Maybe<Scalars["String"]["output"]>;
};

/** The root type for querying data */
export type Query = {
  __typename?: "Query";
  /** Retrieve a record of type `address_geocode_cache` by its primary key */
  address_geocode_cacheByPk?: Maybe<Address_Geocode_Cache>;
  /** A pagable collection of type `address_geocode_cache` */
  address_geocode_cacheCollection: Address_Geocode_CacheConnection;
  /** Retrieve a record of type `app_user_skills` by its primary key */
  app_user_skillsByPk?: Maybe<App_User_Skills>;
  /** A pagable collection of type `app_user_skills` */
  app_user_skillsCollection: App_User_SkillsConnection;
  /** Retrieve a record of type `app_users` by its primary key */
  app_usersByPk?: Maybe<App_Users>;
  /** A pagable collection of type `app_users` */
  app_usersCollection: App_UsersConnection;
  /** Retrieve a record of type `audit_log` by its primary key */
  audit_logByPk?: Maybe<Audit_Log>;
  /** A pagable collection of type `audit_log` */
  audit_logCollection: Audit_LogConnection;
  /** Retrieve a record of type `automation_rules` by its primary key */
  automation_rulesByPk?: Maybe<Automation_Rules>;
  /** A pagable collection of type `automation_rules` */
  automation_rulesCollection: Automation_RulesConnection;
  /** Retrieve a record of type `booking_history` by its primary key */
  booking_historyByPk?: Maybe<Booking_History>;
  /** A pagable collection of type `booking_history` */
  booking_historyCollection: Booking_HistoryConnection;
  /** Retrieve a record of type `calendar_cache` by its primary key */
  calendar_cacheByPk?: Maybe<Calendar_Cache>;
  /** A pagable collection of type `calendar_cache` */
  calendar_cacheCollection: Calendar_CacheConnection;
  caller_owns_email_template?: Maybe<Scalars["Boolean"]["output"]>;
  /** Retrieve a record of type `communication_types` by its primary key */
  communication_typesByPk?: Maybe<Communication_Types>;
  /** A pagable collection of type `communication_types` */
  communication_typesCollection: Communication_TypesConnection;
  /** Retrieve a record of type `communications` by its primary key */
  communicationsByPk?: Maybe<Communications>;
  /** A pagable collection of type `communications` */
  communicationsCollection: CommunicationsConnection;
  communications_build_search_vector?: Maybe<Scalars["Opaque"]["output"]>;
  /** Retrieve a record of type `companies` by its primary key */
  companiesByPk?: Maybe<Companies>;
  /** A pagable collection of type `companies` */
  companiesCollection: CompaniesConnection;
  /** Retrieve a record of type `company_quickbooks_customers` by its primary key */
  company_quickbooks_customersByPk?: Maybe<Company_Quickbooks_Customers>;
  /** A pagable collection of type `company_quickbooks_customers` */
  company_quickbooks_customersCollection: Company_Quickbooks_CustomersConnection;
  /** Retrieve a record of type `company_slack_channel_link_ignores` by its primary key */
  company_slack_channel_link_ignoresByPk?: Maybe<Company_Slack_Channel_Link_Ignores>;
  /** A pagable collection of type `company_slack_channel_link_ignores` */
  company_slack_channel_link_ignoresCollection: Company_Slack_Channel_Link_IgnoresConnection;
  /** Retrieve a record of type `company_user_access` by its primary key */
  company_user_accessByPk?: Maybe<Company_User_Access>;
  /** A pagable collection of type `company_user_access` */
  company_user_accessCollection: Company_User_AccessConnection;
  compute_deal_company_search_text?: Maybe<Scalars["String"]["output"]>;
  compute_deal_contact_search_text?: Maybe<Scalars["String"]["output"]>;
  /** Retrieve a record of type `connection_shares` by its primary key */
  connection_sharesByPk?: Maybe<Connection_Shares>;
  /** A pagable collection of type `connection_shares` */
  connection_sharesCollection: Connection_SharesConnection;
  /** Retrieve a record of type `contact_files` by its primary key */
  contact_filesByPk?: Maybe<Contact_Files>;
  /** A pagable collection of type `contact_files` */
  contact_filesCollection: Contact_FilesConnection;
  /** Retrieve a record of type `contact_meetings` by its primary key */
  contact_meetingsByPk?: Maybe<Contact_Meetings>;
  /** A pagable collection of type `contact_meetings` */
  contact_meetingsCollection: Contact_MeetingsConnection;
  /** Retrieve a record of type `contact_merge_ignores` by its primary key */
  contact_merge_ignoresByPk?: Maybe<Contact_Merge_Ignores>;
  /** A pagable collection of type `contact_merge_ignores` */
  contact_merge_ignoresCollection: Contact_Merge_IgnoresConnection;
  /** Retrieve a record of type `contact_messages` by its primary key */
  contact_messagesByPk?: Maybe<Contact_Messages>;
  /** A pagable collection of type `contact_messages` */
  contact_messagesCollection: Contact_MessagesConnection;
  /** Retrieve a record of type `contact_method_claims` by its primary key */
  contact_method_claimsByPk?: Maybe<Contact_Method_Claims>;
  /** A pagable collection of type `contact_method_claims` */
  contact_method_claimsCollection: Contact_Method_ClaimsConnection;
  contact_method_domain_key?: Maybe<Scalars["String"]["output"]>;
  contact_method_email_key?: Maybe<Scalars["String"]["output"]>;
  /** Retrieve a record of type `contact_notes` by its primary key */
  contact_notesByPk?: Maybe<Contact_Notes>;
  /** A pagable collection of type `contact_notes` */
  contact_notesCollection: Contact_NotesConnection;
  contact_phone_national10?: Maybe<Scalars["String"]["output"]>;
  /** Retrieve a record of type `contact_proposals` by its primary key */
  contact_proposalsByPk?: Maybe<Contact_Proposals>;
  /** A pagable collection of type `contact_proposals` */
  contact_proposalsCollection: Contact_ProposalsConnection;
  /** Retrieve a record of type `contact_tasks` by its primary key */
  contact_tasksByPk?: Maybe<Contact_Tasks>;
  /** A pagable collection of type `contact_tasks` */
  contact_tasksCollection: Contact_TasksConnection;
  /** Retrieve a record of type `contact_user_access` by its primary key */
  contact_user_accessByPk?: Maybe<Contact_User_Access>;
  /** A pagable collection of type `contact_user_access` */
  contact_user_accessCollection: Contact_User_AccessConnection;
  /** Retrieve a record of type `contacts` by its primary key */
  contactsByPk?: Maybe<Contacts>;
  /** A pagable collection of type `contacts` */
  contactsCollection: ContactsConnection;
  /** Retrieve a record of type `contract_previews` by its primary key */
  contract_previewsByPk?: Maybe<Contract_Previews>;
  /** A pagable collection of type `contract_previews` */
  contract_previewsCollection: Contract_PreviewsConnection;
  /** Retrieve a record of type `contracts` by its primary key */
  contractsByPk?: Maybe<Contracts>;
  /** A pagable collection of type `contracts` */
  contractsCollection: ContractsConnection;
  /** Retrieve a record of type `crm_remediation_backup` by its primary key */
  crm_remediation_backupByPk?: Maybe<Crm_Remediation_Backup>;
  /** A pagable collection of type `crm_remediation_backup` */
  crm_remediation_backupCollection: Crm_Remediation_BackupConnection;
  /** Retrieve a record of type `cron_job_runs` by its primary key */
  cron_job_runsByPk?: Maybe<Cron_Job_Runs>;
  /** A pagable collection of type `cron_job_runs` */
  cron_job_runsCollection: Cron_Job_RunsConnection;
  /** Retrieve a record of type `customer_feedback` by its primary key */
  customer_feedbackByPk?: Maybe<Customer_Feedback>;
  /** A pagable collection of type `customer_feedback` */
  customer_feedbackCollection: Customer_FeedbackConnection;
  /** Retrieve a record of type `deals` by its primary key */
  dealsByPk?: Maybe<Deals>;
  /** A pagable collection of type `deals` */
  dealsCollection: DealsConnection;
  /** Retrieve a record of type `device_push_tokens` by its primary key */
  device_push_tokensByPk?: Maybe<Device_Push_Tokens>;
  /** A pagable collection of type `device_push_tokens` */
  device_push_tokensCollection: Device_Push_TokensConnection;
  /** Retrieve a record of type `document_embeddings` by its primary key */
  document_embeddingsByPk?: Maybe<Document_Embeddings>;
  /** A pagable collection of type `document_embeddings` */
  document_embeddingsCollection: Document_EmbeddingsConnection;
  /** Retrieve a record of type `drive_nodes` by its primary key */
  drive_nodesByPk?: Maybe<Drive_Nodes>;
  /** A pagable collection of type `drive_nodes` */
  drive_nodesCollection: Drive_NodesConnection;
  /** Retrieve a record of type `drive_user_roots` by its primary key */
  drive_user_rootsByPk?: Maybe<Drive_User_Roots>;
  /** A pagable collection of type `drive_user_roots` */
  drive_user_rootsCollection: Drive_User_RootsConnection;
  /** Retrieve a record of type `email_audiences` by its primary key */
  email_audiencesByPk?: Maybe<Email_Audiences>;
  /** A pagable collection of type `email_audiences` */
  email_audiencesCollection: Email_AudiencesConnection;
  /** Retrieve a record of type `email_campaign_recipients` by its primary key */
  email_campaign_recipientsByPk?: Maybe<Email_Campaign_Recipients>;
  /** A pagable collection of type `email_campaign_recipients` */
  email_campaign_recipientsCollection: Email_Campaign_RecipientsConnection;
  /** Retrieve a record of type `email_campaigns` by its primary key */
  email_campaignsByPk?: Maybe<Email_Campaigns>;
  /** A pagable collection of type `email_campaigns` */
  email_campaignsCollection: Email_CampaignsConnection;
  /** Retrieve a record of type `email_events` by its primary key */
  email_eventsByPk?: Maybe<Email_Events>;
  /** A pagable collection of type `email_events` */
  email_eventsCollection: Email_EventsConnection;
  /** Retrieve a record of type `email_forwarding_log` by its primary key */
  email_forwarding_logByPk?: Maybe<Email_Forwarding_Log>;
  /** A pagable collection of type `email_forwarding_log` */
  email_forwarding_logCollection: Email_Forwarding_LogConnection;
  /** Retrieve a record of type `email_signatures` by its primary key */
  email_signaturesByPk?: Maybe<Email_Signatures>;
  /** A pagable collection of type `email_signatures` */
  email_signaturesCollection: Email_SignaturesConnection;
  /** Retrieve a record of type `email_template_favorites` by its primary key */
  email_template_favoritesByPk?: Maybe<Email_Template_Favorites>;
  /** A pagable collection of type `email_template_favorites` */
  email_template_favoritesCollection: Email_Template_FavoritesConnection;
  /** Retrieve a record of type `email_template_files` by its primary key */
  email_template_filesByPk?: Maybe<Email_Template_Files>;
  /** A pagable collection of type `email_template_files` */
  email_template_filesCollection: Email_Template_FilesConnection;
  /** Retrieve a record of type `email_template_folders` by its primary key */
  email_template_foldersByPk?: Maybe<Email_Template_Folders>;
  /** A pagable collection of type `email_template_folders` */
  email_template_foldersCollection: Email_Template_FoldersConnection;
  email_template_shared_with_caller?: Maybe<Scalars["Boolean"]["output"]>;
  /** Retrieve a record of type `email_template_shares` by its primary key */
  email_template_sharesByPk?: Maybe<Email_Template_Shares>;
  /** A pagable collection of type `email_template_shares` */
  email_template_sharesCollection: Email_Template_SharesConnection;
  /** Retrieve a record of type `email_templates` by its primary key */
  email_templatesByPk?: Maybe<Email_Templates>;
  /** A pagable collection of type `email_templates` */
  email_templatesCollection: Email_TemplatesConnection;
  /** Retrieve a record of type `email_tracking_open_events` by its primary key */
  email_tracking_open_eventsByPk?: Maybe<Email_Tracking_Open_Events>;
  /** A pagable collection of type `email_tracking_open_events` */
  email_tracking_open_eventsCollection: Email_Tracking_Open_EventsConnection;
  /** Retrieve a record of type `email_tracking_tokens` by its primary key */
  email_tracking_tokensByPk?: Maybe<Email_Tracking_Tokens>;
  /** A pagable collection of type `email_tracking_tokens` */
  email_tracking_tokensCollection: Email_Tracking_TokensConnection;
  /** Retrieve a record of type `email_unsubscribes` by its primary key */
  email_unsubscribesByPk?: Maybe<Email_Unsubscribes>;
  /** A pagable collection of type `email_unsubscribes` */
  email_unsubscribesCollection: Email_UnsubscribesConnection;
  /** Retrieve a record of type `embedding_jobs` by its primary key */
  embedding_jobsByPk?: Maybe<Embedding_Jobs>;
  /** A pagable collection of type `embedding_jobs` */
  embedding_jobsCollection: Embedding_JobsConnection;
  /** Retrieve a record of type `employee_contact_access` by its primary key */
  employee_contact_accessByPk?: Maybe<Employee_Contact_Access>;
  /** A pagable collection of type `employee_contact_access` */
  employee_contact_accessCollection: Employee_Contact_AccessConnection;
  /** Retrieve a record of type `entity_automation_config` by its primary key */
  entity_automation_configByPk?: Maybe<Entity_Automation_Config>;
  /** A pagable collection of type `entity_automation_config` */
  entity_automation_configCollection: Entity_Automation_ConfigConnection;
  format_company_name_from_domain?: Maybe<Scalars["String"]["output"]>;
  fts_split_identifiers?: Maybe<Scalars["String"]["output"]>;
  /** Retrieve a record of type `gemini_notes_sync` by its primary key */
  gemini_notes_syncByPk?: Maybe<Gemini_Notes_Sync>;
  /** A pagable collection of type `gemini_notes_sync` */
  gemini_notes_syncCollection: Gemini_Notes_SyncConnection;
  /** Retrieve a record of type `generic_email_domains` by its primary key */
  generic_email_domainsByPk?: Maybe<Generic_Email_Domains>;
  /** A pagable collection of type `generic_email_domains` */
  generic_email_domainsCollection: Generic_Email_DomainsConnection;
  get_time_entry_company_id?: Maybe<Scalars["UUID"]["output"]>;
  get_unique_company_tags?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  get_unique_company_technologies?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  get_unique_contact_tags?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  get_unique_deal_tags?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  get_unique_email_template_tags?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  get_unique_task_tags?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  get_unique_ticket_tags?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** Retrieve a record of type `google_drive_access_grants` by its primary key */
  google_drive_access_grantsByPk?: Maybe<Google_Drive_Access_Grants>;
  /** A pagable collection of type `google_drive_access_grants` */
  google_drive_access_grantsCollection: Google_Drive_Access_GrantsConnection;
  /** Retrieve a record of type `google_group_enrollments` by its primary key */
  google_group_enrollmentsByPk?: Maybe<Google_Group_Enrollments>;
  /** A pagable collection of type `google_group_enrollments` */
  google_group_enrollmentsCollection: Google_Group_EnrollmentsConnection;
  /** Retrieve a record of type `inbound_sender_rules` by its primary key */
  inbound_sender_rulesByPk?: Maybe<Inbound_Sender_Rules>;
  /** A pagable collection of type `inbound_sender_rules` */
  inbound_sender_rulesCollection: Inbound_Sender_RulesConnection;
  /** Retrieve a record of type `invoice_dunning_log` by its primary key */
  invoice_dunning_logByPk?: Maybe<Invoice_Dunning_Log>;
  /** A pagable collection of type `invoice_dunning_log` */
  invoice_dunning_logCollection: Invoice_Dunning_LogConnection;
  ios_crash_family?: Maybe<Scalars["String"]["output"]>;
  /** Retrieve a record of type `ios_metric_payloads` by its primary key */
  ios_metric_payloadsByPk?: Maybe<Ios_Metric_Payloads>;
  /** A pagable collection of type `ios_metric_payloads` */
  ios_metric_payloadsCollection: Ios_Metric_PayloadsConnection;
  is_generic_email_domain?: Maybe<Scalars["Boolean"]["output"]>;
  jsonb_deep_merge?: Maybe<Scalars["JSON"]["output"]>;
  /** Retrieve a record of type `mail_user_settings` by its primary key */
  mail_user_settingsByPk?: Maybe<Mail_User_Settings>;
  /** A pagable collection of type `mail_user_settings` */
  mail_user_settingsCollection: Mail_User_SettingsConnection;
  /** Retrieve a record of type `marketing_brands` by its primary key */
  marketing_brandsByPk?: Maybe<Marketing_Brands>;
  /** A pagable collection of type `marketing_brands` */
  marketing_brandsCollection: Marketing_BrandsConnection;
  /** Retrieve a record of type `mcp_server_connections` by its primary key */
  mcp_server_connectionsByPk?: Maybe<Mcp_Server_Connections>;
  /** A pagable collection of type `mcp_server_connections` */
  mcp_server_connectionsCollection: Mcp_Server_ConnectionsConnection;
  /** Retrieve a record of type `meridian_chat_summaries` by its primary key */
  meridian_chat_summariesByPk?: Maybe<Meridian_Chat_Summaries>;
  /** A pagable collection of type `meridian_chat_summaries` */
  meridian_chat_summariesCollection: Meridian_Chat_SummariesConnection;
  /** Retrieve a record of type `meridian_chats` by its primary key */
  meridian_chatsByPk?: Maybe<Meridian_Chats>;
  /** A pagable collection of type `meridian_chats` */
  meridian_chatsCollection: Meridian_ChatsConnection;
  /** Retrieve a record of type `meridian_messages` by its primary key */
  meridian_messagesByPk?: Maybe<Meridian_Messages>;
  /** A pagable collection of type `meridian_messages` */
  meridian_messagesCollection: Meridian_MessagesConnection;
  /** Retrieve a record of type `meridian_skill_activations` by its primary key */
  meridian_skill_activationsByPk?: Maybe<Meridian_Skill_Activations>;
  /** A pagable collection of type `meridian_skill_activations` */
  meridian_skill_activationsCollection: Meridian_Skill_ActivationsConnection;
  /** Retrieve a record of type `meridian_skills` by its primary key */
  meridian_skillsByPk?: Maybe<Meridian_Skills>;
  /** A pagable collection of type `meridian_skills` */
  meridian_skillsCollection: Meridian_SkillsConnection;
  /** Retrieve a record of type `meridian_skills_sync_state` by its primary key */
  meridian_skills_sync_stateByPk?: Maybe<Meridian_Skills_Sync_State>;
  /** A pagable collection of type `meridian_skills_sync_state` */
  meridian_skills_sync_stateCollection: Meridian_Skills_Sync_StateConnection;
  /** Retrieve a record of type `meridian_tool_approval_overrides` by its primary key */
  meridian_tool_approval_overridesByPk?: Maybe<Meridian_Tool_Approval_Overrides>;
  /** A pagable collection of type `meridian_tool_approval_overrides` */
  meridian_tool_approval_overridesCollection: Meridian_Tool_Approval_OverridesConnection;
  /** Retrieve a record of type `meridian_tool_approvals` by its primary key */
  meridian_tool_approvalsByPk?: Maybe<Meridian_Tool_Approvals>;
  /** A pagable collection of type `meridian_tool_approvals` */
  meridian_tool_approvalsCollection: Meridian_Tool_ApprovalsConnection;
  /** Retrieve a record of type `meridian_tool_io` by its primary key */
  meridian_tool_ioByPk?: Maybe<Meridian_Tool_Io>;
  /** A pagable collection of type `meridian_tool_io` */
  meridian_tool_ioCollection: Meridian_Tool_IoConnection;
  /** Retrieve a record of type `meridian_tool_results` by its primary key */
  meridian_tool_resultsByPk?: Maybe<Meridian_Tool_Results>;
  /** A pagable collection of type `meridian_tool_results` */
  meridian_tool_resultsCollection: Meridian_Tool_ResultsConnection;
  /** Retrieve a record of type `meridian_tool_rollups` by its primary key */
  meridian_tool_rollupsByPk?: Maybe<Meridian_Tool_Rollups>;
  /** A pagable collection of type `meridian_tool_rollups` */
  meridian_tool_rollupsCollection: Meridian_Tool_RollupsConnection;
  /** Retrieve a record of type `meridian_usage_events` by its primary key */
  meridian_usage_eventsByPk?: Maybe<Meridian_Usage_Events>;
  /** A pagable collection of type `meridian_usage_events` */
  meridian_usage_eventsCollection: Meridian_Usage_EventsConnection;
  /** Retrieve a record of type `meridian_user_memories` by its primary key */
  meridian_user_memoriesByPk?: Maybe<Meridian_User_Memories>;
  /** A pagable collection of type `meridian_user_memories` */
  meridian_user_memoriesCollection: Meridian_User_MemoriesConnection;
  /** Retrieve a record of type `mrr_snapshots` by its primary key */
  mrr_snapshotsByPk?: Maybe<Mrr_Snapshots>;
  /** A pagable collection of type `mrr_snapshots` */
  mrr_snapshotsCollection: Mrr_SnapshotsConnection;
  /** Retrieve a record of type `msp_documents` by its primary key */
  msp_documentsByPk?: Maybe<Msp_Documents>;
  /** A pagable collection of type `msp_documents` */
  msp_documentsCollection: Msp_DocumentsConnection;
  /** Retrieve a record by its `ID` */
  node?: Maybe<Node>;
  normalize_person_name?: Maybe<Scalars["String"]["output"]>;
  normalize_site_domain?: Maybe<Scalars["String"]["output"]>;
  /** Retrieve a record of type `notetaker_summary_log` by its primary key */
  notetaker_summary_logByPk?: Maybe<Notetaker_Summary_Log>;
  /** A pagable collection of type `notetaker_summary_log` */
  notetaker_summary_logCollection: Notetaker_Summary_LogConnection;
  /** Retrieve a record of type `notification_preferences` by its primary key */
  notification_preferencesByPk?: Maybe<Notification_Preferences>;
  /** A pagable collection of type `notification_preferences` */
  notification_preferencesCollection: Notification_PreferencesConnection;
  /** Retrieve a record of type `offerings` by its primary key */
  offeringsByPk?: Maybe<Offerings>;
  /** A pagable collection of type `offerings` */
  offeringsCollection: OfferingsConnection;
  offerings_line_item_search_text?: Maybe<Scalars["String"]["output"]>;
  /** Retrieve a record of type `pending_approvals` by its primary key */
  pending_approvalsByPk?: Maybe<Pending_Approvals>;
  /** A pagable collection of type `pending_approvals` */
  pending_approvalsCollection: Pending_ApprovalsConnection;
  /** Retrieve a record of type `plaid_accounts` by its primary key */
  plaid_accountsByPk?: Maybe<Plaid_Accounts>;
  /** A pagable collection of type `plaid_accounts` */
  plaid_accountsCollection: Plaid_AccountsConnection;
  /** Retrieve a record of type `plaid_items` by its primary key */
  plaid_itemsByPk?: Maybe<Plaid_Items>;
  /** A pagable collection of type `plaid_items` */
  plaid_itemsCollection: Plaid_ItemsConnection;
  plaid_spend_by_customer?: Maybe<Scalars["JSON"]["output"]>;
  /** Retrieve a record of type `plaid_statements` by its primary key */
  plaid_statementsByPk?: Maybe<Plaid_Statements>;
  /** A pagable collection of type `plaid_statements` */
  plaid_statementsCollection: Plaid_StatementsConnection;
  /** Retrieve a record of type `plaid_transaction_attributions` by its primary key */
  plaid_transaction_attributionsByPk?: Maybe<Plaid_Transaction_Attributions>;
  /** A pagable collection of type `plaid_transaction_attributions` */
  plaid_transaction_attributionsCollection: Plaid_Transaction_AttributionsConnection;
  /** Retrieve a record of type `plaid_transactions` by its primary key */
  plaid_transactionsByPk?: Maybe<Plaid_Transactions>;
  /** A pagable collection of type `plaid_transactions` */
  plaid_transactionsCollection: Plaid_TransactionsConnection;
  plaid_unattributed_spend_summary?: Maybe<Scalars["JSON"]["output"]>;
  /** Retrieve a record of type `post_audit_cron_logs` by its primary key */
  post_audit_cron_logsByPk?: Maybe<Post_Audit_Cron_Logs>;
  /** A pagable collection of type `post_audit_cron_logs` */
  post_audit_cron_logsCollection: Post_Audit_Cron_LogsConnection;
  /** Retrieve a record of type `post_audit_documents` by its primary key */
  post_audit_documentsByPk?: Maybe<Post_Audit_Documents>;
  /** A pagable collection of type `post_audit_documents` */
  post_audit_documentsCollection: Post_Audit_DocumentsConnection;
  /** Retrieve a record of type `post_audit_invoice_feedback` by its primary key */
  post_audit_invoice_feedbackByPk?: Maybe<Post_Audit_Invoice_Feedback>;
  /** A pagable collection of type `post_audit_invoice_feedback` */
  post_audit_invoice_feedbackCollection: Post_Audit_Invoice_FeedbackConnection;
  /** Retrieve a record of type `post_audit_invoices` by its primary key */
  post_audit_invoicesByPk?: Maybe<Post_Audit_Invoices>;
  /** A pagable collection of type `post_audit_invoices` */
  post_audit_invoicesCollection: Post_Audit_InvoicesConnection;
  /** Retrieve a record of type `project_chat_subscriptions` by its primary key */
  project_chat_subscriptionsByPk?: Maybe<Project_Chat_Subscriptions>;
  /** A pagable collection of type `project_chat_subscriptions` */
  project_chat_subscriptionsCollection: Project_Chat_SubscriptionsConnection;
  /** Retrieve a record of type `queue_event_log` by its primary key */
  queue_event_logByPk?: Maybe<Queue_Event_Log>;
  /** A pagable collection of type `queue_event_log` */
  queue_event_logCollection: Queue_Event_LogConnection;
  /** Retrieve a record of type `quickbooks_company_customer_acks` by its primary key */
  quickbooks_company_customer_acksByPk?: Maybe<Quickbooks_Company_Customer_Acks>;
  /** A pagable collection of type `quickbooks_company_customer_acks` */
  quickbooks_company_customer_acksCollection: Quickbooks_Company_Customer_AcksConnection;
  /** Retrieve a record of type `quickbooks_customer_link_ignores` by its primary key */
  quickbooks_customer_link_ignoresByPk?: Maybe<Quickbooks_Customer_Link_Ignores>;
  /** A pagable collection of type `quickbooks_customer_link_ignores` */
  quickbooks_customer_link_ignoresCollection: Quickbooks_Customer_Link_IgnoresConnection;
  /** Retrieve a record of type `quickbooks_realm_labels` by its primary key */
  quickbooks_realm_labelsByPk?: Maybe<Quickbooks_Realm_Labels>;
  /** A pagable collection of type `quickbooks_realm_labels` */
  quickbooks_realm_labelsCollection: Quickbooks_Realm_LabelsConnection;
  /** Retrieve a record of type `quo_sync_op_failures` by its primary key */
  quo_sync_op_failuresByPk?: Maybe<Quo_Sync_Op_Failures>;
  /** A pagable collection of type `quo_sync_op_failures` */
  quo_sync_op_failuresCollection: Quo_Sync_Op_FailuresConnection;
  /** Retrieve a record of type `rate_limit_buckets` by its primary key */
  rate_limit_bucketsByPk?: Maybe<Rate_Limit_Buckets>;
  /** A pagable collection of type `rate_limit_buckets` */
  rate_limit_bucketsCollection: Rate_Limit_BucketsConnection;
  /** Retrieve a record of type `recurring_charges` by its primary key */
  recurring_chargesByPk?: Maybe<Recurring_Charges>;
  /** A pagable collection of type `recurring_charges` */
  recurring_chargesCollection: Recurring_ChargesConnection;
  /** Retrieve a record of type `recurring_transactions` by its primary key */
  recurring_transactionsByPk?: Maybe<Recurring_Transactions>;
  /** A pagable collection of type `recurring_transactions` */
  recurring_transactionsCollection: Recurring_TransactionsConnection;
  resolve_deal_engineer_search_text?: Maybe<Scalars["String"]["output"]>;
  /** Retrieve a record of type `revenue_targets` by its primary key */
  revenue_targetsByPk?: Maybe<Revenue_Targets>;
  /** A pagable collection of type `revenue_targets` */
  revenue_targetsCollection: Revenue_TargetsConnection;
  /** Retrieve a record of type `roles` by its primary key */
  rolesByPk?: Maybe<Roles>;
  /** A pagable collection of type `roles` */
  rolesCollection: RolesConnection;
  /** Retrieve a record of type `sales_sequence_enrollments` by its primary key */
  sales_sequence_enrollmentsByPk?: Maybe<Sales_Sequence_Enrollments>;
  /** A pagable collection of type `sales_sequence_enrollments` */
  sales_sequence_enrollmentsCollection: Sales_Sequence_EnrollmentsConnection;
  /** Retrieve a record of type `sales_sequence_step_events` by its primary key */
  sales_sequence_step_eventsByPk?: Maybe<Sales_Sequence_Step_Events>;
  /** A pagable collection of type `sales_sequence_step_events` */
  sales_sequence_step_eventsCollection: Sales_Sequence_Step_EventsConnection;
  /** Retrieve a record of type `sales_sequence_steps` by its primary key */
  sales_sequence_stepsByPk?: Maybe<Sales_Sequence_Steps>;
  /** A pagable collection of type `sales_sequence_steps` */
  sales_sequence_stepsCollection: Sales_Sequence_StepsConnection;
  /** Retrieve a record of type `sales_sequences` by its primary key */
  sales_sequencesByPk?: Maybe<Sales_Sequences>;
  /** A pagable collection of type `sales_sequences` */
  sales_sequencesCollection: Sales_SequencesConnection;
  /** Retrieve a record of type `saved_view_favorites` by its primary key */
  saved_view_favoritesByPk?: Maybe<Saved_View_Favorites>;
  /** A pagable collection of type `saved_view_favorites` */
  saved_view_favoritesCollection: Saved_View_FavoritesConnection;
  /** Retrieve a record of type `saved_views` by its primary key */
  saved_viewsByPk?: Maybe<Saved_Views>;
  /** A pagable collection of type `saved_views` */
  saved_viewsCollection: Saved_ViewsConnection;
  /** Retrieve a record of type `scheduled_emails` by its primary key */
  scheduled_emailsByPk?: Maybe<Scheduled_Emails>;
  /** A pagable collection of type `scheduled_emails` */
  scheduled_emailsCollection: Scheduled_EmailsConnection;
  /** Retrieve a record of type `scheduled_sms` by its primary key */
  scheduled_smsByPk?: Maybe<Scheduled_Sms>;
  /** A pagable collection of type `scheduled_sms` */
  scheduled_smsCollection: Scheduled_SmsConnection;
  /** Retrieve a record of type `secure_links` by its primary key */
  secure_linksByPk?: Maybe<Secure_Links>;
  /** A pagable collection of type `secure_links` */
  secure_linksCollection: Secure_LinksConnection;
  show_limit?: Maybe<Scalars["Float"]["output"]>;
  /** Retrieve a record of type `skills_catalog` by its primary key */
  skills_catalogByPk?: Maybe<Skills_Catalog>;
  /** A pagable collection of type `skills_catalog` */
  skills_catalogCollection: Skills_CatalogConnection;
  /** Retrieve a record of type `slack_channel_provisioning` by its primary key */
  slack_channel_provisioningByPk?: Maybe<Slack_Channel_Provisioning>;
  /** A pagable collection of type `slack_channel_provisioning` */
  slack_channel_provisioningCollection: Slack_Channel_ProvisioningConnection;
  /** Retrieve a record of type `slack_processed_events` by its primary key */
  slack_processed_eventsByPk?: Maybe<Slack_Processed_Events>;
  /** A pagable collection of type `slack_processed_events` */
  slack_processed_eventsCollection: Slack_Processed_EventsConnection;
  /** Retrieve a record of type `social_brand_channels` by its primary key */
  social_brand_channelsByPk?: Maybe<Social_Brand_Channels>;
  /** A pagable collection of type `social_brand_channels` */
  social_brand_channelsCollection: Social_Brand_ChannelsConnection;
  /** Retrieve a record of type `social_brand_credentials` by its primary key */
  social_brand_credentialsByPk?: Maybe<Social_Brand_Credentials>;
  /** A pagable collection of type `social_brand_credentials` */
  social_brand_credentialsCollection: Social_Brand_CredentialsConnection;
  /** Retrieve a record of type `social_hashtag_groups` by its primary key */
  social_hashtag_groupsByPk?: Maybe<Social_Hashtag_Groups>;
  /** A pagable collection of type `social_hashtag_groups` */
  social_hashtag_groupsCollection: Social_Hashtag_GroupsConnection;
  /** Retrieve a record of type `social_media_posts` by its primary key */
  social_media_postsByPk?: Maybe<Social_Media_Posts>;
  /** A pagable collection of type `social_media_posts` */
  social_media_postsCollection: Social_Media_PostsConnection;
  /** Retrieve a record of type `task_notes` by its primary key */
  task_notesByPk?: Maybe<Task_Notes>;
  /** A pagable collection of type `task_notes` */
  task_notesCollection: Task_NotesConnection;
  /** Retrieve a record of type `ticket_attachments` by its primary key */
  ticket_attachmentsByPk?: Maybe<Ticket_Attachments>;
  /** A pagable collection of type `ticket_attachments` */
  ticket_attachmentsCollection: Ticket_AttachmentsConnection;
  /** Retrieve a record of type `ticket_templates` by its primary key */
  ticket_templatesByPk?: Maybe<Ticket_Templates>;
  /** A pagable collection of type `ticket_templates` */
  ticket_templatesCollection: Ticket_TemplatesConnection;
  /** Retrieve a record of type `ticket_updates` by its primary key */
  ticket_updatesByPk?: Maybe<Ticket_Updates>;
  /** A pagable collection of type `ticket_updates` */
  ticket_updatesCollection: Ticket_UpdatesConnection;
  /** Retrieve a record of type `tickets` by its primary key */
  ticketsByPk?: Maybe<Tickets>;
  /** A pagable collection of type `tickets` */
  ticketsCollection: TicketsConnection;
  tickets_build_search_vector?: Maybe<Scalars["Opaque"]["output"]>;
  /** Retrieve a record of type `time_entries` by its primary key */
  time_entriesByPk?: Maybe<Time_Entries>;
  /** A pagable collection of type `time_entries` */
  time_entriesCollection: Time_EntriesConnection;
  /** Retrieve a record of type `user_oauth_connections` by its primary key */
  user_oauth_connectionsByPk?: Maybe<User_Oauth_Connections>;
  /** A pagable collection of type `user_oauth_connections` */
  user_oauth_connectionsCollection: User_Oauth_ConnectionsConnection;
  /** Retrieve a record of type `user_preferences` by its primary key */
  user_preferencesByPk?: Maybe<User_Preferences>;
  /** A pagable collection of type `user_preferences` */
  user_preferencesCollection: User_PreferencesConnection;
};

/** The root type for querying data */
export type QueryAddress_Geocode_CacheByPkArgs = {
  address_key: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryAddress_Geocode_CacheCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Address_Geocode_CacheFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Address_Geocode_CacheOrderBy>>;
};

/** The root type for querying data */
export type QueryApp_User_SkillsByPkArgs = {
  skill_id: Scalars["UUID"]["input"];
  user_id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryApp_User_SkillsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<App_User_SkillsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<App_User_SkillsOrderBy>>;
};

/** The root type for querying data */
export type QueryApp_UsersByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryApp_UsersCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<App_UsersFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<App_UsersOrderBy>>;
};

/** The root type for querying data */
export type QueryAudit_LogByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryAudit_LogCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Audit_LogFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Audit_LogOrderBy>>;
};

/** The root type for querying data */
export type QueryAutomation_RulesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryAutomation_RulesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Automation_RulesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Automation_RulesOrderBy>>;
};

/** The root type for querying data */
export type QueryBooking_HistoryByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryBooking_HistoryCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Booking_HistoryFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Booking_HistoryOrderBy>>;
};

/** The root type for querying data */
export type QueryCalendar_CacheByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryCalendar_CacheCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Calendar_CacheFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Calendar_CacheOrderBy>>;
};

/** The root type for querying data */
export type QueryCaller_Owns_Email_TemplateArgs = {
  p_template_id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryCommunication_TypesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryCommunication_TypesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Communication_TypesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Communication_TypesOrderBy>>;
};

/** The root type for querying data */
export type QueryCommunicationsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryCommunicationsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<CommunicationsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CommunicationsOrderBy>>;
};

/** The root type for querying data */
export type QueryCommunications_Build_Search_VectorArgs = {
  p_body: Scalars["String"]["input"];
  p_direction: Scalars["String"]["input"];
  p_external_id: Scalars["String"]["input"];
  p_status: Scalars["String"]["input"];
  p_title: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryCompaniesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryCompaniesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<CompaniesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CompaniesOrderBy>>;
};

/** The root type for querying data */
export type QueryCompany_Quickbooks_CustomersByPkArgs = {
  company_id: Scalars["UUID"]["input"];
  customer_id: Scalars["String"]["input"];
  realm_id: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryCompany_Quickbooks_CustomersCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Company_Quickbooks_CustomersFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Company_Quickbooks_CustomersOrderBy>>;
};

/** The root type for querying data */
export type QueryCompany_Slack_Channel_Link_IgnoresByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryCompany_Slack_Channel_Link_IgnoresCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Company_Slack_Channel_Link_IgnoresFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Company_Slack_Channel_Link_IgnoresOrderBy>>;
};

/** The root type for querying data */
export type QueryCompany_User_AccessByPkArgs = {
  company_id: Scalars["UUID"]["input"];
  user_id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryCompany_User_AccessCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Company_User_AccessFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Company_User_AccessOrderBy>>;
};

/** The root type for querying data */
export type QueryCompute_Deal_Company_Search_TextArgs = {
  p_company_id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryCompute_Deal_Contact_Search_TextArgs = {
  p_company_id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryConnection_SharesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryConnection_SharesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Connection_SharesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Connection_SharesOrderBy>>;
};

/** The root type for querying data */
export type QueryContact_FilesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryContact_FilesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_FilesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_FilesOrderBy>>;
};

/** The root type for querying data */
export type QueryContact_MeetingsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryContact_MeetingsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_MeetingsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_MeetingsOrderBy>>;
};

/** The root type for querying data */
export type QueryContact_Merge_IgnoresByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryContact_Merge_IgnoresCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_Merge_IgnoresFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_Merge_IgnoresOrderBy>>;
};

/** The root type for querying data */
export type QueryContact_MessagesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryContact_MessagesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_MessagesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_MessagesOrderBy>>;
};

/** The root type for querying data */
export type QueryContact_Method_ClaimsByPkArgs = {
  kind: Scalars["String"]["input"];
  owner_id: Scalars["UUID"]["input"];
  owner_type: Scalars["String"]["input"];
  value_key: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryContact_Method_ClaimsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_Method_ClaimsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_Method_ClaimsOrderBy>>;
};

/** The root type for querying data */
export type QueryContact_Method_Domain_KeyArgs = {
  raw: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryContact_Method_Email_KeyArgs = {
  raw: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryContact_NotesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryContact_NotesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_NotesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_NotesOrderBy>>;
};

/** The root type for querying data */
export type QueryContact_Phone_National10Args = {
  raw: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryContact_ProposalsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryContact_ProposalsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_ProposalsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_ProposalsOrderBy>>;
};

/** The root type for querying data */
export type QueryContact_TasksByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryContact_TasksCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_TasksFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_TasksOrderBy>>;
};

/** The root type for querying data */
export type QueryContact_User_AccessByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryContact_User_AccessCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_User_AccessFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_User_AccessOrderBy>>;
};

/** The root type for querying data */
export type QueryContactsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryContactsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<ContactsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ContactsOrderBy>>;
};

/** The root type for querying data */
export type QueryContract_PreviewsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryContract_PreviewsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contract_PreviewsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contract_PreviewsOrderBy>>;
};

/** The root type for querying data */
export type QueryContractsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryContractsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<ContractsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ContractsOrderBy>>;
};

/** The root type for querying data */
export type QueryCrm_Remediation_BackupByPkArgs = {
  id: Scalars["BigInt"]["input"];
};

/** The root type for querying data */
export type QueryCrm_Remediation_BackupCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Crm_Remediation_BackupFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Crm_Remediation_BackupOrderBy>>;
};

/** The root type for querying data */
export type QueryCron_Job_RunsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryCron_Job_RunsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Cron_Job_RunsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Cron_Job_RunsOrderBy>>;
};

/** The root type for querying data */
export type QueryCustomer_FeedbackByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryCustomer_FeedbackCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Customer_FeedbackFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Customer_FeedbackOrderBy>>;
};

/** The root type for querying data */
export type QueryDealsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryDealsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<DealsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DealsOrderBy>>;
};

/** The root type for querying data */
export type QueryDevice_Push_TokensByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryDevice_Push_TokensCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Device_Push_TokensFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Device_Push_TokensOrderBy>>;
};

/** The root type for querying data */
export type QueryDocument_EmbeddingsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryDocument_EmbeddingsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Document_EmbeddingsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Document_EmbeddingsOrderBy>>;
};

/** The root type for querying data */
export type QueryDrive_NodesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryDrive_NodesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Drive_NodesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Drive_NodesOrderBy>>;
};

/** The root type for querying data */
export type QueryDrive_User_RootsByPkArgs = {
  user_id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryDrive_User_RootsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Drive_User_RootsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Drive_User_RootsOrderBy>>;
};

/** The root type for querying data */
export type QueryEmail_AudiencesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryEmail_AudiencesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_AudiencesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_AudiencesOrderBy>>;
};

/** The root type for querying data */
export type QueryEmail_Campaign_RecipientsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryEmail_Campaign_RecipientsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_Campaign_RecipientsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_Campaign_RecipientsOrderBy>>;
};

/** The root type for querying data */
export type QueryEmail_CampaignsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryEmail_CampaignsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_CampaignsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_CampaignsOrderBy>>;
};

/** The root type for querying data */
export type QueryEmail_EventsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryEmail_EventsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_EventsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_EventsOrderBy>>;
};

/** The root type for querying data */
export type QueryEmail_Forwarding_LogByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryEmail_Forwarding_LogCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_Forwarding_LogFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_Forwarding_LogOrderBy>>;
};

/** The root type for querying data */
export type QueryEmail_SignaturesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryEmail_SignaturesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_SignaturesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_SignaturesOrderBy>>;
};

/** The root type for querying data */
export type QueryEmail_Template_FavoritesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryEmail_Template_FavoritesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_Template_FavoritesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_Template_FavoritesOrderBy>>;
};

/** The root type for querying data */
export type QueryEmail_Template_FilesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryEmail_Template_FilesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_Template_FilesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_Template_FilesOrderBy>>;
};

/** The root type for querying data */
export type QueryEmail_Template_FoldersByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryEmail_Template_FoldersCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_Template_FoldersFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_Template_FoldersOrderBy>>;
};

/** The root type for querying data */
export type QueryEmail_Template_Shared_With_CallerArgs = {
  p_template_id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryEmail_Template_SharesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryEmail_Template_SharesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_Template_SharesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_Template_SharesOrderBy>>;
};

/** The root type for querying data */
export type QueryEmail_TemplatesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryEmail_TemplatesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_TemplatesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_TemplatesOrderBy>>;
};

/** The root type for querying data */
export type QueryEmail_Tracking_Open_EventsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryEmail_Tracking_Open_EventsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_Tracking_Open_EventsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_Tracking_Open_EventsOrderBy>>;
};

/** The root type for querying data */
export type QueryEmail_Tracking_TokensByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryEmail_Tracking_TokensCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_Tracking_TokensFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_Tracking_TokensOrderBy>>;
};

/** The root type for querying data */
export type QueryEmail_UnsubscribesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryEmail_UnsubscribesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_UnsubscribesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_UnsubscribesOrderBy>>;
};

/** The root type for querying data */
export type QueryEmbedding_JobsByPkArgs = {
  entity_id: Scalars["UUID"]["input"];
  entity_type: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryEmbedding_JobsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Embedding_JobsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Embedding_JobsOrderBy>>;
};

/** The root type for querying data */
export type QueryEmployee_Contact_AccessByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryEmployee_Contact_AccessCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Employee_Contact_AccessFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Employee_Contact_AccessOrderBy>>;
};

/** The root type for querying data */
export type QueryEntity_Automation_ConfigByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryEntity_Automation_ConfigCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Entity_Automation_ConfigFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Entity_Automation_ConfigOrderBy>>;
};

/** The root type for querying data */
export type QueryFormat_Company_Name_From_DomainArgs = {
  root_domain: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryFts_Split_IdentifiersArgs = {
  txt: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryGemini_Notes_SyncByPkArgs = {
  file_id: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryGemini_Notes_SyncCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Gemini_Notes_SyncFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Gemini_Notes_SyncOrderBy>>;
};

/** The root type for querying data */
export type QueryGeneric_Email_DomainsByPkArgs = {
  domain: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryGeneric_Email_DomainsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Generic_Email_DomainsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Generic_Email_DomainsOrderBy>>;
};

/** The root type for querying data */
export type QueryGet_Time_Entry_Company_IdArgs = {
  time_entry_id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryGoogle_Drive_Access_GrantsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryGoogle_Drive_Access_GrantsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Google_Drive_Access_GrantsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Google_Drive_Access_GrantsOrderBy>>;
};

/** The root type for querying data */
export type QueryGoogle_Group_EnrollmentsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryGoogle_Group_EnrollmentsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Google_Group_EnrollmentsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Google_Group_EnrollmentsOrderBy>>;
};

/** The root type for querying data */
export type QueryInbound_Sender_RulesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryInbound_Sender_RulesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Inbound_Sender_RulesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Inbound_Sender_RulesOrderBy>>;
};

/** The root type for querying data */
export type QueryInvoice_Dunning_LogByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryInvoice_Dunning_LogCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Invoice_Dunning_LogFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Invoice_Dunning_LogOrderBy>>;
};

/** The root type for querying data */
export type QueryIos_Crash_FamilyArgs = {
  p_exception_type: Scalars["String"]["input"];
  p_kind: Scalars["String"]["input"];
  p_signal: Scalars["String"]["input"];
  p_top_frames: Scalars["JSON"]["input"];
};

/** The root type for querying data */
export type QueryIos_Metric_PayloadsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryIos_Metric_PayloadsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Ios_Metric_PayloadsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Ios_Metric_PayloadsOrderBy>>;
};

/** The root type for querying data */
export type QueryIs_Generic_Email_DomainArgs = {
  raw: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryJsonb_Deep_MergeArgs = {
  a: Scalars["JSON"]["input"];
  b: Scalars["JSON"]["input"];
};

/** The root type for querying data */
export type QueryMail_User_SettingsByPkArgs = {
  user_id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryMail_User_SettingsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Mail_User_SettingsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Mail_User_SettingsOrderBy>>;
};

/** The root type for querying data */
export type QueryMarketing_BrandsByPkArgs = {
  id: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryMarketing_BrandsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Marketing_BrandsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Marketing_BrandsOrderBy>>;
};

/** The root type for querying data */
export type QueryMcp_Server_ConnectionsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryMcp_Server_ConnectionsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Mcp_Server_ConnectionsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Mcp_Server_ConnectionsOrderBy>>;
};

/** The root type for querying data */
export type QueryMeridian_Chat_SummariesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryMeridian_Chat_SummariesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Meridian_Chat_SummariesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Meridian_Chat_SummariesOrderBy>>;
};

/** The root type for querying data */
export type QueryMeridian_ChatsByPkArgs = {
  id: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryMeridian_ChatsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Meridian_ChatsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Meridian_ChatsOrderBy>>;
};

/** The root type for querying data */
export type QueryMeridian_MessagesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryMeridian_MessagesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Meridian_MessagesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Meridian_MessagesOrderBy>>;
};

/** The root type for querying data */
export type QueryMeridian_Skill_ActivationsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryMeridian_Skill_ActivationsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Meridian_Skill_ActivationsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Meridian_Skill_ActivationsOrderBy>>;
};

/** The root type for querying data */
export type QueryMeridian_SkillsByPkArgs = {
  id: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryMeridian_SkillsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Meridian_SkillsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Meridian_SkillsOrderBy>>;
};

/** The root type for querying data */
export type QueryMeridian_Skills_Sync_StateByPkArgs = {
  id: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryMeridian_Skills_Sync_StateCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Meridian_Skills_Sync_StateFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Meridian_Skills_Sync_StateOrderBy>>;
};

/** The root type for querying data */
export type QueryMeridian_Tool_Approval_OverridesByPkArgs = {
  approval_id: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryMeridian_Tool_Approval_OverridesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Meridian_Tool_Approval_OverridesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Meridian_Tool_Approval_OverridesOrderBy>>;
};

/** The root type for querying data */
export type QueryMeridian_Tool_ApprovalsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryMeridian_Tool_ApprovalsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Meridian_Tool_ApprovalsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Meridian_Tool_ApprovalsOrderBy>>;
};

/** The root type for querying data */
export type QueryMeridian_Tool_IoByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryMeridian_Tool_IoCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Meridian_Tool_IoFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Meridian_Tool_IoOrderBy>>;
};

/** The root type for querying data */
export type QueryMeridian_Tool_ResultsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryMeridian_Tool_ResultsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Meridian_Tool_ResultsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Meridian_Tool_ResultsOrderBy>>;
};

/** The root type for querying data */
export type QueryMeridian_Tool_RollupsByPkArgs = {
  chat_id: Scalars["String"]["input"];
  thread_ts: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryMeridian_Tool_RollupsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Meridian_Tool_RollupsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Meridian_Tool_RollupsOrderBy>>;
};

/** The root type for querying data */
export type QueryMeridian_Usage_EventsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryMeridian_Usage_EventsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Meridian_Usage_EventsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Meridian_Usage_EventsOrderBy>>;
};

/** The root type for querying data */
export type QueryMeridian_User_MemoriesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryMeridian_User_MemoriesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Meridian_User_MemoriesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Meridian_User_MemoriesOrderBy>>;
};

/** The root type for querying data */
export type QueryMrr_SnapshotsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryMrr_SnapshotsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Mrr_SnapshotsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Mrr_SnapshotsOrderBy>>;
};

/** The root type for querying data */
export type QueryMsp_DocumentsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryMsp_DocumentsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Msp_DocumentsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Msp_DocumentsOrderBy>>;
};

/** The root type for querying data */
export type QueryNodeArgs = {
  nodeId: Scalars["ID"]["input"];
};

/** The root type for querying data */
export type QueryNormalize_Person_NameArgs = {
  raw: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryNormalize_Site_DomainArgs = {
  input: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryNotetaker_Summary_LogByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryNotetaker_Summary_LogCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Notetaker_Summary_LogFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Notetaker_Summary_LogOrderBy>>;
};

/** The root type for querying data */
export type QueryNotification_PreferencesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryNotification_PreferencesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Notification_PreferencesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Notification_PreferencesOrderBy>>;
};

/** The root type for querying data */
export type QueryOfferingsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryOfferingsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<OfferingsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<OfferingsOrderBy>>;
};

/** The root type for querying data */
export type QueryOfferings_Line_Item_Search_TextArgs = {
  p_costs: Scalars["JSON"]["input"];
  p_staff: Scalars["JSON"]["input"];
};

/** The root type for querying data */
export type QueryPending_ApprovalsByPkArgs = {
  approval_id: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryPending_ApprovalsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Pending_ApprovalsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Pending_ApprovalsOrderBy>>;
};

/** The root type for querying data */
export type QueryPlaid_AccountsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryPlaid_AccountsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Plaid_AccountsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Plaid_AccountsOrderBy>>;
};

/** The root type for querying data */
export type QueryPlaid_ItemsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryPlaid_ItemsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Plaid_ItemsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Plaid_ItemsOrderBy>>;
};

/** The root type for querying data */
export type QueryPlaid_Spend_By_CustomerArgs = {
  p_account_ids?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  p_from?: InputMaybe<Scalars["Date"]["input"]>;
  p_to?: InputMaybe<Scalars["Date"]["input"]>;
};

/** The root type for querying data */
export type QueryPlaid_StatementsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryPlaid_StatementsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Plaid_StatementsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Plaid_StatementsOrderBy>>;
};

/** The root type for querying data */
export type QueryPlaid_Transaction_AttributionsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryPlaid_Transaction_AttributionsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Plaid_Transaction_AttributionsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Plaid_Transaction_AttributionsOrderBy>>;
};

/** The root type for querying data */
export type QueryPlaid_TransactionsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryPlaid_TransactionsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Plaid_TransactionsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Plaid_TransactionsOrderBy>>;
};

/** The root type for querying data */
export type QueryPlaid_Unattributed_Spend_SummaryArgs = {
  p_account_ids?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  p_from?: InputMaybe<Scalars["Date"]["input"]>;
  p_to?: InputMaybe<Scalars["Date"]["input"]>;
};

/** The root type for querying data */
export type QueryPost_Audit_Cron_LogsByPkArgs = {
  id: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryPost_Audit_Cron_LogsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Post_Audit_Cron_LogsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Post_Audit_Cron_LogsOrderBy>>;
};

/** The root type for querying data */
export type QueryPost_Audit_DocumentsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryPost_Audit_DocumentsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Post_Audit_DocumentsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Post_Audit_DocumentsOrderBy>>;
};

/** The root type for querying data */
export type QueryPost_Audit_Invoice_FeedbackByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryPost_Audit_Invoice_FeedbackCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Post_Audit_Invoice_FeedbackFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Post_Audit_Invoice_FeedbackOrderBy>>;
};

/** The root type for querying data */
export type QueryPost_Audit_InvoicesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryPost_Audit_InvoicesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Post_Audit_InvoicesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Post_Audit_InvoicesOrderBy>>;
};

/** The root type for querying data */
export type QueryProject_Chat_SubscriptionsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryProject_Chat_SubscriptionsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Project_Chat_SubscriptionsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Project_Chat_SubscriptionsOrderBy>>;
};

/** The root type for querying data */
export type QueryQueue_Event_LogByPkArgs = {
  id: Scalars["BigInt"]["input"];
};

/** The root type for querying data */
export type QueryQueue_Event_LogCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Queue_Event_LogFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Queue_Event_LogOrderBy>>;
};

/** The root type for querying data */
export type QueryQuickbooks_Company_Customer_AcksByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryQuickbooks_Company_Customer_AcksCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Quickbooks_Company_Customer_AcksFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Quickbooks_Company_Customer_AcksOrderBy>>;
};

/** The root type for querying data */
export type QueryQuickbooks_Customer_Link_IgnoresByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryQuickbooks_Customer_Link_IgnoresCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Quickbooks_Customer_Link_IgnoresFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Quickbooks_Customer_Link_IgnoresOrderBy>>;
};

/** The root type for querying data */
export type QueryQuickbooks_Realm_LabelsByPkArgs = {
  realm_id: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryQuickbooks_Realm_LabelsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Quickbooks_Realm_LabelsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Quickbooks_Realm_LabelsOrderBy>>;
};

/** The root type for querying data */
export type QueryQuo_Sync_Op_FailuresByPkArgs = {
  op_key: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryQuo_Sync_Op_FailuresCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Quo_Sync_Op_FailuresFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Quo_Sync_Op_FailuresOrderBy>>;
};

/** The root type for querying data */
export type QueryRate_Limit_BucketsByPkArgs = {
  bucket_key: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryRate_Limit_BucketsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Rate_Limit_BucketsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Rate_Limit_BucketsOrderBy>>;
};

/** The root type for querying data */
export type QueryRecurring_ChargesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryRecurring_ChargesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Recurring_ChargesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Recurring_ChargesOrderBy>>;
};

/** The root type for querying data */
export type QueryRecurring_TransactionsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryRecurring_TransactionsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Recurring_TransactionsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Recurring_TransactionsOrderBy>>;
};

/** The root type for querying data */
export type QueryResolve_Deal_Engineer_Search_TextArgs = {
  p_engineer_ids: Array<InputMaybe<Scalars["String"]["input"]>>;
};

/** The root type for querying data */
export type QueryRevenue_TargetsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryRevenue_TargetsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Revenue_TargetsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Revenue_TargetsOrderBy>>;
};

/** The root type for querying data */
export type QueryRolesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryRolesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<RolesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<RolesOrderBy>>;
};

/** The root type for querying data */
export type QuerySales_Sequence_EnrollmentsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QuerySales_Sequence_EnrollmentsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Sales_Sequence_EnrollmentsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Sales_Sequence_EnrollmentsOrderBy>>;
};

/** The root type for querying data */
export type QuerySales_Sequence_Step_EventsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QuerySales_Sequence_Step_EventsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Sales_Sequence_Step_EventsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Sales_Sequence_Step_EventsOrderBy>>;
};

/** The root type for querying data */
export type QuerySales_Sequence_StepsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QuerySales_Sequence_StepsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Sales_Sequence_StepsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Sales_Sequence_StepsOrderBy>>;
};

/** The root type for querying data */
export type QuerySales_SequencesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QuerySales_SequencesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Sales_SequencesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Sales_SequencesOrderBy>>;
};

/** The root type for querying data */
export type QuerySaved_View_FavoritesByPkArgs = {
  user_id: Scalars["UUID"]["input"];
  view_id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QuerySaved_View_FavoritesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Saved_View_FavoritesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Saved_View_FavoritesOrderBy>>;
};

/** The root type for querying data */
export type QuerySaved_ViewsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QuerySaved_ViewsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Saved_ViewsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Saved_ViewsOrderBy>>;
};

/** The root type for querying data */
export type QueryScheduled_EmailsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryScheduled_EmailsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Scheduled_EmailsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Scheduled_EmailsOrderBy>>;
};

/** The root type for querying data */
export type QueryScheduled_SmsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryScheduled_SmsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Scheduled_SmsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Scheduled_SmsOrderBy>>;
};

/** The root type for querying data */
export type QuerySecure_LinksByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QuerySecure_LinksCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Secure_LinksFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Secure_LinksOrderBy>>;
};

/** The root type for querying data */
export type QuerySkills_CatalogByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QuerySkills_CatalogCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Skills_CatalogFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Skills_CatalogOrderBy>>;
};

/** The root type for querying data */
export type QuerySlack_Channel_ProvisioningByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QuerySlack_Channel_ProvisioningCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Slack_Channel_ProvisioningFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Slack_Channel_ProvisioningOrderBy>>;
};

/** The root type for querying data */
export type QuerySlack_Processed_EventsByPkArgs = {
  dedup_key: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QuerySlack_Processed_EventsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Slack_Processed_EventsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Slack_Processed_EventsOrderBy>>;
};

/** The root type for querying data */
export type QuerySocial_Brand_ChannelsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QuerySocial_Brand_ChannelsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Social_Brand_ChannelsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Social_Brand_ChannelsOrderBy>>;
};

/** The root type for querying data */
export type QuerySocial_Brand_CredentialsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QuerySocial_Brand_CredentialsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Social_Brand_CredentialsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Social_Brand_CredentialsOrderBy>>;
};

/** The root type for querying data */
export type QuerySocial_Hashtag_GroupsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QuerySocial_Hashtag_GroupsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Social_Hashtag_GroupsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Social_Hashtag_GroupsOrderBy>>;
};

/** The root type for querying data */
export type QuerySocial_Media_PostsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QuerySocial_Media_PostsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Social_Media_PostsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Social_Media_PostsOrderBy>>;
};

/** The root type for querying data */
export type QueryTask_NotesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryTask_NotesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Task_NotesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Task_NotesOrderBy>>;
};

/** The root type for querying data */
export type QueryTicket_AttachmentsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryTicket_AttachmentsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Ticket_AttachmentsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Ticket_AttachmentsOrderBy>>;
};

/** The root type for querying data */
export type QueryTicket_TemplatesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryTicket_TemplatesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Ticket_TemplatesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Ticket_TemplatesOrderBy>>;
};

/** The root type for querying data */
export type QueryTicket_UpdatesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryTicket_UpdatesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Ticket_UpdatesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Ticket_UpdatesOrderBy>>;
};

/** The root type for querying data */
export type QueryTicketsByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryTicketsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<TicketsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TicketsOrderBy>>;
};

/** The root type for querying data */
export type QueryTickets_Build_Search_VectorArgs = {
  p_company_name: Scalars["String"]["input"];
  p_customer_visible_notes: Scalars["String"]["input"];
  p_description: Scalars["String"]["input"];
  p_internal_notes: Scalars["String"]["input"];
  p_tags: Scalars["String"]["input"];
  p_ticket_number: Scalars["String"]["input"];
  p_title: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryTime_EntriesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryTime_EntriesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Time_EntriesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Time_EntriesOrderBy>>;
};

/** The root type for querying data */
export type QueryUser_Oauth_ConnectionsByPkArgs = {
  connection_id: Scalars["String"]["input"];
};

/** The root type for querying data */
export type QueryUser_Oauth_ConnectionsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<User_Oauth_ConnectionsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<User_Oauth_ConnectionsOrderBy>>;
};

/** The root type for querying data */
export type QueryUser_PreferencesByPkArgs = {
  id: Scalars["UUID"]["input"];
};

/** The root type for querying data */
export type QueryUser_PreferencesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<User_PreferencesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<User_PreferencesOrderBy>>;
};

/** Boolean expression comparing fields on type "String" */
export type StringFilter = {
  eq?: InputMaybe<Scalars["String"]["input"]>;
  gt?: InputMaybe<Scalars["String"]["input"]>;
  gte?: InputMaybe<Scalars["String"]["input"]>;
  ilike?: InputMaybe<Scalars["String"]["input"]>;
  in?: InputMaybe<Array<Scalars["String"]["input"]>>;
  iregex?: InputMaybe<Scalars["String"]["input"]>;
  is?: InputMaybe<FilterIs>;
  like?: InputMaybe<Scalars["String"]["input"]>;
  lt?: InputMaybe<Scalars["String"]["input"]>;
  lte?: InputMaybe<Scalars["String"]["input"]>;
  neq?: InputMaybe<Scalars["String"]["input"]>;
  regex?: InputMaybe<Scalars["String"]["input"]>;
  startsWith?: InputMaybe<Scalars["String"]["input"]>;
};

/** Boolean expression comparing fields on type "StringList" */
export type StringListFilter = {
  containedBy?: InputMaybe<Array<Scalars["String"]["input"]>>;
  contains?: InputMaybe<Array<Scalars["String"]["input"]>>;
  eq?: InputMaybe<Array<Scalars["String"]["input"]>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Boolean expression comparing fields on type "Time" */
export type TimeFilter = {
  eq?: InputMaybe<Scalars["Time"]["input"]>;
  gt?: InputMaybe<Scalars["Time"]["input"]>;
  gte?: InputMaybe<Scalars["Time"]["input"]>;
  in?: InputMaybe<Array<Scalars["Time"]["input"]>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars["Time"]["input"]>;
  lte?: InputMaybe<Scalars["Time"]["input"]>;
  neq?: InputMaybe<Scalars["Time"]["input"]>;
};

/** Boolean expression comparing fields on type "TimeList" */
export type TimeListFilter = {
  containedBy?: InputMaybe<Array<Scalars["Time"]["input"]>>;
  contains?: InputMaybe<Array<Scalars["Time"]["input"]>>;
  eq?: InputMaybe<Array<Scalars["Time"]["input"]>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars["Time"]["input"]>>;
};

/** Boolean expression comparing fields on type "UUID" */
export type UuidFilter = {
  eq?: InputMaybe<Scalars["UUID"]["input"]>;
  in?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Scalars["UUID"]["input"]>;
};

/** Boolean expression comparing fields on type "UUIDList" */
export type UuidListFilter = {
  containedBy?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  contains?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  eq?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars["UUID"]["input"]>>;
};

export type Address_Geocode_Cache = Node & {
  __typename?: "address_geocode_cache";
  address_key: Scalars["String"]["output"];
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  formatted_address?: Maybe<Scalars["String"]["output"]>;
  lat?: Maybe<Scalars["Float"]["output"]>;
  lng?: Maybe<Scalars["Float"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type Address_Geocode_CacheConnection = {
  __typename?: "address_geocode_cacheConnection";
  edges: Array<Address_Geocode_CacheEdge>;
  pageInfo: PageInfo;
};

export type Address_Geocode_CacheDeleteResponse = {
  __typename?: "address_geocode_cacheDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Address_Geocode_Cache>;
};

export type Address_Geocode_CacheEdge = {
  __typename?: "address_geocode_cacheEdge";
  cursor: Scalars["String"]["output"];
  node: Address_Geocode_Cache;
};

export type Address_Geocode_CacheFilter = {
  address_key?: InputMaybe<StringFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Address_Geocode_CacheFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  formatted_address?: InputMaybe<StringFilter>;
  lat?: InputMaybe<FloatFilter>;
  lng?: InputMaybe<FloatFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Address_Geocode_CacheFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Address_Geocode_CacheFilter>>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Address_Geocode_CacheInsertInput = {
  address_key?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  formatted_address?: InputMaybe<Scalars["String"]["input"]>;
  lat?: InputMaybe<Scalars["Float"]["input"]>;
  lng?: InputMaybe<Scalars["Float"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Address_Geocode_CacheInsertResponse = {
  __typename?: "address_geocode_cacheInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Address_Geocode_Cache>;
};

export type Address_Geocode_CacheOrderBy = {
  address_key?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  formatted_address?: InputMaybe<OrderByDirection>;
  lat?: InputMaybe<OrderByDirection>;
  lng?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Address_Geocode_CacheUpdateInput = {
  address_key?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  formatted_address?: InputMaybe<Scalars["String"]["input"]>;
  lat?: InputMaybe<Scalars["Float"]["input"]>;
  lng?: InputMaybe<Scalars["Float"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Address_Geocode_CacheUpdateResponse = {
  __typename?: "address_geocode_cacheUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Address_Geocode_Cache>;
};

export type App_User_Skills = Node & {
  __typename?: "app_user_skills";
  app_users?: Maybe<App_Users>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  grade: Scalars["Int"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  skill_id: Scalars["UUID"]["output"];
  skills_catalog?: Maybe<Skills_Catalog>;
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  user_id: Scalars["UUID"]["output"];
};

export type App_User_SkillsConnection = {
  __typename?: "app_user_skillsConnection";
  edges: Array<App_User_SkillsEdge>;
  pageInfo: PageInfo;
};

export type App_User_SkillsDeleteResponse = {
  __typename?: "app_user_skillsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<App_User_Skills>;
};

export type App_User_SkillsEdge = {
  __typename?: "app_user_skillsEdge";
  cursor: Scalars["String"]["output"];
  node: App_User_Skills;
};

export type App_User_SkillsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<App_User_SkillsFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  grade?: InputMaybe<IntFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<App_User_SkillsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<App_User_SkillsFilter>>;
  skill_id?: InputMaybe<UuidFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type App_User_SkillsInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  grade?: InputMaybe<Scalars["Int"]["input"]>;
  skill_id?: InputMaybe<Scalars["UUID"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type App_User_SkillsInsertResponse = {
  __typename?: "app_user_skillsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<App_User_Skills>;
};

export type App_User_SkillsOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  grade?: InputMaybe<OrderByDirection>;
  skill_id?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type App_User_SkillsUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  grade?: InputMaybe<Scalars["Int"]["input"]>;
  skill_id?: InputMaybe<Scalars["UUID"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type App_User_SkillsUpdateResponse = {
  __typename?: "app_user_skillsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<App_User_Skills>;
};

export type App_Users = Node & {
  __typename?: "app_users";
  app_user_skillsCollection?: Maybe<App_User_SkillsConnection>;
  automation_rulesCollection?: Maybe<Automation_RulesConnection>;
  available_hours?: Maybe<Scalars["Int"]["output"]>;
  companiesCollection?: Maybe<CompaniesConnection>;
  company_slack_channel_link_ignoresCollection?: Maybe<Company_Slack_Channel_Link_IgnoresConnection>;
  company_user_accessCollection?: Maybe<Company_User_AccessConnection>;
  config: Scalars["JSON"]["output"];
  connection_sharesCollection?: Maybe<Connection_SharesConnection>;
  contact_filesCollection?: Maybe<Contact_FilesConnection>;
  contact_meetingsCollection?: Maybe<Contact_MeetingsConnection>;
  contact_merge_ignoresCollection?: Maybe<Contact_Merge_IgnoresConnection>;
  contact_messagesCollection?: Maybe<Contact_MessagesConnection>;
  contact_notesCollection?: Maybe<Contact_NotesConnection>;
  contact_proposalsCollection?: Maybe<Contact_ProposalsConnection>;
  contact_tasksCollection?: Maybe<Contact_TasksConnection>;
  contact_user_accessCollection?: Maybe<Contact_User_AccessConnection>;
  contactsCollection?: Maybe<ContactsConnection>;
  contract_previewsCollection?: Maybe<Contract_PreviewsConnection>;
  contractsCollection?: Maybe<ContractsConnection>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  device_push_tokensCollection?: Maybe<Device_Push_TokensConnection>;
  drive_nodesCollection?: Maybe<Drive_NodesConnection>;
  drive_user_roots?: Maybe<Drive_User_Roots>;
  email: Scalars["String"]["output"];
  email_aliases?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  email_signature_title?: Maybe<Scalars["String"]["output"]>;
  email_signaturesCollection?: Maybe<Email_SignaturesConnection>;
  email_tracking_tokensCollection?: Maybe<Email_Tracking_TokensConnection>;
  employee_contact_accessCollection?: Maybe<Employee_Contact_AccessConnection>;
  entity_automation_configCollection?: Maybe<Entity_Automation_ConfigConnection>;
  first_name?: Maybe<Scalars["String"]["output"]>;
  google_drive_access_grantsCollection?: Maybe<Google_Drive_Access_GrantsConnection>;
  google_group_enrollmentsCollection?: Maybe<Google_Group_EnrollmentsConnection>;
  hourly_rate?: Maybe<Scalars["BigFloat"]["output"]>;
  id: Scalars["UUID"]["output"];
  inbound_sender_rulesCollection?: Maybe<Inbound_Sender_RulesConnection>;
  ios_metric_payloadsCollection?: Maybe<Ios_Metric_PayloadsConnection>;
  is_active?: Maybe<Scalars["Boolean"]["output"]>;
  is_billable?: Maybe<Scalars["Boolean"]["output"]>;
  last_name?: Maybe<Scalars["String"]["output"]>;
  mail_user_settings?: Maybe<Mail_User_Settings>;
  mcp_server_connectionsCollection?: Maybe<Mcp_Server_ConnectionsConnection>;
  meridian_default_email_connection_id?: Maybe<Scalars["String"]["output"]>;
  meridian_default_email_provider?: Maybe<Scalars["String"]["output"]>;
  meridian_google_calendar_use_second_account: Scalars["Boolean"]["output"];
  meridian_skill_activationsCollection?: Maybe<Meridian_Skill_ActivationsConnection>;
  meridian_tool_approval_overridesCollection?: Maybe<Meridian_Tool_Approval_OverridesConnection>;
  msp_documentsCollection?: Maybe<Msp_DocumentsConnection>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  notification_preferencesCollection?: Maybe<Notification_PreferencesConnection>;
  offeringsCollection?: Maybe<OfferingsConnection>;
  plaid_itemsCollection?: Maybe<Plaid_ItemsConnection>;
  plaid_transaction_attributionsCollection?: Maybe<Plaid_Transaction_AttributionsConnection>;
  quickbooks_access_token?: Maybe<Scalars["String"]["output"]>;
  quickbooks_active_realm_id?: Maybe<Scalars["String"]["output"]>;
  quickbooks_company_customer_acksCollection?: Maybe<Quickbooks_Company_Customer_AcksConnection>;
  quickbooks_connected_at?: Maybe<Scalars["Datetime"]["output"]>;
  quickbooks_connections?: Maybe<Scalars["JSON"]["output"]>;
  quickbooks_customer_link_ignoresCollection?: Maybe<Quickbooks_Customer_Link_IgnoresConnection>;
  quickbooks_employee_name?: Maybe<Scalars["String"]["output"]>;
  quickbooks_employee_ref?: Maybe<Scalars["String"]["output"]>;
  quickbooks_environment?: Maybe<Scalars["String"]["output"]>;
  quickbooks_last_sync_at?: Maybe<Scalars["Datetime"]["output"]>;
  quickbooks_realm_id?: Maybe<Scalars["String"]["output"]>;
  quickbooks_refresh_token?: Maybe<Scalars["String"]["output"]>;
  quickbooks_token_expires_at?: Maybe<Scalars["Datetime"]["output"]>;
  revenue_targetsCollection?: Maybe<Revenue_TargetsConnection>;
  role_id: Scalars["UUID"]["output"];
  roles?: Maybe<Roles>;
  sales_sequence_enrollmentsCollection?: Maybe<Sales_Sequence_EnrollmentsConnection>;
  sales_sequence_step_eventsCollection?: Maybe<Sales_Sequence_Step_EventsConnection>;
  sales_sequencesCollection?: Maybe<Sales_SequencesConnection>;
  scheduled_emailsCollection?: Maybe<Scheduled_EmailsConnection>;
  scheduled_smsCollection?: Maybe<Scheduled_SmsConnection>;
  search_vector?: Maybe<Scalars["Opaque"]["output"]>;
  secure_linksCollection?: Maybe<Secure_LinksConnection>;
  sensitive_feature_access: Array<Maybe<Scalars["String"]["output"]>>;
  slack_user_id?: Maybe<Scalars["String"]["output"]>;
  tags: Array<Maybe<Scalars["String"]["output"]>>;
  task_notesCollection?: Maybe<Task_NotesConnection>;
  ticket_attachmentsCollection?: Maybe<Ticket_AttachmentsConnection>;
  ticket_templatesCollection?: Maybe<Ticket_TemplatesConnection>;
  ticket_updatesCollection?: Maybe<Ticket_UpdatesConnection>;
  ticketsCollection?: Maybe<TicketsConnection>;
  time_entriesCollection?: Maybe<Time_EntriesConnection>;
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  user_prefs: Scalars["JSON"]["output"];
};

export type App_UsersApp_User_SkillsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<App_User_SkillsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<App_User_SkillsOrderBy>>;
};

export type App_UsersAutomation_RulesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Automation_RulesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Automation_RulesOrderBy>>;
};

export type App_UsersCompaniesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<CompaniesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CompaniesOrderBy>>;
};

export type App_UsersCompany_Slack_Channel_Link_IgnoresCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Company_Slack_Channel_Link_IgnoresFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Company_Slack_Channel_Link_IgnoresOrderBy>>;
};

export type App_UsersCompany_User_AccessCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Company_User_AccessFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Company_User_AccessOrderBy>>;
};

export type App_UsersConnection_SharesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Connection_SharesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Connection_SharesOrderBy>>;
};

export type App_UsersContact_FilesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_FilesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_FilesOrderBy>>;
};

export type App_UsersContact_MeetingsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_MeetingsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_MeetingsOrderBy>>;
};

export type App_UsersContact_Merge_IgnoresCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_Merge_IgnoresFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_Merge_IgnoresOrderBy>>;
};

export type App_UsersContact_MessagesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_MessagesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_MessagesOrderBy>>;
};

export type App_UsersContact_NotesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_NotesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_NotesOrderBy>>;
};

export type App_UsersContact_ProposalsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_ProposalsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_ProposalsOrderBy>>;
};

export type App_UsersContact_TasksCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_TasksFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_TasksOrderBy>>;
};

export type App_UsersContact_User_AccessCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_User_AccessFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_User_AccessOrderBy>>;
};

export type App_UsersContactsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<ContactsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ContactsOrderBy>>;
};

export type App_UsersContract_PreviewsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contract_PreviewsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contract_PreviewsOrderBy>>;
};

export type App_UsersContractsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<ContractsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ContractsOrderBy>>;
};

export type App_UsersDevice_Push_TokensCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Device_Push_TokensFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Device_Push_TokensOrderBy>>;
};

export type App_UsersDrive_NodesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Drive_NodesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Drive_NodesOrderBy>>;
};

export type App_UsersEmail_SignaturesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_SignaturesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_SignaturesOrderBy>>;
};

export type App_UsersEmail_Tracking_TokensCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_Tracking_TokensFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_Tracking_TokensOrderBy>>;
};

export type App_UsersEmployee_Contact_AccessCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Employee_Contact_AccessFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Employee_Contact_AccessOrderBy>>;
};

export type App_UsersEntity_Automation_ConfigCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Entity_Automation_ConfigFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Entity_Automation_ConfigOrderBy>>;
};

export type App_UsersGoogle_Drive_Access_GrantsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Google_Drive_Access_GrantsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Google_Drive_Access_GrantsOrderBy>>;
};

export type App_UsersGoogle_Group_EnrollmentsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Google_Group_EnrollmentsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Google_Group_EnrollmentsOrderBy>>;
};

export type App_UsersInbound_Sender_RulesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Inbound_Sender_RulesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Inbound_Sender_RulesOrderBy>>;
};

export type App_UsersIos_Metric_PayloadsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Ios_Metric_PayloadsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Ios_Metric_PayloadsOrderBy>>;
};

export type App_UsersMcp_Server_ConnectionsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Mcp_Server_ConnectionsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Mcp_Server_ConnectionsOrderBy>>;
};

export type App_UsersMeridian_Skill_ActivationsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Meridian_Skill_ActivationsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Meridian_Skill_ActivationsOrderBy>>;
};

export type App_UsersMeridian_Tool_Approval_OverridesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Meridian_Tool_Approval_OverridesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Meridian_Tool_Approval_OverridesOrderBy>>;
};

export type App_UsersMsp_DocumentsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Msp_DocumentsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Msp_DocumentsOrderBy>>;
};

export type App_UsersNotification_PreferencesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Notification_PreferencesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Notification_PreferencesOrderBy>>;
};

export type App_UsersOfferingsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<OfferingsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<OfferingsOrderBy>>;
};

export type App_UsersPlaid_ItemsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Plaid_ItemsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Plaid_ItemsOrderBy>>;
};

export type App_UsersPlaid_Transaction_AttributionsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Plaid_Transaction_AttributionsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Plaid_Transaction_AttributionsOrderBy>>;
};

export type App_UsersQuickbooks_Company_Customer_AcksCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Quickbooks_Company_Customer_AcksFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Quickbooks_Company_Customer_AcksOrderBy>>;
};

export type App_UsersQuickbooks_Customer_Link_IgnoresCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Quickbooks_Customer_Link_IgnoresFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Quickbooks_Customer_Link_IgnoresOrderBy>>;
};

export type App_UsersRevenue_TargetsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Revenue_TargetsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Revenue_TargetsOrderBy>>;
};

export type App_UsersSales_Sequence_EnrollmentsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Sales_Sequence_EnrollmentsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Sales_Sequence_EnrollmentsOrderBy>>;
};

export type App_UsersSales_Sequence_Step_EventsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Sales_Sequence_Step_EventsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Sales_Sequence_Step_EventsOrderBy>>;
};

export type App_UsersSales_SequencesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Sales_SequencesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Sales_SequencesOrderBy>>;
};

export type App_UsersScheduled_EmailsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Scheduled_EmailsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Scheduled_EmailsOrderBy>>;
};

export type App_UsersScheduled_SmsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Scheduled_SmsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Scheduled_SmsOrderBy>>;
};

export type App_UsersSecure_LinksCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Secure_LinksFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Secure_LinksOrderBy>>;
};

export type App_UsersTask_NotesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Task_NotesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Task_NotesOrderBy>>;
};

export type App_UsersTicket_AttachmentsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Ticket_AttachmentsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Ticket_AttachmentsOrderBy>>;
};

export type App_UsersTicket_TemplatesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Ticket_TemplatesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Ticket_TemplatesOrderBy>>;
};

export type App_UsersTicket_UpdatesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Ticket_UpdatesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Ticket_UpdatesOrderBy>>;
};

export type App_UsersTicketsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<TicketsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TicketsOrderBy>>;
};

export type App_UsersTime_EntriesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Time_EntriesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Time_EntriesOrderBy>>;
};

/** Aggregate results for `app_users` */
export type App_UsersAggregate = {
  __typename?: "app_usersAggregate";
  /** Average aggregates for numeric fields */
  avg?: Maybe<App_UsersAvgAggregateResult>;
  /** The number of records matching the query */
  count: Scalars["Int"]["output"];
  /** Maximum aggregates for comparable fields */
  max?: Maybe<App_UsersMaxAggregateResult>;
  /** Minimum aggregates for comparable fields */
  min?: Maybe<App_UsersMinAggregateResult>;
  /** Summation aggregates for numeric fields */
  sum?: Maybe<App_UsersSumAggregateResult>;
};

/** Result of average aggregation for `app_users` */
export type App_UsersAvgAggregateResult = {
  __typename?: "app_usersAvgAggregateResult";
  /** Average of available_hours across all matching records */
  available_hours?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Average of hourly_rate across all matching records */
  hourly_rate?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type App_UsersConnection = {
  __typename?: "app_usersConnection";
  /** Aggregate functions calculated on the collection of `app_users` */
  aggregate?: Maybe<App_UsersAggregate>;
  edges: Array<App_UsersEdge>;
  pageInfo: PageInfo;
  /** The total number of records matching the `filter` criteria */
  totalCount: Scalars["Int"]["output"];
};

export type App_UsersDeleteResponse = {
  __typename?: "app_usersDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<App_Users>;
};

export type App_UsersEdge = {
  __typename?: "app_usersEdge";
  cursor: Scalars["String"]["output"];
  node: App_Users;
};

export type App_UsersFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<App_UsersFilter>>;
  available_hours?: InputMaybe<IntFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  email?: InputMaybe<StringFilter>;
  email_aliases?: InputMaybe<StringListFilter>;
  email_signature_title?: InputMaybe<StringFilter>;
  first_name?: InputMaybe<StringFilter>;
  hourly_rate?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<UuidFilter>;
  is_active?: InputMaybe<BooleanFilter>;
  is_billable?: InputMaybe<BooleanFilter>;
  last_name?: InputMaybe<StringFilter>;
  meridian_default_email_connection_id?: InputMaybe<StringFilter>;
  meridian_default_email_provider?: InputMaybe<StringFilter>;
  meridian_google_calendar_use_second_account?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<App_UsersFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<App_UsersFilter>>;
  quickbooks_access_token?: InputMaybe<StringFilter>;
  quickbooks_active_realm_id?: InputMaybe<StringFilter>;
  quickbooks_connected_at?: InputMaybe<DatetimeFilter>;
  quickbooks_employee_name?: InputMaybe<StringFilter>;
  quickbooks_employee_ref?: InputMaybe<StringFilter>;
  quickbooks_environment?: InputMaybe<StringFilter>;
  quickbooks_last_sync_at?: InputMaybe<DatetimeFilter>;
  quickbooks_realm_id?: InputMaybe<StringFilter>;
  quickbooks_refresh_token?: InputMaybe<StringFilter>;
  quickbooks_token_expires_at?: InputMaybe<DatetimeFilter>;
  role_id?: InputMaybe<UuidFilter>;
  search_vector?: InputMaybe<OpaqueFilter>;
  sensitive_feature_access?: InputMaybe<StringListFilter>;
  slack_user_id?: InputMaybe<StringFilter>;
  tags?: InputMaybe<StringListFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type App_UsersInsertInput = {
  available_hours?: InputMaybe<Scalars["Int"]["input"]>;
  config?: InputMaybe<Scalars["JSON"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  email_aliases?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  email_signature_title?: InputMaybe<Scalars["String"]["input"]>;
  first_name?: InputMaybe<Scalars["String"]["input"]>;
  hourly_rate?: InputMaybe<Scalars["BigFloat"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_billable?: InputMaybe<Scalars["Boolean"]["input"]>;
  last_name?: InputMaybe<Scalars["String"]["input"]>;
  meridian_default_email_connection_id?: InputMaybe<Scalars["String"]["input"]>;
  meridian_default_email_provider?: InputMaybe<Scalars["String"]["input"]>;
  meridian_google_calendar_use_second_account?: InputMaybe<Scalars["Boolean"]["input"]>;
  quickbooks_access_token?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_active_realm_id?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_connected_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  quickbooks_connections?: InputMaybe<Scalars["JSON"]["input"]>;
  quickbooks_employee_name?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_employee_ref?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_environment?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_last_sync_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  quickbooks_realm_id?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_refresh_token?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_token_expires_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  role_id?: InputMaybe<Scalars["UUID"]["input"]>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  sensitive_feature_access?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  slack_user_id?: InputMaybe<Scalars["String"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_prefs?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type App_UsersInsertResponse = {
  __typename?: "app_usersInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<App_Users>;
};

/** Result of maximum aggregation for `app_users` */
export type App_UsersMaxAggregateResult = {
  __typename?: "app_usersMaxAggregateResult";
  /** Maximum of available_hours across all matching records */
  available_hours?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of created_at across all matching records */
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Maximum of email across all matching records */
  email?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of email_signature_title across all matching records */
  email_signature_title?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of first_name across all matching records */
  first_name?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of hourly_rate across all matching records */
  hourly_rate?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Maximum of is_active across all matching records */
  is_active?: Maybe<Scalars["Boolean"]["output"]>;
  /** Maximum of is_billable across all matching records */
  is_billable?: Maybe<Scalars["Boolean"]["output"]>;
  /** Maximum of last_name across all matching records */
  last_name?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of meridian_default_email_connection_id across all matching records */
  meridian_default_email_connection_id?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of meridian_default_email_provider across all matching records */
  meridian_default_email_provider?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of meridian_google_calendar_use_second_account across all matching records */
  meridian_google_calendar_use_second_account?: Maybe<Scalars["Boolean"]["output"]>;
  /** Maximum of quickbooks_access_token across all matching records */
  quickbooks_access_token?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of quickbooks_active_realm_id across all matching records */
  quickbooks_active_realm_id?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of quickbooks_connected_at across all matching records */
  quickbooks_connected_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Maximum of quickbooks_employee_name across all matching records */
  quickbooks_employee_name?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of quickbooks_employee_ref across all matching records */
  quickbooks_employee_ref?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of quickbooks_environment across all matching records */
  quickbooks_environment?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of quickbooks_last_sync_at across all matching records */
  quickbooks_last_sync_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Maximum of quickbooks_realm_id across all matching records */
  quickbooks_realm_id?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of quickbooks_refresh_token across all matching records */
  quickbooks_refresh_token?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of quickbooks_token_expires_at across all matching records */
  quickbooks_token_expires_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Maximum of slack_user_id across all matching records */
  slack_user_id?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of updated_at across all matching records */
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

/** Result of minimum aggregation for `app_users` */
export type App_UsersMinAggregateResult = {
  __typename?: "app_usersMinAggregateResult";
  /** Minimum of available_hours across all matching records */
  available_hours?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of created_at across all matching records */
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Minimum of email across all matching records */
  email?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of email_signature_title across all matching records */
  email_signature_title?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of first_name across all matching records */
  first_name?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of hourly_rate across all matching records */
  hourly_rate?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Minimum of is_active across all matching records */
  is_active?: Maybe<Scalars["Boolean"]["output"]>;
  /** Minimum of is_billable across all matching records */
  is_billable?: Maybe<Scalars["Boolean"]["output"]>;
  /** Minimum of last_name across all matching records */
  last_name?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of meridian_default_email_connection_id across all matching records */
  meridian_default_email_connection_id?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of meridian_default_email_provider across all matching records */
  meridian_default_email_provider?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of meridian_google_calendar_use_second_account across all matching records */
  meridian_google_calendar_use_second_account?: Maybe<Scalars["Boolean"]["output"]>;
  /** Minimum of quickbooks_access_token across all matching records */
  quickbooks_access_token?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of quickbooks_active_realm_id across all matching records */
  quickbooks_active_realm_id?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of quickbooks_connected_at across all matching records */
  quickbooks_connected_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Minimum of quickbooks_employee_name across all matching records */
  quickbooks_employee_name?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of quickbooks_employee_ref across all matching records */
  quickbooks_employee_ref?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of quickbooks_environment across all matching records */
  quickbooks_environment?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of quickbooks_last_sync_at across all matching records */
  quickbooks_last_sync_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Minimum of quickbooks_realm_id across all matching records */
  quickbooks_realm_id?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of quickbooks_refresh_token across all matching records */
  quickbooks_refresh_token?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of quickbooks_token_expires_at across all matching records */
  quickbooks_token_expires_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Minimum of slack_user_id across all matching records */
  slack_user_id?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of updated_at across all matching records */
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type App_UsersOrderBy = {
  available_hours?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  email?: InputMaybe<OrderByDirection>;
  email_signature_title?: InputMaybe<OrderByDirection>;
  first_name?: InputMaybe<OrderByDirection>;
  hourly_rate?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_active?: InputMaybe<OrderByDirection>;
  is_billable?: InputMaybe<OrderByDirection>;
  last_name?: InputMaybe<OrderByDirection>;
  meridian_default_email_connection_id?: InputMaybe<OrderByDirection>;
  meridian_default_email_provider?: InputMaybe<OrderByDirection>;
  meridian_google_calendar_use_second_account?: InputMaybe<OrderByDirection>;
  quickbooks_access_token?: InputMaybe<OrderByDirection>;
  quickbooks_active_realm_id?: InputMaybe<OrderByDirection>;
  quickbooks_connected_at?: InputMaybe<OrderByDirection>;
  quickbooks_employee_name?: InputMaybe<OrderByDirection>;
  quickbooks_employee_ref?: InputMaybe<OrderByDirection>;
  quickbooks_environment?: InputMaybe<OrderByDirection>;
  quickbooks_last_sync_at?: InputMaybe<OrderByDirection>;
  quickbooks_realm_id?: InputMaybe<OrderByDirection>;
  quickbooks_refresh_token?: InputMaybe<OrderByDirection>;
  quickbooks_token_expires_at?: InputMaybe<OrderByDirection>;
  role_id?: InputMaybe<OrderByDirection>;
  search_vector?: InputMaybe<OrderByDirection>;
  slack_user_id?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

/** Result of summation aggregation for `app_users` */
export type App_UsersSumAggregateResult = {
  __typename?: "app_usersSumAggregateResult";
  /** Sum of available_hours across all matching records */
  available_hours?: Maybe<Scalars["BigInt"]["output"]>;
  /** Sum of hourly_rate across all matching records */
  hourly_rate?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type App_UsersUpdateInput = {
  available_hours?: InputMaybe<Scalars["Int"]["input"]>;
  config?: InputMaybe<Scalars["JSON"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  email_aliases?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  email_signature_title?: InputMaybe<Scalars["String"]["input"]>;
  first_name?: InputMaybe<Scalars["String"]["input"]>;
  hourly_rate?: InputMaybe<Scalars["BigFloat"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_billable?: InputMaybe<Scalars["Boolean"]["input"]>;
  last_name?: InputMaybe<Scalars["String"]["input"]>;
  meridian_default_email_connection_id?: InputMaybe<Scalars["String"]["input"]>;
  meridian_default_email_provider?: InputMaybe<Scalars["String"]["input"]>;
  meridian_google_calendar_use_second_account?: InputMaybe<Scalars["Boolean"]["input"]>;
  quickbooks_access_token?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_active_realm_id?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_connected_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  quickbooks_connections?: InputMaybe<Scalars["JSON"]["input"]>;
  quickbooks_employee_name?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_employee_ref?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_environment?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_last_sync_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  quickbooks_realm_id?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_refresh_token?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_token_expires_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  role_id?: InputMaybe<Scalars["UUID"]["input"]>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  sensitive_feature_access?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  slack_user_id?: InputMaybe<Scalars["String"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_prefs?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type App_UsersUpdateResponse = {
  __typename?: "app_usersUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<App_Users>;
};

export type Audit_Log = Node & {
  __typename?: "audit_log";
  action: Scalars["String"]["output"];
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  details?: Maybe<Scalars["JSON"]["output"]>;
  email: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  ip_address?: Maybe<Scalars["Opaque"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  provider?: Maybe<Scalars["String"]["output"]>;
  user_agent?: Maybe<Scalars["String"]["output"]>;
};

export type Audit_LogConnection = {
  __typename?: "audit_logConnection";
  edges: Array<Audit_LogEdge>;
  pageInfo: PageInfo;
};

export type Audit_LogDeleteResponse = {
  __typename?: "audit_logDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Audit_Log>;
};

export type Audit_LogEdge = {
  __typename?: "audit_logEdge";
  cursor: Scalars["String"]["output"];
  node: Audit_Log;
};

export type Audit_LogFilter = {
  action?: InputMaybe<StringFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Audit_LogFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  ip_address?: InputMaybe<OpaqueFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Audit_LogFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Audit_LogFilter>>;
  provider?: InputMaybe<StringFilter>;
  user_agent?: InputMaybe<StringFilter>;
};

export type Audit_LogInsertInput = {
  action?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  details?: InputMaybe<Scalars["JSON"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  ip_address?: InputMaybe<Scalars["Opaque"]["input"]>;
  provider?: InputMaybe<Scalars["String"]["input"]>;
  user_agent?: InputMaybe<Scalars["String"]["input"]>;
};

export type Audit_LogInsertResponse = {
  __typename?: "audit_logInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Audit_Log>;
};

export type Audit_LogOrderBy = {
  action?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  email?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  ip_address?: InputMaybe<OrderByDirection>;
  provider?: InputMaybe<OrderByDirection>;
  user_agent?: InputMaybe<OrderByDirection>;
};

export type Audit_LogUpdateInput = {
  action?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  details?: InputMaybe<Scalars["JSON"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  ip_address?: InputMaybe<Scalars["Opaque"]["input"]>;
  provider?: InputMaybe<Scalars["String"]["input"]>;
  user_agent?: InputMaybe<Scalars["String"]["input"]>;
};

export type Audit_LogUpdateResponse = {
  __typename?: "audit_logUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Audit_Log>;
};

export type Automation_Rules = Node & {
  __typename?: "automation_rules";
  actions: Scalars["JSON"]["output"];
  app_users?: Maybe<App_Users>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  created_by: Scalars["UUID"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  is_active?: Maybe<Scalars["Boolean"]["output"]>;
  name: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  priority?: Maybe<Scalars["Int"]["output"]>;
  trigger_condition: Scalars["JSON"]["output"];
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type Automation_RulesConnection = {
  __typename?: "automation_rulesConnection";
  edges: Array<Automation_RulesEdge>;
  pageInfo: PageInfo;
};

export type Automation_RulesDeleteResponse = {
  __typename?: "automation_rulesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Automation_Rules>;
};

export type Automation_RulesEdge = {
  __typename?: "automation_rulesEdge";
  cursor: Scalars["String"]["output"];
  node: Automation_Rules;
};

export type Automation_RulesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Automation_RulesFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  is_active?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Automation_RulesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Automation_RulesFilter>>;
  priority?: InputMaybe<IntFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Automation_RulesInsertInput = {
  actions?: InputMaybe<Scalars["JSON"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  priority?: InputMaybe<Scalars["Int"]["input"]>;
  trigger_condition?: InputMaybe<Scalars["JSON"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Automation_RulesInsertResponse = {
  __typename?: "automation_rulesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Automation_Rules>;
};

export type Automation_RulesOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_active?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  priority?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Automation_RulesUpdateInput = {
  actions?: InputMaybe<Scalars["JSON"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  priority?: InputMaybe<Scalars["Int"]["input"]>;
  trigger_condition?: InputMaybe<Scalars["JSON"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Automation_RulesUpdateResponse = {
  __typename?: "automation_rulesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Automation_Rules>;
};

export type Booking_History = Node & {
  __typename?: "booking_history";
  attendees?: Maybe<Scalars["JSON"]["output"]>;
  bookee_email: Scalars["String"]["output"];
  booker_email: Scalars["String"]["output"];
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  end_time: Scalars["Datetime"]["output"];
  google_event_id?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  location?: Maybe<Scalars["String"]["output"]>;
  msft_event_id?: Maybe<Scalars["String"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  start_time: Scalars["Datetime"]["output"];
  status?: Maybe<Scalars["String"]["output"]>;
  subject: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type Booking_HistoryConnection = {
  __typename?: "booking_historyConnection";
  edges: Array<Booking_HistoryEdge>;
  pageInfo: PageInfo;
};

export type Booking_HistoryDeleteResponse = {
  __typename?: "booking_historyDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Booking_History>;
};

export type Booking_HistoryEdge = {
  __typename?: "booking_historyEdge";
  cursor: Scalars["String"]["output"];
  node: Booking_History;
};

export type Booking_HistoryFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Booking_HistoryFilter>>;
  bookee_email?: InputMaybe<StringFilter>;
  booker_email?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  end_time?: InputMaybe<DatetimeFilter>;
  google_event_id?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  location?: InputMaybe<StringFilter>;
  msft_event_id?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Booking_HistoryFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Booking_HistoryFilter>>;
  start_time?: InputMaybe<DatetimeFilter>;
  status?: InputMaybe<StringFilter>;
  subject?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Booking_HistoryInsertInput = {
  attendees?: InputMaybe<Scalars["JSON"]["input"]>;
  bookee_email?: InputMaybe<Scalars["String"]["input"]>;
  booker_email?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  end_time?: InputMaybe<Scalars["Datetime"]["input"]>;
  google_event_id?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  msft_event_id?: InputMaybe<Scalars["String"]["input"]>;
  start_time?: InputMaybe<Scalars["Datetime"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  subject?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Booking_HistoryInsertResponse = {
  __typename?: "booking_historyInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Booking_History>;
};

export type Booking_HistoryOrderBy = {
  bookee_email?: InputMaybe<OrderByDirection>;
  booker_email?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  end_time?: InputMaybe<OrderByDirection>;
  google_event_id?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  location?: InputMaybe<OrderByDirection>;
  msft_event_id?: InputMaybe<OrderByDirection>;
  start_time?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  subject?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Booking_HistoryUpdateInput = {
  attendees?: InputMaybe<Scalars["JSON"]["input"]>;
  bookee_email?: InputMaybe<Scalars["String"]["input"]>;
  booker_email?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  end_time?: InputMaybe<Scalars["Datetime"]["input"]>;
  google_event_id?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  msft_event_id?: InputMaybe<Scalars["String"]["input"]>;
  start_time?: InputMaybe<Scalars["Datetime"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  subject?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Booking_HistoryUpdateResponse = {
  __typename?: "booking_historyUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Booking_History>;
};

export type Calendar_Cache = Node & {
  __typename?: "calendar_cache";
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  email: Scalars["String"]["output"];
  end_time: Scalars["Datetime"]["output"];
  event_data: Scalars["JSON"]["output"];
  event_id: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  last_synced?: Maybe<Scalars["Datetime"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  provider: Scalars["String"]["output"];
  start_time: Scalars["Datetime"]["output"];
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type Calendar_CacheConnection = {
  __typename?: "calendar_cacheConnection";
  edges: Array<Calendar_CacheEdge>;
  pageInfo: PageInfo;
};

export type Calendar_CacheDeleteResponse = {
  __typename?: "calendar_cacheDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Calendar_Cache>;
};

export type Calendar_CacheEdge = {
  __typename?: "calendar_cacheEdge";
  cursor: Scalars["String"]["output"];
  node: Calendar_Cache;
};

export type Calendar_CacheFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Calendar_CacheFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  email?: InputMaybe<StringFilter>;
  end_time?: InputMaybe<DatetimeFilter>;
  event_id?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  last_synced?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Calendar_CacheFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Calendar_CacheFilter>>;
  provider?: InputMaybe<StringFilter>;
  start_time?: InputMaybe<DatetimeFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Calendar_CacheInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  end_time?: InputMaybe<Scalars["Datetime"]["input"]>;
  event_data?: InputMaybe<Scalars["JSON"]["input"]>;
  event_id?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  last_synced?: InputMaybe<Scalars["Datetime"]["input"]>;
  provider?: InputMaybe<Scalars["String"]["input"]>;
  start_time?: InputMaybe<Scalars["Datetime"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Calendar_CacheInsertResponse = {
  __typename?: "calendar_cacheInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Calendar_Cache>;
};

export type Calendar_CacheOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  email?: InputMaybe<OrderByDirection>;
  end_time?: InputMaybe<OrderByDirection>;
  event_id?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  last_synced?: InputMaybe<OrderByDirection>;
  provider?: InputMaybe<OrderByDirection>;
  start_time?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Calendar_CacheUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  end_time?: InputMaybe<Scalars["Datetime"]["input"]>;
  event_data?: InputMaybe<Scalars["JSON"]["input"]>;
  event_id?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  last_synced?: InputMaybe<Scalars["Datetime"]["input"]>;
  provider?: InputMaybe<Scalars["String"]["input"]>;
  start_time?: InputMaybe<Scalars["Datetime"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Calendar_CacheUpdateResponse = {
  __typename?: "calendar_cacheUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Calendar_Cache>;
};

export type Communication_Types = Node & {
  __typename?: "communication_types";
  communicationsCollection?: Maybe<CommunicationsConnection>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  is_active?: Maybe<Scalars["Boolean"]["output"]>;
  key: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type Communication_TypesCommunicationsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<CommunicationsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CommunicationsOrderBy>>;
};

export type Communication_TypesConnection = {
  __typename?: "communication_typesConnection";
  edges: Array<Communication_TypesEdge>;
  pageInfo: PageInfo;
};

export type Communication_TypesDeleteResponse = {
  __typename?: "communication_typesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Communication_Types>;
};

export type Communication_TypesEdge = {
  __typename?: "communication_typesEdge";
  cursor: Scalars["String"]["output"];
  node: Communication_Types;
};

export type Communication_TypesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Communication_TypesFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  is_active?: InputMaybe<BooleanFilter>;
  key?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Communication_TypesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Communication_TypesFilter>>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Communication_TypesInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Communication_TypesInsertResponse = {
  __typename?: "communication_typesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Communication_Types>;
};

export type Communication_TypesOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_active?: InputMaybe<OrderByDirection>;
  key?: InputMaybe<OrderByDirection>;
  label?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Communication_TypesUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Communication_TypesUpdateResponse = {
  __typename?: "communication_typesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Communication_Types>;
};

export type Communications = Node & {
  __typename?: "communications";
  attachment_count: Scalars["Int"]["output"];
  attachments?: Maybe<Scalars["JSON"]["output"]>;
  attachments_filed_at?: Maybe<Scalars["Datetime"]["output"]>;
  body?: Maybe<Scalars["String"]["output"]>;
  body_byte_size?: Maybe<Scalars["Int"]["output"]>;
  body_content_type?: Maybe<Scalars["String"]["output"]>;
  body_preview?: Maybe<Scalars["String"]["output"]>;
  body_s3_key?: Maybe<Scalars["String"]["output"]>;
  communication_types?: Maybe<Communication_Types>;
  companies?: Maybe<Companies>;
  company_id?: Maybe<Scalars["UUID"]["output"]>;
  company_name?: Maybe<Scalars["String"]["output"]>;
  contact_id: Scalars["UUID"]["output"];
  contact_name?: Maybe<Scalars["String"]["output"]>;
  contacts?: Maybe<Contacts>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  direction?: Maybe<Scalars["String"]["output"]>;
  email_tracking_tokensCollection?: Maybe<Email_Tracking_TokensConnection>;
  external_id?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  metadata?: Maybe<Scalars["JSON"]["output"]>;
  metadata_s3_key?: Maybe<Scalars["String"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  occurred_at?: Maybe<Scalars["Datetime"]["output"]>;
  sales_sequence_step_eventsCollection?: Maybe<Sales_Sequence_Step_EventsConnection>;
  search_vector?: Maybe<Scalars["Opaque"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  type_id?: Maybe<Scalars["UUID"]["output"]>;
  type_label?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  user_id: Scalars["String"]["output"];
};

export type CommunicationsEmail_Tracking_TokensCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_Tracking_TokensFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_Tracking_TokensOrderBy>>;
};

export type CommunicationsSales_Sequence_Step_EventsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Sales_Sequence_Step_EventsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Sales_Sequence_Step_EventsOrderBy>>;
};

/** Aggregate results for `communications` */
export type CommunicationsAggregate = {
  __typename?: "communicationsAggregate";
  /** Average aggregates for numeric fields */
  avg?: Maybe<CommunicationsAvgAggregateResult>;
  /** The number of records matching the query */
  count: Scalars["Int"]["output"];
  /** Maximum aggregates for comparable fields */
  max?: Maybe<CommunicationsMaxAggregateResult>;
  /** Minimum aggregates for comparable fields */
  min?: Maybe<CommunicationsMinAggregateResult>;
  /** Summation aggregates for numeric fields */
  sum?: Maybe<CommunicationsSumAggregateResult>;
};

/** Result of average aggregation for `communications` */
export type CommunicationsAvgAggregateResult = {
  __typename?: "communicationsAvgAggregateResult";
  /** Average of attachment_count across all matching records */
  attachment_count?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Average of body_byte_size across all matching records */
  body_byte_size?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type CommunicationsConnection = {
  __typename?: "communicationsConnection";
  /** Aggregate functions calculated on the collection of `communications` */
  aggregate?: Maybe<CommunicationsAggregate>;
  edges: Array<CommunicationsEdge>;
  pageInfo: PageInfo;
  /** The total number of records matching the `filter` criteria */
  totalCount: Scalars["Int"]["output"];
};

export type CommunicationsDeleteResponse = {
  __typename?: "communicationsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Communications>;
};

export type CommunicationsEdge = {
  __typename?: "communicationsEdge";
  cursor: Scalars["String"]["output"];
  node: Communications;
};

export type CommunicationsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<CommunicationsFilter>>;
  attachment_count?: InputMaybe<IntFilter>;
  attachments_filed_at?: InputMaybe<DatetimeFilter>;
  body?: InputMaybe<StringFilter>;
  body_byte_size?: InputMaybe<IntFilter>;
  body_content_type?: InputMaybe<StringFilter>;
  body_preview?: InputMaybe<StringFilter>;
  body_s3_key?: InputMaybe<StringFilter>;
  company_id?: InputMaybe<UuidFilter>;
  company_name?: InputMaybe<StringFilter>;
  contact_id?: InputMaybe<UuidFilter>;
  contact_name?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  direction?: InputMaybe<StringFilter>;
  external_id?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  metadata_s3_key?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<CommunicationsFilter>;
  occurred_at?: InputMaybe<DatetimeFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<CommunicationsFilter>>;
  search_vector?: InputMaybe<OpaqueFilter>;
  status?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  type_id?: InputMaybe<UuidFilter>;
  type_label?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<StringFilter>;
};

export type CommunicationsInsertInput = {
  attachment_count?: InputMaybe<Scalars["Int"]["input"]>;
  attachments?: InputMaybe<Scalars["JSON"]["input"]>;
  attachments_filed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  body?: InputMaybe<Scalars["String"]["input"]>;
  body_byte_size?: InputMaybe<Scalars["Int"]["input"]>;
  body_content_type?: InputMaybe<Scalars["String"]["input"]>;
  body_preview?: InputMaybe<Scalars["String"]["input"]>;
  body_s3_key?: InputMaybe<Scalars["String"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  company_name?: InputMaybe<Scalars["String"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  contact_name?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  direction?: InputMaybe<Scalars["String"]["input"]>;
  external_id?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  metadata_s3_key?: InputMaybe<Scalars["String"]["input"]>;
  occurred_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  type_id?: InputMaybe<Scalars["UUID"]["input"]>;
  type_label?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["String"]["input"]>;
};

export type CommunicationsInsertResponse = {
  __typename?: "communicationsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Communications>;
};

/** Result of maximum aggregation for `communications` */
export type CommunicationsMaxAggregateResult = {
  __typename?: "communicationsMaxAggregateResult";
  /** Maximum of attachment_count across all matching records */
  attachment_count?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of attachments_filed_at across all matching records */
  attachments_filed_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Maximum of body across all matching records */
  body?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of body_byte_size across all matching records */
  body_byte_size?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of body_content_type across all matching records */
  body_content_type?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of body_preview across all matching records */
  body_preview?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of body_s3_key across all matching records */
  body_s3_key?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of company_name across all matching records */
  company_name?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of contact_name across all matching records */
  contact_name?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of created_at across all matching records */
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Maximum of direction across all matching records */
  direction?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of external_id across all matching records */
  external_id?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of metadata_s3_key across all matching records */
  metadata_s3_key?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of occurred_at across all matching records */
  occurred_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Maximum of status across all matching records */
  status?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of title across all matching records */
  title?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of type_label across all matching records */
  type_label?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of updated_at across all matching records */
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Maximum of user_id across all matching records */
  user_id?: Maybe<Scalars["String"]["output"]>;
};

/** Result of minimum aggregation for `communications` */
export type CommunicationsMinAggregateResult = {
  __typename?: "communicationsMinAggregateResult";
  /** Minimum of attachment_count across all matching records */
  attachment_count?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of attachments_filed_at across all matching records */
  attachments_filed_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Minimum of body across all matching records */
  body?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of body_byte_size across all matching records */
  body_byte_size?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of body_content_type across all matching records */
  body_content_type?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of body_preview across all matching records */
  body_preview?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of body_s3_key across all matching records */
  body_s3_key?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of company_name across all matching records */
  company_name?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of contact_name across all matching records */
  contact_name?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of created_at across all matching records */
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Minimum of direction across all matching records */
  direction?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of external_id across all matching records */
  external_id?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of metadata_s3_key across all matching records */
  metadata_s3_key?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of occurred_at across all matching records */
  occurred_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Minimum of status across all matching records */
  status?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of title across all matching records */
  title?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of type_label across all matching records */
  type_label?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of updated_at across all matching records */
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Minimum of user_id across all matching records */
  user_id?: Maybe<Scalars["String"]["output"]>;
};

export type CommunicationsOrderBy = {
  attachment_count?: InputMaybe<OrderByDirection>;
  attachments_filed_at?: InputMaybe<OrderByDirection>;
  body?: InputMaybe<OrderByDirection>;
  body_byte_size?: InputMaybe<OrderByDirection>;
  body_content_type?: InputMaybe<OrderByDirection>;
  body_preview?: InputMaybe<OrderByDirection>;
  body_s3_key?: InputMaybe<OrderByDirection>;
  company_id?: InputMaybe<OrderByDirection>;
  company_name?: InputMaybe<OrderByDirection>;
  contact_id?: InputMaybe<OrderByDirection>;
  contact_name?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  direction?: InputMaybe<OrderByDirection>;
  external_id?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  metadata_s3_key?: InputMaybe<OrderByDirection>;
  occurred_at?: InputMaybe<OrderByDirection>;
  search_vector?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  title?: InputMaybe<OrderByDirection>;
  type_id?: InputMaybe<OrderByDirection>;
  type_label?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

/** Result of summation aggregation for `communications` */
export type CommunicationsSumAggregateResult = {
  __typename?: "communicationsSumAggregateResult";
  /** Sum of attachment_count across all matching records */
  attachment_count?: Maybe<Scalars["BigInt"]["output"]>;
  /** Sum of body_byte_size across all matching records */
  body_byte_size?: Maybe<Scalars["BigInt"]["output"]>;
};

export type CommunicationsUpdateInput = {
  attachment_count?: InputMaybe<Scalars["Int"]["input"]>;
  attachments?: InputMaybe<Scalars["JSON"]["input"]>;
  attachments_filed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  body?: InputMaybe<Scalars["String"]["input"]>;
  body_byte_size?: InputMaybe<Scalars["Int"]["input"]>;
  body_content_type?: InputMaybe<Scalars["String"]["input"]>;
  body_preview?: InputMaybe<Scalars["String"]["input"]>;
  body_s3_key?: InputMaybe<Scalars["String"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  company_name?: InputMaybe<Scalars["String"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  contact_name?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  direction?: InputMaybe<Scalars["String"]["input"]>;
  external_id?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  metadata_s3_key?: InputMaybe<Scalars["String"]["input"]>;
  occurred_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  type_id?: InputMaybe<Scalars["UUID"]["input"]>;
  type_label?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["String"]["input"]>;
};

export type CommunicationsUpdateResponse = {
  __typename?: "communicationsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Communications>;
};

export type Companies = Node & {
  __typename?: "companies";
  active_contact_count: Scalars["Int"]["output"];
  active_deal_count: Scalars["Int"]["output"];
  address?: Maybe<Scalars["String"]["output"]>;
  alignment_status?: Maybe<Project_Health_Status>;
  app_users?: Maybe<App_Users>;
  budget_status?: Maybe<Project_Health_Status>;
  city?: Maybe<Scalars["String"]["output"]>;
  communicationsCollection?: Maybe<CommunicationsConnection>;
  company_quickbooks_customersCollection?: Maybe<Company_Quickbooks_CustomersConnection>;
  company_slack_channel_link_ignores?: Maybe<Company_Slack_Channel_Link_Ignores>;
  company_user_accessCollection?: Maybe<Company_User_AccessConnection>;
  contact_tasksCollection?: Maybe<Contact_TasksConnection>;
  contacts?: Maybe<Contacts>;
  contactsCollection?: Maybe<ContactsConnection>;
  contract_expires_at?: Maybe<Scalars["Date"]["output"]>;
  contract_type?: Maybe<Scalars["String"]["output"]>;
  contractsCollection?: Maybe<ContractsConnection>;
  country?: Maybe<Scalars["String"]["output"]>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  created_by?: Maybe<Scalars["UUID"]["output"]>;
  created_by_backfilled_at?: Maybe<Scalars["Datetime"]["output"]>;
  current_technologies?: Maybe<Scalars["JSON"]["output"]>;
  customer_feedbackCollection?: Maybe<Customer_FeedbackConnection>;
  dealsCollection?: Maybe<DealsConnection>;
  description?: Maybe<Scalars["String"]["output"]>;
  domain?: Maybe<Scalars["String"]["output"]>;
  email_aliases: Array<Maybe<Scalars["String"]["output"]>>;
  email_tracking_tokensCollection?: Maybe<Email_Tracking_TokensConnection>;
  employee_size?: Maybe<Scalars["JSON"]["output"]>;
  google_drive_folder_id?: Maybe<Scalars["String"]["output"]>;
  google_drive_folder_provisioned_at?: Maybe<Scalars["Datetime"]["output"]>;
  google_group_enrollmentsCollection?: Maybe<Google_Group_EnrollmentsConnection>;
  has_active_deals: Scalars["Boolean"]["output"];
  has_open_tickets: Scalars["Boolean"]["output"];
  has_signed_contract: Scalars["Boolean"]["output"];
  hourly_rate?: Maybe<Scalars["BigFloat"]["output"]>;
  id: Scalars["UUID"]["output"];
  inbound_sender_rulesCollection?: Maybe<Inbound_Sender_RulesConnection>;
  industry?: Maybe<Scalars["String"]["output"]>;
  last_contacted_at?: Maybe<Scalars["Datetime"]["output"]>;
  last_enriched_at?: Maybe<Scalars["Date"]["output"]>;
  last_follow_up_task_created_at?: Maybe<Scalars["Datetime"]["output"]>;
  line_contact_id?: Maybe<Scalars["UUID"]["output"]>;
  monthly_rate?: Maybe<Scalars["BigFloat"]["output"]>;
  msp_documentsCollection?: Maybe<Msp_DocumentsConnection>;
  name: Scalars["String"]["output"];
  name_aliases: Array<Maybe<Scalars["String"]["output"]>>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  normalized_name?: Maybe<Scalars["String"]["output"]>;
  notes?: Maybe<Scalars["String"]["output"]>;
  open_ticket_count: Scalars["Int"]["output"];
  organization_email?: Maybe<Scalars["String"]["output"]>;
  organization_phone?: Maybe<Scalars["String"]["output"]>;
  organization_revenue?: Maybe<Scalars["BigFloat"]["output"]>;
  payment_terms?: Maybe<Scalars["String"]["output"]>;
  phone_aliases: Array<Maybe<Scalars["String"]["output"]>>;
  plaid_itemsCollection?: Maybe<Plaid_ItemsConnection>;
  plaid_transaction_attributionsCollection?: Maybe<Plaid_Transaction_AttributionsConnection>;
  quickbooks_company_customer_acksCollection?: Maybe<Quickbooks_Company_Customer_AcksConnection>;
  quickbooks_customer_name?: Maybe<Scalars["String"]["output"]>;
  quickbooks_customer_ref?: Maybe<Scalars["String"]["output"]>;
  quickbooks_sync_at?: Maybe<Scalars["Datetime"]["output"]>;
  recurring_chargesCollection?: Maybe<Recurring_ChargesConnection>;
  recurring_transactionsCollection?: Maybe<Recurring_TransactionsConnection>;
  sales_sequence_enrollmentsCollection?: Maybe<Sales_Sequence_EnrollmentsConnection>;
  schedule_status?: Maybe<Project_Health_Status>;
  scope_status?: Maybe<Project_Health_Status>;
  search_vector?: Maybe<Scalars["Opaque"]["output"]>;
  slack_channel_id?: Maybe<Scalars["String"]["output"]>;
  slack_channel_provisioningCollection?: Maybe<Slack_Channel_ProvisioningConnection>;
  social_links?: Maybe<Scalars["JSON"]["output"]>;
  social_media_postsCollection?: Maybe<Social_Media_PostsConnection>;
  state?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  support_link_created_at?: Maybe<Scalars["Datetime"]["output"]>;
  support_link_public_id?: Maybe<Scalars["String"]["output"]>;
  support_link_secret_encrypted?: Maybe<Scalars["String"]["output"]>;
  tags: Array<Maybe<Scalars["String"]["output"]>>;
  tax_id?: Maybe<Scalars["String"]["output"]>;
  technical_identifiers: Scalars["JSON"]["output"];
  ticketsCollection?: Maybe<TicketsConnection>;
  time_entriesCollection?: Maybe<Time_EntriesConnection>;
  total_deal_value: Scalars["BigFloat"]["output"];
  trigger_enrichment?: Maybe<Scalars["Boolean"]["output"]>;
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  uptime_monitoring_enabled: Scalars["Boolean"]["output"];
  website?: Maybe<Scalars["String"]["output"]>;
  website_normalized?: Maybe<Scalars["String"]["output"]>;
  zip_code?: Maybe<Scalars["String"]["output"]>;
};

export type CompaniesCommunicationsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<CommunicationsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CommunicationsOrderBy>>;
};

export type CompaniesCompany_Quickbooks_CustomersCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Company_Quickbooks_CustomersFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Company_Quickbooks_CustomersOrderBy>>;
};

export type CompaniesCompany_User_AccessCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Company_User_AccessFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Company_User_AccessOrderBy>>;
};

export type CompaniesContact_TasksCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_TasksFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_TasksOrderBy>>;
};

export type CompaniesContactsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<ContactsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ContactsOrderBy>>;
};

export type CompaniesContractsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<ContractsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ContractsOrderBy>>;
};

export type CompaniesCustomer_FeedbackCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Customer_FeedbackFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Customer_FeedbackOrderBy>>;
};

export type CompaniesDealsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<DealsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<DealsOrderBy>>;
};

export type CompaniesEmail_Tracking_TokensCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_Tracking_TokensFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_Tracking_TokensOrderBy>>;
};

export type CompaniesGoogle_Group_EnrollmentsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Google_Group_EnrollmentsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Google_Group_EnrollmentsOrderBy>>;
};

export type CompaniesInbound_Sender_RulesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Inbound_Sender_RulesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Inbound_Sender_RulesOrderBy>>;
};

export type CompaniesMsp_DocumentsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Msp_DocumentsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Msp_DocumentsOrderBy>>;
};

export type CompaniesPlaid_ItemsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Plaid_ItemsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Plaid_ItemsOrderBy>>;
};

export type CompaniesPlaid_Transaction_AttributionsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Plaid_Transaction_AttributionsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Plaid_Transaction_AttributionsOrderBy>>;
};

export type CompaniesQuickbooks_Company_Customer_AcksCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Quickbooks_Company_Customer_AcksFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Quickbooks_Company_Customer_AcksOrderBy>>;
};

export type CompaniesRecurring_ChargesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Recurring_ChargesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Recurring_ChargesOrderBy>>;
};

export type CompaniesRecurring_TransactionsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Recurring_TransactionsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Recurring_TransactionsOrderBy>>;
};

export type CompaniesSales_Sequence_EnrollmentsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Sales_Sequence_EnrollmentsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Sales_Sequence_EnrollmentsOrderBy>>;
};

export type CompaniesSlack_Channel_ProvisioningCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Slack_Channel_ProvisioningFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Slack_Channel_ProvisioningOrderBy>>;
};

export type CompaniesSocial_Media_PostsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Social_Media_PostsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Social_Media_PostsOrderBy>>;
};

export type CompaniesTicketsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<TicketsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TicketsOrderBy>>;
};

export type CompaniesTime_EntriesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Time_EntriesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Time_EntriesOrderBy>>;
};

export type CompaniesConnection = {
  __typename?: "companiesConnection";
  edges: Array<CompaniesEdge>;
  pageInfo: PageInfo;
  /** The total number of records matching the `filter` criteria */
  totalCount: Scalars["Int"]["output"];
};

export type CompaniesDeleteResponse = {
  __typename?: "companiesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Companies>;
};

export type CompaniesEdge = {
  __typename?: "companiesEdge";
  cursor: Scalars["String"]["output"];
  node: Companies;
};

export type CompaniesFilter = {
  active_contact_count?: InputMaybe<IntFilter>;
  active_deal_count?: InputMaybe<IntFilter>;
  address?: InputMaybe<StringFilter>;
  alignment_status?: InputMaybe<Project_Health_StatusFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<CompaniesFilter>>;
  budget_status?: InputMaybe<Project_Health_StatusFilter>;
  city?: InputMaybe<StringFilter>;
  contract_expires_at?: InputMaybe<DateFilter>;
  contract_type?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  created_by_backfilled_at?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  domain?: InputMaybe<StringFilter>;
  email_aliases?: InputMaybe<StringListFilter>;
  google_drive_folder_id?: InputMaybe<StringFilter>;
  google_drive_folder_provisioned_at?: InputMaybe<DatetimeFilter>;
  has_active_deals?: InputMaybe<BooleanFilter>;
  has_open_tickets?: InputMaybe<BooleanFilter>;
  has_signed_contract?: InputMaybe<BooleanFilter>;
  hourly_rate?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<UuidFilter>;
  industry?: InputMaybe<StringFilter>;
  last_contacted_at?: InputMaybe<DatetimeFilter>;
  last_enriched_at?: InputMaybe<DateFilter>;
  last_follow_up_task_created_at?: InputMaybe<DatetimeFilter>;
  line_contact_id?: InputMaybe<UuidFilter>;
  monthly_rate?: InputMaybe<BigFloatFilter>;
  name?: InputMaybe<StringFilter>;
  name_aliases?: InputMaybe<StringListFilter>;
  nodeId?: InputMaybe<IdFilter>;
  normalized_name?: InputMaybe<StringFilter>;
  /** Negates a filter */
  not?: InputMaybe<CompaniesFilter>;
  notes?: InputMaybe<StringFilter>;
  open_ticket_count?: InputMaybe<IntFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<CompaniesFilter>>;
  organization_email?: InputMaybe<StringFilter>;
  organization_phone?: InputMaybe<StringFilter>;
  organization_revenue?: InputMaybe<BigFloatFilter>;
  payment_terms?: InputMaybe<StringFilter>;
  phone_aliases?: InputMaybe<StringListFilter>;
  quickbooks_customer_name?: InputMaybe<StringFilter>;
  quickbooks_customer_ref?: InputMaybe<StringFilter>;
  quickbooks_sync_at?: InputMaybe<DatetimeFilter>;
  schedule_status?: InputMaybe<Project_Health_StatusFilter>;
  scope_status?: InputMaybe<Project_Health_StatusFilter>;
  search_vector?: InputMaybe<OpaqueFilter>;
  slack_channel_id?: InputMaybe<StringFilter>;
  state?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  support_link_created_at?: InputMaybe<DatetimeFilter>;
  support_link_public_id?: InputMaybe<StringFilter>;
  support_link_secret_encrypted?: InputMaybe<StringFilter>;
  tags?: InputMaybe<StringListFilter>;
  tax_id?: InputMaybe<StringFilter>;
  total_deal_value?: InputMaybe<BigFloatFilter>;
  trigger_enrichment?: InputMaybe<BooleanFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  uptime_monitoring_enabled?: InputMaybe<BooleanFilter>;
  website?: InputMaybe<StringFilter>;
  website_normalized?: InputMaybe<StringFilter>;
  zip_code?: InputMaybe<StringFilter>;
};

export type CompaniesInsertInput = {
  active_contact_count?: InputMaybe<Scalars["Int"]["input"]>;
  active_deal_count?: InputMaybe<Scalars["Int"]["input"]>;
  address?: InputMaybe<Scalars["String"]["input"]>;
  alignment_status?: InputMaybe<Project_Health_Status>;
  budget_status?: InputMaybe<Project_Health_Status>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  contract_expires_at?: InputMaybe<Scalars["Date"]["input"]>;
  contract_type?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  created_by_backfilled_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  current_technologies?: InputMaybe<Scalars["JSON"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  domain?: InputMaybe<Scalars["String"]["input"]>;
  email_aliases?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  employee_size?: InputMaybe<Scalars["JSON"]["input"]>;
  google_drive_folder_id?: InputMaybe<Scalars["String"]["input"]>;
  google_drive_folder_provisioned_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  has_active_deals?: InputMaybe<Scalars["Boolean"]["input"]>;
  has_open_tickets?: InputMaybe<Scalars["Boolean"]["input"]>;
  has_signed_contract?: InputMaybe<Scalars["Boolean"]["input"]>;
  hourly_rate?: InputMaybe<Scalars["BigFloat"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  industry?: InputMaybe<Scalars["String"]["input"]>;
  last_contacted_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_enriched_at?: InputMaybe<Scalars["Date"]["input"]>;
  last_follow_up_task_created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  line_contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  monthly_rate?: InputMaybe<Scalars["BigFloat"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  name_aliases?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  open_ticket_count?: InputMaybe<Scalars["Int"]["input"]>;
  organization_email?: InputMaybe<Scalars["String"]["input"]>;
  organization_phone?: InputMaybe<Scalars["String"]["input"]>;
  organization_revenue?: InputMaybe<Scalars["BigFloat"]["input"]>;
  payment_terms?: InputMaybe<Scalars["String"]["input"]>;
  phone_aliases?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  quickbooks_customer_name?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_customer_ref?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_sync_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  schedule_status?: InputMaybe<Project_Health_Status>;
  scope_status?: InputMaybe<Project_Health_Status>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  slack_channel_id?: InputMaybe<Scalars["String"]["input"]>;
  social_links?: InputMaybe<Scalars["JSON"]["input"]>;
  state?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  support_link_created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  support_link_public_id?: InputMaybe<Scalars["String"]["input"]>;
  support_link_secret_encrypted?: InputMaybe<Scalars["String"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  tax_id?: InputMaybe<Scalars["String"]["input"]>;
  technical_identifiers?: InputMaybe<Scalars["JSON"]["input"]>;
  total_deal_value?: InputMaybe<Scalars["BigFloat"]["input"]>;
  trigger_enrichment?: InputMaybe<Scalars["Boolean"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  uptime_monitoring_enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  website?: InputMaybe<Scalars["String"]["input"]>;
  zip_code?: InputMaybe<Scalars["String"]["input"]>;
};

export type CompaniesInsertResponse = {
  __typename?: "companiesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Companies>;
};

export type CompaniesOrderBy = {
  active_contact_count?: InputMaybe<OrderByDirection>;
  active_deal_count?: InputMaybe<OrderByDirection>;
  address?: InputMaybe<OrderByDirection>;
  alignment_status?: InputMaybe<OrderByDirection>;
  budget_status?: InputMaybe<OrderByDirection>;
  city?: InputMaybe<OrderByDirection>;
  contract_expires_at?: InputMaybe<OrderByDirection>;
  contract_type?: InputMaybe<OrderByDirection>;
  country?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  created_by_backfilled_at?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  domain?: InputMaybe<OrderByDirection>;
  google_drive_folder_id?: InputMaybe<OrderByDirection>;
  google_drive_folder_provisioned_at?: InputMaybe<OrderByDirection>;
  has_active_deals?: InputMaybe<OrderByDirection>;
  has_open_tickets?: InputMaybe<OrderByDirection>;
  has_signed_contract?: InputMaybe<OrderByDirection>;
  hourly_rate?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  industry?: InputMaybe<OrderByDirection>;
  last_contacted_at?: InputMaybe<OrderByDirection>;
  last_enriched_at?: InputMaybe<OrderByDirection>;
  last_follow_up_task_created_at?: InputMaybe<OrderByDirection>;
  line_contact_id?: InputMaybe<OrderByDirection>;
  monthly_rate?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  normalized_name?: InputMaybe<OrderByDirection>;
  notes?: InputMaybe<OrderByDirection>;
  open_ticket_count?: InputMaybe<OrderByDirection>;
  organization_email?: InputMaybe<OrderByDirection>;
  organization_phone?: InputMaybe<OrderByDirection>;
  organization_revenue?: InputMaybe<OrderByDirection>;
  payment_terms?: InputMaybe<OrderByDirection>;
  quickbooks_customer_name?: InputMaybe<OrderByDirection>;
  quickbooks_customer_ref?: InputMaybe<OrderByDirection>;
  quickbooks_sync_at?: InputMaybe<OrderByDirection>;
  schedule_status?: InputMaybe<OrderByDirection>;
  scope_status?: InputMaybe<OrderByDirection>;
  search_vector?: InputMaybe<OrderByDirection>;
  slack_channel_id?: InputMaybe<OrderByDirection>;
  state?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  support_link_created_at?: InputMaybe<OrderByDirection>;
  support_link_public_id?: InputMaybe<OrderByDirection>;
  support_link_secret_encrypted?: InputMaybe<OrderByDirection>;
  tax_id?: InputMaybe<OrderByDirection>;
  total_deal_value?: InputMaybe<OrderByDirection>;
  trigger_enrichment?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  uptime_monitoring_enabled?: InputMaybe<OrderByDirection>;
  website?: InputMaybe<OrderByDirection>;
  website_normalized?: InputMaybe<OrderByDirection>;
  zip_code?: InputMaybe<OrderByDirection>;
};

export type CompaniesUpdateInput = {
  active_contact_count?: InputMaybe<Scalars["Int"]["input"]>;
  active_deal_count?: InputMaybe<Scalars["Int"]["input"]>;
  address?: InputMaybe<Scalars["String"]["input"]>;
  alignment_status?: InputMaybe<Project_Health_Status>;
  budget_status?: InputMaybe<Project_Health_Status>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  contract_expires_at?: InputMaybe<Scalars["Date"]["input"]>;
  contract_type?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  created_by_backfilled_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  current_technologies?: InputMaybe<Scalars["JSON"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  domain?: InputMaybe<Scalars["String"]["input"]>;
  email_aliases?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  employee_size?: InputMaybe<Scalars["JSON"]["input"]>;
  google_drive_folder_id?: InputMaybe<Scalars["String"]["input"]>;
  google_drive_folder_provisioned_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  has_active_deals?: InputMaybe<Scalars["Boolean"]["input"]>;
  has_open_tickets?: InputMaybe<Scalars["Boolean"]["input"]>;
  has_signed_contract?: InputMaybe<Scalars["Boolean"]["input"]>;
  hourly_rate?: InputMaybe<Scalars["BigFloat"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  industry?: InputMaybe<Scalars["String"]["input"]>;
  last_contacted_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_enriched_at?: InputMaybe<Scalars["Date"]["input"]>;
  last_follow_up_task_created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  line_contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  monthly_rate?: InputMaybe<Scalars["BigFloat"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  name_aliases?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  open_ticket_count?: InputMaybe<Scalars["Int"]["input"]>;
  organization_email?: InputMaybe<Scalars["String"]["input"]>;
  organization_phone?: InputMaybe<Scalars["String"]["input"]>;
  organization_revenue?: InputMaybe<Scalars["BigFloat"]["input"]>;
  payment_terms?: InputMaybe<Scalars["String"]["input"]>;
  phone_aliases?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  quickbooks_customer_name?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_customer_ref?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_sync_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  schedule_status?: InputMaybe<Project_Health_Status>;
  scope_status?: InputMaybe<Project_Health_Status>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  slack_channel_id?: InputMaybe<Scalars["String"]["input"]>;
  social_links?: InputMaybe<Scalars["JSON"]["input"]>;
  state?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  support_link_created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  support_link_public_id?: InputMaybe<Scalars["String"]["input"]>;
  support_link_secret_encrypted?: InputMaybe<Scalars["String"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  tax_id?: InputMaybe<Scalars["String"]["input"]>;
  technical_identifiers?: InputMaybe<Scalars["JSON"]["input"]>;
  total_deal_value?: InputMaybe<Scalars["BigFloat"]["input"]>;
  trigger_enrichment?: InputMaybe<Scalars["Boolean"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  uptime_monitoring_enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  website?: InputMaybe<Scalars["String"]["input"]>;
  zip_code?: InputMaybe<Scalars["String"]["input"]>;
};

export type CompaniesUpdateResponse = {
  __typename?: "companiesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Companies>;
};

export type Company_Quickbooks_Customers = Node & {
  __typename?: "company_quickbooks_customers";
  companies?: Maybe<Companies>;
  company_id: Scalars["UUID"]["output"];
  customer_id: Scalars["String"]["output"];
  customer_name?: Maybe<Scalars["String"]["output"]>;
  is_legacy_conflict: Scalars["Boolean"]["output"];
  is_secondary: Scalars["Boolean"]["output"];
  linked_at: Scalars["Datetime"]["output"];
  linked_by?: Maybe<Scalars["UUID"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  realm_id: Scalars["String"]["output"];
};

export type Company_Quickbooks_CustomersConnection = {
  __typename?: "company_quickbooks_customersConnection";
  edges: Array<Company_Quickbooks_CustomersEdge>;
  pageInfo: PageInfo;
};

export type Company_Quickbooks_CustomersDeleteResponse = {
  __typename?: "company_quickbooks_customersDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Company_Quickbooks_Customers>;
};

export type Company_Quickbooks_CustomersEdge = {
  __typename?: "company_quickbooks_customersEdge";
  cursor: Scalars["String"]["output"];
  node: Company_Quickbooks_Customers;
};

export type Company_Quickbooks_CustomersFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Company_Quickbooks_CustomersFilter>>;
  company_id?: InputMaybe<UuidFilter>;
  customer_id?: InputMaybe<StringFilter>;
  customer_name?: InputMaybe<StringFilter>;
  is_legacy_conflict?: InputMaybe<BooleanFilter>;
  is_secondary?: InputMaybe<BooleanFilter>;
  linked_at?: InputMaybe<DatetimeFilter>;
  linked_by?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Company_Quickbooks_CustomersFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Company_Quickbooks_CustomersFilter>>;
  realm_id?: InputMaybe<StringFilter>;
};

export type Company_Quickbooks_CustomersInsertInput = {
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  customer_id?: InputMaybe<Scalars["String"]["input"]>;
  customer_name?: InputMaybe<Scalars["String"]["input"]>;
  is_legacy_conflict?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_secondary?: InputMaybe<Scalars["Boolean"]["input"]>;
  linked_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  linked_by?: InputMaybe<Scalars["UUID"]["input"]>;
  realm_id?: InputMaybe<Scalars["String"]["input"]>;
};

export type Company_Quickbooks_CustomersInsertResponse = {
  __typename?: "company_quickbooks_customersInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Company_Quickbooks_Customers>;
};

export type Company_Quickbooks_CustomersOrderBy = {
  company_id?: InputMaybe<OrderByDirection>;
  customer_id?: InputMaybe<OrderByDirection>;
  customer_name?: InputMaybe<OrderByDirection>;
  is_legacy_conflict?: InputMaybe<OrderByDirection>;
  is_secondary?: InputMaybe<OrderByDirection>;
  linked_at?: InputMaybe<OrderByDirection>;
  linked_by?: InputMaybe<OrderByDirection>;
  realm_id?: InputMaybe<OrderByDirection>;
};

export type Company_Quickbooks_CustomersUpdateInput = {
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  customer_id?: InputMaybe<Scalars["String"]["input"]>;
  customer_name?: InputMaybe<Scalars["String"]["input"]>;
  is_legacy_conflict?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_secondary?: InputMaybe<Scalars["Boolean"]["input"]>;
  linked_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  linked_by?: InputMaybe<Scalars["UUID"]["input"]>;
  realm_id?: InputMaybe<Scalars["String"]["input"]>;
};

export type Company_Quickbooks_CustomersUpdateResponse = {
  __typename?: "company_quickbooks_customersUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Company_Quickbooks_Customers>;
};

export type Company_Slack_Channel_Link_Ignores = Node & {
  __typename?: "company_slack_channel_link_ignores";
  app_users?: Maybe<App_Users>;
  companies?: Maybe<Companies>;
  company_id: Scalars["UUID"]["output"];
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  id: Scalars["UUID"]["output"];
  ignored_by?: Maybe<Scalars["UUID"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  reason?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type Company_Slack_Channel_Link_IgnoresConnection = {
  __typename?: "company_slack_channel_link_ignoresConnection";
  edges: Array<Company_Slack_Channel_Link_IgnoresEdge>;
  pageInfo: PageInfo;
};

export type Company_Slack_Channel_Link_IgnoresDeleteResponse = {
  __typename?: "company_slack_channel_link_ignoresDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Company_Slack_Channel_Link_Ignores>;
};

export type Company_Slack_Channel_Link_IgnoresEdge = {
  __typename?: "company_slack_channel_link_ignoresEdge";
  cursor: Scalars["String"]["output"];
  node: Company_Slack_Channel_Link_Ignores;
};

export type Company_Slack_Channel_Link_IgnoresFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Company_Slack_Channel_Link_IgnoresFilter>>;
  company_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  ignored_by?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Company_Slack_Channel_Link_IgnoresFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Company_Slack_Channel_Link_IgnoresFilter>>;
  reason?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Company_Slack_Channel_Link_IgnoresInsertInput = {
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  ignored_by?: InputMaybe<Scalars["UUID"]["input"]>;
  reason?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Company_Slack_Channel_Link_IgnoresInsertResponse = {
  __typename?: "company_slack_channel_link_ignoresInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Company_Slack_Channel_Link_Ignores>;
};

export type Company_Slack_Channel_Link_IgnoresOrderBy = {
  company_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  ignored_by?: InputMaybe<OrderByDirection>;
  reason?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Company_Slack_Channel_Link_IgnoresUpdateInput = {
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  ignored_by?: InputMaybe<Scalars["UUID"]["input"]>;
  reason?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Company_Slack_Channel_Link_IgnoresUpdateResponse = {
  __typename?: "company_slack_channel_link_ignoresUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Company_Slack_Channel_Link_Ignores>;
};

export type Company_User_Access = Node & {
  __typename?: "company_user_access";
  access_level: Scalars["String"]["output"];
  app_users?: Maybe<App_Users>;
  companies?: Maybe<Companies>;
  company_id: Scalars["UUID"]["output"];
  created_at: Scalars["Datetime"]["output"];
  expires_at?: Maybe<Scalars["Datetime"]["output"]>;
  granted_at: Scalars["Datetime"]["output"];
  granted_by?: Maybe<Scalars["UUID"]["output"]>;
  is_active: Scalars["Boolean"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  updated_at: Scalars["Datetime"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type Company_User_AccessConnection = {
  __typename?: "company_user_accessConnection";
  edges: Array<Company_User_AccessEdge>;
  pageInfo: PageInfo;
};

export type Company_User_AccessDeleteResponse = {
  __typename?: "company_user_accessDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Company_User_Access>;
};

export type Company_User_AccessEdge = {
  __typename?: "company_user_accessEdge";
  cursor: Scalars["String"]["output"];
  node: Company_User_Access;
};

export type Company_User_AccessFilter = {
  access_level?: InputMaybe<StringFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Company_User_AccessFilter>>;
  company_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  expires_at?: InputMaybe<DatetimeFilter>;
  granted_at?: InputMaybe<DatetimeFilter>;
  granted_by?: InputMaybe<UuidFilter>;
  is_active?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Company_User_AccessFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Company_User_AccessFilter>>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Company_User_AccessInsertInput = {
  access_level?: InputMaybe<Scalars["String"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  expires_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  granted_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  granted_by?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Company_User_AccessInsertResponse = {
  __typename?: "company_user_accessInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Company_User_Access>;
};

export type Company_User_AccessOrderBy = {
  access_level?: InputMaybe<OrderByDirection>;
  company_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  expires_at?: InputMaybe<OrderByDirection>;
  granted_at?: InputMaybe<OrderByDirection>;
  granted_by?: InputMaybe<OrderByDirection>;
  is_active?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Company_User_AccessUpdateInput = {
  access_level?: InputMaybe<Scalars["String"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  expires_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  granted_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  granted_by?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Company_User_AccessUpdateResponse = {
  __typename?: "company_user_accessUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Company_User_Access>;
};

export type Connection_Shares = Node & {
  __typename?: "connection_shares";
  app_users?: Maybe<App_Users>;
  connection_id: Scalars["String"]["output"];
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  drive_access_enabled: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  owner_id: Scalars["UUID"]["output"];
  provider_config_key: Scalars["String"]["output"];
  shared_with_user_id: Scalars["UUID"]["output"];
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type Connection_SharesConnection = {
  __typename?: "connection_sharesConnection";
  edges: Array<Connection_SharesEdge>;
  pageInfo: PageInfo;
};

export type Connection_SharesDeleteResponse = {
  __typename?: "connection_sharesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Connection_Shares>;
};

export type Connection_SharesEdge = {
  __typename?: "connection_sharesEdge";
  cursor: Scalars["String"]["output"];
  node: Connection_Shares;
};

export type Connection_SharesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Connection_SharesFilter>>;
  connection_id?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  drive_access_enabled?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Connection_SharesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Connection_SharesFilter>>;
  owner_id?: InputMaybe<UuidFilter>;
  provider_config_key?: InputMaybe<StringFilter>;
  shared_with_user_id?: InputMaybe<UuidFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Connection_SharesInsertInput = {
  connection_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  drive_access_enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  owner_id?: InputMaybe<Scalars["UUID"]["input"]>;
  provider_config_key?: InputMaybe<Scalars["String"]["input"]>;
  shared_with_user_id?: InputMaybe<Scalars["UUID"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Connection_SharesInsertResponse = {
  __typename?: "connection_sharesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Connection_Shares>;
};

export type Connection_SharesOrderBy = {
  connection_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  drive_access_enabled?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  owner_id?: InputMaybe<OrderByDirection>;
  provider_config_key?: InputMaybe<OrderByDirection>;
  shared_with_user_id?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Connection_SharesUpdateInput = {
  connection_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  drive_access_enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  owner_id?: InputMaybe<Scalars["UUID"]["input"]>;
  provider_config_key?: InputMaybe<Scalars["String"]["input"]>;
  shared_with_user_id?: InputMaybe<Scalars["UUID"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Connection_SharesUpdateResponse = {
  __typename?: "connection_sharesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Connection_Shares>;
};

export type Contact_Files = Node & {
  __typename?: "contact_files";
  app_users?: Maybe<App_Users>;
  contact_id: Scalars["UUID"]["output"];
  contacts?: Maybe<Contacts>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  size?: Maybe<Scalars["BigInt"]["output"]>;
  tags?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  type?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  uploaded_at?: Maybe<Scalars["Datetime"]["output"]>;
  url: Scalars["String"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type Contact_FilesConnection = {
  __typename?: "contact_filesConnection";
  edges: Array<Contact_FilesEdge>;
  pageInfo: PageInfo;
};

export type Contact_FilesDeleteResponse = {
  __typename?: "contact_filesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Files>;
};

export type Contact_FilesEdge = {
  __typename?: "contact_filesEdge";
  cursor: Scalars["String"]["output"];
  node: Contact_Files;
};

export type Contact_FilesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Contact_FilesFilter>>;
  contact_id?: InputMaybe<UuidFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Contact_FilesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Contact_FilesFilter>>;
  size?: InputMaybe<BigIntFilter>;
  tags?: InputMaybe<StringListFilter>;
  type?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  uploaded_at?: InputMaybe<DatetimeFilter>;
  url?: InputMaybe<StringFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Contact_FilesInsertInput = {
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  uploaded_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Contact_FilesInsertResponse = {
  __typename?: "contact_filesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Files>;
};

export type Contact_FilesOrderBy = {
  contact_id?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  size?: InputMaybe<OrderByDirection>;
  type?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  uploaded_at?: InputMaybe<OrderByDirection>;
  url?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Contact_FilesUpdateInput = {
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  size?: InputMaybe<Scalars["BigInt"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  uploaded_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Contact_FilesUpdateResponse = {
  __typename?: "contact_filesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Files>;
};

export type Contact_Meetings = Node & {
  __typename?: "contact_meetings";
  app_users?: Maybe<App_Users>;
  attendees?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  contact_id: Scalars["UUID"]["output"];
  contacts?: Maybe<Contacts>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  end_time: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  location?: Maybe<Scalars["String"]["output"]>;
  meeting_type?: Maybe<Scalars["String"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  notes?: Maybe<Scalars["String"]["output"]>;
  start_time: Scalars["Datetime"]["output"];
  status?: Maybe<Meeting_Status>;
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  user_id: Scalars["UUID"]["output"];
};

export type Contact_MeetingsConnection = {
  __typename?: "contact_meetingsConnection";
  edges: Array<Contact_MeetingsEdge>;
  pageInfo: PageInfo;
};

export type Contact_MeetingsDeleteResponse = {
  __typename?: "contact_meetingsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Meetings>;
};

export type Contact_MeetingsEdge = {
  __typename?: "contact_meetingsEdge";
  cursor: Scalars["String"]["output"];
  node: Contact_Meetings;
};

export type Contact_MeetingsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Contact_MeetingsFilter>>;
  attendees?: InputMaybe<StringListFilter>;
  contact_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  end_time?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  location?: InputMaybe<StringFilter>;
  meeting_type?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Contact_MeetingsFilter>;
  notes?: InputMaybe<StringFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Contact_MeetingsFilter>>;
  start_time?: InputMaybe<DatetimeFilter>;
  status?: InputMaybe<Meeting_StatusFilter>;
  title?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Contact_MeetingsInsertInput = {
  attendees?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  end_time?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  meeting_type?: InputMaybe<Scalars["String"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  start_time?: InputMaybe<Scalars["Datetime"]["input"]>;
  status?: InputMaybe<Meeting_Status>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Contact_MeetingsInsertResponse = {
  __typename?: "contact_meetingsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Meetings>;
};

export type Contact_MeetingsOrderBy = {
  contact_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  end_time?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  location?: InputMaybe<OrderByDirection>;
  meeting_type?: InputMaybe<OrderByDirection>;
  notes?: InputMaybe<OrderByDirection>;
  start_time?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  title?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Contact_MeetingsUpdateInput = {
  attendees?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  end_time?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  meeting_type?: InputMaybe<Scalars["String"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  start_time?: InputMaybe<Scalars["Datetime"]["input"]>;
  status?: InputMaybe<Meeting_Status>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Contact_MeetingsUpdateResponse = {
  __typename?: "contact_meetingsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Meetings>;
};

export type Contact_Merge_Ignores = Node & {
  __typename?: "contact_merge_ignores";
  app_users?: Maybe<App_Users>;
  contacts?: Maybe<Contacts>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  id: Scalars["UUID"]["output"];
  ignored_by?: Maybe<Scalars["UUID"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  placeholder_contact_id: Scalars["UUID"]["output"];
  reason?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type Contact_Merge_IgnoresConnection = {
  __typename?: "contact_merge_ignoresConnection";
  edges: Array<Contact_Merge_IgnoresEdge>;
  pageInfo: PageInfo;
};

export type Contact_Merge_IgnoresDeleteResponse = {
  __typename?: "contact_merge_ignoresDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Merge_Ignores>;
};

export type Contact_Merge_IgnoresEdge = {
  __typename?: "contact_merge_ignoresEdge";
  cursor: Scalars["String"]["output"];
  node: Contact_Merge_Ignores;
};

export type Contact_Merge_IgnoresFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Contact_Merge_IgnoresFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  ignored_by?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Contact_Merge_IgnoresFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Contact_Merge_IgnoresFilter>>;
  placeholder_contact_id?: InputMaybe<UuidFilter>;
  reason?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Contact_Merge_IgnoresInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  ignored_by?: InputMaybe<Scalars["UUID"]["input"]>;
  placeholder_contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  reason?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Contact_Merge_IgnoresInsertResponse = {
  __typename?: "contact_merge_ignoresInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Merge_Ignores>;
};

export type Contact_Merge_IgnoresOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  ignored_by?: InputMaybe<OrderByDirection>;
  placeholder_contact_id?: InputMaybe<OrderByDirection>;
  reason?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Contact_Merge_IgnoresUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  ignored_by?: InputMaybe<Scalars["UUID"]["input"]>;
  placeholder_contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  reason?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Contact_Merge_IgnoresUpdateResponse = {
  __typename?: "contact_merge_ignoresUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Merge_Ignores>;
};

export type Contact_Messages = Node & {
  __typename?: "contact_messages";
  app_users?: Maybe<App_Users>;
  body: Scalars["String"]["output"];
  contact_id: Scalars["UUID"]["output"];
  contacts?: Maybe<Contacts>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  delivered_at?: Maybe<Scalars["Datetime"]["output"]>;
  direction?: Maybe<Scalars["String"]["output"]>;
  external_message_id?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  message_type?: Maybe<Scalars["String"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  read_at?: Maybe<Scalars["Datetime"]["output"]>;
  sent_at?: Maybe<Scalars["Datetime"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  subject?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  user_id: Scalars["UUID"]["output"];
};

export type Contact_MessagesConnection = {
  __typename?: "contact_messagesConnection";
  edges: Array<Contact_MessagesEdge>;
  pageInfo: PageInfo;
};

export type Contact_MessagesDeleteResponse = {
  __typename?: "contact_messagesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Messages>;
};

export type Contact_MessagesEdge = {
  __typename?: "contact_messagesEdge";
  cursor: Scalars["String"]["output"];
  node: Contact_Messages;
};

export type Contact_MessagesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Contact_MessagesFilter>>;
  body?: InputMaybe<StringFilter>;
  contact_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  delivered_at?: InputMaybe<DatetimeFilter>;
  direction?: InputMaybe<StringFilter>;
  external_message_id?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  message_type?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Contact_MessagesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Contact_MessagesFilter>>;
  read_at?: InputMaybe<DatetimeFilter>;
  sent_at?: InputMaybe<DatetimeFilter>;
  status?: InputMaybe<StringFilter>;
  subject?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Contact_MessagesInsertInput = {
  body?: InputMaybe<Scalars["String"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  delivered_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  direction?: InputMaybe<Scalars["String"]["input"]>;
  external_message_id?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  message_type?: InputMaybe<Scalars["String"]["input"]>;
  read_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  sent_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  subject?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Contact_MessagesInsertResponse = {
  __typename?: "contact_messagesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Messages>;
};

export type Contact_MessagesOrderBy = {
  body?: InputMaybe<OrderByDirection>;
  contact_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  delivered_at?: InputMaybe<OrderByDirection>;
  direction?: InputMaybe<OrderByDirection>;
  external_message_id?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  message_type?: InputMaybe<OrderByDirection>;
  read_at?: InputMaybe<OrderByDirection>;
  sent_at?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  subject?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Contact_MessagesUpdateInput = {
  body?: InputMaybe<Scalars["String"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  delivered_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  direction?: InputMaybe<Scalars["String"]["input"]>;
  external_message_id?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  message_type?: InputMaybe<Scalars["String"]["input"]>;
  read_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  sent_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  subject?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Contact_MessagesUpdateResponse = {
  __typename?: "contact_messagesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Messages>;
};

export type Contact_Method_Claims = Node & {
  __typename?: "contact_method_claims";
  claimed_at: Scalars["Datetime"]["output"];
  is_legacy_conflict: Scalars["Boolean"]["output"];
  is_primary: Scalars["Boolean"]["output"];
  kind: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  owner_id: Scalars["UUID"]["output"];
  owner_type: Scalars["String"]["output"];
  source_column: Scalars["String"]["output"];
  value_key: Scalars["String"]["output"];
  value_raw: Scalars["String"]["output"];
};

export type Contact_Method_ClaimsConnection = {
  __typename?: "contact_method_claimsConnection";
  edges: Array<Contact_Method_ClaimsEdge>;
  pageInfo: PageInfo;
};

export type Contact_Method_ClaimsDeleteResponse = {
  __typename?: "contact_method_claimsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Method_Claims>;
};

export type Contact_Method_ClaimsEdge = {
  __typename?: "contact_method_claimsEdge";
  cursor: Scalars["String"]["output"];
  node: Contact_Method_Claims;
};

export type Contact_Method_ClaimsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Contact_Method_ClaimsFilter>>;
  claimed_at?: InputMaybe<DatetimeFilter>;
  is_legacy_conflict?: InputMaybe<BooleanFilter>;
  is_primary?: InputMaybe<BooleanFilter>;
  kind?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Contact_Method_ClaimsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Contact_Method_ClaimsFilter>>;
  owner_id?: InputMaybe<UuidFilter>;
  owner_type?: InputMaybe<StringFilter>;
  source_column?: InputMaybe<StringFilter>;
  value_key?: InputMaybe<StringFilter>;
  value_raw?: InputMaybe<StringFilter>;
};

export type Contact_Method_ClaimsInsertInput = {
  claimed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  is_legacy_conflict?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_primary?: InputMaybe<Scalars["Boolean"]["input"]>;
  kind?: InputMaybe<Scalars["String"]["input"]>;
  owner_id?: InputMaybe<Scalars["UUID"]["input"]>;
  owner_type?: InputMaybe<Scalars["String"]["input"]>;
  source_column?: InputMaybe<Scalars["String"]["input"]>;
  value_key?: InputMaybe<Scalars["String"]["input"]>;
  value_raw?: InputMaybe<Scalars["String"]["input"]>;
};

export type Contact_Method_ClaimsInsertResponse = {
  __typename?: "contact_method_claimsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Method_Claims>;
};

export type Contact_Method_ClaimsOrderBy = {
  claimed_at?: InputMaybe<OrderByDirection>;
  is_legacy_conflict?: InputMaybe<OrderByDirection>;
  is_primary?: InputMaybe<OrderByDirection>;
  kind?: InputMaybe<OrderByDirection>;
  owner_id?: InputMaybe<OrderByDirection>;
  owner_type?: InputMaybe<OrderByDirection>;
  source_column?: InputMaybe<OrderByDirection>;
  value_key?: InputMaybe<OrderByDirection>;
  value_raw?: InputMaybe<OrderByDirection>;
};

export type Contact_Method_ClaimsUpdateInput = {
  claimed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  is_legacy_conflict?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_primary?: InputMaybe<Scalars["Boolean"]["input"]>;
  kind?: InputMaybe<Scalars["String"]["input"]>;
  owner_id?: InputMaybe<Scalars["UUID"]["input"]>;
  owner_type?: InputMaybe<Scalars["String"]["input"]>;
  source_column?: InputMaybe<Scalars["String"]["input"]>;
  value_key?: InputMaybe<Scalars["String"]["input"]>;
  value_raw?: InputMaybe<Scalars["String"]["input"]>;
};

export type Contact_Method_ClaimsUpdateResponse = {
  __typename?: "contact_method_claimsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Method_Claims>;
};

export type Contact_Notes = Node & {
  __typename?: "contact_notes";
  app_users?: Maybe<App_Users>;
  contact_id: Scalars["UUID"]["output"];
  contacts?: Maybe<Contacts>;
  content: Scalars["String"]["output"];
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  id: Scalars["UUID"]["output"];
  is_internal?: Maybe<Scalars["Boolean"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  note_type?: Maybe<Note_Type>;
  tags?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  title?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  user_id: Scalars["UUID"]["output"];
};

export type Contact_NotesConnection = {
  __typename?: "contact_notesConnection";
  edges: Array<Contact_NotesEdge>;
  pageInfo: PageInfo;
};

export type Contact_NotesDeleteResponse = {
  __typename?: "contact_notesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Notes>;
};

export type Contact_NotesEdge = {
  __typename?: "contact_notesEdge";
  cursor: Scalars["String"]["output"];
  node: Contact_Notes;
};

export type Contact_NotesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Contact_NotesFilter>>;
  contact_id?: InputMaybe<UuidFilter>;
  content?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  is_internal?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Contact_NotesFilter>;
  note_type?: InputMaybe<Note_TypeFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Contact_NotesFilter>>;
  tags?: InputMaybe<StringListFilter>;
  title?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Contact_NotesInsertInput = {
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  content?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  note_type?: InputMaybe<Note_Type>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Contact_NotesInsertResponse = {
  __typename?: "contact_notesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Notes>;
};

export type Contact_NotesOrderBy = {
  contact_id?: InputMaybe<OrderByDirection>;
  content?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_internal?: InputMaybe<OrderByDirection>;
  note_type?: InputMaybe<OrderByDirection>;
  title?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Contact_NotesUpdateInput = {
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  content?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  note_type?: InputMaybe<Note_Type>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Contact_NotesUpdateResponse = {
  __typename?: "contact_notesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Notes>;
};

export type Contact_Proposals = Node & {
  __typename?: "contact_proposals";
  amount?: Maybe<Scalars["BigFloat"]["output"]>;
  app_users?: Maybe<App_Users>;
  contact_id: Scalars["UUID"]["output"];
  contacts?: Maybe<Contacts>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  expires_at?: Maybe<Scalars["Datetime"]["output"]>;
  file_name?: Maybe<Scalars["String"]["output"]>;
  file_size?: Maybe<Scalars["BigInt"]["output"]>;
  file_url?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  notes?: Maybe<Scalars["String"]["output"]>;
  responded_at?: Maybe<Scalars["Datetime"]["output"]>;
  sent_at?: Maybe<Scalars["Datetime"]["output"]>;
  status?: Maybe<Proposal_Status>;
  terms_and_conditions?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  user_id: Scalars["UUID"]["output"];
  viewed_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type Contact_ProposalsConnection = {
  __typename?: "contact_proposalsConnection";
  edges: Array<Contact_ProposalsEdge>;
  pageInfo: PageInfo;
};

export type Contact_ProposalsDeleteResponse = {
  __typename?: "contact_proposalsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Proposals>;
};

export type Contact_ProposalsEdge = {
  __typename?: "contact_proposalsEdge";
  cursor: Scalars["String"]["output"];
  node: Contact_Proposals;
};

export type Contact_ProposalsFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Contact_ProposalsFilter>>;
  contact_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  currency?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  expires_at?: InputMaybe<DatetimeFilter>;
  file_name?: InputMaybe<StringFilter>;
  file_size?: InputMaybe<BigIntFilter>;
  file_url?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Contact_ProposalsFilter>;
  notes?: InputMaybe<StringFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Contact_ProposalsFilter>>;
  responded_at?: InputMaybe<DatetimeFilter>;
  sent_at?: InputMaybe<DatetimeFilter>;
  status?: InputMaybe<Proposal_StatusFilter>;
  terms_and_conditions?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
  viewed_at?: InputMaybe<DatetimeFilter>;
};

export type Contact_ProposalsInsertInput = {
  amount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  currency?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  expires_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  file_name?: InputMaybe<Scalars["String"]["input"]>;
  file_size?: InputMaybe<Scalars["BigInt"]["input"]>;
  file_url?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  responded_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  sent_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  status?: InputMaybe<Proposal_Status>;
  terms_and_conditions?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
  viewed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Contact_ProposalsInsertResponse = {
  __typename?: "contact_proposalsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Proposals>;
};

export type Contact_ProposalsOrderBy = {
  amount?: InputMaybe<OrderByDirection>;
  contact_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  currency?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  expires_at?: InputMaybe<OrderByDirection>;
  file_name?: InputMaybe<OrderByDirection>;
  file_size?: InputMaybe<OrderByDirection>;
  file_url?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  notes?: InputMaybe<OrderByDirection>;
  responded_at?: InputMaybe<OrderByDirection>;
  sent_at?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  terms_and_conditions?: InputMaybe<OrderByDirection>;
  title?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
  viewed_at?: InputMaybe<OrderByDirection>;
};

export type Contact_ProposalsUpdateInput = {
  amount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  currency?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  expires_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  file_name?: InputMaybe<Scalars["String"]["input"]>;
  file_size?: InputMaybe<Scalars["BigInt"]["input"]>;
  file_url?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  responded_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  sent_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  status?: InputMaybe<Proposal_Status>;
  terms_and_conditions?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
  viewed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Contact_ProposalsUpdateResponse = {
  __typename?: "contact_proposalsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Proposals>;
};

export type Contact_Status =
  | "churned"
  | "customer"
  | "inactive"
  | "lead"
  | "other_non_revenue"
  | "personal"
  | "prospect"
  | "system_notification";

/** Boolean expression comparing fields on type "contact_status" */
export type Contact_StatusFilter = {
  eq?: InputMaybe<Contact_Status>;
  in?: InputMaybe<Array<Contact_Status>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Contact_Status>;
};

export type Contact_Tasks = Node & {
  __typename?: "contact_tasks";
  app_users?: Maybe<App_Users>;
  assigned_users?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  companies?: Maybe<Companies>;
  company_id?: Maybe<Scalars["UUID"]["output"]>;
  completed_at?: Maybe<Scalars["Datetime"]["output"]>;
  contact_id?: Maybe<Scalars["UUID"]["output"]>;
  contacts?: Maybe<Contacts>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  due_date?: Maybe<Scalars["Datetime"]["output"]>;
  entity_id?: Maybe<Scalars["UUID"]["output"]>;
  entity_type?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  priority?: Maybe<Scalars["String"]["output"]>;
  search_vector?: Maybe<Scalars["Opaque"]["output"]>;
  status?: Maybe<Task_Status>;
  tags?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  task_notesCollection?: Maybe<Task_NotesConnection>;
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  user_id: Scalars["UUID"]["output"];
};

export type Contact_TasksTask_NotesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Task_NotesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Task_NotesOrderBy>>;
};

/** Aggregate results for `contact_tasks` */
export type Contact_TasksAggregate = {
  __typename?: "contact_tasksAggregate";
  /** The number of records matching the query */
  count: Scalars["Int"]["output"];
  /** Maximum aggregates for comparable fields */
  max?: Maybe<Contact_TasksMaxAggregateResult>;
  /** Minimum aggregates for comparable fields */
  min?: Maybe<Contact_TasksMinAggregateResult>;
};

export type Contact_TasksConnection = {
  __typename?: "contact_tasksConnection";
  /** Aggregate functions calculated on the collection of `contact_tasks` */
  aggregate?: Maybe<Contact_TasksAggregate>;
  edges: Array<Contact_TasksEdge>;
  pageInfo: PageInfo;
  /** The total number of records matching the `filter` criteria */
  totalCount: Scalars["Int"]["output"];
};

export type Contact_TasksDeleteResponse = {
  __typename?: "contact_tasksDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Tasks>;
};

export type Contact_TasksEdge = {
  __typename?: "contact_tasksEdge";
  cursor: Scalars["String"]["output"];
  node: Contact_Tasks;
};

export type Contact_TasksFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Contact_TasksFilter>>;
  assigned_users?: InputMaybe<StringListFilter>;
  company_id?: InputMaybe<UuidFilter>;
  completed_at?: InputMaybe<DatetimeFilter>;
  contact_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  due_date?: InputMaybe<DatetimeFilter>;
  entity_id?: InputMaybe<UuidFilter>;
  entity_type?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Contact_TasksFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Contact_TasksFilter>>;
  priority?: InputMaybe<StringFilter>;
  search_vector?: InputMaybe<OpaqueFilter>;
  status?: InputMaybe<Task_StatusFilter>;
  tags?: InputMaybe<StringListFilter>;
  title?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Contact_TasksInsertInput = {
  assigned_users?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  completed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  due_date?: InputMaybe<Scalars["Datetime"]["input"]>;
  entity_id?: InputMaybe<Scalars["UUID"]["input"]>;
  entity_type?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  priority?: InputMaybe<Scalars["String"]["input"]>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  status?: InputMaybe<Task_Status>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Contact_TasksInsertResponse = {
  __typename?: "contact_tasksInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Tasks>;
};

/** Result of maximum aggregation for `contact_tasks` */
export type Contact_TasksMaxAggregateResult = {
  __typename?: "contact_tasksMaxAggregateResult";
  /** Maximum of completed_at across all matching records */
  completed_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Maximum of created_at across all matching records */
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Maximum of description across all matching records */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of due_date across all matching records */
  due_date?: Maybe<Scalars["Datetime"]["output"]>;
  /** Maximum of entity_type across all matching records */
  entity_type?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of priority across all matching records */
  priority?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of title across all matching records */
  title?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of updated_at across all matching records */
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

/** Result of minimum aggregation for `contact_tasks` */
export type Contact_TasksMinAggregateResult = {
  __typename?: "contact_tasksMinAggregateResult";
  /** Minimum of completed_at across all matching records */
  completed_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Minimum of created_at across all matching records */
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Minimum of description across all matching records */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of due_date across all matching records */
  due_date?: Maybe<Scalars["Datetime"]["output"]>;
  /** Minimum of entity_type across all matching records */
  entity_type?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of priority across all matching records */
  priority?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of title across all matching records */
  title?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of updated_at across all matching records */
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type Contact_TasksOrderBy = {
  company_id?: InputMaybe<OrderByDirection>;
  completed_at?: InputMaybe<OrderByDirection>;
  contact_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  due_date?: InputMaybe<OrderByDirection>;
  entity_id?: InputMaybe<OrderByDirection>;
  entity_type?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  priority?: InputMaybe<OrderByDirection>;
  search_vector?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  title?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Contact_TasksUpdateInput = {
  assigned_users?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  completed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  due_date?: InputMaybe<Scalars["Datetime"]["input"]>;
  entity_id?: InputMaybe<Scalars["UUID"]["input"]>;
  entity_type?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  priority?: InputMaybe<Scalars["String"]["input"]>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  status?: InputMaybe<Task_Status>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Contact_TasksUpdateResponse = {
  __typename?: "contact_tasksUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_Tasks>;
};

export type Contact_User_Access = Node & {
  __typename?: "contact_user_access";
  access_level?: Maybe<Scalars["String"]["output"]>;
  app_users?: Maybe<App_Users>;
  contact_id: Scalars["UUID"]["output"];
  contacts?: Maybe<Contacts>;
  expires_at?: Maybe<Scalars["Datetime"]["output"]>;
  granted_at?: Maybe<Scalars["Datetime"]["output"]>;
  granted_by?: Maybe<Scalars["UUID"]["output"]>;
  id: Scalars["UUID"]["output"];
  is_active?: Maybe<Scalars["Boolean"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type Contact_User_AccessConnection = {
  __typename?: "contact_user_accessConnection";
  edges: Array<Contact_User_AccessEdge>;
  pageInfo: PageInfo;
};

export type Contact_User_AccessDeleteResponse = {
  __typename?: "contact_user_accessDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_User_Access>;
};

export type Contact_User_AccessEdge = {
  __typename?: "contact_user_accessEdge";
  cursor: Scalars["String"]["output"];
  node: Contact_User_Access;
};

export type Contact_User_AccessFilter = {
  access_level?: InputMaybe<StringFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Contact_User_AccessFilter>>;
  contact_id?: InputMaybe<UuidFilter>;
  expires_at?: InputMaybe<DatetimeFilter>;
  granted_at?: InputMaybe<DatetimeFilter>;
  granted_by?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  is_active?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Contact_User_AccessFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Contact_User_AccessFilter>>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Contact_User_AccessInsertInput = {
  access_level?: InputMaybe<Scalars["String"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  expires_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  granted_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  granted_by?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Contact_User_AccessInsertResponse = {
  __typename?: "contact_user_accessInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_User_Access>;
};

export type Contact_User_AccessOrderBy = {
  access_level?: InputMaybe<OrderByDirection>;
  contact_id?: InputMaybe<OrderByDirection>;
  expires_at?: InputMaybe<OrderByDirection>;
  granted_at?: InputMaybe<OrderByDirection>;
  granted_by?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_active?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Contact_User_AccessUpdateInput = {
  access_level?: InputMaybe<Scalars["String"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  expires_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  granted_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  granted_by?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Contact_User_AccessUpdateResponse = {
  __typename?: "contact_user_accessUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contact_User_Access>;
};

export type Contacts = Node & {
  __typename?: "contacts";
  accessible_by_user_ids?: Maybe<Array<Maybe<Scalars["UUID"]["output"]>>>;
  active_deal_count: Scalars["Int"]["output"];
  address?: Maybe<Scalars["String"]["output"]>;
  app_users?: Maybe<App_Users>;
  avatar_url?: Maybe<Scalars["String"]["output"]>;
  city?: Maybe<Scalars["String"]["output"]>;
  communicationsCollection?: Maybe<CommunicationsConnection>;
  companies?: Maybe<Companies>;
  companiesCollection?: Maybe<CompaniesConnection>;
  company_id?: Maybe<Scalars["UUID"]["output"]>;
  company_name?: Maybe<Scalars["String"]["output"]>;
  contact_filesCollection?: Maybe<Contact_FilesConnection>;
  contact_meetingsCollection?: Maybe<Contact_MeetingsConnection>;
  contact_merge_ignores?: Maybe<Contact_Merge_Ignores>;
  contact_messagesCollection?: Maybe<Contact_MessagesConnection>;
  contact_notesCollection?: Maybe<Contact_NotesConnection>;
  contact_proposalsCollection?: Maybe<Contact_ProposalsConnection>;
  contact_tasksCollection?: Maybe<Contact_TasksConnection>;
  contact_user_accessCollection?: Maybe<Contact_User_AccessConnection>;
  contract_expires_at?: Maybe<Scalars["Date"]["output"]>;
  contractsCollection?: Maybe<ContractsConnection>;
  country?: Maybe<Scalars["String"]["output"]>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  created_by?: Maybe<Scalars["UUID"]["output"]>;
  created_by_backfilled_at?: Maybe<Scalars["Datetime"]["output"]>;
  custom_fields?: Maybe<Scalars["JSON"]["output"]>;
  customer_feedbackCollection?: Maybe<Customer_FeedbackConnection>;
  email: Scalars["String"]["output"];
  email_aliases?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  email_campaign_recipientsCollection?: Maybe<Email_Campaign_RecipientsConnection>;
  email_tracking_tokensCollection?: Maybe<Email_Tracking_TokensConnection>;
  employee_contact_accessCollection?: Maybe<Employee_Contact_AccessConnection>;
  google_group_enrollmentsCollection?: Maybe<Google_Group_EnrollmentsConnection>;
  has_active_deals: Scalars["Boolean"]["output"];
  has_signed_contract: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  inbound_sender_rulesCollection?: Maybe<Inbound_Sender_RulesConnection>;
  is_active?: Maybe<Scalars["Boolean"]["output"]>;
  is_company_line: Scalars["Boolean"]["output"];
  last_contacted_at?: Maybe<Scalars["Datetime"]["output"]>;
  last_enriched_at?: Maybe<Scalars["Date"]["output"]>;
  last_follow_up_task_created_at?: Maybe<Scalars["Datetime"]["output"]>;
  lifecycle_stage?: Maybe<Scalars["String"]["output"]>;
  msp_documentsCollection?: Maybe<Msp_DocumentsConnection>;
  name: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  notes?: Maybe<Scalars["String"]["output"]>;
  phone?: Maybe<Scalars["String"]["output"]>;
  phone_aliases?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  recurring_transactionsCollection?: Maybe<Recurring_TransactionsConnection>;
  sales_sequence_enrollmentsCollection?: Maybe<Sales_Sequence_EnrollmentsConnection>;
  search_vector?: Maybe<Scalars["Opaque"]["output"]>;
  social_links?: Maybe<Scalars["JSON"]["output"]>;
  social_media_postsCollection?: Maybe<Social_Media_PostsConnection>;
  source?: Maybe<Scalars["String"]["output"]>;
  state?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Contact_Status>;
  tags?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  ticketsCollection?: Maybe<TicketsConnection>;
  title?: Maybe<Scalars["String"]["output"]>;
  trigger_enrichment?: Maybe<Scalars["Boolean"]["output"]>;
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  updated_by?: Maybe<Scalars["UUID"]["output"]>;
  zip_code?: Maybe<Scalars["String"]["output"]>;
};

export type ContactsCommunicationsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<CommunicationsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CommunicationsOrderBy>>;
};

export type ContactsCompaniesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<CompaniesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<CompaniesOrderBy>>;
};

export type ContactsContact_FilesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_FilesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_FilesOrderBy>>;
};

export type ContactsContact_MeetingsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_MeetingsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_MeetingsOrderBy>>;
};

export type ContactsContact_MessagesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_MessagesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_MessagesOrderBy>>;
};

export type ContactsContact_NotesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_NotesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_NotesOrderBy>>;
};

export type ContactsContact_ProposalsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_ProposalsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_ProposalsOrderBy>>;
};

export type ContactsContact_TasksCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_TasksFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_TasksOrderBy>>;
};

export type ContactsContact_User_AccessCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_User_AccessFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contact_User_AccessOrderBy>>;
};

export type ContactsContractsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<ContractsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ContractsOrderBy>>;
};

export type ContactsCustomer_FeedbackCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Customer_FeedbackFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Customer_FeedbackOrderBy>>;
};

export type ContactsEmail_Campaign_RecipientsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_Campaign_RecipientsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_Campaign_RecipientsOrderBy>>;
};

export type ContactsEmail_Tracking_TokensCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_Tracking_TokensFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_Tracking_TokensOrderBy>>;
};

export type ContactsEmployee_Contact_AccessCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Employee_Contact_AccessFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Employee_Contact_AccessOrderBy>>;
};

export type ContactsGoogle_Group_EnrollmentsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Google_Group_EnrollmentsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Google_Group_EnrollmentsOrderBy>>;
};

export type ContactsInbound_Sender_RulesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Inbound_Sender_RulesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Inbound_Sender_RulesOrderBy>>;
};

export type ContactsMsp_DocumentsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Msp_DocumentsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Msp_DocumentsOrderBy>>;
};

export type ContactsRecurring_TransactionsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Recurring_TransactionsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Recurring_TransactionsOrderBy>>;
};

export type ContactsSales_Sequence_EnrollmentsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Sales_Sequence_EnrollmentsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Sales_Sequence_EnrollmentsOrderBy>>;
};

export type ContactsSocial_Media_PostsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Social_Media_PostsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Social_Media_PostsOrderBy>>;
};

export type ContactsTicketsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<TicketsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<TicketsOrderBy>>;
};

export type ContactsConnection = {
  __typename?: "contactsConnection";
  edges: Array<ContactsEdge>;
  pageInfo: PageInfo;
  /** The total number of records matching the `filter` criteria */
  totalCount: Scalars["Int"]["output"];
};

export type ContactsDeleteResponse = {
  __typename?: "contactsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contacts>;
};

export type ContactsEdge = {
  __typename?: "contactsEdge";
  cursor: Scalars["String"]["output"];
  node: Contacts;
};

export type ContactsFilter = {
  accessible_by_user_ids?: InputMaybe<UuidListFilter>;
  active_deal_count?: InputMaybe<IntFilter>;
  address?: InputMaybe<StringFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<ContactsFilter>>;
  avatar_url?: InputMaybe<StringFilter>;
  city?: InputMaybe<StringFilter>;
  company_id?: InputMaybe<UuidFilter>;
  company_name?: InputMaybe<StringFilter>;
  contract_expires_at?: InputMaybe<DateFilter>;
  country?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  created_by_backfilled_at?: InputMaybe<DatetimeFilter>;
  email?: InputMaybe<StringFilter>;
  email_aliases?: InputMaybe<StringListFilter>;
  has_active_deals?: InputMaybe<BooleanFilter>;
  has_signed_contract?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<UuidFilter>;
  is_active?: InputMaybe<BooleanFilter>;
  is_company_line?: InputMaybe<BooleanFilter>;
  last_contacted_at?: InputMaybe<DatetimeFilter>;
  last_enriched_at?: InputMaybe<DateFilter>;
  last_follow_up_task_created_at?: InputMaybe<DatetimeFilter>;
  lifecycle_stage?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<ContactsFilter>;
  notes?: InputMaybe<StringFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<ContactsFilter>>;
  phone?: InputMaybe<StringFilter>;
  phone_aliases?: InputMaybe<StringListFilter>;
  search_vector?: InputMaybe<OpaqueFilter>;
  source?: InputMaybe<StringFilter>;
  state?: InputMaybe<StringFilter>;
  status?: InputMaybe<Contact_StatusFilter>;
  tags?: InputMaybe<StringListFilter>;
  title?: InputMaybe<StringFilter>;
  trigger_enrichment?: InputMaybe<BooleanFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  updated_by?: InputMaybe<UuidFilter>;
  zip_code?: InputMaybe<StringFilter>;
};

export type ContactsInsertInput = {
  accessible_by_user_ids?: InputMaybe<Array<InputMaybe<Scalars["UUID"]["input"]>>>;
  active_deal_count?: InputMaybe<Scalars["Int"]["input"]>;
  address?: InputMaybe<Scalars["String"]["input"]>;
  avatar_url?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  company_name?: InputMaybe<Scalars["String"]["input"]>;
  contract_expires_at?: InputMaybe<Scalars["Date"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  created_by_backfilled_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  custom_fields?: InputMaybe<Scalars["JSON"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  email_aliases?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  has_active_deals?: InputMaybe<Scalars["Boolean"]["input"]>;
  has_signed_contract?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_company_line?: InputMaybe<Scalars["Boolean"]["input"]>;
  last_contacted_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_enriched_at?: InputMaybe<Scalars["Date"]["input"]>;
  last_follow_up_task_created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  lifecycle_stage?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  phone_aliases?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  social_links?: InputMaybe<Scalars["JSON"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Contact_Status>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  trigger_enrichment?: InputMaybe<Scalars["Boolean"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  updated_by?: InputMaybe<Scalars["UUID"]["input"]>;
  zip_code?: InputMaybe<Scalars["String"]["input"]>;
};

export type ContactsInsertResponse = {
  __typename?: "contactsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contacts>;
};

export type ContactsOrderBy = {
  active_deal_count?: InputMaybe<OrderByDirection>;
  address?: InputMaybe<OrderByDirection>;
  avatar_url?: InputMaybe<OrderByDirection>;
  city?: InputMaybe<OrderByDirection>;
  company_id?: InputMaybe<OrderByDirection>;
  company_name?: InputMaybe<OrderByDirection>;
  contract_expires_at?: InputMaybe<OrderByDirection>;
  country?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  created_by_backfilled_at?: InputMaybe<OrderByDirection>;
  email?: InputMaybe<OrderByDirection>;
  has_active_deals?: InputMaybe<OrderByDirection>;
  has_signed_contract?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_active?: InputMaybe<OrderByDirection>;
  is_company_line?: InputMaybe<OrderByDirection>;
  last_contacted_at?: InputMaybe<OrderByDirection>;
  last_enriched_at?: InputMaybe<OrderByDirection>;
  last_follow_up_task_created_at?: InputMaybe<OrderByDirection>;
  lifecycle_stage?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  notes?: InputMaybe<OrderByDirection>;
  phone?: InputMaybe<OrderByDirection>;
  search_vector?: InputMaybe<OrderByDirection>;
  source?: InputMaybe<OrderByDirection>;
  state?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  title?: InputMaybe<OrderByDirection>;
  trigger_enrichment?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  updated_by?: InputMaybe<OrderByDirection>;
  zip_code?: InputMaybe<OrderByDirection>;
};

export type ContactsUpdateInput = {
  accessible_by_user_ids?: InputMaybe<Array<InputMaybe<Scalars["UUID"]["input"]>>>;
  active_deal_count?: InputMaybe<Scalars["Int"]["input"]>;
  address?: InputMaybe<Scalars["String"]["input"]>;
  avatar_url?: InputMaybe<Scalars["String"]["input"]>;
  city?: InputMaybe<Scalars["String"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  company_name?: InputMaybe<Scalars["String"]["input"]>;
  contract_expires_at?: InputMaybe<Scalars["Date"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  created_by_backfilled_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  custom_fields?: InputMaybe<Scalars["JSON"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  email_aliases?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  has_active_deals?: InputMaybe<Scalars["Boolean"]["input"]>;
  has_signed_contract?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_company_line?: InputMaybe<Scalars["Boolean"]["input"]>;
  last_contacted_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_enriched_at?: InputMaybe<Scalars["Date"]["input"]>;
  last_follow_up_task_created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  lifecycle_stage?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  phone_aliases?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  social_links?: InputMaybe<Scalars["JSON"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Contact_Status>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  trigger_enrichment?: InputMaybe<Scalars["Boolean"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  updated_by?: InputMaybe<Scalars["UUID"]["input"]>;
  zip_code?: InputMaybe<Scalars["String"]["input"]>;
};

export type ContactsUpdateResponse = {
  __typename?: "contactsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contacts>;
};

export type Contract_Previews = Node & {
  __typename?: "contract_previews";
  app_users?: Maybe<App_Users>;
  contract_id: Scalars["String"]["output"];
  created_at: Scalars["Datetime"]["output"];
  created_by?: Maybe<Scalars["UUID"]["output"]>;
  id: Scalars["UUID"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  pdf_url?: Maybe<Scalars["String"]["output"]>;
  secure_link_id?: Maybe<Scalars["UUID"]["output"]>;
  secure_links?: Maybe<Secure_Links>;
  status: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
};

export type Contract_PreviewsConnection = {
  __typename?: "contract_previewsConnection";
  edges: Array<Contract_PreviewsEdge>;
  pageInfo: PageInfo;
};

export type Contract_PreviewsDeleteResponse = {
  __typename?: "contract_previewsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contract_Previews>;
};

export type Contract_PreviewsEdge = {
  __typename?: "contract_previewsEdge";
  cursor: Scalars["String"]["output"];
  node: Contract_Previews;
};

export type Contract_PreviewsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Contract_PreviewsFilter>>;
  contract_id?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Contract_PreviewsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Contract_PreviewsFilter>>;
  pdf_url?: InputMaybe<StringFilter>;
  secure_link_id?: InputMaybe<UuidFilter>;
  status?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Contract_PreviewsInsertInput = {
  contract_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  pdf_url?: InputMaybe<Scalars["String"]["input"]>;
  secure_link_id?: InputMaybe<Scalars["UUID"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Contract_PreviewsInsertResponse = {
  __typename?: "contract_previewsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contract_Previews>;
};

export type Contract_PreviewsOrderBy = {
  contract_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  pdf_url?: InputMaybe<OrderByDirection>;
  secure_link_id?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Contract_PreviewsUpdateInput = {
  contract_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  pdf_url?: InputMaybe<Scalars["String"]["input"]>;
  secure_link_id?: InputMaybe<Scalars["UUID"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Contract_PreviewsUpdateResponse = {
  __typename?: "contract_previewsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contract_Previews>;
};

export type Contracts = Node & {
  __typename?: "contracts";
  app_users?: Maybe<App_Users>;
  companies?: Maybe<Companies>;
  company_id?: Maybe<Scalars["UUID"]["output"]>;
  contact_id?: Maybe<Scalars["UUID"]["output"]>;
  contacts?: Maybe<Contacts>;
  created_at: Scalars["Datetime"]["output"];
  deal_id?: Maybe<Scalars["UUID"]["output"]>;
  deals?: Maybe<Deals>;
  decline_reason?: Maybe<Scalars["String"]["output"]>;
  delivery_mode?: Maybe<Scalars["String"]["output"]>;
  document_name?: Maybe<Scalars["String"]["output"]>;
  esignatures_contract_id?: Maybe<Scalars["String"]["output"]>;
  expires_at?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["UUID"]["output"];
  last_event_at?: Maybe<Scalars["Datetime"]["output"]>;
  metadata: Scalars["JSON"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  recipient_email?: Maybe<Scalars["String"]["output"]>;
  recipient_name?: Maybe<Scalars["String"]["output"]>;
  search_vector?: Maybe<Scalars["Opaque"]["output"]>;
  secure_link_id?: Maybe<Scalars["UUID"]["output"]>;
  secure_links?: Maybe<Secure_Links>;
  sent_at: Scalars["Datetime"]["output"];
  sent_by_user_id?: Maybe<Scalars["UUID"]["output"]>;
  signed_at?: Maybe<Scalars["Datetime"]["output"]>;
  signed_pdf_url?: Maybe<Scalars["String"]["output"]>;
  signing_url?: Maybe<Scalars["String"]["output"]>;
  source: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  template_name?: Maybe<Scalars["String"]["output"]>;
  term_months?: Maybe<Scalars["Int"]["output"]>;
  updated_at: Scalars["Datetime"]["output"];
};

export type ContractsConnection = {
  __typename?: "contractsConnection";
  edges: Array<ContractsEdge>;
  pageInfo: PageInfo;
  /** The total number of records matching the `filter` criteria */
  totalCount: Scalars["Int"]["output"];
};

export type ContractsDeleteResponse = {
  __typename?: "contractsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contracts>;
};

export type ContractsEdge = {
  __typename?: "contractsEdge";
  cursor: Scalars["String"]["output"];
  node: Contracts;
};

export type ContractsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<ContractsFilter>>;
  company_id?: InputMaybe<UuidFilter>;
  contact_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  deal_id?: InputMaybe<UuidFilter>;
  decline_reason?: InputMaybe<StringFilter>;
  delivery_mode?: InputMaybe<StringFilter>;
  document_name?: InputMaybe<StringFilter>;
  esignatures_contract_id?: InputMaybe<StringFilter>;
  expires_at?: InputMaybe<DateFilter>;
  id?: InputMaybe<UuidFilter>;
  last_event_at?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<ContractsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<ContractsFilter>>;
  recipient_email?: InputMaybe<StringFilter>;
  recipient_name?: InputMaybe<StringFilter>;
  search_vector?: InputMaybe<OpaqueFilter>;
  secure_link_id?: InputMaybe<UuidFilter>;
  sent_at?: InputMaybe<DatetimeFilter>;
  sent_by_user_id?: InputMaybe<UuidFilter>;
  signed_at?: InputMaybe<DatetimeFilter>;
  signed_pdf_url?: InputMaybe<StringFilter>;
  signing_url?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  template_name?: InputMaybe<StringFilter>;
  term_months?: InputMaybe<IntFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type ContractsInsertInput = {
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  deal_id?: InputMaybe<Scalars["UUID"]["input"]>;
  decline_reason?: InputMaybe<Scalars["String"]["input"]>;
  delivery_mode?: InputMaybe<Scalars["String"]["input"]>;
  document_name?: InputMaybe<Scalars["String"]["input"]>;
  esignatures_contract_id?: InputMaybe<Scalars["String"]["input"]>;
  expires_at?: InputMaybe<Scalars["Date"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  last_event_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  recipient_email?: InputMaybe<Scalars["String"]["input"]>;
  recipient_name?: InputMaybe<Scalars["String"]["input"]>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  secure_link_id?: InputMaybe<Scalars["UUID"]["input"]>;
  sent_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  sent_by_user_id?: InputMaybe<Scalars["UUID"]["input"]>;
  signed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  signed_pdf_url?: InputMaybe<Scalars["String"]["input"]>;
  signing_url?: InputMaybe<Scalars["String"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  template_name?: InputMaybe<Scalars["String"]["input"]>;
  term_months?: InputMaybe<Scalars["Int"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type ContractsInsertResponse = {
  __typename?: "contractsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contracts>;
};

export type ContractsOrderBy = {
  company_id?: InputMaybe<OrderByDirection>;
  contact_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  deal_id?: InputMaybe<OrderByDirection>;
  decline_reason?: InputMaybe<OrderByDirection>;
  delivery_mode?: InputMaybe<OrderByDirection>;
  document_name?: InputMaybe<OrderByDirection>;
  esignatures_contract_id?: InputMaybe<OrderByDirection>;
  expires_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  last_event_at?: InputMaybe<OrderByDirection>;
  recipient_email?: InputMaybe<OrderByDirection>;
  recipient_name?: InputMaybe<OrderByDirection>;
  search_vector?: InputMaybe<OrderByDirection>;
  secure_link_id?: InputMaybe<OrderByDirection>;
  sent_at?: InputMaybe<OrderByDirection>;
  sent_by_user_id?: InputMaybe<OrderByDirection>;
  signed_at?: InputMaybe<OrderByDirection>;
  signed_pdf_url?: InputMaybe<OrderByDirection>;
  signing_url?: InputMaybe<OrderByDirection>;
  source?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  template_name?: InputMaybe<OrderByDirection>;
  term_months?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type ContractsUpdateInput = {
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  deal_id?: InputMaybe<Scalars["UUID"]["input"]>;
  decline_reason?: InputMaybe<Scalars["String"]["input"]>;
  delivery_mode?: InputMaybe<Scalars["String"]["input"]>;
  document_name?: InputMaybe<Scalars["String"]["input"]>;
  esignatures_contract_id?: InputMaybe<Scalars["String"]["input"]>;
  expires_at?: InputMaybe<Scalars["Date"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  last_event_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  recipient_email?: InputMaybe<Scalars["String"]["input"]>;
  recipient_name?: InputMaybe<Scalars["String"]["input"]>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  secure_link_id?: InputMaybe<Scalars["UUID"]["input"]>;
  sent_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  sent_by_user_id?: InputMaybe<Scalars["UUID"]["input"]>;
  signed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  signed_pdf_url?: InputMaybe<Scalars["String"]["input"]>;
  signing_url?: InputMaybe<Scalars["String"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  template_name?: InputMaybe<Scalars["String"]["input"]>;
  term_months?: InputMaybe<Scalars["Int"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type ContractsUpdateResponse = {
  __typename?: "contractsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Contracts>;
};

export type Crm_Remediation_Backup = Node & {
  __typename?: "crm_remediation_backup";
  batch: Scalars["String"]["output"];
  column_name: Scalars["String"]["output"];
  entity_id: Scalars["UUID"]["output"];
  entity_table: Scalars["String"]["output"];
  id: Scalars["BigInt"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  old_value?: Maybe<Scalars["JSON"]["output"]>;
  ran_at: Scalars["Datetime"]["output"];
};

export type Crm_Remediation_BackupConnection = {
  __typename?: "crm_remediation_backupConnection";
  edges: Array<Crm_Remediation_BackupEdge>;
  pageInfo: PageInfo;
};

export type Crm_Remediation_BackupDeleteResponse = {
  __typename?: "crm_remediation_backupDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Crm_Remediation_Backup>;
};

export type Crm_Remediation_BackupEdge = {
  __typename?: "crm_remediation_backupEdge";
  cursor: Scalars["String"]["output"];
  node: Crm_Remediation_Backup;
};

export type Crm_Remediation_BackupFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Crm_Remediation_BackupFilter>>;
  batch?: InputMaybe<StringFilter>;
  column_name?: InputMaybe<StringFilter>;
  entity_id?: InputMaybe<UuidFilter>;
  entity_table?: InputMaybe<StringFilter>;
  id?: InputMaybe<BigIntFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Crm_Remediation_BackupFilter>;
  note?: InputMaybe<StringFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Crm_Remediation_BackupFilter>>;
  ran_at?: InputMaybe<DatetimeFilter>;
};

export type Crm_Remediation_BackupInsertInput = {
  batch?: InputMaybe<Scalars["String"]["input"]>;
  column_name?: InputMaybe<Scalars["String"]["input"]>;
  entity_id?: InputMaybe<Scalars["UUID"]["input"]>;
  entity_table?: InputMaybe<Scalars["String"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  old_value?: InputMaybe<Scalars["JSON"]["input"]>;
  ran_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Crm_Remediation_BackupInsertResponse = {
  __typename?: "crm_remediation_backupInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Crm_Remediation_Backup>;
};

export type Crm_Remediation_BackupOrderBy = {
  batch?: InputMaybe<OrderByDirection>;
  column_name?: InputMaybe<OrderByDirection>;
  entity_id?: InputMaybe<OrderByDirection>;
  entity_table?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  note?: InputMaybe<OrderByDirection>;
  ran_at?: InputMaybe<OrderByDirection>;
};

export type Crm_Remediation_BackupUpdateInput = {
  batch?: InputMaybe<Scalars["String"]["input"]>;
  column_name?: InputMaybe<Scalars["String"]["input"]>;
  entity_id?: InputMaybe<Scalars["UUID"]["input"]>;
  entity_table?: InputMaybe<Scalars["String"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  old_value?: InputMaybe<Scalars["JSON"]["input"]>;
  ran_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Crm_Remediation_BackupUpdateResponse = {
  __typename?: "crm_remediation_backupUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Crm_Remediation_Backup>;
};

export type Cron_Job_Runs = Node & {
  __typename?: "cron_job_runs";
  completed_at: Scalars["Datetime"]["output"];
  created_at: Scalars["Datetime"]["output"];
  duration_ms: Scalars["Int"]["output"];
  error_summary?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  job_id: Scalars["String"]["output"];
  metadata: Scalars["JSON"]["output"];
  metrics: Scalars["JSON"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  started_at: Scalars["Datetime"]["output"];
  status: Scalars["String"]["output"];
};

export type Cron_Job_RunsConnection = {
  __typename?: "cron_job_runsConnection";
  edges: Array<Cron_Job_RunsEdge>;
  pageInfo: PageInfo;
};

export type Cron_Job_RunsDeleteResponse = {
  __typename?: "cron_job_runsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Cron_Job_Runs>;
};

export type Cron_Job_RunsEdge = {
  __typename?: "cron_job_runsEdge";
  cursor: Scalars["String"]["output"];
  node: Cron_Job_Runs;
};

export type Cron_Job_RunsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Cron_Job_RunsFilter>>;
  completed_at?: InputMaybe<DatetimeFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  duration_ms?: InputMaybe<IntFilter>;
  error_summary?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  job_id?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Cron_Job_RunsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Cron_Job_RunsFilter>>;
  started_at?: InputMaybe<DatetimeFilter>;
  status?: InputMaybe<StringFilter>;
};

export type Cron_Job_RunsInsertInput = {
  completed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  duration_ms?: InputMaybe<Scalars["Int"]["input"]>;
  error_summary?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  job_id?: InputMaybe<Scalars["String"]["input"]>;
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  metrics?: InputMaybe<Scalars["JSON"]["input"]>;
  started_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type Cron_Job_RunsInsertResponse = {
  __typename?: "cron_job_runsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Cron_Job_Runs>;
};

export type Cron_Job_RunsOrderBy = {
  completed_at?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  duration_ms?: InputMaybe<OrderByDirection>;
  error_summary?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  job_id?: InputMaybe<OrderByDirection>;
  started_at?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
};

export type Cron_Job_RunsUpdateInput = {
  completed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  duration_ms?: InputMaybe<Scalars["Int"]["input"]>;
  error_summary?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  job_id?: InputMaybe<Scalars["String"]["input"]>;
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  metrics?: InputMaybe<Scalars["JSON"]["input"]>;
  started_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
};

export type Cron_Job_RunsUpdateResponse = {
  __typename?: "cron_job_runsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Cron_Job_Runs>;
};

export type Customer_Feedback = Node & {
  __typename?: "customer_feedback";
  comment?: Maybe<Scalars["String"]["output"]>;
  companies?: Maybe<Companies>;
  company_id?: Maybe<Scalars["UUID"]["output"]>;
  contact_id?: Maybe<Scalars["UUID"]["output"]>;
  contacts?: Maybe<Contacts>;
  created_at: Scalars["Datetime"]["output"];
  entity_id?: Maybe<Scalars["UUID"]["output"]>;
  entity_type: Scalars["String"]["output"];
  feedback_scope: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  is_anonymous: Scalars["Boolean"]["output"];
  metadata: Scalars["JSON"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  rating?: Maybe<Scalars["Int"]["output"]>;
  secure_link_id?: Maybe<Scalars["UUID"]["output"]>;
  secure_links?: Maybe<Secure_Links>;
  slack_message_ts?: Maybe<Scalars["String"]["output"]>;
  source: Scalars["String"]["output"];
  ticket_id?: Maybe<Scalars["UUID"]["output"]>;
  tickets?: Maybe<Tickets>;
  updated_at: Scalars["Datetime"]["output"];
};

export type Customer_FeedbackConnection = {
  __typename?: "customer_feedbackConnection";
  edges: Array<Customer_FeedbackEdge>;
  pageInfo: PageInfo;
};

export type Customer_FeedbackDeleteResponse = {
  __typename?: "customer_feedbackDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Customer_Feedback>;
};

export type Customer_FeedbackEdge = {
  __typename?: "customer_feedbackEdge";
  cursor: Scalars["String"]["output"];
  node: Customer_Feedback;
};

export type Customer_FeedbackFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Customer_FeedbackFilter>>;
  comment?: InputMaybe<StringFilter>;
  company_id?: InputMaybe<UuidFilter>;
  contact_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  entity_id?: InputMaybe<UuidFilter>;
  entity_type?: InputMaybe<StringFilter>;
  feedback_scope?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  is_anonymous?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Customer_FeedbackFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Customer_FeedbackFilter>>;
  rating?: InputMaybe<IntFilter>;
  secure_link_id?: InputMaybe<UuidFilter>;
  slack_message_ts?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
  ticket_id?: InputMaybe<UuidFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Customer_FeedbackInsertInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  entity_id?: InputMaybe<Scalars["UUID"]["input"]>;
  entity_type?: InputMaybe<Scalars["String"]["input"]>;
  feedback_scope?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_anonymous?: InputMaybe<Scalars["Boolean"]["input"]>;
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  rating?: InputMaybe<Scalars["Int"]["input"]>;
  secure_link_id?: InputMaybe<Scalars["UUID"]["input"]>;
  slack_message_ts?: InputMaybe<Scalars["String"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  ticket_id?: InputMaybe<Scalars["UUID"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Customer_FeedbackInsertResponse = {
  __typename?: "customer_feedbackInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Customer_Feedback>;
};

export type Customer_FeedbackOrderBy = {
  comment?: InputMaybe<OrderByDirection>;
  company_id?: InputMaybe<OrderByDirection>;
  contact_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  entity_id?: InputMaybe<OrderByDirection>;
  entity_type?: InputMaybe<OrderByDirection>;
  feedback_scope?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_anonymous?: InputMaybe<OrderByDirection>;
  rating?: InputMaybe<OrderByDirection>;
  secure_link_id?: InputMaybe<OrderByDirection>;
  slack_message_ts?: InputMaybe<OrderByDirection>;
  source?: InputMaybe<OrderByDirection>;
  ticket_id?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Customer_FeedbackUpdateInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  entity_id?: InputMaybe<Scalars["UUID"]["input"]>;
  entity_type?: InputMaybe<Scalars["String"]["input"]>;
  feedback_scope?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_anonymous?: InputMaybe<Scalars["Boolean"]["input"]>;
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  rating?: InputMaybe<Scalars["Int"]["input"]>;
  secure_link_id?: InputMaybe<Scalars["UUID"]["input"]>;
  slack_message_ts?: InputMaybe<Scalars["String"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  ticket_id?: InputMaybe<Scalars["UUID"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Customer_FeedbackUpdateResponse = {
  __typename?: "customer_feedbackUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Customer_Feedback>;
};

export type Deal_Stage =
  | "completed"
  | "contract_signed"
  | "deal_won"
  | "discovery"
  | "hand_off"
  | "in_progress"
  | "invoiced"
  | "lead"
  | "negotiation"
  | "paid"
  | "proposal"
  | "qualified"
  | "sm_lost_no_savings"
  | "sm_lost_savings_customer_rejected"
  | "started"
  | "wtc_lost_no_budget"
  | "wtc_lost_over_budget"
  | "wtc_lost_solution_rejected";

/** Boolean expression comparing fields on type "deal_stage" */
export type Deal_StageFilter = {
  eq?: InputMaybe<Deal_Stage>;
  in?: InputMaybe<Array<Deal_Stage>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Deal_Stage>;
};

export type Deal_Status = "active" | "lost" | "won";

/** Boolean expression comparing fields on type "deal_status" */
export type Deal_StatusFilter = {
  eq?: InputMaybe<Deal_Status>;
  in?: InputMaybe<Array<Deal_Status>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Deal_Status>;
};

export type Deals = Node & {
  __typename?: "deals";
  alignment_status?: Maybe<Project_Health_Status>;
  assigned_users?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  budget_status?: Maybe<Project_Health_Status>;
  chat_link_created_at?: Maybe<Scalars["Datetime"]["output"]>;
  chat_link_public_id?: Maybe<Scalars["String"]["output"]>;
  chat_link_secret_encrypted?: Maybe<Scalars["String"]["output"]>;
  close_date?: Maybe<Scalars["Date"]["output"]>;
  close_probability?: Maybe<Scalars["Int"]["output"]>;
  companies?: Maybe<Companies>;
  company_id: Scalars["UUID"]["output"];
  company_name?: Maybe<Scalars["String"]["output"]>;
  company_search_text?: Maybe<Scalars["String"]["output"]>;
  contact_search_text?: Maybe<Scalars["String"]["output"]>;
  contract_term_months?: Maybe<Scalars["Int"]["output"]>;
  contractsCollection?: Maybe<ContractsConnection>;
  cost?: Maybe<Scalars["BigFloat"]["output"]>;
  created_at: Scalars["Datetime"]["output"];
  created_by?: Maybe<Scalars["UUID"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  engineer_ids?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  estimated_hours?: Maybe<Scalars["BigFloat"]["output"]>;
  id: Scalars["UUID"]["output"];
  is_committed?: Maybe<Scalars["Boolean"]["output"]>;
  is_recurring?: Maybe<Scalars["Boolean"]["output"]>;
  last_activity_at?: Maybe<Scalars["Datetime"]["output"]>;
  last_communication_at?: Maybe<Scalars["Datetime"]["output"]>;
  last_follow_up_task_created_at?: Maybe<Scalars["Datetime"]["output"]>;
  lost_at?: Maybe<Scalars["Datetime"]["output"]>;
  margin_percentage?: Maybe<Scalars["BigFloat"]["output"]>;
  monthly_amount?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  notes?: Maybe<Scalars["String"]["output"]>;
  project_chat_subscriptionsCollection?: Maybe<Project_Chat_SubscriptionsConnection>;
  revenue: Scalars["BigFloat"]["output"];
  sales_sequence_enrollmentsCollection?: Maybe<Sales_Sequence_EnrollmentsConnection>;
  schedule_status?: Maybe<Project_Health_Status>;
  scope_status?: Maybe<Project_Health_Status>;
  search_vector?: Maybe<Scalars["Opaque"]["output"]>;
  slack_channel_id?: Maybe<Scalars["String"]["output"]>;
  slack_chat_thread_ts?: Maybe<Scalars["String"]["output"]>;
  stage?: Maybe<Deal_Stage>;
  tags?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  won_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type DealsContractsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<ContractsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ContractsOrderBy>>;
};

export type DealsProject_Chat_SubscriptionsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Project_Chat_SubscriptionsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Project_Chat_SubscriptionsOrderBy>>;
};

export type DealsSales_Sequence_EnrollmentsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Sales_Sequence_EnrollmentsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Sales_Sequence_EnrollmentsOrderBy>>;
};

export type DealsConnection = {
  __typename?: "dealsConnection";
  edges: Array<DealsEdge>;
  pageInfo: PageInfo;
  /** The total number of records matching the `filter` criteria */
  totalCount: Scalars["Int"]["output"];
};

export type DealsDeleteResponse = {
  __typename?: "dealsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Deals>;
};

export type DealsEdge = {
  __typename?: "dealsEdge";
  cursor: Scalars["String"]["output"];
  node: Deals;
};

export type DealsFilter = {
  alignment_status?: InputMaybe<Project_Health_StatusFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<DealsFilter>>;
  assigned_users?: InputMaybe<StringListFilter>;
  budget_status?: InputMaybe<Project_Health_StatusFilter>;
  chat_link_created_at?: InputMaybe<DatetimeFilter>;
  chat_link_public_id?: InputMaybe<StringFilter>;
  chat_link_secret_encrypted?: InputMaybe<StringFilter>;
  close_date?: InputMaybe<DateFilter>;
  close_probability?: InputMaybe<IntFilter>;
  company_id?: InputMaybe<UuidFilter>;
  company_name?: InputMaybe<StringFilter>;
  company_search_text?: InputMaybe<StringFilter>;
  contact_search_text?: InputMaybe<StringFilter>;
  contract_term_months?: InputMaybe<IntFilter>;
  cost?: InputMaybe<BigFloatFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  currency?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  engineer_ids?: InputMaybe<StringListFilter>;
  estimated_hours?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<UuidFilter>;
  is_committed?: InputMaybe<BooleanFilter>;
  is_recurring?: InputMaybe<BooleanFilter>;
  last_activity_at?: InputMaybe<DatetimeFilter>;
  last_communication_at?: InputMaybe<DatetimeFilter>;
  last_follow_up_task_created_at?: InputMaybe<DatetimeFilter>;
  lost_at?: InputMaybe<DatetimeFilter>;
  margin_percentage?: InputMaybe<BigFloatFilter>;
  monthly_amount?: InputMaybe<BigFloatFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<DealsFilter>;
  notes?: InputMaybe<StringFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<DealsFilter>>;
  revenue?: InputMaybe<BigFloatFilter>;
  schedule_status?: InputMaybe<Project_Health_StatusFilter>;
  scope_status?: InputMaybe<Project_Health_StatusFilter>;
  search_vector?: InputMaybe<OpaqueFilter>;
  slack_channel_id?: InputMaybe<StringFilter>;
  slack_chat_thread_ts?: InputMaybe<StringFilter>;
  stage?: InputMaybe<Deal_StageFilter>;
  tags?: InputMaybe<StringListFilter>;
  title?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  won_at?: InputMaybe<DatetimeFilter>;
};

export type DealsInsertInput = {
  alignment_status?: InputMaybe<Project_Health_Status>;
  assigned_users?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  budget_status?: InputMaybe<Project_Health_Status>;
  chat_link_created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  chat_link_public_id?: InputMaybe<Scalars["String"]["input"]>;
  chat_link_secret_encrypted?: InputMaybe<Scalars["String"]["input"]>;
  close_date?: InputMaybe<Scalars["Date"]["input"]>;
  close_probability?: InputMaybe<Scalars["Int"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  company_name?: InputMaybe<Scalars["String"]["input"]>;
  company_search_text?: InputMaybe<Scalars["String"]["input"]>;
  contact_search_text?: InputMaybe<Scalars["String"]["input"]>;
  contract_term_months?: InputMaybe<Scalars["Int"]["input"]>;
  cost?: InputMaybe<Scalars["BigFloat"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  currency?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  engineer_ids?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  estimated_hours?: InputMaybe<Scalars["BigFloat"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_committed?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_recurring?: InputMaybe<Scalars["Boolean"]["input"]>;
  last_activity_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_communication_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_follow_up_task_created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  lost_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  margin_percentage?: InputMaybe<Scalars["BigFloat"]["input"]>;
  monthly_amount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  revenue?: InputMaybe<Scalars["BigFloat"]["input"]>;
  schedule_status?: InputMaybe<Project_Health_Status>;
  scope_status?: InputMaybe<Project_Health_Status>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  slack_channel_id?: InputMaybe<Scalars["String"]["input"]>;
  slack_chat_thread_ts?: InputMaybe<Scalars["String"]["input"]>;
  stage?: InputMaybe<Deal_Stage>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  won_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type DealsInsertResponse = {
  __typename?: "dealsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Deals>;
};

export type DealsOrderBy = {
  alignment_status?: InputMaybe<OrderByDirection>;
  budget_status?: InputMaybe<OrderByDirection>;
  chat_link_created_at?: InputMaybe<OrderByDirection>;
  chat_link_public_id?: InputMaybe<OrderByDirection>;
  chat_link_secret_encrypted?: InputMaybe<OrderByDirection>;
  close_date?: InputMaybe<OrderByDirection>;
  close_probability?: InputMaybe<OrderByDirection>;
  company_id?: InputMaybe<OrderByDirection>;
  company_name?: InputMaybe<OrderByDirection>;
  company_search_text?: InputMaybe<OrderByDirection>;
  contact_search_text?: InputMaybe<OrderByDirection>;
  contract_term_months?: InputMaybe<OrderByDirection>;
  cost?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  currency?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  estimated_hours?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_committed?: InputMaybe<OrderByDirection>;
  is_recurring?: InputMaybe<OrderByDirection>;
  last_activity_at?: InputMaybe<OrderByDirection>;
  last_communication_at?: InputMaybe<OrderByDirection>;
  last_follow_up_task_created_at?: InputMaybe<OrderByDirection>;
  lost_at?: InputMaybe<OrderByDirection>;
  margin_percentage?: InputMaybe<OrderByDirection>;
  monthly_amount?: InputMaybe<OrderByDirection>;
  notes?: InputMaybe<OrderByDirection>;
  revenue?: InputMaybe<OrderByDirection>;
  schedule_status?: InputMaybe<OrderByDirection>;
  scope_status?: InputMaybe<OrderByDirection>;
  search_vector?: InputMaybe<OrderByDirection>;
  slack_channel_id?: InputMaybe<OrderByDirection>;
  slack_chat_thread_ts?: InputMaybe<OrderByDirection>;
  stage?: InputMaybe<OrderByDirection>;
  title?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  won_at?: InputMaybe<OrderByDirection>;
};

export type DealsUpdateInput = {
  alignment_status?: InputMaybe<Project_Health_Status>;
  assigned_users?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  budget_status?: InputMaybe<Project_Health_Status>;
  chat_link_created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  chat_link_public_id?: InputMaybe<Scalars["String"]["input"]>;
  chat_link_secret_encrypted?: InputMaybe<Scalars["String"]["input"]>;
  close_date?: InputMaybe<Scalars["Date"]["input"]>;
  close_probability?: InputMaybe<Scalars["Int"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  company_name?: InputMaybe<Scalars["String"]["input"]>;
  company_search_text?: InputMaybe<Scalars["String"]["input"]>;
  contact_search_text?: InputMaybe<Scalars["String"]["input"]>;
  contract_term_months?: InputMaybe<Scalars["Int"]["input"]>;
  cost?: InputMaybe<Scalars["BigFloat"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  currency?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  engineer_ids?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  estimated_hours?: InputMaybe<Scalars["BigFloat"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_committed?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_recurring?: InputMaybe<Scalars["Boolean"]["input"]>;
  last_activity_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_communication_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_follow_up_task_created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  lost_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  margin_percentage?: InputMaybe<Scalars["BigFloat"]["input"]>;
  monthly_amount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  revenue?: InputMaybe<Scalars["BigFloat"]["input"]>;
  schedule_status?: InputMaybe<Project_Health_Status>;
  scope_status?: InputMaybe<Project_Health_Status>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  slack_channel_id?: InputMaybe<Scalars["String"]["input"]>;
  slack_chat_thread_ts?: InputMaybe<Scalars["String"]["input"]>;
  stage?: InputMaybe<Deal_Stage>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  won_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type DealsUpdateResponse = {
  __typename?: "dealsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Deals>;
};

export type Device_Push_Tokens = Node & {
  __typename?: "device_push_tokens";
  apns_token: Scalars["String"]["output"];
  app_users?: Maybe<App_Users>;
  app_version?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Datetime"]["output"];
  environment: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  last_seen_at: Scalars["Datetime"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type Device_Push_TokensConnection = {
  __typename?: "device_push_tokensConnection";
  edges: Array<Device_Push_TokensEdge>;
  pageInfo: PageInfo;
};

export type Device_Push_TokensDeleteResponse = {
  __typename?: "device_push_tokensDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Device_Push_Tokens>;
};

export type Device_Push_TokensEdge = {
  __typename?: "device_push_tokensEdge";
  cursor: Scalars["String"]["output"];
  node: Device_Push_Tokens;
};

export type Device_Push_TokensFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Device_Push_TokensFilter>>;
  apns_token?: InputMaybe<StringFilter>;
  app_version?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  environment?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  last_seen_at?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Device_Push_TokensFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Device_Push_TokensFilter>>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Device_Push_TokensInsertInput = {
  apns_token?: InputMaybe<Scalars["String"]["input"]>;
  app_version?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  environment?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  last_seen_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Device_Push_TokensInsertResponse = {
  __typename?: "device_push_tokensInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Device_Push_Tokens>;
};

export type Device_Push_TokensOrderBy = {
  apns_token?: InputMaybe<OrderByDirection>;
  app_version?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  environment?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  last_seen_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Device_Push_TokensUpdateInput = {
  apns_token?: InputMaybe<Scalars["String"]["input"]>;
  app_version?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  environment?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  last_seen_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Device_Push_TokensUpdateResponse = {
  __typename?: "device_push_tokensUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Device_Push_Tokens>;
};

export type Discount_Type = "fixed_amount" | "percentage";

/** Boolean expression comparing fields on type "discount_type" */
export type Discount_TypeFilter = {
  eq?: InputMaybe<Discount_Type>;
  in?: InputMaybe<Array<Discount_Type>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Discount_Type>;
};

export type Document_Embeddings = Node & {
  __typename?: "document_embeddings";
  content_hash: Scalars["String"]["output"];
  created_at: Scalars["Datetime"]["output"];
  embedding: Scalars["Opaque"]["output"];
  entity_id: Scalars["UUID"]["output"];
  entity_type: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  indexed_at: Scalars["Datetime"]["output"];
  model_id: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  source_updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  updated_at: Scalars["Datetime"]["output"];
};

export type Document_EmbeddingsConnection = {
  __typename?: "document_embeddingsConnection";
  edges: Array<Document_EmbeddingsEdge>;
  pageInfo: PageInfo;
};

export type Document_EmbeddingsDeleteResponse = {
  __typename?: "document_embeddingsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Document_Embeddings>;
};

export type Document_EmbeddingsEdge = {
  __typename?: "document_embeddingsEdge";
  cursor: Scalars["String"]["output"];
  node: Document_Embeddings;
};

export type Document_EmbeddingsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Document_EmbeddingsFilter>>;
  content_hash?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  embedding?: InputMaybe<OpaqueFilter>;
  entity_id?: InputMaybe<UuidFilter>;
  entity_type?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  indexed_at?: InputMaybe<DatetimeFilter>;
  model_id?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Document_EmbeddingsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Document_EmbeddingsFilter>>;
  source_updated_at?: InputMaybe<DatetimeFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Document_EmbeddingsInsertInput = {
  content_hash?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  embedding?: InputMaybe<Scalars["Opaque"]["input"]>;
  entity_id?: InputMaybe<Scalars["UUID"]["input"]>;
  entity_type?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  indexed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  model_id?: InputMaybe<Scalars["String"]["input"]>;
  source_updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Document_EmbeddingsInsertResponse = {
  __typename?: "document_embeddingsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Document_Embeddings>;
};

export type Document_EmbeddingsOrderBy = {
  content_hash?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  embedding?: InputMaybe<OrderByDirection>;
  entity_id?: InputMaybe<OrderByDirection>;
  entity_type?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  indexed_at?: InputMaybe<OrderByDirection>;
  model_id?: InputMaybe<OrderByDirection>;
  source_updated_at?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Document_EmbeddingsUpdateInput = {
  content_hash?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  embedding?: InputMaybe<Scalars["Opaque"]["input"]>;
  entity_id?: InputMaybe<Scalars["UUID"]["input"]>;
  entity_type?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  indexed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  model_id?: InputMaybe<Scalars["String"]["input"]>;
  source_updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Document_EmbeddingsUpdateResponse = {
  __typename?: "document_embeddingsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Document_Embeddings>;
};

export type Drive_Nodes = Node & {
  __typename?: "drive_nodes";
  app_users?: Maybe<App_Users>;
  created_at: Scalars["Datetime"]["output"];
  drive_file_id: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  is_root: Scalars["Boolean"]["output"];
  kind: Scalars["String"]["output"];
  mime_type?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  parent_drive_file_id?: Maybe<Scalars["String"]["output"]>;
  updated_at: Scalars["Datetime"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type Drive_NodesConnection = {
  __typename?: "drive_nodesConnection";
  edges: Array<Drive_NodesEdge>;
  pageInfo: PageInfo;
};

export type Drive_NodesDeleteResponse = {
  __typename?: "drive_nodesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Drive_Nodes>;
};

export type Drive_NodesEdge = {
  __typename?: "drive_nodesEdge";
  cursor: Scalars["String"]["output"];
  node: Drive_Nodes;
};

export type Drive_NodesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Drive_NodesFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  drive_file_id?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  is_root?: InputMaybe<BooleanFilter>;
  kind?: InputMaybe<StringFilter>;
  mime_type?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Drive_NodesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Drive_NodesFilter>>;
  parent_drive_file_id?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Drive_NodesInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  drive_file_id?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_root?: InputMaybe<Scalars["Boolean"]["input"]>;
  kind?: InputMaybe<Scalars["String"]["input"]>;
  mime_type?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  parent_drive_file_id?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Drive_NodesInsertResponse = {
  __typename?: "drive_nodesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Drive_Nodes>;
};

export type Drive_NodesOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  drive_file_id?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_root?: InputMaybe<OrderByDirection>;
  kind?: InputMaybe<OrderByDirection>;
  mime_type?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  parent_drive_file_id?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Drive_NodesUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  drive_file_id?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_root?: InputMaybe<Scalars["Boolean"]["input"]>;
  kind?: InputMaybe<Scalars["String"]["input"]>;
  mime_type?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  parent_drive_file_id?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Drive_NodesUpdateResponse = {
  __typename?: "drive_nodesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Drive_Nodes>;
};

export type Drive_User_Roots = Node & {
  __typename?: "drive_user_roots";
  app_users?: Maybe<App_Users>;
  created_at: Scalars["Datetime"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  root_folder_id: Scalars["String"]["output"];
  shared_drive_id: Scalars["String"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type Drive_User_RootsConnection = {
  __typename?: "drive_user_rootsConnection";
  edges: Array<Drive_User_RootsEdge>;
  pageInfo: PageInfo;
};

export type Drive_User_RootsDeleteResponse = {
  __typename?: "drive_user_rootsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Drive_User_Roots>;
};

export type Drive_User_RootsEdge = {
  __typename?: "drive_user_rootsEdge";
  cursor: Scalars["String"]["output"];
  node: Drive_User_Roots;
};

export type Drive_User_RootsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Drive_User_RootsFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Drive_User_RootsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Drive_User_RootsFilter>>;
  root_folder_id?: InputMaybe<StringFilter>;
  shared_drive_id?: InputMaybe<StringFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Drive_User_RootsInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  root_folder_id?: InputMaybe<Scalars["String"]["input"]>;
  shared_drive_id?: InputMaybe<Scalars["String"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Drive_User_RootsInsertResponse = {
  __typename?: "drive_user_rootsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Drive_User_Roots>;
};

export type Drive_User_RootsOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  root_folder_id?: InputMaybe<OrderByDirection>;
  shared_drive_id?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Drive_User_RootsUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  root_folder_id?: InputMaybe<Scalars["String"]["input"]>;
  shared_drive_id?: InputMaybe<Scalars["String"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Drive_User_RootsUpdateResponse = {
  __typename?: "drive_user_rootsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Drive_User_Roots>;
};

export type Email_Audiences = Node & {
  __typename?: "email_audiences";
  brand: Scalars["String"]["output"];
  created_at: Scalars["Datetime"]["output"];
  created_by?: Maybe<Scalars["UUID"]["output"]>;
  email_campaignsCollection?: Maybe<Email_CampaignsConnection>;
  id: Scalars["UUID"]["output"];
  kind: Scalars["String"]["output"];
  marketing_brands?: Maybe<Marketing_Brands>;
  member_emails?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  name: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  segment_definition?: Maybe<Scalars["JSON"]["output"]>;
  updated_at: Scalars["Datetime"]["output"];
};

export type Email_AudiencesEmail_CampaignsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_CampaignsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_CampaignsOrderBy>>;
};

export type Email_AudiencesConnection = {
  __typename?: "email_audiencesConnection";
  edges: Array<Email_AudiencesEdge>;
  pageInfo: PageInfo;
};

export type Email_AudiencesDeleteResponse = {
  __typename?: "email_audiencesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Audiences>;
};

export type Email_AudiencesEdge = {
  __typename?: "email_audiencesEdge";
  cursor: Scalars["String"]["output"];
  node: Email_Audiences;
};

export type Email_AudiencesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Email_AudiencesFilter>>;
  brand?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  kind?: InputMaybe<StringFilter>;
  member_emails?: InputMaybe<StringListFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Email_AudiencesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Email_AudiencesFilter>>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Email_AudiencesInsertInput = {
  brand?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  kind?: InputMaybe<Scalars["String"]["input"]>;
  member_emails?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  segment_definition?: InputMaybe<Scalars["JSON"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Email_AudiencesInsertResponse = {
  __typename?: "email_audiencesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Audiences>;
};

export type Email_AudiencesOrderBy = {
  brand?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  kind?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Email_AudiencesUpdateInput = {
  brand?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  kind?: InputMaybe<Scalars["String"]["input"]>;
  member_emails?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  segment_definition?: InputMaybe<Scalars["JSON"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Email_AudiencesUpdateResponse = {
  __typename?: "email_audiencesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Audiences>;
};

export type Email_Campaign_Recipients = Node & {
  __typename?: "email_campaign_recipients";
  campaign_id: Scalars["UUID"]["output"];
  clicked_at?: Maybe<Scalars["Datetime"]["output"]>;
  contact_id?: Maybe<Scalars["UUID"]["output"]>;
  contacts?: Maybe<Contacts>;
  created_at: Scalars["Datetime"]["output"];
  email: Scalars["String"]["output"];
  email_campaigns?: Maybe<Email_Campaigns>;
  email_eventsCollection?: Maybe<Email_EventsConnection>;
  error?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  opened_at?: Maybe<Scalars["Datetime"]["output"]>;
  sent_at?: Maybe<Scalars["Datetime"]["output"]>;
  status: Scalars["String"]["output"];
  tracking_token: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
};

export type Email_Campaign_RecipientsEmail_EventsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_EventsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_EventsOrderBy>>;
};

export type Email_Campaign_RecipientsConnection = {
  __typename?: "email_campaign_recipientsConnection";
  edges: Array<Email_Campaign_RecipientsEdge>;
  pageInfo: PageInfo;
};

export type Email_Campaign_RecipientsDeleteResponse = {
  __typename?: "email_campaign_recipientsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Campaign_Recipients>;
};

export type Email_Campaign_RecipientsEdge = {
  __typename?: "email_campaign_recipientsEdge";
  cursor: Scalars["String"]["output"];
  node: Email_Campaign_Recipients;
};

export type Email_Campaign_RecipientsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Email_Campaign_RecipientsFilter>>;
  campaign_id?: InputMaybe<UuidFilter>;
  clicked_at?: InputMaybe<DatetimeFilter>;
  contact_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  email?: InputMaybe<StringFilter>;
  error?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Email_Campaign_RecipientsFilter>;
  opened_at?: InputMaybe<DatetimeFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Email_Campaign_RecipientsFilter>>;
  sent_at?: InputMaybe<DatetimeFilter>;
  status?: InputMaybe<StringFilter>;
  tracking_token?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Email_Campaign_RecipientsInsertInput = {
  campaign_id?: InputMaybe<Scalars["UUID"]["input"]>;
  clicked_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  error?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  opened_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  sent_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  tracking_token?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Email_Campaign_RecipientsInsertResponse = {
  __typename?: "email_campaign_recipientsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Campaign_Recipients>;
};

export type Email_Campaign_RecipientsOrderBy = {
  campaign_id?: InputMaybe<OrderByDirection>;
  clicked_at?: InputMaybe<OrderByDirection>;
  contact_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  email?: InputMaybe<OrderByDirection>;
  error?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  opened_at?: InputMaybe<OrderByDirection>;
  sent_at?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  tracking_token?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Email_Campaign_RecipientsUpdateInput = {
  campaign_id?: InputMaybe<Scalars["UUID"]["input"]>;
  clicked_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  error?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  opened_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  sent_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  tracking_token?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Email_Campaign_RecipientsUpdateResponse = {
  __typename?: "email_campaign_recipientsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Campaign_Recipients>;
};

export type Email_Campaigns = Node & {
  __typename?: "email_campaigns";
  audience_id?: Maybe<Scalars["UUID"]["output"]>;
  body_html?: Maybe<Scalars["String"]["output"]>;
  brand: Scalars["String"]["output"];
  created_at: Scalars["Datetime"]["output"];
  created_by?: Maybe<Scalars["UUID"]["output"]>;
  email_audiences?: Maybe<Email_Audiences>;
  email_campaign_recipientsCollection?: Maybe<Email_Campaign_RecipientsConnection>;
  email_eventsCollection?: Maybe<Email_EventsConnection>;
  email_templates?: Maybe<Email_Templates>;
  email_unsubscribesCollection?: Maybe<Email_UnsubscribesConnection>;
  from_email: Scalars["String"]["output"];
  from_name: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  marketing_brands?: Maybe<Marketing_Brands>;
  name: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  reply_to?: Maybe<Scalars["String"]["output"]>;
  scheduled_at?: Maybe<Scalars["Datetime"]["output"]>;
  sent_at?: Maybe<Scalars["Datetime"]["output"]>;
  stats: Scalars["JSON"]["output"];
  status: Scalars["String"]["output"];
  subject: Scalars["String"]["output"];
  template_id?: Maybe<Scalars["UUID"]["output"]>;
  updated_at: Scalars["Datetime"]["output"];
};

export type Email_CampaignsEmail_Campaign_RecipientsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_Campaign_RecipientsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_Campaign_RecipientsOrderBy>>;
};

export type Email_CampaignsEmail_EventsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_EventsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_EventsOrderBy>>;
};

export type Email_CampaignsEmail_UnsubscribesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_UnsubscribesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_UnsubscribesOrderBy>>;
};

export type Email_CampaignsConnection = {
  __typename?: "email_campaignsConnection";
  edges: Array<Email_CampaignsEdge>;
  pageInfo: PageInfo;
};

export type Email_CampaignsDeleteResponse = {
  __typename?: "email_campaignsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Campaigns>;
};

export type Email_CampaignsEdge = {
  __typename?: "email_campaignsEdge";
  cursor: Scalars["String"]["output"];
  node: Email_Campaigns;
};

export type Email_CampaignsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Email_CampaignsFilter>>;
  audience_id?: InputMaybe<UuidFilter>;
  body_html?: InputMaybe<StringFilter>;
  brand?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  from_email?: InputMaybe<StringFilter>;
  from_name?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Email_CampaignsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Email_CampaignsFilter>>;
  reply_to?: InputMaybe<StringFilter>;
  scheduled_at?: InputMaybe<DatetimeFilter>;
  sent_at?: InputMaybe<DatetimeFilter>;
  status?: InputMaybe<StringFilter>;
  subject?: InputMaybe<StringFilter>;
  template_id?: InputMaybe<UuidFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Email_CampaignsInsertInput = {
  audience_id?: InputMaybe<Scalars["UUID"]["input"]>;
  body_html?: InputMaybe<Scalars["String"]["input"]>;
  brand?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  from_email?: InputMaybe<Scalars["String"]["input"]>;
  from_name?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  reply_to?: InputMaybe<Scalars["String"]["input"]>;
  scheduled_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  sent_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  stats?: InputMaybe<Scalars["JSON"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  subject?: InputMaybe<Scalars["String"]["input"]>;
  template_id?: InputMaybe<Scalars["UUID"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Email_CampaignsInsertResponse = {
  __typename?: "email_campaignsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Campaigns>;
};

export type Email_CampaignsOrderBy = {
  audience_id?: InputMaybe<OrderByDirection>;
  body_html?: InputMaybe<OrderByDirection>;
  brand?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  from_email?: InputMaybe<OrderByDirection>;
  from_name?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  reply_to?: InputMaybe<OrderByDirection>;
  scheduled_at?: InputMaybe<OrderByDirection>;
  sent_at?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  subject?: InputMaybe<OrderByDirection>;
  template_id?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Email_CampaignsUpdateInput = {
  audience_id?: InputMaybe<Scalars["UUID"]["input"]>;
  body_html?: InputMaybe<Scalars["String"]["input"]>;
  brand?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  from_email?: InputMaybe<Scalars["String"]["input"]>;
  from_name?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  reply_to?: InputMaybe<Scalars["String"]["input"]>;
  scheduled_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  sent_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  stats?: InputMaybe<Scalars["JSON"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  subject?: InputMaybe<Scalars["String"]["input"]>;
  template_id?: InputMaybe<Scalars["UUID"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Email_CampaignsUpdateResponse = {
  __typename?: "email_campaignsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Campaigns>;
};

export type Email_Events = Node & {
  __typename?: "email_events";
  campaign_id?: Maybe<Scalars["UUID"]["output"]>;
  email_campaign_recipients?: Maybe<Email_Campaign_Recipients>;
  email_campaigns?: Maybe<Email_Campaigns>;
  id: Scalars["UUID"]["output"];
  ip?: Maybe<Scalars["String"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  occurred_at: Scalars["Datetime"]["output"];
  recipient_id: Scalars["UUID"]["output"];
  type: Scalars["String"]["output"];
  url?: Maybe<Scalars["String"]["output"]>;
  user_agent?: Maybe<Scalars["String"]["output"]>;
};

export type Email_EventsConnection = {
  __typename?: "email_eventsConnection";
  edges: Array<Email_EventsEdge>;
  pageInfo: PageInfo;
};

export type Email_EventsDeleteResponse = {
  __typename?: "email_eventsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Events>;
};

export type Email_EventsEdge = {
  __typename?: "email_eventsEdge";
  cursor: Scalars["String"]["output"];
  node: Email_Events;
};

export type Email_EventsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Email_EventsFilter>>;
  campaign_id?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  ip?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Email_EventsFilter>;
  occurred_at?: InputMaybe<DatetimeFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Email_EventsFilter>>;
  recipient_id?: InputMaybe<UuidFilter>;
  type?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
  user_agent?: InputMaybe<StringFilter>;
};

export type Email_EventsInsertInput = {
  campaign_id?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  ip?: InputMaybe<Scalars["String"]["input"]>;
  occurred_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  recipient_id?: InputMaybe<Scalars["UUID"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
  user_agent?: InputMaybe<Scalars["String"]["input"]>;
};

export type Email_EventsInsertResponse = {
  __typename?: "email_eventsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Events>;
};

export type Email_EventsOrderBy = {
  campaign_id?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  ip?: InputMaybe<OrderByDirection>;
  occurred_at?: InputMaybe<OrderByDirection>;
  recipient_id?: InputMaybe<OrderByDirection>;
  type?: InputMaybe<OrderByDirection>;
  url?: InputMaybe<OrderByDirection>;
  user_agent?: InputMaybe<OrderByDirection>;
};

export type Email_EventsUpdateInput = {
  campaign_id?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  ip?: InputMaybe<Scalars["String"]["input"]>;
  occurred_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  recipient_id?: InputMaybe<Scalars["UUID"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
  user_agent?: InputMaybe<Scalars["String"]["input"]>;
};

export type Email_EventsUpdateResponse = {
  __typename?: "email_eventsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Events>;
};

export type Email_Forwarding_Log = Node & {
  __typename?: "email_forwarding_log";
  canvas_id?: Maybe<Scalars["String"]["output"]>;
  card_blocks?: Maybe<Scalars["JSON"]["output"]>;
  created_at: Scalars["Datetime"]["output"];
  email_external_id: Scalars["String"]["output"];
  error?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  reviewed_at?: Maybe<Scalars["Datetime"]["output"]>;
  reviewed_by_slack_user_id?: Maybe<Scalars["String"]["output"]>;
  rule_id: Scalars["String"]["output"];
  sender_email: Scalars["String"]["output"];
  slack_channel_id: Scalars["String"]["output"];
  slack_message_ts?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  subject?: Maybe<Scalars["String"]["output"]>;
  updated_at: Scalars["Datetime"]["output"];
};

export type Email_Forwarding_LogConnection = {
  __typename?: "email_forwarding_logConnection";
  edges: Array<Email_Forwarding_LogEdge>;
  pageInfo: PageInfo;
};

export type Email_Forwarding_LogDeleteResponse = {
  __typename?: "email_forwarding_logDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Forwarding_Log>;
};

export type Email_Forwarding_LogEdge = {
  __typename?: "email_forwarding_logEdge";
  cursor: Scalars["String"]["output"];
  node: Email_Forwarding_Log;
};

export type Email_Forwarding_LogFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Email_Forwarding_LogFilter>>;
  canvas_id?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  email_external_id?: InputMaybe<StringFilter>;
  error?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Email_Forwarding_LogFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Email_Forwarding_LogFilter>>;
  reviewed_at?: InputMaybe<DatetimeFilter>;
  reviewed_by_slack_user_id?: InputMaybe<StringFilter>;
  rule_id?: InputMaybe<StringFilter>;
  sender_email?: InputMaybe<StringFilter>;
  slack_channel_id?: InputMaybe<StringFilter>;
  slack_message_ts?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  subject?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Email_Forwarding_LogInsertInput = {
  canvas_id?: InputMaybe<Scalars["String"]["input"]>;
  card_blocks?: InputMaybe<Scalars["JSON"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  email_external_id?: InputMaybe<Scalars["String"]["input"]>;
  error?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  reviewed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  reviewed_by_slack_user_id?: InputMaybe<Scalars["String"]["input"]>;
  rule_id?: InputMaybe<Scalars["String"]["input"]>;
  sender_email?: InputMaybe<Scalars["String"]["input"]>;
  slack_channel_id?: InputMaybe<Scalars["String"]["input"]>;
  slack_message_ts?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  subject?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Email_Forwarding_LogInsertResponse = {
  __typename?: "email_forwarding_logInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Forwarding_Log>;
};

export type Email_Forwarding_LogOrderBy = {
  canvas_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  email_external_id?: InputMaybe<OrderByDirection>;
  error?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  reviewed_at?: InputMaybe<OrderByDirection>;
  reviewed_by_slack_user_id?: InputMaybe<OrderByDirection>;
  rule_id?: InputMaybe<OrderByDirection>;
  sender_email?: InputMaybe<OrderByDirection>;
  slack_channel_id?: InputMaybe<OrderByDirection>;
  slack_message_ts?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  subject?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Email_Forwarding_LogUpdateInput = {
  canvas_id?: InputMaybe<Scalars["String"]["input"]>;
  card_blocks?: InputMaybe<Scalars["JSON"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  email_external_id?: InputMaybe<Scalars["String"]["input"]>;
  error?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  reviewed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  reviewed_by_slack_user_id?: InputMaybe<Scalars["String"]["input"]>;
  rule_id?: InputMaybe<Scalars["String"]["input"]>;
  sender_email?: InputMaybe<Scalars["String"]["input"]>;
  slack_channel_id?: InputMaybe<Scalars["String"]["input"]>;
  slack_message_ts?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  subject?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Email_Forwarding_LogUpdateResponse = {
  __typename?: "email_forwarding_logUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Forwarding_Log>;
};

export type Email_Signatures = Node & {
  __typename?: "email_signatures";
  app_users?: Maybe<App_Users>;
  connection_id: Scalars["String"]["output"];
  content: Scalars["String"]["output"];
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  id: Scalars["UUID"]["output"];
  is_default?: Maybe<Scalars["Boolean"]["output"]>;
  name: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  owner_id: Scalars["UUID"]["output"];
  provider_config_key: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type Email_SignaturesConnection = {
  __typename?: "email_signaturesConnection";
  edges: Array<Email_SignaturesEdge>;
  pageInfo: PageInfo;
};

export type Email_SignaturesDeleteResponse = {
  __typename?: "email_signaturesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Signatures>;
};

export type Email_SignaturesEdge = {
  __typename?: "email_signaturesEdge";
  cursor: Scalars["String"]["output"];
  node: Email_Signatures;
};

export type Email_SignaturesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Email_SignaturesFilter>>;
  connection_id?: InputMaybe<StringFilter>;
  content?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  is_default?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Email_SignaturesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Email_SignaturesFilter>>;
  owner_id?: InputMaybe<UuidFilter>;
  provider_config_key?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Email_SignaturesInsertInput = {
  connection_id?: InputMaybe<Scalars["String"]["input"]>;
  content?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_default?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  owner_id?: InputMaybe<Scalars["UUID"]["input"]>;
  provider_config_key?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Email_SignaturesInsertResponse = {
  __typename?: "email_signaturesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Signatures>;
};

export type Email_SignaturesOrderBy = {
  connection_id?: InputMaybe<OrderByDirection>;
  content?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_default?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  owner_id?: InputMaybe<OrderByDirection>;
  provider_config_key?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Email_SignaturesUpdateInput = {
  connection_id?: InputMaybe<Scalars["String"]["input"]>;
  content?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_default?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  owner_id?: InputMaybe<Scalars["UUID"]["input"]>;
  provider_config_key?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Email_SignaturesUpdateResponse = {
  __typename?: "email_signaturesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Signatures>;
};

export type Email_Template_Favorites = Node & {
  __typename?: "email_template_favorites";
  created_at: Scalars["Datetime"]["output"];
  email_templates?: Maybe<Email_Templates>;
  id: Scalars["UUID"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  template_id: Scalars["UUID"]["output"];
  updated_at: Scalars["Datetime"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type Email_Template_FavoritesConnection = {
  __typename?: "email_template_favoritesConnection";
  edges: Array<Email_Template_FavoritesEdge>;
  pageInfo: PageInfo;
};

export type Email_Template_FavoritesDeleteResponse = {
  __typename?: "email_template_favoritesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Template_Favorites>;
};

export type Email_Template_FavoritesEdge = {
  __typename?: "email_template_favoritesEdge";
  cursor: Scalars["String"]["output"];
  node: Email_Template_Favorites;
};

export type Email_Template_FavoritesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Email_Template_FavoritesFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Email_Template_FavoritesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Email_Template_FavoritesFilter>>;
  template_id?: InputMaybe<UuidFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Email_Template_FavoritesInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  template_id?: InputMaybe<Scalars["UUID"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Email_Template_FavoritesInsertResponse = {
  __typename?: "email_template_favoritesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Template_Favorites>;
};

export type Email_Template_FavoritesOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  template_id?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Email_Template_FavoritesUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  template_id?: InputMaybe<Scalars["UUID"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Email_Template_FavoritesUpdateResponse = {
  __typename?: "email_template_favoritesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Template_Favorites>;
};

export type Email_Template_Files = Node & {
  __typename?: "email_template_files";
  created_at: Scalars["Datetime"]["output"];
  email_templates?: Maybe<Email_Templates>;
  file_category: Scalars["String"]["output"];
  file_name: Scalars["String"]["output"];
  file_size: Scalars["Int"]["output"];
  file_type: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  storage_path: Scalars["String"]["output"];
  storage_url: Scalars["String"]["output"];
  template_id: Scalars["UUID"]["output"];
  updated_at: Scalars["Datetime"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type Email_Template_FilesConnection = {
  __typename?: "email_template_filesConnection";
  edges: Array<Email_Template_FilesEdge>;
  pageInfo: PageInfo;
};

export type Email_Template_FilesDeleteResponse = {
  __typename?: "email_template_filesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Template_Files>;
};

export type Email_Template_FilesEdge = {
  __typename?: "email_template_filesEdge";
  cursor: Scalars["String"]["output"];
  node: Email_Template_Files;
};

export type Email_Template_FilesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Email_Template_FilesFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  file_category?: InputMaybe<StringFilter>;
  file_name?: InputMaybe<StringFilter>;
  file_size?: InputMaybe<IntFilter>;
  file_type?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Email_Template_FilesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Email_Template_FilesFilter>>;
  storage_path?: InputMaybe<StringFilter>;
  storage_url?: InputMaybe<StringFilter>;
  template_id?: InputMaybe<UuidFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Email_Template_FilesInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  file_category?: InputMaybe<Scalars["String"]["input"]>;
  file_name?: InputMaybe<Scalars["String"]["input"]>;
  file_size?: InputMaybe<Scalars["Int"]["input"]>;
  file_type?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  storage_path?: InputMaybe<Scalars["String"]["input"]>;
  storage_url?: InputMaybe<Scalars["String"]["input"]>;
  template_id?: InputMaybe<Scalars["UUID"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Email_Template_FilesInsertResponse = {
  __typename?: "email_template_filesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Template_Files>;
};

export type Email_Template_FilesOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  file_category?: InputMaybe<OrderByDirection>;
  file_name?: InputMaybe<OrderByDirection>;
  file_size?: InputMaybe<OrderByDirection>;
  file_type?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  storage_path?: InputMaybe<OrderByDirection>;
  storage_url?: InputMaybe<OrderByDirection>;
  template_id?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Email_Template_FilesUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  file_category?: InputMaybe<Scalars["String"]["input"]>;
  file_name?: InputMaybe<Scalars["String"]["input"]>;
  file_size?: InputMaybe<Scalars["Int"]["input"]>;
  file_type?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  storage_path?: InputMaybe<Scalars["String"]["input"]>;
  storage_url?: InputMaybe<Scalars["String"]["input"]>;
  template_id?: InputMaybe<Scalars["UUID"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Email_Template_FilesUpdateResponse = {
  __typename?: "email_template_filesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Template_Files>;
};

export type Email_Template_Folders = Node & {
  __typename?: "email_template_folders";
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  email_template_folders?: Maybe<Email_Template_Folders>;
  email_template_foldersCollection?: Maybe<Email_Template_FoldersConnection>;
  email_templatesCollection?: Maybe<Email_TemplatesConnection>;
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  parent_id?: Maybe<Scalars["UUID"]["output"]>;
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type Email_Template_FoldersEmail_Template_FoldersCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_Template_FoldersFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_Template_FoldersOrderBy>>;
};

export type Email_Template_FoldersEmail_TemplatesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_TemplatesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_TemplatesOrderBy>>;
};

export type Email_Template_FoldersConnection = {
  __typename?: "email_template_foldersConnection";
  edges: Array<Email_Template_FoldersEdge>;
  pageInfo: PageInfo;
};

export type Email_Template_FoldersDeleteResponse = {
  __typename?: "email_template_foldersDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Template_Folders>;
};

export type Email_Template_FoldersEdge = {
  __typename?: "email_template_foldersEdge";
  cursor: Scalars["String"]["output"];
  node: Email_Template_Folders;
};

export type Email_Template_FoldersFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Email_Template_FoldersFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Email_Template_FoldersFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Email_Template_FoldersFilter>>;
  parent_id?: InputMaybe<UuidFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Email_Template_FoldersInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  parent_id?: InputMaybe<Scalars["UUID"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Email_Template_FoldersInsertResponse = {
  __typename?: "email_template_foldersInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Template_Folders>;
};

export type Email_Template_FoldersOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  parent_id?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Email_Template_FoldersUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  parent_id?: InputMaybe<Scalars["UUID"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Email_Template_FoldersUpdateResponse = {
  __typename?: "email_template_foldersUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Template_Folders>;
};

export type Email_Template_Shares = Node & {
  __typename?: "email_template_shares";
  created_at: Scalars["Datetime"]["output"];
  email_templates?: Maybe<Email_Templates>;
  id: Scalars["UUID"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  template_id: Scalars["UUID"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type Email_Template_SharesConnection = {
  __typename?: "email_template_sharesConnection";
  edges: Array<Email_Template_SharesEdge>;
  pageInfo: PageInfo;
};

export type Email_Template_SharesDeleteResponse = {
  __typename?: "email_template_sharesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Template_Shares>;
};

export type Email_Template_SharesEdge = {
  __typename?: "email_template_sharesEdge";
  cursor: Scalars["String"]["output"];
  node: Email_Template_Shares;
};

export type Email_Template_SharesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Email_Template_SharesFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Email_Template_SharesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Email_Template_SharesFilter>>;
  template_id?: InputMaybe<UuidFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Email_Template_SharesInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  template_id?: InputMaybe<Scalars["UUID"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Email_Template_SharesInsertResponse = {
  __typename?: "email_template_sharesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Template_Shares>;
};

export type Email_Template_SharesOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  template_id?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Email_Template_SharesUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  template_id?: InputMaybe<Scalars["UUID"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Email_Template_SharesUpdateResponse = {
  __typename?: "email_template_sharesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Template_Shares>;
};

export type Email_Templates = Node & {
  __typename?: "email_templates";
  body: Scalars["String"]["output"];
  created_at: Scalars["Datetime"]["output"];
  email_campaignsCollection?: Maybe<Email_CampaignsConnection>;
  email_template_favoritesCollection?: Maybe<Email_Template_FavoritesConnection>;
  email_template_filesCollection?: Maybe<Email_Template_FilesConnection>;
  email_template_folders?: Maybe<Email_Template_Folders>;
  email_template_sharesCollection?: Maybe<Email_Template_SharesConnection>;
  folder_id?: Maybe<Scalars["UUID"]["output"]>;
  id: Scalars["UUID"]["output"];
  is_shared: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  scheduled_emailsCollection?: Maybe<Scheduled_EmailsConnection>;
  search_vector?: Maybe<Scalars["Opaque"]["output"]>;
  subject: Scalars["String"]["output"];
  tags?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  user_id: Scalars["UUID"]["output"];
  variables: Scalars["JSON"]["output"];
};

export type Email_TemplatesEmail_CampaignsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_CampaignsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_CampaignsOrderBy>>;
};

export type Email_TemplatesEmail_Template_FavoritesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_Template_FavoritesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_Template_FavoritesOrderBy>>;
};

export type Email_TemplatesEmail_Template_FilesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_Template_FilesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_Template_FilesOrderBy>>;
};

export type Email_TemplatesEmail_Template_SharesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_Template_SharesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_Template_SharesOrderBy>>;
};

export type Email_TemplatesScheduled_EmailsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Scheduled_EmailsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Scheduled_EmailsOrderBy>>;
};

export type Email_TemplatesConnection = {
  __typename?: "email_templatesConnection";
  edges: Array<Email_TemplatesEdge>;
  pageInfo: PageInfo;
  /** The total number of records matching the `filter` criteria */
  totalCount: Scalars["Int"]["output"];
};

export type Email_TemplatesDeleteResponse = {
  __typename?: "email_templatesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Templates>;
};

export type Email_TemplatesEdge = {
  __typename?: "email_templatesEdge";
  cursor: Scalars["String"]["output"];
  node: Email_Templates;
};

export type Email_TemplatesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Email_TemplatesFilter>>;
  body?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  folder_id?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  is_shared?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Email_TemplatesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Email_TemplatesFilter>>;
  search_vector?: InputMaybe<OpaqueFilter>;
  subject?: InputMaybe<StringFilter>;
  tags?: InputMaybe<StringListFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Email_TemplatesInsertInput = {
  body?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  folder_id?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_shared?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  subject?: InputMaybe<Scalars["String"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
  variables?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type Email_TemplatesInsertResponse = {
  __typename?: "email_templatesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Templates>;
};

export type Email_TemplatesOrderBy = {
  body?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  folder_id?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_shared?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  search_vector?: InputMaybe<OrderByDirection>;
  subject?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Email_TemplatesUpdateInput = {
  body?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  folder_id?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_shared?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  subject?: InputMaybe<Scalars["String"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
  variables?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type Email_TemplatesUpdateResponse = {
  __typename?: "email_templatesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Templates>;
};

export type Email_Tracking_Open_Events = Node & {
  __typename?: "email_tracking_open_events";
  created_at: Scalars["Datetime"]["output"];
  email_tracking_tokens?: Maybe<Email_Tracking_Tokens>;
  id: Scalars["UUID"]["output"];
  ip?: Maybe<Scalars["String"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  occurred_at: Scalars["Datetime"]["output"];
  token_id: Scalars["UUID"]["output"];
  updated_at: Scalars["Datetime"]["output"];
  user_agent?: Maybe<Scalars["String"]["output"]>;
};

export type Email_Tracking_Open_EventsConnection = {
  __typename?: "email_tracking_open_eventsConnection";
  edges: Array<Email_Tracking_Open_EventsEdge>;
  pageInfo: PageInfo;
};

export type Email_Tracking_Open_EventsDeleteResponse = {
  __typename?: "email_tracking_open_eventsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Tracking_Open_Events>;
};

export type Email_Tracking_Open_EventsEdge = {
  __typename?: "email_tracking_open_eventsEdge";
  cursor: Scalars["String"]["output"];
  node: Email_Tracking_Open_Events;
};

export type Email_Tracking_Open_EventsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Email_Tracking_Open_EventsFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  ip?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Email_Tracking_Open_EventsFilter>;
  occurred_at?: InputMaybe<DatetimeFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Email_Tracking_Open_EventsFilter>>;
  token_id?: InputMaybe<UuidFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_agent?: InputMaybe<StringFilter>;
};

export type Email_Tracking_Open_EventsInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  ip?: InputMaybe<Scalars["String"]["input"]>;
  occurred_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  token_id?: InputMaybe<Scalars["UUID"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_agent?: InputMaybe<Scalars["String"]["input"]>;
};

export type Email_Tracking_Open_EventsInsertResponse = {
  __typename?: "email_tracking_open_eventsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Tracking_Open_Events>;
};

export type Email_Tracking_Open_EventsOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  ip?: InputMaybe<OrderByDirection>;
  occurred_at?: InputMaybe<OrderByDirection>;
  token_id?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_agent?: InputMaybe<OrderByDirection>;
};

export type Email_Tracking_Open_EventsUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  ip?: InputMaybe<Scalars["String"]["input"]>;
  occurred_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  token_id?: InputMaybe<Scalars["UUID"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_agent?: InputMaybe<Scalars["String"]["input"]>;
};

export type Email_Tracking_Open_EventsUpdateResponse = {
  __typename?: "email_tracking_open_eventsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Tracking_Open_Events>;
};

export type Email_Tracking_Tokens = Node & {
  __typename?: "email_tracking_tokens";
  app_users?: Maybe<App_Users>;
  communication_id?: Maybe<Scalars["UUID"]["output"]>;
  communications?: Maybe<Communications>;
  companies?: Maybe<Companies>;
  company_id?: Maybe<Scalars["UUID"]["output"]>;
  contact_id?: Maybe<Scalars["UUID"]["output"]>;
  contacts?: Maybe<Contacts>;
  created_at: Scalars["Datetime"]["output"];
  direction: Scalars["String"]["output"];
  email_tracking_open_eventsCollection?: Maybe<Email_Tracking_Open_EventsConnection>;
  external_id?: Maybe<Scalars["String"]["output"]>;
  first_ip?: Maybe<Scalars["String"]["output"]>;
  first_user_agent?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  last_opened_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  open_count: Scalars["Int"]["output"];
  opened_at?: Maybe<Scalars["Datetime"]["output"]>;
  provider?: Maybe<Scalars["String"]["output"]>;
  recipient_email?: Maybe<Scalars["String"]["output"]>;
  sent_by?: Maybe<Scalars["UUID"]["output"]>;
  source: Scalars["String"]["output"];
  token: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
};

export type Email_Tracking_TokensEmail_Tracking_Open_EventsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_Tracking_Open_EventsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_Tracking_Open_EventsOrderBy>>;
};

export type Email_Tracking_TokensConnection = {
  __typename?: "email_tracking_tokensConnection";
  edges: Array<Email_Tracking_TokensEdge>;
  pageInfo: PageInfo;
};

export type Email_Tracking_TokensDeleteResponse = {
  __typename?: "email_tracking_tokensDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Tracking_Tokens>;
};

export type Email_Tracking_TokensEdge = {
  __typename?: "email_tracking_tokensEdge";
  cursor: Scalars["String"]["output"];
  node: Email_Tracking_Tokens;
};

export type Email_Tracking_TokensFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Email_Tracking_TokensFilter>>;
  communication_id?: InputMaybe<UuidFilter>;
  company_id?: InputMaybe<UuidFilter>;
  contact_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  direction?: InputMaybe<StringFilter>;
  external_id?: InputMaybe<StringFilter>;
  first_ip?: InputMaybe<StringFilter>;
  first_user_agent?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  last_opened_at?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Email_Tracking_TokensFilter>;
  open_count?: InputMaybe<IntFilter>;
  opened_at?: InputMaybe<DatetimeFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Email_Tracking_TokensFilter>>;
  provider?: InputMaybe<StringFilter>;
  recipient_email?: InputMaybe<StringFilter>;
  sent_by?: InputMaybe<UuidFilter>;
  source?: InputMaybe<StringFilter>;
  token?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Email_Tracking_TokensInsertInput = {
  communication_id?: InputMaybe<Scalars["UUID"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  direction?: InputMaybe<Scalars["String"]["input"]>;
  external_id?: InputMaybe<Scalars["String"]["input"]>;
  first_ip?: InputMaybe<Scalars["String"]["input"]>;
  first_user_agent?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  last_opened_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  open_count?: InputMaybe<Scalars["Int"]["input"]>;
  opened_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  provider?: InputMaybe<Scalars["String"]["input"]>;
  recipient_email?: InputMaybe<Scalars["String"]["input"]>;
  sent_by?: InputMaybe<Scalars["UUID"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  token?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Email_Tracking_TokensInsertResponse = {
  __typename?: "email_tracking_tokensInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Tracking_Tokens>;
};

export type Email_Tracking_TokensOrderBy = {
  communication_id?: InputMaybe<OrderByDirection>;
  company_id?: InputMaybe<OrderByDirection>;
  contact_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  direction?: InputMaybe<OrderByDirection>;
  external_id?: InputMaybe<OrderByDirection>;
  first_ip?: InputMaybe<OrderByDirection>;
  first_user_agent?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  last_opened_at?: InputMaybe<OrderByDirection>;
  open_count?: InputMaybe<OrderByDirection>;
  opened_at?: InputMaybe<OrderByDirection>;
  provider?: InputMaybe<OrderByDirection>;
  recipient_email?: InputMaybe<OrderByDirection>;
  sent_by?: InputMaybe<OrderByDirection>;
  source?: InputMaybe<OrderByDirection>;
  token?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Email_Tracking_TokensUpdateInput = {
  communication_id?: InputMaybe<Scalars["UUID"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  direction?: InputMaybe<Scalars["String"]["input"]>;
  external_id?: InputMaybe<Scalars["String"]["input"]>;
  first_ip?: InputMaybe<Scalars["String"]["input"]>;
  first_user_agent?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  last_opened_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  open_count?: InputMaybe<Scalars["Int"]["input"]>;
  opened_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  provider?: InputMaybe<Scalars["String"]["input"]>;
  recipient_email?: InputMaybe<Scalars["String"]["input"]>;
  sent_by?: InputMaybe<Scalars["UUID"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  token?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Email_Tracking_TokensUpdateResponse = {
  __typename?: "email_tracking_tokensUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Tracking_Tokens>;
};

export type Email_Unsubscribes = Node & {
  __typename?: "email_unsubscribes";
  brand: Scalars["String"]["output"];
  campaign_id?: Maybe<Scalars["UUID"]["output"]>;
  email: Scalars["String"]["output"];
  email_campaigns?: Maybe<Email_Campaigns>;
  id: Scalars["UUID"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  unsubscribed_at: Scalars["Datetime"]["output"];
};

export type Email_UnsubscribesConnection = {
  __typename?: "email_unsubscribesConnection";
  edges: Array<Email_UnsubscribesEdge>;
  pageInfo: PageInfo;
};

export type Email_UnsubscribesDeleteResponse = {
  __typename?: "email_unsubscribesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Unsubscribes>;
};

export type Email_UnsubscribesEdge = {
  __typename?: "email_unsubscribesEdge";
  cursor: Scalars["String"]["output"];
  node: Email_Unsubscribes;
};

export type Email_UnsubscribesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Email_UnsubscribesFilter>>;
  brand?: InputMaybe<StringFilter>;
  campaign_id?: InputMaybe<UuidFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Email_UnsubscribesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Email_UnsubscribesFilter>>;
  unsubscribed_at?: InputMaybe<DatetimeFilter>;
};

export type Email_UnsubscribesInsertInput = {
  brand?: InputMaybe<Scalars["String"]["input"]>;
  campaign_id?: InputMaybe<Scalars["UUID"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  unsubscribed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Email_UnsubscribesInsertResponse = {
  __typename?: "email_unsubscribesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Unsubscribes>;
};

export type Email_UnsubscribesOrderBy = {
  brand?: InputMaybe<OrderByDirection>;
  campaign_id?: InputMaybe<OrderByDirection>;
  email?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  unsubscribed_at?: InputMaybe<OrderByDirection>;
};

export type Email_UnsubscribesUpdateInput = {
  brand?: InputMaybe<Scalars["String"]["input"]>;
  campaign_id?: InputMaybe<Scalars["UUID"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  unsubscribed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Email_UnsubscribesUpdateResponse = {
  __typename?: "email_unsubscribesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Email_Unsubscribes>;
};

export type Embedding_Jobs = Node & {
  __typename?: "embedding_jobs";
  attempts: Scalars["Int"]["output"];
  enqueued_at: Scalars["Datetime"]["output"];
  entity_id: Scalars["UUID"]["output"];
  entity_type: Scalars["String"]["output"];
  last_error?: Maybe<Scalars["String"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  op: Scalars["String"]["output"];
};

export type Embedding_JobsConnection = {
  __typename?: "embedding_jobsConnection";
  edges: Array<Embedding_JobsEdge>;
  pageInfo: PageInfo;
};

export type Embedding_JobsDeleteResponse = {
  __typename?: "embedding_jobsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Embedding_Jobs>;
};

export type Embedding_JobsEdge = {
  __typename?: "embedding_jobsEdge";
  cursor: Scalars["String"]["output"];
  node: Embedding_Jobs;
};

export type Embedding_JobsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Embedding_JobsFilter>>;
  attempts?: InputMaybe<IntFilter>;
  enqueued_at?: InputMaybe<DatetimeFilter>;
  entity_id?: InputMaybe<UuidFilter>;
  entity_type?: InputMaybe<StringFilter>;
  last_error?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Embedding_JobsFilter>;
  op?: InputMaybe<StringFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Embedding_JobsFilter>>;
};

export type Embedding_JobsInsertInput = {
  attempts?: InputMaybe<Scalars["Int"]["input"]>;
  enqueued_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  entity_id?: InputMaybe<Scalars["UUID"]["input"]>;
  entity_type?: InputMaybe<Scalars["String"]["input"]>;
  last_error?: InputMaybe<Scalars["String"]["input"]>;
  op?: InputMaybe<Scalars["String"]["input"]>;
};

export type Embedding_JobsInsertResponse = {
  __typename?: "embedding_jobsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Embedding_Jobs>;
};

export type Embedding_JobsOrderBy = {
  attempts?: InputMaybe<OrderByDirection>;
  enqueued_at?: InputMaybe<OrderByDirection>;
  entity_id?: InputMaybe<OrderByDirection>;
  entity_type?: InputMaybe<OrderByDirection>;
  last_error?: InputMaybe<OrderByDirection>;
  op?: InputMaybe<OrderByDirection>;
};

export type Embedding_JobsUpdateInput = {
  attempts?: InputMaybe<Scalars["Int"]["input"]>;
  enqueued_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  entity_id?: InputMaybe<Scalars["UUID"]["input"]>;
  entity_type?: InputMaybe<Scalars["String"]["input"]>;
  last_error?: InputMaybe<Scalars["String"]["input"]>;
  op?: InputMaybe<Scalars["String"]["input"]>;
};

export type Embedding_JobsUpdateResponse = {
  __typename?: "embedding_jobsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Embedding_Jobs>;
};

export type Employee_Contact_Access = Node & {
  __typename?: "employee_contact_access";
  app_users?: Maybe<App_Users>;
  contact_id: Scalars["UUID"]["output"];
  contacts?: Maybe<Contacts>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  granted_by?: Maybe<Scalars["UUID"]["output"]>;
  id: Scalars["UUID"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type Employee_Contact_AccessConnection = {
  __typename?: "employee_contact_accessConnection";
  edges: Array<Employee_Contact_AccessEdge>;
  pageInfo: PageInfo;
};

export type Employee_Contact_AccessDeleteResponse = {
  __typename?: "employee_contact_accessDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Employee_Contact_Access>;
};

export type Employee_Contact_AccessEdge = {
  __typename?: "employee_contact_accessEdge";
  cursor: Scalars["String"]["output"];
  node: Employee_Contact_Access;
};

export type Employee_Contact_AccessFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Employee_Contact_AccessFilter>>;
  contact_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  granted_by?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Employee_Contact_AccessFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Employee_Contact_AccessFilter>>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Employee_Contact_AccessInsertInput = {
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  granted_by?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Employee_Contact_AccessInsertResponse = {
  __typename?: "employee_contact_accessInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Employee_Contact_Access>;
};

export type Employee_Contact_AccessOrderBy = {
  contact_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  granted_by?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Employee_Contact_AccessUpdateInput = {
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  granted_by?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Employee_Contact_AccessUpdateResponse = {
  __typename?: "employee_contact_accessUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Employee_Contact_Access>;
};

export type Entity_Automation_Config = Node & {
  __typename?: "entity_automation_config";
  app_users?: Maybe<App_Users>;
  assigned_user_ids?: Maybe<Array<Maybe<Scalars["UUID"]["output"]>>>;
  automation_kind: Scalars["String"]["output"];
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  created_by?: Maybe<Scalars["UUID"]["output"]>;
  day_of_week?: Maybe<Scalars["Int"]["output"]>;
  enabled?: Maybe<Scalars["Boolean"]["output"]>;
  entity_id: Scalars["UUID"]["output"];
  entity_type: Scalars["String"]["output"];
  frequency?: Maybe<Scalars["String"]["output"]>;
  goal_config?: Maybe<Scalars["JSON"]["output"]>;
  goal_last_evaluated_at?: Maybe<Scalars["Datetime"]["output"]>;
  goal_last_posted_date?: Maybe<Scalars["Date"]["output"]>;
  goal_last_status?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  priority?: Maybe<Scalars["String"]["output"]>;
  run_on_business_days_only?: Maybe<Scalars["Boolean"]["output"]>;
  selected_days_of_week?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  tags?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  task_description_template?: Maybe<Scalars["String"]["output"]>;
  task_title_fixed?: Maybe<Scalars["String"]["output"]>;
  task_title_template?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  use_title_template?: Maybe<Scalars["Boolean"]["output"]>;
};

export type Entity_Automation_ConfigConnection = {
  __typename?: "entity_automation_configConnection";
  edges: Array<Entity_Automation_ConfigEdge>;
  pageInfo: PageInfo;
};

export type Entity_Automation_ConfigDeleteResponse = {
  __typename?: "entity_automation_configDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Entity_Automation_Config>;
};

export type Entity_Automation_ConfigEdge = {
  __typename?: "entity_automation_configEdge";
  cursor: Scalars["String"]["output"];
  node: Entity_Automation_Config;
};

export type Entity_Automation_ConfigFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Entity_Automation_ConfigFilter>>;
  assigned_user_ids?: InputMaybe<UuidListFilter>;
  automation_kind?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  day_of_week?: InputMaybe<IntFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  entity_id?: InputMaybe<UuidFilter>;
  entity_type?: InputMaybe<StringFilter>;
  frequency?: InputMaybe<StringFilter>;
  goal_last_evaluated_at?: InputMaybe<DatetimeFilter>;
  goal_last_posted_date?: InputMaybe<DateFilter>;
  goal_last_status?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Entity_Automation_ConfigFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Entity_Automation_ConfigFilter>>;
  priority?: InputMaybe<StringFilter>;
  run_on_business_days_only?: InputMaybe<BooleanFilter>;
  selected_days_of_week?: InputMaybe<IntListFilter>;
  tags?: InputMaybe<StringListFilter>;
  task_description_template?: InputMaybe<StringFilter>;
  task_title_fixed?: InputMaybe<StringFilter>;
  task_title_template?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  use_title_template?: InputMaybe<BooleanFilter>;
};

export type Entity_Automation_ConfigInsertInput = {
  assigned_user_ids?: InputMaybe<Array<InputMaybe<Scalars["UUID"]["input"]>>>;
  automation_kind?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  day_of_week?: InputMaybe<Scalars["Int"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  entity_id?: InputMaybe<Scalars["UUID"]["input"]>;
  entity_type?: InputMaybe<Scalars["String"]["input"]>;
  frequency?: InputMaybe<Scalars["String"]["input"]>;
  goal_config?: InputMaybe<Scalars["JSON"]["input"]>;
  goal_last_evaluated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  goal_last_posted_date?: InputMaybe<Scalars["Date"]["input"]>;
  goal_last_status?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  priority?: InputMaybe<Scalars["String"]["input"]>;
  run_on_business_days_only?: InputMaybe<Scalars["Boolean"]["input"]>;
  selected_days_of_week?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  task_description_template?: InputMaybe<Scalars["String"]["input"]>;
  task_title_fixed?: InputMaybe<Scalars["String"]["input"]>;
  task_title_template?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  use_title_template?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type Entity_Automation_ConfigInsertResponse = {
  __typename?: "entity_automation_configInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Entity_Automation_Config>;
};

export type Entity_Automation_ConfigOrderBy = {
  automation_kind?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  day_of_week?: InputMaybe<OrderByDirection>;
  enabled?: InputMaybe<OrderByDirection>;
  entity_id?: InputMaybe<OrderByDirection>;
  entity_type?: InputMaybe<OrderByDirection>;
  frequency?: InputMaybe<OrderByDirection>;
  goal_last_evaluated_at?: InputMaybe<OrderByDirection>;
  goal_last_posted_date?: InputMaybe<OrderByDirection>;
  goal_last_status?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  priority?: InputMaybe<OrderByDirection>;
  run_on_business_days_only?: InputMaybe<OrderByDirection>;
  task_description_template?: InputMaybe<OrderByDirection>;
  task_title_fixed?: InputMaybe<OrderByDirection>;
  task_title_template?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  use_title_template?: InputMaybe<OrderByDirection>;
};

export type Entity_Automation_ConfigUpdateInput = {
  assigned_user_ids?: InputMaybe<Array<InputMaybe<Scalars["UUID"]["input"]>>>;
  automation_kind?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  day_of_week?: InputMaybe<Scalars["Int"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  entity_id?: InputMaybe<Scalars["UUID"]["input"]>;
  entity_type?: InputMaybe<Scalars["String"]["input"]>;
  frequency?: InputMaybe<Scalars["String"]["input"]>;
  goal_config?: InputMaybe<Scalars["JSON"]["input"]>;
  goal_last_evaluated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  goal_last_posted_date?: InputMaybe<Scalars["Date"]["input"]>;
  goal_last_status?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  priority?: InputMaybe<Scalars["String"]["input"]>;
  run_on_business_days_only?: InputMaybe<Scalars["Boolean"]["input"]>;
  selected_days_of_week?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  task_description_template?: InputMaybe<Scalars["String"]["input"]>;
  task_title_fixed?: InputMaybe<Scalars["String"]["input"]>;
  task_title_template?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  use_title_template?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type Entity_Automation_ConfigUpdateResponse = {
  __typename?: "entity_automation_configUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Entity_Automation_Config>;
};

export type Gemini_Notes_Sync = Node & {
  __typename?: "gemini_notes_sync";
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  doc_created_at?: Maybe<Scalars["Datetime"]["output"]>;
  doc_modified_at?: Maybe<Scalars["Datetime"]["output"]>;
  doc_title?: Maybe<Scalars["String"]["output"]>;
  doc_url?: Maybe<Scalars["String"]["output"]>;
  file_id: Scalars["String"]["output"];
  matched_entity_id?: Maybe<Scalars["UUID"]["output"]>;
  matched_entity_type?: Maybe<Scalars["String"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  organizer_email: Scalars["String"]["output"];
  posted_at?: Maybe<Scalars["Datetime"]["output"]>;
  slack_canvas_id?: Maybe<Scalars["String"]["output"]>;
  slack_canvas_url?: Maybe<Scalars["String"]["output"]>;
  slack_channel_id?: Maybe<Scalars["String"]["output"]>;
  slack_ts?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type Gemini_Notes_SyncConnection = {
  __typename?: "gemini_notes_syncConnection";
  edges: Array<Gemini_Notes_SyncEdge>;
  pageInfo: PageInfo;
};

export type Gemini_Notes_SyncDeleteResponse = {
  __typename?: "gemini_notes_syncDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Gemini_Notes_Sync>;
};

export type Gemini_Notes_SyncEdge = {
  __typename?: "gemini_notes_syncEdge";
  cursor: Scalars["String"]["output"];
  node: Gemini_Notes_Sync;
};

export type Gemini_Notes_SyncFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Gemini_Notes_SyncFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  doc_created_at?: InputMaybe<DatetimeFilter>;
  doc_modified_at?: InputMaybe<DatetimeFilter>;
  doc_title?: InputMaybe<StringFilter>;
  doc_url?: InputMaybe<StringFilter>;
  file_id?: InputMaybe<StringFilter>;
  matched_entity_id?: InputMaybe<UuidFilter>;
  matched_entity_type?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Gemini_Notes_SyncFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Gemini_Notes_SyncFilter>>;
  organizer_email?: InputMaybe<StringFilter>;
  posted_at?: InputMaybe<DatetimeFilter>;
  slack_canvas_id?: InputMaybe<StringFilter>;
  slack_canvas_url?: InputMaybe<StringFilter>;
  slack_channel_id?: InputMaybe<StringFilter>;
  slack_ts?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Gemini_Notes_SyncInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  doc_created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  doc_modified_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  doc_title?: InputMaybe<Scalars["String"]["input"]>;
  doc_url?: InputMaybe<Scalars["String"]["input"]>;
  file_id?: InputMaybe<Scalars["String"]["input"]>;
  matched_entity_id?: InputMaybe<Scalars["UUID"]["input"]>;
  matched_entity_type?: InputMaybe<Scalars["String"]["input"]>;
  organizer_email?: InputMaybe<Scalars["String"]["input"]>;
  posted_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  slack_canvas_id?: InputMaybe<Scalars["String"]["input"]>;
  slack_canvas_url?: InputMaybe<Scalars["String"]["input"]>;
  slack_channel_id?: InputMaybe<Scalars["String"]["input"]>;
  slack_ts?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Gemini_Notes_SyncInsertResponse = {
  __typename?: "gemini_notes_syncInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Gemini_Notes_Sync>;
};

export type Gemini_Notes_SyncOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  doc_created_at?: InputMaybe<OrderByDirection>;
  doc_modified_at?: InputMaybe<OrderByDirection>;
  doc_title?: InputMaybe<OrderByDirection>;
  doc_url?: InputMaybe<OrderByDirection>;
  file_id?: InputMaybe<OrderByDirection>;
  matched_entity_id?: InputMaybe<OrderByDirection>;
  matched_entity_type?: InputMaybe<OrderByDirection>;
  organizer_email?: InputMaybe<OrderByDirection>;
  posted_at?: InputMaybe<OrderByDirection>;
  slack_canvas_id?: InputMaybe<OrderByDirection>;
  slack_canvas_url?: InputMaybe<OrderByDirection>;
  slack_channel_id?: InputMaybe<OrderByDirection>;
  slack_ts?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Gemini_Notes_SyncUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  doc_created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  doc_modified_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  doc_title?: InputMaybe<Scalars["String"]["input"]>;
  doc_url?: InputMaybe<Scalars["String"]["input"]>;
  file_id?: InputMaybe<Scalars["String"]["input"]>;
  matched_entity_id?: InputMaybe<Scalars["UUID"]["input"]>;
  matched_entity_type?: InputMaybe<Scalars["String"]["input"]>;
  organizer_email?: InputMaybe<Scalars["String"]["input"]>;
  posted_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  slack_canvas_id?: InputMaybe<Scalars["String"]["input"]>;
  slack_canvas_url?: InputMaybe<Scalars["String"]["input"]>;
  slack_channel_id?: InputMaybe<Scalars["String"]["input"]>;
  slack_ts?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Gemini_Notes_SyncUpdateResponse = {
  __typename?: "gemini_notes_syncUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Gemini_Notes_Sync>;
};

export type Generic_Email_Domains = Node & {
  __typename?: "generic_email_domains";
  blocked_as_company_domain: Scalars["Boolean"]["output"];
  created_at: Scalars["Datetime"]["output"];
  domain: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
};

export type Generic_Email_DomainsConnection = {
  __typename?: "generic_email_domainsConnection";
  edges: Array<Generic_Email_DomainsEdge>;
  pageInfo: PageInfo;
};

export type Generic_Email_DomainsDeleteResponse = {
  __typename?: "generic_email_domainsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Generic_Email_Domains>;
};

export type Generic_Email_DomainsEdge = {
  __typename?: "generic_email_domainsEdge";
  cursor: Scalars["String"]["output"];
  node: Generic_Email_Domains;
};

export type Generic_Email_DomainsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Generic_Email_DomainsFilter>>;
  blocked_as_company_domain?: InputMaybe<BooleanFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  domain?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Generic_Email_DomainsFilter>;
  note?: InputMaybe<StringFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Generic_Email_DomainsFilter>>;
};

export type Generic_Email_DomainsInsertInput = {
  blocked_as_company_domain?: InputMaybe<Scalars["Boolean"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  domain?: InputMaybe<Scalars["String"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
};

export type Generic_Email_DomainsInsertResponse = {
  __typename?: "generic_email_domainsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Generic_Email_Domains>;
};

export type Generic_Email_DomainsOrderBy = {
  blocked_as_company_domain?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  domain?: InputMaybe<OrderByDirection>;
  note?: InputMaybe<OrderByDirection>;
};

export type Generic_Email_DomainsUpdateInput = {
  blocked_as_company_domain?: InputMaybe<Scalars["Boolean"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  domain?: InputMaybe<Scalars["String"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
};

export type Generic_Email_DomainsUpdateResponse = {
  __typename?: "generic_email_domainsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Generic_Email_Domains>;
};

export type Google_Drive_Access_Grants = Node & {
  __typename?: "google_drive_access_grants";
  app_users?: Maybe<App_Users>;
  created_at: Scalars["Datetime"]["output"];
  expires_at: Scalars["Datetime"]["output"];
  granted_by?: Maybe<Scalars["UUID"]["output"]>;
  grantee_email: Scalars["String"]["output"];
  grantor_email: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  revoked_at?: Maybe<Scalars["Datetime"]["output"]>;
  scope: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
};

export type Google_Drive_Access_GrantsConnection = {
  __typename?: "google_drive_access_grantsConnection";
  edges: Array<Google_Drive_Access_GrantsEdge>;
  pageInfo: PageInfo;
};

export type Google_Drive_Access_GrantsDeleteResponse = {
  __typename?: "google_drive_access_grantsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Google_Drive_Access_Grants>;
};

export type Google_Drive_Access_GrantsEdge = {
  __typename?: "google_drive_access_grantsEdge";
  cursor: Scalars["String"]["output"];
  node: Google_Drive_Access_Grants;
};

export type Google_Drive_Access_GrantsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Google_Drive_Access_GrantsFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  expires_at?: InputMaybe<DatetimeFilter>;
  granted_by?: InputMaybe<UuidFilter>;
  grantee_email?: InputMaybe<StringFilter>;
  grantor_email?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Google_Drive_Access_GrantsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Google_Drive_Access_GrantsFilter>>;
  revoked_at?: InputMaybe<DatetimeFilter>;
  scope?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Google_Drive_Access_GrantsInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  expires_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  granted_by?: InputMaybe<Scalars["UUID"]["input"]>;
  grantee_email?: InputMaybe<Scalars["String"]["input"]>;
  grantor_email?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  revoked_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  scope?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Google_Drive_Access_GrantsInsertResponse = {
  __typename?: "google_drive_access_grantsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Google_Drive_Access_Grants>;
};

export type Google_Drive_Access_GrantsOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  expires_at?: InputMaybe<OrderByDirection>;
  granted_by?: InputMaybe<OrderByDirection>;
  grantee_email?: InputMaybe<OrderByDirection>;
  grantor_email?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  revoked_at?: InputMaybe<OrderByDirection>;
  scope?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Google_Drive_Access_GrantsUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  expires_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  granted_by?: InputMaybe<Scalars["UUID"]["input"]>;
  grantee_email?: InputMaybe<Scalars["String"]["input"]>;
  grantor_email?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  revoked_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  scope?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Google_Drive_Access_GrantsUpdateResponse = {
  __typename?: "google_drive_access_grantsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Google_Drive_Access_Grants>;
};

export type Google_Group_Enrollments = Node & {
  __typename?: "google_group_enrollments";
  app_users?: Maybe<App_Users>;
  auto_provision_opt_out: Scalars["Boolean"]["output"];
  companies?: Maybe<Companies>;
  company_id: Scalars["UUID"]["output"];
  contact_id?: Maybe<Scalars["UUID"]["output"]>;
  contacts?: Maybe<Contacts>;
  created_at: Scalars["Datetime"]["output"];
  created_by?: Maybe<Scalars["UUID"]["output"]>;
  enabled: Scalars["Boolean"]["output"];
  group_email: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  notes?: Maybe<Scalars["String"]["output"]>;
  slack_channel_id?: Maybe<Scalars["String"]["output"]>;
  updated_at: Scalars["Datetime"]["output"];
};

export type Google_Group_EnrollmentsConnection = {
  __typename?: "google_group_enrollmentsConnection";
  edges: Array<Google_Group_EnrollmentsEdge>;
  pageInfo: PageInfo;
};

export type Google_Group_EnrollmentsDeleteResponse = {
  __typename?: "google_group_enrollmentsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Google_Group_Enrollments>;
};

export type Google_Group_EnrollmentsEdge = {
  __typename?: "google_group_enrollmentsEdge";
  cursor: Scalars["String"]["output"];
  node: Google_Group_Enrollments;
};

export type Google_Group_EnrollmentsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Google_Group_EnrollmentsFilter>>;
  auto_provision_opt_out?: InputMaybe<BooleanFilter>;
  company_id?: InputMaybe<UuidFilter>;
  contact_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  group_email?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Google_Group_EnrollmentsFilter>;
  notes?: InputMaybe<StringFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Google_Group_EnrollmentsFilter>>;
  slack_channel_id?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Google_Group_EnrollmentsInsertInput = {
  auto_provision_opt_out?: InputMaybe<Scalars["Boolean"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  group_email?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  slack_channel_id?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Google_Group_EnrollmentsInsertResponse = {
  __typename?: "google_group_enrollmentsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Google_Group_Enrollments>;
};

export type Google_Group_EnrollmentsOrderBy = {
  auto_provision_opt_out?: InputMaybe<OrderByDirection>;
  company_id?: InputMaybe<OrderByDirection>;
  contact_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  enabled?: InputMaybe<OrderByDirection>;
  group_email?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  notes?: InputMaybe<OrderByDirection>;
  slack_channel_id?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Google_Group_EnrollmentsUpdateInput = {
  auto_provision_opt_out?: InputMaybe<Scalars["Boolean"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  group_email?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  slack_channel_id?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Google_Group_EnrollmentsUpdateResponse = {
  __typename?: "google_group_enrollmentsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Google_Group_Enrollments>;
};

export type Inbound_Sender_Rules = Node & {
  __typename?: "inbound_sender_rules";
  active: Scalars["Boolean"]["output"];
  app_users?: Maybe<App_Users>;
  auto_assign_to?: Maybe<Scalars["String"]["output"]>;
  companies?: Maybe<Companies>;
  company_id?: Maybe<Scalars["UUID"]["output"]>;
  company_name?: Maybe<Scalars["String"]["output"]>;
  contact_id?: Maybe<Scalars["UUID"]["output"]>;
  contacts?: Maybe<Contacts>;
  created_at: Scalars["Datetime"]["output"];
  created_by?: Maybe<Scalars["UUID"]["output"]>;
  default_priority?: Maybe<Scalars["String"]["output"]>;
  domain: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  match_type: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  notes?: Maybe<Scalars["String"]["output"]>;
  sla_hours?: Maybe<Scalars["Int"]["output"]>;
  subject_pattern?: Maybe<Scalars["String"]["output"]>;
  updated_at: Scalars["Datetime"]["output"];
};

export type Inbound_Sender_RulesConnection = {
  __typename?: "inbound_sender_rulesConnection";
  edges: Array<Inbound_Sender_RulesEdge>;
  pageInfo: PageInfo;
};

export type Inbound_Sender_RulesDeleteResponse = {
  __typename?: "inbound_sender_rulesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Inbound_Sender_Rules>;
};

export type Inbound_Sender_RulesEdge = {
  __typename?: "inbound_sender_rulesEdge";
  cursor: Scalars["String"]["output"];
  node: Inbound_Sender_Rules;
};

export type Inbound_Sender_RulesFilter = {
  active?: InputMaybe<BooleanFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Inbound_Sender_RulesFilter>>;
  auto_assign_to?: InputMaybe<StringFilter>;
  company_id?: InputMaybe<UuidFilter>;
  company_name?: InputMaybe<StringFilter>;
  contact_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  default_priority?: InputMaybe<StringFilter>;
  domain?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  match_type?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Inbound_Sender_RulesFilter>;
  notes?: InputMaybe<StringFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Inbound_Sender_RulesFilter>>;
  sla_hours?: InputMaybe<IntFilter>;
  subject_pattern?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Inbound_Sender_RulesInsertInput = {
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  auto_assign_to?: InputMaybe<Scalars["String"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  company_name?: InputMaybe<Scalars["String"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  default_priority?: InputMaybe<Scalars["String"]["input"]>;
  domain?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  match_type?: InputMaybe<Scalars["String"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  sla_hours?: InputMaybe<Scalars["Int"]["input"]>;
  subject_pattern?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Inbound_Sender_RulesInsertResponse = {
  __typename?: "inbound_sender_rulesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Inbound_Sender_Rules>;
};

export type Inbound_Sender_RulesOrderBy = {
  active?: InputMaybe<OrderByDirection>;
  auto_assign_to?: InputMaybe<OrderByDirection>;
  company_id?: InputMaybe<OrderByDirection>;
  company_name?: InputMaybe<OrderByDirection>;
  contact_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  default_priority?: InputMaybe<OrderByDirection>;
  domain?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  match_type?: InputMaybe<OrderByDirection>;
  notes?: InputMaybe<OrderByDirection>;
  sla_hours?: InputMaybe<OrderByDirection>;
  subject_pattern?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Inbound_Sender_RulesUpdateInput = {
  active?: InputMaybe<Scalars["Boolean"]["input"]>;
  auto_assign_to?: InputMaybe<Scalars["String"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  company_name?: InputMaybe<Scalars["String"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  default_priority?: InputMaybe<Scalars["String"]["input"]>;
  domain?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  match_type?: InputMaybe<Scalars["String"]["input"]>;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  sla_hours?: InputMaybe<Scalars["Int"]["input"]>;
  subject_pattern?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Inbound_Sender_RulesUpdateResponse = {
  __typename?: "inbound_sender_rulesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Inbound_Sender_Rules>;
};

export type Invoice_Dunning_Log = Node & {
  __typename?: "invoice_dunning_log";
  action: Scalars["String"]["output"];
  amount?: Maybe<Scalars["BigFloat"]["output"]>;
  channel?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Datetime"]["output"];
  created_by?: Maybe<Scalars["UUID"]["output"]>;
  customer_id?: Maybe<Scalars["String"]["output"]>;
  customer_name?: Maybe<Scalars["String"]["output"]>;
  cycle: Scalars["Int"]["output"];
  days_overdue?: Maybe<Scalars["Int"]["output"]>;
  doc_number?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  invoice_id: Scalars["String"]["output"];
  metadata: Scalars["JSON"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  realm_id: Scalars["String"]["output"];
  stage: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
};

export type Invoice_Dunning_LogConnection = {
  __typename?: "invoice_dunning_logConnection";
  edges: Array<Invoice_Dunning_LogEdge>;
  pageInfo: PageInfo;
};

export type Invoice_Dunning_LogDeleteResponse = {
  __typename?: "invoice_dunning_logDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Invoice_Dunning_Log>;
};

export type Invoice_Dunning_LogEdge = {
  __typename?: "invoice_dunning_logEdge";
  cursor: Scalars["String"]["output"];
  node: Invoice_Dunning_Log;
};

export type Invoice_Dunning_LogFilter = {
  action?: InputMaybe<StringFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Invoice_Dunning_LogFilter>>;
  channel?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  customer_id?: InputMaybe<StringFilter>;
  customer_name?: InputMaybe<StringFilter>;
  cycle?: InputMaybe<IntFilter>;
  days_overdue?: InputMaybe<IntFilter>;
  doc_number?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  invoice_id?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Invoice_Dunning_LogFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Invoice_Dunning_LogFilter>>;
  realm_id?: InputMaybe<StringFilter>;
  stage?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Invoice_Dunning_LogInsertInput = {
  action?: InputMaybe<Scalars["String"]["input"]>;
  amount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  channel?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  customer_id?: InputMaybe<Scalars["String"]["input"]>;
  customer_name?: InputMaybe<Scalars["String"]["input"]>;
  cycle?: InputMaybe<Scalars["Int"]["input"]>;
  days_overdue?: InputMaybe<Scalars["Int"]["input"]>;
  doc_number?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  invoice_id?: InputMaybe<Scalars["String"]["input"]>;
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  realm_id?: InputMaybe<Scalars["String"]["input"]>;
  stage?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Invoice_Dunning_LogInsertResponse = {
  __typename?: "invoice_dunning_logInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Invoice_Dunning_Log>;
};

export type Invoice_Dunning_LogOrderBy = {
  action?: InputMaybe<OrderByDirection>;
  amount?: InputMaybe<OrderByDirection>;
  channel?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  customer_id?: InputMaybe<OrderByDirection>;
  customer_name?: InputMaybe<OrderByDirection>;
  cycle?: InputMaybe<OrderByDirection>;
  days_overdue?: InputMaybe<OrderByDirection>;
  doc_number?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  invoice_id?: InputMaybe<OrderByDirection>;
  realm_id?: InputMaybe<OrderByDirection>;
  stage?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Invoice_Dunning_LogUpdateInput = {
  action?: InputMaybe<Scalars["String"]["input"]>;
  amount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  channel?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  customer_id?: InputMaybe<Scalars["String"]["input"]>;
  customer_name?: InputMaybe<Scalars["String"]["input"]>;
  cycle?: InputMaybe<Scalars["Int"]["input"]>;
  days_overdue?: InputMaybe<Scalars["Int"]["input"]>;
  doc_number?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  invoice_id?: InputMaybe<Scalars["String"]["input"]>;
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  realm_id?: InputMaybe<Scalars["String"]["input"]>;
  stage?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Invoice_Dunning_LogUpdateResponse = {
  __typename?: "invoice_dunning_logUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Invoice_Dunning_Log>;
};

export type Ios_Metric_Payloads = Node & {
  __typename?: "ios_metric_payloads";
  app_users?: Maybe<App_Users>;
  app_version?: Maybe<Scalars["String"]["output"]>;
  average_suspended_memory_bytes?: Maybe<Scalars["BigInt"]["output"]>;
  background_crash_count?: Maybe<Scalars["Int"]["output"]>;
  background_memory_kill_count?: Maybe<Scalars["Int"]["output"]>;
  background_task_timeout_count?: Maybe<Scalars["Int"]["output"]>;
  background_watchdog_count?: Maybe<Scalars["Int"]["output"]>;
  cellular_download_bytes?: Maybe<Scalars["BigInt"]["output"]>;
  cellular_upload_bytes?: Maybe<Scalars["BigInt"]["output"]>;
  created_at: Scalars["Datetime"]["output"];
  cumulative_cpu_time_ms?: Maybe<Scalars["BigInt"]["output"]>;
  cumulative_logical_writes_bytes?: Maybe<Scalars["BigInt"]["output"]>;
  device_model?: Maybe<Scalars["String"]["output"]>;
  foreground_crash_count?: Maybe<Scalars["Int"]["output"]>;
  foreground_memory_kill_count?: Maybe<Scalars["Int"]["output"]>;
  foreground_session_count?: Maybe<Scalars["Int"]["output"]>;
  foreground_watchdog_count?: Maybe<Scalars["Int"]["output"]>;
  hang_time_p50_ms?: Maybe<Scalars["Int"]["output"]>;
  hang_time_p90_ms?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["UUID"]["output"];
  install_id: Scalars["String"]["output"];
  kind: Scalars["String"]["output"];
  launch_time_p50_ms?: Maybe<Scalars["Int"]["output"]>;
  launch_time_p90_ms?: Maybe<Scalars["Int"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  normal_exit_count?: Maybe<Scalars["Int"]["output"]>;
  os_version?: Maybe<Scalars["String"]["output"]>;
  payload: Scalars["JSON"]["output"];
  peak_memory_bytes?: Maybe<Scalars["BigInt"]["output"]>;
  period_end: Scalars["Datetime"]["output"];
  period_start: Scalars["Datetime"]["output"];
  resume_time_p50_ms?: Maybe<Scalars["Int"]["output"]>;
  resume_time_p90_ms?: Maybe<Scalars["Int"]["output"]>;
  scroll_hitch_time_ratio_ppm?: Maybe<Scalars["Int"]["output"]>;
  surface_counts: Scalars["JSON"]["output"];
  user_id: Scalars["UUID"]["output"];
  wifi_download_bytes?: Maybe<Scalars["BigInt"]["output"]>;
  wifi_upload_bytes?: Maybe<Scalars["BigInt"]["output"]>;
};

export type Ios_Metric_PayloadsConnection = {
  __typename?: "ios_metric_payloadsConnection";
  edges: Array<Ios_Metric_PayloadsEdge>;
  pageInfo: PageInfo;
};

export type Ios_Metric_PayloadsDeleteResponse = {
  __typename?: "ios_metric_payloadsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Ios_Metric_Payloads>;
};

export type Ios_Metric_PayloadsEdge = {
  __typename?: "ios_metric_payloadsEdge";
  cursor: Scalars["String"]["output"];
  node: Ios_Metric_Payloads;
};

export type Ios_Metric_PayloadsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Ios_Metric_PayloadsFilter>>;
  app_version?: InputMaybe<StringFilter>;
  average_suspended_memory_bytes?: InputMaybe<BigIntFilter>;
  background_crash_count?: InputMaybe<IntFilter>;
  background_memory_kill_count?: InputMaybe<IntFilter>;
  background_task_timeout_count?: InputMaybe<IntFilter>;
  background_watchdog_count?: InputMaybe<IntFilter>;
  cellular_download_bytes?: InputMaybe<BigIntFilter>;
  cellular_upload_bytes?: InputMaybe<BigIntFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  cumulative_cpu_time_ms?: InputMaybe<BigIntFilter>;
  cumulative_logical_writes_bytes?: InputMaybe<BigIntFilter>;
  device_model?: InputMaybe<StringFilter>;
  foreground_crash_count?: InputMaybe<IntFilter>;
  foreground_memory_kill_count?: InputMaybe<IntFilter>;
  foreground_session_count?: InputMaybe<IntFilter>;
  foreground_watchdog_count?: InputMaybe<IntFilter>;
  hang_time_p50_ms?: InputMaybe<IntFilter>;
  hang_time_p90_ms?: InputMaybe<IntFilter>;
  id?: InputMaybe<UuidFilter>;
  install_id?: InputMaybe<StringFilter>;
  kind?: InputMaybe<StringFilter>;
  launch_time_p50_ms?: InputMaybe<IntFilter>;
  launch_time_p90_ms?: InputMaybe<IntFilter>;
  nodeId?: InputMaybe<IdFilter>;
  normal_exit_count?: InputMaybe<IntFilter>;
  /** Negates a filter */
  not?: InputMaybe<Ios_Metric_PayloadsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Ios_Metric_PayloadsFilter>>;
  os_version?: InputMaybe<StringFilter>;
  peak_memory_bytes?: InputMaybe<BigIntFilter>;
  period_end?: InputMaybe<DatetimeFilter>;
  period_start?: InputMaybe<DatetimeFilter>;
  resume_time_p50_ms?: InputMaybe<IntFilter>;
  resume_time_p90_ms?: InputMaybe<IntFilter>;
  scroll_hitch_time_ratio_ppm?: InputMaybe<IntFilter>;
  user_id?: InputMaybe<UuidFilter>;
  wifi_download_bytes?: InputMaybe<BigIntFilter>;
  wifi_upload_bytes?: InputMaybe<BigIntFilter>;
};

export type Ios_Metric_PayloadsInsertInput = {
  app_version?: InputMaybe<Scalars["String"]["input"]>;
  average_suspended_memory_bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
  background_crash_count?: InputMaybe<Scalars["Int"]["input"]>;
  background_memory_kill_count?: InputMaybe<Scalars["Int"]["input"]>;
  background_task_timeout_count?: InputMaybe<Scalars["Int"]["input"]>;
  background_watchdog_count?: InputMaybe<Scalars["Int"]["input"]>;
  cellular_download_bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
  cellular_upload_bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  cumulative_cpu_time_ms?: InputMaybe<Scalars["BigInt"]["input"]>;
  cumulative_logical_writes_bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
  device_model?: InputMaybe<Scalars["String"]["input"]>;
  foreground_crash_count?: InputMaybe<Scalars["Int"]["input"]>;
  foreground_memory_kill_count?: InputMaybe<Scalars["Int"]["input"]>;
  foreground_session_count?: InputMaybe<Scalars["Int"]["input"]>;
  foreground_watchdog_count?: InputMaybe<Scalars["Int"]["input"]>;
  hang_time_p50_ms?: InputMaybe<Scalars["Int"]["input"]>;
  hang_time_p90_ms?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  install_id?: InputMaybe<Scalars["String"]["input"]>;
  kind?: InputMaybe<Scalars["String"]["input"]>;
  launch_time_p50_ms?: InputMaybe<Scalars["Int"]["input"]>;
  launch_time_p90_ms?: InputMaybe<Scalars["Int"]["input"]>;
  normal_exit_count?: InputMaybe<Scalars["Int"]["input"]>;
  os_version?: InputMaybe<Scalars["String"]["input"]>;
  payload?: InputMaybe<Scalars["JSON"]["input"]>;
  peak_memory_bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
  period_end?: InputMaybe<Scalars["Datetime"]["input"]>;
  period_start?: InputMaybe<Scalars["Datetime"]["input"]>;
  resume_time_p50_ms?: InputMaybe<Scalars["Int"]["input"]>;
  resume_time_p90_ms?: InputMaybe<Scalars["Int"]["input"]>;
  scroll_hitch_time_ratio_ppm?: InputMaybe<Scalars["Int"]["input"]>;
  surface_counts?: InputMaybe<Scalars["JSON"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
  wifi_download_bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
  wifi_upload_bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
};

export type Ios_Metric_PayloadsInsertResponse = {
  __typename?: "ios_metric_payloadsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Ios_Metric_Payloads>;
};

export type Ios_Metric_PayloadsOrderBy = {
  app_version?: InputMaybe<OrderByDirection>;
  average_suspended_memory_bytes?: InputMaybe<OrderByDirection>;
  background_crash_count?: InputMaybe<OrderByDirection>;
  background_memory_kill_count?: InputMaybe<OrderByDirection>;
  background_task_timeout_count?: InputMaybe<OrderByDirection>;
  background_watchdog_count?: InputMaybe<OrderByDirection>;
  cellular_download_bytes?: InputMaybe<OrderByDirection>;
  cellular_upload_bytes?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  cumulative_cpu_time_ms?: InputMaybe<OrderByDirection>;
  cumulative_logical_writes_bytes?: InputMaybe<OrderByDirection>;
  device_model?: InputMaybe<OrderByDirection>;
  foreground_crash_count?: InputMaybe<OrderByDirection>;
  foreground_memory_kill_count?: InputMaybe<OrderByDirection>;
  foreground_session_count?: InputMaybe<OrderByDirection>;
  foreground_watchdog_count?: InputMaybe<OrderByDirection>;
  hang_time_p50_ms?: InputMaybe<OrderByDirection>;
  hang_time_p90_ms?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  install_id?: InputMaybe<OrderByDirection>;
  kind?: InputMaybe<OrderByDirection>;
  launch_time_p50_ms?: InputMaybe<OrderByDirection>;
  launch_time_p90_ms?: InputMaybe<OrderByDirection>;
  normal_exit_count?: InputMaybe<OrderByDirection>;
  os_version?: InputMaybe<OrderByDirection>;
  peak_memory_bytes?: InputMaybe<OrderByDirection>;
  period_end?: InputMaybe<OrderByDirection>;
  period_start?: InputMaybe<OrderByDirection>;
  resume_time_p50_ms?: InputMaybe<OrderByDirection>;
  resume_time_p90_ms?: InputMaybe<OrderByDirection>;
  scroll_hitch_time_ratio_ppm?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
  wifi_download_bytes?: InputMaybe<OrderByDirection>;
  wifi_upload_bytes?: InputMaybe<OrderByDirection>;
};

export type Ios_Metric_PayloadsUpdateInput = {
  app_version?: InputMaybe<Scalars["String"]["input"]>;
  average_suspended_memory_bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
  background_crash_count?: InputMaybe<Scalars["Int"]["input"]>;
  background_memory_kill_count?: InputMaybe<Scalars["Int"]["input"]>;
  background_task_timeout_count?: InputMaybe<Scalars["Int"]["input"]>;
  background_watchdog_count?: InputMaybe<Scalars["Int"]["input"]>;
  cellular_download_bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
  cellular_upload_bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  cumulative_cpu_time_ms?: InputMaybe<Scalars["BigInt"]["input"]>;
  cumulative_logical_writes_bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
  device_model?: InputMaybe<Scalars["String"]["input"]>;
  foreground_crash_count?: InputMaybe<Scalars["Int"]["input"]>;
  foreground_memory_kill_count?: InputMaybe<Scalars["Int"]["input"]>;
  foreground_session_count?: InputMaybe<Scalars["Int"]["input"]>;
  foreground_watchdog_count?: InputMaybe<Scalars["Int"]["input"]>;
  hang_time_p50_ms?: InputMaybe<Scalars["Int"]["input"]>;
  hang_time_p90_ms?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  install_id?: InputMaybe<Scalars["String"]["input"]>;
  kind?: InputMaybe<Scalars["String"]["input"]>;
  launch_time_p50_ms?: InputMaybe<Scalars["Int"]["input"]>;
  launch_time_p90_ms?: InputMaybe<Scalars["Int"]["input"]>;
  normal_exit_count?: InputMaybe<Scalars["Int"]["input"]>;
  os_version?: InputMaybe<Scalars["String"]["input"]>;
  payload?: InputMaybe<Scalars["JSON"]["input"]>;
  peak_memory_bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
  period_end?: InputMaybe<Scalars["Datetime"]["input"]>;
  period_start?: InputMaybe<Scalars["Datetime"]["input"]>;
  resume_time_p50_ms?: InputMaybe<Scalars["Int"]["input"]>;
  resume_time_p90_ms?: InputMaybe<Scalars["Int"]["input"]>;
  scroll_hitch_time_ratio_ppm?: InputMaybe<Scalars["Int"]["input"]>;
  surface_counts?: InputMaybe<Scalars["JSON"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
  wifi_download_bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
  wifi_upload_bytes?: InputMaybe<Scalars["BigInt"]["input"]>;
};

export type Ios_Metric_PayloadsUpdateResponse = {
  __typename?: "ios_metric_payloadsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Ios_Metric_Payloads>;
};

export type Mail_User_Settings = Node & {
  __typename?: "mail_user_settings";
  app_users?: Maybe<App_Users>;
  away?: Maybe<Scalars["JSON"]["output"]>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  folders: Scalars["JSON"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  rules: Scalars["JSON"]["output"];
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  user_id: Scalars["UUID"]["output"];
};

export type Mail_User_SettingsConnection = {
  __typename?: "mail_user_settingsConnection";
  edges: Array<Mail_User_SettingsEdge>;
  pageInfo: PageInfo;
};

export type Mail_User_SettingsDeleteResponse = {
  __typename?: "mail_user_settingsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Mail_User_Settings>;
};

export type Mail_User_SettingsEdge = {
  __typename?: "mail_user_settingsEdge";
  cursor: Scalars["String"]["output"];
  node: Mail_User_Settings;
};

export type Mail_User_SettingsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Mail_User_SettingsFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Mail_User_SettingsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Mail_User_SettingsFilter>>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Mail_User_SettingsInsertInput = {
  away?: InputMaybe<Scalars["JSON"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  folders?: InputMaybe<Scalars["JSON"]["input"]>;
  rules?: InputMaybe<Scalars["JSON"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Mail_User_SettingsInsertResponse = {
  __typename?: "mail_user_settingsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Mail_User_Settings>;
};

export type Mail_User_SettingsOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Mail_User_SettingsUpdateInput = {
  away?: InputMaybe<Scalars["JSON"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  folders?: InputMaybe<Scalars["JSON"]["input"]>;
  rules?: InputMaybe<Scalars["JSON"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Mail_User_SettingsUpdateResponse = {
  __typename?: "mail_user_settingsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Mail_User_Settings>;
};

export type Marketing_Brands = Node & {
  __typename?: "marketing_brands";
  created_at: Scalars["Datetime"]["output"];
  created_by?: Maybe<Scalars["UUID"]["output"]>;
  display_name: Scalars["String"]["output"];
  drive_root_folder_id?: Maybe<Scalars["String"]["output"]>;
  email: Scalars["JSON"]["output"];
  email_audiencesCollection?: Maybe<Email_AudiencesConnection>;
  email_campaignsCollection?: Maybe<Email_CampaignsConnection>;
  id: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  slack_channel_id?: Maybe<Scalars["String"]["output"]>;
  social_brand_channelsCollection?: Maybe<Social_Brand_ChannelsConnection>;
  social_brand_credentialsCollection?: Maybe<Social_Brand_CredentialsConnection>;
  social_hashtag_groups?: Maybe<Social_Hashtag_Groups>;
  social_media_postsCollection?: Maybe<Social_Media_PostsConnection>;
  sort_order: Scalars["Int"]["output"];
  status: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
  voice: Scalars["JSON"]["output"];
  zapier?: Maybe<Scalars["JSON"]["output"]>;
};

export type Marketing_BrandsEmail_AudiencesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_AudiencesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_AudiencesOrderBy>>;
};

export type Marketing_BrandsEmail_CampaignsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_CampaignsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Email_CampaignsOrderBy>>;
};

export type Marketing_BrandsSocial_Brand_ChannelsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Social_Brand_ChannelsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Social_Brand_ChannelsOrderBy>>;
};

export type Marketing_BrandsSocial_Brand_CredentialsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Social_Brand_CredentialsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Social_Brand_CredentialsOrderBy>>;
};

export type Marketing_BrandsSocial_Media_PostsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Social_Media_PostsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Social_Media_PostsOrderBy>>;
};

export type Marketing_BrandsConnection = {
  __typename?: "marketing_brandsConnection";
  edges: Array<Marketing_BrandsEdge>;
  pageInfo: PageInfo;
};

export type Marketing_BrandsDeleteResponse = {
  __typename?: "marketing_brandsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Marketing_Brands>;
};

export type Marketing_BrandsEdge = {
  __typename?: "marketing_brandsEdge";
  cursor: Scalars["String"]["output"];
  node: Marketing_Brands;
};

export type Marketing_BrandsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Marketing_BrandsFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  display_name?: InputMaybe<StringFilter>;
  drive_root_folder_id?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Marketing_BrandsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Marketing_BrandsFilter>>;
  slack_channel_id?: InputMaybe<StringFilter>;
  sort_order?: InputMaybe<IntFilter>;
  status?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Marketing_BrandsInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  display_name?: InputMaybe<Scalars["String"]["input"]>;
  drive_root_folder_id?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["JSON"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  slack_channel_id?: InputMaybe<Scalars["String"]["input"]>;
  sort_order?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  voice?: InputMaybe<Scalars["JSON"]["input"]>;
  zapier?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type Marketing_BrandsInsertResponse = {
  __typename?: "marketing_brandsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Marketing_Brands>;
};

export type Marketing_BrandsOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  display_name?: InputMaybe<OrderByDirection>;
  drive_root_folder_id?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  slack_channel_id?: InputMaybe<OrderByDirection>;
  sort_order?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Marketing_BrandsUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  display_name?: InputMaybe<Scalars["String"]["input"]>;
  drive_root_folder_id?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["JSON"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  slack_channel_id?: InputMaybe<Scalars["String"]["input"]>;
  sort_order?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  voice?: InputMaybe<Scalars["JSON"]["input"]>;
  zapier?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type Marketing_BrandsUpdateResponse = {
  __typename?: "marketing_brandsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Marketing_Brands>;
};

export type Mcp_Server_Connections = Node & {
  __typename?: "mcp_server_connections";
  app_users?: Maybe<App_Users>;
  auth_type: Scalars["String"]["output"];
  created_at: Scalars["Datetime"]["output"];
  enabled: Scalars["Boolean"]["output"];
  header_name?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  last_connected_at?: Maybe<Scalars["Datetime"]["output"]>;
  last_error?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  oauth_access_token_encrypted?: Maybe<Scalars["String"]["output"]>;
  oauth_authorization_server?: Maybe<Scalars["String"]["output"]>;
  oauth_client_id?: Maybe<Scalars["String"]["output"]>;
  oauth_pkce_verifier_encrypted?: Maybe<Scalars["String"]["output"]>;
  oauth_redirect_uri?: Maybe<Scalars["String"]["output"]>;
  oauth_refresh_token_encrypted?: Maybe<Scalars["String"]["output"]>;
  oauth_scope?: Maybe<Scalars["String"]["output"]>;
  oauth_state?: Maybe<Scalars["String"]["output"]>;
  oauth_token_expires_at?: Maybe<Scalars["Datetime"]["output"]>;
  secret_encrypted?: Maybe<Scalars["String"]["output"]>;
  server_url: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  tool_count?: Maybe<Scalars["Int"]["output"]>;
  transport: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type Mcp_Server_ConnectionsConnection = {
  __typename?: "mcp_server_connectionsConnection";
  edges: Array<Mcp_Server_ConnectionsEdge>;
  pageInfo: PageInfo;
};

export type Mcp_Server_ConnectionsDeleteResponse = {
  __typename?: "mcp_server_connectionsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Mcp_Server_Connections>;
};

export type Mcp_Server_ConnectionsEdge = {
  __typename?: "mcp_server_connectionsEdge";
  cursor: Scalars["String"]["output"];
  node: Mcp_Server_Connections;
};

export type Mcp_Server_ConnectionsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Mcp_Server_ConnectionsFilter>>;
  auth_type?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  header_name?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  last_connected_at?: InputMaybe<DatetimeFilter>;
  last_error?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Mcp_Server_ConnectionsFilter>;
  oauth_access_token_encrypted?: InputMaybe<StringFilter>;
  oauth_authorization_server?: InputMaybe<StringFilter>;
  oauth_client_id?: InputMaybe<StringFilter>;
  oauth_pkce_verifier_encrypted?: InputMaybe<StringFilter>;
  oauth_redirect_uri?: InputMaybe<StringFilter>;
  oauth_refresh_token_encrypted?: InputMaybe<StringFilter>;
  oauth_scope?: InputMaybe<StringFilter>;
  oauth_state?: InputMaybe<StringFilter>;
  oauth_token_expires_at?: InputMaybe<DatetimeFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Mcp_Server_ConnectionsFilter>>;
  secret_encrypted?: InputMaybe<StringFilter>;
  server_url?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  tool_count?: InputMaybe<IntFilter>;
  transport?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Mcp_Server_ConnectionsInsertInput = {
  auth_type?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  header_name?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  last_connected_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_error?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  oauth_access_token_encrypted?: InputMaybe<Scalars["String"]["input"]>;
  oauth_authorization_server?: InputMaybe<Scalars["String"]["input"]>;
  oauth_client_id?: InputMaybe<Scalars["String"]["input"]>;
  oauth_pkce_verifier_encrypted?: InputMaybe<Scalars["String"]["input"]>;
  oauth_redirect_uri?: InputMaybe<Scalars["String"]["input"]>;
  oauth_refresh_token_encrypted?: InputMaybe<Scalars["String"]["input"]>;
  oauth_scope?: InputMaybe<Scalars["String"]["input"]>;
  oauth_state?: InputMaybe<Scalars["String"]["input"]>;
  oauth_token_expires_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  secret_encrypted?: InputMaybe<Scalars["String"]["input"]>;
  server_url?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  tool_count?: InputMaybe<Scalars["Int"]["input"]>;
  transport?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Mcp_Server_ConnectionsInsertResponse = {
  __typename?: "mcp_server_connectionsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Mcp_Server_Connections>;
};

export type Mcp_Server_ConnectionsOrderBy = {
  auth_type?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  enabled?: InputMaybe<OrderByDirection>;
  header_name?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  last_connected_at?: InputMaybe<OrderByDirection>;
  last_error?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  oauth_access_token_encrypted?: InputMaybe<OrderByDirection>;
  oauth_authorization_server?: InputMaybe<OrderByDirection>;
  oauth_client_id?: InputMaybe<OrderByDirection>;
  oauth_pkce_verifier_encrypted?: InputMaybe<OrderByDirection>;
  oauth_redirect_uri?: InputMaybe<OrderByDirection>;
  oauth_refresh_token_encrypted?: InputMaybe<OrderByDirection>;
  oauth_scope?: InputMaybe<OrderByDirection>;
  oauth_state?: InputMaybe<OrderByDirection>;
  oauth_token_expires_at?: InputMaybe<OrderByDirection>;
  secret_encrypted?: InputMaybe<OrderByDirection>;
  server_url?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  tool_count?: InputMaybe<OrderByDirection>;
  transport?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Mcp_Server_ConnectionsUpdateInput = {
  auth_type?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  header_name?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  last_connected_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_error?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  oauth_access_token_encrypted?: InputMaybe<Scalars["String"]["input"]>;
  oauth_authorization_server?: InputMaybe<Scalars["String"]["input"]>;
  oauth_client_id?: InputMaybe<Scalars["String"]["input"]>;
  oauth_pkce_verifier_encrypted?: InputMaybe<Scalars["String"]["input"]>;
  oauth_redirect_uri?: InputMaybe<Scalars["String"]["input"]>;
  oauth_refresh_token_encrypted?: InputMaybe<Scalars["String"]["input"]>;
  oauth_scope?: InputMaybe<Scalars["String"]["input"]>;
  oauth_state?: InputMaybe<Scalars["String"]["input"]>;
  oauth_token_expires_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  secret_encrypted?: InputMaybe<Scalars["String"]["input"]>;
  server_url?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  tool_count?: InputMaybe<Scalars["Int"]["input"]>;
  transport?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Mcp_Server_ConnectionsUpdateResponse = {
  __typename?: "mcp_server_connectionsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Mcp_Server_Connections>;
};

export type Meeting_Status = "cancelled" | "completed" | "rescheduled" | "scheduled";

/** Boolean expression comparing fields on type "meeting_status" */
export type Meeting_StatusFilter = {
  eq?: InputMaybe<Meeting_Status>;
  in?: InputMaybe<Array<Meeting_Status>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Meeting_Status>;
};

export type Meridian_Chat_Summaries = Node & {
  __typename?: "meridian_chat_summaries";
  chat_id: Scalars["String"]["output"];
  created_at: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  key_decisions?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  key_entities?: Maybe<Scalars["JSON"]["output"]>;
  key_topics?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  meridian_chats?: Maybe<Meridian_Chats>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  open_threads?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  summarized_through_count: Scalars["Int"]["output"];
  summary: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type Meridian_Chat_SummariesConnection = {
  __typename?: "meridian_chat_summariesConnection";
  edges: Array<Meridian_Chat_SummariesEdge>;
  pageInfo: PageInfo;
};

export type Meridian_Chat_SummariesDeleteResponse = {
  __typename?: "meridian_chat_summariesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Chat_Summaries>;
};

export type Meridian_Chat_SummariesEdge = {
  __typename?: "meridian_chat_summariesEdge";
  cursor: Scalars["String"]["output"];
  node: Meridian_Chat_Summaries;
};

export type Meridian_Chat_SummariesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Meridian_Chat_SummariesFilter>>;
  chat_id?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  key_decisions?: InputMaybe<StringListFilter>;
  key_topics?: InputMaybe<StringListFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Meridian_Chat_SummariesFilter>;
  open_threads?: InputMaybe<StringListFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Meridian_Chat_SummariesFilter>>;
  summarized_through_count?: InputMaybe<IntFilter>;
  summary?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Meridian_Chat_SummariesInsertInput = {
  chat_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  key_decisions?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  key_entities?: InputMaybe<Scalars["JSON"]["input"]>;
  key_topics?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  open_threads?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  summarized_through_count?: InputMaybe<Scalars["Int"]["input"]>;
  summary?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Meridian_Chat_SummariesInsertResponse = {
  __typename?: "meridian_chat_summariesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Chat_Summaries>;
};

export type Meridian_Chat_SummariesOrderBy = {
  chat_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  summarized_through_count?: InputMaybe<OrderByDirection>;
  summary?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Meridian_Chat_SummariesUpdateInput = {
  chat_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  key_decisions?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  key_entities?: InputMaybe<Scalars["JSON"]["input"]>;
  key_topics?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  open_threads?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  summarized_through_count?: InputMaybe<Scalars["Int"]["input"]>;
  summary?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Meridian_Chat_SummariesUpdateResponse = {
  __typename?: "meridian_chat_summariesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Chat_Summaries>;
};

export type Meridian_Chats = Node & {
  __typename?: "meridian_chats";
  created_at: Scalars["Datetime"]["output"];
  id: Scalars["String"]["output"];
  last_message_at: Scalars["Datetime"]["output"];
  meridian_chat_summaries?: Maybe<Meridian_Chat_Summaries>;
  meridian_messagesCollection?: Maybe<Meridian_MessagesConnection>;
  meridian_tool_approvalsCollection?: Maybe<Meridian_Tool_ApprovalsConnection>;
  meridian_tool_resultsCollection?: Maybe<Meridian_Tool_ResultsConnection>;
  meridian_usage_eventsCollection?: Maybe<Meridian_Usage_EventsConnection>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  original_owner_id?: Maybe<Scalars["UUID"]["output"]>;
  shared_with?: Maybe<Scalars["JSON"]["output"]>;
  status: Scalars["String"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  updated_at: Scalars["Datetime"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type Meridian_ChatsMeridian_MessagesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Meridian_MessagesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Meridian_MessagesOrderBy>>;
};

export type Meridian_ChatsMeridian_Tool_ApprovalsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Meridian_Tool_ApprovalsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Meridian_Tool_ApprovalsOrderBy>>;
};

export type Meridian_ChatsMeridian_Tool_ResultsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Meridian_Tool_ResultsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Meridian_Tool_ResultsOrderBy>>;
};

export type Meridian_ChatsMeridian_Usage_EventsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Meridian_Usage_EventsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Meridian_Usage_EventsOrderBy>>;
};

export type Meridian_ChatsConnection = {
  __typename?: "meridian_chatsConnection";
  edges: Array<Meridian_ChatsEdge>;
  pageInfo: PageInfo;
};

export type Meridian_ChatsDeleteResponse = {
  __typename?: "meridian_chatsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Chats>;
};

export type Meridian_ChatsEdge = {
  __typename?: "meridian_chatsEdge";
  cursor: Scalars["String"]["output"];
  node: Meridian_Chats;
};

export type Meridian_ChatsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Meridian_ChatsFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<StringFilter>;
  last_message_at?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Meridian_ChatsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Meridian_ChatsFilter>>;
  original_owner_id?: InputMaybe<UuidFilter>;
  status?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Meridian_ChatsInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  last_message_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  original_owner_id?: InputMaybe<Scalars["UUID"]["input"]>;
  shared_with?: InputMaybe<Scalars["JSON"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Meridian_ChatsInsertResponse = {
  __typename?: "meridian_chatsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Chats>;
};

export type Meridian_ChatsOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  last_message_at?: InputMaybe<OrderByDirection>;
  original_owner_id?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  title?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Meridian_ChatsUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  last_message_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  original_owner_id?: InputMaybe<Scalars["UUID"]["input"]>;
  shared_with?: InputMaybe<Scalars["JSON"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Meridian_ChatsUpdateResponse = {
  __typename?: "meridian_chatsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Chats>;
};

export type Meridian_Messages = Node & {
  __typename?: "meridian_messages";
  chat_id: Scalars["String"]["output"];
  created_at: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  meridian_chats?: Maybe<Meridian_Chats>;
  message_id: Scalars["String"]["output"];
  metadata?: Maybe<Scalars["JSON"]["output"]>;
  model_id?: Maybe<Scalars["String"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  parts: Scalars["JSON"]["output"];
  provider?: Maybe<Scalars["String"]["output"]>;
  role: Scalars["String"]["output"];
  timestamp: Scalars["Datetime"]["output"];
};

export type Meridian_MessagesConnection = {
  __typename?: "meridian_messagesConnection";
  edges: Array<Meridian_MessagesEdge>;
  pageInfo: PageInfo;
};

export type Meridian_MessagesDeleteResponse = {
  __typename?: "meridian_messagesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Messages>;
};

export type Meridian_MessagesEdge = {
  __typename?: "meridian_messagesEdge";
  cursor: Scalars["String"]["output"];
  node: Meridian_Messages;
};

export type Meridian_MessagesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Meridian_MessagesFilter>>;
  chat_id?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  message_id?: InputMaybe<StringFilter>;
  model_id?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Meridian_MessagesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Meridian_MessagesFilter>>;
  provider?: InputMaybe<StringFilter>;
  role?: InputMaybe<StringFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
};

export type Meridian_MessagesInsertInput = {
  chat_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  message_id?: InputMaybe<Scalars["String"]["input"]>;
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  model_id?: InputMaybe<Scalars["String"]["input"]>;
  parts?: InputMaybe<Scalars["JSON"]["input"]>;
  provider?: InputMaybe<Scalars["String"]["input"]>;
  role?: InputMaybe<Scalars["String"]["input"]>;
  timestamp?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Meridian_MessagesInsertResponse = {
  __typename?: "meridian_messagesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Messages>;
};

export type Meridian_MessagesOrderBy = {
  chat_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  message_id?: InputMaybe<OrderByDirection>;
  model_id?: InputMaybe<OrderByDirection>;
  provider?: InputMaybe<OrderByDirection>;
  role?: InputMaybe<OrderByDirection>;
  timestamp?: InputMaybe<OrderByDirection>;
};

export type Meridian_MessagesUpdateInput = {
  chat_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  message_id?: InputMaybe<Scalars["String"]["input"]>;
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  model_id?: InputMaybe<Scalars["String"]["input"]>;
  parts?: InputMaybe<Scalars["JSON"]["input"]>;
  provider?: InputMaybe<Scalars["String"]["input"]>;
  role?: InputMaybe<Scalars["String"]["input"]>;
  timestamp?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Meridian_MessagesUpdateResponse = {
  __typename?: "meridian_messagesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Messages>;
};

export type Meridian_Skill_Activations = Node & {
  __typename?: "meridian_skill_activations";
  activated_at: Scalars["Datetime"]["output"];
  app_users?: Maybe<App_Users>;
  chat_id?: Maybe<Scalars["String"]["output"]>;
  deactivated_at?: Maybe<Scalars["Datetime"]["output"]>;
  id: Scalars["UUID"]["output"];
  invoked_by: Scalars["String"]["output"];
  meridian_skills?: Maybe<Meridian_Skills>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  skill_id: Scalars["String"]["output"];
  surface: Scalars["String"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type Meridian_Skill_ActivationsConnection = {
  __typename?: "meridian_skill_activationsConnection";
  edges: Array<Meridian_Skill_ActivationsEdge>;
  pageInfo: PageInfo;
};

export type Meridian_Skill_ActivationsDeleteResponse = {
  __typename?: "meridian_skill_activationsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Skill_Activations>;
};

export type Meridian_Skill_ActivationsEdge = {
  __typename?: "meridian_skill_activationsEdge";
  cursor: Scalars["String"]["output"];
  node: Meridian_Skill_Activations;
};

export type Meridian_Skill_ActivationsFilter = {
  activated_at?: InputMaybe<DatetimeFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Meridian_Skill_ActivationsFilter>>;
  chat_id?: InputMaybe<StringFilter>;
  deactivated_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  invoked_by?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Meridian_Skill_ActivationsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Meridian_Skill_ActivationsFilter>>;
  skill_id?: InputMaybe<StringFilter>;
  surface?: InputMaybe<StringFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Meridian_Skill_ActivationsInsertInput = {
  activated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  chat_id?: InputMaybe<Scalars["String"]["input"]>;
  deactivated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  invoked_by?: InputMaybe<Scalars["String"]["input"]>;
  skill_id?: InputMaybe<Scalars["String"]["input"]>;
  surface?: InputMaybe<Scalars["String"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Meridian_Skill_ActivationsInsertResponse = {
  __typename?: "meridian_skill_activationsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Skill_Activations>;
};

export type Meridian_Skill_ActivationsOrderBy = {
  activated_at?: InputMaybe<OrderByDirection>;
  chat_id?: InputMaybe<OrderByDirection>;
  deactivated_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  invoked_by?: InputMaybe<OrderByDirection>;
  skill_id?: InputMaybe<OrderByDirection>;
  surface?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Meridian_Skill_ActivationsUpdateInput = {
  activated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  chat_id?: InputMaybe<Scalars["String"]["input"]>;
  deactivated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  invoked_by?: InputMaybe<Scalars["String"]["input"]>;
  skill_id?: InputMaybe<Scalars["String"]["input"]>;
  surface?: InputMaybe<Scalars["String"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Meridian_Skill_ActivationsUpdateResponse = {
  __typename?: "meridian_skill_activationsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Skill_Activations>;
};

export type Meridian_Skills = Node & {
  __typename?: "meridian_skills";
  allowed_tools: Array<Maybe<Scalars["String"]["output"]>>;
  argument_hint?: Maybe<Scalars["String"]["output"]>;
  availability: Scalars["String"]["output"];
  body_chars: Scalars["Int"]["output"];
  body_s3_key?: Maybe<Scalars["String"]["output"]>;
  catalog_generated_at?: Maybe<Scalars["Datetime"]["output"]>;
  category?: Maybe<Scalars["String"]["output"]>;
  content_sha256: Scalars["String"]["output"];
  created_at: Scalars["Datetime"]["output"];
  description: Scalars["String"]["output"];
  disable_model_invocation: Scalars["Boolean"]["output"];
  hitl_required: Scalars["Boolean"]["output"];
  how_to_get: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  is_active: Scalars["Boolean"]["output"];
  meridian_skill_activationsCollection?: Maybe<Meridian_Skill_ActivationsConnection>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  path: Scalars["String"]["output"];
  plugin?: Maybe<Scalars["String"]["output"]>;
  plugin_version?: Maybe<Scalars["String"]["output"]>;
  required_capabilities: Array<Maybe<Scalars["String"]["output"]>>;
  runtimes: Array<Maybe<Scalars["String"]["output"]>>;
  synced_at: Scalars["Datetime"]["output"];
  tags: Array<Maybe<Scalars["String"]["output"]>>;
  updated_at: Scalars["Datetime"]["output"];
};

export type Meridian_SkillsMeridian_Skill_ActivationsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Meridian_Skill_ActivationsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Meridian_Skill_ActivationsOrderBy>>;
};

export type Meridian_SkillsConnection = {
  __typename?: "meridian_skillsConnection";
  edges: Array<Meridian_SkillsEdge>;
  pageInfo: PageInfo;
};

export type Meridian_SkillsDeleteResponse = {
  __typename?: "meridian_skillsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Skills>;
};

export type Meridian_SkillsEdge = {
  __typename?: "meridian_skillsEdge";
  cursor: Scalars["String"]["output"];
  node: Meridian_Skills;
};

export type Meridian_SkillsFilter = {
  allowed_tools?: InputMaybe<StringListFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Meridian_SkillsFilter>>;
  argument_hint?: InputMaybe<StringFilter>;
  availability?: InputMaybe<StringFilter>;
  body_chars?: InputMaybe<IntFilter>;
  body_s3_key?: InputMaybe<StringFilter>;
  catalog_generated_at?: InputMaybe<DatetimeFilter>;
  category?: InputMaybe<StringFilter>;
  content_sha256?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  disable_model_invocation?: InputMaybe<BooleanFilter>;
  hitl_required?: InputMaybe<BooleanFilter>;
  how_to_get?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  is_active?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Meridian_SkillsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Meridian_SkillsFilter>>;
  path?: InputMaybe<StringFilter>;
  plugin?: InputMaybe<StringFilter>;
  plugin_version?: InputMaybe<StringFilter>;
  required_capabilities?: InputMaybe<StringListFilter>;
  runtimes?: InputMaybe<StringListFilter>;
  synced_at?: InputMaybe<DatetimeFilter>;
  tags?: InputMaybe<StringListFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Meridian_SkillsInsertInput = {
  allowed_tools?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  argument_hint?: InputMaybe<Scalars["String"]["input"]>;
  availability?: InputMaybe<Scalars["String"]["input"]>;
  body_chars?: InputMaybe<Scalars["Int"]["input"]>;
  body_s3_key?: InputMaybe<Scalars["String"]["input"]>;
  catalog_generated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  category?: InputMaybe<Scalars["String"]["input"]>;
  content_sha256?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  disable_model_invocation?: InputMaybe<Scalars["Boolean"]["input"]>;
  hitl_required?: InputMaybe<Scalars["Boolean"]["input"]>;
  how_to_get?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  path?: InputMaybe<Scalars["String"]["input"]>;
  plugin?: InputMaybe<Scalars["String"]["input"]>;
  plugin_version?: InputMaybe<Scalars["String"]["input"]>;
  required_capabilities?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  runtimes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  synced_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Meridian_SkillsInsertResponse = {
  __typename?: "meridian_skillsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Skills>;
};

export type Meridian_SkillsOrderBy = {
  argument_hint?: InputMaybe<OrderByDirection>;
  availability?: InputMaybe<OrderByDirection>;
  body_chars?: InputMaybe<OrderByDirection>;
  body_s3_key?: InputMaybe<OrderByDirection>;
  catalog_generated_at?: InputMaybe<OrderByDirection>;
  category?: InputMaybe<OrderByDirection>;
  content_sha256?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  disable_model_invocation?: InputMaybe<OrderByDirection>;
  hitl_required?: InputMaybe<OrderByDirection>;
  how_to_get?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_active?: InputMaybe<OrderByDirection>;
  path?: InputMaybe<OrderByDirection>;
  plugin?: InputMaybe<OrderByDirection>;
  plugin_version?: InputMaybe<OrderByDirection>;
  synced_at?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Meridian_SkillsUpdateInput = {
  allowed_tools?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  argument_hint?: InputMaybe<Scalars["String"]["input"]>;
  availability?: InputMaybe<Scalars["String"]["input"]>;
  body_chars?: InputMaybe<Scalars["Int"]["input"]>;
  body_s3_key?: InputMaybe<Scalars["String"]["input"]>;
  catalog_generated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  category?: InputMaybe<Scalars["String"]["input"]>;
  content_sha256?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  disable_model_invocation?: InputMaybe<Scalars["Boolean"]["input"]>;
  hitl_required?: InputMaybe<Scalars["Boolean"]["input"]>;
  how_to_get?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  path?: InputMaybe<Scalars["String"]["input"]>;
  plugin?: InputMaybe<Scalars["String"]["input"]>;
  plugin_version?: InputMaybe<Scalars["String"]["input"]>;
  required_capabilities?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  runtimes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  synced_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Meridian_SkillsUpdateResponse = {
  __typename?: "meridian_skillsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Skills>;
};

export type Meridian_Skills_Sync_State = Node & {
  __typename?: "meridian_skills_sync_state";
  catalog_etag?: Maybe<Scalars["String"]["output"]>;
  catalog_generated_at?: Maybe<Scalars["Datetime"]["output"]>;
  catalog_sha?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  last_sync_at?: Maybe<Scalars["Datetime"]["output"]>;
  last_sync_error?: Maybe<Scalars["String"]["output"]>;
  last_sync_status?: Maybe<Scalars["String"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  skills_deactivated: Scalars["Int"]["output"];
  skills_upserted: Scalars["Int"]["output"];
  updated_at: Scalars["Datetime"]["output"];
};

export type Meridian_Skills_Sync_StateConnection = {
  __typename?: "meridian_skills_sync_stateConnection";
  edges: Array<Meridian_Skills_Sync_StateEdge>;
  pageInfo: PageInfo;
};

export type Meridian_Skills_Sync_StateDeleteResponse = {
  __typename?: "meridian_skills_sync_stateDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Skills_Sync_State>;
};

export type Meridian_Skills_Sync_StateEdge = {
  __typename?: "meridian_skills_sync_stateEdge";
  cursor: Scalars["String"]["output"];
  node: Meridian_Skills_Sync_State;
};

export type Meridian_Skills_Sync_StateFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Meridian_Skills_Sync_StateFilter>>;
  catalog_etag?: InputMaybe<StringFilter>;
  catalog_generated_at?: InputMaybe<DatetimeFilter>;
  catalog_sha?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  last_sync_at?: InputMaybe<DatetimeFilter>;
  last_sync_error?: InputMaybe<StringFilter>;
  last_sync_status?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Meridian_Skills_Sync_StateFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Meridian_Skills_Sync_StateFilter>>;
  skills_deactivated?: InputMaybe<IntFilter>;
  skills_upserted?: InputMaybe<IntFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Meridian_Skills_Sync_StateInsertInput = {
  catalog_etag?: InputMaybe<Scalars["String"]["input"]>;
  catalog_generated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  catalog_sha?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  last_sync_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_sync_error?: InputMaybe<Scalars["String"]["input"]>;
  last_sync_status?: InputMaybe<Scalars["String"]["input"]>;
  skills_deactivated?: InputMaybe<Scalars["Int"]["input"]>;
  skills_upserted?: InputMaybe<Scalars["Int"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Meridian_Skills_Sync_StateInsertResponse = {
  __typename?: "meridian_skills_sync_stateInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Skills_Sync_State>;
};

export type Meridian_Skills_Sync_StateOrderBy = {
  catalog_etag?: InputMaybe<OrderByDirection>;
  catalog_generated_at?: InputMaybe<OrderByDirection>;
  catalog_sha?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  last_sync_at?: InputMaybe<OrderByDirection>;
  last_sync_error?: InputMaybe<OrderByDirection>;
  last_sync_status?: InputMaybe<OrderByDirection>;
  skills_deactivated?: InputMaybe<OrderByDirection>;
  skills_upserted?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Meridian_Skills_Sync_StateUpdateInput = {
  catalog_etag?: InputMaybe<Scalars["String"]["input"]>;
  catalog_generated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  catalog_sha?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  last_sync_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_sync_error?: InputMaybe<Scalars["String"]["input"]>;
  last_sync_status?: InputMaybe<Scalars["String"]["input"]>;
  skills_deactivated?: InputMaybe<Scalars["Int"]["input"]>;
  skills_upserted?: InputMaybe<Scalars["Int"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Meridian_Skills_Sync_StateUpdateResponse = {
  __typename?: "meridian_skills_sync_stateUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Skills_Sync_State>;
};

export type Meridian_Tool_Approval_Overrides = Node & {
  __typename?: "meridian_tool_approval_overrides";
  app_users?: Maybe<App_Users>;
  approval_id: Scalars["String"]["output"];
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  override_payload: Scalars["JSON"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type Meridian_Tool_Approval_OverridesConnection = {
  __typename?: "meridian_tool_approval_overridesConnection";
  edges: Array<Meridian_Tool_Approval_OverridesEdge>;
  pageInfo: PageInfo;
};

export type Meridian_Tool_Approval_OverridesDeleteResponse = {
  __typename?: "meridian_tool_approval_overridesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Tool_Approval_Overrides>;
};

export type Meridian_Tool_Approval_OverridesEdge = {
  __typename?: "meridian_tool_approval_overridesEdge";
  cursor: Scalars["String"]["output"];
  node: Meridian_Tool_Approval_Overrides;
};

export type Meridian_Tool_Approval_OverridesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Meridian_Tool_Approval_OverridesFilter>>;
  approval_id?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Meridian_Tool_Approval_OverridesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Meridian_Tool_Approval_OverridesFilter>>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Meridian_Tool_Approval_OverridesInsertInput = {
  approval_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  override_payload?: InputMaybe<Scalars["JSON"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Meridian_Tool_Approval_OverridesInsertResponse = {
  __typename?: "meridian_tool_approval_overridesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Tool_Approval_Overrides>;
};

export type Meridian_Tool_Approval_OverridesOrderBy = {
  approval_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Meridian_Tool_Approval_OverridesUpdateInput = {
  approval_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  override_payload?: InputMaybe<Scalars["JSON"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Meridian_Tool_Approval_OverridesUpdateResponse = {
  __typename?: "meridian_tool_approval_overridesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Tool_Approval_Overrides>;
};

export type Meridian_Tool_Approvals = Node & {
  __typename?: "meridian_tool_approvals";
  chat_id?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Datetime"]["output"];
  execution_claim_id?: Maybe<Scalars["String"]["output"]>;
  execution_claimed_at?: Maybe<Scalars["Datetime"]["output"]>;
  execution_completed_at?: Maybe<Scalars["Datetime"]["output"]>;
  execution_succeeded?: Maybe<Scalars["Boolean"]["output"]>;
  expires_at: Scalars["BigInt"]["output"];
  id: Scalars["UUID"]["output"];
  meridian_chats?: Maybe<Meridian_Chats>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  parameters: Scalars["JSON"]["output"];
  requested_at: Scalars["BigInt"]["output"];
  responded_at?: Maybe<Scalars["BigInt"]["output"]>;
  responded_by?: Maybe<Scalars["String"]["output"]>;
  slack_channel?: Maybe<Scalars["String"]["output"]>;
  slack_message_ts?: Maybe<Scalars["String"]["output"]>;
  slack_thread_ts?: Maybe<Scalars["String"]["output"]>;
  slack_user_id?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  tool_name: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type Meridian_Tool_ApprovalsConnection = {
  __typename?: "meridian_tool_approvalsConnection";
  edges: Array<Meridian_Tool_ApprovalsEdge>;
  pageInfo: PageInfo;
};

export type Meridian_Tool_ApprovalsDeleteResponse = {
  __typename?: "meridian_tool_approvalsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Tool_Approvals>;
};

export type Meridian_Tool_ApprovalsEdge = {
  __typename?: "meridian_tool_approvalsEdge";
  cursor: Scalars["String"]["output"];
  node: Meridian_Tool_Approvals;
};

export type Meridian_Tool_ApprovalsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Meridian_Tool_ApprovalsFilter>>;
  chat_id?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  execution_claim_id?: InputMaybe<StringFilter>;
  execution_claimed_at?: InputMaybe<DatetimeFilter>;
  execution_completed_at?: InputMaybe<DatetimeFilter>;
  execution_succeeded?: InputMaybe<BooleanFilter>;
  expires_at?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Meridian_Tool_ApprovalsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Meridian_Tool_ApprovalsFilter>>;
  requested_at?: InputMaybe<BigIntFilter>;
  responded_at?: InputMaybe<BigIntFilter>;
  responded_by?: InputMaybe<StringFilter>;
  slack_channel?: InputMaybe<StringFilter>;
  slack_message_ts?: InputMaybe<StringFilter>;
  slack_thread_ts?: InputMaybe<StringFilter>;
  slack_user_id?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  tool_name?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Meridian_Tool_ApprovalsInsertInput = {
  chat_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  execution_claim_id?: InputMaybe<Scalars["String"]["input"]>;
  execution_claimed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  execution_completed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  execution_succeeded?: InputMaybe<Scalars["Boolean"]["input"]>;
  expires_at?: InputMaybe<Scalars["BigInt"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  parameters?: InputMaybe<Scalars["JSON"]["input"]>;
  requested_at?: InputMaybe<Scalars["BigInt"]["input"]>;
  responded_at?: InputMaybe<Scalars["BigInt"]["input"]>;
  responded_by?: InputMaybe<Scalars["String"]["input"]>;
  slack_channel?: InputMaybe<Scalars["String"]["input"]>;
  slack_message_ts?: InputMaybe<Scalars["String"]["input"]>;
  slack_thread_ts?: InputMaybe<Scalars["String"]["input"]>;
  slack_user_id?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  tool_name?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Meridian_Tool_ApprovalsInsertResponse = {
  __typename?: "meridian_tool_approvalsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Tool_Approvals>;
};

export type Meridian_Tool_ApprovalsOrderBy = {
  chat_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  execution_claim_id?: InputMaybe<OrderByDirection>;
  execution_claimed_at?: InputMaybe<OrderByDirection>;
  execution_completed_at?: InputMaybe<OrderByDirection>;
  execution_succeeded?: InputMaybe<OrderByDirection>;
  expires_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  requested_at?: InputMaybe<OrderByDirection>;
  responded_at?: InputMaybe<OrderByDirection>;
  responded_by?: InputMaybe<OrderByDirection>;
  slack_channel?: InputMaybe<OrderByDirection>;
  slack_message_ts?: InputMaybe<OrderByDirection>;
  slack_thread_ts?: InputMaybe<OrderByDirection>;
  slack_user_id?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  tool_name?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Meridian_Tool_ApprovalsUpdateInput = {
  chat_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  execution_claim_id?: InputMaybe<Scalars["String"]["input"]>;
  execution_claimed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  execution_completed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  execution_succeeded?: InputMaybe<Scalars["Boolean"]["input"]>;
  expires_at?: InputMaybe<Scalars["BigInt"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  parameters?: InputMaybe<Scalars["JSON"]["input"]>;
  requested_at?: InputMaybe<Scalars["BigInt"]["input"]>;
  responded_at?: InputMaybe<Scalars["BigInt"]["input"]>;
  responded_by?: InputMaybe<Scalars["String"]["input"]>;
  slack_channel?: InputMaybe<Scalars["String"]["input"]>;
  slack_message_ts?: InputMaybe<Scalars["String"]["input"]>;
  slack_thread_ts?: InputMaybe<Scalars["String"]["input"]>;
  slack_user_id?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  tool_name?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Meridian_Tool_ApprovalsUpdateResponse = {
  __typename?: "meridian_tool_approvalsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Tool_Approvals>;
};

export type Meridian_Tool_Io = Node & {
  __typename?: "meridian_tool_io";
  cache_hit?: Maybe<Scalars["Boolean"]["output"]>;
  chat_id?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Datetime"]["output"];
  duration_ms?: Maybe<Scalars["Int"]["output"]>;
  error_code?: Maybe<Scalars["String"]["output"]>;
  error_kind?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  ids_requested?: Maybe<Scalars["Int"]["output"]>;
  input_bytes: Scalars["Int"]["output"];
  is_error: Scalars["Boolean"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  output_bytes: Scalars["Int"]["output"];
  output_items?: Maybe<Scalars["Int"]["output"]>;
  result_truncated?: Maybe<Scalars["Boolean"]["output"]>;
  sections_returned?: Maybe<Scalars["Int"]["output"]>;
  surface?: Maybe<Scalars["String"]["output"]>;
  tool_name: Scalars["String"]["output"];
  turn_id?: Maybe<Scalars["String"]["output"]>;
  turn_index?: Maybe<Scalars["Int"]["output"]>;
  user_id?: Maybe<Scalars["UUID"]["output"]>;
};

export type Meridian_Tool_IoConnection = {
  __typename?: "meridian_tool_ioConnection";
  edges: Array<Meridian_Tool_IoEdge>;
  pageInfo: PageInfo;
};

export type Meridian_Tool_IoDeleteResponse = {
  __typename?: "meridian_tool_ioDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Tool_Io>;
};

export type Meridian_Tool_IoEdge = {
  __typename?: "meridian_tool_ioEdge";
  cursor: Scalars["String"]["output"];
  node: Meridian_Tool_Io;
};

export type Meridian_Tool_IoFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Meridian_Tool_IoFilter>>;
  cache_hit?: InputMaybe<BooleanFilter>;
  chat_id?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  duration_ms?: InputMaybe<IntFilter>;
  error_code?: InputMaybe<StringFilter>;
  error_kind?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  ids_requested?: InputMaybe<IntFilter>;
  input_bytes?: InputMaybe<IntFilter>;
  is_error?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Meridian_Tool_IoFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Meridian_Tool_IoFilter>>;
  output_bytes?: InputMaybe<IntFilter>;
  output_items?: InputMaybe<IntFilter>;
  result_truncated?: InputMaybe<BooleanFilter>;
  sections_returned?: InputMaybe<IntFilter>;
  surface?: InputMaybe<StringFilter>;
  tool_name?: InputMaybe<StringFilter>;
  turn_id?: InputMaybe<StringFilter>;
  turn_index?: InputMaybe<IntFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Meridian_Tool_IoInsertInput = {
  cache_hit?: InputMaybe<Scalars["Boolean"]["input"]>;
  chat_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  duration_ms?: InputMaybe<Scalars["Int"]["input"]>;
  error_code?: InputMaybe<Scalars["String"]["input"]>;
  error_kind?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  ids_requested?: InputMaybe<Scalars["Int"]["input"]>;
  input_bytes?: InputMaybe<Scalars["Int"]["input"]>;
  is_error?: InputMaybe<Scalars["Boolean"]["input"]>;
  output_bytes?: InputMaybe<Scalars["Int"]["input"]>;
  output_items?: InputMaybe<Scalars["Int"]["input"]>;
  result_truncated?: InputMaybe<Scalars["Boolean"]["input"]>;
  sections_returned?: InputMaybe<Scalars["Int"]["input"]>;
  surface?: InputMaybe<Scalars["String"]["input"]>;
  tool_name?: InputMaybe<Scalars["String"]["input"]>;
  turn_id?: InputMaybe<Scalars["String"]["input"]>;
  turn_index?: InputMaybe<Scalars["Int"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Meridian_Tool_IoInsertResponse = {
  __typename?: "meridian_tool_ioInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Tool_Io>;
};

export type Meridian_Tool_IoOrderBy = {
  cache_hit?: InputMaybe<OrderByDirection>;
  chat_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  duration_ms?: InputMaybe<OrderByDirection>;
  error_code?: InputMaybe<OrderByDirection>;
  error_kind?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  ids_requested?: InputMaybe<OrderByDirection>;
  input_bytes?: InputMaybe<OrderByDirection>;
  is_error?: InputMaybe<OrderByDirection>;
  output_bytes?: InputMaybe<OrderByDirection>;
  output_items?: InputMaybe<OrderByDirection>;
  result_truncated?: InputMaybe<OrderByDirection>;
  sections_returned?: InputMaybe<OrderByDirection>;
  surface?: InputMaybe<OrderByDirection>;
  tool_name?: InputMaybe<OrderByDirection>;
  turn_id?: InputMaybe<OrderByDirection>;
  turn_index?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Meridian_Tool_IoUpdateInput = {
  cache_hit?: InputMaybe<Scalars["Boolean"]["input"]>;
  chat_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  duration_ms?: InputMaybe<Scalars["Int"]["input"]>;
  error_code?: InputMaybe<Scalars["String"]["input"]>;
  error_kind?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  ids_requested?: InputMaybe<Scalars["Int"]["input"]>;
  input_bytes?: InputMaybe<Scalars["Int"]["input"]>;
  is_error?: InputMaybe<Scalars["Boolean"]["input"]>;
  output_bytes?: InputMaybe<Scalars["Int"]["input"]>;
  output_items?: InputMaybe<Scalars["Int"]["input"]>;
  result_truncated?: InputMaybe<Scalars["Boolean"]["input"]>;
  sections_returned?: InputMaybe<Scalars["Int"]["input"]>;
  surface?: InputMaybe<Scalars["String"]["input"]>;
  tool_name?: InputMaybe<Scalars["String"]["input"]>;
  turn_id?: InputMaybe<Scalars["String"]["input"]>;
  turn_index?: InputMaybe<Scalars["Int"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Meridian_Tool_IoUpdateResponse = {
  __typename?: "meridian_tool_ioUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Tool_Io>;
};

export type Meridian_Tool_Results = Node & {
  __typename?: "meridian_tool_results";
  chat_id: Scalars["String"]["output"];
  created_at: Scalars["Datetime"]["output"];
  executed_at: Scalars["Datetime"]["output"];
  execution_time?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["UUID"]["output"];
  input_size?: Maybe<Scalars["Int"]["output"]>;
  meridian_chats?: Maybe<Meridian_Chats>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  output_size?: Maybe<Scalars["Int"]["output"]>;
  result_summary: Scalars["String"]["output"];
  result_type: Scalars["String"]["output"];
  summarized_at: Scalars["Datetime"]["output"];
  tool_call_id: Scalars["String"]["output"];
  tool_name: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type Meridian_Tool_ResultsConnection = {
  __typename?: "meridian_tool_resultsConnection";
  edges: Array<Meridian_Tool_ResultsEdge>;
  pageInfo: PageInfo;
};

export type Meridian_Tool_ResultsDeleteResponse = {
  __typename?: "meridian_tool_resultsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Tool_Results>;
};

export type Meridian_Tool_ResultsEdge = {
  __typename?: "meridian_tool_resultsEdge";
  cursor: Scalars["String"]["output"];
  node: Meridian_Tool_Results;
};

export type Meridian_Tool_ResultsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Meridian_Tool_ResultsFilter>>;
  chat_id?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  executed_at?: InputMaybe<DatetimeFilter>;
  execution_time?: InputMaybe<IntFilter>;
  id?: InputMaybe<UuidFilter>;
  input_size?: InputMaybe<IntFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Meridian_Tool_ResultsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Meridian_Tool_ResultsFilter>>;
  output_size?: InputMaybe<IntFilter>;
  result_summary?: InputMaybe<StringFilter>;
  result_type?: InputMaybe<StringFilter>;
  summarized_at?: InputMaybe<DatetimeFilter>;
  tool_call_id?: InputMaybe<StringFilter>;
  tool_name?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Meridian_Tool_ResultsInsertInput = {
  chat_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  executed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  execution_time?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  input_size?: InputMaybe<Scalars["Int"]["input"]>;
  output_size?: InputMaybe<Scalars["Int"]["input"]>;
  result_summary?: InputMaybe<Scalars["String"]["input"]>;
  result_type?: InputMaybe<Scalars["String"]["input"]>;
  summarized_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  tool_call_id?: InputMaybe<Scalars["String"]["input"]>;
  tool_name?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Meridian_Tool_ResultsInsertResponse = {
  __typename?: "meridian_tool_resultsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Tool_Results>;
};

export type Meridian_Tool_ResultsOrderBy = {
  chat_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  executed_at?: InputMaybe<OrderByDirection>;
  execution_time?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  input_size?: InputMaybe<OrderByDirection>;
  output_size?: InputMaybe<OrderByDirection>;
  result_summary?: InputMaybe<OrderByDirection>;
  result_type?: InputMaybe<OrderByDirection>;
  summarized_at?: InputMaybe<OrderByDirection>;
  tool_call_id?: InputMaybe<OrderByDirection>;
  tool_name?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Meridian_Tool_ResultsUpdateInput = {
  chat_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  executed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  execution_time?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  input_size?: InputMaybe<Scalars["Int"]["input"]>;
  output_size?: InputMaybe<Scalars["Int"]["input"]>;
  result_summary?: InputMaybe<Scalars["String"]["input"]>;
  result_type?: InputMaybe<Scalars["String"]["input"]>;
  summarized_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  tool_call_id?: InputMaybe<Scalars["String"]["input"]>;
  tool_name?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Meridian_Tool_ResultsUpdateResponse = {
  __typename?: "meridian_tool_resultsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Tool_Results>;
};

export type Meridian_Tool_Rollups = Node & {
  __typename?: "meridian_tool_rollups";
  chat_id: Scalars["String"]["output"];
  created_at: Scalars["Datetime"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  state: Scalars["JSON"]["output"];
  thread_ts: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
};

export type Meridian_Tool_RollupsConnection = {
  __typename?: "meridian_tool_rollupsConnection";
  edges: Array<Meridian_Tool_RollupsEdge>;
  pageInfo: PageInfo;
};

export type Meridian_Tool_RollupsDeleteResponse = {
  __typename?: "meridian_tool_rollupsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Tool_Rollups>;
};

export type Meridian_Tool_RollupsEdge = {
  __typename?: "meridian_tool_rollupsEdge";
  cursor: Scalars["String"]["output"];
  node: Meridian_Tool_Rollups;
};

export type Meridian_Tool_RollupsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Meridian_Tool_RollupsFilter>>;
  chat_id?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Meridian_Tool_RollupsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Meridian_Tool_RollupsFilter>>;
  thread_ts?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Meridian_Tool_RollupsInsertInput = {
  chat_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  state?: InputMaybe<Scalars["JSON"]["input"]>;
  thread_ts?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Meridian_Tool_RollupsInsertResponse = {
  __typename?: "meridian_tool_rollupsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Tool_Rollups>;
};

export type Meridian_Tool_RollupsOrderBy = {
  chat_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  thread_ts?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Meridian_Tool_RollupsUpdateInput = {
  chat_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  state?: InputMaybe<Scalars["JSON"]["input"]>;
  thread_ts?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Meridian_Tool_RollupsUpdateResponse = {
  __typename?: "meridian_tool_rollupsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Tool_Rollups>;
};

export type Meridian_Usage_Events = Node & {
  __typename?: "meridian_usage_events";
  cache_creation_input_tokens: Scalars["Int"]["output"];
  cache_read_cost_usd: Scalars["BigFloat"]["output"];
  cache_read_input_tokens: Scalars["Int"]["output"];
  cache_write_cost_usd: Scalars["BigFloat"]["output"];
  canonical_model_id?: Maybe<Scalars["String"]["output"]>;
  chat_id?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Datetime"]["output"];
  duration_ms?: Maybe<Scalars["Int"]["output"]>;
  feature?: Maybe<Scalars["String"]["output"]>;
  finish_reason?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  input_cost_usd: Scalars["BigFloat"]["output"];
  input_tokens: Scalars["Int"]["output"];
  meridian_chats?: Maybe<Meridian_Chats>;
  model_id: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  output_cost_usd: Scalars["BigFloat"]["output"];
  output_tokens: Scalars["Int"]["output"];
  pricing_unknown: Scalars["Boolean"]["output"];
  provider?: Maybe<Scalars["String"]["output"]>;
  step_index: Scalars["Int"]["output"];
  surface: Scalars["String"]["output"];
  tools: Scalars["JSON"]["output"];
  total_cost_usd: Scalars["BigFloat"]["output"];
  total_tokens: Scalars["Int"]["output"];
  user_id?: Maybe<Scalars["UUID"]["output"]>;
};

export type Meridian_Usage_EventsConnection = {
  __typename?: "meridian_usage_eventsConnection";
  edges: Array<Meridian_Usage_EventsEdge>;
  pageInfo: PageInfo;
};

export type Meridian_Usage_EventsDeleteResponse = {
  __typename?: "meridian_usage_eventsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Usage_Events>;
};

export type Meridian_Usage_EventsEdge = {
  __typename?: "meridian_usage_eventsEdge";
  cursor: Scalars["String"]["output"];
  node: Meridian_Usage_Events;
};

export type Meridian_Usage_EventsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Meridian_Usage_EventsFilter>>;
  cache_creation_input_tokens?: InputMaybe<IntFilter>;
  cache_read_cost_usd?: InputMaybe<BigFloatFilter>;
  cache_read_input_tokens?: InputMaybe<IntFilter>;
  cache_write_cost_usd?: InputMaybe<BigFloatFilter>;
  canonical_model_id?: InputMaybe<StringFilter>;
  chat_id?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  duration_ms?: InputMaybe<IntFilter>;
  feature?: InputMaybe<StringFilter>;
  finish_reason?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  input_cost_usd?: InputMaybe<BigFloatFilter>;
  input_tokens?: InputMaybe<IntFilter>;
  model_id?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Meridian_Usage_EventsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Meridian_Usage_EventsFilter>>;
  output_cost_usd?: InputMaybe<BigFloatFilter>;
  output_tokens?: InputMaybe<IntFilter>;
  pricing_unknown?: InputMaybe<BooleanFilter>;
  provider?: InputMaybe<StringFilter>;
  step_index?: InputMaybe<IntFilter>;
  surface?: InputMaybe<StringFilter>;
  total_cost_usd?: InputMaybe<BigFloatFilter>;
  total_tokens?: InputMaybe<IntFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Meridian_Usage_EventsInsertInput = {
  cache_creation_input_tokens?: InputMaybe<Scalars["Int"]["input"]>;
  cache_read_cost_usd?: InputMaybe<Scalars["BigFloat"]["input"]>;
  cache_read_input_tokens?: InputMaybe<Scalars["Int"]["input"]>;
  cache_write_cost_usd?: InputMaybe<Scalars["BigFloat"]["input"]>;
  canonical_model_id?: InputMaybe<Scalars["String"]["input"]>;
  chat_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  duration_ms?: InputMaybe<Scalars["Int"]["input"]>;
  feature?: InputMaybe<Scalars["String"]["input"]>;
  finish_reason?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  input_cost_usd?: InputMaybe<Scalars["BigFloat"]["input"]>;
  input_tokens?: InputMaybe<Scalars["Int"]["input"]>;
  model_id?: InputMaybe<Scalars["String"]["input"]>;
  output_cost_usd?: InputMaybe<Scalars["BigFloat"]["input"]>;
  output_tokens?: InputMaybe<Scalars["Int"]["input"]>;
  pricing_unknown?: InputMaybe<Scalars["Boolean"]["input"]>;
  provider?: InputMaybe<Scalars["String"]["input"]>;
  step_index?: InputMaybe<Scalars["Int"]["input"]>;
  surface?: InputMaybe<Scalars["String"]["input"]>;
  tools?: InputMaybe<Scalars["JSON"]["input"]>;
  total_cost_usd?: InputMaybe<Scalars["BigFloat"]["input"]>;
  total_tokens?: InputMaybe<Scalars["Int"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Meridian_Usage_EventsInsertResponse = {
  __typename?: "meridian_usage_eventsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Usage_Events>;
};

export type Meridian_Usage_EventsOrderBy = {
  cache_creation_input_tokens?: InputMaybe<OrderByDirection>;
  cache_read_cost_usd?: InputMaybe<OrderByDirection>;
  cache_read_input_tokens?: InputMaybe<OrderByDirection>;
  cache_write_cost_usd?: InputMaybe<OrderByDirection>;
  canonical_model_id?: InputMaybe<OrderByDirection>;
  chat_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  duration_ms?: InputMaybe<OrderByDirection>;
  feature?: InputMaybe<OrderByDirection>;
  finish_reason?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  input_cost_usd?: InputMaybe<OrderByDirection>;
  input_tokens?: InputMaybe<OrderByDirection>;
  model_id?: InputMaybe<OrderByDirection>;
  output_cost_usd?: InputMaybe<OrderByDirection>;
  output_tokens?: InputMaybe<OrderByDirection>;
  pricing_unknown?: InputMaybe<OrderByDirection>;
  provider?: InputMaybe<OrderByDirection>;
  step_index?: InputMaybe<OrderByDirection>;
  surface?: InputMaybe<OrderByDirection>;
  total_cost_usd?: InputMaybe<OrderByDirection>;
  total_tokens?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Meridian_Usage_EventsUpdateInput = {
  cache_creation_input_tokens?: InputMaybe<Scalars["Int"]["input"]>;
  cache_read_cost_usd?: InputMaybe<Scalars["BigFloat"]["input"]>;
  cache_read_input_tokens?: InputMaybe<Scalars["Int"]["input"]>;
  cache_write_cost_usd?: InputMaybe<Scalars["BigFloat"]["input"]>;
  canonical_model_id?: InputMaybe<Scalars["String"]["input"]>;
  chat_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  duration_ms?: InputMaybe<Scalars["Int"]["input"]>;
  feature?: InputMaybe<Scalars["String"]["input"]>;
  finish_reason?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  input_cost_usd?: InputMaybe<Scalars["BigFloat"]["input"]>;
  input_tokens?: InputMaybe<Scalars["Int"]["input"]>;
  model_id?: InputMaybe<Scalars["String"]["input"]>;
  output_cost_usd?: InputMaybe<Scalars["BigFloat"]["input"]>;
  output_tokens?: InputMaybe<Scalars["Int"]["input"]>;
  pricing_unknown?: InputMaybe<Scalars["Boolean"]["input"]>;
  provider?: InputMaybe<Scalars["String"]["input"]>;
  step_index?: InputMaybe<Scalars["Int"]["input"]>;
  surface?: InputMaybe<Scalars["String"]["input"]>;
  tools?: InputMaybe<Scalars["JSON"]["input"]>;
  total_cost_usd?: InputMaybe<Scalars["BigFloat"]["input"]>;
  total_tokens?: InputMaybe<Scalars["Int"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Meridian_Usage_EventsUpdateResponse = {
  __typename?: "meridian_usage_eventsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_Usage_Events>;
};

export type Meridian_User_Memories = Node & {
  __typename?: "meridian_user_memories";
  content: Scalars["String"]["output"];
  created_at: Scalars["Datetime"]["output"];
  embedding?: Maybe<Scalars["Opaque"]["output"]>;
  id: Scalars["UUID"]["output"];
  importance: Scalars["Int"]["output"];
  key: Scalars["String"]["output"];
  last_used_at?: Maybe<Scalars["Datetime"]["output"]>;
  memory_type: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  search_vector?: Maybe<Scalars["Opaque"]["output"]>;
  source: Scalars["String"]["output"];
  trust: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
  use_count: Scalars["Int"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type Meridian_User_MemoriesConnection = {
  __typename?: "meridian_user_memoriesConnection";
  edges: Array<Meridian_User_MemoriesEdge>;
  pageInfo: PageInfo;
};

export type Meridian_User_MemoriesDeleteResponse = {
  __typename?: "meridian_user_memoriesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_User_Memories>;
};

export type Meridian_User_MemoriesEdge = {
  __typename?: "meridian_user_memoriesEdge";
  cursor: Scalars["String"]["output"];
  node: Meridian_User_Memories;
};

export type Meridian_User_MemoriesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Meridian_User_MemoriesFilter>>;
  content?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  embedding?: InputMaybe<OpaqueFilter>;
  id?: InputMaybe<UuidFilter>;
  importance?: InputMaybe<IntFilter>;
  key?: InputMaybe<StringFilter>;
  last_used_at?: InputMaybe<DatetimeFilter>;
  memory_type?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Meridian_User_MemoriesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Meridian_User_MemoriesFilter>>;
  search_vector?: InputMaybe<OpaqueFilter>;
  source?: InputMaybe<StringFilter>;
  trust?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  use_count?: InputMaybe<IntFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Meridian_User_MemoriesInsertInput = {
  content?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  embedding?: InputMaybe<Scalars["Opaque"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  importance?: InputMaybe<Scalars["Int"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  last_used_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  memory_type?: InputMaybe<Scalars["String"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  trust?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  use_count?: InputMaybe<Scalars["Int"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Meridian_User_MemoriesInsertResponse = {
  __typename?: "meridian_user_memoriesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_User_Memories>;
};

export type Meridian_User_MemoriesOrderBy = {
  content?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  embedding?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  importance?: InputMaybe<OrderByDirection>;
  key?: InputMaybe<OrderByDirection>;
  last_used_at?: InputMaybe<OrderByDirection>;
  memory_type?: InputMaybe<OrderByDirection>;
  search_vector?: InputMaybe<OrderByDirection>;
  source?: InputMaybe<OrderByDirection>;
  trust?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  use_count?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Meridian_User_MemoriesUpdateInput = {
  content?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  embedding?: InputMaybe<Scalars["Opaque"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  importance?: InputMaybe<Scalars["Int"]["input"]>;
  key?: InputMaybe<Scalars["String"]["input"]>;
  last_used_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  memory_type?: InputMaybe<Scalars["String"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  trust?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  use_count?: InputMaybe<Scalars["Int"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Meridian_User_MemoriesUpdateResponse = {
  __typename?: "meridian_user_memoriesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Meridian_User_Memories>;
};

export type Mrr_Snapshots = Node & {
  __typename?: "mrr_snapshots";
  account_id: Scalars["UUID"]["output"];
  amount: Scalars["BigFloat"]["output"];
  company_id?: Maybe<Scalars["UUID"]["output"]>;
  created_at: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  month: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  source: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
};

export type Mrr_SnapshotsConnection = {
  __typename?: "mrr_snapshotsConnection";
  edges: Array<Mrr_SnapshotsEdge>;
  pageInfo: PageInfo;
};

export type Mrr_SnapshotsDeleteResponse = {
  __typename?: "mrr_snapshotsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Mrr_Snapshots>;
};

export type Mrr_SnapshotsEdge = {
  __typename?: "mrr_snapshotsEdge";
  cursor: Scalars["String"]["output"];
  node: Mrr_Snapshots;
};

export type Mrr_SnapshotsFilter = {
  account_id?: InputMaybe<UuidFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Mrr_SnapshotsFilter>>;
  company_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  month?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Mrr_SnapshotsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Mrr_SnapshotsFilter>>;
  source?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Mrr_SnapshotsInsertInput = {
  account_id?: InputMaybe<Scalars["UUID"]["input"]>;
  amount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  month?: InputMaybe<Scalars["String"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Mrr_SnapshotsInsertResponse = {
  __typename?: "mrr_snapshotsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Mrr_Snapshots>;
};

export type Mrr_SnapshotsOrderBy = {
  account_id?: InputMaybe<OrderByDirection>;
  amount?: InputMaybe<OrderByDirection>;
  company_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  month?: InputMaybe<OrderByDirection>;
  source?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Mrr_SnapshotsUpdateInput = {
  account_id?: InputMaybe<Scalars["UUID"]["input"]>;
  amount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  month?: InputMaybe<Scalars["String"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Mrr_SnapshotsUpdateResponse = {
  __typename?: "mrr_snapshotsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Mrr_Snapshots>;
};

export type Msp_Documents = Node & {
  __typename?: "msp_documents";
  access_count?: Maybe<Scalars["Int"]["output"]>;
  app_users?: Maybe<App_Users>;
  category: Scalars["String"]["output"];
  client_id?: Maybe<Scalars["UUID"]["output"]>;
  companies?: Maybe<Companies>;
  company_id?: Maybe<Scalars["UUID"]["output"]>;
  contacts?: Maybe<Contacts>;
  content?: Maybe<Scalars["String"]["output"]>;
  content_byte_size?: Maybe<Scalars["Int"]["output"]>;
  content_content_type?: Maybe<Scalars["String"]["output"]>;
  content_preview?: Maybe<Scalars["String"]["output"]>;
  content_s3_key?: Maybe<Scalars["String"]["output"]>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  created_by: Scalars["UUID"]["output"];
  difficulty?: Maybe<Scalars["String"]["output"]>;
  estimated_read_time?: Maybe<Scalars["Int"]["output"]>;
  excerpt?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  is_active?: Maybe<Scalars["Boolean"]["output"]>;
  is_featured?: Maybe<Scalars["Boolean"]["output"]>;
  is_internal?: Maybe<Scalars["Boolean"]["output"]>;
  last_accessed_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  shared_with_users?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  tags?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  title: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  updated_by?: Maybe<Scalars["UUID"]["output"]>;
};

/** Aggregate results for `msp_documents` */
export type Msp_DocumentsAggregate = {
  __typename?: "msp_documentsAggregate";
  /** Average aggregates for numeric fields */
  avg?: Maybe<Msp_DocumentsAvgAggregateResult>;
  /** The number of records matching the query */
  count: Scalars["Int"]["output"];
  /** Maximum aggregates for comparable fields */
  max?: Maybe<Msp_DocumentsMaxAggregateResult>;
  /** Minimum aggregates for comparable fields */
  min?: Maybe<Msp_DocumentsMinAggregateResult>;
  /** Summation aggregates for numeric fields */
  sum?: Maybe<Msp_DocumentsSumAggregateResult>;
};

/** Result of average aggregation for `msp_documents` */
export type Msp_DocumentsAvgAggregateResult = {
  __typename?: "msp_documentsAvgAggregateResult";
  /** Average of access_count across all matching records */
  access_count?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Average of content_byte_size across all matching records */
  content_byte_size?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Average of estimated_read_time across all matching records */
  estimated_read_time?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type Msp_DocumentsConnection = {
  __typename?: "msp_documentsConnection";
  /** Aggregate functions calculated on the collection of `msp_documents` */
  aggregate?: Maybe<Msp_DocumentsAggregate>;
  edges: Array<Msp_DocumentsEdge>;
  pageInfo: PageInfo;
  /** The total number of records matching the `filter` criteria */
  totalCount: Scalars["Int"]["output"];
};

export type Msp_DocumentsDeleteResponse = {
  __typename?: "msp_documentsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Msp_Documents>;
};

export type Msp_DocumentsEdge = {
  __typename?: "msp_documentsEdge";
  cursor: Scalars["String"]["output"];
  node: Msp_Documents;
};

export type Msp_DocumentsFilter = {
  access_count?: InputMaybe<IntFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Msp_DocumentsFilter>>;
  category?: InputMaybe<StringFilter>;
  client_id?: InputMaybe<UuidFilter>;
  company_id?: InputMaybe<UuidFilter>;
  content?: InputMaybe<StringFilter>;
  content_byte_size?: InputMaybe<IntFilter>;
  content_content_type?: InputMaybe<StringFilter>;
  content_preview?: InputMaybe<StringFilter>;
  content_s3_key?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  difficulty?: InputMaybe<StringFilter>;
  estimated_read_time?: InputMaybe<IntFilter>;
  excerpt?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  is_active?: InputMaybe<BooleanFilter>;
  is_featured?: InputMaybe<BooleanFilter>;
  is_internal?: InputMaybe<BooleanFilter>;
  last_accessed_at?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Msp_DocumentsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Msp_DocumentsFilter>>;
  shared_with_users?: InputMaybe<StringListFilter>;
  tags?: InputMaybe<StringListFilter>;
  title?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  updated_by?: InputMaybe<UuidFilter>;
};

export type Msp_DocumentsInsertInput = {
  access_count?: InputMaybe<Scalars["Int"]["input"]>;
  category?: InputMaybe<Scalars["String"]["input"]>;
  client_id?: InputMaybe<Scalars["UUID"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  content?: InputMaybe<Scalars["String"]["input"]>;
  content_byte_size?: InputMaybe<Scalars["Int"]["input"]>;
  content_content_type?: InputMaybe<Scalars["String"]["input"]>;
  content_preview?: InputMaybe<Scalars["String"]["input"]>;
  content_s3_key?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  difficulty?: InputMaybe<Scalars["String"]["input"]>;
  estimated_read_time?: InputMaybe<Scalars["Int"]["input"]>;
  excerpt?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_featured?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  last_accessed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  shared_with_users?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  updated_by?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Msp_DocumentsInsertResponse = {
  __typename?: "msp_documentsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Msp_Documents>;
};

/** Result of maximum aggregation for `msp_documents` */
export type Msp_DocumentsMaxAggregateResult = {
  __typename?: "msp_documentsMaxAggregateResult";
  /** Maximum of access_count across all matching records */
  access_count?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of category across all matching records */
  category?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of content across all matching records */
  content?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of content_byte_size across all matching records */
  content_byte_size?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of content_content_type across all matching records */
  content_content_type?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of content_preview across all matching records */
  content_preview?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of content_s3_key across all matching records */
  content_s3_key?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of created_at across all matching records */
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Maximum of difficulty across all matching records */
  difficulty?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of estimated_read_time across all matching records */
  estimated_read_time?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of excerpt across all matching records */
  excerpt?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of is_active across all matching records */
  is_active?: Maybe<Scalars["Boolean"]["output"]>;
  /** Maximum of is_featured across all matching records */
  is_featured?: Maybe<Scalars["Boolean"]["output"]>;
  /** Maximum of is_internal across all matching records */
  is_internal?: Maybe<Scalars["Boolean"]["output"]>;
  /** Maximum of last_accessed_at across all matching records */
  last_accessed_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Maximum of title across all matching records */
  title?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of updated_at across all matching records */
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

/** Result of minimum aggregation for `msp_documents` */
export type Msp_DocumentsMinAggregateResult = {
  __typename?: "msp_documentsMinAggregateResult";
  /** Minimum of access_count across all matching records */
  access_count?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of category across all matching records */
  category?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of content across all matching records */
  content?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of content_byte_size across all matching records */
  content_byte_size?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of content_content_type across all matching records */
  content_content_type?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of content_preview across all matching records */
  content_preview?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of content_s3_key across all matching records */
  content_s3_key?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of created_at across all matching records */
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Minimum of difficulty across all matching records */
  difficulty?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of estimated_read_time across all matching records */
  estimated_read_time?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of excerpt across all matching records */
  excerpt?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of is_active across all matching records */
  is_active?: Maybe<Scalars["Boolean"]["output"]>;
  /** Minimum of is_featured across all matching records */
  is_featured?: Maybe<Scalars["Boolean"]["output"]>;
  /** Minimum of is_internal across all matching records */
  is_internal?: Maybe<Scalars["Boolean"]["output"]>;
  /** Minimum of last_accessed_at across all matching records */
  last_accessed_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Minimum of title across all matching records */
  title?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of updated_at across all matching records */
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type Msp_DocumentsOrderBy = {
  access_count?: InputMaybe<OrderByDirection>;
  category?: InputMaybe<OrderByDirection>;
  client_id?: InputMaybe<OrderByDirection>;
  company_id?: InputMaybe<OrderByDirection>;
  content?: InputMaybe<OrderByDirection>;
  content_byte_size?: InputMaybe<OrderByDirection>;
  content_content_type?: InputMaybe<OrderByDirection>;
  content_preview?: InputMaybe<OrderByDirection>;
  content_s3_key?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  difficulty?: InputMaybe<OrderByDirection>;
  estimated_read_time?: InputMaybe<OrderByDirection>;
  excerpt?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_active?: InputMaybe<OrderByDirection>;
  is_featured?: InputMaybe<OrderByDirection>;
  is_internal?: InputMaybe<OrderByDirection>;
  last_accessed_at?: InputMaybe<OrderByDirection>;
  title?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  updated_by?: InputMaybe<OrderByDirection>;
};

/** Result of summation aggregation for `msp_documents` */
export type Msp_DocumentsSumAggregateResult = {
  __typename?: "msp_documentsSumAggregateResult";
  /** Sum of access_count across all matching records */
  access_count?: Maybe<Scalars["BigInt"]["output"]>;
  /** Sum of content_byte_size across all matching records */
  content_byte_size?: Maybe<Scalars["BigInt"]["output"]>;
  /** Sum of estimated_read_time across all matching records */
  estimated_read_time?: Maybe<Scalars["BigInt"]["output"]>;
};

export type Msp_DocumentsUpdateInput = {
  access_count?: InputMaybe<Scalars["Int"]["input"]>;
  category?: InputMaybe<Scalars["String"]["input"]>;
  client_id?: InputMaybe<Scalars["UUID"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  content?: InputMaybe<Scalars["String"]["input"]>;
  content_byte_size?: InputMaybe<Scalars["Int"]["input"]>;
  content_content_type?: InputMaybe<Scalars["String"]["input"]>;
  content_preview?: InputMaybe<Scalars["String"]["input"]>;
  content_s3_key?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  difficulty?: InputMaybe<Scalars["String"]["input"]>;
  estimated_read_time?: InputMaybe<Scalars["Int"]["input"]>;
  excerpt?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_featured?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  last_accessed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  shared_with_users?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  updated_by?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Msp_DocumentsUpdateResponse = {
  __typename?: "msp_documentsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Msp_Documents>;
};

export type Note_Type = "call" | "email" | "general" | "internal" | "meeting" | "proposal";

/** Boolean expression comparing fields on type "note_type" */
export type Note_TypeFilter = {
  eq?: InputMaybe<Note_Type>;
  in?: InputMaybe<Array<Note_Type>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Note_Type>;
};

export type Notetaker_Summary_Log = Node & {
  __typename?: "notetaker_summary_log";
  canvas_id?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Datetime"]["output"];
  email_external_id: Scalars["String"]["output"];
  error?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  mailbox?: Maybe<Scalars["String"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  notetaker_source: Scalars["String"]["output"];
  sender_email: Scalars["String"]["output"];
  slack_channel_id: Scalars["String"]["output"];
  slack_message_ts?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  subject?: Maybe<Scalars["String"]["output"]>;
  updated_at: Scalars["Datetime"]["output"];
};

export type Notetaker_Summary_LogConnection = {
  __typename?: "notetaker_summary_logConnection";
  edges: Array<Notetaker_Summary_LogEdge>;
  pageInfo: PageInfo;
};

export type Notetaker_Summary_LogDeleteResponse = {
  __typename?: "notetaker_summary_logDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Notetaker_Summary_Log>;
};

export type Notetaker_Summary_LogEdge = {
  __typename?: "notetaker_summary_logEdge";
  cursor: Scalars["String"]["output"];
  node: Notetaker_Summary_Log;
};

export type Notetaker_Summary_LogFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Notetaker_Summary_LogFilter>>;
  canvas_id?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  email_external_id?: InputMaybe<StringFilter>;
  error?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  mailbox?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Notetaker_Summary_LogFilter>;
  notetaker_source?: InputMaybe<StringFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Notetaker_Summary_LogFilter>>;
  sender_email?: InputMaybe<StringFilter>;
  slack_channel_id?: InputMaybe<StringFilter>;
  slack_message_ts?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  subject?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Notetaker_Summary_LogInsertInput = {
  canvas_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  email_external_id?: InputMaybe<Scalars["String"]["input"]>;
  error?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  mailbox?: InputMaybe<Scalars["String"]["input"]>;
  notetaker_source?: InputMaybe<Scalars["String"]["input"]>;
  sender_email?: InputMaybe<Scalars["String"]["input"]>;
  slack_channel_id?: InputMaybe<Scalars["String"]["input"]>;
  slack_message_ts?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  subject?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Notetaker_Summary_LogInsertResponse = {
  __typename?: "notetaker_summary_logInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Notetaker_Summary_Log>;
};

export type Notetaker_Summary_LogOrderBy = {
  canvas_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  email_external_id?: InputMaybe<OrderByDirection>;
  error?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  mailbox?: InputMaybe<OrderByDirection>;
  notetaker_source?: InputMaybe<OrderByDirection>;
  sender_email?: InputMaybe<OrderByDirection>;
  slack_channel_id?: InputMaybe<OrderByDirection>;
  slack_message_ts?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  subject?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Notetaker_Summary_LogUpdateInput = {
  canvas_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  email_external_id?: InputMaybe<Scalars["String"]["input"]>;
  error?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  mailbox?: InputMaybe<Scalars["String"]["input"]>;
  notetaker_source?: InputMaybe<Scalars["String"]["input"]>;
  sender_email?: InputMaybe<Scalars["String"]["input"]>;
  slack_channel_id?: InputMaybe<Scalars["String"]["input"]>;
  slack_message_ts?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  subject?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Notetaker_Summary_LogUpdateResponse = {
  __typename?: "notetaker_summary_logUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Notetaker_Summary_Log>;
};

export type Notification_Preferences = Node & {
  __typename?: "notification_preferences";
  app_users?: Maybe<App_Users>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  email_address?: Maybe<Scalars["String"]["output"]>;
  email_enabled?: Maybe<Scalars["Boolean"]["output"]>;
  enabled?: Maybe<Scalars["Boolean"]["output"]>;
  event_type: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  phone_number?: Maybe<Scalars["String"]["output"]>;
  push_enabled: Scalars["Boolean"]["output"];
  reminder_config?: Maybe<Scalars["JSON"]["output"]>;
  slack_channel_id?: Maybe<Scalars["String"]["output"]>;
  slack_enabled?: Maybe<Scalars["Boolean"]["output"]>;
  slack_user_id?: Maybe<Scalars["String"]["output"]>;
  sms_enabled?: Maybe<Scalars["Boolean"]["output"]>;
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  user_id: Scalars["UUID"]["output"];
};

export type Notification_PreferencesConnection = {
  __typename?: "notification_preferencesConnection";
  edges: Array<Notification_PreferencesEdge>;
  pageInfo: PageInfo;
};

export type Notification_PreferencesDeleteResponse = {
  __typename?: "notification_preferencesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Notification_Preferences>;
};

export type Notification_PreferencesEdge = {
  __typename?: "notification_preferencesEdge";
  cursor: Scalars["String"]["output"];
  node: Notification_Preferences;
};

export type Notification_PreferencesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Notification_PreferencesFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  email_address?: InputMaybe<StringFilter>;
  email_enabled?: InputMaybe<BooleanFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  event_type?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Notification_PreferencesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Notification_PreferencesFilter>>;
  phone_number?: InputMaybe<StringFilter>;
  push_enabled?: InputMaybe<BooleanFilter>;
  slack_channel_id?: InputMaybe<StringFilter>;
  slack_enabled?: InputMaybe<BooleanFilter>;
  slack_user_id?: InputMaybe<StringFilter>;
  sms_enabled?: InputMaybe<BooleanFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Notification_PreferencesInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  email_address?: InputMaybe<Scalars["String"]["input"]>;
  email_enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  event_type?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  phone_number?: InputMaybe<Scalars["String"]["input"]>;
  push_enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  reminder_config?: InputMaybe<Scalars["JSON"]["input"]>;
  slack_channel_id?: InputMaybe<Scalars["String"]["input"]>;
  slack_enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  slack_user_id?: InputMaybe<Scalars["String"]["input"]>;
  sms_enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Notification_PreferencesInsertResponse = {
  __typename?: "notification_preferencesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Notification_Preferences>;
};

export type Notification_PreferencesOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  email_address?: InputMaybe<OrderByDirection>;
  email_enabled?: InputMaybe<OrderByDirection>;
  enabled?: InputMaybe<OrderByDirection>;
  event_type?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  phone_number?: InputMaybe<OrderByDirection>;
  push_enabled?: InputMaybe<OrderByDirection>;
  slack_channel_id?: InputMaybe<OrderByDirection>;
  slack_enabled?: InputMaybe<OrderByDirection>;
  slack_user_id?: InputMaybe<OrderByDirection>;
  sms_enabled?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Notification_PreferencesUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  email_address?: InputMaybe<Scalars["String"]["input"]>;
  email_enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  event_type?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  phone_number?: InputMaybe<Scalars["String"]["input"]>;
  push_enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  reminder_config?: InputMaybe<Scalars["JSON"]["input"]>;
  slack_channel_id?: InputMaybe<Scalars["String"]["input"]>;
  slack_enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  slack_user_id?: InputMaybe<Scalars["String"]["input"]>;
  sms_enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Notification_PreferencesUpdateResponse = {
  __typename?: "notification_preferencesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Notification_Preferences>;
};

export type Offerings = Node & {
  __typename?: "offerings";
  app_users?: Maybe<App_Users>;
  base_price?: Maybe<Scalars["BigFloat"]["output"]>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  created_by?: Maybe<Scalars["UUID"]["output"]>;
  cta_href?: Maybe<Scalars["String"]["output"]>;
  cta_text?: Maybe<Scalars["String"]["output"]>;
  delivery_kit?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  executive_summary?: Maybe<Scalars["String"]["output"]>;
  hard_cost_line_items?: Maybe<Scalars["JSON"]["output"]>;
  id: Scalars["UUID"]["output"];
  image_url?: Maybe<Scalars["String"]["output"]>;
  linked_project_slug?: Maybe<Scalars["String"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  one_pager_pdf_url?: Maybe<Scalars["String"]["output"]>;
  pricing_display?: Maybe<Scalars["String"]["output"]>;
  pricing_model?: Maybe<Scalars["String"]["output"]>;
  search_vector?: Maybe<Scalars["Opaque"]["output"]>;
  staff_line_items?: Maybe<Scalars["JSON"]["output"]>;
  tags?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  title: Scalars["String"]["output"];
  total_cost?: Maybe<Scalars["BigFloat"]["output"]>;
  total_hard_costs?: Maybe<Scalars["BigFloat"]["output"]>;
  total_hours?: Maybe<Scalars["BigFloat"]["output"]>;
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  website_id?: Maybe<Scalars["String"]["output"]>;
};

export type OfferingsConnection = {
  __typename?: "offeringsConnection";
  edges: Array<OfferingsEdge>;
  pageInfo: PageInfo;
  /** The total number of records matching the `filter` criteria */
  totalCount: Scalars["Int"]["output"];
};

export type OfferingsDeleteResponse = {
  __typename?: "offeringsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Offerings>;
};

export type OfferingsEdge = {
  __typename?: "offeringsEdge";
  cursor: Scalars["String"]["output"];
  node: Offerings;
};

export type OfferingsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<OfferingsFilter>>;
  base_price?: InputMaybe<BigFloatFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  cta_href?: InputMaybe<StringFilter>;
  cta_text?: InputMaybe<StringFilter>;
  delivery_kit?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  executive_summary?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  image_url?: InputMaybe<StringFilter>;
  linked_project_slug?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<OfferingsFilter>;
  one_pager_pdf_url?: InputMaybe<StringFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<OfferingsFilter>>;
  pricing_display?: InputMaybe<StringFilter>;
  pricing_model?: InputMaybe<StringFilter>;
  search_vector?: InputMaybe<OpaqueFilter>;
  tags?: InputMaybe<StringListFilter>;
  title?: InputMaybe<StringFilter>;
  total_cost?: InputMaybe<BigFloatFilter>;
  total_hard_costs?: InputMaybe<BigFloatFilter>;
  total_hours?: InputMaybe<BigFloatFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  website_id?: InputMaybe<StringFilter>;
};

export type OfferingsInsertInput = {
  base_price?: InputMaybe<Scalars["BigFloat"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  cta_href?: InputMaybe<Scalars["String"]["input"]>;
  cta_text?: InputMaybe<Scalars["String"]["input"]>;
  delivery_kit?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  executive_summary?: InputMaybe<Scalars["String"]["input"]>;
  hard_cost_line_items?: InputMaybe<Scalars["JSON"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  image_url?: InputMaybe<Scalars["String"]["input"]>;
  linked_project_slug?: InputMaybe<Scalars["String"]["input"]>;
  one_pager_pdf_url?: InputMaybe<Scalars["String"]["input"]>;
  pricing_display?: InputMaybe<Scalars["String"]["input"]>;
  pricing_model?: InputMaybe<Scalars["String"]["input"]>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  staff_line_items?: InputMaybe<Scalars["JSON"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  total_cost?: InputMaybe<Scalars["BigFloat"]["input"]>;
  total_hard_costs?: InputMaybe<Scalars["BigFloat"]["input"]>;
  total_hours?: InputMaybe<Scalars["BigFloat"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  website_id?: InputMaybe<Scalars["String"]["input"]>;
};

export type OfferingsInsertResponse = {
  __typename?: "offeringsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Offerings>;
};

export type OfferingsOrderBy = {
  base_price?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  cta_href?: InputMaybe<OrderByDirection>;
  cta_text?: InputMaybe<OrderByDirection>;
  delivery_kit?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  executive_summary?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  image_url?: InputMaybe<OrderByDirection>;
  linked_project_slug?: InputMaybe<OrderByDirection>;
  one_pager_pdf_url?: InputMaybe<OrderByDirection>;
  pricing_display?: InputMaybe<OrderByDirection>;
  pricing_model?: InputMaybe<OrderByDirection>;
  search_vector?: InputMaybe<OrderByDirection>;
  title?: InputMaybe<OrderByDirection>;
  total_cost?: InputMaybe<OrderByDirection>;
  total_hard_costs?: InputMaybe<OrderByDirection>;
  total_hours?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  website_id?: InputMaybe<OrderByDirection>;
};

export type OfferingsUpdateInput = {
  base_price?: InputMaybe<Scalars["BigFloat"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  cta_href?: InputMaybe<Scalars["String"]["input"]>;
  cta_text?: InputMaybe<Scalars["String"]["input"]>;
  delivery_kit?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  executive_summary?: InputMaybe<Scalars["String"]["input"]>;
  hard_cost_line_items?: InputMaybe<Scalars["JSON"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  image_url?: InputMaybe<Scalars["String"]["input"]>;
  linked_project_slug?: InputMaybe<Scalars["String"]["input"]>;
  one_pager_pdf_url?: InputMaybe<Scalars["String"]["input"]>;
  pricing_display?: InputMaybe<Scalars["String"]["input"]>;
  pricing_model?: InputMaybe<Scalars["String"]["input"]>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  staff_line_items?: InputMaybe<Scalars["JSON"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  total_cost?: InputMaybe<Scalars["BigFloat"]["input"]>;
  total_hard_costs?: InputMaybe<Scalars["BigFloat"]["input"]>;
  total_hours?: InputMaybe<Scalars["BigFloat"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  website_id?: InputMaybe<Scalars["String"]["input"]>;
};

export type OfferingsUpdateResponse = {
  __typename?: "offeringsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Offerings>;
};

export type Pending_Approvals = Node & {
  __typename?: "pending_approvals";
  approval_id: Scalars["String"]["output"];
  created_at: Scalars["Datetime"]["output"];
  enhanced: Scalars["JSON"]["output"];
  id_column: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  row_id: Scalars["String"]["output"];
  slack_channel?: Maybe<Scalars["String"]["output"]>;
  slack_ts?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  table_name: Scalars["String"]["output"];
};

export type Pending_ApprovalsConnection = {
  __typename?: "pending_approvalsConnection";
  edges: Array<Pending_ApprovalsEdge>;
  pageInfo: PageInfo;
};

export type Pending_ApprovalsDeleteResponse = {
  __typename?: "pending_approvalsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Pending_Approvals>;
};

export type Pending_ApprovalsEdge = {
  __typename?: "pending_approvalsEdge";
  cursor: Scalars["String"]["output"];
  node: Pending_Approvals;
};

export type Pending_ApprovalsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Pending_ApprovalsFilter>>;
  approval_id?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  id_column?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Pending_ApprovalsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Pending_ApprovalsFilter>>;
  row_id?: InputMaybe<StringFilter>;
  slack_channel?: InputMaybe<StringFilter>;
  slack_ts?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  table_name?: InputMaybe<StringFilter>;
};

export type Pending_ApprovalsInsertInput = {
  approval_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  enhanced?: InputMaybe<Scalars["JSON"]["input"]>;
  id_column?: InputMaybe<Scalars["String"]["input"]>;
  row_id?: InputMaybe<Scalars["String"]["input"]>;
  slack_channel?: InputMaybe<Scalars["String"]["input"]>;
  slack_ts?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  table_name?: InputMaybe<Scalars["String"]["input"]>;
};

export type Pending_ApprovalsInsertResponse = {
  __typename?: "pending_approvalsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Pending_Approvals>;
};

export type Pending_ApprovalsOrderBy = {
  approval_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  id_column?: InputMaybe<OrderByDirection>;
  row_id?: InputMaybe<OrderByDirection>;
  slack_channel?: InputMaybe<OrderByDirection>;
  slack_ts?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  table_name?: InputMaybe<OrderByDirection>;
};

export type Pending_ApprovalsUpdateInput = {
  approval_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  enhanced?: InputMaybe<Scalars["JSON"]["input"]>;
  id_column?: InputMaybe<Scalars["String"]["input"]>;
  row_id?: InputMaybe<Scalars["String"]["input"]>;
  slack_channel?: InputMaybe<Scalars["String"]["input"]>;
  slack_ts?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  table_name?: InputMaybe<Scalars["String"]["input"]>;
};

export type Pending_ApprovalsUpdateResponse = {
  __typename?: "pending_approvalsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Pending_Approvals>;
};

export type Plaid_Accounts = Node & {
  __typename?: "plaid_accounts";
  account_id: Scalars["String"]["output"];
  available_balance?: Maybe<Scalars["BigFloat"]["output"]>;
  balance_updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  created_at: Scalars["Datetime"]["output"];
  current_balance?: Maybe<Scalars["BigFloat"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  enabled: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  iso_currency_code?: Maybe<Scalars["String"]["output"]>;
  label?: Maybe<Scalars["String"]["output"]>;
  mask?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  plaid_item_id: Scalars["UUID"]["output"];
  plaid_items?: Maybe<Plaid_Items>;
  plaid_statementsCollection?: Maybe<Plaid_StatementsConnection>;
  plaid_transactionsCollection?: Maybe<Plaid_TransactionsConnection>;
  spend_profile?: Maybe<Scalars["String"]["output"]>;
  spend_profile_set_at?: Maybe<Scalars["Datetime"]["output"]>;
  spend_profile_set_by?: Maybe<Scalars["UUID"]["output"]>;
  spend_profile_source?: Maybe<Scalars["String"]["output"]>;
  statements_drive_folder_id?: Maybe<Scalars["String"]["output"]>;
  subtype?: Maybe<Scalars["String"]["output"]>;
  type: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
};

export type Plaid_AccountsPlaid_StatementsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Plaid_StatementsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Plaid_StatementsOrderBy>>;
};

export type Plaid_AccountsPlaid_TransactionsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Plaid_TransactionsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Plaid_TransactionsOrderBy>>;
};

export type Plaid_AccountsConnection = {
  __typename?: "plaid_accountsConnection";
  edges: Array<Plaid_AccountsEdge>;
  pageInfo: PageInfo;
};

export type Plaid_AccountsDeleteResponse = {
  __typename?: "plaid_accountsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Plaid_Accounts>;
};

export type Plaid_AccountsEdge = {
  __typename?: "plaid_accountsEdge";
  cursor: Scalars["String"]["output"];
  node: Plaid_Accounts;
};

export type Plaid_AccountsFilter = {
  account_id?: InputMaybe<StringFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Plaid_AccountsFilter>>;
  available_balance?: InputMaybe<BigFloatFilter>;
  balance_updated_at?: InputMaybe<DatetimeFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  current_balance?: InputMaybe<BigFloatFilter>;
  description?: InputMaybe<StringFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<UuidFilter>;
  iso_currency_code?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  mask?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Plaid_AccountsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Plaid_AccountsFilter>>;
  plaid_item_id?: InputMaybe<UuidFilter>;
  spend_profile?: InputMaybe<StringFilter>;
  spend_profile_set_at?: InputMaybe<DatetimeFilter>;
  spend_profile_set_by?: InputMaybe<UuidFilter>;
  spend_profile_source?: InputMaybe<StringFilter>;
  statements_drive_folder_id?: InputMaybe<StringFilter>;
  subtype?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Plaid_AccountsInsertInput = {
  account_id?: InputMaybe<Scalars["String"]["input"]>;
  available_balance?: InputMaybe<Scalars["BigFloat"]["input"]>;
  balance_updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  current_balance?: InputMaybe<Scalars["BigFloat"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  iso_currency_code?: InputMaybe<Scalars["String"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  mask?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  plaid_item_id?: InputMaybe<Scalars["UUID"]["input"]>;
  spend_profile?: InputMaybe<Scalars["String"]["input"]>;
  spend_profile_set_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  spend_profile_set_by?: InputMaybe<Scalars["UUID"]["input"]>;
  spend_profile_source?: InputMaybe<Scalars["String"]["input"]>;
  statements_drive_folder_id?: InputMaybe<Scalars["String"]["input"]>;
  subtype?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Plaid_AccountsInsertResponse = {
  __typename?: "plaid_accountsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Plaid_Accounts>;
};

export type Plaid_AccountsOrderBy = {
  account_id?: InputMaybe<OrderByDirection>;
  available_balance?: InputMaybe<OrderByDirection>;
  balance_updated_at?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  current_balance?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  enabled?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  iso_currency_code?: InputMaybe<OrderByDirection>;
  label?: InputMaybe<OrderByDirection>;
  mask?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  plaid_item_id?: InputMaybe<OrderByDirection>;
  spend_profile?: InputMaybe<OrderByDirection>;
  spend_profile_set_at?: InputMaybe<OrderByDirection>;
  spend_profile_set_by?: InputMaybe<OrderByDirection>;
  spend_profile_source?: InputMaybe<OrderByDirection>;
  statements_drive_folder_id?: InputMaybe<OrderByDirection>;
  subtype?: InputMaybe<OrderByDirection>;
  type?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Plaid_AccountsUpdateInput = {
  account_id?: InputMaybe<Scalars["String"]["input"]>;
  available_balance?: InputMaybe<Scalars["BigFloat"]["input"]>;
  balance_updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  current_balance?: InputMaybe<Scalars["BigFloat"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  iso_currency_code?: InputMaybe<Scalars["String"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  mask?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  plaid_item_id?: InputMaybe<Scalars["UUID"]["input"]>;
  spend_profile?: InputMaybe<Scalars["String"]["input"]>;
  spend_profile_set_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  spend_profile_set_by?: InputMaybe<Scalars["UUID"]["input"]>;
  spend_profile_source?: InputMaybe<Scalars["String"]["input"]>;
  statements_drive_folder_id?: InputMaybe<Scalars["String"]["input"]>;
  subtype?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Plaid_AccountsUpdateResponse = {
  __typename?: "plaid_accountsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Plaid_Accounts>;
};

export type Plaid_Items = Node & {
  __typename?: "plaid_items";
  access_token_encrypted: Scalars["String"]["output"];
  app_users?: Maybe<App_Users>;
  companies?: Maybe<Companies>;
  company_id?: Maybe<Scalars["UUID"]["output"]>;
  connected_by?: Maybe<Scalars["UUID"]["output"]>;
  created_at: Scalars["Datetime"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  institution_name?: Maybe<Scalars["String"]["output"]>;
  item_id: Scalars["String"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  plaid_accountsCollection?: Maybe<Plaid_AccountsConnection>;
  plaid_statementsCollection?: Maybe<Plaid_StatementsConnection>;
  statements_drive_folder_id?: Maybe<Scalars["String"]["output"]>;
  statements_enabled: Scalars["Boolean"]["output"];
  statements_last_error?: Maybe<Scalars["String"]["output"]>;
  statements_last_synced_at?: Maybe<Scalars["Datetime"]["output"]>;
  status: Scalars["String"]["output"];
  transactions_cursor?: Maybe<Scalars["String"]["output"]>;
  updated_at: Scalars["Datetime"]["output"];
};

export type Plaid_ItemsPlaid_AccountsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Plaid_AccountsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Plaid_AccountsOrderBy>>;
};

export type Plaid_ItemsPlaid_StatementsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Plaid_StatementsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Plaid_StatementsOrderBy>>;
};

export type Plaid_ItemsConnection = {
  __typename?: "plaid_itemsConnection";
  edges: Array<Plaid_ItemsEdge>;
  pageInfo: PageInfo;
};

export type Plaid_ItemsDeleteResponse = {
  __typename?: "plaid_itemsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Plaid_Items>;
};

export type Plaid_ItemsEdge = {
  __typename?: "plaid_itemsEdge";
  cursor: Scalars["String"]["output"];
  node: Plaid_Items;
};

export type Plaid_ItemsFilter = {
  access_token_encrypted?: InputMaybe<StringFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Plaid_ItemsFilter>>;
  company_id?: InputMaybe<UuidFilter>;
  connected_by?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  institution_name?: InputMaybe<StringFilter>;
  item_id?: InputMaybe<StringFilter>;
  label?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Plaid_ItemsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Plaid_ItemsFilter>>;
  statements_drive_folder_id?: InputMaybe<StringFilter>;
  statements_enabled?: InputMaybe<BooleanFilter>;
  statements_last_error?: InputMaybe<StringFilter>;
  statements_last_synced_at?: InputMaybe<DatetimeFilter>;
  status?: InputMaybe<StringFilter>;
  transactions_cursor?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Plaid_ItemsInsertInput = {
  access_token_encrypted?: InputMaybe<Scalars["String"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  connected_by?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  institution_name?: InputMaybe<Scalars["String"]["input"]>;
  item_id?: InputMaybe<Scalars["String"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  statements_drive_folder_id?: InputMaybe<Scalars["String"]["input"]>;
  statements_enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  statements_last_error?: InputMaybe<Scalars["String"]["input"]>;
  statements_last_synced_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  transactions_cursor?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Plaid_ItemsInsertResponse = {
  __typename?: "plaid_itemsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Plaid_Items>;
};

export type Plaid_ItemsOrderBy = {
  access_token_encrypted?: InputMaybe<OrderByDirection>;
  company_id?: InputMaybe<OrderByDirection>;
  connected_by?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  institution_name?: InputMaybe<OrderByDirection>;
  item_id?: InputMaybe<OrderByDirection>;
  label?: InputMaybe<OrderByDirection>;
  statements_drive_folder_id?: InputMaybe<OrderByDirection>;
  statements_enabled?: InputMaybe<OrderByDirection>;
  statements_last_error?: InputMaybe<OrderByDirection>;
  statements_last_synced_at?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  transactions_cursor?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Plaid_ItemsUpdateInput = {
  access_token_encrypted?: InputMaybe<Scalars["String"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  connected_by?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  institution_name?: InputMaybe<Scalars["String"]["input"]>;
  item_id?: InputMaybe<Scalars["String"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  statements_drive_folder_id?: InputMaybe<Scalars["String"]["input"]>;
  statements_enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  statements_last_error?: InputMaybe<Scalars["String"]["input"]>;
  statements_last_synced_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  transactions_cursor?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Plaid_ItemsUpdateResponse = {
  __typename?: "plaid_itemsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Plaid_Items>;
};

export type Plaid_Statements = Node & {
  __typename?: "plaid_statements";
  account_id: Scalars["String"]["output"];
  content_hash?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Datetime"]["output"];
  date_posted?: Maybe<Scalars["Date"]["output"]>;
  drive_file_id?: Maybe<Scalars["String"]["output"]>;
  drive_folder_id?: Maybe<Scalars["String"]["output"]>;
  drive_synced_at?: Maybe<Scalars["Datetime"]["output"]>;
  drive_web_view_link?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  month: Scalars["Int"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  plaid_accounts?: Maybe<Plaid_Accounts>;
  plaid_item_id: Scalars["UUID"]["output"];
  plaid_items?: Maybe<Plaid_Items>;
  s3_key?: Maybe<Scalars["String"]["output"]>;
  statement_id: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
  year: Scalars["Int"]["output"];
};

export type Plaid_StatementsConnection = {
  __typename?: "plaid_statementsConnection";
  edges: Array<Plaid_StatementsEdge>;
  pageInfo: PageInfo;
};

export type Plaid_StatementsDeleteResponse = {
  __typename?: "plaid_statementsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Plaid_Statements>;
};

export type Plaid_StatementsEdge = {
  __typename?: "plaid_statementsEdge";
  cursor: Scalars["String"]["output"];
  node: Plaid_Statements;
};

export type Plaid_StatementsFilter = {
  account_id?: InputMaybe<StringFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Plaid_StatementsFilter>>;
  content_hash?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  date_posted?: InputMaybe<DateFilter>;
  drive_file_id?: InputMaybe<StringFilter>;
  drive_folder_id?: InputMaybe<StringFilter>;
  drive_synced_at?: InputMaybe<DatetimeFilter>;
  drive_web_view_link?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  month?: InputMaybe<IntFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Plaid_StatementsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Plaid_StatementsFilter>>;
  plaid_item_id?: InputMaybe<UuidFilter>;
  s3_key?: InputMaybe<StringFilter>;
  statement_id?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  year?: InputMaybe<IntFilter>;
};

export type Plaid_StatementsInsertInput = {
  account_id?: InputMaybe<Scalars["String"]["input"]>;
  content_hash?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  date_posted?: InputMaybe<Scalars["Date"]["input"]>;
  drive_file_id?: InputMaybe<Scalars["String"]["input"]>;
  drive_folder_id?: InputMaybe<Scalars["String"]["input"]>;
  drive_synced_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  drive_web_view_link?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  month?: InputMaybe<Scalars["Int"]["input"]>;
  plaid_item_id?: InputMaybe<Scalars["UUID"]["input"]>;
  s3_key?: InputMaybe<Scalars["String"]["input"]>;
  statement_id?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  year?: InputMaybe<Scalars["Int"]["input"]>;
};

export type Plaid_StatementsInsertResponse = {
  __typename?: "plaid_statementsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Plaid_Statements>;
};

export type Plaid_StatementsOrderBy = {
  account_id?: InputMaybe<OrderByDirection>;
  content_hash?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  date_posted?: InputMaybe<OrderByDirection>;
  drive_file_id?: InputMaybe<OrderByDirection>;
  drive_folder_id?: InputMaybe<OrderByDirection>;
  drive_synced_at?: InputMaybe<OrderByDirection>;
  drive_web_view_link?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  month?: InputMaybe<OrderByDirection>;
  plaid_item_id?: InputMaybe<OrderByDirection>;
  s3_key?: InputMaybe<OrderByDirection>;
  statement_id?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  year?: InputMaybe<OrderByDirection>;
};

export type Plaid_StatementsUpdateInput = {
  account_id?: InputMaybe<Scalars["String"]["input"]>;
  content_hash?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  date_posted?: InputMaybe<Scalars["Date"]["input"]>;
  drive_file_id?: InputMaybe<Scalars["String"]["input"]>;
  drive_folder_id?: InputMaybe<Scalars["String"]["input"]>;
  drive_synced_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  drive_web_view_link?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  month?: InputMaybe<Scalars["Int"]["input"]>;
  plaid_item_id?: InputMaybe<Scalars["UUID"]["input"]>;
  s3_key?: InputMaybe<Scalars["String"]["input"]>;
  statement_id?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  year?: InputMaybe<Scalars["Int"]["input"]>;
};

export type Plaid_StatementsUpdateResponse = {
  __typename?: "plaid_statementsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Plaid_Statements>;
};

export type Plaid_Transaction_Attributions = Node & {
  __typename?: "plaid_transaction_attributions";
  app_users?: Maybe<App_Users>;
  attributed_at: Scalars["Datetime"]["output"];
  attributed_by?: Maybe<Scalars["UUID"]["output"]>;
  companies?: Maybe<Companies>;
  company_id?: Maybe<Scalars["UUID"]["output"]>;
  cost_category?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  is_net_cost: Scalars["Boolean"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  plaid_transaction_id: Scalars["String"]["output"];
  plaid_transactions?: Maybe<Plaid_Transactions>;
  source: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
};

export type Plaid_Transaction_AttributionsConnection = {
  __typename?: "plaid_transaction_attributionsConnection";
  edges: Array<Plaid_Transaction_AttributionsEdge>;
  pageInfo: PageInfo;
};

export type Plaid_Transaction_AttributionsDeleteResponse = {
  __typename?: "plaid_transaction_attributionsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Plaid_Transaction_Attributions>;
};

export type Plaid_Transaction_AttributionsEdge = {
  __typename?: "plaid_transaction_attributionsEdge";
  cursor: Scalars["String"]["output"];
  node: Plaid_Transaction_Attributions;
};

export type Plaid_Transaction_AttributionsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Plaid_Transaction_AttributionsFilter>>;
  attributed_at?: InputMaybe<DatetimeFilter>;
  attributed_by?: InputMaybe<UuidFilter>;
  company_id?: InputMaybe<UuidFilter>;
  cost_category?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  is_net_cost?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Plaid_Transaction_AttributionsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Plaid_Transaction_AttributionsFilter>>;
  plaid_transaction_id?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Plaid_Transaction_AttributionsInsertInput = {
  attributed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  attributed_by?: InputMaybe<Scalars["UUID"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  cost_category?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_net_cost?: InputMaybe<Scalars["Boolean"]["input"]>;
  plaid_transaction_id?: InputMaybe<Scalars["String"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Plaid_Transaction_AttributionsInsertResponse = {
  __typename?: "plaid_transaction_attributionsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Plaid_Transaction_Attributions>;
};

export type Plaid_Transaction_AttributionsOrderBy = {
  attributed_at?: InputMaybe<OrderByDirection>;
  attributed_by?: InputMaybe<OrderByDirection>;
  company_id?: InputMaybe<OrderByDirection>;
  cost_category?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_net_cost?: InputMaybe<OrderByDirection>;
  plaid_transaction_id?: InputMaybe<OrderByDirection>;
  source?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Plaid_Transaction_AttributionsUpdateInput = {
  attributed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  attributed_by?: InputMaybe<Scalars["UUID"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  cost_category?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_net_cost?: InputMaybe<Scalars["Boolean"]["input"]>;
  plaid_transaction_id?: InputMaybe<Scalars["String"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Plaid_Transaction_AttributionsUpdateResponse = {
  __typename?: "plaid_transaction_attributionsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Plaid_Transaction_Attributions>;
};

export type Plaid_Transactions = Node & {
  __typename?: "plaid_transactions";
  account_id: Scalars["String"]["output"];
  amount: Scalars["BigFloat"]["output"];
  counterparties?: Maybe<Scalars["JSON"]["output"]>;
  counterparty_entity_id?: Maybe<Scalars["String"]["output"]>;
  counterparty_name?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Datetime"]["output"];
  date: Scalars["Date"]["output"];
  id: Scalars["UUID"]["output"];
  iso_currency_code?: Maybe<Scalars["String"]["output"]>;
  merchant_key?: Maybe<Scalars["String"]["output"]>;
  merchant_name?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  pending: Scalars["Boolean"]["output"];
  pfc_confidence?: Maybe<Scalars["String"]["output"]>;
  pfc_detailed?: Maybe<Scalars["String"]["output"]>;
  pfc_primary?: Maybe<Scalars["String"]["output"]>;
  plaid_accounts?: Maybe<Plaid_Accounts>;
  plaid_transaction_attributions?: Maybe<Plaid_Transaction_Attributions>;
  plaid_transaction_id: Scalars["String"]["output"];
  raw_s3_key?: Maybe<Scalars["String"]["output"]>;
  search_vector?: Maybe<Scalars["Opaque"]["output"]>;
  updated_at: Scalars["Datetime"]["output"];
};

export type Plaid_TransactionsConnection = {
  __typename?: "plaid_transactionsConnection";
  edges: Array<Plaid_TransactionsEdge>;
  pageInfo: PageInfo;
};

export type Plaid_TransactionsDeleteResponse = {
  __typename?: "plaid_transactionsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Plaid_Transactions>;
};

export type Plaid_TransactionsEdge = {
  __typename?: "plaid_transactionsEdge";
  cursor: Scalars["String"]["output"];
  node: Plaid_Transactions;
};

export type Plaid_TransactionsFilter = {
  account_id?: InputMaybe<StringFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Plaid_TransactionsFilter>>;
  counterparty_entity_id?: InputMaybe<StringFilter>;
  counterparty_name?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  date?: InputMaybe<DateFilter>;
  id?: InputMaybe<UuidFilter>;
  iso_currency_code?: InputMaybe<StringFilter>;
  merchant_key?: InputMaybe<StringFilter>;
  merchant_name?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Plaid_TransactionsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Plaid_TransactionsFilter>>;
  pending?: InputMaybe<BooleanFilter>;
  pfc_confidence?: InputMaybe<StringFilter>;
  pfc_detailed?: InputMaybe<StringFilter>;
  pfc_primary?: InputMaybe<StringFilter>;
  plaid_transaction_id?: InputMaybe<StringFilter>;
  raw_s3_key?: InputMaybe<StringFilter>;
  search_vector?: InputMaybe<OpaqueFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Plaid_TransactionsInsertInput = {
  account_id?: InputMaybe<Scalars["String"]["input"]>;
  amount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  counterparties?: InputMaybe<Scalars["JSON"]["input"]>;
  counterparty_entity_id?: InputMaybe<Scalars["String"]["input"]>;
  counterparty_name?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  date?: InputMaybe<Scalars["Date"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  iso_currency_code?: InputMaybe<Scalars["String"]["input"]>;
  merchant_key?: InputMaybe<Scalars["String"]["input"]>;
  merchant_name?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  pending?: InputMaybe<Scalars["Boolean"]["input"]>;
  pfc_confidence?: InputMaybe<Scalars["String"]["input"]>;
  pfc_detailed?: InputMaybe<Scalars["String"]["input"]>;
  pfc_primary?: InputMaybe<Scalars["String"]["input"]>;
  plaid_transaction_id?: InputMaybe<Scalars["String"]["input"]>;
  raw_s3_key?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Plaid_TransactionsInsertResponse = {
  __typename?: "plaid_transactionsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Plaid_Transactions>;
};

export type Plaid_TransactionsOrderBy = {
  account_id?: InputMaybe<OrderByDirection>;
  amount?: InputMaybe<OrderByDirection>;
  counterparty_entity_id?: InputMaybe<OrderByDirection>;
  counterparty_name?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  date?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  iso_currency_code?: InputMaybe<OrderByDirection>;
  merchant_key?: InputMaybe<OrderByDirection>;
  merchant_name?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  pending?: InputMaybe<OrderByDirection>;
  pfc_confidence?: InputMaybe<OrderByDirection>;
  pfc_detailed?: InputMaybe<OrderByDirection>;
  pfc_primary?: InputMaybe<OrderByDirection>;
  plaid_transaction_id?: InputMaybe<OrderByDirection>;
  raw_s3_key?: InputMaybe<OrderByDirection>;
  search_vector?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Plaid_TransactionsUpdateInput = {
  account_id?: InputMaybe<Scalars["String"]["input"]>;
  amount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  counterparties?: InputMaybe<Scalars["JSON"]["input"]>;
  counterparty_entity_id?: InputMaybe<Scalars["String"]["input"]>;
  counterparty_name?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  date?: InputMaybe<Scalars["Date"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  iso_currency_code?: InputMaybe<Scalars["String"]["input"]>;
  merchant_key?: InputMaybe<Scalars["String"]["input"]>;
  merchant_name?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  pending?: InputMaybe<Scalars["Boolean"]["input"]>;
  pfc_confidence?: InputMaybe<Scalars["String"]["input"]>;
  pfc_detailed?: InputMaybe<Scalars["String"]["input"]>;
  pfc_primary?: InputMaybe<Scalars["String"]["input"]>;
  plaid_transaction_id?: InputMaybe<Scalars["String"]["input"]>;
  raw_s3_key?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Plaid_TransactionsUpdateResponse = {
  __typename?: "plaid_transactionsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Plaid_Transactions>;
};

export type Post_Audit_Cron_Logs = Node & {
  __typename?: "post_audit_cron_logs";
  createdAt?: Maybe<Scalars["Datetime"]["output"]>;
  duration_ms?: Maybe<Scalars["Int"]["output"]>;
  environment: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  metrics: Scalars["JSON"]["output"];
  month?: Maybe<Scalars["String"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  results: Scalars["JSON"]["output"];
  searchDate?: Maybe<Scalars["Datetime"]["output"]>;
  userEmail: Scalars["String"]["output"];
};

export type Post_Audit_Cron_LogsConnection = {
  __typename?: "post_audit_cron_logsConnection";
  edges: Array<Post_Audit_Cron_LogsEdge>;
  pageInfo: PageInfo;
};

export type Post_Audit_Cron_LogsDeleteResponse = {
  __typename?: "post_audit_cron_logsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Post_Audit_Cron_Logs>;
};

export type Post_Audit_Cron_LogsEdge = {
  __typename?: "post_audit_cron_logsEdge";
  cursor: Scalars["String"]["output"];
  node: Post_Audit_Cron_Logs;
};

export type Post_Audit_Cron_LogsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Post_Audit_Cron_LogsFilter>>;
  createdAt?: InputMaybe<DatetimeFilter>;
  duration_ms?: InputMaybe<IntFilter>;
  environment?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  month?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Post_Audit_Cron_LogsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Post_Audit_Cron_LogsFilter>>;
  searchDate?: InputMaybe<DatetimeFilter>;
  userEmail?: InputMaybe<StringFilter>;
};

export type Post_Audit_Cron_LogsInsertInput = {
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  duration_ms?: InputMaybe<Scalars["Int"]["input"]>;
  environment?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  metrics?: InputMaybe<Scalars["JSON"]["input"]>;
  month?: InputMaybe<Scalars["String"]["input"]>;
  results?: InputMaybe<Scalars["JSON"]["input"]>;
  searchDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  userEmail?: InputMaybe<Scalars["String"]["input"]>;
};

export type Post_Audit_Cron_LogsInsertResponse = {
  __typename?: "post_audit_cron_logsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Post_Audit_Cron_Logs>;
};

export type Post_Audit_Cron_LogsOrderBy = {
  createdAt?: InputMaybe<OrderByDirection>;
  duration_ms?: InputMaybe<OrderByDirection>;
  environment?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  month?: InputMaybe<OrderByDirection>;
  searchDate?: InputMaybe<OrderByDirection>;
  userEmail?: InputMaybe<OrderByDirection>;
};

export type Post_Audit_Cron_LogsUpdateInput = {
  createdAt?: InputMaybe<Scalars["Datetime"]["input"]>;
  duration_ms?: InputMaybe<Scalars["Int"]["input"]>;
  environment?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  metrics?: InputMaybe<Scalars["JSON"]["input"]>;
  month?: InputMaybe<Scalars["String"]["input"]>;
  results?: InputMaybe<Scalars["JSON"]["input"]>;
  searchDate?: InputMaybe<Scalars["Datetime"]["input"]>;
  userEmail?: InputMaybe<Scalars["String"]["input"]>;
};

export type Post_Audit_Cron_LogsUpdateResponse = {
  __typename?: "post_audit_cron_logsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Post_Audit_Cron_Logs>;
};

export type Post_Audit_Documents = Node & {
  __typename?: "post_audit_documents";
  attachment_name: Scalars["String"]["output"];
  card_blocks?: Maybe<Scalars["JSON"]["output"]>;
  completed_at?: Maybe<Scalars["Datetime"]["output"]>;
  completed_by_slack_user_id?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Datetime"]["output"];
  done_folder_id?: Maybe<Scalars["String"]["output"]>;
  drive_file_id?: Maybe<Scalars["String"]["output"]>;
  environment: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  message_id: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  pending_folder_id?: Maybe<Scalars["String"]["output"]>;
  post_audit_invoice_feedbackCollection?: Maybe<Post_Audit_Invoice_FeedbackConnection>;
  post_audit_invoices?: Maybe<Post_Audit_Invoices>;
  slack_channel_id?: Maybe<Scalars["String"]["output"]>;
  slack_message_ts?: Maybe<Scalars["String"]["output"]>;
  source: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
};

export type Post_Audit_DocumentsPost_Audit_Invoice_FeedbackCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Post_Audit_Invoice_FeedbackFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Post_Audit_Invoice_FeedbackOrderBy>>;
};

export type Post_Audit_DocumentsConnection = {
  __typename?: "post_audit_documentsConnection";
  edges: Array<Post_Audit_DocumentsEdge>;
  pageInfo: PageInfo;
};

export type Post_Audit_DocumentsDeleteResponse = {
  __typename?: "post_audit_documentsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Post_Audit_Documents>;
};

export type Post_Audit_DocumentsEdge = {
  __typename?: "post_audit_documentsEdge";
  cursor: Scalars["String"]["output"];
  node: Post_Audit_Documents;
};

export type Post_Audit_DocumentsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Post_Audit_DocumentsFilter>>;
  attachment_name?: InputMaybe<StringFilter>;
  completed_at?: InputMaybe<DatetimeFilter>;
  completed_by_slack_user_id?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  done_folder_id?: InputMaybe<StringFilter>;
  drive_file_id?: InputMaybe<StringFilter>;
  environment?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  message_id?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Post_Audit_DocumentsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Post_Audit_DocumentsFilter>>;
  pending_folder_id?: InputMaybe<StringFilter>;
  slack_channel_id?: InputMaybe<StringFilter>;
  slack_message_ts?: InputMaybe<StringFilter>;
  source?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Post_Audit_DocumentsInsertInput = {
  attachment_name?: InputMaybe<Scalars["String"]["input"]>;
  card_blocks?: InputMaybe<Scalars["JSON"]["input"]>;
  completed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  completed_by_slack_user_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  done_folder_id?: InputMaybe<Scalars["String"]["input"]>;
  drive_file_id?: InputMaybe<Scalars["String"]["input"]>;
  environment?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  message_id?: InputMaybe<Scalars["String"]["input"]>;
  pending_folder_id?: InputMaybe<Scalars["String"]["input"]>;
  slack_channel_id?: InputMaybe<Scalars["String"]["input"]>;
  slack_message_ts?: InputMaybe<Scalars["String"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Post_Audit_DocumentsInsertResponse = {
  __typename?: "post_audit_documentsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Post_Audit_Documents>;
};

export type Post_Audit_DocumentsOrderBy = {
  attachment_name?: InputMaybe<OrderByDirection>;
  completed_at?: InputMaybe<OrderByDirection>;
  completed_by_slack_user_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  done_folder_id?: InputMaybe<OrderByDirection>;
  drive_file_id?: InputMaybe<OrderByDirection>;
  environment?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  message_id?: InputMaybe<OrderByDirection>;
  pending_folder_id?: InputMaybe<OrderByDirection>;
  slack_channel_id?: InputMaybe<OrderByDirection>;
  slack_message_ts?: InputMaybe<OrderByDirection>;
  source?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Post_Audit_DocumentsUpdateInput = {
  attachment_name?: InputMaybe<Scalars["String"]["input"]>;
  card_blocks?: InputMaybe<Scalars["JSON"]["input"]>;
  completed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  completed_by_slack_user_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  done_folder_id?: InputMaybe<Scalars["String"]["input"]>;
  drive_file_id?: InputMaybe<Scalars["String"]["input"]>;
  environment?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  message_id?: InputMaybe<Scalars["String"]["input"]>;
  pending_folder_id?: InputMaybe<Scalars["String"]["input"]>;
  slack_channel_id?: InputMaybe<Scalars["String"]["input"]>;
  slack_message_ts?: InputMaybe<Scalars["String"]["input"]>;
  source?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Post_Audit_DocumentsUpdateResponse = {
  __typename?: "post_audit_documentsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Post_Audit_Documents>;
};

export type Post_Audit_Invoice_Feedback = Node & {
  __typename?: "post_audit_invoice_feedback";
  ai_value?: Maybe<Scalars["JSON"]["output"]>;
  corrected_value?: Maybe<Scalars["JSON"]["output"]>;
  created_at: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  issue_type: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  post_audit_document_id?: Maybe<Scalars["UUID"]["output"]>;
  post_audit_documents?: Maybe<Post_Audit_Documents>;
  post_audit_invoice_id?: Maybe<Scalars["UUID"]["output"]>;
  post_audit_invoices?: Maybe<Post_Audit_Invoices>;
  realm_id?: Maybe<Scalars["String"]["output"]>;
  resolved: Scalars["Boolean"]["output"];
  slack_user_id?: Maybe<Scalars["String"]["output"]>;
  stage: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
};

export type Post_Audit_Invoice_FeedbackConnection = {
  __typename?: "post_audit_invoice_feedbackConnection";
  edges: Array<Post_Audit_Invoice_FeedbackEdge>;
  pageInfo: PageInfo;
};

export type Post_Audit_Invoice_FeedbackDeleteResponse = {
  __typename?: "post_audit_invoice_feedbackDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Post_Audit_Invoice_Feedback>;
};

export type Post_Audit_Invoice_FeedbackEdge = {
  __typename?: "post_audit_invoice_feedbackEdge";
  cursor: Scalars["String"]["output"];
  node: Post_Audit_Invoice_Feedback;
};

export type Post_Audit_Invoice_FeedbackFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Post_Audit_Invoice_FeedbackFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  issue_type?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Post_Audit_Invoice_FeedbackFilter>;
  note?: InputMaybe<StringFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Post_Audit_Invoice_FeedbackFilter>>;
  post_audit_document_id?: InputMaybe<UuidFilter>;
  post_audit_invoice_id?: InputMaybe<UuidFilter>;
  realm_id?: InputMaybe<StringFilter>;
  resolved?: InputMaybe<BooleanFilter>;
  slack_user_id?: InputMaybe<StringFilter>;
  stage?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Post_Audit_Invoice_FeedbackInsertInput = {
  ai_value?: InputMaybe<Scalars["JSON"]["input"]>;
  corrected_value?: InputMaybe<Scalars["JSON"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  issue_type?: InputMaybe<Scalars["String"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  post_audit_document_id?: InputMaybe<Scalars["UUID"]["input"]>;
  post_audit_invoice_id?: InputMaybe<Scalars["UUID"]["input"]>;
  realm_id?: InputMaybe<Scalars["String"]["input"]>;
  resolved?: InputMaybe<Scalars["Boolean"]["input"]>;
  slack_user_id?: InputMaybe<Scalars["String"]["input"]>;
  stage?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Post_Audit_Invoice_FeedbackInsertResponse = {
  __typename?: "post_audit_invoice_feedbackInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Post_Audit_Invoice_Feedback>;
};

export type Post_Audit_Invoice_FeedbackOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  issue_type?: InputMaybe<OrderByDirection>;
  note?: InputMaybe<OrderByDirection>;
  post_audit_document_id?: InputMaybe<OrderByDirection>;
  post_audit_invoice_id?: InputMaybe<OrderByDirection>;
  realm_id?: InputMaybe<OrderByDirection>;
  resolved?: InputMaybe<OrderByDirection>;
  slack_user_id?: InputMaybe<OrderByDirection>;
  stage?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Post_Audit_Invoice_FeedbackUpdateInput = {
  ai_value?: InputMaybe<Scalars["JSON"]["input"]>;
  corrected_value?: InputMaybe<Scalars["JSON"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  issue_type?: InputMaybe<Scalars["String"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  post_audit_document_id?: InputMaybe<Scalars["UUID"]["input"]>;
  post_audit_invoice_id?: InputMaybe<Scalars["UUID"]["input"]>;
  realm_id?: InputMaybe<Scalars["String"]["input"]>;
  resolved?: InputMaybe<Scalars["Boolean"]["input"]>;
  slack_user_id?: InputMaybe<Scalars["String"]["input"]>;
  stage?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Post_Audit_Invoice_FeedbackUpdateResponse = {
  __typename?: "post_audit_invoice_feedbackUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Post_Audit_Invoice_Feedback>;
};

export type Post_Audit_Invoices = Node & {
  __typename?: "post_audit_invoices";
  amount_source?: Maybe<Scalars["String"]["output"]>;
  approved_at?: Maybe<Scalars["Datetime"]["output"]>;
  approved_by_slack_user_id?: Maybe<Scalars["String"]["output"]>;
  audit_month?: Maybe<Scalars["String"]["output"]>;
  category?: Maybe<Scalars["String"]["output"]>;
  created_at: Scalars["Datetime"]["output"];
  environment: Scalars["String"]["output"];
  final_amount?: Maybe<Scalars["BigFloat"]["output"]>;
  ho_reference?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  line_description?: Maybe<Scalars["String"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  post_audit_document_id: Scalars["UUID"]["output"];
  post_audit_documents?: Maybe<Post_Audit_Documents>;
  post_audit_invoice_feedbackCollection?: Maybe<Post_Audit_Invoice_FeedbackConnection>;
  post_audit_number?: Maybe<Scalars["String"]["output"]>;
  proposed_amount?: Maybe<Scalars["BigFloat"]["output"]>;
  qb_customer_name?: Maybe<Scalars["String"]["output"]>;
  qb_customer_ref?: Maybe<Scalars["String"]["output"]>;
  qb_invoice_doc_number?: Maybe<Scalars["String"]["output"]>;
  qb_invoice_id?: Maybe<Scalars["String"]["output"]>;
  qb_item_name?: Maybe<Scalars["String"]["output"]>;
  qb_item_ref?: Maybe<Scalars["String"]["output"]>;
  qb_sync_token?: Maybe<Scalars["String"]["output"]>;
  realm_id: Scalars["String"]["output"];
  savings_figure?: Maybe<Scalars["BigFloat"]["output"]>;
  searched_company_name?: Maybe<Scalars["String"]["output"]>;
  send_method?: Maybe<Scalars["String"]["output"]>;
  sent_at?: Maybe<Scalars["Datetime"]["output"]>;
  status: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
};

export type Post_Audit_InvoicesPost_Audit_Invoice_FeedbackCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Post_Audit_Invoice_FeedbackFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Post_Audit_Invoice_FeedbackOrderBy>>;
};

export type Post_Audit_InvoicesConnection = {
  __typename?: "post_audit_invoicesConnection";
  edges: Array<Post_Audit_InvoicesEdge>;
  pageInfo: PageInfo;
};

export type Post_Audit_InvoicesDeleteResponse = {
  __typename?: "post_audit_invoicesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Post_Audit_Invoices>;
};

export type Post_Audit_InvoicesEdge = {
  __typename?: "post_audit_invoicesEdge";
  cursor: Scalars["String"]["output"];
  node: Post_Audit_Invoices;
};

export type Post_Audit_InvoicesFilter = {
  amount_source?: InputMaybe<StringFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Post_Audit_InvoicesFilter>>;
  approved_at?: InputMaybe<DatetimeFilter>;
  approved_by_slack_user_id?: InputMaybe<StringFilter>;
  audit_month?: InputMaybe<StringFilter>;
  category?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  environment?: InputMaybe<StringFilter>;
  final_amount?: InputMaybe<BigFloatFilter>;
  ho_reference?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  line_description?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Post_Audit_InvoicesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Post_Audit_InvoicesFilter>>;
  post_audit_document_id?: InputMaybe<UuidFilter>;
  post_audit_number?: InputMaybe<StringFilter>;
  proposed_amount?: InputMaybe<BigFloatFilter>;
  qb_customer_name?: InputMaybe<StringFilter>;
  qb_customer_ref?: InputMaybe<StringFilter>;
  qb_invoice_doc_number?: InputMaybe<StringFilter>;
  qb_invoice_id?: InputMaybe<StringFilter>;
  qb_item_name?: InputMaybe<StringFilter>;
  qb_item_ref?: InputMaybe<StringFilter>;
  qb_sync_token?: InputMaybe<StringFilter>;
  realm_id?: InputMaybe<StringFilter>;
  savings_figure?: InputMaybe<BigFloatFilter>;
  searched_company_name?: InputMaybe<StringFilter>;
  send_method?: InputMaybe<StringFilter>;
  sent_at?: InputMaybe<DatetimeFilter>;
  status?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Post_Audit_InvoicesInsertInput = {
  amount_source?: InputMaybe<Scalars["String"]["input"]>;
  approved_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  approved_by_slack_user_id?: InputMaybe<Scalars["String"]["input"]>;
  audit_month?: InputMaybe<Scalars["String"]["input"]>;
  category?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  environment?: InputMaybe<Scalars["String"]["input"]>;
  final_amount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  ho_reference?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  line_description?: InputMaybe<Scalars["String"]["input"]>;
  post_audit_document_id?: InputMaybe<Scalars["UUID"]["input"]>;
  post_audit_number?: InputMaybe<Scalars["String"]["input"]>;
  proposed_amount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  qb_customer_name?: InputMaybe<Scalars["String"]["input"]>;
  qb_customer_ref?: InputMaybe<Scalars["String"]["input"]>;
  qb_invoice_doc_number?: InputMaybe<Scalars["String"]["input"]>;
  qb_invoice_id?: InputMaybe<Scalars["String"]["input"]>;
  qb_item_name?: InputMaybe<Scalars["String"]["input"]>;
  qb_item_ref?: InputMaybe<Scalars["String"]["input"]>;
  qb_sync_token?: InputMaybe<Scalars["String"]["input"]>;
  realm_id?: InputMaybe<Scalars["String"]["input"]>;
  savings_figure?: InputMaybe<Scalars["BigFloat"]["input"]>;
  searched_company_name?: InputMaybe<Scalars["String"]["input"]>;
  send_method?: InputMaybe<Scalars["String"]["input"]>;
  sent_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Post_Audit_InvoicesInsertResponse = {
  __typename?: "post_audit_invoicesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Post_Audit_Invoices>;
};

export type Post_Audit_InvoicesOrderBy = {
  amount_source?: InputMaybe<OrderByDirection>;
  approved_at?: InputMaybe<OrderByDirection>;
  approved_by_slack_user_id?: InputMaybe<OrderByDirection>;
  audit_month?: InputMaybe<OrderByDirection>;
  category?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  environment?: InputMaybe<OrderByDirection>;
  final_amount?: InputMaybe<OrderByDirection>;
  ho_reference?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  line_description?: InputMaybe<OrderByDirection>;
  post_audit_document_id?: InputMaybe<OrderByDirection>;
  post_audit_number?: InputMaybe<OrderByDirection>;
  proposed_amount?: InputMaybe<OrderByDirection>;
  qb_customer_name?: InputMaybe<OrderByDirection>;
  qb_customer_ref?: InputMaybe<OrderByDirection>;
  qb_invoice_doc_number?: InputMaybe<OrderByDirection>;
  qb_invoice_id?: InputMaybe<OrderByDirection>;
  qb_item_name?: InputMaybe<OrderByDirection>;
  qb_item_ref?: InputMaybe<OrderByDirection>;
  qb_sync_token?: InputMaybe<OrderByDirection>;
  realm_id?: InputMaybe<OrderByDirection>;
  savings_figure?: InputMaybe<OrderByDirection>;
  searched_company_name?: InputMaybe<OrderByDirection>;
  send_method?: InputMaybe<OrderByDirection>;
  sent_at?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Post_Audit_InvoicesUpdateInput = {
  amount_source?: InputMaybe<Scalars["String"]["input"]>;
  approved_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  approved_by_slack_user_id?: InputMaybe<Scalars["String"]["input"]>;
  audit_month?: InputMaybe<Scalars["String"]["input"]>;
  category?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  environment?: InputMaybe<Scalars["String"]["input"]>;
  final_amount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  ho_reference?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  line_description?: InputMaybe<Scalars["String"]["input"]>;
  post_audit_document_id?: InputMaybe<Scalars["UUID"]["input"]>;
  post_audit_number?: InputMaybe<Scalars["String"]["input"]>;
  proposed_amount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  qb_customer_name?: InputMaybe<Scalars["String"]["input"]>;
  qb_customer_ref?: InputMaybe<Scalars["String"]["input"]>;
  qb_invoice_doc_number?: InputMaybe<Scalars["String"]["input"]>;
  qb_invoice_id?: InputMaybe<Scalars["String"]["input"]>;
  qb_item_name?: InputMaybe<Scalars["String"]["input"]>;
  qb_item_ref?: InputMaybe<Scalars["String"]["input"]>;
  qb_sync_token?: InputMaybe<Scalars["String"]["input"]>;
  realm_id?: InputMaybe<Scalars["String"]["input"]>;
  savings_figure?: InputMaybe<Scalars["BigFloat"]["input"]>;
  searched_company_name?: InputMaybe<Scalars["String"]["input"]>;
  send_method?: InputMaybe<Scalars["String"]["input"]>;
  sent_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Post_Audit_InvoicesUpdateResponse = {
  __typename?: "post_audit_invoicesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Post_Audit_Invoices>;
};

export type Project_Chat_Subscriptions = Node & {
  __typename?: "project_chat_subscriptions";
  channel: Scalars["String"]["output"];
  created_at: Scalars["Datetime"]["output"];
  deal_id: Scalars["UUID"]["output"];
  deals?: Maybe<Deals>;
  destination: Scalars["String"]["output"];
  display_name?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  is_active: Scalars["Boolean"]["output"];
  last_notified_message_ts?: Maybe<Scalars["String"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  updated_at: Scalars["Datetime"]["output"];
};

export type Project_Chat_SubscriptionsConnection = {
  __typename?: "project_chat_subscriptionsConnection";
  edges: Array<Project_Chat_SubscriptionsEdge>;
  pageInfo: PageInfo;
};

export type Project_Chat_SubscriptionsDeleteResponse = {
  __typename?: "project_chat_subscriptionsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Project_Chat_Subscriptions>;
};

export type Project_Chat_SubscriptionsEdge = {
  __typename?: "project_chat_subscriptionsEdge";
  cursor: Scalars["String"]["output"];
  node: Project_Chat_Subscriptions;
};

export type Project_Chat_SubscriptionsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Project_Chat_SubscriptionsFilter>>;
  channel?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  deal_id?: InputMaybe<UuidFilter>;
  destination?: InputMaybe<StringFilter>;
  display_name?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  is_active?: InputMaybe<BooleanFilter>;
  last_notified_message_ts?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Project_Chat_SubscriptionsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Project_Chat_SubscriptionsFilter>>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Project_Chat_SubscriptionsInsertInput = {
  channel?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  deal_id?: InputMaybe<Scalars["UUID"]["input"]>;
  destination?: InputMaybe<Scalars["String"]["input"]>;
  display_name?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  last_notified_message_ts?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Project_Chat_SubscriptionsInsertResponse = {
  __typename?: "project_chat_subscriptionsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Project_Chat_Subscriptions>;
};

export type Project_Chat_SubscriptionsOrderBy = {
  channel?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  deal_id?: InputMaybe<OrderByDirection>;
  destination?: InputMaybe<OrderByDirection>;
  display_name?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_active?: InputMaybe<OrderByDirection>;
  last_notified_message_ts?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Project_Chat_SubscriptionsUpdateInput = {
  channel?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  deal_id?: InputMaybe<Scalars["UUID"]["input"]>;
  destination?: InputMaybe<Scalars["String"]["input"]>;
  display_name?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  last_notified_message_ts?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Project_Chat_SubscriptionsUpdateResponse = {
  __typename?: "project_chat_subscriptionsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Project_Chat_Subscriptions>;
};

export type Project_Health_Status = "green" | "red" | "yellow";

/** Boolean expression comparing fields on type "project_health_status" */
export type Project_Health_StatusFilter = {
  eq?: InputMaybe<Project_Health_Status>;
  in?: InputMaybe<Array<Project_Health_Status>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Project_Health_Status>;
};

export type Proposal_Status = "accepted" | "draft" | "expired" | "rejected" | "sent" | "viewed";

/** Boolean expression comparing fields on type "proposal_status" */
export type Proposal_StatusFilter = {
  eq?: InputMaybe<Proposal_Status>;
  in?: InputMaybe<Array<Proposal_Status>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Proposal_Status>;
};

export type Queue_Event_Log = Node & {
  __typename?: "queue_event_log";
  created_at: Scalars["Datetime"]["output"];
  disposition: Scalars["String"]["output"];
  duration_ms: Scalars["Int"]["output"];
  error?: Maybe<Scalars["String"]["output"]>;
  event_type: Scalars["String"]["output"];
  id: Scalars["BigInt"]["output"];
  message_id?: Maybe<Scalars["String"]["output"]>;
  meta?: Maybe<Scalars["JSON"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  queue_name: Scalars["String"]["output"];
  receive_count: Scalars["Int"]["output"];
  version: Scalars["Int"]["output"];
};

export type Queue_Event_LogConnection = {
  __typename?: "queue_event_logConnection";
  edges: Array<Queue_Event_LogEdge>;
  pageInfo: PageInfo;
};

export type Queue_Event_LogDeleteResponse = {
  __typename?: "queue_event_logDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Queue_Event_Log>;
};

export type Queue_Event_LogEdge = {
  __typename?: "queue_event_logEdge";
  cursor: Scalars["String"]["output"];
  node: Queue_Event_Log;
};

export type Queue_Event_LogFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Queue_Event_LogFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  disposition?: InputMaybe<StringFilter>;
  duration_ms?: InputMaybe<IntFilter>;
  error?: InputMaybe<StringFilter>;
  event_type?: InputMaybe<StringFilter>;
  id?: InputMaybe<BigIntFilter>;
  message_id?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Queue_Event_LogFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Queue_Event_LogFilter>>;
  queue_name?: InputMaybe<StringFilter>;
  receive_count?: InputMaybe<IntFilter>;
  version?: InputMaybe<IntFilter>;
};

export type Queue_Event_LogInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  disposition?: InputMaybe<Scalars["String"]["input"]>;
  duration_ms?: InputMaybe<Scalars["Int"]["input"]>;
  error?: InputMaybe<Scalars["String"]["input"]>;
  event_type?: InputMaybe<Scalars["String"]["input"]>;
  message_id?: InputMaybe<Scalars["String"]["input"]>;
  meta?: InputMaybe<Scalars["JSON"]["input"]>;
  queue_name?: InputMaybe<Scalars["String"]["input"]>;
  receive_count?: InputMaybe<Scalars["Int"]["input"]>;
  version?: InputMaybe<Scalars["Int"]["input"]>;
};

export type Queue_Event_LogInsertResponse = {
  __typename?: "queue_event_logInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Queue_Event_Log>;
};

export type Queue_Event_LogOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  disposition?: InputMaybe<OrderByDirection>;
  duration_ms?: InputMaybe<OrderByDirection>;
  error?: InputMaybe<OrderByDirection>;
  event_type?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  message_id?: InputMaybe<OrderByDirection>;
  queue_name?: InputMaybe<OrderByDirection>;
  receive_count?: InputMaybe<OrderByDirection>;
  version?: InputMaybe<OrderByDirection>;
};

export type Queue_Event_LogUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  disposition?: InputMaybe<Scalars["String"]["input"]>;
  duration_ms?: InputMaybe<Scalars["Int"]["input"]>;
  error?: InputMaybe<Scalars["String"]["input"]>;
  event_type?: InputMaybe<Scalars["String"]["input"]>;
  message_id?: InputMaybe<Scalars["String"]["input"]>;
  meta?: InputMaybe<Scalars["JSON"]["input"]>;
  queue_name?: InputMaybe<Scalars["String"]["input"]>;
  receive_count?: InputMaybe<Scalars["Int"]["input"]>;
  version?: InputMaybe<Scalars["Int"]["input"]>;
};

export type Queue_Event_LogUpdateResponse = {
  __typename?: "queue_event_logUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Queue_Event_Log>;
};

export type Quickbooks_Company_Customer_Acks = Node & {
  __typename?: "quickbooks_company_customer_acks";
  acked_by?: Maybe<Scalars["UUID"]["output"]>;
  app_users?: Maybe<App_Users>;
  companies?: Maybe<Companies>;
  company_id: Scalars["UUID"]["output"];
  created_at: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  realm_id: Scalars["String"]["output"];
  reason?: Maybe<Scalars["String"]["output"]>;
  secondary_customer_ids: Array<Maybe<Scalars["String"]["output"]>>;
  updated_at: Scalars["Datetime"]["output"];
};

export type Quickbooks_Company_Customer_AcksConnection = {
  __typename?: "quickbooks_company_customer_acksConnection";
  edges: Array<Quickbooks_Company_Customer_AcksEdge>;
  pageInfo: PageInfo;
};

export type Quickbooks_Company_Customer_AcksDeleteResponse = {
  __typename?: "quickbooks_company_customer_acksDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Quickbooks_Company_Customer_Acks>;
};

export type Quickbooks_Company_Customer_AcksEdge = {
  __typename?: "quickbooks_company_customer_acksEdge";
  cursor: Scalars["String"]["output"];
  node: Quickbooks_Company_Customer_Acks;
};

export type Quickbooks_Company_Customer_AcksFilter = {
  acked_by?: InputMaybe<UuidFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Quickbooks_Company_Customer_AcksFilter>>;
  company_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Quickbooks_Company_Customer_AcksFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Quickbooks_Company_Customer_AcksFilter>>;
  realm_id?: InputMaybe<StringFilter>;
  reason?: InputMaybe<StringFilter>;
  secondary_customer_ids?: InputMaybe<StringListFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Quickbooks_Company_Customer_AcksInsertInput = {
  acked_by?: InputMaybe<Scalars["UUID"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  realm_id?: InputMaybe<Scalars["String"]["input"]>;
  reason?: InputMaybe<Scalars["String"]["input"]>;
  secondary_customer_ids?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Quickbooks_Company_Customer_AcksInsertResponse = {
  __typename?: "quickbooks_company_customer_acksInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Quickbooks_Company_Customer_Acks>;
};

export type Quickbooks_Company_Customer_AcksOrderBy = {
  acked_by?: InputMaybe<OrderByDirection>;
  company_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  realm_id?: InputMaybe<OrderByDirection>;
  reason?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Quickbooks_Company_Customer_AcksUpdateInput = {
  acked_by?: InputMaybe<Scalars["UUID"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  realm_id?: InputMaybe<Scalars["String"]["input"]>;
  reason?: InputMaybe<Scalars["String"]["input"]>;
  secondary_customer_ids?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Quickbooks_Company_Customer_AcksUpdateResponse = {
  __typename?: "quickbooks_company_customer_acksUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Quickbooks_Company_Customer_Acks>;
};

export type Quickbooks_Customer_Link_Ignores = Node & {
  __typename?: "quickbooks_customer_link_ignores";
  app_users?: Maybe<App_Users>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  id: Scalars["UUID"]["output"];
  ignored_by?: Maybe<Scalars["UUID"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  qb_customer_id: Scalars["String"]["output"];
  qb_customer_name?: Maybe<Scalars["String"]["output"]>;
  realm_id: Scalars["String"]["output"];
  reason?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type Quickbooks_Customer_Link_IgnoresConnection = {
  __typename?: "quickbooks_customer_link_ignoresConnection";
  edges: Array<Quickbooks_Customer_Link_IgnoresEdge>;
  pageInfo: PageInfo;
};

export type Quickbooks_Customer_Link_IgnoresDeleteResponse = {
  __typename?: "quickbooks_customer_link_ignoresDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Quickbooks_Customer_Link_Ignores>;
};

export type Quickbooks_Customer_Link_IgnoresEdge = {
  __typename?: "quickbooks_customer_link_ignoresEdge";
  cursor: Scalars["String"]["output"];
  node: Quickbooks_Customer_Link_Ignores;
};

export type Quickbooks_Customer_Link_IgnoresFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Quickbooks_Customer_Link_IgnoresFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  ignored_by?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Quickbooks_Customer_Link_IgnoresFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Quickbooks_Customer_Link_IgnoresFilter>>;
  qb_customer_id?: InputMaybe<StringFilter>;
  qb_customer_name?: InputMaybe<StringFilter>;
  realm_id?: InputMaybe<StringFilter>;
  reason?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Quickbooks_Customer_Link_IgnoresInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  ignored_by?: InputMaybe<Scalars["UUID"]["input"]>;
  qb_customer_id?: InputMaybe<Scalars["String"]["input"]>;
  qb_customer_name?: InputMaybe<Scalars["String"]["input"]>;
  realm_id?: InputMaybe<Scalars["String"]["input"]>;
  reason?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Quickbooks_Customer_Link_IgnoresInsertResponse = {
  __typename?: "quickbooks_customer_link_ignoresInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Quickbooks_Customer_Link_Ignores>;
};

export type Quickbooks_Customer_Link_IgnoresOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  ignored_by?: InputMaybe<OrderByDirection>;
  qb_customer_id?: InputMaybe<OrderByDirection>;
  qb_customer_name?: InputMaybe<OrderByDirection>;
  realm_id?: InputMaybe<OrderByDirection>;
  reason?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Quickbooks_Customer_Link_IgnoresUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  ignored_by?: InputMaybe<Scalars["UUID"]["input"]>;
  qb_customer_id?: InputMaybe<Scalars["String"]["input"]>;
  qb_customer_name?: InputMaybe<Scalars["String"]["input"]>;
  realm_id?: InputMaybe<Scalars["String"]["input"]>;
  reason?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Quickbooks_Customer_Link_IgnoresUpdateResponse = {
  __typename?: "quickbooks_customer_link_ignoresUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Quickbooks_Customer_Link_Ignores>;
};

export type Quickbooks_Realm_Labels = Node & {
  __typename?: "quickbooks_realm_labels";
  category: Scalars["String"]["output"];
  created_at: Scalars["Datetime"]["output"];
  is_active: Scalars["Boolean"]["output"];
  label: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  realm_id: Scalars["String"]["output"];
  slack_channel_id?: Maybe<Scalars["String"]["output"]>;
  updated_at: Scalars["Datetime"]["output"];
};

export type Quickbooks_Realm_LabelsConnection = {
  __typename?: "quickbooks_realm_labelsConnection";
  edges: Array<Quickbooks_Realm_LabelsEdge>;
  pageInfo: PageInfo;
};

export type Quickbooks_Realm_LabelsDeleteResponse = {
  __typename?: "quickbooks_realm_labelsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Quickbooks_Realm_Labels>;
};

export type Quickbooks_Realm_LabelsEdge = {
  __typename?: "quickbooks_realm_labelsEdge";
  cursor: Scalars["String"]["output"];
  node: Quickbooks_Realm_Labels;
};

export type Quickbooks_Realm_LabelsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Quickbooks_Realm_LabelsFilter>>;
  category?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  is_active?: InputMaybe<BooleanFilter>;
  label?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Quickbooks_Realm_LabelsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Quickbooks_Realm_LabelsFilter>>;
  realm_id?: InputMaybe<StringFilter>;
  slack_channel_id?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Quickbooks_Realm_LabelsInsertInput = {
  category?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  realm_id?: InputMaybe<Scalars["String"]["input"]>;
  slack_channel_id?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Quickbooks_Realm_LabelsInsertResponse = {
  __typename?: "quickbooks_realm_labelsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Quickbooks_Realm_Labels>;
};

export type Quickbooks_Realm_LabelsOrderBy = {
  category?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  is_active?: InputMaybe<OrderByDirection>;
  label?: InputMaybe<OrderByDirection>;
  realm_id?: InputMaybe<OrderByDirection>;
  slack_channel_id?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Quickbooks_Realm_LabelsUpdateInput = {
  category?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  realm_id?: InputMaybe<Scalars["String"]["input"]>;
  slack_channel_id?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Quickbooks_Realm_LabelsUpdateResponse = {
  __typename?: "quickbooks_realm_labelsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Quickbooks_Realm_Labels>;
};

export type Quo_Sync_Op_Failures = Node & {
  __typename?: "quo_sync_op_failures";
  failure_count: Scalars["Int"]["output"];
  first_failed_at: Scalars["Datetime"]["output"];
  last_error?: Maybe<Scalars["String"]["output"]>;
  last_failed_at: Scalars["Datetime"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  op_key: Scalars["String"]["output"];
  op_kind: Scalars["String"]["output"];
  quarantined_until?: Maybe<Scalars["Datetime"]["output"]>;
};

export type Quo_Sync_Op_FailuresConnection = {
  __typename?: "quo_sync_op_failuresConnection";
  edges: Array<Quo_Sync_Op_FailuresEdge>;
  pageInfo: PageInfo;
};

export type Quo_Sync_Op_FailuresDeleteResponse = {
  __typename?: "quo_sync_op_failuresDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Quo_Sync_Op_Failures>;
};

export type Quo_Sync_Op_FailuresEdge = {
  __typename?: "quo_sync_op_failuresEdge";
  cursor: Scalars["String"]["output"];
  node: Quo_Sync_Op_Failures;
};

export type Quo_Sync_Op_FailuresFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Quo_Sync_Op_FailuresFilter>>;
  failure_count?: InputMaybe<IntFilter>;
  first_failed_at?: InputMaybe<DatetimeFilter>;
  last_error?: InputMaybe<StringFilter>;
  last_failed_at?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Quo_Sync_Op_FailuresFilter>;
  op_key?: InputMaybe<StringFilter>;
  op_kind?: InputMaybe<StringFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Quo_Sync_Op_FailuresFilter>>;
  quarantined_until?: InputMaybe<DatetimeFilter>;
};

export type Quo_Sync_Op_FailuresInsertInput = {
  failure_count?: InputMaybe<Scalars["Int"]["input"]>;
  first_failed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_error?: InputMaybe<Scalars["String"]["input"]>;
  last_failed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  op_key?: InputMaybe<Scalars["String"]["input"]>;
  op_kind?: InputMaybe<Scalars["String"]["input"]>;
  quarantined_until?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Quo_Sync_Op_FailuresInsertResponse = {
  __typename?: "quo_sync_op_failuresInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Quo_Sync_Op_Failures>;
};

export type Quo_Sync_Op_FailuresOrderBy = {
  failure_count?: InputMaybe<OrderByDirection>;
  first_failed_at?: InputMaybe<OrderByDirection>;
  last_error?: InputMaybe<OrderByDirection>;
  last_failed_at?: InputMaybe<OrderByDirection>;
  op_key?: InputMaybe<OrderByDirection>;
  op_kind?: InputMaybe<OrderByDirection>;
  quarantined_until?: InputMaybe<OrderByDirection>;
};

export type Quo_Sync_Op_FailuresUpdateInput = {
  failure_count?: InputMaybe<Scalars["Int"]["input"]>;
  first_failed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_error?: InputMaybe<Scalars["String"]["input"]>;
  last_failed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  op_key?: InputMaybe<Scalars["String"]["input"]>;
  op_kind?: InputMaybe<Scalars["String"]["input"]>;
  quarantined_until?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Quo_Sync_Op_FailuresUpdateResponse = {
  __typename?: "quo_sync_op_failuresUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Quo_Sync_Op_Failures>;
};

export type Rate_Limit_Buckets = Node & {
  __typename?: "rate_limit_buckets";
  bucket_key: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  tokens: Scalars["Float"]["output"];
  updated_at: Scalars["Datetime"]["output"];
};

export type Rate_Limit_BucketsConnection = {
  __typename?: "rate_limit_bucketsConnection";
  edges: Array<Rate_Limit_BucketsEdge>;
  pageInfo: PageInfo;
};

export type Rate_Limit_BucketsDeleteResponse = {
  __typename?: "rate_limit_bucketsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Rate_Limit_Buckets>;
};

export type Rate_Limit_BucketsEdge = {
  __typename?: "rate_limit_bucketsEdge";
  cursor: Scalars["String"]["output"];
  node: Rate_Limit_Buckets;
};

export type Rate_Limit_BucketsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Rate_Limit_BucketsFilter>>;
  bucket_key?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Rate_Limit_BucketsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Rate_Limit_BucketsFilter>>;
  tokens?: InputMaybe<FloatFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Rate_Limit_BucketsInsertInput = {
  bucket_key?: InputMaybe<Scalars["String"]["input"]>;
  tokens?: InputMaybe<Scalars["Float"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Rate_Limit_BucketsInsertResponse = {
  __typename?: "rate_limit_bucketsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Rate_Limit_Buckets>;
};

export type Rate_Limit_BucketsOrderBy = {
  bucket_key?: InputMaybe<OrderByDirection>;
  tokens?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Rate_Limit_BucketsUpdateInput = {
  bucket_key?: InputMaybe<Scalars["String"]["input"]>;
  tokens?: InputMaybe<Scalars["Float"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Rate_Limit_BucketsUpdateResponse = {
  __typename?: "rate_limit_bucketsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Rate_Limit_Buckets>;
};

export type Recurring_Charges = Node & {
  __typename?: "recurring_charges";
  admin_email: Scalars["String"]["output"];
  companies?: Maybe<Companies>;
  company_id?: Maybe<Scalars["UUID"]["output"]>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  customer_id: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  last_charged_at?: Maybe<Scalars["Datetime"]["output"]>;
  metadata?: Maybe<Scalars["JSON"]["output"]>;
  next_charge_date: Scalars["Date"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  realm_id: Scalars["String"]["output"];
  schedule_type: Scalars["String"]["output"];
  search_vector?: Maybe<Scalars["Opaque"]["output"]>;
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type Recurring_ChargesConnection = {
  __typename?: "recurring_chargesConnection";
  edges: Array<Recurring_ChargesEdge>;
  pageInfo: PageInfo;
  /** The total number of records matching the `filter` criteria */
  totalCount: Scalars["Int"]["output"];
};

export type Recurring_ChargesDeleteResponse = {
  __typename?: "recurring_chargesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Recurring_Charges>;
};

export type Recurring_ChargesEdge = {
  __typename?: "recurring_chargesEdge";
  cursor: Scalars["String"]["output"];
  node: Recurring_Charges;
};

export type Recurring_ChargesFilter = {
  admin_email?: InputMaybe<StringFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Recurring_ChargesFilter>>;
  company_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  customer_id?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  last_charged_at?: InputMaybe<DatetimeFilter>;
  next_charge_date?: InputMaybe<DateFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Recurring_ChargesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Recurring_ChargesFilter>>;
  realm_id?: InputMaybe<StringFilter>;
  schedule_type?: InputMaybe<StringFilter>;
  search_vector?: InputMaybe<OpaqueFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Recurring_ChargesInsertInput = {
  admin_email?: InputMaybe<Scalars["String"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  customer_id?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  last_charged_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  next_charge_date?: InputMaybe<Scalars["Date"]["input"]>;
  realm_id?: InputMaybe<Scalars["String"]["input"]>;
  schedule_type?: InputMaybe<Scalars["String"]["input"]>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Recurring_ChargesInsertResponse = {
  __typename?: "recurring_chargesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Recurring_Charges>;
};

export type Recurring_ChargesOrderBy = {
  admin_email?: InputMaybe<OrderByDirection>;
  company_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  customer_id?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  last_charged_at?: InputMaybe<OrderByDirection>;
  next_charge_date?: InputMaybe<OrderByDirection>;
  realm_id?: InputMaybe<OrderByDirection>;
  schedule_type?: InputMaybe<OrderByDirection>;
  search_vector?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Recurring_ChargesUpdateInput = {
  admin_email?: InputMaybe<Scalars["String"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  customer_id?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  last_charged_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  next_charge_date?: InputMaybe<Scalars["Date"]["input"]>;
  realm_id?: InputMaybe<Scalars["String"]["input"]>;
  schedule_type?: InputMaybe<Scalars["String"]["input"]>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Recurring_ChargesUpdateResponse = {
  __typename?: "recurring_chargesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Recurring_Charges>;
};

export type Recurring_Transactions = Node & {
  __typename?: "recurring_transactions";
  amount: Scalars["BigFloat"]["output"];
  billing_cadence: Scalars["String"]["output"];
  companies?: Maybe<Companies>;
  company_id?: Maybe<Scalars["UUID"]["output"]>;
  company_name?: Maybe<Scalars["String"]["output"]>;
  contact_name?: Maybe<Scalars["String"]["output"]>;
  contacts?: Maybe<Contacts>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  created_by?: Maybe<Scalars["UUID"]["output"]>;
  customer_id?: Maybe<Scalars["UUID"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  item: Scalars["String"]["output"];
  last_error?: Maybe<Scalars["String"]["output"]>;
  last_error_at?: Maybe<Scalars["Datetime"]["output"]>;
  last_synced_at?: Maybe<Scalars["Datetime"]["output"]>;
  last_synced_month?: Maybe<Scalars["String"]["output"]>;
  next_bill_on?: Maybe<Scalars["Date"]["output"]>;
  next_retry_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  quantity: Scalars["BigFloat"]["output"];
  quickbooks_id?: Maybe<Scalars["String"]["output"]>;
  quickbooks_realm_id?: Maybe<Scalars["String"]["output"]>;
  retry_count: Scalars["Int"]["output"];
  search_vector?: Maybe<Scalars["Opaque"]["output"]>;
  sync_status?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  updated_by?: Maybe<Scalars["UUID"]["output"]>;
};

/** Aggregate results for `recurring_transactions` */
export type Recurring_TransactionsAggregate = {
  __typename?: "recurring_transactionsAggregate";
  /** Average aggregates for numeric fields */
  avg?: Maybe<Recurring_TransactionsAvgAggregateResult>;
  /** The number of records matching the query */
  count: Scalars["Int"]["output"];
  /** Maximum aggregates for comparable fields */
  max?: Maybe<Recurring_TransactionsMaxAggregateResult>;
  /** Minimum aggregates for comparable fields */
  min?: Maybe<Recurring_TransactionsMinAggregateResult>;
  /** Summation aggregates for numeric fields */
  sum?: Maybe<Recurring_TransactionsSumAggregateResult>;
};

/** Result of average aggregation for `recurring_transactions` */
export type Recurring_TransactionsAvgAggregateResult = {
  __typename?: "recurring_transactionsAvgAggregateResult";
  /** Average of amount across all matching records */
  amount?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Average of quantity across all matching records */
  quantity?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Average of retry_count across all matching records */
  retry_count?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type Recurring_TransactionsConnection = {
  __typename?: "recurring_transactionsConnection";
  /** Aggregate functions calculated on the collection of `recurring_transactions` */
  aggregate?: Maybe<Recurring_TransactionsAggregate>;
  edges: Array<Recurring_TransactionsEdge>;
  pageInfo: PageInfo;
  /** The total number of records matching the `filter` criteria */
  totalCount: Scalars["Int"]["output"];
};

export type Recurring_TransactionsDeleteResponse = {
  __typename?: "recurring_transactionsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Recurring_Transactions>;
};

export type Recurring_TransactionsEdge = {
  __typename?: "recurring_transactionsEdge";
  cursor: Scalars["String"]["output"];
  node: Recurring_Transactions;
};

export type Recurring_TransactionsFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Recurring_TransactionsFilter>>;
  billing_cadence?: InputMaybe<StringFilter>;
  company_id?: InputMaybe<UuidFilter>;
  company_name?: InputMaybe<StringFilter>;
  contact_name?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  customer_id?: InputMaybe<UuidFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  item?: InputMaybe<StringFilter>;
  last_error?: InputMaybe<StringFilter>;
  last_error_at?: InputMaybe<DatetimeFilter>;
  last_synced_at?: InputMaybe<DatetimeFilter>;
  last_synced_month?: InputMaybe<StringFilter>;
  next_bill_on?: InputMaybe<DateFilter>;
  next_retry_at?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Recurring_TransactionsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Recurring_TransactionsFilter>>;
  quantity?: InputMaybe<BigFloatFilter>;
  quickbooks_id?: InputMaybe<StringFilter>;
  quickbooks_realm_id?: InputMaybe<StringFilter>;
  retry_count?: InputMaybe<IntFilter>;
  search_vector?: InputMaybe<OpaqueFilter>;
  sync_status?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  updated_by?: InputMaybe<UuidFilter>;
};

export type Recurring_TransactionsInsertInput = {
  amount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  billing_cadence?: InputMaybe<Scalars["String"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  company_name?: InputMaybe<Scalars["String"]["input"]>;
  contact_name?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  customer_id?: InputMaybe<Scalars["UUID"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  item?: InputMaybe<Scalars["String"]["input"]>;
  last_error?: InputMaybe<Scalars["String"]["input"]>;
  last_error_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_synced_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_synced_month?: InputMaybe<Scalars["String"]["input"]>;
  next_bill_on?: InputMaybe<Scalars["Date"]["input"]>;
  next_retry_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  quantity?: InputMaybe<Scalars["BigFloat"]["input"]>;
  quickbooks_id?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_realm_id?: InputMaybe<Scalars["String"]["input"]>;
  retry_count?: InputMaybe<Scalars["Int"]["input"]>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  sync_status?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  updated_by?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Recurring_TransactionsInsertResponse = {
  __typename?: "recurring_transactionsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Recurring_Transactions>;
};

/** Result of maximum aggregation for `recurring_transactions` */
export type Recurring_TransactionsMaxAggregateResult = {
  __typename?: "recurring_transactionsMaxAggregateResult";
  /** Maximum of amount across all matching records */
  amount?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Maximum of billing_cadence across all matching records */
  billing_cadence?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of company_name across all matching records */
  company_name?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of contact_name across all matching records */
  contact_name?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of created_at across all matching records */
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Maximum of description across all matching records */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of item across all matching records */
  item?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of last_error across all matching records */
  last_error?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of last_error_at across all matching records */
  last_error_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Maximum of last_synced_at across all matching records */
  last_synced_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Maximum of last_synced_month across all matching records */
  last_synced_month?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of next_bill_on across all matching records */
  next_bill_on?: Maybe<Scalars["Date"]["output"]>;
  /** Maximum of next_retry_at across all matching records */
  next_retry_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Maximum of quantity across all matching records */
  quantity?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Maximum of quickbooks_id across all matching records */
  quickbooks_id?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of quickbooks_realm_id across all matching records */
  quickbooks_realm_id?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of retry_count across all matching records */
  retry_count?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of sync_status across all matching records */
  sync_status?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of updated_at across all matching records */
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

/** Result of minimum aggregation for `recurring_transactions` */
export type Recurring_TransactionsMinAggregateResult = {
  __typename?: "recurring_transactionsMinAggregateResult";
  /** Minimum of amount across all matching records */
  amount?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Minimum of billing_cadence across all matching records */
  billing_cadence?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of company_name across all matching records */
  company_name?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of contact_name across all matching records */
  contact_name?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of created_at across all matching records */
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Minimum of description across all matching records */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of item across all matching records */
  item?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of last_error across all matching records */
  last_error?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of last_error_at across all matching records */
  last_error_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Minimum of last_synced_at across all matching records */
  last_synced_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Minimum of last_synced_month across all matching records */
  last_synced_month?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of next_bill_on across all matching records */
  next_bill_on?: Maybe<Scalars["Date"]["output"]>;
  /** Minimum of next_retry_at across all matching records */
  next_retry_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Minimum of quantity across all matching records */
  quantity?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Minimum of quickbooks_id across all matching records */
  quickbooks_id?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of quickbooks_realm_id across all matching records */
  quickbooks_realm_id?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of retry_count across all matching records */
  retry_count?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of sync_status across all matching records */
  sync_status?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of updated_at across all matching records */
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type Recurring_TransactionsOrderBy = {
  amount?: InputMaybe<OrderByDirection>;
  billing_cadence?: InputMaybe<OrderByDirection>;
  company_id?: InputMaybe<OrderByDirection>;
  company_name?: InputMaybe<OrderByDirection>;
  contact_name?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  customer_id?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  item?: InputMaybe<OrderByDirection>;
  last_error?: InputMaybe<OrderByDirection>;
  last_error_at?: InputMaybe<OrderByDirection>;
  last_synced_at?: InputMaybe<OrderByDirection>;
  last_synced_month?: InputMaybe<OrderByDirection>;
  next_bill_on?: InputMaybe<OrderByDirection>;
  next_retry_at?: InputMaybe<OrderByDirection>;
  quantity?: InputMaybe<OrderByDirection>;
  quickbooks_id?: InputMaybe<OrderByDirection>;
  quickbooks_realm_id?: InputMaybe<OrderByDirection>;
  retry_count?: InputMaybe<OrderByDirection>;
  search_vector?: InputMaybe<OrderByDirection>;
  sync_status?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  updated_by?: InputMaybe<OrderByDirection>;
};

/** Result of summation aggregation for `recurring_transactions` */
export type Recurring_TransactionsSumAggregateResult = {
  __typename?: "recurring_transactionsSumAggregateResult";
  /** Sum of amount across all matching records */
  amount?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sum of quantity across all matching records */
  quantity?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sum of retry_count across all matching records */
  retry_count?: Maybe<Scalars["BigInt"]["output"]>;
};

export type Recurring_TransactionsUpdateInput = {
  amount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  billing_cadence?: InputMaybe<Scalars["String"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  company_name?: InputMaybe<Scalars["String"]["input"]>;
  contact_name?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  customer_id?: InputMaybe<Scalars["UUID"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  item?: InputMaybe<Scalars["String"]["input"]>;
  last_error?: InputMaybe<Scalars["String"]["input"]>;
  last_error_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_synced_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_synced_month?: InputMaybe<Scalars["String"]["input"]>;
  next_bill_on?: InputMaybe<Scalars["Date"]["input"]>;
  next_retry_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  quantity?: InputMaybe<Scalars["BigFloat"]["input"]>;
  quickbooks_id?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_realm_id?: InputMaybe<Scalars["String"]["input"]>;
  retry_count?: InputMaybe<Scalars["Int"]["input"]>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  sync_status?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  updated_by?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Recurring_TransactionsUpdateResponse = {
  __typename?: "recurring_transactionsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Recurring_Transactions>;
};

export type Revenue_Targets = Node & {
  __typename?: "revenue_targets";
  app_users?: Maybe<App_Users>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  created_by: Scalars["UUID"]["output"];
  currency?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  period_end: Scalars["Date"]["output"];
  period_start: Scalars["Date"]["output"];
  target_amount: Scalars["BigFloat"]["output"];
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type Revenue_TargetsConnection = {
  __typename?: "revenue_targetsConnection";
  edges: Array<Revenue_TargetsEdge>;
  pageInfo: PageInfo;
};

export type Revenue_TargetsDeleteResponse = {
  __typename?: "revenue_targetsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Revenue_Targets>;
};

export type Revenue_TargetsEdge = {
  __typename?: "revenue_targetsEdge";
  cursor: Scalars["String"]["output"];
  node: Revenue_Targets;
};

export type Revenue_TargetsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Revenue_TargetsFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  currency?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Revenue_TargetsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Revenue_TargetsFilter>>;
  period_end?: InputMaybe<DateFilter>;
  period_start?: InputMaybe<DateFilter>;
  target_amount?: InputMaybe<BigFloatFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Revenue_TargetsInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  currency?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  period_end?: InputMaybe<Scalars["Date"]["input"]>;
  period_start?: InputMaybe<Scalars["Date"]["input"]>;
  target_amount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Revenue_TargetsInsertResponse = {
  __typename?: "revenue_targetsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Revenue_Targets>;
};

export type Revenue_TargetsOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  currency?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  period_end?: InputMaybe<OrderByDirection>;
  period_start?: InputMaybe<OrderByDirection>;
  target_amount?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Revenue_TargetsUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  currency?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  period_end?: InputMaybe<Scalars["Date"]["input"]>;
  period_start?: InputMaybe<Scalars["Date"]["input"]>;
  target_amount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Revenue_TargetsUpdateResponse = {
  __typename?: "revenue_targetsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Revenue_Targets>;
};

export type Roles = Node & {
  __typename?: "roles";
  app_usersCollection?: Maybe<App_UsersConnection>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  display_name: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  is_active?: Maybe<Scalars["Boolean"]["output"]>;
  name: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  permissions?: Maybe<Scalars["JSON"]["output"]>;
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type RolesApp_UsersCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<App_UsersFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<App_UsersOrderBy>>;
};

/** Aggregate results for `roles` */
export type RolesAggregate = {
  __typename?: "rolesAggregate";
  /** The number of records matching the query */
  count: Scalars["Int"]["output"];
  /** Maximum aggregates for comparable fields */
  max?: Maybe<RolesMaxAggregateResult>;
  /** Minimum aggregates for comparable fields */
  min?: Maybe<RolesMinAggregateResult>;
};

export type RolesConnection = {
  __typename?: "rolesConnection";
  /** Aggregate functions calculated on the collection of `roles` */
  aggregate?: Maybe<RolesAggregate>;
  edges: Array<RolesEdge>;
  pageInfo: PageInfo;
  /** The total number of records matching the `filter` criteria */
  totalCount: Scalars["Int"]["output"];
};

export type RolesDeleteResponse = {
  __typename?: "rolesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Roles>;
};

export type RolesEdge = {
  __typename?: "rolesEdge";
  cursor: Scalars["String"]["output"];
  node: Roles;
};

export type RolesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<RolesFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  display_name?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  is_active?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<RolesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<RolesFilter>>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type RolesInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  display_name?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  permissions?: InputMaybe<Scalars["JSON"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type RolesInsertResponse = {
  __typename?: "rolesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Roles>;
};

/** Result of maximum aggregation for `roles` */
export type RolesMaxAggregateResult = {
  __typename?: "rolesMaxAggregateResult";
  /** Maximum of created_at across all matching records */
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Maximum of description across all matching records */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of display_name across all matching records */
  display_name?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of is_active across all matching records */
  is_active?: Maybe<Scalars["Boolean"]["output"]>;
  /** Maximum of name across all matching records */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of updated_at across all matching records */
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

/** Result of minimum aggregation for `roles` */
export type RolesMinAggregateResult = {
  __typename?: "rolesMinAggregateResult";
  /** Minimum of created_at across all matching records */
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Minimum of description across all matching records */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of display_name across all matching records */
  display_name?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of is_active across all matching records */
  is_active?: Maybe<Scalars["Boolean"]["output"]>;
  /** Minimum of name across all matching records */
  name?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of updated_at across all matching records */
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type RolesOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  display_name?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_active?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type RolesUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  display_name?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  permissions?: InputMaybe<Scalars["JSON"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type RolesUpdateResponse = {
  __typename?: "rolesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Roles>;
};

export type Sales_Sequence_Enrollments = Node & {
  __typename?: "sales_sequence_enrollments";
  app_users?: Maybe<App_Users>;
  assigned_to: Scalars["UUID"]["output"];
  companies?: Maybe<Companies>;
  company_id?: Maybe<Scalars["UUID"]["output"]>;
  completed_at?: Maybe<Scalars["Datetime"]["output"]>;
  contact_id?: Maybe<Scalars["UUID"]["output"]>;
  contacts?: Maybe<Contacts>;
  created_at: Scalars["Datetime"]["output"];
  current_step_number: Scalars["Int"]["output"];
  deal_id?: Maybe<Scalars["UUID"]["output"]>;
  deals?: Maybe<Deals>;
  enrolled_at: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  next_action_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  pause_reason?: Maybe<Scalars["String"]["output"]>;
  paused_at?: Maybe<Scalars["Datetime"]["output"]>;
  sales_sequence_step_eventsCollection?: Maybe<Sales_Sequence_Step_EventsConnection>;
  sales_sequences?: Maybe<Sales_Sequences>;
  sequence_id: Scalars["UUID"]["output"];
  status: Sequence_Enrollment_Status;
  updated_at: Scalars["Datetime"]["output"];
};

export type Sales_Sequence_EnrollmentsSales_Sequence_Step_EventsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Sales_Sequence_Step_EventsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Sales_Sequence_Step_EventsOrderBy>>;
};

export type Sales_Sequence_EnrollmentsConnection = {
  __typename?: "sales_sequence_enrollmentsConnection";
  edges: Array<Sales_Sequence_EnrollmentsEdge>;
  pageInfo: PageInfo;
};

export type Sales_Sequence_EnrollmentsDeleteResponse = {
  __typename?: "sales_sequence_enrollmentsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Sales_Sequence_Enrollments>;
};

export type Sales_Sequence_EnrollmentsEdge = {
  __typename?: "sales_sequence_enrollmentsEdge";
  cursor: Scalars["String"]["output"];
  node: Sales_Sequence_Enrollments;
};

export type Sales_Sequence_EnrollmentsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Sales_Sequence_EnrollmentsFilter>>;
  assigned_to?: InputMaybe<UuidFilter>;
  company_id?: InputMaybe<UuidFilter>;
  completed_at?: InputMaybe<DatetimeFilter>;
  contact_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  current_step_number?: InputMaybe<IntFilter>;
  deal_id?: InputMaybe<UuidFilter>;
  enrolled_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  next_action_at?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Sales_Sequence_EnrollmentsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Sales_Sequence_EnrollmentsFilter>>;
  pause_reason?: InputMaybe<StringFilter>;
  paused_at?: InputMaybe<DatetimeFilter>;
  sequence_id?: InputMaybe<UuidFilter>;
  status?: InputMaybe<Sequence_Enrollment_StatusFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Sales_Sequence_EnrollmentsInsertInput = {
  assigned_to?: InputMaybe<Scalars["UUID"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  completed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  current_step_number?: InputMaybe<Scalars["Int"]["input"]>;
  deal_id?: InputMaybe<Scalars["UUID"]["input"]>;
  enrolled_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  next_action_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  pause_reason?: InputMaybe<Scalars["String"]["input"]>;
  paused_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  sequence_id?: InputMaybe<Scalars["UUID"]["input"]>;
  status?: InputMaybe<Sequence_Enrollment_Status>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Sales_Sequence_EnrollmentsInsertResponse = {
  __typename?: "sales_sequence_enrollmentsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Sales_Sequence_Enrollments>;
};

export type Sales_Sequence_EnrollmentsOrderBy = {
  assigned_to?: InputMaybe<OrderByDirection>;
  company_id?: InputMaybe<OrderByDirection>;
  completed_at?: InputMaybe<OrderByDirection>;
  contact_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  current_step_number?: InputMaybe<OrderByDirection>;
  deal_id?: InputMaybe<OrderByDirection>;
  enrolled_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  next_action_at?: InputMaybe<OrderByDirection>;
  pause_reason?: InputMaybe<OrderByDirection>;
  paused_at?: InputMaybe<OrderByDirection>;
  sequence_id?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Sales_Sequence_EnrollmentsUpdateInput = {
  assigned_to?: InputMaybe<Scalars["UUID"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  completed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  current_step_number?: InputMaybe<Scalars["Int"]["input"]>;
  deal_id?: InputMaybe<Scalars["UUID"]["input"]>;
  enrolled_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  next_action_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  pause_reason?: InputMaybe<Scalars["String"]["input"]>;
  paused_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  sequence_id?: InputMaybe<Scalars["UUID"]["input"]>;
  status?: InputMaybe<Sequence_Enrollment_Status>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Sales_Sequence_EnrollmentsUpdateResponse = {
  __typename?: "sales_sequence_enrollmentsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Sales_Sequence_Enrollments>;
};

export type Sales_Sequence_Step_Events = Node & {
  __typename?: "sales_sequence_step_events";
  actor?: Maybe<Scalars["UUID"]["output"]>;
  app_users?: Maybe<App_Users>;
  channel: Sequence_Channel;
  communication_id?: Maybe<Scalars["UUID"]["output"]>;
  communications?: Maybe<Communications>;
  created_at: Scalars["Datetime"]["output"];
  enrollment_id: Scalars["UUID"]["output"];
  id: Scalars["UUID"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  occurred_at: Scalars["Datetime"]["output"];
  outcome: Sequence_Step_Outcome;
  sales_sequence_enrollments?: Maybe<Sales_Sequence_Enrollments>;
  step_number: Scalars["Int"]["output"];
};

export type Sales_Sequence_Step_EventsConnection = {
  __typename?: "sales_sequence_step_eventsConnection";
  edges: Array<Sales_Sequence_Step_EventsEdge>;
  pageInfo: PageInfo;
};

export type Sales_Sequence_Step_EventsDeleteResponse = {
  __typename?: "sales_sequence_step_eventsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Sales_Sequence_Step_Events>;
};

export type Sales_Sequence_Step_EventsEdge = {
  __typename?: "sales_sequence_step_eventsEdge";
  cursor: Scalars["String"]["output"];
  node: Sales_Sequence_Step_Events;
};

export type Sales_Sequence_Step_EventsFilter = {
  actor?: InputMaybe<UuidFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Sales_Sequence_Step_EventsFilter>>;
  channel?: InputMaybe<Sequence_ChannelFilter>;
  communication_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  enrollment_id?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Sales_Sequence_Step_EventsFilter>;
  note?: InputMaybe<StringFilter>;
  occurred_at?: InputMaybe<DatetimeFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Sales_Sequence_Step_EventsFilter>>;
  outcome?: InputMaybe<Sequence_Step_OutcomeFilter>;
  step_number?: InputMaybe<IntFilter>;
};

export type Sales_Sequence_Step_EventsInsertInput = {
  actor?: InputMaybe<Scalars["UUID"]["input"]>;
  channel?: InputMaybe<Sequence_Channel>;
  communication_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  enrollment_id?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  occurred_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  outcome?: InputMaybe<Sequence_Step_Outcome>;
  step_number?: InputMaybe<Scalars["Int"]["input"]>;
};

export type Sales_Sequence_Step_EventsInsertResponse = {
  __typename?: "sales_sequence_step_eventsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Sales_Sequence_Step_Events>;
};

export type Sales_Sequence_Step_EventsOrderBy = {
  actor?: InputMaybe<OrderByDirection>;
  channel?: InputMaybe<OrderByDirection>;
  communication_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  enrollment_id?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  note?: InputMaybe<OrderByDirection>;
  occurred_at?: InputMaybe<OrderByDirection>;
  outcome?: InputMaybe<OrderByDirection>;
  step_number?: InputMaybe<OrderByDirection>;
};

export type Sales_Sequence_Step_EventsUpdateInput = {
  actor?: InputMaybe<Scalars["UUID"]["input"]>;
  channel?: InputMaybe<Sequence_Channel>;
  communication_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  enrollment_id?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  note?: InputMaybe<Scalars["String"]["input"]>;
  occurred_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  outcome?: InputMaybe<Sequence_Step_Outcome>;
  step_number?: InputMaybe<Scalars["Int"]["input"]>;
};

export type Sales_Sequence_Step_EventsUpdateResponse = {
  __typename?: "sales_sequence_step_eventsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Sales_Sequence_Step_Events>;
};

export type Sales_Sequence_Steps = Node & {
  __typename?: "sales_sequence_steps";
  channel: Sequence_Channel;
  created_at: Scalars["Datetime"]["output"];
  delay_business_days: Scalars["Int"]["output"];
  guidance?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  pause_for_reply: Scalars["Boolean"]["output"];
  sales_sequences?: Maybe<Sales_Sequences>;
  sequence_id: Scalars["UUID"]["output"];
  step_number: Scalars["Int"]["output"];
  title: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
};

export type Sales_Sequence_StepsConnection = {
  __typename?: "sales_sequence_stepsConnection";
  edges: Array<Sales_Sequence_StepsEdge>;
  pageInfo: PageInfo;
};

export type Sales_Sequence_StepsDeleteResponse = {
  __typename?: "sales_sequence_stepsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Sales_Sequence_Steps>;
};

export type Sales_Sequence_StepsEdge = {
  __typename?: "sales_sequence_stepsEdge";
  cursor: Scalars["String"]["output"];
  node: Sales_Sequence_Steps;
};

export type Sales_Sequence_StepsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Sales_Sequence_StepsFilter>>;
  channel?: InputMaybe<Sequence_ChannelFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  delay_business_days?: InputMaybe<IntFilter>;
  guidance?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Sales_Sequence_StepsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Sales_Sequence_StepsFilter>>;
  pause_for_reply?: InputMaybe<BooleanFilter>;
  sequence_id?: InputMaybe<UuidFilter>;
  step_number?: InputMaybe<IntFilter>;
  title?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Sales_Sequence_StepsInsertInput = {
  channel?: InputMaybe<Sequence_Channel>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  delay_business_days?: InputMaybe<Scalars["Int"]["input"]>;
  guidance?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  pause_for_reply?: InputMaybe<Scalars["Boolean"]["input"]>;
  sequence_id?: InputMaybe<Scalars["UUID"]["input"]>;
  step_number?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Sales_Sequence_StepsInsertResponse = {
  __typename?: "sales_sequence_stepsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Sales_Sequence_Steps>;
};

export type Sales_Sequence_StepsOrderBy = {
  channel?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  delay_business_days?: InputMaybe<OrderByDirection>;
  guidance?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  pause_for_reply?: InputMaybe<OrderByDirection>;
  sequence_id?: InputMaybe<OrderByDirection>;
  step_number?: InputMaybe<OrderByDirection>;
  title?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Sales_Sequence_StepsUpdateInput = {
  channel?: InputMaybe<Sequence_Channel>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  delay_business_days?: InputMaybe<Scalars["Int"]["input"]>;
  guidance?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  pause_for_reply?: InputMaybe<Scalars["Boolean"]["input"]>;
  sequence_id?: InputMaybe<Scalars["UUID"]["input"]>;
  step_number?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Sales_Sequence_StepsUpdateResponse = {
  __typename?: "sales_sequence_stepsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Sales_Sequence_Steps>;
};

export type Sales_Sequences = Node & {
  __typename?: "sales_sequences";
  app_users?: Maybe<App_Users>;
  created_at: Scalars["Datetime"]["output"];
  created_by?: Maybe<Scalars["UUID"]["output"]>;
  deal_stage_trigger?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  is_active: Scalars["Boolean"]["output"];
  is_default: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  region_hint: Sequence_Region_Hint;
  sales_sequence_enrollmentsCollection?: Maybe<Sales_Sequence_EnrollmentsConnection>;
  sales_sequence_stepsCollection?: Maybe<Sales_Sequence_StepsConnection>;
  target_type: Sequence_Target;
  updated_at: Scalars["Datetime"]["output"];
};

export type Sales_SequencesSales_Sequence_EnrollmentsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Sales_Sequence_EnrollmentsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Sales_Sequence_EnrollmentsOrderBy>>;
};

export type Sales_SequencesSales_Sequence_StepsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Sales_Sequence_StepsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Sales_Sequence_StepsOrderBy>>;
};

export type Sales_SequencesConnection = {
  __typename?: "sales_sequencesConnection";
  edges: Array<Sales_SequencesEdge>;
  pageInfo: PageInfo;
};

export type Sales_SequencesDeleteResponse = {
  __typename?: "sales_sequencesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Sales_Sequences>;
};

export type Sales_SequencesEdge = {
  __typename?: "sales_sequencesEdge";
  cursor: Scalars["String"]["output"];
  node: Sales_Sequences;
};

export type Sales_SequencesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Sales_SequencesFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  deal_stage_trigger?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  is_active?: InputMaybe<BooleanFilter>;
  is_default?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Sales_SequencesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Sales_SequencesFilter>>;
  region_hint?: InputMaybe<Sequence_Region_HintFilter>;
  target_type?: InputMaybe<Sequence_TargetFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Sales_SequencesInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  deal_stage_trigger?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_default?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  region_hint?: InputMaybe<Sequence_Region_Hint>;
  target_type?: InputMaybe<Sequence_Target>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Sales_SequencesInsertResponse = {
  __typename?: "sales_sequencesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Sales_Sequences>;
};

export type Sales_SequencesOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  deal_stage_trigger?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_active?: InputMaybe<OrderByDirection>;
  is_default?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  region_hint?: InputMaybe<OrderByDirection>;
  target_type?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Sales_SequencesUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  deal_stage_trigger?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_default?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  region_hint?: InputMaybe<Sequence_Region_Hint>;
  target_type?: InputMaybe<Sequence_Target>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Sales_SequencesUpdateResponse = {
  __typename?: "sales_sequencesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Sales_Sequences>;
};

export type Saved_View_Favorites = Node & {
  __typename?: "saved_view_favorites";
  created_at: Scalars["Datetime"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  saved_views?: Maybe<Saved_Views>;
  user_id: Scalars["UUID"]["output"];
  view_id: Scalars["UUID"]["output"];
};

export type Saved_View_FavoritesConnection = {
  __typename?: "saved_view_favoritesConnection";
  edges: Array<Saved_View_FavoritesEdge>;
  pageInfo: PageInfo;
};

export type Saved_View_FavoritesDeleteResponse = {
  __typename?: "saved_view_favoritesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Saved_View_Favorites>;
};

export type Saved_View_FavoritesEdge = {
  __typename?: "saved_view_favoritesEdge";
  cursor: Scalars["String"]["output"];
  node: Saved_View_Favorites;
};

export type Saved_View_FavoritesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Saved_View_FavoritesFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Saved_View_FavoritesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Saved_View_FavoritesFilter>>;
  user_id?: InputMaybe<UuidFilter>;
  view_id?: InputMaybe<UuidFilter>;
};

export type Saved_View_FavoritesInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
  view_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Saved_View_FavoritesInsertResponse = {
  __typename?: "saved_view_favoritesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Saved_View_Favorites>;
};

export type Saved_View_FavoritesOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
  view_id?: InputMaybe<OrderByDirection>;
};

export type Saved_View_FavoritesUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
  view_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Saved_View_FavoritesUpdateResponse = {
  __typename?: "saved_view_favoritesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Saved_View_Favorites>;
};

export type Saved_Views = Node & {
  __typename?: "saved_views";
  created_at: Scalars["Datetime"]["output"];
  created_by: Scalars["UUID"]["output"];
  filters: Scalars["JSON"]["output"];
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  resource: Scalars["String"]["output"];
  saved_view_favoritesCollection?: Maybe<Saved_View_FavoritesConnection>;
  shared_with_user_ids: Array<Maybe<Scalars["UUID"]["output"]>>;
  updated_at: Scalars["Datetime"]["output"];
  visibility: Scalars["String"]["output"];
};

export type Saved_ViewsSaved_View_FavoritesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Saved_View_FavoritesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Saved_View_FavoritesOrderBy>>;
};

export type Saved_ViewsConnection = {
  __typename?: "saved_viewsConnection";
  edges: Array<Saved_ViewsEdge>;
  pageInfo: PageInfo;
};

export type Saved_ViewsDeleteResponse = {
  __typename?: "saved_viewsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Saved_Views>;
};

export type Saved_ViewsEdge = {
  __typename?: "saved_viewsEdge";
  cursor: Scalars["String"]["output"];
  node: Saved_Views;
};

export type Saved_ViewsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Saved_ViewsFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Saved_ViewsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Saved_ViewsFilter>>;
  resource?: InputMaybe<StringFilter>;
  shared_with_user_ids?: InputMaybe<UuidListFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  visibility?: InputMaybe<StringFilter>;
};

export type Saved_ViewsInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  filters?: InputMaybe<Scalars["JSON"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  resource?: InputMaybe<Scalars["String"]["input"]>;
  shared_with_user_ids?: InputMaybe<Array<InputMaybe<Scalars["UUID"]["input"]>>>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  visibility?: InputMaybe<Scalars["String"]["input"]>;
};

export type Saved_ViewsInsertResponse = {
  __typename?: "saved_viewsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Saved_Views>;
};

export type Saved_ViewsOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  resource?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  visibility?: InputMaybe<OrderByDirection>;
};

export type Saved_ViewsUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  filters?: InputMaybe<Scalars["JSON"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  resource?: InputMaybe<Scalars["String"]["input"]>;
  shared_with_user_ids?: InputMaybe<Array<InputMaybe<Scalars["UUID"]["input"]>>>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  visibility?: InputMaybe<Scalars["String"]["input"]>;
};

export type Saved_ViewsUpdateResponse = {
  __typename?: "saved_viewsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Saved_Views>;
};

export type Scheduled_Emails = Node & {
  __typename?: "scheduled_emails";
  app_users?: Maybe<App_Users>;
  attempts: Scalars["Int"]["output"];
  bcc?: Maybe<Scalars["String"]["output"]>;
  body: Scalars["String"]["output"];
  body_format?: Maybe<Scalars["String"]["output"]>;
  cc?: Maybe<Scalars["String"]["output"]>;
  connection_id?: Maybe<Scalars["String"]["output"]>;
  contact_id?: Maybe<Scalars["UUID"]["output"]>;
  created_at: Scalars["Datetime"]["output"];
  email_templates?: Maybe<Email_Templates>;
  error?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  provider?: Maybe<Scalars["String"]["output"]>;
  scheduled_at: Scalars["Datetime"]["output"];
  sent_at?: Maybe<Scalars["Datetime"]["output"]>;
  signature_id?: Maybe<Scalars["UUID"]["output"]>;
  status: Scalars["String"]["output"];
  subject: Scalars["String"]["output"];
  template_id?: Maybe<Scalars["UUID"]["output"]>;
  to_email: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type Scheduled_EmailsConnection = {
  __typename?: "scheduled_emailsConnection";
  edges: Array<Scheduled_EmailsEdge>;
  pageInfo: PageInfo;
};

export type Scheduled_EmailsDeleteResponse = {
  __typename?: "scheduled_emailsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Scheduled_Emails>;
};

export type Scheduled_EmailsEdge = {
  __typename?: "scheduled_emailsEdge";
  cursor: Scalars["String"]["output"];
  node: Scheduled_Emails;
};

export type Scheduled_EmailsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Scheduled_EmailsFilter>>;
  attempts?: InputMaybe<IntFilter>;
  bcc?: InputMaybe<StringFilter>;
  body?: InputMaybe<StringFilter>;
  body_format?: InputMaybe<StringFilter>;
  cc?: InputMaybe<StringFilter>;
  connection_id?: InputMaybe<StringFilter>;
  contact_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  error?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Scheduled_EmailsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Scheduled_EmailsFilter>>;
  provider?: InputMaybe<StringFilter>;
  scheduled_at?: InputMaybe<DatetimeFilter>;
  sent_at?: InputMaybe<DatetimeFilter>;
  signature_id?: InputMaybe<UuidFilter>;
  status?: InputMaybe<StringFilter>;
  subject?: InputMaybe<StringFilter>;
  template_id?: InputMaybe<UuidFilter>;
  to_email?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Scheduled_EmailsInsertInput = {
  attempts?: InputMaybe<Scalars["Int"]["input"]>;
  bcc?: InputMaybe<Scalars["String"]["input"]>;
  body?: InputMaybe<Scalars["String"]["input"]>;
  body_format?: InputMaybe<Scalars["String"]["input"]>;
  cc?: InputMaybe<Scalars["String"]["input"]>;
  connection_id?: InputMaybe<Scalars["String"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  error?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  provider?: InputMaybe<Scalars["String"]["input"]>;
  scheduled_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  sent_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  signature_id?: InputMaybe<Scalars["UUID"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  subject?: InputMaybe<Scalars["String"]["input"]>;
  template_id?: InputMaybe<Scalars["UUID"]["input"]>;
  to_email?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Scheduled_EmailsInsertResponse = {
  __typename?: "scheduled_emailsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Scheduled_Emails>;
};

export type Scheduled_EmailsOrderBy = {
  attempts?: InputMaybe<OrderByDirection>;
  bcc?: InputMaybe<OrderByDirection>;
  body?: InputMaybe<OrderByDirection>;
  body_format?: InputMaybe<OrderByDirection>;
  cc?: InputMaybe<OrderByDirection>;
  connection_id?: InputMaybe<OrderByDirection>;
  contact_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  error?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  provider?: InputMaybe<OrderByDirection>;
  scheduled_at?: InputMaybe<OrderByDirection>;
  sent_at?: InputMaybe<OrderByDirection>;
  signature_id?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  subject?: InputMaybe<OrderByDirection>;
  template_id?: InputMaybe<OrderByDirection>;
  to_email?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Scheduled_EmailsUpdateInput = {
  attempts?: InputMaybe<Scalars["Int"]["input"]>;
  bcc?: InputMaybe<Scalars["String"]["input"]>;
  body?: InputMaybe<Scalars["String"]["input"]>;
  body_format?: InputMaybe<Scalars["String"]["input"]>;
  cc?: InputMaybe<Scalars["String"]["input"]>;
  connection_id?: InputMaybe<Scalars["String"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  error?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  provider?: InputMaybe<Scalars["String"]["input"]>;
  scheduled_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  sent_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  signature_id?: InputMaybe<Scalars["UUID"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  subject?: InputMaybe<Scalars["String"]["input"]>;
  template_id?: InputMaybe<Scalars["UUID"]["input"]>;
  to_email?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Scheduled_EmailsUpdateResponse = {
  __typename?: "scheduled_emailsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Scheduled_Emails>;
};

export type Scheduled_Sms = Node & {
  __typename?: "scheduled_sms";
  app_users?: Maybe<App_Users>;
  attempts: Scalars["Int"]["output"];
  body: Scalars["String"]["output"];
  contact_id: Scalars["UUID"]["output"];
  created_at: Scalars["Datetime"]["output"];
  error?: Maybe<Scalars["String"]["output"]>;
  external_id?: Maybe<Scalars["String"]["output"]>;
  from_number: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  phone_override?: Maybe<Scalars["String"]["output"]>;
  quick_reply_id?: Maybe<Scalars["String"]["output"]>;
  scheduled_at: Scalars["Datetime"]["output"];
  sent_at?: Maybe<Scalars["Datetime"]["output"]>;
  status: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type Scheduled_SmsConnection = {
  __typename?: "scheduled_smsConnection";
  edges: Array<Scheduled_SmsEdge>;
  pageInfo: PageInfo;
};

export type Scheduled_SmsDeleteResponse = {
  __typename?: "scheduled_smsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Scheduled_Sms>;
};

export type Scheduled_SmsEdge = {
  __typename?: "scheduled_smsEdge";
  cursor: Scalars["String"]["output"];
  node: Scheduled_Sms;
};

export type Scheduled_SmsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Scheduled_SmsFilter>>;
  attempts?: InputMaybe<IntFilter>;
  body?: InputMaybe<StringFilter>;
  contact_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  error?: InputMaybe<StringFilter>;
  external_id?: InputMaybe<StringFilter>;
  from_number?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Scheduled_SmsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Scheduled_SmsFilter>>;
  phone_override?: InputMaybe<StringFilter>;
  quick_reply_id?: InputMaybe<StringFilter>;
  scheduled_at?: InputMaybe<DatetimeFilter>;
  sent_at?: InputMaybe<DatetimeFilter>;
  status?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Scheduled_SmsInsertInput = {
  attempts?: InputMaybe<Scalars["Int"]["input"]>;
  body?: InputMaybe<Scalars["String"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  error?: InputMaybe<Scalars["String"]["input"]>;
  external_id?: InputMaybe<Scalars["String"]["input"]>;
  from_number?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  phone_override?: InputMaybe<Scalars["String"]["input"]>;
  quick_reply_id?: InputMaybe<Scalars["String"]["input"]>;
  scheduled_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  sent_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Scheduled_SmsInsertResponse = {
  __typename?: "scheduled_smsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Scheduled_Sms>;
};

export type Scheduled_SmsOrderBy = {
  attempts?: InputMaybe<OrderByDirection>;
  body?: InputMaybe<OrderByDirection>;
  contact_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  error?: InputMaybe<OrderByDirection>;
  external_id?: InputMaybe<OrderByDirection>;
  from_number?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  phone_override?: InputMaybe<OrderByDirection>;
  quick_reply_id?: InputMaybe<OrderByDirection>;
  scheduled_at?: InputMaybe<OrderByDirection>;
  sent_at?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Scheduled_SmsUpdateInput = {
  attempts?: InputMaybe<Scalars["Int"]["input"]>;
  body?: InputMaybe<Scalars["String"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  error?: InputMaybe<Scalars["String"]["input"]>;
  external_id?: InputMaybe<Scalars["String"]["input"]>;
  from_number?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  phone_override?: InputMaybe<Scalars["String"]["input"]>;
  quick_reply_id?: InputMaybe<Scalars["String"]["input"]>;
  scheduled_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  sent_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Scheduled_SmsUpdateResponse = {
  __typename?: "scheduled_smsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Scheduled_Sms>;
};

export type Secure_Links = Node & {
  __typename?: "secure_links";
  app_users?: Maybe<App_Users>;
  contract_previewsCollection?: Maybe<Contract_PreviewsConnection>;
  contractsCollection?: Maybe<ContractsConnection>;
  created_at: Scalars["Datetime"]["output"];
  created_by?: Maybe<Scalars["UUID"]["output"]>;
  customer_feedbackCollection?: Maybe<Customer_FeedbackConnection>;
  expires_at: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  last_used_at?: Maybe<Scalars["Datetime"]["output"]>;
  max_uses?: Maybe<Scalars["Int"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  payload?: Maybe<Scalars["JSON"]["output"]>;
  public_id: Scalars["UUID"]["output"];
  purpose: Scalars["String"]["output"];
  revoked_at?: Maybe<Scalars["Datetime"]["output"]>;
  secret_hash: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
  use_count: Scalars["Int"]["output"];
};

export type Secure_LinksContract_PreviewsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contract_PreviewsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Contract_PreviewsOrderBy>>;
};

export type Secure_LinksContractsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<ContractsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<ContractsOrderBy>>;
};

export type Secure_LinksCustomer_FeedbackCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Customer_FeedbackFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Customer_FeedbackOrderBy>>;
};

export type Secure_LinksConnection = {
  __typename?: "secure_linksConnection";
  edges: Array<Secure_LinksEdge>;
  pageInfo: PageInfo;
};

export type Secure_LinksDeleteResponse = {
  __typename?: "secure_linksDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Secure_Links>;
};

export type Secure_LinksEdge = {
  __typename?: "secure_linksEdge";
  cursor: Scalars["String"]["output"];
  node: Secure_Links;
};

export type Secure_LinksFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Secure_LinksFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  expires_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  last_used_at?: InputMaybe<DatetimeFilter>;
  max_uses?: InputMaybe<IntFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Secure_LinksFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Secure_LinksFilter>>;
  public_id?: InputMaybe<UuidFilter>;
  purpose?: InputMaybe<StringFilter>;
  revoked_at?: InputMaybe<DatetimeFilter>;
  secret_hash?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  use_count?: InputMaybe<IntFilter>;
};

export type Secure_LinksInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  expires_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  last_used_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  max_uses?: InputMaybe<Scalars["Int"]["input"]>;
  payload?: InputMaybe<Scalars["JSON"]["input"]>;
  public_id?: InputMaybe<Scalars["UUID"]["input"]>;
  purpose?: InputMaybe<Scalars["String"]["input"]>;
  revoked_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  secret_hash?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  use_count?: InputMaybe<Scalars["Int"]["input"]>;
};

export type Secure_LinksInsertResponse = {
  __typename?: "secure_linksInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Secure_Links>;
};

export type Secure_LinksOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  expires_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  last_used_at?: InputMaybe<OrderByDirection>;
  max_uses?: InputMaybe<OrderByDirection>;
  public_id?: InputMaybe<OrderByDirection>;
  purpose?: InputMaybe<OrderByDirection>;
  revoked_at?: InputMaybe<OrderByDirection>;
  secret_hash?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  use_count?: InputMaybe<OrderByDirection>;
};

export type Secure_LinksUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  expires_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  last_used_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  max_uses?: InputMaybe<Scalars["Int"]["input"]>;
  payload?: InputMaybe<Scalars["JSON"]["input"]>;
  public_id?: InputMaybe<Scalars["UUID"]["input"]>;
  purpose?: InputMaybe<Scalars["String"]["input"]>;
  revoked_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  secret_hash?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  use_count?: InputMaybe<Scalars["Int"]["input"]>;
};

export type Secure_LinksUpdateResponse = {
  __typename?: "secure_linksUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Secure_Links>;
};

export type Sequence_Channel = "call" | "email" | "letter" | "linkedin" | "other" | "sms";

/** Boolean expression comparing fields on type "sequence_channel" */
export type Sequence_ChannelFilter = {
  eq?: InputMaybe<Sequence_Channel>;
  in?: InputMaybe<Array<Sequence_Channel>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Sequence_Channel>;
};

export type Sequence_Enrollment_Status = "active" | "bailed" | "completed" | "paused" | "replied";

/** Boolean expression comparing fields on type "sequence_enrollment_status" */
export type Sequence_Enrollment_StatusFilter = {
  eq?: InputMaybe<Sequence_Enrollment_Status>;
  in?: InputMaybe<Array<Sequence_Enrollment_Status>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Sequence_Enrollment_Status>;
};

export type Sequence_Region_Hint = "any" | "local" | "remote";

/** Boolean expression comparing fields on type "sequence_region_hint" */
export type Sequence_Region_HintFilter = {
  eq?: InputMaybe<Sequence_Region_Hint>;
  in?: InputMaybe<Array<Sequence_Region_Hint>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Sequence_Region_Hint>;
};

export type Sequence_Step_Outcome =
  "booked" | "bounced" | "done" | "no_answer" | "replied" | "skipped";

/** Boolean expression comparing fields on type "sequence_step_outcome" */
export type Sequence_Step_OutcomeFilter = {
  eq?: InputMaybe<Sequence_Step_Outcome>;
  in?: InputMaybe<Array<Sequence_Step_Outcome>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Sequence_Step_Outcome>;
};

export type Sequence_Target = "company" | "contact";

/** Boolean expression comparing fields on type "sequence_target" */
export type Sequence_TargetFilter = {
  eq?: InputMaybe<Sequence_Target>;
  in?: InputMaybe<Array<Sequence_Target>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Sequence_Target>;
};

export type Skills_Catalog = Node & {
  __typename?: "skills_catalog";
  app_user_skillsCollection?: Maybe<App_User_SkillsConnection>;
  category: Scalars["String"]["output"];
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  id: Scalars["UUID"]["output"];
  name: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  search_vector?: Maybe<Scalars["Opaque"]["output"]>;
  sort_order: Scalars["Int"]["output"];
};

export type Skills_CatalogApp_User_SkillsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<App_User_SkillsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<App_User_SkillsOrderBy>>;
};

export type Skills_CatalogConnection = {
  __typename?: "skills_catalogConnection";
  edges: Array<Skills_CatalogEdge>;
  pageInfo: PageInfo;
};

export type Skills_CatalogDeleteResponse = {
  __typename?: "skills_catalogDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Skills_Catalog>;
};

export type Skills_CatalogEdge = {
  __typename?: "skills_catalogEdge";
  cursor: Scalars["String"]["output"];
  node: Skills_Catalog;
};

export type Skills_CatalogFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Skills_CatalogFilter>>;
  category?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Skills_CatalogFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Skills_CatalogFilter>>;
  search_vector?: InputMaybe<OpaqueFilter>;
  sort_order?: InputMaybe<IntFilter>;
};

export type Skills_CatalogInsertInput = {
  category?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sort_order?: InputMaybe<Scalars["Int"]["input"]>;
};

export type Skills_CatalogInsertResponse = {
  __typename?: "skills_catalogInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Skills_Catalog>;
};

export type Skills_CatalogOrderBy = {
  category?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  search_vector?: InputMaybe<OrderByDirection>;
  sort_order?: InputMaybe<OrderByDirection>;
};

export type Skills_CatalogUpdateInput = {
  category?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sort_order?: InputMaybe<Scalars["Int"]["input"]>;
};

export type Skills_CatalogUpdateResponse = {
  __typename?: "skills_catalogUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Skills_Catalog>;
};

export type Slack_Channel_Provisioning = Node & {
  __typename?: "slack_channel_provisioning";
  bookmarks_hash?: Maybe<Scalars["String"]["output"]>;
  canvas_id?: Maybe<Scalars["String"]["output"]>;
  channel_id: Scalars["String"]["output"];
  companies?: Maybe<Companies>;
  company_id: Scalars["UUID"]["output"];
  content_hash?: Maybe<Scalars["String"]["output"]>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  id: Scalars["UUID"]["output"];
  last_error?: Maybe<Scalars["String"]["output"]>;
  last_status?: Maybe<Scalars["String"]["output"]>;
  last_synced_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  topic_hash?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type Slack_Channel_ProvisioningConnection = {
  __typename?: "slack_channel_provisioningConnection";
  edges: Array<Slack_Channel_ProvisioningEdge>;
  pageInfo: PageInfo;
};

export type Slack_Channel_ProvisioningDeleteResponse = {
  __typename?: "slack_channel_provisioningDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Slack_Channel_Provisioning>;
};

export type Slack_Channel_ProvisioningEdge = {
  __typename?: "slack_channel_provisioningEdge";
  cursor: Scalars["String"]["output"];
  node: Slack_Channel_Provisioning;
};

export type Slack_Channel_ProvisioningFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Slack_Channel_ProvisioningFilter>>;
  bookmarks_hash?: InputMaybe<StringFilter>;
  canvas_id?: InputMaybe<StringFilter>;
  channel_id?: InputMaybe<StringFilter>;
  company_id?: InputMaybe<UuidFilter>;
  content_hash?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  last_error?: InputMaybe<StringFilter>;
  last_status?: InputMaybe<StringFilter>;
  last_synced_at?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Slack_Channel_ProvisioningFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Slack_Channel_ProvisioningFilter>>;
  topic_hash?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Slack_Channel_ProvisioningInsertInput = {
  bookmarks_hash?: InputMaybe<Scalars["String"]["input"]>;
  canvas_id?: InputMaybe<Scalars["String"]["input"]>;
  channel_id?: InputMaybe<Scalars["String"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  content_hash?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  last_error?: InputMaybe<Scalars["String"]["input"]>;
  last_status?: InputMaybe<Scalars["String"]["input"]>;
  last_synced_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  topic_hash?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Slack_Channel_ProvisioningInsertResponse = {
  __typename?: "slack_channel_provisioningInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Slack_Channel_Provisioning>;
};

export type Slack_Channel_ProvisioningOrderBy = {
  bookmarks_hash?: InputMaybe<OrderByDirection>;
  canvas_id?: InputMaybe<OrderByDirection>;
  channel_id?: InputMaybe<OrderByDirection>;
  company_id?: InputMaybe<OrderByDirection>;
  content_hash?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  last_error?: InputMaybe<OrderByDirection>;
  last_status?: InputMaybe<OrderByDirection>;
  last_synced_at?: InputMaybe<OrderByDirection>;
  topic_hash?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Slack_Channel_ProvisioningUpdateInput = {
  bookmarks_hash?: InputMaybe<Scalars["String"]["input"]>;
  canvas_id?: InputMaybe<Scalars["String"]["input"]>;
  channel_id?: InputMaybe<Scalars["String"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  content_hash?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  last_error?: InputMaybe<Scalars["String"]["input"]>;
  last_status?: InputMaybe<Scalars["String"]["input"]>;
  last_synced_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  topic_hash?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Slack_Channel_ProvisioningUpdateResponse = {
  __typename?: "slack_channel_provisioningUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Slack_Channel_Provisioning>;
};

export type Slack_Processed_Events = Node & {
  __typename?: "slack_processed_events";
  dedup_key: Scalars["String"]["output"];
  expires_at: Scalars["Datetime"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  payload_type: Scalars["String"]["output"];
  processed_at: Scalars["Datetime"]["output"];
};

export type Slack_Processed_EventsConnection = {
  __typename?: "slack_processed_eventsConnection";
  edges: Array<Slack_Processed_EventsEdge>;
  pageInfo: PageInfo;
};

export type Slack_Processed_EventsDeleteResponse = {
  __typename?: "slack_processed_eventsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Slack_Processed_Events>;
};

export type Slack_Processed_EventsEdge = {
  __typename?: "slack_processed_eventsEdge";
  cursor: Scalars["String"]["output"];
  node: Slack_Processed_Events;
};

export type Slack_Processed_EventsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Slack_Processed_EventsFilter>>;
  dedup_key?: InputMaybe<StringFilter>;
  expires_at?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Slack_Processed_EventsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Slack_Processed_EventsFilter>>;
  payload_type?: InputMaybe<StringFilter>;
  processed_at?: InputMaybe<DatetimeFilter>;
};

export type Slack_Processed_EventsInsertInput = {
  dedup_key?: InputMaybe<Scalars["String"]["input"]>;
  expires_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  payload_type?: InputMaybe<Scalars["String"]["input"]>;
  processed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Slack_Processed_EventsInsertResponse = {
  __typename?: "slack_processed_eventsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Slack_Processed_Events>;
};

export type Slack_Processed_EventsOrderBy = {
  dedup_key?: InputMaybe<OrderByDirection>;
  expires_at?: InputMaybe<OrderByDirection>;
  payload_type?: InputMaybe<OrderByDirection>;
  processed_at?: InputMaybe<OrderByDirection>;
};

export type Slack_Processed_EventsUpdateInput = {
  dedup_key?: InputMaybe<Scalars["String"]["input"]>;
  expires_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  payload_type?: InputMaybe<Scalars["String"]["input"]>;
  processed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Slack_Processed_EventsUpdateResponse = {
  __typename?: "slack_processed_eventsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Slack_Processed_Events>;
};

export type Social_Brand_Channels = Node & {
  __typename?: "social_brand_channels";
  brand_id: Scalars["String"]["output"];
  created_at: Scalars["Datetime"]["output"];
  credential_id?: Maybe<Scalars["UUID"]["output"]>;
  external_channel_id?: Maybe<Scalars["String"]["output"]>;
  external_display_name?: Maybe<Scalars["String"]["output"]>;
  external_service?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  last_published_at?: Maybe<Scalars["Datetime"]["output"]>;
  marketing_brands?: Maybe<Marketing_Brands>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  platform: Scalars["String"]["output"];
  provider: Scalars["String"]["output"];
  social_brand_credentials?: Maybe<Social_Brand_Credentials>;
  status: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
  webhook_url?: Maybe<Scalars["String"]["output"]>;
};

export type Social_Brand_ChannelsConnection = {
  __typename?: "social_brand_channelsConnection";
  edges: Array<Social_Brand_ChannelsEdge>;
  pageInfo: PageInfo;
};

export type Social_Brand_ChannelsDeleteResponse = {
  __typename?: "social_brand_channelsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Social_Brand_Channels>;
};

export type Social_Brand_ChannelsEdge = {
  __typename?: "social_brand_channelsEdge";
  cursor: Scalars["String"]["output"];
  node: Social_Brand_Channels;
};

export type Social_Brand_ChannelsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Social_Brand_ChannelsFilter>>;
  brand_id?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  credential_id?: InputMaybe<UuidFilter>;
  external_channel_id?: InputMaybe<StringFilter>;
  external_display_name?: InputMaybe<StringFilter>;
  external_service?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  last_published_at?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Social_Brand_ChannelsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Social_Brand_ChannelsFilter>>;
  platform?: InputMaybe<StringFilter>;
  provider?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  webhook_url?: InputMaybe<StringFilter>;
};

export type Social_Brand_ChannelsInsertInput = {
  brand_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  credential_id?: InputMaybe<Scalars["UUID"]["input"]>;
  external_channel_id?: InputMaybe<Scalars["String"]["input"]>;
  external_display_name?: InputMaybe<Scalars["String"]["input"]>;
  external_service?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  last_published_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  platform?: InputMaybe<Scalars["String"]["input"]>;
  provider?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  webhook_url?: InputMaybe<Scalars["String"]["input"]>;
};

export type Social_Brand_ChannelsInsertResponse = {
  __typename?: "social_brand_channelsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Social_Brand_Channels>;
};

export type Social_Brand_ChannelsOrderBy = {
  brand_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  credential_id?: InputMaybe<OrderByDirection>;
  external_channel_id?: InputMaybe<OrderByDirection>;
  external_display_name?: InputMaybe<OrderByDirection>;
  external_service?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  last_published_at?: InputMaybe<OrderByDirection>;
  platform?: InputMaybe<OrderByDirection>;
  provider?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  webhook_url?: InputMaybe<OrderByDirection>;
};

export type Social_Brand_ChannelsUpdateInput = {
  brand_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  credential_id?: InputMaybe<Scalars["UUID"]["input"]>;
  external_channel_id?: InputMaybe<Scalars["String"]["input"]>;
  external_display_name?: InputMaybe<Scalars["String"]["input"]>;
  external_service?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  last_published_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  platform?: InputMaybe<Scalars["String"]["input"]>;
  provider?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  webhook_url?: InputMaybe<Scalars["String"]["input"]>;
};

export type Social_Brand_ChannelsUpdateResponse = {
  __typename?: "social_brand_channelsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Social_Brand_Channels>;
};

export type Social_Brand_Credentials = Node & {
  __typename?: "social_brand_credentials";
  api_key_encrypted?: Maybe<Scalars["String"]["output"]>;
  api_key_env_var?: Maybe<Scalars["String"]["output"]>;
  brand_id: Scalars["String"]["output"];
  channel_count?: Maybe<Scalars["Int"]["output"]>;
  created_at: Scalars["Datetime"]["output"];
  id: Scalars["UUID"]["output"];
  label: Scalars["String"]["output"];
  last_error?: Maybe<Scalars["String"]["output"]>;
  last_verified_at?: Maybe<Scalars["Datetime"]["output"]>;
  marketing_brands?: Maybe<Marketing_Brands>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  platforms: Array<Maybe<Scalars["String"]["output"]>>;
  provider: Scalars["String"]["output"];
  social_brand_channelsCollection?: Maybe<Social_Brand_ChannelsConnection>;
  updated_at: Scalars["Datetime"]["output"];
};

export type Social_Brand_CredentialsSocial_Brand_ChannelsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Social_Brand_ChannelsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Social_Brand_ChannelsOrderBy>>;
};

export type Social_Brand_CredentialsConnection = {
  __typename?: "social_brand_credentialsConnection";
  edges: Array<Social_Brand_CredentialsEdge>;
  pageInfo: PageInfo;
};

export type Social_Brand_CredentialsDeleteResponse = {
  __typename?: "social_brand_credentialsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Social_Brand_Credentials>;
};

export type Social_Brand_CredentialsEdge = {
  __typename?: "social_brand_credentialsEdge";
  cursor: Scalars["String"]["output"];
  node: Social_Brand_Credentials;
};

export type Social_Brand_CredentialsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Social_Brand_CredentialsFilter>>;
  api_key_encrypted?: InputMaybe<StringFilter>;
  api_key_env_var?: InputMaybe<StringFilter>;
  brand_id?: InputMaybe<StringFilter>;
  channel_count?: InputMaybe<IntFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  label?: InputMaybe<StringFilter>;
  last_error?: InputMaybe<StringFilter>;
  last_verified_at?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Social_Brand_CredentialsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Social_Brand_CredentialsFilter>>;
  platforms?: InputMaybe<StringListFilter>;
  provider?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Social_Brand_CredentialsInsertInput = {
  api_key_encrypted?: InputMaybe<Scalars["String"]["input"]>;
  api_key_env_var?: InputMaybe<Scalars["String"]["input"]>;
  brand_id?: InputMaybe<Scalars["String"]["input"]>;
  channel_count?: InputMaybe<Scalars["Int"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  last_error?: InputMaybe<Scalars["String"]["input"]>;
  last_verified_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  platforms?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  provider?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Social_Brand_CredentialsInsertResponse = {
  __typename?: "social_brand_credentialsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Social_Brand_Credentials>;
};

export type Social_Brand_CredentialsOrderBy = {
  api_key_encrypted?: InputMaybe<OrderByDirection>;
  api_key_env_var?: InputMaybe<OrderByDirection>;
  brand_id?: InputMaybe<OrderByDirection>;
  channel_count?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  label?: InputMaybe<OrderByDirection>;
  last_error?: InputMaybe<OrderByDirection>;
  last_verified_at?: InputMaybe<OrderByDirection>;
  provider?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Social_Brand_CredentialsUpdateInput = {
  api_key_encrypted?: InputMaybe<Scalars["String"]["input"]>;
  api_key_env_var?: InputMaybe<Scalars["String"]["input"]>;
  brand_id?: InputMaybe<Scalars["String"]["input"]>;
  channel_count?: InputMaybe<Scalars["Int"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  label?: InputMaybe<Scalars["String"]["input"]>;
  last_error?: InputMaybe<Scalars["String"]["input"]>;
  last_verified_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  platforms?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  provider?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Social_Brand_CredentialsUpdateResponse = {
  __typename?: "social_brand_credentialsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Social_Brand_Credentials>;
};

export type Social_Hashtag_Groups = Node & {
  __typename?: "social_hashtag_groups";
  brand: Scalars["String"]["output"];
  created_at: Scalars["Datetime"]["output"];
  created_by?: Maybe<Scalars["UUID"]["output"]>;
  id: Scalars["UUID"]["output"];
  marketing_brands?: Maybe<Marketing_Brands>;
  name: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  tags: Array<Maybe<Scalars["String"]["output"]>>;
  updated_at: Scalars["Datetime"]["output"];
};

export type Social_Hashtag_GroupsConnection = {
  __typename?: "social_hashtag_groupsConnection";
  edges: Array<Social_Hashtag_GroupsEdge>;
  pageInfo: PageInfo;
};

export type Social_Hashtag_GroupsDeleteResponse = {
  __typename?: "social_hashtag_groupsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Social_Hashtag_Groups>;
};

export type Social_Hashtag_GroupsEdge = {
  __typename?: "social_hashtag_groupsEdge";
  cursor: Scalars["String"]["output"];
  node: Social_Hashtag_Groups;
};

export type Social_Hashtag_GroupsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Social_Hashtag_GroupsFilter>>;
  brand?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Social_Hashtag_GroupsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Social_Hashtag_GroupsFilter>>;
  tags?: InputMaybe<StringListFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Social_Hashtag_GroupsInsertInput = {
  brand?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Social_Hashtag_GroupsInsertResponse = {
  __typename?: "social_hashtag_groupsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Social_Hashtag_Groups>;
};

export type Social_Hashtag_GroupsOrderBy = {
  brand?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Social_Hashtag_GroupsUpdateInput = {
  brand?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Social_Hashtag_GroupsUpdateResponse = {
  __typename?: "social_hashtag_groupsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Social_Hashtag_Groups>;
};

export type Social_Media_Posts = Node & {
  __typename?: "social_media_posts";
  body: Scalars["String"]["output"];
  brand: Scalars["String"]["output"];
  companies?: Maybe<Companies>;
  company_id?: Maybe<Scalars["UUID"]["output"]>;
  contact_id?: Maybe<Scalars["UUID"]["output"]>;
  contacts?: Maybe<Contacts>;
  created_at: Scalars["Datetime"]["output"];
  created_by?: Maybe<Scalars["UUID"]["output"]>;
  drive_file_id?: Maybe<Scalars["String"]["output"]>;
  drive_file_name?: Maybe<Scalars["String"]["output"]>;
  drive_folder_id?: Maybe<Scalars["String"]["output"]>;
  error_summary?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
  location?: Maybe<Scalars["String"]["output"]>;
  marketing_brands?: Maybe<Marketing_Brands>;
  media_kind: Scalars["String"]["output"];
  media_url?: Maybe<Scalars["String"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  platforms: Array<Maybe<Scalars["String"]["output"]>>;
  published_at?: Maybe<Scalars["Datetime"]["output"]>;
  results: Scalars["JSON"]["output"];
  scheduled_at?: Maybe<Scalars["Datetime"]["output"]>;
  status: Scalars["String"]["output"];
  tags: Array<Maybe<Scalars["String"]["output"]>>;
  thumbnail_url?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  updated_at: Scalars["Datetime"]["output"];
  youtube?: Maybe<Scalars["JSON"]["output"]>;
};

export type Social_Media_PostsConnection = {
  __typename?: "social_media_postsConnection";
  edges: Array<Social_Media_PostsEdge>;
  pageInfo: PageInfo;
};

export type Social_Media_PostsDeleteResponse = {
  __typename?: "social_media_postsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Social_Media_Posts>;
};

export type Social_Media_PostsEdge = {
  __typename?: "social_media_postsEdge";
  cursor: Scalars["String"]["output"];
  node: Social_Media_Posts;
};

export type Social_Media_PostsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Social_Media_PostsFilter>>;
  body?: InputMaybe<StringFilter>;
  brand?: InputMaybe<StringFilter>;
  company_id?: InputMaybe<UuidFilter>;
  contact_id?: InputMaybe<UuidFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  drive_file_id?: InputMaybe<StringFilter>;
  drive_file_name?: InputMaybe<StringFilter>;
  drive_folder_id?: InputMaybe<StringFilter>;
  error_summary?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  location?: InputMaybe<StringFilter>;
  media_kind?: InputMaybe<StringFilter>;
  media_url?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Social_Media_PostsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Social_Media_PostsFilter>>;
  platforms?: InputMaybe<StringListFilter>;
  published_at?: InputMaybe<DatetimeFilter>;
  scheduled_at?: InputMaybe<DatetimeFilter>;
  status?: InputMaybe<StringFilter>;
  tags?: InputMaybe<StringListFilter>;
  thumbnail_url?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Social_Media_PostsInsertInput = {
  body?: InputMaybe<Scalars["String"]["input"]>;
  brand?: InputMaybe<Scalars["String"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  drive_file_id?: InputMaybe<Scalars["String"]["input"]>;
  drive_file_name?: InputMaybe<Scalars["String"]["input"]>;
  drive_folder_id?: InputMaybe<Scalars["String"]["input"]>;
  error_summary?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  media_kind?: InputMaybe<Scalars["String"]["input"]>;
  media_url?: InputMaybe<Scalars["String"]["input"]>;
  platforms?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  published_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  results?: InputMaybe<Scalars["JSON"]["input"]>;
  scheduled_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  thumbnail_url?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  youtube?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type Social_Media_PostsInsertResponse = {
  __typename?: "social_media_postsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Social_Media_Posts>;
};

export type Social_Media_PostsOrderBy = {
  body?: InputMaybe<OrderByDirection>;
  brand?: InputMaybe<OrderByDirection>;
  company_id?: InputMaybe<OrderByDirection>;
  contact_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  drive_file_id?: InputMaybe<OrderByDirection>;
  drive_file_name?: InputMaybe<OrderByDirection>;
  drive_folder_id?: InputMaybe<OrderByDirection>;
  error_summary?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  location?: InputMaybe<OrderByDirection>;
  media_kind?: InputMaybe<OrderByDirection>;
  media_url?: InputMaybe<OrderByDirection>;
  published_at?: InputMaybe<OrderByDirection>;
  scheduled_at?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  thumbnail_url?: InputMaybe<OrderByDirection>;
  title?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Social_Media_PostsUpdateInput = {
  body?: InputMaybe<Scalars["String"]["input"]>;
  brand?: InputMaybe<Scalars["String"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  drive_file_id?: InputMaybe<Scalars["String"]["input"]>;
  drive_file_name?: InputMaybe<Scalars["String"]["input"]>;
  drive_folder_id?: InputMaybe<Scalars["String"]["input"]>;
  error_summary?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  media_kind?: InputMaybe<Scalars["String"]["input"]>;
  media_url?: InputMaybe<Scalars["String"]["input"]>;
  platforms?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  published_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  results?: InputMaybe<Scalars["JSON"]["input"]>;
  scheduled_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  thumbnail_url?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  youtube?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type Social_Media_PostsUpdateResponse = {
  __typename?: "social_media_postsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Social_Media_Posts>;
};

export type Sync_Status = "disapproved" | "failed" | "pending" | "synced";

/** Boolean expression comparing fields on type "sync_status" */
export type Sync_StatusFilter = {
  eq?: InputMaybe<Sync_Status>;
  in?: InputMaybe<Array<Sync_Status>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Sync_Status>;
};

export type Task_Notes = Node & {
  __typename?: "task_notes";
  app_users?: Maybe<App_Users>;
  contact_tasks?: Maybe<Contact_Tasks>;
  content: Scalars["String"]["output"];
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  id: Scalars["UUID"]["output"];
  is_internal?: Maybe<Scalars["Boolean"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  note_type?: Maybe<Scalars["String"]["output"]>;
  task_id: Scalars["UUID"]["output"];
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  user_id?: Maybe<Scalars["UUID"]["output"]>;
};

export type Task_NotesConnection = {
  __typename?: "task_notesConnection";
  edges: Array<Task_NotesEdge>;
  pageInfo: PageInfo;
};

export type Task_NotesDeleteResponse = {
  __typename?: "task_notesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Task_Notes>;
};

export type Task_NotesEdge = {
  __typename?: "task_notesEdge";
  cursor: Scalars["String"]["output"];
  node: Task_Notes;
};

export type Task_NotesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Task_NotesFilter>>;
  content?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  is_internal?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Task_NotesFilter>;
  note_type?: InputMaybe<StringFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Task_NotesFilter>>;
  task_id?: InputMaybe<UuidFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Task_NotesInsertInput = {
  content?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  note_type?: InputMaybe<Scalars["String"]["input"]>;
  task_id?: InputMaybe<Scalars["UUID"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Task_NotesInsertResponse = {
  __typename?: "task_notesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Task_Notes>;
};

export type Task_NotesOrderBy = {
  content?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_internal?: InputMaybe<OrderByDirection>;
  note_type?: InputMaybe<OrderByDirection>;
  task_id?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Task_NotesUpdateInput = {
  content?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  note_type?: InputMaybe<Scalars["String"]["input"]>;
  task_id?: InputMaybe<Scalars["UUID"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Task_NotesUpdateResponse = {
  __typename?: "task_notesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Task_Notes>;
};

export type Task_Status = "cancelled" | "completed" | "in_progress" | "pending";

/** Boolean expression comparing fields on type "task_status" */
export type Task_StatusFilter = {
  eq?: InputMaybe<Task_Status>;
  in?: InputMaybe<Array<Task_Status>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Task_Status>;
};

export type Ticket_Attachments = Node & {
  __typename?: "ticket_attachments";
  app_users?: Maybe<App_Users>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  file_name: Scalars["String"]["output"];
  file_path: Scalars["String"]["output"];
  file_size?: Maybe<Scalars["BigInt"]["output"]>;
  id: Scalars["UUID"]["output"];
  mime_type?: Maybe<Scalars["String"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  ticket_id: Scalars["UUID"]["output"];
  tickets?: Maybe<Tickets>;
  user_id: Scalars["UUID"]["output"];
};

export type Ticket_AttachmentsConnection = {
  __typename?: "ticket_attachmentsConnection";
  edges: Array<Ticket_AttachmentsEdge>;
  pageInfo: PageInfo;
};

export type Ticket_AttachmentsDeleteResponse = {
  __typename?: "ticket_attachmentsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Ticket_Attachments>;
};

export type Ticket_AttachmentsEdge = {
  __typename?: "ticket_attachmentsEdge";
  cursor: Scalars["String"]["output"];
  node: Ticket_Attachments;
};

export type Ticket_AttachmentsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Ticket_AttachmentsFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  description?: InputMaybe<StringFilter>;
  file_name?: InputMaybe<StringFilter>;
  file_path?: InputMaybe<StringFilter>;
  file_size?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<UuidFilter>;
  mime_type?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Ticket_AttachmentsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Ticket_AttachmentsFilter>>;
  ticket_id?: InputMaybe<UuidFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Ticket_AttachmentsInsertInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  file_name?: InputMaybe<Scalars["String"]["input"]>;
  file_path?: InputMaybe<Scalars["String"]["input"]>;
  file_size?: InputMaybe<Scalars["BigInt"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  mime_type?: InputMaybe<Scalars["String"]["input"]>;
  ticket_id?: InputMaybe<Scalars["UUID"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Ticket_AttachmentsInsertResponse = {
  __typename?: "ticket_attachmentsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Ticket_Attachments>;
};

export type Ticket_AttachmentsOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  file_name?: InputMaybe<OrderByDirection>;
  file_path?: InputMaybe<OrderByDirection>;
  file_size?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  mime_type?: InputMaybe<OrderByDirection>;
  ticket_id?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Ticket_AttachmentsUpdateInput = {
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  file_name?: InputMaybe<Scalars["String"]["input"]>;
  file_path?: InputMaybe<Scalars["String"]["input"]>;
  file_size?: InputMaybe<Scalars["BigInt"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  mime_type?: InputMaybe<Scalars["String"]["input"]>;
  ticket_id?: InputMaybe<Scalars["UUID"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Ticket_AttachmentsUpdateResponse = {
  __typename?: "ticket_attachmentsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Ticket_Attachments>;
};

export type Ticket_Category =
  | "backup"
  | "cloud"
  | "email"
  | "hardware"
  | "network"
  | "other"
  | "phone"
  | "printer"
  | "security"
  | "software";

/** Boolean expression comparing fields on type "ticket_category" */
export type Ticket_CategoryFilter = {
  eq?: InputMaybe<Ticket_Category>;
  in?: InputMaybe<Array<Ticket_Category>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Ticket_Category>;
};

export type Ticket_Priority = "critical" | "high" | "low" | "medium" | "urgent";

/** Boolean expression comparing fields on type "ticket_priority" */
export type Ticket_PriorityFilter = {
  eq?: InputMaybe<Ticket_Priority>;
  in?: InputMaybe<Array<Ticket_Priority>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Ticket_Priority>;
};

export type Ticket_Status =
  | "assigned"
  | "cancelled"
  | "closed"
  | "in_progress"
  | "new"
  | "resolved"
  | "waiting_for_customer"
  | "waiting_for_vendor";

/** Boolean expression comparing fields on type "ticket_status" */
export type Ticket_StatusFilter = {
  eq?: InputMaybe<Ticket_Status>;
  in?: InputMaybe<Array<Ticket_Status>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Ticket_Status>;
};

export type Ticket_Templates = Node & {
  __typename?: "ticket_templates";
  app_users?: Maybe<App_Users>;
  category?: Maybe<Ticket_Category>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  created_by: Scalars["UUID"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  description_template: Scalars["String"]["output"];
  estimated_hours?: Maybe<Scalars["BigFloat"]["output"]>;
  id: Scalars["UUID"]["output"];
  is_active?: Maybe<Scalars["Boolean"]["output"]>;
  name: Scalars["String"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  sla_hours?: Maybe<Scalars["Int"]["output"]>;
  tags?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  title_template: Scalars["String"]["output"];
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type Ticket_TemplatesConnection = {
  __typename?: "ticket_templatesConnection";
  edges: Array<Ticket_TemplatesEdge>;
  pageInfo: PageInfo;
};

export type Ticket_TemplatesDeleteResponse = {
  __typename?: "ticket_templatesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Ticket_Templates>;
};

export type Ticket_TemplatesEdge = {
  __typename?: "ticket_templatesEdge";
  cursor: Scalars["String"]["output"];
  node: Ticket_Templates;
};

export type Ticket_TemplatesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Ticket_TemplatesFilter>>;
  category?: InputMaybe<Ticket_CategoryFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  description?: InputMaybe<StringFilter>;
  description_template?: InputMaybe<StringFilter>;
  estimated_hours?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<UuidFilter>;
  is_active?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Ticket_TemplatesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Ticket_TemplatesFilter>>;
  sla_hours?: InputMaybe<IntFilter>;
  tags?: InputMaybe<StringListFilter>;
  title_template?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type Ticket_TemplatesInsertInput = {
  category?: InputMaybe<Ticket_Category>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  description_template?: InputMaybe<Scalars["String"]["input"]>;
  estimated_hours?: InputMaybe<Scalars["BigFloat"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sla_hours?: InputMaybe<Scalars["Int"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title_template?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Ticket_TemplatesInsertResponse = {
  __typename?: "ticket_templatesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Ticket_Templates>;
};

export type Ticket_TemplatesOrderBy = {
  category?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  description_template?: InputMaybe<OrderByDirection>;
  estimated_hours?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_active?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  sla_hours?: InputMaybe<OrderByDirection>;
  title_template?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type Ticket_TemplatesUpdateInput = {
  category?: InputMaybe<Ticket_Category>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  description_template?: InputMaybe<Scalars["String"]["input"]>;
  estimated_hours?: InputMaybe<Scalars["BigFloat"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  sla_hours?: InputMaybe<Scalars["Int"]["input"]>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  title_template?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type Ticket_TemplatesUpdateResponse = {
  __typename?: "ticket_templatesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Ticket_Templates>;
};

export type Ticket_Updates = Node & {
  __typename?: "ticket_updates";
  app_users?: Maybe<App_Users>;
  content: Scalars["String"]["output"];
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  id: Scalars["UUID"]["output"];
  is_internal?: Maybe<Scalars["Boolean"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  ticket_id: Scalars["UUID"]["output"];
  tickets?: Maybe<Tickets>;
  update_type: Scalars["String"]["output"];
  user_id: Scalars["UUID"]["output"];
};

export type Ticket_UpdatesConnection = {
  __typename?: "ticket_updatesConnection";
  edges: Array<Ticket_UpdatesEdge>;
  pageInfo: PageInfo;
};

export type Ticket_UpdatesDeleteResponse = {
  __typename?: "ticket_updatesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Ticket_Updates>;
};

export type Ticket_UpdatesEdge = {
  __typename?: "ticket_updatesEdge";
  cursor: Scalars["String"]["output"];
  node: Ticket_Updates;
};

export type Ticket_UpdatesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Ticket_UpdatesFilter>>;
  content?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  is_internal?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Ticket_UpdatesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Ticket_UpdatesFilter>>;
  ticket_id?: InputMaybe<UuidFilter>;
  update_type?: InputMaybe<StringFilter>;
  user_id?: InputMaybe<UuidFilter>;
};

export type Ticket_UpdatesInsertInput = {
  content?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  ticket_id?: InputMaybe<Scalars["UUID"]["input"]>;
  update_type?: InputMaybe<Scalars["String"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Ticket_UpdatesInsertResponse = {
  __typename?: "ticket_updatesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Ticket_Updates>;
};

export type Ticket_UpdatesOrderBy = {
  content?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_internal?: InputMaybe<OrderByDirection>;
  ticket_id?: InputMaybe<OrderByDirection>;
  update_type?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
};

export type Ticket_UpdatesUpdateInput = {
  content?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  ticket_id?: InputMaybe<Scalars["UUID"]["input"]>;
  update_type?: InputMaybe<Scalars["String"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type Ticket_UpdatesUpdateResponse = {
  __typename?: "ticket_updatesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Ticket_Updates>;
};

export type Tickets = Node & {
  __typename?: "tickets";
  actual_hours?: Maybe<Scalars["BigFloat"]["output"]>;
  app_users?: Maybe<App_Users>;
  assigned_to?: Maybe<Scalars["UUID"]["output"]>;
  auto_assign?: Maybe<Scalars["Boolean"]["output"]>;
  auto_escalate?: Maybe<Scalars["Boolean"]["output"]>;
  billable_hours?: Maybe<Scalars["BigFloat"]["output"]>;
  category?: Maybe<Ticket_Category>;
  closed_at?: Maybe<Scalars["Datetime"]["output"]>;
  companies?: Maybe<Companies>;
  company_id: Scalars["UUID"]["output"];
  company_name?: Maybe<Scalars["String"]["output"]>;
  contact_id?: Maybe<Scalars["UUID"]["output"]>;
  contact_name?: Maybe<Scalars["String"]["output"]>;
  contacts?: Maybe<Contacts>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  created_by: Scalars["UUID"]["output"];
  customer_feedbackCollection?: Maybe<Customer_FeedbackConnection>;
  customer_visible_notes?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  description_byte_size?: Maybe<Scalars["Int"]["output"]>;
  description_content_type?: Maybe<Scalars["String"]["output"]>;
  description_preview?: Maybe<Scalars["String"]["output"]>;
  description_s3_key?: Maybe<Scalars["String"]["output"]>;
  discount_amount?: Maybe<Scalars["BigFloat"]["output"]>;
  discount_percentage?: Maybe<Scalars["BigFloat"]["output"]>;
  discount_type?: Maybe<Discount_Type>;
  due_date?: Maybe<Scalars["Datetime"]["output"]>;
  escalation_level?: Maybe<Scalars["Int"]["output"]>;
  estimated_hours?: Maybe<Scalars["BigFloat"]["output"]>;
  has_time_entries?: Maybe<Scalars["Boolean"]["output"]>;
  hourly_rate?: Maybe<Scalars["BigFloat"]["output"]>;
  id: Scalars["UUID"]["output"];
  internal_notes?: Maybe<Scalars["String"]["output"]>;
  is_internal?: Maybe<Scalars["Boolean"]["output"]>;
  is_software?: Maybe<Scalars["Boolean"]["output"]>;
  last_activity_at?: Maybe<Scalars["Datetime"]["output"]>;
  last_escalation_at?: Maybe<Scalars["Datetime"]["output"]>;
  last_follow_up_task_created_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  non_billable_hours?: Maybe<Scalars["BigFloat"]["output"]>;
  priority?: Maybe<Ticket_Priority>;
  reminder_sent?: Maybe<Scalars["Boolean"]["output"]>;
  reminder_sent_at?: Maybe<Scalars["Datetime"]["output"]>;
  resolved_at?: Maybe<Scalars["Datetime"]["output"]>;
  search_vector?: Maybe<Scalars["Opaque"]["output"]>;
  sla_hours?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<Ticket_Status>;
  tags?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  ticket_attachmentsCollection?: Maybe<Ticket_AttachmentsConnection>;
  ticket_number: Scalars["Int"]["output"];
  ticket_updatesCollection?: Maybe<Ticket_UpdatesConnection>;
  time_entriesCollection?: Maybe<Time_EntriesConnection>;
  title: Scalars["String"]["output"];
  total_billed?: Maybe<Scalars["BigFloat"]["output"]>;
  total_cost?: Maybe<Scalars["BigFloat"]["output"]>;
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
};

export type TicketsCustomer_FeedbackCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Customer_FeedbackFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Customer_FeedbackOrderBy>>;
};

export type TicketsTicket_AttachmentsCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Ticket_AttachmentsFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Ticket_AttachmentsOrderBy>>;
};

export type TicketsTicket_UpdatesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Ticket_UpdatesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Ticket_UpdatesOrderBy>>;
};

export type TicketsTime_EntriesCollectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  before?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Time_EntriesFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Array<Time_EntriesOrderBy>>;
};

export type TicketsConnection = {
  __typename?: "ticketsConnection";
  edges: Array<TicketsEdge>;
  pageInfo: PageInfo;
  /** The total number of records matching the `filter` criteria */
  totalCount: Scalars["Int"]["output"];
};

export type TicketsDeleteResponse = {
  __typename?: "ticketsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Tickets>;
};

export type TicketsEdge = {
  __typename?: "ticketsEdge";
  cursor: Scalars["String"]["output"];
  node: Tickets;
};

export type TicketsFilter = {
  actual_hours?: InputMaybe<BigFloatFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<TicketsFilter>>;
  assigned_to?: InputMaybe<UuidFilter>;
  auto_assign?: InputMaybe<BooleanFilter>;
  auto_escalate?: InputMaybe<BooleanFilter>;
  billable_hours?: InputMaybe<BigFloatFilter>;
  category?: InputMaybe<Ticket_CategoryFilter>;
  closed_at?: InputMaybe<DatetimeFilter>;
  company_id?: InputMaybe<UuidFilter>;
  company_name?: InputMaybe<StringFilter>;
  contact_id?: InputMaybe<UuidFilter>;
  contact_name?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  created_by?: InputMaybe<UuidFilter>;
  customer_visible_notes?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  description_byte_size?: InputMaybe<IntFilter>;
  description_content_type?: InputMaybe<StringFilter>;
  description_preview?: InputMaybe<StringFilter>;
  description_s3_key?: InputMaybe<StringFilter>;
  discount_amount?: InputMaybe<BigFloatFilter>;
  discount_percentage?: InputMaybe<BigFloatFilter>;
  discount_type?: InputMaybe<Discount_TypeFilter>;
  due_date?: InputMaybe<DatetimeFilter>;
  escalation_level?: InputMaybe<IntFilter>;
  estimated_hours?: InputMaybe<BigFloatFilter>;
  has_time_entries?: InputMaybe<BooleanFilter>;
  hourly_rate?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<UuidFilter>;
  internal_notes?: InputMaybe<StringFilter>;
  is_internal?: InputMaybe<BooleanFilter>;
  is_software?: InputMaybe<BooleanFilter>;
  last_activity_at?: InputMaybe<DatetimeFilter>;
  last_escalation_at?: InputMaybe<DatetimeFilter>;
  last_follow_up_task_created_at?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  non_billable_hours?: InputMaybe<BigFloatFilter>;
  /** Negates a filter */
  not?: InputMaybe<TicketsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<TicketsFilter>>;
  priority?: InputMaybe<Ticket_PriorityFilter>;
  reminder_sent?: InputMaybe<BooleanFilter>;
  reminder_sent_at?: InputMaybe<DatetimeFilter>;
  resolved_at?: InputMaybe<DatetimeFilter>;
  search_vector?: InputMaybe<OpaqueFilter>;
  sla_hours?: InputMaybe<IntFilter>;
  status?: InputMaybe<Ticket_StatusFilter>;
  tags?: InputMaybe<StringListFilter>;
  ticket_number?: InputMaybe<IntFilter>;
  title?: InputMaybe<StringFilter>;
  total_billed?: InputMaybe<BigFloatFilter>;
  total_cost?: InputMaybe<BigFloatFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type TicketsInsertInput = {
  actual_hours?: InputMaybe<Scalars["BigFloat"]["input"]>;
  assigned_to?: InputMaybe<Scalars["UUID"]["input"]>;
  auto_assign?: InputMaybe<Scalars["Boolean"]["input"]>;
  auto_escalate?: InputMaybe<Scalars["Boolean"]["input"]>;
  billable_hours?: InputMaybe<Scalars["BigFloat"]["input"]>;
  category?: InputMaybe<Ticket_Category>;
  closed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  company_name?: InputMaybe<Scalars["String"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  contact_name?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  customer_visible_notes?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  description_byte_size?: InputMaybe<Scalars["Int"]["input"]>;
  description_content_type?: InputMaybe<Scalars["String"]["input"]>;
  description_preview?: InputMaybe<Scalars["String"]["input"]>;
  description_s3_key?: InputMaybe<Scalars["String"]["input"]>;
  discount_amount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  discount_percentage?: InputMaybe<Scalars["BigFloat"]["input"]>;
  discount_type?: InputMaybe<Discount_Type>;
  due_date?: InputMaybe<Scalars["Datetime"]["input"]>;
  escalation_level?: InputMaybe<Scalars["Int"]["input"]>;
  estimated_hours?: InputMaybe<Scalars["BigFloat"]["input"]>;
  has_time_entries?: InputMaybe<Scalars["Boolean"]["input"]>;
  hourly_rate?: InputMaybe<Scalars["BigFloat"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  internal_notes?: InputMaybe<Scalars["String"]["input"]>;
  is_internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_software?: InputMaybe<Scalars["Boolean"]["input"]>;
  last_activity_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_escalation_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_follow_up_task_created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  non_billable_hours?: InputMaybe<Scalars["BigFloat"]["input"]>;
  priority?: InputMaybe<Ticket_Priority>;
  reminder_sent?: InputMaybe<Scalars["Boolean"]["input"]>;
  reminder_sent_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  resolved_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  sla_hours?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<Ticket_Status>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  ticket_number?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  total_billed?: InputMaybe<Scalars["BigFloat"]["input"]>;
  total_cost?: InputMaybe<Scalars["BigFloat"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type TicketsInsertResponse = {
  __typename?: "ticketsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Tickets>;
};

export type TicketsOrderBy = {
  actual_hours?: InputMaybe<OrderByDirection>;
  assigned_to?: InputMaybe<OrderByDirection>;
  auto_assign?: InputMaybe<OrderByDirection>;
  auto_escalate?: InputMaybe<OrderByDirection>;
  billable_hours?: InputMaybe<OrderByDirection>;
  category?: InputMaybe<OrderByDirection>;
  closed_at?: InputMaybe<OrderByDirection>;
  company_id?: InputMaybe<OrderByDirection>;
  company_name?: InputMaybe<OrderByDirection>;
  contact_id?: InputMaybe<OrderByDirection>;
  contact_name?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  created_by?: InputMaybe<OrderByDirection>;
  customer_visible_notes?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  description_byte_size?: InputMaybe<OrderByDirection>;
  description_content_type?: InputMaybe<OrderByDirection>;
  description_preview?: InputMaybe<OrderByDirection>;
  description_s3_key?: InputMaybe<OrderByDirection>;
  discount_amount?: InputMaybe<OrderByDirection>;
  discount_percentage?: InputMaybe<OrderByDirection>;
  discount_type?: InputMaybe<OrderByDirection>;
  due_date?: InputMaybe<OrderByDirection>;
  escalation_level?: InputMaybe<OrderByDirection>;
  estimated_hours?: InputMaybe<OrderByDirection>;
  has_time_entries?: InputMaybe<OrderByDirection>;
  hourly_rate?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  internal_notes?: InputMaybe<OrderByDirection>;
  is_internal?: InputMaybe<OrderByDirection>;
  is_software?: InputMaybe<OrderByDirection>;
  last_activity_at?: InputMaybe<OrderByDirection>;
  last_escalation_at?: InputMaybe<OrderByDirection>;
  last_follow_up_task_created_at?: InputMaybe<OrderByDirection>;
  non_billable_hours?: InputMaybe<OrderByDirection>;
  priority?: InputMaybe<OrderByDirection>;
  reminder_sent?: InputMaybe<OrderByDirection>;
  reminder_sent_at?: InputMaybe<OrderByDirection>;
  resolved_at?: InputMaybe<OrderByDirection>;
  search_vector?: InputMaybe<OrderByDirection>;
  sla_hours?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  ticket_number?: InputMaybe<OrderByDirection>;
  title?: InputMaybe<OrderByDirection>;
  total_billed?: InputMaybe<OrderByDirection>;
  total_cost?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type TicketsUpdateInput = {
  actual_hours?: InputMaybe<Scalars["BigFloat"]["input"]>;
  assigned_to?: InputMaybe<Scalars["UUID"]["input"]>;
  auto_assign?: InputMaybe<Scalars["Boolean"]["input"]>;
  auto_escalate?: InputMaybe<Scalars["Boolean"]["input"]>;
  billable_hours?: InputMaybe<Scalars["BigFloat"]["input"]>;
  category?: InputMaybe<Ticket_Category>;
  closed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  company_name?: InputMaybe<Scalars["String"]["input"]>;
  contact_id?: InputMaybe<Scalars["UUID"]["input"]>;
  contact_name?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  created_by?: InputMaybe<Scalars["UUID"]["input"]>;
  customer_visible_notes?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  description_byte_size?: InputMaybe<Scalars["Int"]["input"]>;
  description_content_type?: InputMaybe<Scalars["String"]["input"]>;
  description_preview?: InputMaybe<Scalars["String"]["input"]>;
  description_s3_key?: InputMaybe<Scalars["String"]["input"]>;
  discount_amount?: InputMaybe<Scalars["BigFloat"]["input"]>;
  discount_percentage?: InputMaybe<Scalars["BigFloat"]["input"]>;
  discount_type?: InputMaybe<Discount_Type>;
  due_date?: InputMaybe<Scalars["Datetime"]["input"]>;
  escalation_level?: InputMaybe<Scalars["Int"]["input"]>;
  estimated_hours?: InputMaybe<Scalars["BigFloat"]["input"]>;
  has_time_entries?: InputMaybe<Scalars["Boolean"]["input"]>;
  hourly_rate?: InputMaybe<Scalars["BigFloat"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  internal_notes?: InputMaybe<Scalars["String"]["input"]>;
  is_internal?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_software?: InputMaybe<Scalars["Boolean"]["input"]>;
  last_activity_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_escalation_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_follow_up_task_created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  non_billable_hours?: InputMaybe<Scalars["BigFloat"]["input"]>;
  priority?: InputMaybe<Ticket_Priority>;
  reminder_sent?: InputMaybe<Scalars["Boolean"]["input"]>;
  reminder_sent_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  resolved_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  sla_hours?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<Ticket_Status>;
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  ticket_number?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  total_billed?: InputMaybe<Scalars["BigFloat"]["input"]>;
  total_cost?: InputMaybe<Scalars["BigFloat"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type TicketsUpdateResponse = {
  __typename?: "ticketsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Tickets>;
};

export type Time_Entries = Node & {
  __typename?: "time_entries";
  app_users?: Maybe<App_Users>;
  approved_at?: Maybe<Scalars["Datetime"]["output"]>;
  approved_by?: Maybe<Scalars["UUID"]["output"]>;
  billable_rate?: Maybe<Scalars["BigFloat"]["output"]>;
  companies?: Maybe<Companies>;
  company_id?: Maybe<Scalars["UUID"]["output"]>;
  company_name?: Maybe<Scalars["String"]["output"]>;
  contact_name?: Maybe<Scalars["String"]["output"]>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  date_worked: Scalars["Date"]["output"];
  description: Scalars["String"]["output"];
  end_time?: Maybe<Scalars["Time"]["output"]>;
  entry_type?: Maybe<Time_Entry_Type>;
  hours: Scalars["BigFloat"]["output"];
  id: Scalars["UUID"]["output"];
  is_approved?: Maybe<Scalars["Boolean"]["output"]>;
  is_software?: Maybe<Scalars["Boolean"]["output"]>;
  last_follow_up_task_created_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  quickbooks_customer_ref?: Maybe<Scalars["String"]["output"]>;
  quickbooks_employee_ref?: Maybe<Scalars["String"]["output"]>;
  quickbooks_id?: Maybe<Scalars["String"]["output"]>;
  search_vector?: Maybe<Scalars["Opaque"]["output"]>;
  start_time?: Maybe<Scalars["Time"]["output"]>;
  sync_status?: Maybe<Sync_Status>;
  synced_at?: Maybe<Scalars["Datetime"]["output"]>;
  ticket_id?: Maybe<Scalars["UUID"]["output"]>;
  ticket_number?: Maybe<Scalars["Int"]["output"]>;
  ticket_title?: Maybe<Scalars["String"]["output"]>;
  tickets?: Maybe<Tickets>;
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  user_id: Scalars["UUID"]["output"];
  user_name?: Maybe<Scalars["String"]["output"]>;
};

/** Aggregate results for `time_entries` */
export type Time_EntriesAggregate = {
  __typename?: "time_entriesAggregate";
  /** Average aggregates for numeric fields */
  avg?: Maybe<Time_EntriesAvgAggregateResult>;
  /** The number of records matching the query */
  count: Scalars["Int"]["output"];
  /** Maximum aggregates for comparable fields */
  max?: Maybe<Time_EntriesMaxAggregateResult>;
  /** Minimum aggregates for comparable fields */
  min?: Maybe<Time_EntriesMinAggregateResult>;
  /** Summation aggregates for numeric fields */
  sum?: Maybe<Time_EntriesSumAggregateResult>;
};

/** Result of average aggregation for `time_entries` */
export type Time_EntriesAvgAggregateResult = {
  __typename?: "time_entriesAvgAggregateResult";
  /** Average of billable_rate across all matching records */
  billable_rate?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Average of hours across all matching records */
  hours?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Average of ticket_number across all matching records */
  ticket_number?: Maybe<Scalars["BigFloat"]["output"]>;
};

export type Time_EntriesConnection = {
  __typename?: "time_entriesConnection";
  /** Aggregate functions calculated on the collection of `time_entries` */
  aggregate?: Maybe<Time_EntriesAggregate>;
  edges: Array<Time_EntriesEdge>;
  pageInfo: PageInfo;
  /** The total number of records matching the `filter` criteria */
  totalCount: Scalars["Int"]["output"];
};

export type Time_EntriesDeleteResponse = {
  __typename?: "time_entriesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Time_Entries>;
};

export type Time_EntriesEdge = {
  __typename?: "time_entriesEdge";
  cursor: Scalars["String"]["output"];
  node: Time_Entries;
};

export type Time_EntriesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<Time_EntriesFilter>>;
  approved_at?: InputMaybe<DatetimeFilter>;
  approved_by?: InputMaybe<UuidFilter>;
  billable_rate?: InputMaybe<BigFloatFilter>;
  company_id?: InputMaybe<UuidFilter>;
  company_name?: InputMaybe<StringFilter>;
  contact_name?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  date_worked?: InputMaybe<DateFilter>;
  description?: InputMaybe<StringFilter>;
  end_time?: InputMaybe<TimeFilter>;
  entry_type?: InputMaybe<Time_Entry_TypeFilter>;
  hours?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<UuidFilter>;
  is_approved?: InputMaybe<BooleanFilter>;
  is_software?: InputMaybe<BooleanFilter>;
  last_follow_up_task_created_at?: InputMaybe<DatetimeFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<Time_EntriesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<Time_EntriesFilter>>;
  quickbooks_customer_ref?: InputMaybe<StringFilter>;
  quickbooks_employee_ref?: InputMaybe<StringFilter>;
  quickbooks_id?: InputMaybe<StringFilter>;
  search_vector?: InputMaybe<OpaqueFilter>;
  start_time?: InputMaybe<TimeFilter>;
  sync_status?: InputMaybe<Sync_StatusFilter>;
  synced_at?: InputMaybe<DatetimeFilter>;
  ticket_id?: InputMaybe<UuidFilter>;
  ticket_number?: InputMaybe<IntFilter>;
  ticket_title?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
  user_id?: InputMaybe<UuidFilter>;
  user_name?: InputMaybe<StringFilter>;
};

export type Time_EntriesInsertInput = {
  approved_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  approved_by?: InputMaybe<Scalars["UUID"]["input"]>;
  billable_rate?: InputMaybe<Scalars["BigFloat"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  company_name?: InputMaybe<Scalars["String"]["input"]>;
  contact_name?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  date_worked?: InputMaybe<Scalars["Date"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  end_time?: InputMaybe<Scalars["Time"]["input"]>;
  entry_type?: InputMaybe<Time_Entry_Type>;
  hours?: InputMaybe<Scalars["BigFloat"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_approved?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_software?: InputMaybe<Scalars["Boolean"]["input"]>;
  last_follow_up_task_created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  quickbooks_customer_ref?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_employee_ref?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_id?: InputMaybe<Scalars["String"]["input"]>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  start_time?: InputMaybe<Scalars["Time"]["input"]>;
  sync_status?: InputMaybe<Sync_Status>;
  synced_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  ticket_id?: InputMaybe<Scalars["UUID"]["input"]>;
  ticket_number?: InputMaybe<Scalars["Int"]["input"]>;
  ticket_title?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
  user_name?: InputMaybe<Scalars["String"]["input"]>;
};

export type Time_EntriesInsertResponse = {
  __typename?: "time_entriesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Time_Entries>;
};

/** Result of maximum aggregation for `time_entries` */
export type Time_EntriesMaxAggregateResult = {
  __typename?: "time_entriesMaxAggregateResult";
  /** Maximum of approved_at across all matching records */
  approved_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Maximum of billable_rate across all matching records */
  billable_rate?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Maximum of company_name across all matching records */
  company_name?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of contact_name across all matching records */
  contact_name?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of created_at across all matching records */
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Maximum of date_worked across all matching records */
  date_worked?: Maybe<Scalars["Date"]["output"]>;
  /** Maximum of description across all matching records */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of end_time across all matching records */
  end_time?: Maybe<Scalars["Time"]["output"]>;
  /** Maximum of hours across all matching records */
  hours?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Maximum of is_approved across all matching records */
  is_approved?: Maybe<Scalars["Boolean"]["output"]>;
  /** Maximum of is_software across all matching records */
  is_software?: Maybe<Scalars["Boolean"]["output"]>;
  /** Maximum of last_follow_up_task_created_at across all matching records */
  last_follow_up_task_created_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Maximum of quickbooks_customer_ref across all matching records */
  quickbooks_customer_ref?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of quickbooks_employee_ref across all matching records */
  quickbooks_employee_ref?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of quickbooks_id across all matching records */
  quickbooks_id?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of start_time across all matching records */
  start_time?: Maybe<Scalars["Time"]["output"]>;
  /** Maximum of synced_at across all matching records */
  synced_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Maximum of ticket_number across all matching records */
  ticket_number?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum of ticket_title across all matching records */
  ticket_title?: Maybe<Scalars["String"]["output"]>;
  /** Maximum of updated_at across all matching records */
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Maximum of user_name across all matching records */
  user_name?: Maybe<Scalars["String"]["output"]>;
};

/** Result of minimum aggregation for `time_entries` */
export type Time_EntriesMinAggregateResult = {
  __typename?: "time_entriesMinAggregateResult";
  /** Minimum of approved_at across all matching records */
  approved_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Minimum of billable_rate across all matching records */
  billable_rate?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Minimum of company_name across all matching records */
  company_name?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of contact_name across all matching records */
  contact_name?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of created_at across all matching records */
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Minimum of date_worked across all matching records */
  date_worked?: Maybe<Scalars["Date"]["output"]>;
  /** Minimum of description across all matching records */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of end_time across all matching records */
  end_time?: Maybe<Scalars["Time"]["output"]>;
  /** Minimum of hours across all matching records */
  hours?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Minimum of is_approved across all matching records */
  is_approved?: Maybe<Scalars["Boolean"]["output"]>;
  /** Minimum of is_software across all matching records */
  is_software?: Maybe<Scalars["Boolean"]["output"]>;
  /** Minimum of last_follow_up_task_created_at across all matching records */
  last_follow_up_task_created_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Minimum of quickbooks_customer_ref across all matching records */
  quickbooks_customer_ref?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of quickbooks_employee_ref across all matching records */
  quickbooks_employee_ref?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of quickbooks_id across all matching records */
  quickbooks_id?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of start_time across all matching records */
  start_time?: Maybe<Scalars["Time"]["output"]>;
  /** Minimum of synced_at across all matching records */
  synced_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Minimum of ticket_number across all matching records */
  ticket_number?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum of ticket_title across all matching records */
  ticket_title?: Maybe<Scalars["String"]["output"]>;
  /** Minimum of updated_at across all matching records */
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  /** Minimum of user_name across all matching records */
  user_name?: Maybe<Scalars["String"]["output"]>;
};

export type Time_EntriesOrderBy = {
  approved_at?: InputMaybe<OrderByDirection>;
  approved_by?: InputMaybe<OrderByDirection>;
  billable_rate?: InputMaybe<OrderByDirection>;
  company_id?: InputMaybe<OrderByDirection>;
  company_name?: InputMaybe<OrderByDirection>;
  contact_name?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  date_worked?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  end_time?: InputMaybe<OrderByDirection>;
  entry_type?: InputMaybe<OrderByDirection>;
  hours?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  is_approved?: InputMaybe<OrderByDirection>;
  is_software?: InputMaybe<OrderByDirection>;
  last_follow_up_task_created_at?: InputMaybe<OrderByDirection>;
  quickbooks_customer_ref?: InputMaybe<OrderByDirection>;
  quickbooks_employee_ref?: InputMaybe<OrderByDirection>;
  quickbooks_id?: InputMaybe<OrderByDirection>;
  search_vector?: InputMaybe<OrderByDirection>;
  start_time?: InputMaybe<OrderByDirection>;
  sync_status?: InputMaybe<OrderByDirection>;
  synced_at?: InputMaybe<OrderByDirection>;
  ticket_id?: InputMaybe<OrderByDirection>;
  ticket_number?: InputMaybe<OrderByDirection>;
  ticket_title?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
  user_id?: InputMaybe<OrderByDirection>;
  user_name?: InputMaybe<OrderByDirection>;
};

/** Result of summation aggregation for `time_entries` */
export type Time_EntriesSumAggregateResult = {
  __typename?: "time_entriesSumAggregateResult";
  /** Sum of billable_rate across all matching records */
  billable_rate?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sum of hours across all matching records */
  hours?: Maybe<Scalars["BigFloat"]["output"]>;
  /** Sum of ticket_number across all matching records */
  ticket_number?: Maybe<Scalars["BigInt"]["output"]>;
};

export type Time_EntriesUpdateInput = {
  approved_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  approved_by?: InputMaybe<Scalars["UUID"]["input"]>;
  billable_rate?: InputMaybe<Scalars["BigFloat"]["input"]>;
  company_id?: InputMaybe<Scalars["UUID"]["input"]>;
  company_name?: InputMaybe<Scalars["String"]["input"]>;
  contact_name?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  date_worked?: InputMaybe<Scalars["Date"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  end_time?: InputMaybe<Scalars["Time"]["input"]>;
  entry_type?: InputMaybe<Time_Entry_Type>;
  hours?: InputMaybe<Scalars["BigFloat"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  is_approved?: InputMaybe<Scalars["Boolean"]["input"]>;
  is_software?: InputMaybe<Scalars["Boolean"]["input"]>;
  last_follow_up_task_created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  quickbooks_customer_ref?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_employee_ref?: InputMaybe<Scalars["String"]["input"]>;
  quickbooks_id?: InputMaybe<Scalars["String"]["input"]>;
  search_vector?: InputMaybe<Scalars["Opaque"]["input"]>;
  start_time?: InputMaybe<Scalars["Time"]["input"]>;
  sync_status?: InputMaybe<Sync_Status>;
  synced_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  ticket_id?: InputMaybe<Scalars["UUID"]["input"]>;
  ticket_number?: InputMaybe<Scalars["Int"]["input"]>;
  ticket_title?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  user_id?: InputMaybe<Scalars["UUID"]["input"]>;
  user_name?: InputMaybe<Scalars["String"]["input"]>;
};

export type Time_EntriesUpdateResponse = {
  __typename?: "time_entriesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<Time_Entries>;
};

export type Time_Entry_Type = "billable" | "non_billable" | "research" | "travel";

/** Boolean expression comparing fields on type "time_entry_type" */
export type Time_Entry_TypeFilter = {
  eq?: InputMaybe<Time_Entry_Type>;
  in?: InputMaybe<Array<Time_Entry_Type>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Time_Entry_Type>;
};

export type User_Oauth_Connections = Node & {
  __typename?: "user_oauth_connections";
  access_token_enc?: Maybe<Scalars["String"]["output"]>;
  access_token_expires_at?: Maybe<Scalars["Datetime"]["output"]>;
  auth_user_id?: Maybe<Scalars["UUID"]["output"]>;
  connection_id: Scalars["String"]["output"];
  created_at: Scalars["Datetime"]["output"];
  end_user_display_name?: Maybe<Scalars["String"]["output"]>;
  end_user_email: Scalars["String"]["output"];
  last_refresh_failure_at?: Maybe<Scalars["Datetime"]["output"]>;
  last_refreshed_at?: Maybe<Scalars["Datetime"]["output"]>;
  never_expires: Scalars["Boolean"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  previous_refresh_token_enc?: Maybe<Scalars["String"]["output"]>;
  provider_config_key: Scalars["String"]["output"];
  refresh_attempts: Scalars["Int"]["output"];
  refresh_exhausted: Scalars["Boolean"]["output"];
  refresh_token_enc?: Maybe<Scalars["String"]["output"]>;
  scopes: Array<Maybe<Scalars["String"]["output"]>>;
  status: Scalars["String"]["output"];
  updated_at: Scalars["Datetime"]["output"];
};

export type User_Oauth_ConnectionsConnection = {
  __typename?: "user_oauth_connectionsConnection";
  edges: Array<User_Oauth_ConnectionsEdge>;
  pageInfo: PageInfo;
};

export type User_Oauth_ConnectionsDeleteResponse = {
  __typename?: "user_oauth_connectionsDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<User_Oauth_Connections>;
};

export type User_Oauth_ConnectionsEdge = {
  __typename?: "user_oauth_connectionsEdge";
  cursor: Scalars["String"]["output"];
  node: User_Oauth_Connections;
};

export type User_Oauth_ConnectionsFilter = {
  access_token_enc?: InputMaybe<StringFilter>;
  access_token_expires_at?: InputMaybe<DatetimeFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<User_Oauth_ConnectionsFilter>>;
  auth_user_id?: InputMaybe<UuidFilter>;
  connection_id?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DatetimeFilter>;
  end_user_display_name?: InputMaybe<StringFilter>;
  end_user_email?: InputMaybe<StringFilter>;
  last_refresh_failure_at?: InputMaybe<DatetimeFilter>;
  last_refreshed_at?: InputMaybe<DatetimeFilter>;
  never_expires?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<User_Oauth_ConnectionsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<User_Oauth_ConnectionsFilter>>;
  previous_refresh_token_enc?: InputMaybe<StringFilter>;
  provider_config_key?: InputMaybe<StringFilter>;
  refresh_attempts?: InputMaybe<IntFilter>;
  refresh_exhausted?: InputMaybe<BooleanFilter>;
  refresh_token_enc?: InputMaybe<StringFilter>;
  scopes?: InputMaybe<StringListFilter>;
  status?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type User_Oauth_ConnectionsInsertInput = {
  access_token_enc?: InputMaybe<Scalars["String"]["input"]>;
  access_token_expires_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  auth_user_id?: InputMaybe<Scalars["UUID"]["input"]>;
  connection_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  end_user_display_name?: InputMaybe<Scalars["String"]["input"]>;
  end_user_email?: InputMaybe<Scalars["String"]["input"]>;
  last_refresh_failure_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_refreshed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  never_expires?: InputMaybe<Scalars["Boolean"]["input"]>;
  previous_refresh_token_enc?: InputMaybe<Scalars["String"]["input"]>;
  provider_config_key?: InputMaybe<Scalars["String"]["input"]>;
  refresh_attempts?: InputMaybe<Scalars["Int"]["input"]>;
  refresh_exhausted?: InputMaybe<Scalars["Boolean"]["input"]>;
  refresh_token_enc?: InputMaybe<Scalars["String"]["input"]>;
  scopes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type User_Oauth_ConnectionsInsertResponse = {
  __typename?: "user_oauth_connectionsInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<User_Oauth_Connections>;
};

export type User_Oauth_ConnectionsOrderBy = {
  access_token_enc?: InputMaybe<OrderByDirection>;
  access_token_expires_at?: InputMaybe<OrderByDirection>;
  auth_user_id?: InputMaybe<OrderByDirection>;
  connection_id?: InputMaybe<OrderByDirection>;
  created_at?: InputMaybe<OrderByDirection>;
  end_user_display_name?: InputMaybe<OrderByDirection>;
  end_user_email?: InputMaybe<OrderByDirection>;
  last_refresh_failure_at?: InputMaybe<OrderByDirection>;
  last_refreshed_at?: InputMaybe<OrderByDirection>;
  never_expires?: InputMaybe<OrderByDirection>;
  previous_refresh_token_enc?: InputMaybe<OrderByDirection>;
  provider_config_key?: InputMaybe<OrderByDirection>;
  refresh_attempts?: InputMaybe<OrderByDirection>;
  refresh_exhausted?: InputMaybe<OrderByDirection>;
  refresh_token_enc?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type User_Oauth_ConnectionsUpdateInput = {
  access_token_enc?: InputMaybe<Scalars["String"]["input"]>;
  access_token_expires_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  auth_user_id?: InputMaybe<Scalars["UUID"]["input"]>;
  connection_id?: InputMaybe<Scalars["String"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  end_user_display_name?: InputMaybe<Scalars["String"]["input"]>;
  end_user_email?: InputMaybe<Scalars["String"]["input"]>;
  last_refresh_failure_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  last_refreshed_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  never_expires?: InputMaybe<Scalars["Boolean"]["input"]>;
  previous_refresh_token_enc?: InputMaybe<Scalars["String"]["input"]>;
  provider_config_key?: InputMaybe<Scalars["String"]["input"]>;
  refresh_attempts?: InputMaybe<Scalars["Int"]["input"]>;
  refresh_exhausted?: InputMaybe<Scalars["Boolean"]["input"]>;
  refresh_token_enc?: InputMaybe<Scalars["String"]["input"]>;
  scopes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
};

export type User_Oauth_ConnectionsUpdateResponse = {
  __typename?: "user_oauth_connectionsUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<User_Oauth_Connections>;
};

export type User_Preferences = Node & {
  __typename?: "user_preferences";
  calendar_settings?: Maybe<Scalars["JSON"]["output"]>;
  created_at?: Maybe<Scalars["Datetime"]["output"]>;
  default_meeting_duration?: Maybe<Scalars["Int"]["output"]>;
  email: Scalars["String"]["output"];
  id: Scalars["UUID"]["output"];
  /** Globally Unique Record Identifier */
  nodeId: Scalars["ID"]["output"];
  timezone?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Datetime"]["output"]>;
  working_hours?: Maybe<Scalars["JSON"]["output"]>;
};

export type User_PreferencesConnection = {
  __typename?: "user_preferencesConnection";
  edges: Array<User_PreferencesEdge>;
  pageInfo: PageInfo;
};

export type User_PreferencesDeleteResponse = {
  __typename?: "user_preferencesDeleteResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<User_Preferences>;
};

export type User_PreferencesEdge = {
  __typename?: "user_preferencesEdge";
  cursor: Scalars["String"]["output"];
  node: User_Preferences;
};

export type User_PreferencesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<User_PreferencesFilter>>;
  created_at?: InputMaybe<DatetimeFilter>;
  default_meeting_duration?: InputMaybe<IntFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<User_PreferencesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<User_PreferencesFilter>>;
  timezone?: InputMaybe<StringFilter>;
  updated_at?: InputMaybe<DatetimeFilter>;
};

export type User_PreferencesInsertInput = {
  calendar_settings?: InputMaybe<Scalars["JSON"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  default_meeting_duration?: InputMaybe<Scalars["Int"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  timezone?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  working_hours?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type User_PreferencesInsertResponse = {
  __typename?: "user_preferencesInsertResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<User_Preferences>;
};

export type User_PreferencesOrderBy = {
  created_at?: InputMaybe<OrderByDirection>;
  default_meeting_duration?: InputMaybe<OrderByDirection>;
  email?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  timezone?: InputMaybe<OrderByDirection>;
  updated_at?: InputMaybe<OrderByDirection>;
};

export type User_PreferencesUpdateInput = {
  calendar_settings?: InputMaybe<Scalars["JSON"]["input"]>;
  created_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  default_meeting_duration?: InputMaybe<Scalars["Int"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["UUID"]["input"]>;
  timezone?: InputMaybe<Scalars["String"]["input"]>;
  updated_at?: InputMaybe<Scalars["Datetime"]["input"]>;
  working_hours?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type User_PreferencesUpdateResponse = {
  __typename?: "user_preferencesUpdateResponse";
  /** Count of the records impacted by the mutation */
  affectedCount: Scalars["Int"]["output"];
  /** Array of records impacted by the mutation */
  records: Array<User_Preferences>;
};

export type GetCommunicationssQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<CommunicationsFilter>;
}>;

export type GetCommunicationssQuery = {
  __typename?: "Query";
  communicationsCollection: {
    __typename?: "communicationsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "communicationsEdge";
      node: {
        __typename?: "communications";
        id: string;
        contact_id: string;
        company_id?: string | null;
        company_name?: string | null;
        contact_name?: string | null;
        user_id: string;
        type_id?: string | null;
        type_label?: string | null;
        title?: string | null;
        body_preview?: string | null;
        body_s3_key?: string | null;
        direction?: string | null;
        status?: string | null;
        external_id?: string | null;
        occurred_at?: string | null;
        created_at?: string | null;
        updated_at?: string | null;
        metadata?: Record<string, any> | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetCommunicationsQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetCommunicationsQuery = {
  __typename?: "Query";
  communicationsCollection: {
    __typename?: "communicationsConnection";
    edges: Array<{
      __typename?: "communicationsEdge";
      node: {
        __typename?: "communications";
        id: string;
        contact_id: string;
        company_id?: string | null;
        company_name?: string | null;
        contact_name?: string | null;
        user_id: string;
        type_id?: string | null;
        type_label?: string | null;
        title?: string | null;
        body?: string | null;
        body_preview?: string | null;
        body_s3_key?: string | null;
        direction?: string | null;
        status?: string | null;
        external_id?: string | null;
        occurred_at?: string | null;
        created_at?: string | null;
        updated_at?: string | null;
        metadata?: Record<string, any> | null;
      };
    }>;
  };
};

export type CreateCommunicationsMutationVariables = Exact<{
  input: CommunicationsInsertInput;
}>;

export type CreateCommunicationsMutation = {
  __typename?: "Mutation";
  insertIntocommunicationsCollection?: {
    __typename?: "communicationsInsertResponse";
    records: Array<{
      __typename?: "communications";
      id: string;
      contact_id: string;
      company_id?: string | null;
      user_id: string;
      type_id?: string | null;
      title?: string | null;
      body?: string | null;
      direction?: string | null;
      status?: string | null;
      external_id?: string | null;
      occurred_at?: string | null;
      created_at?: string | null;
      updated_at?: string | null;
      metadata?: Record<string, any> | null;
    }>;
  } | null;
};

export type UpdateCommunicationsMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  input: CommunicationsUpdateInput;
}>;

export type UpdateCommunicationsMutation = {
  __typename?: "Mutation";
  updatecommunicationsCollection: {
    __typename?: "communicationsUpdateResponse";
    records: Array<{
      __typename?: "communications";
      id: string;
      contact_id: string;
      company_id?: string | null;
      user_id: string;
      type_id?: string | null;
      title?: string | null;
      body?: string | null;
      direction?: string | null;
      status?: string | null;
      external_id?: string | null;
      occurred_at?: string | null;
      created_at?: string | null;
      updated_at?: string | null;
      metadata?: Record<string, any> | null;
    }>;
  };
};

export type DeleteCommunicationsMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeleteCommunicationsMutation = {
  __typename?: "Mutation";
  deleteFromcommunicationsCollection: {
    __typename?: "communicationsDeleteResponse";
    records: Array<{ __typename?: "communications"; id: string }>;
  };
};

export type GetRecentCommunicationsForFollowUpQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  since?: InputMaybe<Scalars["Datetime"]["input"]>;
}>;

export type GetRecentCommunicationsForFollowUpQuery = {
  __typename?: "Query";
  communicationsCollection: {
    __typename?: "communicationsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "communicationsEdge";
      node: {
        __typename?: "communications";
        id: string;
        contact_id: string;
        company_id?: string | null;
        company_name?: string | null;
        contact_name?: string | null;
        type_id?: string | null;
        type_label?: string | null;
        title?: string | null;
        body_preview?: string | null;
        occurred_at?: string | null;
        created_at?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetCommunicationTypesQueryVariables = Exact<{ [key: string]: never }>;

export type GetCommunicationTypesQuery = {
  __typename?: "Query";
  communication_typesCollection: {
    __typename?: "communication_typesConnection";
    edges: Array<{
      __typename?: "communication_typesEdge";
      node: {
        __typename?: "communication_types";
        id: string;
        key: string;
        label: string;
        description?: string | null;
        is_active?: boolean | null;
      };
    }>;
  };
};

export type GetCompaniessQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<CompaniesFilter>;
}>;

export type GetCompaniessQuery = {
  __typename?: "Query";
  companiesCollection: {
    __typename?: "companiesConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "companiesEdge";
      node: {
        __typename?: "companies";
        id: string;
        name: string;
        normalized_name?: string | null;
        name_aliases: Array<Maybe<Scalars["String"]["output"]>>;
        contract_type?: string | null;
        hourly_rate?: number | null;
        monthly_rate?: number | null;
        payment_terms?: string | null;
        tax_id?: string | null;
        description?: string | null;
        notes?: string | null;
        quickbooks_customer_ref?: string | null;
        quickbooks_customer_name?: string | null;
        quickbooks_sync_at?: string | null;
        website?: string | null;
        uptime_monitoring_enabled: boolean;
        domain?: string | null;
        industry?: string | null;
        address?: string | null;
        city?: string | null;
        state?: string | null;
        zip_code?: string | null;
        country?: string | null;
        status?: string | null;
        created_at?: string | null;
        updated_at?: string | null;
        created_by?: string | null;
        current_technologies?: Record<string, any> | null;
        social_links?: Record<string, any> | null;
        employee_size?: Record<string, any> | null;
        technical_identifiers: Record<string, any>;
        schedule_status?: Project_Health_Status | null;
        budget_status?: Project_Health_Status | null;
        scope_status?: Project_Health_Status | null;
        alignment_status?: Project_Health_Status | null;
        last_follow_up_task_created_at?: string | null;
        last_contacted_at?: string | null;
        has_active_deals: boolean;
        active_deal_count: number;
        total_deal_value: number;
        has_signed_contract: boolean;
        contract_expires_at?: string | null;
        has_open_tickets: boolean;
        open_ticket_count: number;
        active_contact_count: number;
        organization_revenue?: number | null;
        organization_phone?: string | null;
        organization_email?: string | null;
        phone_aliases: Array<string | null>;
        email_aliases: Array<string | null>;
        line_contact_id?: string | null;
        last_enriched_at?: string | null;
        slack_channel_id?: string | null;
        google_drive_folder_id?: string | null;
        tags: Array<string | null>;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetCompanyQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetCompanyQuery = {
  __typename?: "Query";
  companiesCollection: {
    __typename?: "companiesConnection";
    edges: Array<{
      __typename?: "companiesEdge";
      node: {
        __typename?: "companies";
        id: string;
        name: string;
        normalized_name?: string | null;
        name_aliases: Array<Maybe<Scalars["String"]["output"]>>;
        contract_type?: string | null;
        hourly_rate?: number | null;
        monthly_rate?: number | null;
        payment_terms?: string | null;
        tax_id?: string | null;
        description?: string | null;
        notes?: string | null;
        quickbooks_customer_ref?: string | null;
        quickbooks_customer_name?: string | null;
        quickbooks_sync_at?: string | null;
        website?: string | null;
        uptime_monitoring_enabled: boolean;
        domain?: string | null;
        industry?: string | null;
        address?: string | null;
        city?: string | null;
        state?: string | null;
        zip_code?: string | null;
        country?: string | null;
        status?: string | null;
        created_at?: string | null;
        updated_at?: string | null;
        created_by?: string | null;
        current_technologies?: Record<string, any> | null;
        social_links?: Record<string, any> | null;
        employee_size?: Record<string, any> | null;
        technical_identifiers: Record<string, any>;
        schedule_status?: Project_Health_Status | null;
        budget_status?: Project_Health_Status | null;
        scope_status?: Project_Health_Status | null;
        alignment_status?: Project_Health_Status | null;
        last_follow_up_task_created_at?: string | null;
        last_contacted_at?: string | null;
        has_active_deals: boolean;
        active_deal_count: number;
        total_deal_value: number;
        has_signed_contract: boolean;
        contract_expires_at?: string | null;
        has_open_tickets: boolean;
        open_ticket_count: number;
        active_contact_count: number;
        organization_revenue?: number | null;
        organization_phone?: string | null;
        organization_email?: string | null;
        phone_aliases: Array<string | null>;
        email_aliases: Array<string | null>;
        line_contact_id?: string | null;
        last_enriched_at?: string | null;
        slack_channel_id?: string | null;
        google_drive_folder_id?: string | null;
        tags: Array<string | null>;
      };
    }>;
  };
};

export type CreateCompanyMutationVariables = Exact<{
  input: CompaniesInsertInput;
}>;

export type CreateCompanyMutation = {
  __typename?: "Mutation";
  insertIntocompaniesCollection?: {
    __typename?: "companiesInsertResponse";
    records: Array<{
      __typename?: "companies";
      id: string;
      name: string;
      normalized_name?: string | null;
      name_aliases: Array<Maybe<Scalars["String"]["output"]>>;
      tags: Array<string | null>;
      created_at?: string | null;
      updated_at?: string | null;
    }>;
  } | null;
};

export type UpdateCompanyMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  input: CompaniesUpdateInput;
}>;

export type UpdateCompanyMutation = {
  __typename?: "Mutation";
  updatecompaniesCollection: {
    __typename?: "companiesUpdateResponse";
    records: Array<{
      __typename?: "companies";
      id: string;
      name: string;
      normalized_name?: string | null;
      name_aliases: Array<Maybe<Scalars["String"]["output"]>>;
      contract_type?: string | null;
      hourly_rate?: number | null;
      monthly_rate?: number | null;
      payment_terms?: string | null;
      tax_id?: string | null;
      description?: string | null;
      notes?: string | null;
      quickbooks_customer_ref?: string | null;
      quickbooks_customer_name?: string | null;
      quickbooks_sync_at?: string | null;
      website?: string | null;
      uptime_monitoring_enabled: boolean;
      domain?: string | null;
      industry?: string | null;
      address?: string | null;
      city?: string | null;
      state?: string | null;
      zip_code?: string | null;
      country?: string | null;
      status?: string | null;
      created_at?: string | null;
      updated_at?: string | null;
      current_technologies?: Record<string, any> | null;
      social_links?: Record<string, any> | null;
      employee_size?: Record<string, any> | null;
      technical_identifiers: Record<string, any>;
      schedule_status?: Project_Health_Status | null;
      budget_status?: Project_Health_Status | null;
      scope_status?: Project_Health_Status | null;
      alignment_status?: Project_Health_Status | null;
      last_follow_up_task_created_at?: string | null;
      last_contacted_at?: string | null;
      has_active_deals: boolean;
      active_deal_count: number;
      total_deal_value: number;
      has_signed_contract: boolean;
      contract_expires_at?: string | null;
      has_open_tickets: boolean;
      open_ticket_count: number;
      active_contact_count: number;
      organization_revenue?: number | null;
      organization_phone?: string | null;
      organization_email?: string | null;
      phone_aliases: Array<string | null>;
      email_aliases: Array<string | null>;
      line_contact_id?: string | null;
      last_enriched_at?: string | null;
      slack_channel_id?: string | null;
      google_drive_folder_id?: string | null;
      tags: Array<string | null>;
    }>;
  };
};

export type GetCompanyTechnicalIdentifiersQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetCompanyTechnicalIdentifiersQuery = {
  __typename?: "Query";
  companiesCollection: {
    __typename?: "companiesConnection";
    edges: Array<{
      __typename?: "companiesEdge";
      node: {
        __typename?: "companies";
        id: string;
        name: string;
        technical_identifiers: Record<string, any>;
      };
    }>;
  };
};

export type DeleteCompanyMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeleteCompanyMutation = {
  __typename?: "Mutation";
  deleteFromcompaniesCollection: {
    __typename?: "companiesDeleteResponse";
    records: Array<{ __typename?: "companies"; id: string }>;
  };
};

export type GetCompaniesWithNoTicketsThisMonthQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
}>;

export type GetCompaniesWithNoTicketsThisMonthQuery = {
  __typename?: "Query";
  companiesCollection: {
    __typename?: "companiesConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "companiesEdge";
      node: {
        __typename?: "companies";
        id: string;
        name: string;
        normalized_name?: string | null;
        name_aliases: Array<Maybe<Scalars["String"]["output"]>>;
        status?: string | null;
        created_at?: string | null;
        updated_at?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
  ticketsCollection: {
    __typename?: "ticketsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "ticketsEdge";
      node: { __typename?: "tickets"; id: string; company_id: string; created_at?: string | null };
    }>;
  };
};

export type GetContactssQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<ContactsFilter>;
}>;

export type GetContactssQuery = {
  __typename?: "Query";
  contactsCollection: {
    __typename?: "contactsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "contactsEdge";
      node: {
        __typename?: "contacts";
        id: string;
        name: string;
        company_name?: string | null;
        company_id?: string | null;
        email: string;
        email_aliases?: Array<string | null> | null;
        phone?: string | null;
        phone_aliases?: Array<string | null> | null;
        address?: string | null;
        city?: string | null;
        state?: string | null;
        zip_code?: string | null;
        country?: string | null;
        title?: string | null;
        status?: Contact_Status | null;
        tags?: Array<string | null> | null;
        lifecycle_stage?: string | null;
        source?: string | null;
        last_contacted_at?: string | null;
        avatar_url?: string | null;
        social_links?: Record<string, any> | null;
        custom_fields?: Record<string, any> | null;
        is_active?: boolean | null;
        is_company_line: boolean;
        created_at?: string | null;
        updated_at?: string | null;
        created_by?: string | null;
        updated_by?: string | null;
        notes?: string | null;
        last_follow_up_task_created_at?: string | null;
        has_active_deals: boolean;
        active_deal_count: number;
        has_signed_contract: boolean;
        contract_expires_at?: string | null;
        companies?: {
          __typename?: "companies";
          id: string;
          name: string;
          industry?: string | null;
        } | null;
        app_users?: {
          __typename?: "app_users";
          id: string;
          email: string;
          first_name?: string | null;
          last_name?: string | null;
        } | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetContactsQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetContactsQuery = {
  __typename?: "Query";
  contactsCollection: {
    __typename?: "contactsConnection";
    edges: Array<{
      __typename?: "contactsEdge";
      node: {
        __typename?: "contacts";
        id: string;
        name: string;
        company_name?: string | null;
        company_id?: string | null;
        email: string;
        email_aliases?: Array<string | null> | null;
        phone?: string | null;
        phone_aliases?: Array<string | null> | null;
        address?: string | null;
        city?: string | null;
        state?: string | null;
        zip_code?: string | null;
        country?: string | null;
        title?: string | null;
        status?: Contact_Status | null;
        tags?: Array<string | null> | null;
        lifecycle_stage?: string | null;
        source?: string | null;
        last_contacted_at?: string | null;
        avatar_url?: string | null;
        social_links?: Record<string, any> | null;
        custom_fields?: Record<string, any> | null;
        is_active?: boolean | null;
        is_company_line: boolean;
        created_at?: string | null;
        updated_at?: string | null;
        created_by?: string | null;
        updated_by?: string | null;
        notes?: string | null;
        last_follow_up_task_created_at?: string | null;
        has_active_deals: boolean;
        active_deal_count: number;
        has_signed_contract: boolean;
        contract_expires_at?: string | null;
        companies?: {
          __typename?: "companies";
          id: string;
          name: string;
          organization_phone?: string | null;
          phone_aliases: Array<string | null>;
          organization_email?: string | null;
          email_aliases: Array<string | null>;
          line_contact_id?: string | null;
          website?: string | null;
          industry?: string | null;
          contract_type?: string | null;
          hourly_rate?: number | null;
          monthly_rate?: number | null;
          payment_terms?: string | null;
          tax_id?: string | null;
        } | null;
        app_users?: {
          __typename?: "app_users";
          id: string;
          email: string;
          first_name?: string | null;
          last_name?: string | null;
        } | null;
      };
    }>;
  };
};

export type CreateContactsMutationVariables = Exact<{
  input: ContactsInsertInput;
}>;

export type CreateContactsMutation = {
  __typename?: "Mutation";
  insertIntocontactsCollection?: {
    __typename?: "contactsInsertResponse";
    records: Array<{
      __typename?: "contacts";
      id: string;
      name: string;
      company_name?: string | null;
      company_id?: string | null;
      email: string;
      email_aliases?: Array<string | null> | null;
      phone?: string | null;
      phone_aliases?: Array<string | null> | null;
      address?: string | null;
      city?: string | null;
      state?: string | null;
      zip_code?: string | null;
      country?: string | null;
      title?: string | null;
      status?: Contact_Status | null;
      tags?: Array<string | null> | null;
      lifecycle_stage?: string | null;
      source?: string | null;
      last_contacted_at?: string | null;
      avatar_url?: string | null;
      social_links?: Record<string, any> | null;
      custom_fields?: Record<string, any> | null;
      is_active?: boolean | null;
      is_company_line: boolean;
      created_at?: string | null;
      updated_at?: string | null;
      created_by?: string | null;
      updated_by?: string | null;
      notes?: string | null;
      last_follow_up_task_created_at?: string | null;
      has_active_deals: boolean;
      active_deal_count: number;
      has_signed_contract: boolean;
      contract_expires_at?: string | null;
    }>;
  } | null;
};

export type UpdateContactsMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  input: ContactsUpdateInput;
}>;

export type UpdateContactsMutation = {
  __typename?: "Mutation";
  updatecontactsCollection: {
    __typename?: "contactsUpdateResponse";
    records: Array<{
      __typename?: "contacts";
      id: string;
      name: string;
      company_name?: string | null;
      company_id?: string | null;
      email: string;
      email_aliases?: Array<string | null> | null;
      phone?: string | null;
      phone_aliases?: Array<string | null> | null;
      address?: string | null;
      city?: string | null;
      state?: string | null;
      zip_code?: string | null;
      country?: string | null;
      title?: string | null;
      status?: Contact_Status | null;
      tags?: Array<string | null> | null;
      lifecycle_stage?: string | null;
      source?: string | null;
      last_contacted_at?: string | null;
      avatar_url?: string | null;
      social_links?: Record<string, any> | null;
      custom_fields?: Record<string, any> | null;
      is_active?: boolean | null;
      is_company_line: boolean;
      created_at?: string | null;
      updated_at?: string | null;
      created_by?: string | null;
      updated_by?: string | null;
      notes?: string | null;
      last_follow_up_task_created_at?: string | null;
      has_active_deals: boolean;
      active_deal_count: number;
      has_signed_contract: boolean;
      contract_expires_at?: string | null;
    }>;
  };
};

export type DeleteContactsMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeleteContactsMutation = {
  __typename?: "Mutation";
  deleteFromcontactsCollection: {
    __typename?: "contactsDeleteResponse";
    records: Array<{ __typename?: "contacts"; id: string }>;
  };
};

export type GetContactsWithNoTicketsThisMonthQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
}>;

export type GetContactsWithNoTicketsThisMonthQuery = {
  __typename?: "Query";
  contactsCollection: {
    __typename?: "contactsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "contactsEdge";
      node: {
        __typename?: "contacts";
        id: string;
        name: string;
        company_name?: string | null;
        company_id?: string | null;
        email: string;
        phone?: string | null;
        phone_aliases?: Array<string | null> | null;
        status?: Contact_Status | null;
        is_active?: boolean | null;
        is_company_line: boolean;
        created_at?: string | null;
        updated_at?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
  ticketsCollection: {
    __typename?: "ticketsConnection";
    edges: Array<{
      __typename?: "ticketsEdge";
      node: {
        __typename?: "tickets";
        id: string;
        contact_id?: string | null;
        created_at?: string | null;
      };
    }>;
  };
};

export type GetContactsEmailsByFilterQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<ContactsFilter>;
}>;

export type GetContactsEmailsByFilterQuery = {
  __typename?: "Query";
  contactsCollection: {
    __typename?: "contactsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "contactsEdge";
      node: { __typename?: "contacts"; id: string; name: string; email: string };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type ContractFieldsFragment = {
  __typename?: "contracts";
  id: string;
  esignatures_contract_id?: string | null;
  template_name?: string | null;
  document_name?: string | null;
  status: string;
  delivery_mode?: string | null;
  recipient_name?: string | null;
  recipient_email?: string | null;
  signing_url?: string | null;
  signed_pdf_url?: string | null;
  decline_reason?: string | null;
  sent_by_user_id?: string | null;
  contact_id?: string | null;
  company_id?: string | null;
  deal_id?: string | null;
  secure_link_id?: string | null;
  metadata: Record<string, any>;
  sent_at: string;
  last_event_at?: string | null;
  signed_at?: string | null;
  created_at: string;
  updated_at: string;
  term_months?: number | null;
  expires_at?: string | null;
  source: string;
  deals?: { __typename?: "deals"; id: string; title: string } | null;
} & { " $fragmentName"?: "ContractFieldsFragment" };

export type GetContractsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<ContractsFilter>;
  orderBy?: InputMaybe<Array<ContractsOrderBy> | ContractsOrderBy>;
}>;

export type GetContractsQuery = {
  __typename?: "Query";
  contractsCollection: {
    __typename?: "contractsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "contractsEdge";
      node: { __typename?: "contracts" } & {
        " $fragmentRefs"?: { ContractFieldsFragment: ContractFieldsFragment };
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetContractQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetContractQuery = {
  __typename?: "Query";
  contractsCollection: {
    __typename?: "contractsConnection";
    edges: Array<{
      __typename?: "contractsEdge";
      node: { __typename?: "contracts" } & {
        " $fragmentRefs"?: { ContractFieldsFragment: ContractFieldsFragment };
      };
    }>;
  };
};

export type GetContractsByContactQueryVariables = Exact<{
  contactId: Scalars["UUID"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  orderBy?: InputMaybe<Array<ContractsOrderBy> | ContractsOrderBy>;
}>;

export type GetContractsByContactQuery = {
  __typename?: "Query";
  contractsCollection: {
    __typename?: "contractsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "contractsEdge";
      node: { __typename?: "contracts" } & {
        " $fragmentRefs"?: { ContractFieldsFragment: ContractFieldsFragment };
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetContractsByCompanyQueryVariables = Exact<{
  companyId: Scalars["UUID"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  orderBy?: InputMaybe<Array<ContractsOrderBy> | ContractsOrderBy>;
}>;

export type GetContractsByCompanyQuery = {
  __typename?: "Query";
  contractsCollection: {
    __typename?: "contractsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "contractsEdge";
      node: { __typename?: "contracts" } & {
        " $fragmentRefs"?: { ContractFieldsFragment: ContractFieldsFragment };
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetContractsByDealQueryVariables = Exact<{
  dealId: Scalars["UUID"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  orderBy?: InputMaybe<Array<ContractsOrderBy> | ContractsOrderBy>;
}>;

export type GetContractsByDealQuery = {
  __typename?: "Query";
  contractsCollection: {
    __typename?: "contractsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "contractsEdge";
      node: { __typename?: "contracts" } & {
        " $fragmentRefs"?: { ContractFieldsFragment: ContractFieldsFragment };
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type CreateContractsMutationVariables = Exact<{
  input: ContractsInsertInput;
}>;

export type CreateContractsMutation = {
  __typename?: "Mutation";
  insertIntocontractsCollection?: {
    __typename?: "contractsInsertResponse";
    records: Array<{
      __typename?: "contracts";
      id: string;
      document_name?: string | null;
      recipient_name?: string | null;
      company_id?: string | null;
      contact_id?: string | null;
      deal_id?: string | null;
      signed_at?: string | null;
      term_months?: number | null;
      expires_at?: string | null;
      source: string;
      signed_pdf_url?: string | null;
    }>;
  } | null;
};

export type UpdateContractsMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  input: ContractsUpdateInput;
}>;

export type UpdateContractsMutation = {
  __typename?: "Mutation";
  updatecontractsCollection: {
    __typename?: "contractsUpdateResponse";
    records: Array<
      { __typename?: "contracts" } & {
        " $fragmentRefs"?: { ContractFieldsFragment: ContractFieldsFragment };
      }
    >;
  };
};

export type DeleteContractsMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeleteContractsMutation = {
  __typename?: "Mutation";
  deleteFromcontractsCollection: {
    __typename?: "contractsDeleteResponse";
    records: Array<{ __typename?: "contracts"; id: string }>;
  };
};

export type GetDashboardStatsQueryVariables = Exact<{ [key: string]: never }>;

export type GetDashboardStatsQuery = {
  __typename?: "Query";
  ticketsCollection: {
    __typename?: "ticketsConnection";
    edges: Array<{
      __typename?: "ticketsEdge";
      node: {
        __typename?: "tickets";
        id: string;
        ticket_number: number;
        title: string;
        status?: Ticket_Status | null;
        priority?: Ticket_Priority | null;
        created_at?: string | null;
        updated_at?: string | null;
        total_billed?: number | null;
        billable_hours?: number | null;
        non_billable_hours?: number | null;
        hourly_rate?: number | null;
      };
    }>;
  };
  time_entriesCollection: {
    __typename?: "time_entriesConnection";
    edges: Array<{
      __typename?: "time_entriesEdge";
      node: {
        __typename?: "time_entries";
        id: string;
        hours: number;
        entry_type?: Time_Entry_Type | null;
        billable_rate?: number | null;
        date_worked: string;
        created_at?: string | null;
        updated_at?: string | null;
      };
    }>;
  };
  contact_tasksCollection: {
    __typename?: "contact_tasksConnection";
    edges: Array<{
      __typename?: "contact_tasksEdge";
      node: {
        __typename?: "contact_tasks";
        id: string;
        title: string;
        status?: Task_Status | null;
        priority?: string | null;
        due_date?: string | null;
        completed_at?: string | null;
        created_at?: string | null;
        updated_at?: string | null;
      };
    }>;
  };
};

export type GetCriticalTicketsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  filter?: InputMaybe<TicketsFilter>;
}>;

export type GetCriticalTicketsQuery = {
  __typename?: "Query";
  ticketsCollection: {
    __typename?: "ticketsConnection";
    edges: Array<{
      __typename?: "ticketsEdge";
      node: {
        __typename?: "tickets";
        id: string;
        ticket_number: number;
        title: string;
        description?: string | null;
        status?: Ticket_Status | null;
        priority?: Ticket_Priority | null;
        category?: Ticket_Category | null;
        due_date?: string | null;
        created_at?: string | null;
        updated_at?: string | null;
        last_activity_at?: string | null;
        assigned_to?: string | null;
        contact_id?: string | null;
        created_by: string;
        estimated_hours?: number | null;
        actual_hours?: number | null;
        billable_hours?: number | null;
        non_billable_hours?: number | null;
        hourly_rate?: number | null;
        total_cost?: number | null;
        total_billed?: number | null;
        tags?: Array<string | null> | null;
        internal_notes?: string | null;
        customer_visible_notes?: string | null;
        is_internal?: boolean | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetRecentActivityQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  ticketFilter?: InputMaybe<TicketsFilter>;
  timeEntryFilter?: InputMaybe<Time_EntriesFilter>;
}>;

export type GetRecentActivityQuery = {
  __typename?: "Query";
  ticketsCollection: {
    __typename?: "ticketsConnection";
    edges: Array<{
      __typename?: "ticketsEdge";
      node: {
        __typename?: "tickets";
        id: string;
        ticket_number: number;
        title: string;
        status?: Ticket_Status | null;
        priority?: Ticket_Priority | null;
        created_at?: string | null;
        updated_at?: string | null;
        assigned_to?: string | null;
        contact_id?: string | null;
        created_by: string;
        tags?: Array<string | null> | null;
        internal_notes?: string | null;
        customer_visible_notes?: string | null;
        is_internal?: boolean | null;
      };
    }>;
  };
  time_entriesCollection: {
    __typename?: "time_entriesConnection";
    edges: Array<{
      __typename?: "time_entriesEdge";
      node: {
        __typename?: "time_entries";
        id: string;
        ticket_id?: string | null;
        user_id: string;
        description: string;
        hours: number;
        entry_type?: Time_Entry_Type | null;
        billable_rate?: number | null;
        date_worked: string;
        start_time?: string | null;
        end_time?: string | null;
        is_approved?: boolean | null;
        approved_by?: string | null;
        approved_at?: string | null;
        created_at?: string | null;
        updated_at?: string | null;
        sync_status?: Sync_Status | null;
        quickbooks_id?: string | null;
        synced_at?: string | null;
        quickbooks_employee_ref?: string | null;
        quickbooks_customer_ref?: string | null;
      };
    }>;
  };
};

export type GetTimeSummaryQueryVariables = Exact<{
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
  dateFrom?: InputMaybe<Scalars["Date"]["input"]>;
  dateTo?: InputMaybe<Scalars["Date"]["input"]>;
}>;

export type GetTimeSummaryQuery = {
  __typename?: "Query";
  time_entriesCollection: {
    __typename?: "time_entriesConnection";
    edges: Array<{
      __typename?: "time_entriesEdge";
      node: {
        __typename?: "time_entries";
        id: string;
        ticket_id?: string | null;
        user_id: string;
        description: string;
        hours: number;
        entry_type?: Time_Entry_Type | null;
        billable_rate?: number | null;
        date_worked: string;
        start_time?: string | null;
        end_time?: string | null;
        is_approved?: boolean | null;
        approved_by?: string | null;
        approved_at?: string | null;
        created_at?: string | null;
        updated_at?: string | null;
        sync_status?: Sync_Status | null;
        quickbooks_id?: string | null;
        synced_at?: string | null;
        quickbooks_employee_ref?: string | null;
        quickbooks_customer_ref?: string | null;
      };
    }>;
  };
};

export type GetUserTaskStatsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars["UUID"]["input"]>;
}>;

export type GetUserTaskStatsQuery = {
  __typename?: "Query";
  contact_tasksCollection: {
    __typename?: "contact_tasksConnection";
    edges: Array<{
      __typename?: "contact_tasksEdge";
      node: {
        __typename?: "contact_tasks";
        id: string;
        title: string;
        description?: string | null;
        status?: Task_Status | null;
        priority?: string | null;
        due_date?: string | null;
        completed_at?: string | null;
        assigned_users?: Array<string | null> | null;
        tags?: Array<string | null> | null;
        created_at?: string | null;
        updated_at?: string | null;
        contact_id?: string | null;
        user_id: string;
      };
    }>;
  };
};

export type GetCeoHealthCompaniesQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  dateFrom?: InputMaybe<Scalars["Datetime"]["input"]>;
  dateTo?: InputMaybe<Scalars["Datetime"]["input"]>;
}>;

export type GetCeoHealthCompaniesQuery = {
  __typename?: "Query";
  companiesCollection: {
    __typename?: "companiesConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "companiesEdge";
      node: {
        __typename?: "companies";
        id: string;
        name: string;
        organization_revenue?: number | null;
        schedule_status?: Project_Health_Status | null;
        budget_status?: Project_Health_Status | null;
        scope_status?: Project_Health_Status | null;
        alignment_status?: Project_Health_Status | null;
        dealsCollection?: { __typename?: "dealsConnection"; totalCount: number } | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetCeoHealthDealsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  dateFrom?: InputMaybe<Scalars["Date"]["input"]>;
  dateTo?: InputMaybe<Scalars["Date"]["input"]>;
}>;

export type GetCeoHealthDealsQuery = {
  __typename?: "Query";
  dealsCollection: {
    __typename?: "dealsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "dealsEdge";
      node: {
        __typename?: "deals";
        id: string;
        revenue: number;
        cost?: number | null;
        margin_percentage?: number | null;
        stage?: Deal_Stage | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetCeoHealthTimeEntriesQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  dateFrom?: InputMaybe<Scalars["Date"]["input"]>;
  dateTo?: InputMaybe<Scalars["Date"]["input"]>;
}>;

export type GetCeoHealthTimeEntriesQuery = {
  __typename?: "Query";
  time_entriesCollection: {
    __typename?: "time_entriesConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "time_entriesEdge";
      node: {
        __typename?: "time_entries";
        id: string;
        hours: number;
        entry_type?: Time_Entry_Type | null;
        date_worked: string;
        user_id: string;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetCeoHealthUsersQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
}>;

export type GetCeoHealthUsersQuery = {
  __typename?: "Query";
  app_usersCollection: {
    __typename?: "app_usersConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "app_usersEdge";
      node: {
        __typename?: "app_users";
        id: string;
        first_name?: string | null;
        last_name?: string | null;
        email: string;
        available_hours?: number | null;
        is_billable?: boolean | null;
        hourly_rate?: number | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetDealsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<DealsFilter>;
  orderBy?: InputMaybe<Array<DealsOrderBy> | DealsOrderBy>;
}>;

export type GetDealsQuery = {
  __typename?: "Query";
  dealsCollection: {
    __typename?: "dealsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "dealsEdge";
      node: {
        __typename?: "deals";
        id: string;
        company_id: string;
        company_name?: string | null;
        title: string;
        description?: string | null;
        revenue: number;
        currency?: string | null;
        stage?: Deal_Stage | null;
        close_date?: string | null;
        close_probability?: number | null;
        is_recurring?: boolean | null;
        monthly_amount?: number | null;
        contract_term_months?: number | null;
        is_committed?: boolean | null;
        tags?: Array<string | null> | null;
        notes?: string | null;
        last_activity_at?: string | null;
        last_communication_at?: string | null;
        created_at: string;
        updated_at?: string | null;
        created_by?: string | null;
        won_at?: string | null;
        lost_at?: string | null;
        assigned_users?: Array<string | null> | null;
        engineer_ids?: Array<string | null> | null;
        slack_channel_id?: string | null;
        cost?: number | null;
        margin_percentage?: number | null;
        estimated_hours?: number | null;
        schedule_status?: Project_Health_Status | null;
        budget_status?: Project_Health_Status | null;
        scope_status?: Project_Health_Status | null;
        alignment_status?: Project_Health_Status | null;
        last_follow_up_task_created_at?: string | null;
        contractsCollection?: {
          __typename?: "contractsConnection";
          edges: Array<{
            __typename?: "contractsEdge";
            node: { __typename?: "contracts"; status: string };
          }>;
        } | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetDealQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetDealQuery = {
  __typename?: "Query";
  dealsCollection: {
    __typename?: "dealsConnection";
    edges: Array<{
      __typename?: "dealsEdge";
      node: {
        __typename?: "deals";
        id: string;
        company_id: string;
        company_name?: string | null;
        title: string;
        description?: string | null;
        revenue: number;
        currency?: string | null;
        stage?: Deal_Stage | null;
        close_date?: string | null;
        close_probability?: number | null;
        is_recurring?: boolean | null;
        monthly_amount?: number | null;
        contract_term_months?: number | null;
        is_committed?: boolean | null;
        tags?: Array<string | null> | null;
        notes?: string | null;
        last_activity_at?: string | null;
        last_communication_at?: string | null;
        created_at: string;
        updated_at?: string | null;
        created_by?: string | null;
        won_at?: string | null;
        lost_at?: string | null;
        assigned_users?: Array<string | null> | null;
        engineer_ids?: Array<string | null> | null;
        slack_channel_id?: string | null;
        cost?: number | null;
        margin_percentage?: number | null;
        estimated_hours?: number | null;
        schedule_status?: Project_Health_Status | null;
        budget_status?: Project_Health_Status | null;
        scope_status?: Project_Health_Status | null;
        alignment_status?: Project_Health_Status | null;
        last_follow_up_task_created_at?: string | null;
      };
    }>;
  };
};

export type GetDealsByCompanyQueryVariables = Exact<{
  company_id: Scalars["UUID"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
}>;

export type GetDealsByCompanyQuery = {
  __typename?: "Query";
  dealsCollection: {
    __typename?: "dealsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "dealsEdge";
      node: {
        __typename?: "deals";
        id: string;
        company_id: string;
        company_name?: string | null;
        title: string;
        description?: string | null;
        revenue: number;
        currency?: string | null;
        stage?: Deal_Stage | null;
        close_date?: string | null;
        close_probability?: number | null;
        is_recurring?: boolean | null;
        monthly_amount?: number | null;
        contract_term_months?: number | null;
        is_committed?: boolean | null;
        tags?: Array<string | null> | null;
        notes?: string | null;
        last_activity_at?: string | null;
        last_communication_at?: string | null;
        created_at: string;
        updated_at?: string | null;
        created_by?: string | null;
        won_at?: string | null;
        lost_at?: string | null;
        assigned_users?: Array<string | null> | null;
        engineer_ids?: Array<string | null> | null;
        slack_channel_id?: string | null;
        cost?: number | null;
        margin_percentage?: number | null;
        estimated_hours?: number | null;
        schedule_status?: Project_Health_Status | null;
        budget_status?: Project_Health_Status | null;
        scope_status?: Project_Health_Status | null;
        alignment_status?: Project_Health_Status | null;
        last_follow_up_task_created_at?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetActiveDealsByStageQueryVariables = Exact<{
  stage: Deal_Stage;
}>;

export type GetActiveDealsByStageQuery = {
  __typename?: "Query";
  dealsCollection: {
    __typename?: "dealsConnection";
    edges: Array<{
      __typename?: "dealsEdge";
      node: {
        __typename?: "deals";
        id: string;
        company_id: string;
        company_name?: string | null;
        title: string;
        revenue: number;
        currency?: string | null;
        close_probability?: number | null;
        close_date?: string | null;
        last_activity_at?: string | null;
        last_communication_at?: string | null;
        created_at: string;
      };
    }>;
  };
};

export type GetRecurringDealsQueryVariables = Exact<{ [key: string]: never }>;

export type GetRecurringDealsQuery = {
  __typename?: "Query";
  dealsCollection: {
    __typename?: "dealsConnection";
    edges: Array<{
      __typename?: "dealsEdge";
      node: {
        __typename?: "deals";
        id: string;
        company_id: string;
        company_name?: string | null;
        title: string;
        monthly_amount?: number | null;
        contract_term_months?: number | null;
        currency?: string | null;
        stage?: Deal_Stage | null;
        created_at: string;
      };
    }>;
  };
};

export type GetCommittedDealsQueryVariables = Exact<{ [key: string]: never }>;

export type GetCommittedDealsQuery = {
  __typename?: "Query";
  dealsCollection: {
    __typename?: "dealsConnection";
    edges: Array<{
      __typename?: "dealsEdge";
      node: {
        __typename?: "deals";
        id: string;
        company_id: string;
        company_name?: string | null;
        title: string;
        revenue: number;
        currency?: string | null;
        stage?: Deal_Stage | null;
        close_probability?: number | null;
        created_at: string;
      };
    }>;
  };
};

export type CreateDealMutationVariables = Exact<{
  input: DealsInsertInput;
}>;

export type CreateDealMutation = {
  __typename?: "Mutation";
  insertIntodealsCollection?: {
    __typename?: "dealsInsertResponse";
    records: Array<{
      __typename?: "deals";
      id: string;
      company_id: string;
      title: string;
      revenue: number;
      currency?: string | null;
      stage?: Deal_Stage | null;
      created_at: string;
      updated_at?: string | null;
    }>;
  } | null;
};

export type UpdateDealMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  input: DealsUpdateInput;
}>;

export type UpdateDealMutation = {
  __typename?: "Mutation";
  updatedealsCollection: {
    __typename?: "dealsUpdateResponse";
    records: Array<{
      __typename?: "deals";
      id: string;
      company_id: string;
      company_name?: string | null;
      title: string;
      description?: string | null;
      revenue: number;
      currency?: string | null;
      stage?: Deal_Stage | null;
      close_date?: string | null;
      close_probability?: number | null;
      is_recurring?: boolean | null;
      monthly_amount?: number | null;
      contract_term_months?: number | null;
      is_committed?: boolean | null;
      tags?: Array<string | null> | null;
      notes?: string | null;
      last_activity_at?: string | null;
      last_communication_at?: string | null;
      created_at: string;
      updated_at?: string | null;
      created_by?: string | null;
      won_at?: string | null;
      lost_at?: string | null;
      assigned_users?: Array<string | null> | null;
    }>;
  };
};

export type DeleteDealMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeleteDealMutation = {
  __typename?: "Mutation";
  deleteFromdealsCollection: {
    __typename?: "dealsDeleteResponse";
    records: Array<{ __typename?: "deals"; id: string }>;
  };
};

export type GetDealsByFilterQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<DealsFilter>;
  orderBy?: InputMaybe<Array<DealsOrderBy> | DealsOrderBy>;
}>;

export type GetDealsByFilterQuery = {
  __typename?: "Query";
  dealsCollection: {
    __typename?: "dealsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "dealsEdge";
      node: {
        __typename?: "deals";
        id: string;
        company_id: string;
        company_name?: string | null;
        title: string;
        description?: string | null;
        revenue: number;
        currency?: string | null;
        stage?: Deal_Stage | null;
        close_date?: string | null;
        close_probability?: number | null;
        is_recurring?: boolean | null;
        monthly_amount?: number | null;
        contract_term_months?: number | null;
        is_committed?: boolean | null;
        tags?: Array<string | null> | null;
        notes?: string | null;
        last_activity_at?: string | null;
        last_communication_at?: string | null;
        created_at: string;
        updated_at?: string | null;
        created_by?: string | null;
        won_at?: string | null;
        lost_at?: string | null;
        assigned_users?: Array<string | null> | null;
        engineer_ids?: Array<string | null> | null;
        slack_channel_id?: string | null;
        cost?: number | null;
        margin_percentage?: number | null;
        estimated_hours?: number | null;
        schedule_status?: Project_Health_Status | null;
        budget_status?: Project_Health_Status | null;
        scope_status?: Project_Health_Status | null;
        alignment_status?: Project_Health_Status | null;
        last_follow_up_task_created_at?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetDealsByStageForUpdateQueryVariables = Exact<{
  stage: Deal_Stage;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
}>;

export type GetDealsByStageForUpdateQuery = {
  __typename?: "Query";
  dealsCollection: {
    __typename?: "dealsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "dealsEdge";
      node: {
        __typename?: "deals";
        id: string;
        title: string;
        stage?: Deal_Stage | null;
        revenue: number;
        close_date?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type BulkUpdateDealsStageMutationVariables = Exact<{
  ids: Array<Scalars["UUID"]["input"]> | Scalars["UUID"]["input"];
  stage: Deal_Stage;
}>;

export type BulkUpdateDealsStageMutation = {
  __typename?: "Mutation";
  updatedealsCollection: {
    __typename?: "dealsUpdateResponse";
    records: Array<{
      __typename?: "deals";
      id: string;
      stage?: Deal_Stage | null;
      updated_at?: string | null;
    }>;
  };
};

export type GetDealssQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<DealsFilter>;
  orderBy?: InputMaybe<Array<DealsOrderBy> | DealsOrderBy>;
}>;

export type GetDealssQuery = {
  __typename?: "Query";
  dealsCollection: {
    __typename?: "dealsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "dealsEdge";
      node: {
        __typename?: "deals";
        id: string;
        company_id: string;
        company_name?: string | null;
        title: string;
        description?: string | null;
        revenue: number;
        currency?: string | null;
        stage?: Deal_Stage | null;
        close_date?: string | null;
        close_probability?: number | null;
        is_recurring?: boolean | null;
        monthly_amount?: number | null;
        contract_term_months?: number | null;
        is_committed?: boolean | null;
        tags?: Array<string | null> | null;
        notes?: string | null;
        last_activity_at?: string | null;
        last_communication_at?: string | null;
        created_at: string;
        updated_at?: string | null;
        created_by?: string | null;
        won_at?: string | null;
        lost_at?: string | null;
        cost?: number | null;
        margin_percentage?: number | null;
        estimated_hours?: number | null;
        schedule_status?: Project_Health_Status | null;
        budget_status?: Project_Health_Status | null;
        scope_status?: Project_Health_Status | null;
        alignment_status?: Project_Health_Status | null;
        last_follow_up_task_created_at?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetRevenueTargetsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
}>;

export type GetRevenueTargetsQuery = {
  __typename?: "Query";
  revenue_targetsCollection: {
    __typename?: "revenue_targetsConnection";
    edges: Array<{
      __typename?: "revenue_targetsEdge";
      node: {
        __typename?: "revenue_targets";
        id: string;
        created_by: string;
        target_amount: number;
        currency?: string | null;
        period_start: string;
        period_end: string;
        created_at?: string | null;
        updated_at?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetLatestRevenueTargetQueryVariables = Exact<{ [key: string]: never }>;

export type GetLatestRevenueTargetQuery = {
  __typename?: "Query";
  revenue_targetsCollection: {
    __typename?: "revenue_targetsConnection";
    edges: Array<{
      __typename?: "revenue_targetsEdge";
      node: {
        __typename?: "revenue_targets";
        id: string;
        created_by: string;
        target_amount: number;
        currency?: string | null;
        period_start: string;
        period_end: string;
        created_at?: string | null;
        updated_at?: string | null;
      };
    }>;
  };
};

export type CreateRevenueTargetMutationVariables = Exact<{
  input: Revenue_TargetsInsertInput;
}>;

export type CreateRevenueTargetMutation = {
  __typename?: "Mutation";
  insertIntorevenue_targetsCollection?: {
    __typename?: "revenue_targetsInsertResponse";
    records: Array<{
      __typename?: "revenue_targets";
      id: string;
      target_amount: number;
      currency?: string | null;
      period_start: string;
      period_end: string;
      created_at?: string | null;
    }>;
  } | null;
};

export type UpdateRevenueTargetMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  input: Revenue_TargetsUpdateInput;
}>;

export type UpdateRevenueTargetMutation = {
  __typename?: "Mutation";
  updaterevenue_targetsCollection: {
    __typename?: "revenue_targetsUpdateResponse";
    records: Array<{
      __typename?: "revenue_targets";
      id: string;
      target_amount: number;
      currency?: string | null;
      period_start: string;
      period_end: string;
      updated_at?: string | null;
    }>;
  };
};

export type GetCeoRiskDealsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  dateFrom?: InputMaybe<Scalars["Date"]["input"]>;
  dateTo?: InputMaybe<Scalars["Date"]["input"]>;
}>;

export type GetCeoRiskDealsQuery = {
  __typename?: "Query";
  dealsCollection: {
    __typename?: "dealsConnection";
    edges: Array<{
      __typename?: "dealsEdge";
      node: {
        __typename?: "deals";
        id: string;
        company_id: string;
        company_name?: string | null;
        title: string;
        revenue: number;
        close_probability?: number | null;
        close_date?: string | null;
        last_activity_at?: string | null;
        last_communication_at?: string | null;
        created_at: string;
        stage?: Deal_Stage | null;
        assigned_users?: Array<string | null> | null;
        estimated_hours?: number | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetCeoRiskRatedCompaniesQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
}>;

export type GetCeoRiskRatedCompaniesQuery = {
  __typename?: "Query";
  companiesCollection: {
    __typename?: "companiesConnection";
    edges: Array<{
      __typename?: "companiesEdge";
      node: {
        __typename?: "companies";
        id: string;
        name: string;
        schedule_status?: Project_Health_Status | null;
        budget_status?: Project_Health_Status | null;
        scope_status?: Project_Health_Status | null;
        alignment_status?: Project_Health_Status | null;
        last_follow_up_task_created_at?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetCeoRiskUnassignedTicketsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
}>;

export type GetCeoRiskUnassignedTicketsQuery = {
  __typename?: "Query";
  ticketsCollection: {
    __typename?: "ticketsConnection";
    edges: Array<{
      __typename?: "ticketsEdge";
      node: {
        __typename?: "tickets";
        id: string;
        title: string;
        priority?: Ticket_Priority | null;
        created_at?: string | null;
        assigned_to?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetCeoRiskUsersQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
}>;

export type GetCeoRiskUsersQuery = {
  __typename?: "Query";
  app_usersCollection: {
    __typename?: "app_usersConnection";
    edges: Array<{
      __typename?: "app_usersEdge";
      node: {
        __typename?: "app_users";
        id: string;
        first_name?: string | null;
        last_name?: string | null;
        email: string;
        available_hours?: number | null;
        is_billable?: boolean | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type EmailCampaignFieldsFragment = {
  __typename?: "email_campaigns";
  id: string;
  brand: string;
  name: string;
  subject: string;
  template_id?: string | null;
  body_html?: string | null;
  from_email: string;
  from_name: string;
  reply_to?: string | null;
  status: string;
  scheduled_at?: string | null;
  sent_at?: string | null;
  audience_id?: string | null;
  stats: Record<string, any>;
  created_by?: string | null;
  created_at: string;
  updated_at: string;
} & { " $fragmentName"?: "EmailCampaignFieldsFragment" };

export type GetEmailCampaignsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Email_CampaignsFilter>;
  orderBy?: InputMaybe<Array<Email_CampaignsOrderBy> | Email_CampaignsOrderBy>;
}>;

export type GetEmailCampaignsQuery = {
  __typename?: "Query";
  email_campaignsCollection: {
    __typename?: "email_campaignsConnection";
    edges: Array<{
      __typename?: "email_campaignsEdge";
      node: { __typename?: "email_campaigns" } & {
        " $fragmentRefs"?: { EmailCampaignFieldsFragment: EmailCampaignFieldsFragment };
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetEmailCampaignQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetEmailCampaignQuery = {
  __typename?: "Query";
  email_campaignsCollection: {
    __typename?: "email_campaignsConnection";
    edges: Array<{
      __typename?: "email_campaignsEdge";
      node: { __typename?: "email_campaigns" } & {
        " $fragmentRefs"?: { EmailCampaignFieldsFragment: EmailCampaignFieldsFragment };
      };
    }>;
  };
};

export type CreateEmailCampaignsMutationVariables = Exact<{
  input: Email_CampaignsInsertInput;
}>;

export type CreateEmailCampaignsMutation = {
  __typename?: "Mutation";
  insertIntoemail_campaignsCollection?: {
    __typename?: "email_campaignsInsertResponse";
    records: Array<
      { __typename?: "email_campaigns" } & {
        " $fragmentRefs"?: { EmailCampaignFieldsFragment: EmailCampaignFieldsFragment };
      }
    >;
  } | null;
};

export type UpdateEmailCampaignsMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  input: Email_CampaignsUpdateInput;
}>;

export type UpdateEmailCampaignsMutation = {
  __typename?: "Mutation";
  updateemail_campaignsCollection: {
    __typename?: "email_campaignsUpdateResponse";
    records: Array<
      { __typename?: "email_campaigns" } & {
        " $fragmentRefs"?: { EmailCampaignFieldsFragment: EmailCampaignFieldsFragment };
      }
    >;
  };
};

export type DeleteEmailCampaignsMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeleteEmailCampaignsMutation = {
  __typename?: "Mutation";
  deleteFromemail_campaignsCollection: {
    __typename?: "email_campaignsDeleteResponse";
    records: Array<{ __typename?: "email_campaigns"; id: string }>;
  };
};

export type GetEmailTemplateQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetEmailTemplateQuery = {
  __typename?: "Query";
  email_templatesCollection: {
    __typename?: "email_templatesConnection";
    edges: Array<{
      __typename?: "email_templatesEdge";
      node: {
        __typename?: "email_templates";
        id: string;
        name: string;
        subject: string;
        body: string;
        folder_id?: string | null;
        is_shared: boolean;
        tags?: Array<string | null> | null;
        created_at: string;
      };
    }>;
  };
};

export type GetEmailTemplatesCollectionQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  filter?: InputMaybe<Email_TemplatesFilter>;
}>;

export type GetEmailTemplatesCollectionQuery = {
  __typename?: "Query";
  email_templatesCollection: {
    __typename?: "email_templatesConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "email_templatesEdge";
      node: { __typename?: "email_templates"; id: string; name: string; subject: string };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type InsertEmailTemplateMutationVariables = Exact<{
  objects: Array<Email_TemplatesInsertInput> | Email_TemplatesInsertInput;
}>;

export type InsertEmailTemplateMutation = {
  __typename?: "Mutation";
  insertIntoemail_templatesCollection?: {
    __typename?: "email_templatesInsertResponse";
    records: Array<{
      __typename?: "email_templates";
      id: string;
      name: string;
      subject: string;
      body: string;
      folder_id?: string | null;
      is_shared: boolean;
      tags?: Array<string | null> | null;
      created_at: string;
    }>;
  } | null;
};

export type GetEmployeeContactAccessCollectionQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  filter?: InputMaybe<Employee_Contact_AccessFilter>;
}>;

export type GetEmployeeContactAccessCollectionQuery = {
  __typename?: "Query";
  employee_contact_accessCollection: {
    __typename?: "employee_contact_accessConnection";
    edges: Array<{
      __typename?: "employee_contact_accessEdge";
      node: {
        __typename?: "employee_contact_access";
        id: string;
        user_id: string;
        contact_id: string;
        created_at?: string | null;
        granted_by?: string | null;
        app_users?: {
          __typename?: "app_users";
          id: string;
          email: string;
          first_name?: string | null;
          last_name?: string | null;
        } | null;
        contacts?: {
          __typename?: "contacts";
          id: string;
          name: string;
          company_name?: string | null;
          email: string;
        } | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type InsertEmployeeContactAccessMutationVariables = Exact<{
  objects: Array<Employee_Contact_AccessInsertInput> | Employee_Contact_AccessInsertInput;
}>;

export type InsertEmployeeContactAccessMutation = {
  __typename?: "Mutation";
  insertIntoemployee_contact_accessCollection?: {
    __typename?: "employee_contact_accessInsertResponse";
    records: Array<{
      __typename?: "employee_contact_access";
      id: string;
      user_id: string;
      contact_id: string;
      created_at?: string | null;
    }>;
  } | null;
};

export type GetEntityAutomationConfigQueryVariables = Exact<{
  entityType: Scalars["String"]["input"];
  entityId: Scalars["UUID"]["input"];
}>;

export type GetEntityAutomationConfigQuery = {
  __typename?: "Query";
  entity_automation_configCollection: {
    __typename?: "entity_automation_configConnection";
    edges: Array<{
      __typename?: "entity_automation_configEdge";
      node: {
        __typename?: "entity_automation_config";
        id: string;
        entity_type: string;
        entity_id: string;
        created_by?: string | null;
        enabled?: boolean | null;
        frequency?: string | null;
        day_of_week?: number | null;
        run_on_business_days_only?: boolean | null;
        selected_days_of_week?: Array<number | null> | null;
        use_title_template?: boolean | null;
        task_title_template?: string | null;
        task_title_fixed?: string | null;
        task_description_template?: string | null;
        assigned_user_ids?: Array<string | null> | null;
        tags?: Array<string | null> | null;
        priority?: string | null;
        created_at?: string | null;
        updated_at?: string | null;
      };
    }>;
  };
};

export type ListEntityAutomationConfigsQueryVariables = Exact<{
  entityType: Scalars["String"]["input"];
}>;

export type ListEntityAutomationConfigsQuery = {
  __typename?: "Query";
  entity_automation_configCollection: {
    __typename?: "entity_automation_configConnection";
    edges: Array<{
      __typename?: "entity_automation_configEdge";
      node: {
        __typename?: "entity_automation_config";
        id: string;
        entity_type: string;
        entity_id: string;
        created_by?: string | null;
        enabled?: boolean | null;
        frequency?: string | null;
        day_of_week?: number | null;
        run_on_business_days_only?: boolean | null;
        selected_days_of_week?: Array<number | null> | null;
        use_title_template?: boolean | null;
        task_title_template?: string | null;
        task_title_fixed?: string | null;
        task_description_template?: string | null;
        assigned_user_ids?: Array<string | null> | null;
        tags?: Array<string | null> | null;
        priority?: string | null;
        created_at?: string | null;
        updated_at?: string | null;
      };
    }>;
  };
};

export type CreateEntityAutomationConfigMutationVariables = Exact<{
  input: Entity_Automation_ConfigInsertInput;
}>;

export type CreateEntityAutomationConfigMutation = {
  __typename?: "Mutation";
  insertIntoentity_automation_configCollection?: {
    __typename?: "entity_automation_configInsertResponse";
    records: Array<{
      __typename?: "entity_automation_config";
      id: string;
      entity_type: string;
      entity_id: string;
      created_by?: string | null;
      enabled?: boolean | null;
      frequency?: string | null;
      day_of_week?: number | null;
      run_on_business_days_only?: boolean | null;
      selected_days_of_week?: Array<number | null> | null;
      use_title_template?: boolean | null;
      task_title_template?: string | null;
      task_title_fixed?: string | null;
      task_description_template?: string | null;
      assigned_user_ids?: Array<string | null> | null;
      tags?: Array<string | null> | null;
      priority?: string | null;
      created_at?: string | null;
      updated_at?: string | null;
    }>;
  } | null;
};

export type UpdateEntityAutomationConfigMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  input: Entity_Automation_ConfigUpdateInput;
}>;

export type UpdateEntityAutomationConfigMutation = {
  __typename?: "Mutation";
  updateentity_automation_configCollection: {
    __typename?: "entity_automation_configUpdateResponse";
    records: Array<{
      __typename?: "entity_automation_config";
      id: string;
      entity_type: string;
      entity_id: string;
      created_by?: string | null;
      enabled?: boolean | null;
      frequency?: string | null;
      day_of_week?: number | null;
      run_on_business_days_only?: boolean | null;
      selected_days_of_week?: Array<number | null> | null;
      use_title_template?: boolean | null;
      task_title_template?: string | null;
      task_title_fixed?: string | null;
      task_description_template?: string | null;
      assigned_user_ids?: Array<string | null> | null;
      tags?: Array<string | null> | null;
      priority?: string | null;
      created_at?: string | null;
      updated_at?: string | null;
    }>;
  };
};

export type DeleteEntityAutomationConfigMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeleteEntityAutomationConfigMutation = {
  __typename?: "Mutation";
  deleteFromentity_automation_configCollection: {
    __typename?: "entity_automation_configDeleteResponse";
    records: Array<{ __typename?: "entity_automation_config"; id: string }>;
  };
};

export type GetMspDocumentssQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Msp_DocumentsFilter>;
}>;

export type GetMspDocumentssQuery = {
  __typename?: "Query";
  msp_documentsCollection: {
    __typename?: "msp_documentsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "msp_documentsEdge";
      node: {
        __typename?: "msp_documents";
        id: string;
        title: string;
        content?: string | null;
        excerpt?: string | null;
        category: string;
        tags?: Array<string | null> | null;
        client_id?: string | null;
        company_id?: string | null;
        difficulty?: string | null;
        is_internal?: boolean | null;
        is_active?: boolean | null;
        is_featured?: boolean | null;
        estimated_read_time?: number | null;
        last_accessed_at?: string | null;
        access_count?: number | null;
        created_by: string;
        updated_by?: string | null;
        created_at?: string | null;
        updated_at?: string | null;
        shared_with_users?: Array<string | null> | null;
        company?: {
          __typename?: "companies";
          id: string;
          name: string;
          industry?: string | null;
          website?: string | null;
          city?: string | null;
          state?: string | null;
        } | null;
        client?: {
          __typename?: "contacts";
          id: string;
          name: string;
          company_name?: string | null;
          email: string;
        } | null;
        creator?: {
          __typename?: "app_users";
          id: string;
          first_name?: string | null;
          last_name?: string | null;
          email: string;
        } | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetMspDocumentsQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetMspDocumentsQuery = {
  __typename?: "Query";
  msp_documentsCollection: {
    __typename?: "msp_documentsConnection";
    edges: Array<{
      __typename?: "msp_documentsEdge";
      node: {
        __typename?: "msp_documents";
        id: string;
        title: string;
        content?: string | null;
        content_s3_key?: string | null;
        content_preview?: string | null;
        excerpt?: string | null;
        category: string;
        tags?: Array<string | null> | null;
        client_id?: string | null;
        company_id?: string | null;
        difficulty?: string | null;
        is_internal?: boolean | null;
        is_active?: boolean | null;
        is_featured?: boolean | null;
        estimated_read_time?: number | null;
        last_accessed_at?: string | null;
        access_count?: number | null;
        created_by: string;
        updated_by?: string | null;
        created_at?: string | null;
        updated_at?: string | null;
        shared_with_users?: Array<string | null> | null;
        company?: {
          __typename?: "companies";
          id: string;
          name: string;
          industry?: string | null;
          website?: string | null;
          city?: string | null;
          state?: string | null;
        } | null;
        client?: {
          __typename?: "contacts";
          id: string;
          name: string;
          company_name?: string | null;
          email: string;
        } | null;
        creator?: {
          __typename?: "app_users";
          id: string;
          first_name?: string | null;
          last_name?: string | null;
          email: string;
        } | null;
      };
    }>;
  };
};

export type CreateMspDocumentsMutationVariables = Exact<{
  input: Msp_DocumentsInsertInput;
}>;

export type CreateMspDocumentsMutation = {
  __typename?: "Mutation";
  insertIntomsp_documentsCollection?: {
    __typename?: "msp_documentsInsertResponse";
    records: Array<{
      __typename?: "msp_documents";
      id: string;
      title: string;
      content?: string | null;
      excerpt?: string | null;
      category: string;
      tags?: Array<string | null> | null;
      client_id?: string | null;
      company_id?: string | null;
      difficulty?: string | null;
      is_internal?: boolean | null;
      is_active?: boolean | null;
      is_featured?: boolean | null;
      estimated_read_time?: number | null;
      last_accessed_at?: string | null;
      access_count?: number | null;
      created_by: string;
      updated_by?: string | null;
      created_at?: string | null;
      updated_at?: string | null;
      shared_with_users?: Array<string | null> | null;
    }>;
  } | null;
};

export type UpdateMspDocumentsMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  input: Msp_DocumentsUpdateInput;
}>;

export type UpdateMspDocumentsMutation = {
  __typename?: "Mutation";
  updatemsp_documentsCollection: {
    __typename?: "msp_documentsUpdateResponse";
    records: Array<{
      __typename?: "msp_documents";
      id: string;
      title: string;
      content?: string | null;
      excerpt?: string | null;
      category: string;
      tags?: Array<string | null> | null;
      client_id?: string | null;
      company_id?: string | null;
      difficulty?: string | null;
      is_internal?: boolean | null;
      is_active?: boolean | null;
      is_featured?: boolean | null;
      estimated_read_time?: number | null;
      last_accessed_at?: string | null;
      access_count?: number | null;
      created_by: string;
      updated_by?: string | null;
      created_at?: string | null;
      updated_at?: string | null;
      shared_with_users?: Array<string | null> | null;
    }>;
  };
};

export type DeleteMspDocumentsMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeleteMspDocumentsMutation = {
  __typename?: "Mutation";
  deleteFrommsp_documentsCollection: {
    __typename?: "msp_documentsDeleteResponse";
    records: Array<{ __typename?: "msp_documents"; id: string }>;
  };
};

export type GetOfferingsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<OfferingsFilter>;
  orderBy?: InputMaybe<Array<OfferingsOrderBy> | OfferingsOrderBy>;
}>;

export type GetOfferingsQuery = {
  __typename?: "Query";
  offeringsCollection: {
    __typename?: "offeringsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "offeringsEdge";
      node: {
        __typename?: "offerings";
        id: string;
        title: string;
        description?: string | null;
        executive_summary?: string | null;
        tags?: Array<string | null> | null;
        delivery_kit?: string | null;
        one_pager_pdf_url?: string | null;
        image_url?: string | null;
        staff_line_items?: Record<string, any> | null;
        hard_cost_line_items?: Record<string, any> | null;
        total_hours?: number | null;
        total_hard_costs?: number | null;
        total_cost?: number | null;
        created_at?: string | null;
        updated_at?: string | null;
        created_by?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetOfferingQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetOfferingQuery = {
  __typename?: "Query";
  offeringsCollection: {
    __typename?: "offeringsConnection";
    edges: Array<{
      __typename?: "offeringsEdge";
      node: {
        __typename?: "offerings";
        id: string;
        title: string;
        description?: string | null;
        executive_summary?: string | null;
        tags?: Array<string | null> | null;
        delivery_kit?: string | null;
        one_pager_pdf_url?: string | null;
        image_url?: string | null;
        staff_line_items?: Record<string, any> | null;
        hard_cost_line_items?: Record<string, any> | null;
        total_hours?: number | null;
        total_hard_costs?: number | null;
        total_cost?: number | null;
        created_at?: string | null;
        updated_at?: string | null;
        created_by?: string | null;
      };
    }>;
  };
};

export type CreateOfferingMutationVariables = Exact<{
  input: OfferingsInsertInput;
}>;

export type CreateOfferingMutation = {
  __typename?: "Mutation";
  insertIntoofferingsCollection?: {
    __typename?: "offeringsInsertResponse";
    records: Array<{
      __typename?: "offerings";
      id: string;
      title: string;
      description?: string | null;
      executive_summary?: string | null;
      tags?: Array<string | null> | null;
      delivery_kit?: string | null;
      one_pager_pdf_url?: string | null;
      image_url?: string | null;
      staff_line_items?: Record<string, any> | null;
      hard_cost_line_items?: Record<string, any> | null;
      total_hours?: number | null;
      total_hard_costs?: number | null;
      total_cost?: number | null;
      created_at?: string | null;
      updated_at?: string | null;
      created_by?: string | null;
    }>;
  } | null;
};

export type UpdateOfferingMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  input: OfferingsUpdateInput;
}>;

export type UpdateOfferingMutation = {
  __typename?: "Mutation";
  updateofferingsCollection: {
    __typename?: "offeringsUpdateResponse";
    records: Array<{
      __typename?: "offerings";
      id: string;
      title: string;
      description?: string | null;
      executive_summary?: string | null;
      tags?: Array<string | null> | null;
      delivery_kit?: string | null;
      one_pager_pdf_url?: string | null;
      image_url?: string | null;
      staff_line_items?: Record<string, any> | null;
      hard_cost_line_items?: Record<string, any> | null;
      total_hours?: number | null;
      total_hard_costs?: number | null;
      total_cost?: number | null;
      created_at?: string | null;
      updated_at?: string | null;
      created_by?: string | null;
    }>;
  };
};

export type DeleteOfferingMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeleteOfferingMutation = {
  __typename?: "Mutation";
  deleteFromofferingsCollection: {
    __typename?: "offeringsDeleteResponse";
    records: Array<{ __typename?: "offerings"; id: string }>;
  };
};

export type GetPlaidTransactionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Plaid_TransactionsFilter>;
}>;

export type GetPlaidTransactionsQuery = {
  __typename?: "Query";
  plaid_transactionsCollection: {
    __typename?: "plaid_transactionsConnection";
    edges: Array<{
      __typename?: "plaid_transactionsEdge";
      node: {
        __typename?: "plaid_transactions";
        id: string;
        plaid_transaction_id: string;
        account_id: string;
        amount: number;
        iso_currency_code?: string | null;
        date: string;
        name: string;
        merchant_name?: string | null;
        pfc_primary?: string | null;
        pfc_detailed?: string | null;
        pending: boolean;
        plaid_accounts?: { __typename?: "plaid_accounts"; account_id: string; name: string } | null;
        plaid_transaction_attributions?: {
          __typename?: "plaid_transaction_attributions";
          company_id?: string | null;
          is_net_cost: boolean;
          cost_category?: string | null;
          source: string;
          companies?: { __typename?: "companies"; id: string; name: string } | null;
        } | null;
      };
    }>;
    pageInfo: {
      __typename?: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      endCursor?: string | null;
      startCursor?: string | null;
    };
  };
};

export type GetRecurringChargesQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Recurring_ChargesFilter>;
}>;

export type GetRecurringChargesQuery = {
  __typename?: "Query";
  recurring_chargesCollection: {
    __typename?: "recurring_chargesConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "recurring_chargesEdge";
      node: {
        __typename?: "recurring_charges";
        id: string;
        customer_id: string;
        schedule_type: string;
        last_charged_at?: string | null;
        next_charge_date: string;
        metadata?: Record<string, any> | null;
        realm_id: string;
        admin_email: string;
        created_at?: string | null;
        updated_at?: string | null;
      };
    }>;
    pageInfo: {
      __typename?: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export type GetRecurringChargeQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetRecurringChargeQuery = {
  __typename?: "Query";
  recurring_chargesCollection: {
    __typename?: "recurring_chargesConnection";
    edges: Array<{
      __typename?: "recurring_chargesEdge";
      node: {
        __typename?: "recurring_charges";
        id: string;
        customer_id: string;
        schedule_type: string;
        last_charged_at?: string | null;
        next_charge_date: string;
        metadata?: Record<string, any> | null;
        realm_id: string;
        admin_email: string;
        created_at?: string | null;
        updated_at?: string | null;
      };
    }>;
  };
};

export type CreateRecurringChargeMutationVariables = Exact<{
  input: Recurring_ChargesInsertInput;
}>;

export type CreateRecurringChargeMutation = {
  __typename?: "Mutation";
  insertIntorecurring_chargesCollection?: {
    __typename?: "recurring_chargesInsertResponse";
    records: Array<{
      __typename?: "recurring_charges";
      id: string;
      customer_id: string;
      schedule_type: string;
      next_charge_date: string;
      metadata?: Record<string, any> | null;
      realm_id: string;
      admin_email: string;
      created_at?: string | null;
      updated_at?: string | null;
    }>;
  } | null;
};

export type UpdateRecurringChargeMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  input: Recurring_ChargesUpdateInput;
}>;

export type UpdateRecurringChargeMutation = {
  __typename?: "Mutation";
  updaterecurring_chargesCollection: {
    __typename?: "recurring_chargesUpdateResponse";
    records: Array<{
      __typename?: "recurring_charges";
      id: string;
      customer_id: string;
      schedule_type: string;
      last_charged_at?: string | null;
      next_charge_date: string;
      metadata?: Record<string, any> | null;
      realm_id: string;
      admin_email: string;
      updated_at?: string | null;
    }>;
  };
};

export type DeleteRecurringChargeMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeleteRecurringChargeMutation = {
  __typename?: "Mutation";
  deleteFromrecurring_chargesCollection: {
    __typename?: "recurring_chargesDeleteResponse";
    records: Array<{ __typename?: "recurring_charges"; id: string }>;
  };
};

export type GetRecurringTransactionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Recurring_TransactionsFilter>;
}>;

export type GetRecurringTransactionsQuery = {
  __typename?: "Query";
  recurring_transactionsCollection: {
    __typename?: "recurring_transactionsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "recurring_transactionsEdge";
      node: {
        __typename?: "recurring_transactions";
        id: string;
        customer_id?: string | null;
        company_id?: string | null;
        company_name?: string | null;
        contact_name?: string | null;
        item: string;
        description?: string | null;
        amount: number;
        quantity: number;
        billing_cadence: string;
        next_bill_on?: string | null;
        sync_status?: string | null;
        last_synced_at?: string | null;
        last_synced_month?: string | null;
        quickbooks_id?: string | null;
        quickbooks_realm_id?: string | null;
        created_at?: string | null;
        updated_at?: string | null;
        created_by?: string | null;
        updated_by?: string | null;
      };
    }>;
    pageInfo: {
      __typename?: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export type GetRecurringTransactionQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetRecurringTransactionQuery = {
  __typename?: "Query";
  recurring_transactionsCollection: {
    __typename?: "recurring_transactionsConnection";
    edges: Array<{
      __typename?: "recurring_transactionsEdge";
      node: {
        __typename?: "recurring_transactions";
        id: string;
        customer_id?: string | null;
        company_id?: string | null;
        company_name?: string | null;
        contact_name?: string | null;
        item: string;
        description?: string | null;
        amount: number;
        quantity: number;
        billing_cadence: string;
        next_bill_on?: string | null;
        sync_status?: string | null;
        last_synced_at?: string | null;
        last_synced_month?: string | null;
        quickbooks_id?: string | null;
        quickbooks_realm_id?: string | null;
        created_at?: string | null;
        updated_at?: string | null;
        created_by?: string | null;
        updated_by?: string | null;
      };
    }>;
  };
};

export type CreateRecurringTransactionMutationVariables = Exact<{
  input: Recurring_TransactionsInsertInput;
}>;

export type CreateRecurringTransactionMutation = {
  __typename?: "Mutation";
  insertIntorecurring_transactionsCollection?: {
    __typename?: "recurring_transactionsInsertResponse";
    records: Array<{
      __typename?: "recurring_transactions";
      id: string;
      customer_id?: string | null;
      company_id?: string | null;
      item: string;
      description?: string | null;
      amount: number;
      quantity: number;
      billing_cadence: string;
      next_bill_on?: string | null;
      sync_status?: string | null;
      created_at?: string | null;
      updated_at?: string | null;
    }>;
  } | null;
};

export type UpdateRecurringTransactionMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  input: Recurring_TransactionsUpdateInput;
}>;

export type UpdateRecurringTransactionMutation = {
  __typename?: "Mutation";
  updaterecurring_transactionsCollection: {
    __typename?: "recurring_transactionsUpdateResponse";
    records: Array<{
      __typename?: "recurring_transactions";
      id: string;
      customer_id?: string | null;
      company_id?: string | null;
      item: string;
      description?: string | null;
      amount: number;
      quantity: number;
      billing_cadence: string;
      next_bill_on?: string | null;
      sync_status?: string | null;
      last_synced_at?: string | null;
      last_synced_month?: string | null;
      quickbooks_id?: string | null;
      quickbooks_realm_id?: string | null;
      updated_at?: string | null;
    }>;
  };
};

export type DeleteRecurringTransactionMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeleteRecurringTransactionMutation = {
  __typename?: "Mutation";
  deleteFromrecurring_transactionsCollection: {
    __typename?: "recurring_transactionsDeleteResponse";
    records: Array<{ __typename?: "recurring_transactions"; id: string }>;
  };
};

export type GetRelationshipMapDataQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
}>;

export type GetRelationshipMapDataQuery = {
  __typename?: "Query";
  companiesCollection: {
    __typename?: "companiesConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "companiesEdge";
      node: {
        __typename?: "companies";
        id: string;
        name: string;
        status?: string | null;
        created_at?: string | null;
        updated_at?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
  contactsCollection: {
    __typename?: "contactsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "contactsEdge";
      node: {
        __typename?: "contacts";
        id: string;
        name: string;
        email: string;
        status?: Contact_Status | null;
        company_id?: string | null;
        created_at?: string | null;
        updated_at?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
  dealsCollection: {
    __typename?: "dealsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "dealsEdge";
      node: {
        __typename?: "deals";
        id: string;
        title: string;
        stage?: Deal_Stage | null;
        revenue: number;
        company_id: string;
        created_at: string;
        updated_at?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
  ticketsCollection: {
    __typename?: "ticketsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "ticketsEdge";
      node: {
        __typename?: "tickets";
        id: string;
        title: string;
        status?: Ticket_Status | null;
        priority?: Ticket_Priority | null;
        company_id: string;
        contact_id?: string | null;
        actual_hours?: number | null;
        created_at?: string | null;
        updated_at?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
  contact_tasksCollection: {
    __typename?: "contact_tasksConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "contact_tasksEdge";
      node: {
        __typename?: "contact_tasks";
        id: string;
        title: string;
        status?: Task_Status | null;
        priority?: string | null;
        contact_id?: string | null;
        company_id?: string | null;
        user_id: string;
        created_at?: string | null;
        updated_at?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
  time_entriesCollection: {
    __typename?: "time_entriesConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "time_entriesEdge";
      node: {
        __typename?: "time_entries";
        id: string;
        description: string;
        hours: number;
        ticket_id?: string | null;
        created_at?: string | null;
        updated_at?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
  communicationsCollection: {
    __typename?: "communicationsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "communicationsEdge";
      node: {
        __typename?: "communications";
        id: string;
        direction?: string | null;
        status?: string | null;
        contact_id: string;
        company_id?: string | null;
        created_at?: string | null;
        updated_at?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetRolessQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<RolesFilter>;
}>;

export type GetRolessQuery = {
  __typename?: "Query";
  rolesCollection: {
    __typename?: "rolesConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "rolesEdge";
      node: {
        __typename?: "roles";
        id: string;
        name: string;
        display_name: string;
        description?: string | null;
        permissions?: Record<string, any> | null;
        is_active?: boolean | null;
        created_at?: string | null;
        updated_at?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetRolesQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetRolesQuery = {
  __typename?: "Query";
  rolesCollection: {
    __typename?: "rolesConnection";
    edges: Array<{
      __typename?: "rolesEdge";
      node: {
        __typename?: "roles";
        id: string;
        name: string;
        display_name: string;
        description?: string | null;
        permissions?: Record<string, any> | null;
        is_active?: boolean | null;
        created_at?: string | null;
        updated_at?: string | null;
      };
    }>;
  };
};

export type CreateRolesMutationVariables = Exact<{
  input: RolesInsertInput;
}>;

export type CreateRolesMutation = {
  __typename?: "Mutation";
  insertIntorolesCollection?: {
    __typename?: "rolesInsertResponse";
    records: Array<{
      __typename?: "roles";
      id: string;
      name: string;
      display_name: string;
      description?: string | null;
      permissions?: Record<string, any> | null;
      is_active?: boolean | null;
      created_at?: string | null;
      updated_at?: string | null;
    }>;
  } | null;
};

export type UpdateRolesMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  input: RolesUpdateInput;
}>;

export type UpdateRolesMutation = {
  __typename?: "Mutation";
  updaterolesCollection: {
    __typename?: "rolesUpdateResponse";
    records: Array<{
      __typename?: "roles";
      id: string;
      name: string;
      display_name: string;
      description?: string | null;
      permissions?: Record<string, any> | null;
      is_active?: boolean | null;
      created_at?: string | null;
      updated_at?: string | null;
    }>;
  };
};

export type DeleteRolesMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeleteRolesMutation = {
  __typename?: "Mutation";
  deleteFromrolesCollection: {
    __typename?: "rolesDeleteResponse";
    records: Array<{ __typename?: "roles"; id: string }>;
  };
};

export type GetSavedViewsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  resource: Scalars["String"]["input"];
}>;

export type GetSavedViewsQuery = {
  __typename?: "Query";
  saved_viewsCollection: {
    __typename?: "saved_viewsConnection";
    edges: Array<{
      __typename?: "saved_viewsEdge";
      node: {
        __typename?: "saved_views";
        id: string;
        resource: string;
        name: string;
        filters: Record<string, any>;
        visibility: string;
        shared_with_user_ids: Array<string | null>;
        created_by: string;
        created_at: string;
        updated_at: string;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetSavedViewFavoritesQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  userId: Scalars["UUID"]["input"];
  resource: Scalars["String"]["input"];
}>;

export type GetSavedViewFavoritesQuery = {
  __typename?: "Query";
  saved_view_favoritesCollection: {
    __typename?: "saved_view_favoritesConnection";
    edges: Array<{
      __typename?: "saved_view_favoritesEdge";
      node: {
        __typename?: "saved_view_favorites";
        view_id: string;
        user_id: string;
        created_at: string;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetAllSavedViewFavoritesQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  userId: Scalars["UUID"]["input"];
}>;

export type GetAllSavedViewFavoritesQuery = {
  __typename?: "Query";
  saved_view_favoritesCollection: {
    __typename?: "saved_view_favoritesConnection";
    edges: Array<{
      __typename?: "saved_view_favoritesEdge";
      node: {
        __typename?: "saved_view_favorites";
        view_id: string;
        user_id: string;
        created_at: string;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type ValidateUserAccessToViewQueryVariables = Exact<{
  viewId: Scalars["UUID"]["input"];
}>;

export type ValidateUserAccessToViewQuery = {
  __typename?: "Query";
  saved_viewsCollection: {
    __typename?: "saved_viewsConnection";
    edges: Array<{
      __typename?: "saved_viewsEdge";
      node: {
        __typename?: "saved_views";
        id: string;
        visibility: string;
        created_by: string;
        shared_with_user_ids: Array<string | null>;
      };
    }>;
  };
};

export type CreateSavedViewMutationVariables = Exact<{
  input: Saved_ViewsInsertInput;
}>;

export type CreateSavedViewMutation = {
  __typename?: "Mutation";
  insertIntosaved_viewsCollection?: {
    __typename?: "saved_viewsInsertResponse";
    records: Array<{
      __typename?: "saved_views";
      id: string;
      resource: string;
      name: string;
      filters: Record<string, any>;
      visibility: string;
      shared_with_user_ids: Array<string | null>;
      created_by: string;
      created_at: string;
      updated_at: string;
    }>;
  } | null;
};

export type UpdateSavedViewMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  input: Saved_ViewsUpdateInput;
}>;

export type UpdateSavedViewMutation = {
  __typename?: "Mutation";
  updatesaved_viewsCollection: {
    __typename?: "saved_viewsUpdateResponse";
    records: Array<{
      __typename?: "saved_views";
      id: string;
      resource: string;
      name: string;
      filters: Record<string, any>;
      visibility: string;
      shared_with_user_ids: Array<string | null>;
      created_by: string;
      created_at: string;
      updated_at: string;
    }>;
  };
};

export type DeleteSavedViewMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeleteSavedViewMutation = {
  __typename?: "Mutation";
  deleteFromsaved_viewsCollection: {
    __typename?: "saved_viewsDeleteResponse";
    records: Array<{ __typename?: "saved_views"; id: string }>;
  };
};

export type ToggleSavedViewFavoriteMutationVariables = Exact<{
  userId: Scalars["UUID"]["input"];
  viewId: Scalars["UUID"]["input"];
}>;

export type ToggleSavedViewFavoriteMutation = {
  __typename?: "Mutation";
  insertIntosaved_view_favoritesCollection?: {
    __typename?: "saved_view_favoritesInsertResponse";
    records: Array<{
      __typename?: "saved_view_favorites";
      user_id: string;
      view_id: string;
      created_at: string;
    }>;
  } | null;
};

export type DeleteSavedViewFavoriteMutationVariables = Exact<{
  userId: Scalars["UUID"]["input"];
  viewId: Scalars["UUID"]["input"];
}>;

export type DeleteSavedViewFavoriteMutation = {
  __typename?: "Mutation";
  deleteFromsaved_view_favoritesCollection: {
    __typename?: "saved_view_favoritesDeleteResponse";
    records: Array<{ __typename?: "saved_view_favorites"; user_id: string; view_id: string }>;
  };
};

export type GetEnrollmentsForContactQueryVariables = Exact<{
  contactId: Scalars["UUID"]["input"];
}>;

export type GetEnrollmentsForContactQuery = {
  __typename?: "Query";
  sales_sequence_enrollmentsCollection: {
    __typename?: "sales_sequence_enrollmentsConnection";
    edges: Array<{
      __typename?: "sales_sequence_enrollmentsEdge";
      node: {
        __typename?: "sales_sequence_enrollments";
        id: string;
        status: Sequence_Enrollment_Status;
        current_step_number: number;
        next_action_at?: string | null;
        enrolled_at: string;
        pause_reason?: string | null;
        deal_id?: string | null;
        company_id?: string | null;
        sequence_id: string;
        sales_sequences?: {
          __typename?: "sales_sequences";
          id: string;
          name: string;
          sales_sequence_stepsCollection?: {
            __typename?: "sales_sequence_stepsConnection";
            edges: Array<{
              __typename?: "sales_sequence_stepsEdge";
              node: {
                __typename?: "sales_sequence_steps";
                step_number: number;
                title: string;
                channel: Sequence_Channel;
              };
            }>;
          } | null;
        } | null;
        sales_sequence_step_eventsCollection?: {
          __typename?: "sales_sequence_step_eventsConnection";
          edges: Array<{
            __typename?: "sales_sequence_step_eventsEdge";
            node: {
              __typename?: "sales_sequence_step_events";
              id: string;
              step_number: number;
              channel: Sequence_Channel;
              outcome: Sequence_Step_Outcome;
              occurred_at: string;
              note?: string | null;
            };
          }>;
        } | null;
      };
    }>;
  };
};

export type UpdateSalesSequenceMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  set: Sales_SequencesUpdateInput;
}>;

export type UpdateSalesSequenceMutation = {
  __typename?: "Mutation";
  updatesales_sequencesCollection: {
    __typename?: "sales_sequencesUpdateResponse";
    affectedCount: number;
    records: Array<{
      __typename?: "sales_sequences";
      id: string;
      name: string;
      description?: string | null;
      region_hint: Sequence_Region_Hint;
      is_active: boolean;
      is_default: boolean;
    }>;
  };
};

export type UpdateSalesSequenceStepMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  set: Sales_Sequence_StepsUpdateInput;
}>;

export type UpdateSalesSequenceStepMutation = {
  __typename?: "Mutation";
  updatesales_sequence_stepsCollection: {
    __typename?: "sales_sequence_stepsUpdateResponse";
    affectedCount: number;
    records: Array<{
      __typename?: "sales_sequence_steps";
      id: string;
      step_number: number;
      channel: Sequence_Channel;
      delay_business_days: number;
      title: string;
      guidance?: string | null;
      pause_for_reply: boolean;
    }>;
  };
};

export type InsertSalesSequenceStepMutationVariables = Exact<{
  object: Sales_Sequence_StepsInsertInput;
}>;

export type InsertSalesSequenceStepMutation = {
  __typename?: "Mutation";
  insertIntosales_sequence_stepsCollection?: {
    __typename?: "sales_sequence_stepsInsertResponse";
    records: Array<{
      __typename?: "sales_sequence_steps";
      id: string;
      step_number: number;
      channel: Sequence_Channel;
      delay_business_days: number;
      title: string;
      guidance?: string | null;
      pause_for_reply: boolean;
    }>;
  } | null;
};

export type DeleteSalesSequenceStepMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeleteSalesSequenceStepMutation = {
  __typename?: "Mutation";
  deleteFromsales_sequence_stepsCollection: {
    __typename?: "sales_sequence_stepsDeleteResponse";
    affectedCount: number;
  };
};

export type GetContactForSequenceEnrollQueryVariables = Exact<{
  contactId: Scalars["UUID"]["input"];
}>;

export type GetContactForSequenceEnrollQuery = {
  __typename?: "Query";
  contactsCollection: {
    __typename?: "contactsConnection";
    edges: Array<{
      __typename?: "contactsEdge";
      node: {
        __typename?: "contacts";
        id: string;
        name: string;
        email: string;
        phone?: string | null;
        title?: string | null;
        status?: Contact_Status | null;
        company_name?: string | null;
        companies?: { __typename?: "companies"; id: string; name: string } | null;
      };
    }>;
  };
};

export type GetCompanyForSequenceEnrollQueryVariables = Exact<{
  companyId: Scalars["UUID"]["input"];
}>;

export type GetCompanyForSequenceEnrollQuery = {
  __typename?: "Query";
  companiesCollection: {
    __typename?: "companiesConnection";
    edges: Array<{
      __typename?: "companiesEdge";
      node: { __typename?: "companies"; id: string; name: string; status?: string | null };
    }>;
  };
};

export type GetContactsForCompanyQueryVariables = Exact<{
  companyId: Scalars["UUID"]["input"];
}>;

export type GetContactsForCompanyQuery = {
  __typename?: "Query";
  contactsCollection: {
    __typename?: "contactsConnection";
    edges: Array<{
      __typename?: "contactsEdge";
      node: { __typename?: "contacts"; id: string; name: string; email: string };
    }>;
  };
};

export type GetSalesSequencesQueryVariables = Exact<{ [key: string]: never }>;

export type GetSalesSequencesQuery = {
  __typename?: "Query";
  sales_sequencesCollection: {
    __typename?: "sales_sequencesConnection";
    edges: Array<{
      __typename?: "sales_sequencesEdge";
      node: {
        __typename?: "sales_sequences";
        id: string;
        name: string;
        description?: string | null;
        target_type: Sequence_Target;
        region_hint: Sequence_Region_Hint;
        is_active: boolean;
        is_default: boolean;
        deal_stage_trigger?: string | null;
        created_at: string;
        sales_sequence_stepsCollection?: {
          __typename?: "sales_sequence_stepsConnection";
          edges: Array<{
            __typename?: "sales_sequence_stepsEdge";
            node: {
              __typename?: "sales_sequence_steps";
              id: string;
              step_number: number;
              channel: Sequence_Channel;
              delay_business_days: number;
              title: string;
              guidance?: string | null;
              pause_for_reply: boolean;
            };
          }>;
        } | null;
      };
    }>;
  };
};

export type GetSkillsCatalogQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Skills_CatalogFilter>;
  orderBy?: InputMaybe<Array<Skills_CatalogOrderBy> | Skills_CatalogOrderBy>;
}>;

export type GetSkillsCatalogQuery = {
  __typename?: "Query";
  skills_catalogCollection: {
    __typename?: "skills_catalogConnection";
    edges: Array<{
      __typename?: "skills_catalogEdge";
      node: {
        __typename?: "skills_catalog";
        id: string;
        name: string;
        category: string;
        sort_order: number;
        created_at?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetSkillsCatalogAllQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<Skills_CatalogOrderBy> | Skills_CatalogOrderBy>;
}>;

export type GetSkillsCatalogAllQuery = {
  __typename?: "Query";
  skills_catalogCollection: {
    __typename?: "skills_catalogConnection";
    edges: Array<{
      __typename?: "skills_catalogEdge";
      node: {
        __typename?: "skills_catalog";
        id: string;
        name: string;
        category: string;
        sort_order: number;
        created_at?: string | null;
      };
    }>;
  };
};

export type GetAppUserSkillsQueryVariables = Exact<{
  filter?: InputMaybe<App_User_SkillsFilter>;
  orderBy?: InputMaybe<Array<App_User_SkillsOrderBy> | App_User_SkillsOrderBy>;
}>;

export type GetAppUserSkillsQuery = {
  __typename?: "Query";
  app_user_skillsCollection: {
    __typename?: "app_user_skillsConnection";
    edges: Array<{
      __typename?: "app_user_skillsEdge";
      node: {
        __typename?: "app_user_skills";
        user_id: string;
        skill_id: string;
        grade: number;
        created_at?: string | null;
        updated_at?: string | null;
        skills_catalog?: {
          __typename?: "skills_catalog";
          id: string;
          name: string;
          category: string;
          sort_order: number;
        } | null;
      };
    }>;
  };
};

export type InsertAppUserSkillMutationVariables = Exact<{
  input: App_User_SkillsInsertInput;
}>;

export type InsertAppUserSkillMutation = {
  __typename?: "Mutation";
  insertIntoapp_user_skillsCollection?: {
    __typename?: "app_user_skillsInsertResponse";
    records: Array<{
      __typename?: "app_user_skills";
      user_id: string;
      skill_id: string;
      grade: number;
      created_at?: string | null;
      updated_at?: string | null;
    }>;
  } | null;
};

export type UpdateAppUserSkillMutationVariables = Exact<{
  filter: App_User_SkillsFilter;
  set: App_User_SkillsUpdateInput;
}>;

export type UpdateAppUserSkillMutation = {
  __typename?: "Mutation";
  updateapp_user_skillsCollection: {
    __typename?: "app_user_skillsUpdateResponse";
    records: Array<{
      __typename?: "app_user_skills";
      user_id: string;
      skill_id: string;
      grade: number;
      created_at?: string | null;
      updated_at?: string | null;
    }>;
  };
};

export type DeleteAppUserSkillMutationVariables = Exact<{
  filter: App_User_SkillsFilter;
}>;

export type DeleteAppUserSkillMutation = {
  __typename?: "Mutation";
  deleteFromapp_user_skillsCollection: {
    __typename?: "app_user_skillsDeleteResponse";
    records: Array<{ __typename?: "app_user_skills"; user_id: string; skill_id: string }>;
  };
};

export type SocialMediaPostFieldsFragment = {
  __typename?: "social_media_posts";
  id: string;
  brand: string;
  title?: string | null;
  body: string;
  media_kind: string;
  media_url?: string | null;
  thumbnail_url?: string | null;
  drive_file_id?: string | null;
  drive_file_name?: string | null;
  drive_folder_id?: string | null;
  tags: Array<string | null>;
  location?: string | null;
  youtube?: Record<string, any> | null;
  platforms: Array<string | null>;
  status: string;
  scheduled_at?: string | null;
  published_at?: string | null;
  results: Record<string, any>;
  error_summary?: string | null;
  contact_id?: string | null;
  company_id?: string | null;
  created_by?: string | null;
  created_at: string;
  updated_at: string;
} & { " $fragmentName"?: "SocialMediaPostFieldsFragment" };

export type GetSocialMediaPostsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Social_Media_PostsFilter>;
  orderBy?: InputMaybe<Array<Social_Media_PostsOrderBy> | Social_Media_PostsOrderBy>;
}>;

export type GetSocialMediaPostsQuery = {
  __typename?: "Query";
  social_media_postsCollection: {
    __typename?: "social_media_postsConnection";
    edges: Array<{
      __typename?: "social_media_postsEdge";
      node: { __typename?: "social_media_posts" } & {
        " $fragmentRefs"?: { SocialMediaPostFieldsFragment: SocialMediaPostFieldsFragment };
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetSocialMediaPostQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetSocialMediaPostQuery = {
  __typename?: "Query";
  social_media_postsCollection: {
    __typename?: "social_media_postsConnection";
    edges: Array<{
      __typename?: "social_media_postsEdge";
      node: { __typename?: "social_media_posts" } & {
        " $fragmentRefs"?: { SocialMediaPostFieldsFragment: SocialMediaPostFieldsFragment };
      };
    }>;
  };
};

export type GetSocialMediaPostsByContactQueryVariables = Exact<{
  contactId: Scalars["UUID"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  orderBy?: InputMaybe<Array<Social_Media_PostsOrderBy> | Social_Media_PostsOrderBy>;
}>;

export type GetSocialMediaPostsByContactQuery = {
  __typename?: "Query";
  social_media_postsCollection: {
    __typename?: "social_media_postsConnection";
    edges: Array<{
      __typename?: "social_media_postsEdge";
      node: { __typename?: "social_media_posts" } & {
        " $fragmentRefs"?: { SocialMediaPostFieldsFragment: SocialMediaPostFieldsFragment };
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetSocialMediaPostsByCompanyQueryVariables = Exact<{
  companyId: Scalars["UUID"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  orderBy?: InputMaybe<Array<Social_Media_PostsOrderBy> | Social_Media_PostsOrderBy>;
}>;

export type GetSocialMediaPostsByCompanyQuery = {
  __typename?: "Query";
  social_media_postsCollection: {
    __typename?: "social_media_postsConnection";
    edges: Array<{
      __typename?: "social_media_postsEdge";
      node: { __typename?: "social_media_posts" } & {
        " $fragmentRefs"?: { SocialMediaPostFieldsFragment: SocialMediaPostFieldsFragment };
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type CreateSocialMediaPostsMutationVariables = Exact<{
  input: Social_Media_PostsInsertInput;
}>;

export type CreateSocialMediaPostsMutation = {
  __typename?: "Mutation";
  insertIntosocial_media_postsCollection?: {
    __typename?: "social_media_postsInsertResponse";
    records: Array<
      { __typename?: "social_media_posts" } & {
        " $fragmentRefs"?: { SocialMediaPostFieldsFragment: SocialMediaPostFieldsFragment };
      }
    >;
  } | null;
};

export type UpdateSocialMediaPostsMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  input: Social_Media_PostsUpdateInput;
}>;

export type UpdateSocialMediaPostsMutation = {
  __typename?: "Mutation";
  updatesocial_media_postsCollection: {
    __typename?: "social_media_postsUpdateResponse";
    records: Array<
      { __typename?: "social_media_posts" } & {
        " $fragmentRefs"?: { SocialMediaPostFieldsFragment: SocialMediaPostFieldsFragment };
      }
    >;
  };
};

export type DeleteSocialMediaPostsMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeleteSocialMediaPostsMutation = {
  __typename?: "Mutation";
  deleteFromsocial_media_postsCollection: {
    __typename?: "social_media_postsDeleteResponse";
    records: Array<{ __typename?: "social_media_posts"; id: string }>;
  };
};

export type GetContactUniqueTagsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetContactUniqueTagsQuery = {
  __typename?: "Query";
  contactsCollection: {
    __typename?: "contactsConnection";
    edges: Array<{
      __typename?: "contactsEdge";
      node: { __typename?: "contacts"; tags?: Array<string | null> | null };
    }>;
  };
};

export type GetTicketUniqueTagsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetTicketUniqueTagsQuery = {
  __typename?: "Query";
  ticketsCollection: {
    __typename?: "ticketsConnection";
    edges: Array<{
      __typename?: "ticketsEdge";
      node: { __typename?: "tickets"; tags?: Array<string | null> | null };
    }>;
  };
};

export type GetTaskUniqueTagsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetTaskUniqueTagsQuery = {
  __typename?: "Query";
  contact_tasksCollection: {
    __typename?: "contact_tasksConnection";
    edges: Array<{
      __typename?: "contact_tasksEdge";
      node: { __typename?: "contact_tasks"; tags?: Array<string | null> | null };
    }>;
  };
};

export type GetEmailTemplateUniqueTagsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetEmailTemplateUniqueTagsQuery = {
  __typename?: "Query";
  email_templatesCollection: {
    __typename?: "email_templatesConnection";
    edges: Array<{
      __typename?: "email_templatesEdge";
      node: { __typename?: "email_templates"; tags?: Array<string | null> | null };
    }>;
  };
};

export type GetMspDocumentUniqueTagsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetMspDocumentUniqueTagsQuery = {
  __typename?: "Query";
  msp_documentsCollection: {
    __typename?: "msp_documentsConnection";
    edges: Array<{
      __typename?: "msp_documentsEdge";
      node: { __typename?: "msp_documents"; tags?: Array<string | null> | null };
    }>;
  };
};

export type GetCompanyUniqueTechnologiesQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetCompanyUniqueTechnologiesQuery = {
  __typename?: "Query";
  companiesCollection: {
    __typename?: "companiesConnection";
    edges: Array<{
      __typename?: "companiesEdge";
      node: { __typename?: "companies"; current_technologies?: Record<string, any> | null };
    }>;
  };
};

export type GetTaskssQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Contact_TasksFilter>;
}>;

export type GetTaskssQuery = {
  __typename?: "Query";
  contact_tasksCollection: {
    __typename?: "contact_tasksConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "contact_tasksEdge";
      node: {
        __typename?: "contact_tasks";
        id: string;
        title: string;
        description?: string | null;
        status?: Task_Status | null;
        priority?: string | null;
        due_date?: string | null;
        completed_at?: string | null;
        assigned_users?: Array<string | null> | null;
        tags?: Array<string | null> | null;
        created_at?: string | null;
        updated_at?: string | null;
        contact_id?: string | null;
        company_id?: string | null;
        user_id: string;
        entity_type?: string | null;
        entity_id?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetTasksQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetTasksQuery = {
  __typename?: "Query";
  contact_tasksCollection: {
    __typename?: "contact_tasksConnection";
    edges: Array<{
      __typename?: "contact_tasksEdge";
      node: {
        __typename?: "contact_tasks";
        id: string;
        title: string;
        description?: string | null;
        status?: Task_Status | null;
        priority?: string | null;
        due_date?: string | null;
        completed_at?: string | null;
        assigned_users?: Array<string | null> | null;
        tags?: Array<string | null> | null;
        created_at?: string | null;
        updated_at?: string | null;
        contact_id?: string | null;
        company_id?: string | null;
        user_id: string;
        entity_type?: string | null;
        entity_id?: string | null;
        contacts?: {
          __typename?: "contacts";
          id: string;
          name: string;
          email: string;
          company_name?: string | null;
        } | null;
      };
    }>;
  };
};

export type CreateTasksMutationVariables = Exact<{
  input: Contact_TasksInsertInput;
}>;

export type CreateTasksMutation = {
  __typename?: "Mutation";
  insertIntocontact_tasksCollection?: {
    __typename?: "contact_tasksInsertResponse";
    records: Array<{
      __typename?: "contact_tasks";
      id: string;
      title: string;
      description?: string | null;
      status?: Task_Status | null;
      priority?: string | null;
      due_date?: string | null;
      completed_at?: string | null;
      assigned_users?: Array<string | null> | null;
      tags?: Array<string | null> | null;
      created_at?: string | null;
      updated_at?: string | null;
      contact_id?: string | null;
      company_id?: string | null;
      user_id: string;
      entity_type?: string | null;
      entity_id?: string | null;
    }>;
  } | null;
};

export type CreateTaskNoteMutationVariables = Exact<{
  input: Task_NotesInsertInput;
}>;

export type CreateTaskNoteMutation = {
  __typename?: "Mutation";
  insertIntotask_notesCollection?: {
    __typename?: "task_notesInsertResponse";
    records: Array<{
      __typename?: "task_notes";
      id: string;
      task_id: string;
      content: string;
      note_type?: string | null;
      is_internal?: boolean | null;
      user_id?: string | null;
      created_at?: string | null;
      updated_at?: string | null;
    }>;
  } | null;
};

export type ListTaskNotesQueryVariables = Exact<{
  taskId: Scalars["UUID"]["input"];
}>;

export type ListTaskNotesQuery = {
  __typename?: "Query";
  task_notesCollection: {
    __typename?: "task_notesConnection";
    edges: Array<{
      __typename?: "task_notesEdge";
      node: {
        __typename?: "task_notes";
        id: string;
        task_id: string;
        content: string;
        note_type?: string | null;
        is_internal?: boolean | null;
        user_id?: string | null;
        created_at?: string | null;
        updated_at?: string | null;
      };
    }>;
  };
};

export type UpdateTaskNoteMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  input: Task_NotesUpdateInput;
}>;

export type UpdateTaskNoteMutation = {
  __typename?: "Mutation";
  updatetask_notesCollection: {
    __typename?: "task_notesUpdateResponse";
    records: Array<{
      __typename?: "task_notes";
      id: string;
      task_id: string;
      content: string;
      note_type?: string | null;
      is_internal?: boolean | null;
      user_id?: string | null;
      created_at?: string | null;
      updated_at?: string | null;
    }>;
  };
};

export type DeleteTaskNoteMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeleteTaskNoteMutation = {
  __typename?: "Mutation";
  deleteFromtask_notesCollection: {
    __typename?: "task_notesDeleteResponse";
    records: Array<{ __typename?: "task_notes"; id: string; task_id: string }>;
  };
};

export type UpdateTasksMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  input: Contact_TasksUpdateInput;
}>;

export type UpdateTasksMutation = {
  __typename?: "Mutation";
  updatecontact_tasksCollection: {
    __typename?: "contact_tasksUpdateResponse";
    records: Array<{
      __typename?: "contact_tasks";
      id: string;
      title: string;
      description?: string | null;
      status?: Task_Status | null;
      priority?: string | null;
      due_date?: string | null;
      completed_at?: string | null;
      assigned_users?: Array<string | null> | null;
      tags?: Array<string | null> | null;
      created_at?: string | null;
      updated_at?: string | null;
      contact_id?: string | null;
      company_id?: string | null;
      user_id: string;
      entity_type?: string | null;
      entity_id?: string | null;
    }>;
  };
};

export type DeleteTasksMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeleteTasksMutation = {
  __typename?: "Mutation";
  deleteFromcontact_tasksCollection: {
    __typename?: "contact_tasksDeleteResponse";
    records: Array<{ __typename?: "contact_tasks"; id: string }>;
  };
};

export type GetTicketssQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<TicketsFilter>;
}>;

export type GetTicketssQuery = {
  __typename?: "Query";
  ticketsCollection: {
    __typename?: "ticketsConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "ticketsEdge";
      node: {
        __typename?: "tickets";
        id: string;
        ticket_number: number;
        title: string;
        description?: string | null;
        description_preview?: string | null;
        description_s3_key?: string | null;
        description_content_type?: string | null;
        description_byte_size?: number | null;
        contact_id?: string | null;
        company_id: string;
        company_name?: string | null;
        contact_name?: string | null;
        is_software?: boolean | null;
        assigned_to?: string | null;
        created_by: string;
        status?: Ticket_Status | null;
        priority?: Ticket_Priority | null;
        category?: Ticket_Category | null;
        estimated_hours?: number | null;
        actual_hours?: number | null;
        billable_hours?: number | null;
        non_billable_hours?: number | null;
        hourly_rate?: number | null;
        total_cost?: number | null;
        total_billed?: number | null;
        discount_amount?: number | null;
        discount_type?: Discount_Type | null;
        discount_percentage?: number | null;
        sla_hours?: number | null;
        due_date?: string | null;
        resolved_at?: string | null;
        closed_at?: string | null;
        auto_assign?: boolean | null;
        auto_escalate?: boolean | null;
        escalation_level?: number | null;
        last_escalation_at?: string | null;
        reminder_sent?: boolean | null;
        reminder_sent_at?: string | null;
        tags?: Array<string | null> | null;
        internal_notes?: string | null;
        customer_visible_notes?: string | null;
        is_internal?: boolean | null;
        has_time_entries?: boolean | null;
        created_at?: string | null;
        updated_at?: string | null;
        last_follow_up_task_created_at?: string | null;
        last_activity_at?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetTicketsQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetTicketsQuery = {
  __typename?: "Query";
  ticketsCollection: {
    __typename?: "ticketsConnection";
    edges: Array<{
      __typename?: "ticketsEdge";
      node: {
        __typename?: "tickets";
        id: string;
        ticket_number: number;
        title: string;
        description?: string | null;
        description_preview?: string | null;
        description_s3_key?: string | null;
        description_content_type?: string | null;
        description_byte_size?: number | null;
        contact_id?: string | null;
        company_id: string;
        company_name?: string | null;
        contact_name?: string | null;
        is_software?: boolean | null;
        assigned_to?: string | null;
        created_by: string;
        status?: Ticket_Status | null;
        priority?: Ticket_Priority | null;
        category?: Ticket_Category | null;
        estimated_hours?: number | null;
        actual_hours?: number | null;
        billable_hours?: number | null;
        non_billable_hours?: number | null;
        hourly_rate?: number | null;
        total_cost?: number | null;
        total_billed?: number | null;
        discount_amount?: number | null;
        discount_type?: Discount_Type | null;
        discount_percentage?: number | null;
        sla_hours?: number | null;
        due_date?: string | null;
        resolved_at?: string | null;
        closed_at?: string | null;
        auto_assign?: boolean | null;
        auto_escalate?: boolean | null;
        escalation_level?: number | null;
        last_escalation_at?: string | null;
        reminder_sent?: boolean | null;
        reminder_sent_at?: string | null;
        tags?: Array<string | null> | null;
        internal_notes?: string | null;
        customer_visible_notes?: string | null;
        is_internal?: boolean | null;
        has_time_entries?: boolean | null;
        created_at?: string | null;
        updated_at?: string | null;
        last_follow_up_task_created_at?: string | null;
        last_activity_at?: string | null;
      };
    }>;
  };
};

export type CreateTicketsMutationVariables = Exact<{
  input: TicketsInsertInput;
}>;

export type CreateTicketsMutation = {
  __typename?: "Mutation";
  insertIntoticketsCollection?: {
    __typename?: "ticketsInsertResponse";
    records: Array<{
      __typename?: "tickets";
      id: string;
      ticket_number: number;
      title: string;
      description?: string | null;
      description_preview?: string | null;
      description_s3_key?: string | null;
      description_content_type?: string | null;
      description_byte_size?: number | null;
      contact_id?: string | null;
      company_id: string;
      company_name?: string | null;
      contact_name?: string | null;
      is_software?: boolean | null;
      assigned_to?: string | null;
      created_by: string;
      status?: Ticket_Status | null;
      priority?: Ticket_Priority | null;
      category?: Ticket_Category | null;
      estimated_hours?: number | null;
      actual_hours?: number | null;
      billable_hours?: number | null;
      non_billable_hours?: number | null;
      hourly_rate?: number | null;
      total_cost?: number | null;
      total_billed?: number | null;
      discount_amount?: number | null;
      discount_type?: Discount_Type | null;
      discount_percentage?: number | null;
      sla_hours?: number | null;
      due_date?: string | null;
      resolved_at?: string | null;
      closed_at?: string | null;
      auto_assign?: boolean | null;
      auto_escalate?: boolean | null;
      escalation_level?: number | null;
      last_escalation_at?: string | null;
      reminder_sent?: boolean | null;
      reminder_sent_at?: string | null;
      tags?: Array<string | null> | null;
      internal_notes?: string | null;
      customer_visible_notes?: string | null;
      is_internal?: boolean | null;
      has_time_entries?: boolean | null;
      created_at?: string | null;
      updated_at?: string | null;
      last_follow_up_task_created_at?: string | null;
      last_activity_at?: string | null;
    }>;
  } | null;
};

export type UpdateTicketsMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  input: TicketsUpdateInput;
}>;

export type UpdateTicketsMutation = {
  __typename?: "Mutation";
  updateticketsCollection: {
    __typename?: "ticketsUpdateResponse";
    records: Array<{
      __typename?: "tickets";
      id: string;
      ticket_number: number;
      title: string;
      description?: string | null;
      description_preview?: string | null;
      description_s3_key?: string | null;
      description_content_type?: string | null;
      description_byte_size?: number | null;
      contact_id?: string | null;
      company_id: string;
      company_name?: string | null;
      contact_name?: string | null;
      is_software?: boolean | null;
      assigned_to?: string | null;
      created_by: string;
      status?: Ticket_Status | null;
      priority?: Ticket_Priority | null;
      category?: Ticket_Category | null;
      estimated_hours?: number | null;
      actual_hours?: number | null;
      billable_hours?: number | null;
      non_billable_hours?: number | null;
      hourly_rate?: number | null;
      total_cost?: number | null;
      total_billed?: number | null;
      discount_amount?: number | null;
      discount_type?: Discount_Type | null;
      discount_percentage?: number | null;
      sla_hours?: number | null;
      due_date?: string | null;
      resolved_at?: string | null;
      closed_at?: string | null;
      auto_assign?: boolean | null;
      auto_escalate?: boolean | null;
      escalation_level?: number | null;
      last_escalation_at?: string | null;
      reminder_sent?: boolean | null;
      reminder_sent_at?: string | null;
      tags?: Array<string | null> | null;
      internal_notes?: string | null;
      customer_visible_notes?: string | null;
      is_internal?: boolean | null;
      has_time_entries?: boolean | null;
      created_at?: string | null;
      updated_at?: string | null;
      last_follow_up_task_created_at?: string | null;
      last_activity_at?: string | null;
    }>;
  };
};

export type DeleteTicketsMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeleteTicketsMutation = {
  __typename?: "Mutation";
  deleteFromticketsCollection: {
    __typename?: "ticketsDeleteResponse";
    records: Array<{ __typename?: "tickets"; id: string }>;
  };
};

export type GetTimeEntriessQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Time_EntriesFilter>;
}>;

export type GetTimeEntriessQuery = {
  __typename?: "Query";
  time_entriesCollection: {
    __typename?: "time_entriesConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "time_entriesEdge";
      node: {
        __typename?: "time_entries";
        id: string;
        ticket_id?: string | null;
        ticket_number?: number | null;
        ticket_title?: string | null;
        company_id?: string | null;
        company_name?: string | null;
        contact_name?: string | null;
        is_software?: boolean | null;
        user_id: string;
        user_name?: string | null;
        description: string;
        hours: number;
        entry_type?: Time_Entry_Type | null;
        billable_rate?: number | null;
        date_worked: string;
        start_time?: string | null;
        end_time?: string | null;
        is_approved?: boolean | null;
        approved_by?: string | null;
        approved_at?: string | null;
        created_at?: string | null;
        updated_at?: string | null;
        last_follow_up_task_created_at?: string | null;
        sync_status?: Sync_Status | null;
        quickbooks_id?: string | null;
        synced_at?: string | null;
        quickbooks_employee_ref?: string | null;
        quickbooks_customer_ref?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetTimeEntriesQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetTimeEntriesQuery = {
  __typename?: "Query";
  time_entriesCollection: {
    __typename?: "time_entriesConnection";
    edges: Array<{
      __typename?: "time_entriesEdge";
      node: {
        __typename?: "time_entries";
        id: string;
        ticket_id?: string | null;
        ticket_number?: number | null;
        ticket_title?: string | null;
        company_id?: string | null;
        company_name?: string | null;
        contact_name?: string | null;
        is_software?: boolean | null;
        user_id: string;
        user_name?: string | null;
        description: string;
        hours: number;
        entry_type?: Time_Entry_Type | null;
        billable_rate?: number | null;
        date_worked: string;
        start_time?: string | null;
        end_time?: string | null;
        is_approved?: boolean | null;
        approved_by?: string | null;
        approved_at?: string | null;
        created_at?: string | null;
        updated_at?: string | null;
        last_follow_up_task_created_at?: string | null;
        sync_status?: Sync_Status | null;
        quickbooks_id?: string | null;
        synced_at?: string | null;
        quickbooks_employee_ref?: string | null;
        quickbooks_customer_ref?: string | null;
      };
    }>;
  };
};

export type GetClientTimeEntriessQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<Time_EntriesFilter>;
}>;

export type GetClientTimeEntriessQuery = {
  __typename?: "Query";
  time_entriesCollection: {
    __typename?: "time_entriesConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "time_entriesEdge";
      node: {
        __typename?: "time_entries";
        id: string;
        ticket_id?: string | null;
        ticket_number?: number | null;
        ticket_title?: string | null;
        company_id?: string | null;
        company_name?: string | null;
        description: string;
        hours: number;
        entry_type?: Time_Entry_Type | null;
        date_worked: string;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetClientTimeEntriesQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetClientTimeEntriesQuery = {
  __typename?: "Query";
  time_entriesCollection: {
    __typename?: "time_entriesConnection";
    edges: Array<{
      __typename?: "time_entriesEdge";
      node: {
        __typename?: "time_entries";
        id: string;
        ticket_id?: string | null;
        ticket_number?: number | null;
        ticket_title?: string | null;
        company_id?: string | null;
        company_name?: string | null;
        description: string;
        hours: number;
        entry_type?: Time_Entry_Type | null;
        date_worked: string;
      };
    }>;
  };
};

export type CreateTimeEntriesMutationVariables = Exact<{
  input: Time_EntriesInsertInput;
}>;

export type CreateTimeEntriesMutation = {
  __typename?: "Mutation";
  insertIntotime_entriesCollection?: {
    __typename?: "time_entriesInsertResponse";
    records: Array<{
      __typename?: "time_entries";
      id: string;
      ticket_id?: string | null;
      company_id?: string | null;
      user_id: string;
      description: string;
      hours: number;
      entry_type?: Time_Entry_Type | null;
      billable_rate?: number | null;
      date_worked: string;
      start_time?: string | null;
      end_time?: string | null;
      is_approved?: boolean | null;
      approved_by?: string | null;
      approved_at?: string | null;
      created_at?: string | null;
      updated_at?: string | null;
      last_follow_up_task_created_at?: string | null;
      sync_status?: Sync_Status | null;
      quickbooks_id?: string | null;
      synced_at?: string | null;
      quickbooks_employee_ref?: string | null;
      quickbooks_customer_ref?: string | null;
    }>;
  } | null;
};

export type UpdateTimeEntriesMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  input: Time_EntriesUpdateInput;
}>;

export type UpdateTimeEntriesMutation = {
  __typename?: "Mutation";
  updatetime_entriesCollection: {
    __typename?: "time_entriesUpdateResponse";
    records: Array<{
      __typename?: "time_entries";
      id: string;
      ticket_id?: string | null;
      company_id?: string | null;
      user_id: string;
      description: string;
      hours: number;
      entry_type?: Time_Entry_Type | null;
      billable_rate?: number | null;
      date_worked: string;
      start_time?: string | null;
      end_time?: string | null;
      is_approved?: boolean | null;
      approved_by?: string | null;
      approved_at?: string | null;
      created_at?: string | null;
      updated_at?: string | null;
      last_follow_up_task_created_at?: string | null;
      sync_status?: Sync_Status | null;
      quickbooks_id?: string | null;
      synced_at?: string | null;
      quickbooks_employee_ref?: string | null;
      quickbooks_customer_ref?: string | null;
    }>;
  };
};

export type DeleteTimeEntriesMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeleteTimeEntriesMutation = {
  __typename?: "Mutation";
  deleteFromtime_entriesCollection: {
    __typename?: "time_entriesDeleteResponse";
    records: Array<{ __typename?: "time_entries"; id: string }>;
  };
};

export type GetUserssQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<App_UsersFilter>;
}>;

export type GetUserssQuery = {
  __typename?: "Query";
  app_usersCollection: {
    __typename?: "app_usersConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "app_usersEdge";
      node: {
        __typename?: "app_users";
        id: string;
        email: string;
        first_name?: string | null;
        last_name?: string | null;
        role_id: string;
        is_active?: boolean | null;
        created_at?: string | null;
        updated_at?: string | null;
        quickbooks_access_token?: string | null;
        quickbooks_refresh_token?: string | null;
        quickbooks_realm_id?: string | null;
        quickbooks_environment?: string | null;
        quickbooks_token_expires_at?: string | null;
        quickbooks_connected_at?: string | null;
        quickbooks_last_sync_at?: string | null;
        quickbooks_employee_ref?: string | null;
        quickbooks_employee_name?: string | null;
        quickbooks_connections?: Record<string, any> | null;
        quickbooks_active_realm_id?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type SearchUsersQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type SearchUsersQuery = {
  __typename?: "Query";
  app_usersCollection: {
    __typename?: "app_usersConnection";
    totalCount: number;
    edges: Array<{
      __typename?: "app_usersEdge";
      node: {
        __typename?: "app_users";
        id: string;
        email: string;
        first_name?: string | null;
        last_name?: string | null;
        role_id: string;
        is_active?: boolean | null;
        created_at?: string | null;
        updated_at?: string | null;
      };
    }>;
    pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetUsersQueryVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type GetUsersQuery = {
  __typename?: "Query";
  app_usersCollection: {
    __typename?: "app_usersConnection";
    edges: Array<{
      __typename?: "app_usersEdge";
      node: {
        __typename?: "app_users";
        id: string;
        email: string;
        first_name?: string | null;
        last_name?: string | null;
        role_id: string;
        is_active?: boolean | null;
        created_at?: string | null;
        updated_at?: string | null;
        quickbooks_access_token?: string | null;
        quickbooks_refresh_token?: string | null;
        quickbooks_realm_id?: string | null;
        quickbooks_environment?: string | null;
        quickbooks_token_expires_at?: string | null;
        quickbooks_connected_at?: string | null;
        quickbooks_last_sync_at?: string | null;
        quickbooks_employee_ref?: string | null;
        quickbooks_employee_name?: string | null;
        quickbooks_connections?: Record<string, any> | null;
        quickbooks_active_realm_id?: string | null;
        meridian_default_email_connection_id?: string | null;
        meridian_default_email_provider?: string | null;
      };
    }>;
  };
};

export type CreateUsersMutationVariables = Exact<{
  input: App_UsersInsertInput;
}>;

export type CreateUsersMutation = {
  __typename?: "Mutation";
  insertIntoapp_usersCollection?: {
    __typename?: "app_usersInsertResponse";
    records: Array<{
      __typename?: "app_users";
      id: string;
      email: string;
      first_name?: string | null;
      last_name?: string | null;
      role_id: string;
      is_active?: boolean | null;
      created_at?: string | null;
      updated_at?: string | null;
      quickbooks_access_token?: string | null;
      quickbooks_refresh_token?: string | null;
      quickbooks_realm_id?: string | null;
      quickbooks_environment?: string | null;
      quickbooks_token_expires_at?: string | null;
      quickbooks_connected_at?: string | null;
      quickbooks_last_sync_at?: string | null;
      quickbooks_employee_ref?: string | null;
      quickbooks_employee_name?: string | null;
      quickbooks_connections?: Record<string, any> | null;
      quickbooks_active_realm_id?: string | null;
    }>;
  } | null;
};

export type UpdateUsersMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
  input: App_UsersUpdateInput;
}>;

export type UpdateUsersMutation = {
  __typename?: "Mutation";
  updateapp_usersCollection: {
    __typename?: "app_usersUpdateResponse";
    records: Array<{
      __typename?: "app_users";
      id: string;
      email: string;
      first_name?: string | null;
      last_name?: string | null;
      role_id: string;
      is_active?: boolean | null;
      created_at?: string | null;
      updated_at?: string | null;
      quickbooks_access_token?: string | null;
      quickbooks_refresh_token?: string | null;
      quickbooks_realm_id?: string | null;
      quickbooks_environment?: string | null;
      quickbooks_token_expires_at?: string | null;
      quickbooks_connected_at?: string | null;
      quickbooks_last_sync_at?: string | null;
      quickbooks_employee_ref?: string | null;
      quickbooks_employee_name?: string | null;
      quickbooks_connections?: Record<string, any> | null;
      quickbooks_active_realm_id?: string | null;
    }>;
  };
};

export type DeleteUsersMutationVariables = Exact<{
  id: Scalars["UUID"]["input"];
}>;

export type DeleteUsersMutation = {
  __typename?: "Mutation";
  deleteFromapp_usersCollection: {
    __typename?: "app_usersDeleteResponse";
    records: Array<{ __typename?: "app_users"; id: string }>;
  };
};

export const ContractFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContractFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "contracts" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "esignatures_contract_id" } },
          { kind: "Field", name: { kind: "Name", value: "template_name" } },
          { kind: "Field", name: { kind: "Name", value: "document_name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "delivery_mode" } },
          { kind: "Field", name: { kind: "Name", value: "recipient_name" } },
          { kind: "Field", name: { kind: "Name", value: "recipient_email" } },
          { kind: "Field", name: { kind: "Name", value: "signing_url" } },
          { kind: "Field", name: { kind: "Name", value: "signed_pdf_url" } },
          { kind: "Field", name: { kind: "Name", value: "decline_reason" } },
          { kind: "Field", name: { kind: "Name", value: "sent_by_user_id" } },
          { kind: "Field", name: { kind: "Name", value: "contact_id" } },
          { kind: "Field", name: { kind: "Name", value: "company_id" } },
          { kind: "Field", name: { kind: "Name", value: "deal_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deals" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "secure_link_id" } },
          { kind: "Field", name: { kind: "Name", value: "metadata" } },
          { kind: "Field", name: { kind: "Name", value: "sent_at" } },
          { kind: "Field", name: { kind: "Name", value: "last_event_at" } },
          { kind: "Field", name: { kind: "Name", value: "signed_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
          { kind: "Field", name: { kind: "Name", value: "term_months" } },
          { kind: "Field", name: { kind: "Name", value: "expires_at" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContractFieldsFragment, unknown>;
export const EmailCampaignFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmailCampaignFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "email_campaigns" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "template_id" } },
          { kind: "Field", name: { kind: "Name", value: "body_html" } },
          { kind: "Field", name: { kind: "Name", value: "from_email" } },
          { kind: "Field", name: { kind: "Name", value: "from_name" } },
          { kind: "Field", name: { kind: "Name", value: "reply_to" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_at" } },
          { kind: "Field", name: { kind: "Name", value: "sent_at" } },
          { kind: "Field", name: { kind: "Name", value: "audience_id" } },
          { kind: "Field", name: { kind: "Name", value: "stats" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmailCampaignFieldsFragment, unknown>;
export const SocialMediaPostFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SocialMediaPostFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "social_media_posts" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "media_kind" } },
          { kind: "Field", name: { kind: "Name", value: "media_url" } },
          { kind: "Field", name: { kind: "Name", value: "thumbnail_url" } },
          { kind: "Field", name: { kind: "Name", value: "drive_file_id" } },
          { kind: "Field", name: { kind: "Name", value: "drive_file_name" } },
          { kind: "Field", name: { kind: "Name", value: "drive_folder_id" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "youtube" } },
          { kind: "Field", name: { kind: "Name", value: "platforms" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_at" } },
          { kind: "Field", name: { kind: "Name", value: "published_at" } },
          { kind: "Field", name: { kind: "Name", value: "results" } },
          { kind: "Field", name: { kind: "Name", value: "error_summary" } },
          { kind: "Field", name: { kind: "Name", value: "contact_id" } },
          { kind: "Field", name: { kind: "Name", value: "company_id" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SocialMediaPostFieldsFragment, unknown>;
export const GetCommunicationssDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCommunicationss" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "communicationsFilter" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "communicationsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_name" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            { kind: "Field", name: { kind: "Name", value: "type_id" } },
                            { kind: "Field", name: { kind: "Name", value: "type_label" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "body_preview" } },
                            { kind: "Field", name: { kind: "Name", value: "body_s3_key" } },
                            { kind: "Field", name: { kind: "Name", value: "direction" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "external_id" } },
                            { kind: "Field", name: { kind: "Name", value: "occurred_at" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "metadata" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCommunicationssQuery, GetCommunicationssQueryVariables>;
export const GetCommunicationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCommunications" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "communicationsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_name" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            { kind: "Field", name: { kind: "Name", value: "type_id" } },
                            { kind: "Field", name: { kind: "Name", value: "type_label" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "body" } },
                            { kind: "Field", name: { kind: "Name", value: "body_preview" } },
                            { kind: "Field", name: { kind: "Name", value: "body_s3_key" } },
                            { kind: "Field", name: { kind: "Name", value: "direction" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "external_id" } },
                            { kind: "Field", name: { kind: "Name", value: "occurred_at" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "metadata" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCommunicationsQuery, GetCommunicationsQueryVariables>;
export const CreateCommunicationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateCommunications" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "communicationsInsertInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntocommunicationsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "Variable", name: { kind: "Name", value: "input" } }],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                      { kind: "Field", name: { kind: "Name", value: "company_id" } },
                      { kind: "Field", name: { kind: "Name", value: "user_id" } },
                      { kind: "Field", name: { kind: "Name", value: "type_id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "body" } },
                      { kind: "Field", name: { kind: "Name", value: "direction" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "external_id" } },
                      { kind: "Field", name: { kind: "Name", value: "occurred_at" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                      { kind: "Field", name: { kind: "Name", value: "metadata" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCommunicationsMutation, CreateCommunicationsMutationVariables>;
export const UpdateCommunicationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateCommunications" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "communicationsUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatecommunicationsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                      { kind: "Field", name: { kind: "Name", value: "company_id" } },
                      { kind: "Field", name: { kind: "Name", value: "user_id" } },
                      { kind: "Field", name: { kind: "Name", value: "type_id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "body" } },
                      { kind: "Field", name: { kind: "Name", value: "direction" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "external_id" } },
                      { kind: "Field", name: { kind: "Name", value: "occurred_at" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                      { kind: "Field", name: { kind: "Name", value: "metadata" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCommunicationsMutation, UpdateCommunicationsMutationVariables>;
export const DeleteCommunicationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteCommunications" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFromcommunicationsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteCommunicationsMutation, DeleteCommunicationsMutationVariables>;
export const GetRecentCommunicationsForFollowUpDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRecentCommunicationsForFollowUp" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "since" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Datetime" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "communicationsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "occurred_at" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "gte" },
                            value: { kind: "Variable", name: { kind: "Name", value: "since" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "occurred_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_name" } },
                            { kind: "Field", name: { kind: "Name", value: "type_id" } },
                            { kind: "Field", name: { kind: "Name", value: "type_label" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "body_preview" } },
                            { kind: "Field", name: { kind: "Name", value: "occurred_at" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetRecentCommunicationsForFollowUpQuery,
  GetRecentCommunicationsForFollowUpQueryVariables
>;
export const GetCommunicationTypesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCommunicationTypes" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "communication_typesCollection" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "key" } },
                            { kind: "Field", name: { kind: "Name", value: "label" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "is_active" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCommunicationTypesQuery, GetCommunicationTypesQueryVariables>;
export const GetCompaniessDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCompaniess" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "companiesFilter" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "companiesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "normalized_name" } },
                            { kind: "Field", name: { kind: "Name", value: "name_aliases" } },
                            { kind: "Field", name: { kind: "Name", value: "contract_type" } },
                            { kind: "Field", name: { kind: "Name", value: "hourly_rate" } },
                            { kind: "Field", name: { kind: "Name", value: "monthly_rate" } },
                            { kind: "Field", name: { kind: "Name", value: "payment_terms" } },
                            { kind: "Field", name: { kind: "Name", value: "tax_id" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "notes" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_customer_ref" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_customer_name" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "quickbooks_sync_at" } },
                            { kind: "Field", name: { kind: "Name", value: "website" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "uptime_monitoring_enabled" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "domain" } },
                            { kind: "Field", name: { kind: "Name", value: "industry" } },
                            { kind: "Field", name: { kind: "Name", value: "address" } },
                            { kind: "Field", name: { kind: "Name", value: "city" } },
                            { kind: "Field", name: { kind: "Name", value: "state" } },
                            { kind: "Field", name: { kind: "Name", value: "zip_code" } },
                            { kind: "Field", name: { kind: "Name", value: "country" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "current_technologies" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "social_links" } },
                            { kind: "Field", name: { kind: "Name", value: "employee_size" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "technical_identifiers" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "schedule_status" } },
                            { kind: "Field", name: { kind: "Name", value: "budget_status" } },
                            { kind: "Field", name: { kind: "Name", value: "scope_status" } },
                            { kind: "Field", name: { kind: "Name", value: "alignment_status" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last_follow_up_task_created_at" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "last_contacted_at" } },
                            { kind: "Field", name: { kind: "Name", value: "has_active_deals" } },
                            { kind: "Field", name: { kind: "Name", value: "active_deal_count" } },
                            { kind: "Field", name: { kind: "Name", value: "total_deal_value" } },
                            { kind: "Field", name: { kind: "Name", value: "has_signed_contract" } },
                            { kind: "Field", name: { kind: "Name", value: "contract_expires_at" } },
                            { kind: "Field", name: { kind: "Name", value: "has_open_tickets" } },
                            { kind: "Field", name: { kind: "Name", value: "open_ticket_count" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "active_contact_count" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "organization_revenue" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "organization_phone" } },
                            { kind: "Field", name: { kind: "Name", value: "organization_email" } },
                            { kind: "Field", name: { kind: "Name", value: "phone_aliases" } },
                            { kind: "Field", name: { kind: "Name", value: "email_aliases" } },
                            { kind: "Field", name: { kind: "Name", value: "line_contact_id" } },
                            { kind: "Field", name: { kind: "Name", value: "last_enriched_at" } },
                            { kind: "Field", name: { kind: "Name", value: "slack_channel_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "google_drive_folder_id" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompaniessQuery, GetCompaniessQueryVariables>;
export const GetCompanyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCompany" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "companiesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "normalized_name" } },
                            { kind: "Field", name: { kind: "Name", value: "name_aliases" } },
                            { kind: "Field", name: { kind: "Name", value: "contract_type" } },
                            { kind: "Field", name: { kind: "Name", value: "hourly_rate" } },
                            { kind: "Field", name: { kind: "Name", value: "monthly_rate" } },
                            { kind: "Field", name: { kind: "Name", value: "payment_terms" } },
                            { kind: "Field", name: { kind: "Name", value: "tax_id" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "notes" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_customer_ref" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_customer_name" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "quickbooks_sync_at" } },
                            { kind: "Field", name: { kind: "Name", value: "website" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "uptime_monitoring_enabled" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "domain" } },
                            { kind: "Field", name: { kind: "Name", value: "industry" } },
                            { kind: "Field", name: { kind: "Name", value: "address" } },
                            { kind: "Field", name: { kind: "Name", value: "city" } },
                            { kind: "Field", name: { kind: "Name", value: "state" } },
                            { kind: "Field", name: { kind: "Name", value: "zip_code" } },
                            { kind: "Field", name: { kind: "Name", value: "country" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "current_technologies" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "social_links" } },
                            { kind: "Field", name: { kind: "Name", value: "employee_size" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "technical_identifiers" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "schedule_status" } },
                            { kind: "Field", name: { kind: "Name", value: "budget_status" } },
                            { kind: "Field", name: { kind: "Name", value: "scope_status" } },
                            { kind: "Field", name: { kind: "Name", value: "alignment_status" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last_follow_up_task_created_at" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "last_contacted_at" } },
                            { kind: "Field", name: { kind: "Name", value: "has_active_deals" } },
                            { kind: "Field", name: { kind: "Name", value: "active_deal_count" } },
                            { kind: "Field", name: { kind: "Name", value: "total_deal_value" } },
                            { kind: "Field", name: { kind: "Name", value: "has_signed_contract" } },
                            { kind: "Field", name: { kind: "Name", value: "contract_expires_at" } },
                            { kind: "Field", name: { kind: "Name", value: "has_open_tickets" } },
                            { kind: "Field", name: { kind: "Name", value: "open_ticket_count" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "active_contact_count" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "organization_revenue" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "organization_phone" } },
                            { kind: "Field", name: { kind: "Name", value: "organization_email" } },
                            { kind: "Field", name: { kind: "Name", value: "phone_aliases" } },
                            { kind: "Field", name: { kind: "Name", value: "email_aliases" } },
                            { kind: "Field", name: { kind: "Name", value: "line_contact_id" } },
                            { kind: "Field", name: { kind: "Name", value: "last_enriched_at" } },
                            { kind: "Field", name: { kind: "Name", value: "slack_channel_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "google_drive_folder_id" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompanyQuery, GetCompanyQueryVariables>;
export const CreateCompanyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateCompany" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "companiesInsertInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntocompaniesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "Variable", name: { kind: "Name", value: "input" } }],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "normalized_name" } },
                      { kind: "Field", name: { kind: "Name", value: "name_aliases" } },
                      { kind: "Field", name: { kind: "Name", value: "tags" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const UpdateCompanyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateCompany" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "companiesUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatecompaniesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "normalized_name" } },
                      { kind: "Field", name: { kind: "Name", value: "name_aliases" } },
                      { kind: "Field", name: { kind: "Name", value: "contract_type" } },
                      { kind: "Field", name: { kind: "Name", value: "hourly_rate" } },
                      { kind: "Field", name: { kind: "Name", value: "monthly_rate" } },
                      { kind: "Field", name: { kind: "Name", value: "payment_terms" } },
                      { kind: "Field", name: { kind: "Name", value: "tax_id" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "notes" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_customer_ref" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_customer_name" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_sync_at" } },
                      { kind: "Field", name: { kind: "Name", value: "website" } },
                      { kind: "Field", name: { kind: "Name", value: "uptime_monitoring_enabled" } },
                      { kind: "Field", name: { kind: "Name", value: "domain" } },
                      { kind: "Field", name: { kind: "Name", value: "industry" } },
                      { kind: "Field", name: { kind: "Name", value: "address" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      { kind: "Field", name: { kind: "Name", value: "zip_code" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                      { kind: "Field", name: { kind: "Name", value: "current_technologies" } },
                      { kind: "Field", name: { kind: "Name", value: "social_links" } },
                      { kind: "Field", name: { kind: "Name", value: "employee_size" } },
                      { kind: "Field", name: { kind: "Name", value: "technical_identifiers" } },
                      { kind: "Field", name: { kind: "Name", value: "schedule_status" } },
                      { kind: "Field", name: { kind: "Name", value: "budget_status" } },
                      { kind: "Field", name: { kind: "Name", value: "scope_status" } },
                      { kind: "Field", name: { kind: "Name", value: "alignment_status" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "last_follow_up_task_created_at" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "last_contacted_at" } },
                      { kind: "Field", name: { kind: "Name", value: "has_active_deals" } },
                      { kind: "Field", name: { kind: "Name", value: "active_deal_count" } },
                      { kind: "Field", name: { kind: "Name", value: "total_deal_value" } },
                      { kind: "Field", name: { kind: "Name", value: "has_signed_contract" } },
                      { kind: "Field", name: { kind: "Name", value: "contract_expires_at" } },
                      { kind: "Field", name: { kind: "Name", value: "has_open_tickets" } },
                      { kind: "Field", name: { kind: "Name", value: "open_ticket_count" } },
                      { kind: "Field", name: { kind: "Name", value: "active_contact_count" } },
                      { kind: "Field", name: { kind: "Name", value: "organization_revenue" } },
                      { kind: "Field", name: { kind: "Name", value: "organization_phone" } },
                      { kind: "Field", name: { kind: "Name", value: "organization_email" } },
                      { kind: "Field", name: { kind: "Name", value: "phone_aliases" } },
                      { kind: "Field", name: { kind: "Name", value: "email_aliases" } },
                      { kind: "Field", name: { kind: "Name", value: "line_contact_id" } },
                      { kind: "Field", name: { kind: "Name", value: "last_enriched_at" } },
                      { kind: "Field", name: { kind: "Name", value: "slack_channel_id" } },
                      { kind: "Field", name: { kind: "Name", value: "google_drive_folder_id" } },
                      { kind: "Field", name: { kind: "Name", value: "tags" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const GetCompanyTechnicalIdentifiersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCompanyTechnicalIdentifiers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "companiesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "technical_identifiers" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCompanyTechnicalIdentifiersQuery,
  GetCompanyTechnicalIdentifiersQueryVariables
>;
export const DeleteCompanyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteCompany" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFromcompaniesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteCompanyMutation, DeleteCompanyMutationVariables>;
export const GetCompaniesWithNoTicketsThisMonthDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCompaniesWithNoTicketsThisMonth" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "companiesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "name" },
                          value: { kind: "EnumValue", value: "AscNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "normalized_name" } },
                            { kind: "Field", name: { kind: "Name", value: "name_aliases" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ticketsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "10000" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCompaniesWithNoTicketsThisMonthQuery,
  GetCompaniesWithNoTicketsThisMonthQueryVariables
>;
export const GetContactssDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetContactss" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "contactsFilter" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contactsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "companies" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "industry" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "email_aliases" } },
                            { kind: "Field", name: { kind: "Name", value: "phone" } },
                            { kind: "Field", name: { kind: "Name", value: "phone_aliases" } },
                            { kind: "Field", name: { kind: "Name", value: "address" } },
                            { kind: "Field", name: { kind: "Name", value: "city" } },
                            { kind: "Field", name: { kind: "Name", value: "state" } },
                            { kind: "Field", name: { kind: "Name", value: "zip_code" } },
                            { kind: "Field", name: { kind: "Name", value: "country" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "lifecycle_stage" } },
                            { kind: "Field", name: { kind: "Name", value: "source" } },
                            { kind: "Field", name: { kind: "Name", value: "last_contacted_at" } },
                            { kind: "Field", name: { kind: "Name", value: "avatar_url" } },
                            { kind: "Field", name: { kind: "Name", value: "social_links" } },
                            { kind: "Field", name: { kind: "Name", value: "custom_fields" } },
                            { kind: "Field", name: { kind: "Name", value: "is_active" } },
                            { kind: "Field", name: { kind: "Name", value: "is_company_line" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_by" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "app_users" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                  { kind: "Field", name: { kind: "Name", value: "first_name" } },
                                  { kind: "Field", name: { kind: "Name", value: "last_name" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "notes" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last_follow_up_task_created_at" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "has_active_deals" } },
                            { kind: "Field", name: { kind: "Name", value: "active_deal_count" } },
                            { kind: "Field", name: { kind: "Name", value: "has_signed_contract" } },
                            { kind: "Field", name: { kind: "Name", value: "contract_expires_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetContactssQuery, GetContactssQueryVariables>;
export const GetContactsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetContacts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contactsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "companies" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "organization_phone" },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "phone_aliases" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "organization_email" },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "email_aliases" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "line_contact_id" },
                                  },
                                  { kind: "Field", name: { kind: "Name", value: "website" } },
                                  { kind: "Field", name: { kind: "Name", value: "industry" } },
                                  { kind: "Field", name: { kind: "Name", value: "contract_type" } },
                                  { kind: "Field", name: { kind: "Name", value: "hourly_rate" } },
                                  { kind: "Field", name: { kind: "Name", value: "monthly_rate" } },
                                  { kind: "Field", name: { kind: "Name", value: "payment_terms" } },
                                  { kind: "Field", name: { kind: "Name", value: "tax_id" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "email_aliases" } },
                            { kind: "Field", name: { kind: "Name", value: "phone" } },
                            { kind: "Field", name: { kind: "Name", value: "phone_aliases" } },
                            { kind: "Field", name: { kind: "Name", value: "address" } },
                            { kind: "Field", name: { kind: "Name", value: "city" } },
                            { kind: "Field", name: { kind: "Name", value: "state" } },
                            { kind: "Field", name: { kind: "Name", value: "zip_code" } },
                            { kind: "Field", name: { kind: "Name", value: "country" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "lifecycle_stage" } },
                            { kind: "Field", name: { kind: "Name", value: "source" } },
                            { kind: "Field", name: { kind: "Name", value: "last_contacted_at" } },
                            { kind: "Field", name: { kind: "Name", value: "avatar_url" } },
                            { kind: "Field", name: { kind: "Name", value: "social_links" } },
                            { kind: "Field", name: { kind: "Name", value: "custom_fields" } },
                            { kind: "Field", name: { kind: "Name", value: "is_active" } },
                            { kind: "Field", name: { kind: "Name", value: "is_company_line" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_by" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "app_users" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                  { kind: "Field", name: { kind: "Name", value: "first_name" } },
                                  { kind: "Field", name: { kind: "Name", value: "last_name" } },
                                ],
                              },
                            },
                            { kind: "Field", name: { kind: "Name", value: "notes" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last_follow_up_task_created_at" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "has_active_deals" } },
                            { kind: "Field", name: { kind: "Name", value: "active_deal_count" } },
                            { kind: "Field", name: { kind: "Name", value: "has_signed_contract" } },
                            { kind: "Field", name: { kind: "Name", value: "contract_expires_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetContactsQuery, GetContactsQueryVariables>;
export const CreateContactsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateContacts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "contactsInsertInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntocontactsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "Variable", name: { kind: "Name", value: "input" } }],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "company_name" } },
                      { kind: "Field", name: { kind: "Name", value: "company_id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "email_aliases" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      { kind: "Field", name: { kind: "Name", value: "phone_aliases" } },
                      { kind: "Field", name: { kind: "Name", value: "address" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      { kind: "Field", name: { kind: "Name", value: "zip_code" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "tags" } },
                      { kind: "Field", name: { kind: "Name", value: "lifecycle_stage" } },
                      { kind: "Field", name: { kind: "Name", value: "source" } },
                      { kind: "Field", name: { kind: "Name", value: "last_contacted_at" } },
                      { kind: "Field", name: { kind: "Name", value: "avatar_url" } },
                      { kind: "Field", name: { kind: "Name", value: "social_links" } },
                      { kind: "Field", name: { kind: "Name", value: "custom_fields" } },
                      { kind: "Field", name: { kind: "Name", value: "is_active" } },
                      { kind: "Field", name: { kind: "Name", value: "is_company_line" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                      { kind: "Field", name: { kind: "Name", value: "created_by" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_by" } },
                      { kind: "Field", name: { kind: "Name", value: "notes" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "last_follow_up_task_created_at" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "has_active_deals" } },
                      { kind: "Field", name: { kind: "Name", value: "active_deal_count" } },
                      { kind: "Field", name: { kind: "Name", value: "has_signed_contract" } },
                      { kind: "Field", name: { kind: "Name", value: "contract_expires_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateContactsMutation, CreateContactsMutationVariables>;
export const UpdateContactsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateContacts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "contactsUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatecontactsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "company_name" } },
                      { kind: "Field", name: { kind: "Name", value: "company_id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "email_aliases" } },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      { kind: "Field", name: { kind: "Name", value: "phone_aliases" } },
                      { kind: "Field", name: { kind: "Name", value: "address" } },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      { kind: "Field", name: { kind: "Name", value: "zip_code" } },
                      { kind: "Field", name: { kind: "Name", value: "country" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "tags" } },
                      { kind: "Field", name: { kind: "Name", value: "lifecycle_stage" } },
                      { kind: "Field", name: { kind: "Name", value: "source" } },
                      { kind: "Field", name: { kind: "Name", value: "last_contacted_at" } },
                      { kind: "Field", name: { kind: "Name", value: "avatar_url" } },
                      { kind: "Field", name: { kind: "Name", value: "social_links" } },
                      { kind: "Field", name: { kind: "Name", value: "custom_fields" } },
                      { kind: "Field", name: { kind: "Name", value: "is_active" } },
                      { kind: "Field", name: { kind: "Name", value: "is_company_line" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                      { kind: "Field", name: { kind: "Name", value: "created_by" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_by" } },
                      { kind: "Field", name: { kind: "Name", value: "notes" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "last_follow_up_task_created_at" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "has_active_deals" } },
                      { kind: "Field", name: { kind: "Name", value: "active_deal_count" } },
                      { kind: "Field", name: { kind: "Name", value: "has_signed_contract" } },
                      { kind: "Field", name: { kind: "Name", value: "contract_expires_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateContactsMutation, UpdateContactsMutationVariables>;
export const DeleteContactsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteContacts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFromcontactsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteContactsMutation, DeleteContactsMutationVariables>;
export const GetContactsWithNoTicketsThisMonthDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetContactsWithNoTicketsThisMonth" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contactsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "name" },
                          value: { kind: "EnumValue", value: "AscNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "phone" } },
                            { kind: "Field", name: { kind: "Name", value: "phone_aliases" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "is_active" } },
                            { kind: "Field", name: { kind: "Name", value: "is_company_line" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ticketsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "10000" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetContactsWithNoTicketsThisMonthQuery,
  GetContactsWithNoTicketsThisMonthQueryVariables
>;
export const GetContactsEmailsByFilterDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetContactsEmailsByFilter" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "contactsFilter" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contactsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetContactsEmailsByFilterQuery,
  GetContactsEmailsByFilterQueryVariables
>;
export const GetContractsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetContracts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "contractsFilter" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "contractsOrderBy" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contractsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContractFields" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContractFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "contracts" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "esignatures_contract_id" } },
          { kind: "Field", name: { kind: "Name", value: "template_name" } },
          { kind: "Field", name: { kind: "Name", value: "document_name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "delivery_mode" } },
          { kind: "Field", name: { kind: "Name", value: "recipient_name" } },
          { kind: "Field", name: { kind: "Name", value: "recipient_email" } },
          { kind: "Field", name: { kind: "Name", value: "signing_url" } },
          { kind: "Field", name: { kind: "Name", value: "signed_pdf_url" } },
          { kind: "Field", name: { kind: "Name", value: "decline_reason" } },
          { kind: "Field", name: { kind: "Name", value: "sent_by_user_id" } },
          { kind: "Field", name: { kind: "Name", value: "contact_id" } },
          { kind: "Field", name: { kind: "Name", value: "company_id" } },
          { kind: "Field", name: { kind: "Name", value: "deal_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deals" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "secure_link_id" } },
          { kind: "Field", name: { kind: "Name", value: "metadata" } },
          { kind: "Field", name: { kind: "Name", value: "sent_at" } },
          { kind: "Field", name: { kind: "Name", value: "last_event_at" } },
          { kind: "Field", name: { kind: "Name", value: "signed_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
          { kind: "Field", name: { kind: "Name", value: "term_months" } },
          { kind: "Field", name: { kind: "Name", value: "expires_at" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetContractsQuery, GetContractsQueryVariables>;
export const GetContractDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetContract" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contractsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContractFields" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContractFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "contracts" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "esignatures_contract_id" } },
          { kind: "Field", name: { kind: "Name", value: "template_name" } },
          { kind: "Field", name: { kind: "Name", value: "document_name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "delivery_mode" } },
          { kind: "Field", name: { kind: "Name", value: "recipient_name" } },
          { kind: "Field", name: { kind: "Name", value: "recipient_email" } },
          { kind: "Field", name: { kind: "Name", value: "signing_url" } },
          { kind: "Field", name: { kind: "Name", value: "signed_pdf_url" } },
          { kind: "Field", name: { kind: "Name", value: "decline_reason" } },
          { kind: "Field", name: { kind: "Name", value: "sent_by_user_id" } },
          { kind: "Field", name: { kind: "Name", value: "contact_id" } },
          { kind: "Field", name: { kind: "Name", value: "company_id" } },
          { kind: "Field", name: { kind: "Name", value: "deal_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deals" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "secure_link_id" } },
          { kind: "Field", name: { kind: "Name", value: "metadata" } },
          { kind: "Field", name: { kind: "Name", value: "sent_at" } },
          { kind: "Field", name: { kind: "Name", value: "last_event_at" } },
          { kind: "Field", name: { kind: "Name", value: "signed_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
          { kind: "Field", name: { kind: "Name", value: "term_months" } },
          { kind: "Field", name: { kind: "Name", value: "expires_at" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetContractQuery, GetContractQueryVariables>;
export const GetContractsByContactDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetContractsByContact" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "contractsOrderBy" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contractsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "contact_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "contactId" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContractFields" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContractFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "contracts" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "esignatures_contract_id" } },
          { kind: "Field", name: { kind: "Name", value: "template_name" } },
          { kind: "Field", name: { kind: "Name", value: "document_name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "delivery_mode" } },
          { kind: "Field", name: { kind: "Name", value: "recipient_name" } },
          { kind: "Field", name: { kind: "Name", value: "recipient_email" } },
          { kind: "Field", name: { kind: "Name", value: "signing_url" } },
          { kind: "Field", name: { kind: "Name", value: "signed_pdf_url" } },
          { kind: "Field", name: { kind: "Name", value: "decline_reason" } },
          { kind: "Field", name: { kind: "Name", value: "sent_by_user_id" } },
          { kind: "Field", name: { kind: "Name", value: "contact_id" } },
          { kind: "Field", name: { kind: "Name", value: "company_id" } },
          { kind: "Field", name: { kind: "Name", value: "deal_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deals" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "secure_link_id" } },
          { kind: "Field", name: { kind: "Name", value: "metadata" } },
          { kind: "Field", name: { kind: "Name", value: "sent_at" } },
          { kind: "Field", name: { kind: "Name", value: "last_event_at" } },
          { kind: "Field", name: { kind: "Name", value: "signed_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
          { kind: "Field", name: { kind: "Name", value: "term_months" } },
          { kind: "Field", name: { kind: "Name", value: "expires_at" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetContractsByContactQuery, GetContractsByContactQueryVariables>;
export const GetContractsByCompanyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetContractsByCompany" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "companyId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "contractsOrderBy" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contractsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "company_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "companyId" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContractFields" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContractFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "contracts" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "esignatures_contract_id" } },
          { kind: "Field", name: { kind: "Name", value: "template_name" } },
          { kind: "Field", name: { kind: "Name", value: "document_name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "delivery_mode" } },
          { kind: "Field", name: { kind: "Name", value: "recipient_name" } },
          { kind: "Field", name: { kind: "Name", value: "recipient_email" } },
          { kind: "Field", name: { kind: "Name", value: "signing_url" } },
          { kind: "Field", name: { kind: "Name", value: "signed_pdf_url" } },
          { kind: "Field", name: { kind: "Name", value: "decline_reason" } },
          { kind: "Field", name: { kind: "Name", value: "sent_by_user_id" } },
          { kind: "Field", name: { kind: "Name", value: "contact_id" } },
          { kind: "Field", name: { kind: "Name", value: "company_id" } },
          { kind: "Field", name: { kind: "Name", value: "deal_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deals" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "secure_link_id" } },
          { kind: "Field", name: { kind: "Name", value: "metadata" } },
          { kind: "Field", name: { kind: "Name", value: "sent_at" } },
          { kind: "Field", name: { kind: "Name", value: "last_event_at" } },
          { kind: "Field", name: { kind: "Name", value: "signed_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
          { kind: "Field", name: { kind: "Name", value: "term_months" } },
          { kind: "Field", name: { kind: "Name", value: "expires_at" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetContractsByCompanyQuery, GetContractsByCompanyQueryVariables>;
export const GetContractsByDealDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetContractsByDeal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dealId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "contractsOrderBy" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contractsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "deal_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "dealId" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ContractFields" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContractFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "contracts" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "esignatures_contract_id" } },
          { kind: "Field", name: { kind: "Name", value: "template_name" } },
          { kind: "Field", name: { kind: "Name", value: "document_name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "delivery_mode" } },
          { kind: "Field", name: { kind: "Name", value: "recipient_name" } },
          { kind: "Field", name: { kind: "Name", value: "recipient_email" } },
          { kind: "Field", name: { kind: "Name", value: "signing_url" } },
          { kind: "Field", name: { kind: "Name", value: "signed_pdf_url" } },
          { kind: "Field", name: { kind: "Name", value: "decline_reason" } },
          { kind: "Field", name: { kind: "Name", value: "sent_by_user_id" } },
          { kind: "Field", name: { kind: "Name", value: "contact_id" } },
          { kind: "Field", name: { kind: "Name", value: "company_id" } },
          { kind: "Field", name: { kind: "Name", value: "deal_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deals" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "secure_link_id" } },
          { kind: "Field", name: { kind: "Name", value: "metadata" } },
          { kind: "Field", name: { kind: "Name", value: "sent_at" } },
          { kind: "Field", name: { kind: "Name", value: "last_event_at" } },
          { kind: "Field", name: { kind: "Name", value: "signed_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
          { kind: "Field", name: { kind: "Name", value: "term_months" } },
          { kind: "Field", name: { kind: "Name", value: "expires_at" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetContractsByDealQuery, GetContractsByDealQueryVariables>;
export const CreateContractsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateContracts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "contractsInsertInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntocontractsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "Variable", name: { kind: "Name", value: "input" } }],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "document_name" } },
                      { kind: "Field", name: { kind: "Name", value: "recipient_name" } },
                      { kind: "Field", name: { kind: "Name", value: "company_id" } },
                      { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                      { kind: "Field", name: { kind: "Name", value: "deal_id" } },
                      { kind: "Field", name: { kind: "Name", value: "signed_at" } },
                      { kind: "Field", name: { kind: "Name", value: "term_months" } },
                      { kind: "Field", name: { kind: "Name", value: "expires_at" } },
                      { kind: "Field", name: { kind: "Name", value: "source" } },
                      { kind: "Field", name: { kind: "Name", value: "signed_pdf_url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateContractsMutation, CreateContractsMutationVariables>;
export const UpdateContractsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateContracts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "contractsUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatecontractsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "FragmentSpread", name: { kind: "Name", value: "ContractFields" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ContractFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "contracts" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "esignatures_contract_id" } },
          { kind: "Field", name: { kind: "Name", value: "template_name" } },
          { kind: "Field", name: { kind: "Name", value: "document_name" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "delivery_mode" } },
          { kind: "Field", name: { kind: "Name", value: "recipient_name" } },
          { kind: "Field", name: { kind: "Name", value: "recipient_email" } },
          { kind: "Field", name: { kind: "Name", value: "signing_url" } },
          { kind: "Field", name: { kind: "Name", value: "signed_pdf_url" } },
          { kind: "Field", name: { kind: "Name", value: "decline_reason" } },
          { kind: "Field", name: { kind: "Name", value: "sent_by_user_id" } },
          { kind: "Field", name: { kind: "Name", value: "contact_id" } },
          { kind: "Field", name: { kind: "Name", value: "company_id" } },
          { kind: "Field", name: { kind: "Name", value: "deal_id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "deals" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "secure_link_id" } },
          { kind: "Field", name: { kind: "Name", value: "metadata" } },
          { kind: "Field", name: { kind: "Name", value: "sent_at" } },
          { kind: "Field", name: { kind: "Name", value: "last_event_at" } },
          { kind: "Field", name: { kind: "Name", value: "signed_at" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
          { kind: "Field", name: { kind: "Name", value: "term_months" } },
          { kind: "Field", name: { kind: "Name", value: "expires_at" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateContractsMutation, UpdateContractsMutationVariables>;
export const DeleteContractsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteContracts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFromcontractsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteContractsMutation, DeleteContractsMutationVariables>;
export const GetDashboardStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDashboardStats" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ticketsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "1000" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "ticket_number" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "priority" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "total_billed" } },
                            { kind: "Field", name: { kind: "Name", value: "billable_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "non_billable_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "hourly_rate" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "time_entriesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "1000" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "hours" } },
                            { kind: "Field", name: { kind: "Name", value: "entry_type" } },
                            { kind: "Field", name: { kind: "Name", value: "billable_rate" } },
                            { kind: "Field", name: { kind: "Name", value: "date_worked" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact_tasksCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "1000" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "priority" } },
                            { kind: "Field", name: { kind: "Name", value: "due_date" } },
                            { kind: "Field", name: { kind: "Name", value: "completed_at" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDashboardStatsQuery, GetDashboardStatsQueryVariables>;
export const GetCriticalTicketsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCriticalTickets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ticketsFilter" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ticketsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "priority" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "ticket_number" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "priority" } },
                            { kind: "Field", name: { kind: "Name", value: "category" } },
                            { kind: "Field", name: { kind: "Name", value: "due_date" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "last_activity_at" } },
                            { kind: "Field", name: { kind: "Name", value: "assigned_to" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                            { kind: "Field", name: { kind: "Name", value: "estimated_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "actual_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "billable_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "non_billable_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "hourly_rate" } },
                            { kind: "Field", name: { kind: "Name", value: "total_cost" } },
                            { kind: "Field", name: { kind: "Name", value: "total_billed" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "internal_notes" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "customer_visible_notes" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "is_internal" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCriticalTicketsQuery, GetCriticalTicketsQueryVariables>;
export const GetRecentActivityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRecentActivity" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ticketFilter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ticketsFilter" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "timeEntryFilter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "time_entriesFilter" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ticketsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "ticketFilter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "ticket_number" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "priority" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "assigned_to" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "internal_notes" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "customer_visible_notes" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "is_internal" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "time_entriesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "timeEntryFilter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "ticket_id" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "hours" } },
                            { kind: "Field", name: { kind: "Name", value: "entry_type" } },
                            { kind: "Field", name: { kind: "Name", value: "billable_rate" } },
                            { kind: "Field", name: { kind: "Name", value: "date_worked" } },
                            { kind: "Field", name: { kind: "Name", value: "start_time" } },
                            { kind: "Field", name: { kind: "Name", value: "end_time" } },
                            { kind: "Field", name: { kind: "Name", value: "is_approved" } },
                            { kind: "Field", name: { kind: "Name", value: "approved_by" } },
                            { kind: "Field", name: { kind: "Name", value: "approved_at" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "sync_status" } },
                            { kind: "Field", name: { kind: "Name", value: "quickbooks_id" } },
                            { kind: "Field", name: { kind: "Name", value: "synced_at" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_employee_ref" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_customer_ref" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRecentActivityQuery, GetRecentActivityQueryVariables>;
export const GetTimeSummaryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTimeSummary" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dateFrom" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dateTo" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "time_entriesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "1000" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "user_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "date_worked" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "gte" },
                            value: { kind: "Variable", name: { kind: "Name", value: "dateFrom" } },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "lte" },
                            value: { kind: "Variable", name: { kind: "Name", value: "dateTo" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "date_worked" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "ticket_id" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "hours" } },
                            { kind: "Field", name: { kind: "Name", value: "entry_type" } },
                            { kind: "Field", name: { kind: "Name", value: "billable_rate" } },
                            { kind: "Field", name: { kind: "Name", value: "date_worked" } },
                            { kind: "Field", name: { kind: "Name", value: "start_time" } },
                            { kind: "Field", name: { kind: "Name", value: "end_time" } },
                            { kind: "Field", name: { kind: "Name", value: "is_approved" } },
                            { kind: "Field", name: { kind: "Name", value: "approved_by" } },
                            { kind: "Field", name: { kind: "Name", value: "approved_at" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "sync_status" } },
                            { kind: "Field", name: { kind: "Name", value: "quickbooks_id" } },
                            { kind: "Field", name: { kind: "Name", value: "synced_at" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_employee_ref" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_customer_ref" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTimeSummaryQuery, GetTimeSummaryQueryVariables>;
export const GetUserTaskStatsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserTaskStats" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contact_tasksCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "1000" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "user_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "priority" } },
                            { kind: "Field", name: { kind: "Name", value: "due_date" } },
                            { kind: "Field", name: { kind: "Name", value: "completed_at" } },
                            { kind: "Field", name: { kind: "Name", value: "assigned_users" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserTaskStatsQuery, GetUserTaskStatsQueryVariables>;
export const GetCeoHealthCompaniesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCeoHealthCompanies" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dateFrom" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Datetime" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dateTo" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Datetime" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "companiesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "and" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "created_at" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "gte" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "dateFrom" },
                                      },
                                    },
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "lte" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "dateTo" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "or" },
                                value: {
                                  kind: "ListValue",
                                  values: [
                                    {
                                      kind: "ObjectValue",
                                      fields: [
                                        {
                                          kind: "ObjectField",
                                          name: { kind: "Name", value: "schedule_status" },
                                          value: {
                                            kind: "ObjectValue",
                                            fields: [
                                              {
                                                kind: "ObjectField",
                                                name: { kind: "Name", value: "is" },
                                                value: { kind: "EnumValue", value: "NOT_NULL" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: "ObjectValue",
                                      fields: [
                                        {
                                          kind: "ObjectField",
                                          name: { kind: "Name", value: "budget_status" },
                                          value: {
                                            kind: "ObjectValue",
                                            fields: [
                                              {
                                                kind: "ObjectField",
                                                name: { kind: "Name", value: "is" },
                                                value: { kind: "EnumValue", value: "NOT_NULL" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: "ObjectValue",
                                      fields: [
                                        {
                                          kind: "ObjectField",
                                          name: { kind: "Name", value: "scope_status" },
                                          value: {
                                            kind: "ObjectValue",
                                            fields: [
                                              {
                                                kind: "ObjectField",
                                                name: { kind: "Name", value: "is" },
                                                value: { kind: "EnumValue", value: "NOT_NULL" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: "ObjectValue",
                                      fields: [
                                        {
                                          kind: "ObjectField",
                                          name: { kind: "Name", value: "alignment_status" },
                                          value: {
                                            kind: "ObjectValue",
                                            fields: [
                                              {
                                                kind: "ObjectField",
                                                name: { kind: "Name", value: "is" },
                                                value: { kind: "EnumValue", value: "NOT_NULL" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "organization_revenue" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "schedule_status" } },
                            { kind: "Field", name: { kind: "Name", value: "budget_status" } },
                            { kind: "Field", name: { kind: "Name", value: "scope_status" } },
                            { kind: "Field", name: { kind: "Name", value: "alignment_status" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "dealsCollection" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCeoHealthCompaniesQuery, GetCeoHealthCompaniesQueryVariables>;
export const GetCeoHealthDealsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCeoHealthDeals" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dateFrom" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dateTo" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "dealsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "and" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "close_date" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "gte" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "dateFrom" },
                                      },
                                    },
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "lte" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "dateTo" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "stage" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "in" },
                                      value: {
                                        kind: "ListValue",
                                        values: [
                                          { kind: "EnumValue", value: "lead" },
                                          { kind: "EnumValue", value: "qualified" },
                                          { kind: "EnumValue", value: "discovery" },
                                          { kind: "EnumValue", value: "proposal" },
                                          { kind: "EnumValue", value: "negotiation" },
                                          { kind: "EnumValue", value: "contract_signed" },
                                          { kind: "EnumValue", value: "deal_won" },
                                          { kind: "EnumValue", value: "hand_off" },
                                          { kind: "EnumValue", value: "started" },
                                          { kind: "EnumValue", value: "in_progress" },
                                          { kind: "EnumValue", value: "completed" },
                                          { kind: "EnumValue", value: "invoiced" },
                                          { kind: "EnumValue", value: "paid" },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "revenue" } },
                            { kind: "Field", name: { kind: "Name", value: "cost" } },
                            { kind: "Field", name: { kind: "Name", value: "margin_percentage" } },
                            { kind: "Field", name: { kind: "Name", value: "stage" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCeoHealthDealsQuery, GetCeoHealthDealsQueryVariables>;
export const GetCeoHealthTimeEntriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCeoHealthTimeEntries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dateFrom" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dateTo" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "time_entriesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "date_worked" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "gte" },
                            value: { kind: "Variable", name: { kind: "Name", value: "dateFrom" } },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "lte" },
                            value: { kind: "Variable", name: { kind: "Name", value: "dateTo" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "date_worked" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "hours" } },
                            { kind: "Field", name: { kind: "Name", value: "entry_type" } },
                            { kind: "Field", name: { kind: "Name", value: "date_worked" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCeoHealthTimeEntriesQuery, GetCeoHealthTimeEntriesQueryVariables>;
export const GetCeoHealthUsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCeoHealthUsers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "app_usersCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "is_active" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "first_name" } },
                            { kind: "Field", name: { kind: "Name", value: "last_name" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "available_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "is_billable" } },
                            { kind: "Field", name: { kind: "Name", value: "hourly_rate" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCeoHealthUsersQuery, GetCeoHealthUsersQueryVariables>;
export const GetDealsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDeals" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "dealsFilter" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "dealsOrderBy" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "dealsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "revenue" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "stage" } },
                            { kind: "Field", name: { kind: "Name", value: "close_date" } },
                            { kind: "Field", name: { kind: "Name", value: "close_probability" } },
                            { kind: "Field", name: { kind: "Name", value: "is_recurring" } },
                            { kind: "Field", name: { kind: "Name", value: "monthly_amount" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "contract_term_months" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "is_committed" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "notes" } },
                            { kind: "Field", name: { kind: "Name", value: "last_activity_at" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last_communication_at" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                            { kind: "Field", name: { kind: "Name", value: "won_at" } },
                            { kind: "Field", name: { kind: "Name", value: "lost_at" } },
                            { kind: "Field", name: { kind: "Name", value: "assigned_users" } },
                            { kind: "Field", name: { kind: "Name", value: "engineer_ids" } },
                            { kind: "Field", name: { kind: "Name", value: "slack_channel_id" } },
                            { kind: "Field", name: { kind: "Name", value: "cost" } },
                            { kind: "Field", name: { kind: "Name", value: "margin_percentage" } },
                            { kind: "Field", name: { kind: "Name", value: "estimated_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "schedule_status" } },
                            { kind: "Field", name: { kind: "Name", value: "budget_status" } },
                            { kind: "Field", name: { kind: "Name", value: "scope_status" } },
                            { kind: "Field", name: { kind: "Name", value: "alignment_status" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last_follow_up_task_created_at" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "contractsCollection" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "first" },
                                  value: { kind: "IntValue", value: "20" },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "edges" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "node" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "status" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDealsQuery, GetDealsQueryVariables>;
export const GetDealDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDeal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "dealsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "revenue" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "stage" } },
                            { kind: "Field", name: { kind: "Name", value: "close_date" } },
                            { kind: "Field", name: { kind: "Name", value: "close_probability" } },
                            { kind: "Field", name: { kind: "Name", value: "is_recurring" } },
                            { kind: "Field", name: { kind: "Name", value: "monthly_amount" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "contract_term_months" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "is_committed" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "notes" } },
                            { kind: "Field", name: { kind: "Name", value: "last_activity_at" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last_communication_at" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                            { kind: "Field", name: { kind: "Name", value: "won_at" } },
                            { kind: "Field", name: { kind: "Name", value: "lost_at" } },
                            { kind: "Field", name: { kind: "Name", value: "assigned_users" } },
                            { kind: "Field", name: { kind: "Name", value: "engineer_ids" } },
                            { kind: "Field", name: { kind: "Name", value: "slack_channel_id" } },
                            { kind: "Field", name: { kind: "Name", value: "cost" } },
                            { kind: "Field", name: { kind: "Name", value: "margin_percentage" } },
                            { kind: "Field", name: { kind: "Name", value: "estimated_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "schedule_status" } },
                            { kind: "Field", name: { kind: "Name", value: "budget_status" } },
                            { kind: "Field", name: { kind: "Name", value: "scope_status" } },
                            { kind: "Field", name: { kind: "Name", value: "alignment_status" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last_follow_up_task_created_at" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDealQuery, GetDealQueryVariables>;
export const GetDealsByCompanyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDealsByCompany" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "company_id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "dealsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "company_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "company_id" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "revenue" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "stage" } },
                            { kind: "Field", name: { kind: "Name", value: "close_date" } },
                            { kind: "Field", name: { kind: "Name", value: "close_probability" } },
                            { kind: "Field", name: { kind: "Name", value: "is_recurring" } },
                            { kind: "Field", name: { kind: "Name", value: "monthly_amount" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "contract_term_months" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "is_committed" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "notes" } },
                            { kind: "Field", name: { kind: "Name", value: "last_activity_at" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last_communication_at" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                            { kind: "Field", name: { kind: "Name", value: "won_at" } },
                            { kind: "Field", name: { kind: "Name", value: "lost_at" } },
                            { kind: "Field", name: { kind: "Name", value: "assigned_users" } },
                            { kind: "Field", name: { kind: "Name", value: "engineer_ids" } },
                            { kind: "Field", name: { kind: "Name", value: "slack_channel_id" } },
                            { kind: "Field", name: { kind: "Name", value: "cost" } },
                            { kind: "Field", name: { kind: "Name", value: "margin_percentage" } },
                            { kind: "Field", name: { kind: "Name", value: "estimated_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "schedule_status" } },
                            { kind: "Field", name: { kind: "Name", value: "budget_status" } },
                            { kind: "Field", name: { kind: "Name", value: "scope_status" } },
                            { kind: "Field", name: { kind: "Name", value: "alignment_status" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last_follow_up_task_created_at" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDealsByCompanyQuery, GetDealsByCompanyQueryVariables>;
export const GetActiveDealsByStageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetActiveDealsByStage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "stage" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "deal_stage" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "dealsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "stage" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "stage" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "close_date" },
                          value: { kind: "EnumValue", value: "AscNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "revenue" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "close_probability" } },
                            { kind: "Field", name: { kind: "Name", value: "close_date" } },
                            { kind: "Field", name: { kind: "Name", value: "last_activity_at" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last_communication_at" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetActiveDealsByStageQuery, GetActiveDealsByStageQueryVariables>;
export const GetRecurringDealsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRecurringDeals" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "dealsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "is_recurring" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "monthly_amount" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "contract_term_months" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "stage" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRecurringDealsQuery, GetRecurringDealsQueryVariables>;
export const GetCommittedDealsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCommittedDeals" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "dealsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "is_committed" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "revenue" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "stage" } },
                            { kind: "Field", name: { kind: "Name", value: "close_probability" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCommittedDealsQuery, GetCommittedDealsQueryVariables>;
export const CreateDealDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateDeal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "dealsInsertInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntodealsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "Variable", name: { kind: "Name", value: "input" } }],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "company_id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "revenue" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "stage" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateDealMutation, CreateDealMutationVariables>;
export const UpdateDealDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateDeal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "dealsUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatedealsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "company_id" } },
                      { kind: "Field", name: { kind: "Name", value: "company_name" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "revenue" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "stage" } },
                      { kind: "Field", name: { kind: "Name", value: "close_date" } },
                      { kind: "Field", name: { kind: "Name", value: "close_probability" } },
                      { kind: "Field", name: { kind: "Name", value: "is_recurring" } },
                      { kind: "Field", name: { kind: "Name", value: "monthly_amount" } },
                      { kind: "Field", name: { kind: "Name", value: "contract_term_months" } },
                      { kind: "Field", name: { kind: "Name", value: "is_committed" } },
                      { kind: "Field", name: { kind: "Name", value: "tags" } },
                      { kind: "Field", name: { kind: "Name", value: "notes" } },
                      { kind: "Field", name: { kind: "Name", value: "last_activity_at" } },
                      { kind: "Field", name: { kind: "Name", value: "last_communication_at" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                      { kind: "Field", name: { kind: "Name", value: "created_by" } },
                      { kind: "Field", name: { kind: "Name", value: "won_at" } },
                      { kind: "Field", name: { kind: "Name", value: "lost_at" } },
                      { kind: "Field", name: { kind: "Name", value: "assigned_users" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateDealMutation, UpdateDealMutationVariables>;
export const DeleteDealDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteDeal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFromdealsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteDealMutation, DeleteDealMutationVariables>;
export const GetDealsByFilterDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDealsByFilter" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "dealsFilter" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "dealsOrderBy" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "dealsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "revenue" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "stage" } },
                            { kind: "Field", name: { kind: "Name", value: "close_date" } },
                            { kind: "Field", name: { kind: "Name", value: "close_probability" } },
                            { kind: "Field", name: { kind: "Name", value: "is_recurring" } },
                            { kind: "Field", name: { kind: "Name", value: "monthly_amount" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "contract_term_months" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "is_committed" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "notes" } },
                            { kind: "Field", name: { kind: "Name", value: "last_activity_at" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last_communication_at" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                            { kind: "Field", name: { kind: "Name", value: "won_at" } },
                            { kind: "Field", name: { kind: "Name", value: "lost_at" } },
                            { kind: "Field", name: { kind: "Name", value: "assigned_users" } },
                            { kind: "Field", name: { kind: "Name", value: "engineer_ids" } },
                            { kind: "Field", name: { kind: "Name", value: "slack_channel_id" } },
                            { kind: "Field", name: { kind: "Name", value: "cost" } },
                            { kind: "Field", name: { kind: "Name", value: "margin_percentage" } },
                            { kind: "Field", name: { kind: "Name", value: "estimated_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "schedule_status" } },
                            { kind: "Field", name: { kind: "Name", value: "budget_status" } },
                            { kind: "Field", name: { kind: "Name", value: "scope_status" } },
                            { kind: "Field", name: { kind: "Name", value: "alignment_status" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last_follow_up_task_created_at" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDealsByFilterQuery, GetDealsByFilterQueryVariables>;
export const GetDealsByStageForUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDealsByStageForUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "stage" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "deal_stage" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "dealsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "stage" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "stage" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "stage" } },
                            { kind: "Field", name: { kind: "Name", value: "revenue" } },
                            { kind: "Field", name: { kind: "Name", value: "close_date" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDealsByStageForUpdateQuery, GetDealsByStageForUpdateQueryVariables>;
export const BulkUpdateDealsStageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "BulkUpdateDealsStage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
              },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "stage" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "deal_stage" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatedealsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "in" },
                            value: { kind: "Variable", name: { kind: "Name", value: "ids" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "stage" },
                      value: { kind: "Variable", name: { kind: "Name", value: "stage" } },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "last_activity_at" },
                      value: { kind: "StringValue", value: "now()", block: false },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "stage" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BulkUpdateDealsStageMutation, BulkUpdateDealsStageMutationVariables>;
export const GetDealssDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDealss" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "dealsFilter" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "dealsOrderBy" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "dealsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "revenue" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "stage" } },
                            { kind: "Field", name: { kind: "Name", value: "close_date" } },
                            { kind: "Field", name: { kind: "Name", value: "close_probability" } },
                            { kind: "Field", name: { kind: "Name", value: "is_recurring" } },
                            { kind: "Field", name: { kind: "Name", value: "monthly_amount" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "contract_term_months" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "is_committed" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "notes" } },
                            { kind: "Field", name: { kind: "Name", value: "last_activity_at" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last_communication_at" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                            { kind: "Field", name: { kind: "Name", value: "won_at" } },
                            { kind: "Field", name: { kind: "Name", value: "lost_at" } },
                            { kind: "Field", name: { kind: "Name", value: "cost" } },
                            { kind: "Field", name: { kind: "Name", value: "margin_percentage" } },
                            { kind: "Field", name: { kind: "Name", value: "estimated_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "schedule_status" } },
                            { kind: "Field", name: { kind: "Name", value: "budget_status" } },
                            { kind: "Field", name: { kind: "Name", value: "scope_status" } },
                            { kind: "Field", name: { kind: "Name", value: "alignment_status" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last_follow_up_task_created_at" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDealssQuery, GetDealssQueryVariables>;
export const GetRevenueTargetsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRevenueTargets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "revenue_targetsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "period_start" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                            { kind: "Field", name: { kind: "Name", value: "target_amount" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "period_start" } },
                            { kind: "Field", name: { kind: "Name", value: "period_end" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRevenueTargetsQuery, GetRevenueTargetsQueryVariables>;
export const GetLatestRevenueTargetDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLatestRevenueTarget" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "revenue_targetsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "1" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "period_start" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                            { kind: "Field", name: { kind: "Name", value: "target_amount" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                            { kind: "Field", name: { kind: "Name", value: "period_start" } },
                            { kind: "Field", name: { kind: "Name", value: "period_end" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetLatestRevenueTargetQuery, GetLatestRevenueTargetQueryVariables>;
export const CreateRevenueTargetDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateRevenueTarget" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "revenue_targetsInsertInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntorevenue_targetsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "Variable", name: { kind: "Name", value: "input" } }],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "target_amount" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "period_start" } },
                      { kind: "Field", name: { kind: "Name", value: "period_end" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateRevenueTargetMutation, CreateRevenueTargetMutationVariables>;
export const UpdateRevenueTargetDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateRevenueTarget" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "revenue_targetsUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updaterevenue_targetsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "target_amount" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                      { kind: "Field", name: { kind: "Name", value: "period_start" } },
                      { kind: "Field", name: { kind: "Name", value: "period_end" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateRevenueTargetMutation, UpdateRevenueTargetMutationVariables>;
export const GetCeoRiskDealsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCeoRiskDeals" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dateFrom" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dateTo" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "dealsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "close_date" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "gte" },
                            value: { kind: "Variable", name: { kind: "Name", value: "dateFrom" } },
                          },
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "lte" },
                            value: { kind: "Variable", name: { kind: "Name", value: "dateTo" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "last_activity_at" },
                          value: { kind: "EnumValue", value: "AscNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "revenue" } },
                            { kind: "Field", name: { kind: "Name", value: "close_probability" } },
                            { kind: "Field", name: { kind: "Name", value: "close_date" } },
                            { kind: "Field", name: { kind: "Name", value: "last_activity_at" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last_communication_at" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "stage" } },
                            { kind: "Field", name: { kind: "Name", value: "assigned_users" } },
                            { kind: "Field", name: { kind: "Name", value: "estimated_hours" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCeoRiskDealsQuery, GetCeoRiskDealsQueryVariables>;
export const GetCeoRiskRatedCompaniesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCeoRiskRatedCompanies" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "companiesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "or" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "schedule_status" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "is" },
                                      value: { kind: "EnumValue", value: "NOT_NULL" },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "budget_status" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "is" },
                                      value: { kind: "EnumValue", value: "NOT_NULL" },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "scope_status" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "is" },
                                      value: { kind: "EnumValue", value: "NOT_NULL" },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "alignment_status" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "is" },
                                      value: { kind: "EnumValue", value: "NOT_NULL" },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "schedule_status" } },
                            { kind: "Field", name: { kind: "Name", value: "budget_status" } },
                            { kind: "Field", name: { kind: "Name", value: "scope_status" } },
                            { kind: "Field", name: { kind: "Name", value: "alignment_status" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last_follow_up_task_created_at" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCeoRiskRatedCompaniesQuery, GetCeoRiskRatedCompaniesQueryVariables>;
export const GetCeoRiskUnassignedTicketsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCeoRiskUnassignedTickets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ticketsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "assigned_to" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "is" },
                            value: { kind: "EnumValue", value: "NULL" },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "priority" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "assigned_to" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCeoRiskUnassignedTicketsQuery,
  GetCeoRiskUnassignedTicketsQueryVariables
>;
export const GetCeoRiskUsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCeoRiskUsers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "app_usersCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "is_active" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "is_billable" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "BooleanValue", value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "first_name" } },
                            { kind: "Field", name: { kind: "Name", value: "last_name" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "available_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "is_billable" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCeoRiskUsersQuery, GetCeoRiskUsersQueryVariables>;
export const GetEmailCampaignsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEmailCampaigns" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "email_campaignsFilter" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "email_campaignsOrderBy" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "email_campaignsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "EmailCampaignFields" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmailCampaignFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "email_campaigns" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "template_id" } },
          { kind: "Field", name: { kind: "Name", value: "body_html" } },
          { kind: "Field", name: { kind: "Name", value: "from_email" } },
          { kind: "Field", name: { kind: "Name", value: "from_name" } },
          { kind: "Field", name: { kind: "Name", value: "reply_to" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_at" } },
          { kind: "Field", name: { kind: "Name", value: "sent_at" } },
          { kind: "Field", name: { kind: "Name", value: "audience_id" } },
          { kind: "Field", name: { kind: "Name", value: "stats" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEmailCampaignsQuery, GetEmailCampaignsQueryVariables>;
export const GetEmailCampaignDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEmailCampaign" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "email_campaignsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "EmailCampaignFields" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmailCampaignFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "email_campaigns" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "template_id" } },
          { kind: "Field", name: { kind: "Name", value: "body_html" } },
          { kind: "Field", name: { kind: "Name", value: "from_email" } },
          { kind: "Field", name: { kind: "Name", value: "from_name" } },
          { kind: "Field", name: { kind: "Name", value: "reply_to" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_at" } },
          { kind: "Field", name: { kind: "Name", value: "sent_at" } },
          { kind: "Field", name: { kind: "Name", value: "audience_id" } },
          { kind: "Field", name: { kind: "Name", value: "stats" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEmailCampaignQuery, GetEmailCampaignQueryVariables>;
export const CreateEmailCampaignsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateEmailCampaigns" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "email_campaignsInsertInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntoemail_campaignsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "Variable", name: { kind: "Name", value: "input" } }],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "EmailCampaignFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmailCampaignFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "email_campaigns" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "template_id" } },
          { kind: "Field", name: { kind: "Name", value: "body_html" } },
          { kind: "Field", name: { kind: "Name", value: "from_email" } },
          { kind: "Field", name: { kind: "Name", value: "from_name" } },
          { kind: "Field", name: { kind: "Name", value: "reply_to" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_at" } },
          { kind: "Field", name: { kind: "Name", value: "sent_at" } },
          { kind: "Field", name: { kind: "Name", value: "audience_id" } },
          { kind: "Field", name: { kind: "Name", value: "stats" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateEmailCampaignsMutation, CreateEmailCampaignsMutationVariables>;
export const UpdateEmailCampaignsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateEmailCampaigns" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "email_campaignsUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateemail_campaignsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "EmailCampaignFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "EmailCampaignFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "email_campaigns" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "subject" } },
          { kind: "Field", name: { kind: "Name", value: "template_id" } },
          { kind: "Field", name: { kind: "Name", value: "body_html" } },
          { kind: "Field", name: { kind: "Name", value: "from_email" } },
          { kind: "Field", name: { kind: "Name", value: "from_name" } },
          { kind: "Field", name: { kind: "Name", value: "reply_to" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_at" } },
          { kind: "Field", name: { kind: "Name", value: "sent_at" } },
          { kind: "Field", name: { kind: "Name", value: "audience_id" } },
          { kind: "Field", name: { kind: "Name", value: "stats" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateEmailCampaignsMutation, UpdateEmailCampaignsMutationVariables>;
export const DeleteEmailCampaignsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteEmailCampaigns" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFromemail_campaignsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteEmailCampaignsMutation, DeleteEmailCampaignsMutationVariables>;
export const GetEmailTemplateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEmailTemplate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "email_templatesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "subject" } },
                            { kind: "Field", name: { kind: "Name", value: "body" } },
                            { kind: "Field", name: { kind: "Name", value: "folder_id" } },
                            { kind: "Field", name: { kind: "Name", value: "is_shared" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>;
export const GetEmailTemplatesCollectionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEmailTemplatesCollection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "email_templatesFilter" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "email_templatesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "name" },
                          value: { kind: "EnumValue", value: "AscNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "subject" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetEmailTemplatesCollectionQuery,
  GetEmailTemplatesCollectionQueryVariables
>;
export const InsertEmailTemplateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InsertEmailTemplate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "objects" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "email_templatesInsertInput" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntoemail_templatesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: { kind: "Variable", name: { kind: "Name", value: "objects" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "subject" } },
                      { kind: "Field", name: { kind: "Name", value: "body" } },
                      { kind: "Field", name: { kind: "Name", value: "folder_id" } },
                      { kind: "Field", name: { kind: "Name", value: "is_shared" } },
                      { kind: "Field", name: { kind: "Name", value: "tags" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InsertEmailTemplateMutation, InsertEmailTemplateMutationVariables>;
export const GetEmployeeContactAccessCollectionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEmployeeContactAccessCollection" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "employee_contact_accessFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "employee_contact_accessCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "granted_by" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "app_users" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                  { kind: "Field", name: { kind: "Name", value: "first_name" } },
                                  { kind: "Field", name: { kind: "Name", value: "last_name" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "contacts" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "company_name" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetEmployeeContactAccessCollectionQuery,
  GetEmployeeContactAccessCollectionQueryVariables
>;
export const InsertEmployeeContactAccessDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InsertEmployeeContactAccess" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "objects" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "employee_contact_accessInsertInput" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntoemployee_contact_accessCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: { kind: "Variable", name: { kind: "Name", value: "objects" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "user_id" } },
                      { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InsertEmployeeContactAccessMutation,
  InsertEmployeeContactAccessMutationVariables
>;
export const GetEntityAutomationConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEntityAutomationConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "entityType" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "entityId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "entity_automation_configCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "and" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "entity_type" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "eq" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "entityType" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "entity_id" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "eq" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "entityId" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "entity_type" } },
                            { kind: "Field", name: { kind: "Name", value: "entity_id" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                            { kind: "Field", name: { kind: "Name", value: "enabled" } },
                            { kind: "Field", name: { kind: "Name", value: "frequency" } },
                            { kind: "Field", name: { kind: "Name", value: "day_of_week" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "run_on_business_days_only" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "selected_days_of_week" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "use_title_template" } },
                            { kind: "Field", name: { kind: "Name", value: "task_title_template" } },
                            { kind: "Field", name: { kind: "Name", value: "task_title_fixed" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "task_description_template" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "assigned_user_ids" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "priority" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetEntityAutomationConfigQuery,
  GetEntityAutomationConfigQueryVariables
>;
export const ListEntityAutomationConfigsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ListEntityAutomationConfigs" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "entityType" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "entity_automation_configCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "entity_type" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "entityType" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "entity_type" } },
                            { kind: "Field", name: { kind: "Name", value: "entity_id" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                            { kind: "Field", name: { kind: "Name", value: "enabled" } },
                            { kind: "Field", name: { kind: "Name", value: "frequency" } },
                            { kind: "Field", name: { kind: "Name", value: "day_of_week" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "run_on_business_days_only" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "selected_days_of_week" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "use_title_template" } },
                            { kind: "Field", name: { kind: "Name", value: "task_title_template" } },
                            { kind: "Field", name: { kind: "Name", value: "task_title_fixed" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "task_description_template" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "assigned_user_ids" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "priority" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ListEntityAutomationConfigsQuery,
  ListEntityAutomationConfigsQueryVariables
>;
export const CreateEntityAutomationConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateEntityAutomationConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "entity_automation_configInsertInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntoentity_automation_configCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "Variable", name: { kind: "Name", value: "input" } }],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "entity_type" } },
                      { kind: "Field", name: { kind: "Name", value: "entity_id" } },
                      { kind: "Field", name: { kind: "Name", value: "created_by" } },
                      { kind: "Field", name: { kind: "Name", value: "enabled" } },
                      { kind: "Field", name: { kind: "Name", value: "frequency" } },
                      { kind: "Field", name: { kind: "Name", value: "day_of_week" } },
                      { kind: "Field", name: { kind: "Name", value: "run_on_business_days_only" } },
                      { kind: "Field", name: { kind: "Name", value: "selected_days_of_week" } },
                      { kind: "Field", name: { kind: "Name", value: "use_title_template" } },
                      { kind: "Field", name: { kind: "Name", value: "task_title_template" } },
                      { kind: "Field", name: { kind: "Name", value: "task_title_fixed" } },
                      { kind: "Field", name: { kind: "Name", value: "task_description_template" } },
                      { kind: "Field", name: { kind: "Name", value: "assigned_user_ids" } },
                      { kind: "Field", name: { kind: "Name", value: "tags" } },
                      { kind: "Field", name: { kind: "Name", value: "priority" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateEntityAutomationConfigMutation,
  CreateEntityAutomationConfigMutationVariables
>;
export const UpdateEntityAutomationConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateEntityAutomationConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "entity_automation_configUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateentity_automation_configCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "entity_type" } },
                      { kind: "Field", name: { kind: "Name", value: "entity_id" } },
                      { kind: "Field", name: { kind: "Name", value: "created_by" } },
                      { kind: "Field", name: { kind: "Name", value: "enabled" } },
                      { kind: "Field", name: { kind: "Name", value: "frequency" } },
                      { kind: "Field", name: { kind: "Name", value: "day_of_week" } },
                      { kind: "Field", name: { kind: "Name", value: "run_on_business_days_only" } },
                      { kind: "Field", name: { kind: "Name", value: "selected_days_of_week" } },
                      { kind: "Field", name: { kind: "Name", value: "use_title_template" } },
                      { kind: "Field", name: { kind: "Name", value: "task_title_template" } },
                      { kind: "Field", name: { kind: "Name", value: "task_title_fixed" } },
                      { kind: "Field", name: { kind: "Name", value: "task_description_template" } },
                      { kind: "Field", name: { kind: "Name", value: "assigned_user_ids" } },
                      { kind: "Field", name: { kind: "Name", value: "tags" } },
                      { kind: "Field", name: { kind: "Name", value: "priority" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateEntityAutomationConfigMutation,
  UpdateEntityAutomationConfigMutationVariables
>;
export const DeleteEntityAutomationConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteEntityAutomationConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFromentity_automation_configCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteEntityAutomationConfigMutation,
  DeleteEntityAutomationConfigMutationVariables
>;
export const GetMspDocumentssDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMspDocumentss" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "msp_documentsFilter" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "msp_documentsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "content" } },
                            { kind: "Field", name: { kind: "Name", value: "excerpt" } },
                            { kind: "Field", name: { kind: "Name", value: "category" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "client_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "difficulty" } },
                            { kind: "Field", name: { kind: "Name", value: "is_internal" } },
                            { kind: "Field", name: { kind: "Name", value: "is_active" } },
                            { kind: "Field", name: { kind: "Name", value: "is_featured" } },
                            { kind: "Field", name: { kind: "Name", value: "estimated_read_time" } },
                            { kind: "Field", name: { kind: "Name", value: "last_accessed_at" } },
                            { kind: "Field", name: { kind: "Name", value: "access_count" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_by" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "shared_with_users" } },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "company" },
                              name: { kind: "Name", value: "companies" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "industry" } },
                                  { kind: "Field", name: { kind: "Name", value: "website" } },
                                  { kind: "Field", name: { kind: "Name", value: "city" } },
                                  { kind: "Field", name: { kind: "Name", value: "state" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "client" },
                              name: { kind: "Name", value: "contacts" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "company_name" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "creator" },
                              name: { kind: "Name", value: "app_users" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "first_name" } },
                                  { kind: "Field", name: { kind: "Name", value: "last_name" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMspDocumentssQuery, GetMspDocumentssQueryVariables>;
export const GetMspDocumentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMspDocuments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "msp_documentsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "content" } },
                            { kind: "Field", name: { kind: "Name", value: "content_s3_key" } },
                            { kind: "Field", name: { kind: "Name", value: "content_preview" } },
                            { kind: "Field", name: { kind: "Name", value: "excerpt" } },
                            { kind: "Field", name: { kind: "Name", value: "category" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "client_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "difficulty" } },
                            { kind: "Field", name: { kind: "Name", value: "is_internal" } },
                            { kind: "Field", name: { kind: "Name", value: "is_active" } },
                            { kind: "Field", name: { kind: "Name", value: "is_featured" } },
                            { kind: "Field", name: { kind: "Name", value: "estimated_read_time" } },
                            { kind: "Field", name: { kind: "Name", value: "last_accessed_at" } },
                            { kind: "Field", name: { kind: "Name", value: "access_count" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_by" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "shared_with_users" } },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "company" },
                              name: { kind: "Name", value: "companies" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "industry" } },
                                  { kind: "Field", name: { kind: "Name", value: "website" } },
                                  { kind: "Field", name: { kind: "Name", value: "city" } },
                                  { kind: "Field", name: { kind: "Name", value: "state" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "client" },
                              name: { kind: "Name", value: "contacts" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "company_name" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "creator" },
                              name: { kind: "Name", value: "app_users" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "first_name" } },
                                  { kind: "Field", name: { kind: "Name", value: "last_name" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMspDocumentsQuery, GetMspDocumentsQueryVariables>;
export const CreateMspDocumentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateMspDocuments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "msp_documentsInsertInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntomsp_documentsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "Variable", name: { kind: "Name", value: "input" } }],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "content" } },
                      { kind: "Field", name: { kind: "Name", value: "excerpt" } },
                      { kind: "Field", name: { kind: "Name", value: "category" } },
                      { kind: "Field", name: { kind: "Name", value: "tags" } },
                      { kind: "Field", name: { kind: "Name", value: "client_id" } },
                      { kind: "Field", name: { kind: "Name", value: "company_id" } },
                      { kind: "Field", name: { kind: "Name", value: "difficulty" } },
                      { kind: "Field", name: { kind: "Name", value: "is_internal" } },
                      { kind: "Field", name: { kind: "Name", value: "is_active" } },
                      { kind: "Field", name: { kind: "Name", value: "is_featured" } },
                      { kind: "Field", name: { kind: "Name", value: "estimated_read_time" } },
                      { kind: "Field", name: { kind: "Name", value: "last_accessed_at" } },
                      { kind: "Field", name: { kind: "Name", value: "access_count" } },
                      { kind: "Field", name: { kind: "Name", value: "created_by" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_by" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                      { kind: "Field", name: { kind: "Name", value: "shared_with_users" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateMspDocumentsMutation, CreateMspDocumentsMutationVariables>;
export const UpdateMspDocumentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateMspDocuments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "msp_documentsUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatemsp_documentsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "content" } },
                      { kind: "Field", name: { kind: "Name", value: "excerpt" } },
                      { kind: "Field", name: { kind: "Name", value: "category" } },
                      { kind: "Field", name: { kind: "Name", value: "tags" } },
                      { kind: "Field", name: { kind: "Name", value: "client_id" } },
                      { kind: "Field", name: { kind: "Name", value: "company_id" } },
                      { kind: "Field", name: { kind: "Name", value: "difficulty" } },
                      { kind: "Field", name: { kind: "Name", value: "is_internal" } },
                      { kind: "Field", name: { kind: "Name", value: "is_active" } },
                      { kind: "Field", name: { kind: "Name", value: "is_featured" } },
                      { kind: "Field", name: { kind: "Name", value: "estimated_read_time" } },
                      { kind: "Field", name: { kind: "Name", value: "last_accessed_at" } },
                      { kind: "Field", name: { kind: "Name", value: "access_count" } },
                      { kind: "Field", name: { kind: "Name", value: "created_by" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_by" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                      { kind: "Field", name: { kind: "Name", value: "shared_with_users" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateMspDocumentsMutation, UpdateMspDocumentsMutationVariables>;
export const DeleteMspDocumentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteMspDocuments" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFrommsp_documentsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteMspDocumentsMutation, DeleteMspDocumentsMutationVariables>;
export const GetOfferingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOfferings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "offeringsFilter" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "offeringsOrderBy" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "offeringsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "executive_summary" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "delivery_kit" } },
                            { kind: "Field", name: { kind: "Name", value: "one_pager_pdf_url" } },
                            { kind: "Field", name: { kind: "Name", value: "image_url" } },
                            { kind: "Field", name: { kind: "Name", value: "staff_line_items" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hard_cost_line_items" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "total_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "total_hard_costs" } },
                            { kind: "Field", name: { kind: "Name", value: "total_cost" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOfferingsQuery, GetOfferingsQueryVariables>;
export const GetOfferingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOffering" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "offeringsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "executive_summary" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "delivery_kit" } },
                            { kind: "Field", name: { kind: "Name", value: "one_pager_pdf_url" } },
                            { kind: "Field", name: { kind: "Name", value: "image_url" } },
                            { kind: "Field", name: { kind: "Name", value: "staff_line_items" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hard_cost_line_items" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "total_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "total_hard_costs" } },
                            { kind: "Field", name: { kind: "Name", value: "total_cost" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOfferingQuery, GetOfferingQueryVariables>;
export const CreateOfferingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateOffering" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "offeringsInsertInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntoofferingsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "Variable", name: { kind: "Name", value: "input" } }],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "executive_summary" } },
                      { kind: "Field", name: { kind: "Name", value: "tags" } },
                      { kind: "Field", name: { kind: "Name", value: "delivery_kit" } },
                      { kind: "Field", name: { kind: "Name", value: "one_pager_pdf_url" } },
                      { kind: "Field", name: { kind: "Name", value: "image_url" } },
                      { kind: "Field", name: { kind: "Name", value: "staff_line_items" } },
                      { kind: "Field", name: { kind: "Name", value: "hard_cost_line_items" } },
                      { kind: "Field", name: { kind: "Name", value: "total_hours" } },
                      { kind: "Field", name: { kind: "Name", value: "total_hard_costs" } },
                      { kind: "Field", name: { kind: "Name", value: "total_cost" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                      { kind: "Field", name: { kind: "Name", value: "created_by" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateOfferingMutation, CreateOfferingMutationVariables>;
export const UpdateOfferingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateOffering" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "offeringsUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateofferingsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "executive_summary" } },
                      { kind: "Field", name: { kind: "Name", value: "tags" } },
                      { kind: "Field", name: { kind: "Name", value: "delivery_kit" } },
                      { kind: "Field", name: { kind: "Name", value: "one_pager_pdf_url" } },
                      { kind: "Field", name: { kind: "Name", value: "image_url" } },
                      { kind: "Field", name: { kind: "Name", value: "staff_line_items" } },
                      { kind: "Field", name: { kind: "Name", value: "hard_cost_line_items" } },
                      { kind: "Field", name: { kind: "Name", value: "total_hours" } },
                      { kind: "Field", name: { kind: "Name", value: "total_hard_costs" } },
                      { kind: "Field", name: { kind: "Name", value: "total_cost" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                      { kind: "Field", name: { kind: "Name", value: "created_by" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateOfferingMutation, UpdateOfferingMutationVariables>;
export const DeleteOfferingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteOffering" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFromofferingsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteOfferingMutation, DeleteOfferingMutationVariables>;
export const GetPlaidTransactionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPlaidTransactions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "plaid_transactionsFilter" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "plaid_transactionsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "date" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "id" },
                          value: { kind: "EnumValue", value: "AscNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "plaid_transaction_id" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "account_id" } },
                            { kind: "Field", name: { kind: "Name", value: "amount" } },
                            { kind: "Field", name: { kind: "Name", value: "iso_currency_code" } },
                            { kind: "Field", name: { kind: "Name", value: "date" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "merchant_name" } },
                            { kind: "Field", name: { kind: "Name", value: "pfc_primary" } },
                            { kind: "Field", name: { kind: "Name", value: "pfc_detailed" } },
                            { kind: "Field", name: { kind: "Name", value: "pending" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "plaid_accounts" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "account_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "plaid_transaction_attributions" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "company_id" } },
                                  { kind: "Field", name: { kind: "Name", value: "is_net_cost" } },
                                  { kind: "Field", name: { kind: "Name", value: "cost_category" } },
                                  { kind: "Field", name: { kind: "Name", value: "source" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "companies" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "id" } },
                                        { kind: "Field", name: { kind: "Name", value: "name" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPlaidTransactionsQuery, GetPlaidTransactionsQueryVariables>;
export const GetRecurringChargesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRecurringCharges" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "recurring_chargesFilter" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "recurring_chargesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "next_charge_date" },
                          value: { kind: "EnumValue", value: "AscNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "customer_id" } },
                            { kind: "Field", name: { kind: "Name", value: "schedule_type" } },
                            { kind: "Field", name: { kind: "Name", value: "last_charged_at" } },
                            { kind: "Field", name: { kind: "Name", value: "next_charge_date" } },
                            { kind: "Field", name: { kind: "Name", value: "metadata" } },
                            { kind: "Field", name: { kind: "Name", value: "realm_id" } },
                            { kind: "Field", name: { kind: "Name", value: "admin_email" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRecurringChargesQuery, GetRecurringChargesQueryVariables>;
export const GetRecurringChargeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRecurringCharge" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "recurring_chargesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "customer_id" } },
                            { kind: "Field", name: { kind: "Name", value: "schedule_type" } },
                            { kind: "Field", name: { kind: "Name", value: "last_charged_at" } },
                            { kind: "Field", name: { kind: "Name", value: "next_charge_date" } },
                            { kind: "Field", name: { kind: "Name", value: "metadata" } },
                            { kind: "Field", name: { kind: "Name", value: "realm_id" } },
                            { kind: "Field", name: { kind: "Name", value: "admin_email" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRecurringChargeQuery, GetRecurringChargeQueryVariables>;
export const CreateRecurringChargeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateRecurringCharge" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "recurring_chargesInsertInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntorecurring_chargesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "Variable", name: { kind: "Name", value: "input" } }],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "customer_id" } },
                      { kind: "Field", name: { kind: "Name", value: "schedule_type" } },
                      { kind: "Field", name: { kind: "Name", value: "next_charge_date" } },
                      { kind: "Field", name: { kind: "Name", value: "metadata" } },
                      { kind: "Field", name: { kind: "Name", value: "realm_id" } },
                      { kind: "Field", name: { kind: "Name", value: "admin_email" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateRecurringChargeMutation, CreateRecurringChargeMutationVariables>;
export const UpdateRecurringChargeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateRecurringCharge" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "recurring_chargesUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updaterecurring_chargesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "customer_id" } },
                      { kind: "Field", name: { kind: "Name", value: "schedule_type" } },
                      { kind: "Field", name: { kind: "Name", value: "last_charged_at" } },
                      { kind: "Field", name: { kind: "Name", value: "next_charge_date" } },
                      { kind: "Field", name: { kind: "Name", value: "metadata" } },
                      { kind: "Field", name: { kind: "Name", value: "realm_id" } },
                      { kind: "Field", name: { kind: "Name", value: "admin_email" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateRecurringChargeMutation, UpdateRecurringChargeMutationVariables>;
export const DeleteRecurringChargeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteRecurringCharge" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFromrecurring_chargesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteRecurringChargeMutation, DeleteRecurringChargeMutationVariables>;
export const GetRecurringTransactionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRecurringTransactions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "recurring_transactionsFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "recurring_transactionsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "customer_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_name" } },
                            { kind: "Field", name: { kind: "Name", value: "item" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "amount" } },
                            { kind: "Field", name: { kind: "Name", value: "quantity" } },
                            { kind: "Field", name: { kind: "Name", value: "billing_cadence" } },
                            { kind: "Field", name: { kind: "Name", value: "next_bill_on" } },
                            { kind: "Field", name: { kind: "Name", value: "sync_status" } },
                            { kind: "Field", name: { kind: "Name", value: "last_synced_at" } },
                            { kind: "Field", name: { kind: "Name", value: "last_synced_month" } },
                            { kind: "Field", name: { kind: "Name", value: "quickbooks_id" } },
                            { kind: "Field", name: { kind: "Name", value: "quickbooks_realm_id" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_by" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                      { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRecurringTransactionsQuery, GetRecurringTransactionsQueryVariables>;
export const GetRecurringTransactionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRecurringTransaction" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "recurring_transactionsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "customer_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_name" } },
                            { kind: "Field", name: { kind: "Name", value: "item" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "amount" } },
                            { kind: "Field", name: { kind: "Name", value: "quantity" } },
                            { kind: "Field", name: { kind: "Name", value: "billing_cadence" } },
                            { kind: "Field", name: { kind: "Name", value: "next_bill_on" } },
                            { kind: "Field", name: { kind: "Name", value: "sync_status" } },
                            { kind: "Field", name: { kind: "Name", value: "last_synced_at" } },
                            { kind: "Field", name: { kind: "Name", value: "last_synced_month" } },
                            { kind: "Field", name: { kind: "Name", value: "quickbooks_id" } },
                            { kind: "Field", name: { kind: "Name", value: "quickbooks_realm_id" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_by" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRecurringTransactionQuery, GetRecurringTransactionQueryVariables>;
export const CreateRecurringTransactionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateRecurringTransaction" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "recurring_transactionsInsertInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntorecurring_transactionsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "Variable", name: { kind: "Name", value: "input" } }],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "customer_id" } },
                      { kind: "Field", name: { kind: "Name", value: "company_id" } },
                      { kind: "Field", name: { kind: "Name", value: "item" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "amount" } },
                      { kind: "Field", name: { kind: "Name", value: "quantity" } },
                      { kind: "Field", name: { kind: "Name", value: "billing_cadence" } },
                      { kind: "Field", name: { kind: "Name", value: "next_bill_on" } },
                      { kind: "Field", name: { kind: "Name", value: "sync_status" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateRecurringTransactionMutation,
  CreateRecurringTransactionMutationVariables
>;
export const UpdateRecurringTransactionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateRecurringTransaction" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "recurring_transactionsUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updaterecurring_transactionsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "customer_id" } },
                      { kind: "Field", name: { kind: "Name", value: "company_id" } },
                      { kind: "Field", name: { kind: "Name", value: "item" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "amount" } },
                      { kind: "Field", name: { kind: "Name", value: "quantity" } },
                      { kind: "Field", name: { kind: "Name", value: "billing_cadence" } },
                      { kind: "Field", name: { kind: "Name", value: "next_bill_on" } },
                      { kind: "Field", name: { kind: "Name", value: "sync_status" } },
                      { kind: "Field", name: { kind: "Name", value: "last_synced_at" } },
                      { kind: "Field", name: { kind: "Name", value: "last_synced_month" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_id" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_realm_id" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateRecurringTransactionMutation,
  UpdateRecurringTransactionMutationVariables
>;
export const DeleteRecurringTransactionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteRecurringTransaction" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFromrecurring_transactionsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteRecurringTransactionMutation,
  DeleteRecurringTransactionMutationVariables
>;
export const GetRelationshipMapDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      description: {
        kind: "StringValue",
        value:
          "GraphQL queries for relationship map visualization\nFetches entities and their relationships for graph visualization",
        block: true,
      },
      name: { kind: "Name", value: "GetRelationshipMapData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "companiesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contactsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "dealsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "stage" } },
                            { kind: "Field", name: { kind: "Name", value: "revenue" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "ticketsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "priority" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                            { kind: "Field", name: { kind: "Name", value: "actual_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact_tasksCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "priority" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "time_entriesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "hours" } },
                            { kind: "Field", name: { kind: "Name", value: "ticket_id" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "communicationsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "direction" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRelationshipMapDataQuery, GetRelationshipMapDataQueryVariables>;
export const GetRolessDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRoless" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "rolesFilter" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rolesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "display_name" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "permissions" } },
                            { kind: "Field", name: { kind: "Name", value: "is_active" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRolessQuery, GetRolessQueryVariables>;
export const GetRolesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRoles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rolesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "display_name" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "permissions" } },
                            { kind: "Field", name: { kind: "Name", value: "is_active" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRolesQuery, GetRolesQueryVariables>;
export const CreateRolesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateRoles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "rolesInsertInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntorolesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "Variable", name: { kind: "Name", value: "input" } }],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "display_name" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "permissions" } },
                      { kind: "Field", name: { kind: "Name", value: "is_active" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateRolesMutation, CreateRolesMutationVariables>;
export const UpdateRolesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateRoles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "rolesUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updaterolesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "display_name" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "permissions" } },
                      { kind: "Field", name: { kind: "Name", value: "is_active" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateRolesMutation, UpdateRolesMutationVariables>;
export const DeleteRolesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteRoles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFromrolesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteRolesMutation, DeleteRolesMutationVariables>;
export const GetSavedViewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSavedViews" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "resource" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "saved_viewsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "resource" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "resource" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "updated_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "resource" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "filters" } },
                            { kind: "Field", name: { kind: "Name", value: "visibility" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "shared_with_user_ids" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSavedViewsQuery, GetSavedViewsQueryVariables>;
export const GetSavedViewFavoritesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSavedViewFavorites" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "resource" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "saved_view_favoritesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "user_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "view_id" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSavedViewFavoritesQuery, GetSavedViewFavoritesQueryVariables>;
export const GetAllSavedViewFavoritesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAllSavedViewFavorites" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "saved_view_favoritesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "user_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "view_id" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllSavedViewFavoritesQuery, GetAllSavedViewFavoritesQueryVariables>;
export const ValidateUserAccessToViewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ValidateUserAccessToView" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "viewId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "saved_viewsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "viewId" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "visibility" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "shared_with_user_ids" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ValidateUserAccessToViewQuery, ValidateUserAccessToViewQueryVariables>;
export const CreateSavedViewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateSavedView" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "saved_viewsInsertInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntosaved_viewsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "Variable", name: { kind: "Name", value: "input" } }],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "resource" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "filters" } },
                      { kind: "Field", name: { kind: "Name", value: "visibility" } },
                      { kind: "Field", name: { kind: "Name", value: "shared_with_user_ids" } },
                      { kind: "Field", name: { kind: "Name", value: "created_by" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateSavedViewMutation, CreateSavedViewMutationVariables>;
export const UpdateSavedViewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateSavedView" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "saved_viewsUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatesaved_viewsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "resource" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "filters" } },
                      { kind: "Field", name: { kind: "Name", value: "visibility" } },
                      { kind: "Field", name: { kind: "Name", value: "shared_with_user_ids" } },
                      { kind: "Field", name: { kind: "Name", value: "created_by" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSavedViewMutation, UpdateSavedViewMutationVariables>;
export const DeleteSavedViewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteSavedView" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFromsaved_viewsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteSavedViewMutation, DeleteSavedViewMutationVariables>;
export const ToggleSavedViewFavoriteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ToggleSavedViewFavorite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "viewId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntosaved_view_favoritesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "user_id" },
                          value: { kind: "Variable", name: { kind: "Name", value: "userId" } },
                        },
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "view_id" },
                          value: { kind: "Variable", name: { kind: "Name", value: "viewId" } },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "user_id" } },
                      { kind: "Field", name: { kind: "Name", value: "view_id" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ToggleSavedViewFavoriteMutation,
  ToggleSavedViewFavoriteMutationVariables
>;
export const DeleteSavedViewFavoriteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteSavedViewFavorite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "userId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "viewId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFromsaved_view_favoritesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "and" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "user_id" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "eq" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "userId" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "view_id" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "eq" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "viewId" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "user_id" } },
                      { kind: "Field", name: { kind: "Name", value: "view_id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteSavedViewFavoriteMutation,
  DeleteSavedViewFavoriteMutationVariables
>;
export const GetEnrollmentsForContactDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEnrollmentsForContact" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sales_sequence_enrollmentsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "contact_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "contactId" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "current_step_number" } },
                            { kind: "Field", name: { kind: "Name", value: "next_action_at" } },
                            { kind: "Field", name: { kind: "Name", value: "enrolled_at" } },
                            { kind: "Field", name: { kind: "Name", value: "pause_reason" } },
                            { kind: "Field", name: { kind: "Name", value: "deal_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "sequence_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sales_sequences" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sales_sequence_stepsCollection" },
                                    arguments: [
                                      {
                                        kind: "Argument",
                                        name: { kind: "Name", value: "orderBy" },
                                        value: {
                                          kind: "ListValue",
                                          values: [
                                            {
                                              kind: "ObjectValue",
                                              fields: [
                                                {
                                                  kind: "ObjectField",
                                                  name: { kind: "Name", value: "step_number" },
                                                  value: {
                                                    kind: "EnumValue",
                                                    value: "AscNullsLast",
                                                  },
                                                },
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "edges" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "node" },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "step_number" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "title" },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "channel" },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sales_sequence_step_eventsCollection" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "orderBy" },
                                  value: {
                                    kind: "ListValue",
                                    values: [
                                      {
                                        kind: "ObjectValue",
                                        fields: [
                                          {
                                            kind: "ObjectField",
                                            name: { kind: "Name", value: "occurred_at" },
                                            value: { kind: "EnumValue", value: "DescNullsLast" },
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                },
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "first" },
                                  value: { kind: "IntValue", value: "10" },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "edges" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "node" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "step_number" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "channel" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "outcome" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "occurred_at" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "note" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEnrollmentsForContactQuery, GetEnrollmentsForContactQueryVariables>;
export const UpdateSalesSequenceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateSalesSequence" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "set" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "sales_sequencesUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatesales_sequencesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: { kind: "Variable", name: { kind: "Name", value: "set" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "atMost" },
                value: { kind: "IntValue", value: "1" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "affectedCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "region_hint" } },
                      { kind: "Field", name: { kind: "Name", value: "is_active" } },
                      { kind: "Field", name: { kind: "Name", value: "is_default" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSalesSequenceMutation, UpdateSalesSequenceMutationVariables>;
export const UpdateSalesSequenceStepDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateSalesSequenceStep" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "set" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "sales_sequence_stepsUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatesales_sequence_stepsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: { kind: "Variable", name: { kind: "Name", value: "set" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "atMost" },
                value: { kind: "IntValue", value: "1" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "affectedCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "step_number" } },
                      { kind: "Field", name: { kind: "Name", value: "channel" } },
                      { kind: "Field", name: { kind: "Name", value: "delay_business_days" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "guidance" } },
                      { kind: "Field", name: { kind: "Name", value: "pause_for_reply" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateSalesSequenceStepMutation,
  UpdateSalesSequenceStepMutationVariables
>;
export const InsertSalesSequenceStepDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InsertSalesSequenceStep" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "object" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "sales_sequence_stepsInsertInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntosales_sequence_stepsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "Variable", name: { kind: "Name", value: "object" } }],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "step_number" } },
                      { kind: "Field", name: { kind: "Name", value: "channel" } },
                      { kind: "Field", name: { kind: "Name", value: "delay_business_days" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "guidance" } },
                      { kind: "Field", name: { kind: "Name", value: "pause_for_reply" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InsertSalesSequenceStepMutation,
  InsertSalesSequenceStepMutationVariables
>;
export const DeleteSalesSequenceStepDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteSalesSequenceStep" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFromsales_sequence_stepsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "atMost" },
                value: { kind: "IntValue", value: "1" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "affectedCount" } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteSalesSequenceStepMutation,
  DeleteSalesSequenceStepMutationVariables
>;
export const GetContactForSequenceEnrollDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetContactForSequenceEnroll" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contactsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "contactId" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "phone" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "companies" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetContactForSequenceEnrollQuery,
  GetContactForSequenceEnrollQueryVariables
>;
export const GetCompanyForSequenceEnrollDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCompanyForSequenceEnroll" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "companyId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "companiesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "companyId" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCompanyForSequenceEnrollQuery,
  GetCompanyForSequenceEnrollQueryVariables
>;
export const GetContactsForCompanyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetContactsForCompany" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "companyId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contactsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "company_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "companyId" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "name" },
                          value: { kind: "EnumValue", value: "AscNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "200" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetContactsForCompanyQuery, GetContactsForCompanyQueryVariables>;
export const GetSalesSequencesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSalesSequences" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sales_sequencesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "is_default" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "name" },
                          value: { kind: "EnumValue", value: "AscNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "target_type" } },
                            { kind: "Field", name: { kind: "Name", value: "region_hint" } },
                            { kind: "Field", name: { kind: "Name", value: "is_active" } },
                            { kind: "Field", name: { kind: "Name", value: "is_default" } },
                            { kind: "Field", name: { kind: "Name", value: "deal_stage_trigger" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sales_sequence_stepsCollection" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "orderBy" },
                                  value: {
                                    kind: "ListValue",
                                    values: [
                                      {
                                        kind: "ObjectValue",
                                        fields: [
                                          {
                                            kind: "ObjectField",
                                            name: { kind: "Name", value: "step_number" },
                                            value: { kind: "EnumValue", value: "AscNullsLast" },
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "edges" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "node" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "step_number" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "channel" },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "delay_business_days",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "title" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "guidance" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "pause_for_reply" },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSalesSequencesQuery, GetSalesSequencesQueryVariables>;
export const GetSkillsCatalogDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSkillsCatalog" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "skills_catalogFilter" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "skills_catalogOrderBy" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "skills_catalogCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "category" } },
                            { kind: "Field", name: { kind: "Name", value: "sort_order" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSkillsCatalogQuery, GetSkillsCatalogQueryVariables>;
export const GetSkillsCatalogAllDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSkillsCatalogAll" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "skills_catalogOrderBy" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "skills_catalogCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "500" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "name" } },
                            { kind: "Field", name: { kind: "Name", value: "category" } },
                            { kind: "Field", name: { kind: "Name", value: "sort_order" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSkillsCatalogAllQuery, GetSkillsCatalogAllQueryVariables>;
export const GetAppUserSkillsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAppUserSkills" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "app_user_skillsFilter" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "app_user_skillsOrderBy" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "app_user_skillsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "200" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            { kind: "Field", name: { kind: "Name", value: "skill_id" } },
                            { kind: "Field", name: { kind: "Name", value: "grade" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "skills_catalog" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "category" } },
                                  { kind: "Field", name: { kind: "Name", value: "sort_order" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAppUserSkillsQuery, GetAppUserSkillsQueryVariables>;
export const InsertAppUserSkillDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InsertAppUserSkill" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "app_user_skillsInsertInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntoapp_user_skillsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "Variable", name: { kind: "Name", value: "input" } }],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "user_id" } },
                      { kind: "Field", name: { kind: "Name", value: "skill_id" } },
                      { kind: "Field", name: { kind: "Name", value: "grade" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InsertAppUserSkillMutation, InsertAppUserSkillMutationVariables>;
export const UpdateAppUserSkillDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateAppUserSkill" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "app_user_skillsFilter" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "set" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "app_user_skillsUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateapp_user_skillsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: { kind: "Variable", name: { kind: "Name", value: "set" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "user_id" } },
                      { kind: "Field", name: { kind: "Name", value: "skill_id" } },
                      { kind: "Field", name: { kind: "Name", value: "grade" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateAppUserSkillMutation, UpdateAppUserSkillMutationVariables>;
export const DeleteAppUserSkillDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteAppUserSkill" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "app_user_skillsFilter" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFromapp_user_skillsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "user_id" } },
                      { kind: "Field", name: { kind: "Name", value: "skill_id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteAppUserSkillMutation, DeleteAppUserSkillMutationVariables>;
export const GetSocialMediaPostsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSocialMediaPosts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "social_media_postsFilter" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "social_media_postsOrderBy" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "social_media_postsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "SocialMediaPostFields" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SocialMediaPostFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "social_media_posts" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "media_kind" } },
          { kind: "Field", name: { kind: "Name", value: "media_url" } },
          { kind: "Field", name: { kind: "Name", value: "thumbnail_url" } },
          { kind: "Field", name: { kind: "Name", value: "drive_file_id" } },
          { kind: "Field", name: { kind: "Name", value: "drive_file_name" } },
          { kind: "Field", name: { kind: "Name", value: "drive_folder_id" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "youtube" } },
          { kind: "Field", name: { kind: "Name", value: "platforms" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_at" } },
          { kind: "Field", name: { kind: "Name", value: "published_at" } },
          { kind: "Field", name: { kind: "Name", value: "results" } },
          { kind: "Field", name: { kind: "Name", value: "error_summary" } },
          { kind: "Field", name: { kind: "Name", value: "contact_id" } },
          { kind: "Field", name: { kind: "Name", value: "company_id" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSocialMediaPostsQuery, GetSocialMediaPostsQueryVariables>;
export const GetSocialMediaPostDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSocialMediaPost" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "social_media_postsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "SocialMediaPostFields" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SocialMediaPostFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "social_media_posts" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "media_kind" } },
          { kind: "Field", name: { kind: "Name", value: "media_url" } },
          { kind: "Field", name: { kind: "Name", value: "thumbnail_url" } },
          { kind: "Field", name: { kind: "Name", value: "drive_file_id" } },
          { kind: "Field", name: { kind: "Name", value: "drive_file_name" } },
          { kind: "Field", name: { kind: "Name", value: "drive_folder_id" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "youtube" } },
          { kind: "Field", name: { kind: "Name", value: "platforms" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_at" } },
          { kind: "Field", name: { kind: "Name", value: "published_at" } },
          { kind: "Field", name: { kind: "Name", value: "results" } },
          { kind: "Field", name: { kind: "Name", value: "error_summary" } },
          { kind: "Field", name: { kind: "Name", value: "contact_id" } },
          { kind: "Field", name: { kind: "Name", value: "company_id" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSocialMediaPostQuery, GetSocialMediaPostQueryVariables>;
export const GetSocialMediaPostsByContactDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSocialMediaPostsByContact" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "social_media_postsOrderBy" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "social_media_postsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "contact_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "contactId" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "SocialMediaPostFields" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SocialMediaPostFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "social_media_posts" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "media_kind" } },
          { kind: "Field", name: { kind: "Name", value: "media_url" } },
          { kind: "Field", name: { kind: "Name", value: "thumbnail_url" } },
          { kind: "Field", name: { kind: "Name", value: "drive_file_id" } },
          { kind: "Field", name: { kind: "Name", value: "drive_file_name" } },
          { kind: "Field", name: { kind: "Name", value: "drive_folder_id" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "youtube" } },
          { kind: "Field", name: { kind: "Name", value: "platforms" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_at" } },
          { kind: "Field", name: { kind: "Name", value: "published_at" } },
          { kind: "Field", name: { kind: "Name", value: "results" } },
          { kind: "Field", name: { kind: "Name", value: "error_summary" } },
          { kind: "Field", name: { kind: "Name", value: "contact_id" } },
          { kind: "Field", name: { kind: "Name", value: "company_id" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSocialMediaPostsByContactQuery,
  GetSocialMediaPostsByContactQueryVariables
>;
export const GetSocialMediaPostsByCompanyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSocialMediaPostsByCompany" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "companyId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "social_media_postsOrderBy" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "social_media_postsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "company_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "companyId" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: { kind: "Variable", name: { kind: "Name", value: "orderBy" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "SocialMediaPostFields" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SocialMediaPostFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "social_media_posts" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "media_kind" } },
          { kind: "Field", name: { kind: "Name", value: "media_url" } },
          { kind: "Field", name: { kind: "Name", value: "thumbnail_url" } },
          { kind: "Field", name: { kind: "Name", value: "drive_file_id" } },
          { kind: "Field", name: { kind: "Name", value: "drive_file_name" } },
          { kind: "Field", name: { kind: "Name", value: "drive_folder_id" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "youtube" } },
          { kind: "Field", name: { kind: "Name", value: "platforms" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_at" } },
          { kind: "Field", name: { kind: "Name", value: "published_at" } },
          { kind: "Field", name: { kind: "Name", value: "results" } },
          { kind: "Field", name: { kind: "Name", value: "error_summary" } },
          { kind: "Field", name: { kind: "Name", value: "contact_id" } },
          { kind: "Field", name: { kind: "Name", value: "company_id" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSocialMediaPostsByCompanyQuery,
  GetSocialMediaPostsByCompanyQueryVariables
>;
export const CreateSocialMediaPostsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateSocialMediaPosts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "social_media_postsInsertInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntosocial_media_postsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "Variable", name: { kind: "Name", value: "input" } }],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "SocialMediaPostFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SocialMediaPostFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "social_media_posts" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "media_kind" } },
          { kind: "Field", name: { kind: "Name", value: "media_url" } },
          { kind: "Field", name: { kind: "Name", value: "thumbnail_url" } },
          { kind: "Field", name: { kind: "Name", value: "drive_file_id" } },
          { kind: "Field", name: { kind: "Name", value: "drive_file_name" } },
          { kind: "Field", name: { kind: "Name", value: "drive_folder_id" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "youtube" } },
          { kind: "Field", name: { kind: "Name", value: "platforms" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_at" } },
          { kind: "Field", name: { kind: "Name", value: "published_at" } },
          { kind: "Field", name: { kind: "Name", value: "results" } },
          { kind: "Field", name: { kind: "Name", value: "error_summary" } },
          { kind: "Field", name: { kind: "Name", value: "contact_id" } },
          { kind: "Field", name: { kind: "Name", value: "company_id" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateSocialMediaPostsMutation,
  CreateSocialMediaPostsMutationVariables
>;
export const UpdateSocialMediaPostsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateSocialMediaPosts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "social_media_postsUpdateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatesocial_media_postsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "SocialMediaPostFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SocialMediaPostFields" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "social_media_posts" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "brand" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "media_kind" } },
          { kind: "Field", name: { kind: "Name", value: "media_url" } },
          { kind: "Field", name: { kind: "Name", value: "thumbnail_url" } },
          { kind: "Field", name: { kind: "Name", value: "drive_file_id" } },
          { kind: "Field", name: { kind: "Name", value: "drive_file_name" } },
          { kind: "Field", name: { kind: "Name", value: "drive_folder_id" } },
          { kind: "Field", name: { kind: "Name", value: "tags" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "youtube" } },
          { kind: "Field", name: { kind: "Name", value: "platforms" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "scheduled_at" } },
          { kind: "Field", name: { kind: "Name", value: "published_at" } },
          { kind: "Field", name: { kind: "Name", value: "results" } },
          { kind: "Field", name: { kind: "Name", value: "error_summary" } },
          { kind: "Field", name: { kind: "Name", value: "contact_id" } },
          { kind: "Field", name: { kind: "Name", value: "company_id" } },
          { kind: "Field", name: { kind: "Name", value: "created_by" } },
          { kind: "Field", name: { kind: "Name", value: "created_at" } },
          { kind: "Field", name: { kind: "Name", value: "updated_at" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateSocialMediaPostsMutation,
  UpdateSocialMediaPostsMutationVariables
>;
export const DeleteSocialMediaPostsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteSocialMediaPosts" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFromsocial_media_postsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteSocialMediaPostsMutation,
  DeleteSocialMediaPostsMutationVariables
>;
export const GetContactUniqueTagsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetContactUniqueTags" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          defaultValue: { kind: "IntValue", value: "1000" },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contactsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "tags" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetContactUniqueTagsQuery, GetContactUniqueTagsQueryVariables>;
export const GetTicketUniqueTagsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTicketUniqueTags" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          defaultValue: { kind: "IntValue", value: "1000" },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ticketsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "tags" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTicketUniqueTagsQuery, GetTicketUniqueTagsQueryVariables>;
export const GetTaskUniqueTagsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTaskUniqueTags" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          defaultValue: { kind: "IntValue", value: "1000" },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contact_tasksCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "tags" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTaskUniqueTagsQuery, GetTaskUniqueTagsQueryVariables>;
export const GetEmailTemplateUniqueTagsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEmailTemplateUniqueTags" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          defaultValue: { kind: "IntValue", value: "1000" },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "email_templatesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "tags" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetEmailTemplateUniqueTagsQuery,
  GetEmailTemplateUniqueTagsQueryVariables
>;
export const GetMspDocumentUniqueTagsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMspDocumentUniqueTags" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          defaultValue: { kind: "IntValue", value: "1000" },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "msp_documentsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{ kind: "Field", name: { kind: "Name", value: "tags" } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMspDocumentUniqueTagsQuery, GetMspDocumentUniqueTagsQueryVariables>;
export const GetCompanyUniqueTechnologiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCompanyUniqueTechnologies" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          defaultValue: { kind: "IntValue", value: "1000" },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "companiesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "current_technologies" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCompanyUniqueTechnologiesQuery,
  GetCompanyUniqueTechnologiesQueryVariables
>;
export const GetTaskssDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTaskss" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "contact_tasksFilter" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contact_tasksCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "priority" } },
                            { kind: "Field", name: { kind: "Name", value: "due_date" } },
                            { kind: "Field", name: { kind: "Name", value: "completed_at" } },
                            { kind: "Field", name: { kind: "Name", value: "assigned_users" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            { kind: "Field", name: { kind: "Name", value: "entity_type" } },
                            { kind: "Field", name: { kind: "Name", value: "entity_id" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTaskssQuery, GetTaskssQueryVariables>;
export const GetTasksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTasks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "contact_tasksCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "priority" } },
                            { kind: "Field", name: { kind: "Name", value: "due_date" } },
                            { kind: "Field", name: { kind: "Name", value: "completed_at" } },
                            { kind: "Field", name: { kind: "Name", value: "assigned_users" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            { kind: "Field", name: { kind: "Name", value: "entity_type" } },
                            { kind: "Field", name: { kind: "Name", value: "entity_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "contacts" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  { kind: "Field", name: { kind: "Name", value: "name" } },
                                  { kind: "Field", name: { kind: "Name", value: "email" } },
                                  { kind: "Field", name: { kind: "Name", value: "company_name" } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTasksQuery, GetTasksQueryVariables>;
export const CreateTasksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateTasks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "contact_tasksInsertInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntocontact_tasksCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "Variable", name: { kind: "Name", value: "input" } }],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "priority" } },
                      { kind: "Field", name: { kind: "Name", value: "due_date" } },
                      { kind: "Field", name: { kind: "Name", value: "completed_at" } },
                      { kind: "Field", name: { kind: "Name", value: "assigned_users" } },
                      { kind: "Field", name: { kind: "Name", value: "tags" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                      { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                      { kind: "Field", name: { kind: "Name", value: "company_id" } },
                      { kind: "Field", name: { kind: "Name", value: "user_id" } },
                      { kind: "Field", name: { kind: "Name", value: "entity_type" } },
                      { kind: "Field", name: { kind: "Name", value: "entity_id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTasksMutation, CreateTasksMutationVariables>;
export const CreateTaskNoteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateTaskNote" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "task_notesInsertInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntotask_notesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "Variable", name: { kind: "Name", value: "input" } }],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "task_id" } },
                      { kind: "Field", name: { kind: "Name", value: "content" } },
                      { kind: "Field", name: { kind: "Name", value: "note_type" } },
                      { kind: "Field", name: { kind: "Name", value: "is_internal" } },
                      { kind: "Field", name: { kind: "Name", value: "user_id" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTaskNoteMutation, CreateTaskNoteMutationVariables>;
export const ListTaskNotesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ListTaskNotes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "taskId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "task_notesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "task_id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "taskId" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "AscNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "task_id" } },
                            { kind: "Field", name: { kind: "Name", value: "content" } },
                            { kind: "Field", name: { kind: "Name", value: "note_type" } },
                            { kind: "Field", name: { kind: "Name", value: "is_internal" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListTaskNotesQuery, ListTaskNotesQueryVariables>;
export const UpdateTaskNoteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateTaskNote" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "task_notesUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatetask_notesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "task_id" } },
                      { kind: "Field", name: { kind: "Name", value: "content" } },
                      { kind: "Field", name: { kind: "Name", value: "note_type" } },
                      { kind: "Field", name: { kind: "Name", value: "is_internal" } },
                      { kind: "Field", name: { kind: "Name", value: "user_id" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTaskNoteMutation, UpdateTaskNoteMutationVariables>;
export const DeleteTaskNoteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteTaskNote" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFromtask_notesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "task_id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteTaskNoteMutation, DeleteTaskNoteMutationVariables>;
export const UpdateTasksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateTasks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "contact_tasksUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatecontact_tasksCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "priority" } },
                      { kind: "Field", name: { kind: "Name", value: "due_date" } },
                      { kind: "Field", name: { kind: "Name", value: "completed_at" } },
                      { kind: "Field", name: { kind: "Name", value: "assigned_users" } },
                      { kind: "Field", name: { kind: "Name", value: "tags" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                      { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                      { kind: "Field", name: { kind: "Name", value: "company_id" } },
                      { kind: "Field", name: { kind: "Name", value: "user_id" } },
                      { kind: "Field", name: { kind: "Name", value: "entity_type" } },
                      { kind: "Field", name: { kind: "Name", value: "entity_id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTasksMutation, UpdateTasksMutationVariables>;
export const DeleteTasksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteTasks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFromcontact_tasksCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteTasksMutation, DeleteTasksMutationVariables>;
export const GetTicketssDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTicketss" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ticketsFilter" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ticketsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "ticket_number" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "description_preview" } },
                            { kind: "Field", name: { kind: "Name", value: "description_s3_key" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description_content_type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description_byte_size" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_name" } },
                            { kind: "Field", name: { kind: "Name", value: "is_software" } },
                            { kind: "Field", name: { kind: "Name", value: "assigned_to" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "priority" } },
                            { kind: "Field", name: { kind: "Name", value: "category" } },
                            { kind: "Field", name: { kind: "Name", value: "estimated_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "actual_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "billable_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "non_billable_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "hourly_rate" } },
                            { kind: "Field", name: { kind: "Name", value: "total_cost" } },
                            { kind: "Field", name: { kind: "Name", value: "total_billed" } },
                            { kind: "Field", name: { kind: "Name", value: "discount_amount" } },
                            { kind: "Field", name: { kind: "Name", value: "discount_type" } },
                            { kind: "Field", name: { kind: "Name", value: "discount_percentage" } },
                            { kind: "Field", name: { kind: "Name", value: "sla_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "due_date" } },
                            { kind: "Field", name: { kind: "Name", value: "resolved_at" } },
                            { kind: "Field", name: { kind: "Name", value: "closed_at" } },
                            { kind: "Field", name: { kind: "Name", value: "auto_assign" } },
                            { kind: "Field", name: { kind: "Name", value: "auto_escalate" } },
                            { kind: "Field", name: { kind: "Name", value: "escalation_level" } },
                            { kind: "Field", name: { kind: "Name", value: "last_escalation_at" } },
                            { kind: "Field", name: { kind: "Name", value: "reminder_sent" } },
                            { kind: "Field", name: { kind: "Name", value: "reminder_sent_at" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "internal_notes" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "customer_visible_notes" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "is_internal" } },
                            { kind: "Field", name: { kind: "Name", value: "has_time_entries" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last_follow_up_task_created_at" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "last_activity_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTicketssQuery, GetTicketssQueryVariables>;
export const GetTicketsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTickets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ticketsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "ticket_number" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "description_preview" } },
                            { kind: "Field", name: { kind: "Name", value: "description_s3_key" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description_content_type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description_byte_size" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_name" } },
                            { kind: "Field", name: { kind: "Name", value: "is_software" } },
                            { kind: "Field", name: { kind: "Name", value: "assigned_to" } },
                            { kind: "Field", name: { kind: "Name", value: "created_by" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "priority" } },
                            { kind: "Field", name: { kind: "Name", value: "category" } },
                            { kind: "Field", name: { kind: "Name", value: "estimated_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "actual_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "billable_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "non_billable_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "hourly_rate" } },
                            { kind: "Field", name: { kind: "Name", value: "total_cost" } },
                            { kind: "Field", name: { kind: "Name", value: "total_billed" } },
                            { kind: "Field", name: { kind: "Name", value: "discount_amount" } },
                            { kind: "Field", name: { kind: "Name", value: "discount_type" } },
                            { kind: "Field", name: { kind: "Name", value: "discount_percentage" } },
                            { kind: "Field", name: { kind: "Name", value: "sla_hours" } },
                            { kind: "Field", name: { kind: "Name", value: "due_date" } },
                            { kind: "Field", name: { kind: "Name", value: "resolved_at" } },
                            { kind: "Field", name: { kind: "Name", value: "closed_at" } },
                            { kind: "Field", name: { kind: "Name", value: "auto_assign" } },
                            { kind: "Field", name: { kind: "Name", value: "auto_escalate" } },
                            { kind: "Field", name: { kind: "Name", value: "escalation_level" } },
                            { kind: "Field", name: { kind: "Name", value: "last_escalation_at" } },
                            { kind: "Field", name: { kind: "Name", value: "reminder_sent" } },
                            { kind: "Field", name: { kind: "Name", value: "reminder_sent_at" } },
                            { kind: "Field", name: { kind: "Name", value: "tags" } },
                            { kind: "Field", name: { kind: "Name", value: "internal_notes" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "customer_visible_notes" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "is_internal" } },
                            { kind: "Field", name: { kind: "Name", value: "has_time_entries" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last_follow_up_task_created_at" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "last_activity_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTicketsQuery, GetTicketsQueryVariables>;
export const CreateTicketsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateTickets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ticketsInsertInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntoticketsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "Variable", name: { kind: "Name", value: "input" } }],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "ticket_number" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "description_preview" } },
                      { kind: "Field", name: { kind: "Name", value: "description_s3_key" } },
                      { kind: "Field", name: { kind: "Name", value: "description_content_type" } },
                      { kind: "Field", name: { kind: "Name", value: "description_byte_size" } },
                      { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                      { kind: "Field", name: { kind: "Name", value: "company_id" } },
                      { kind: "Field", name: { kind: "Name", value: "company_name" } },
                      { kind: "Field", name: { kind: "Name", value: "contact_name" } },
                      { kind: "Field", name: { kind: "Name", value: "is_software" } },
                      { kind: "Field", name: { kind: "Name", value: "assigned_to" } },
                      { kind: "Field", name: { kind: "Name", value: "created_by" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "priority" } },
                      { kind: "Field", name: { kind: "Name", value: "category" } },
                      { kind: "Field", name: { kind: "Name", value: "estimated_hours" } },
                      { kind: "Field", name: { kind: "Name", value: "actual_hours" } },
                      { kind: "Field", name: { kind: "Name", value: "billable_hours" } },
                      { kind: "Field", name: { kind: "Name", value: "non_billable_hours" } },
                      { kind: "Field", name: { kind: "Name", value: "hourly_rate" } },
                      { kind: "Field", name: { kind: "Name", value: "total_cost" } },
                      { kind: "Field", name: { kind: "Name", value: "total_billed" } },
                      { kind: "Field", name: { kind: "Name", value: "discount_amount" } },
                      { kind: "Field", name: { kind: "Name", value: "discount_type" } },
                      { kind: "Field", name: { kind: "Name", value: "discount_percentage" } },
                      { kind: "Field", name: { kind: "Name", value: "sla_hours" } },
                      { kind: "Field", name: { kind: "Name", value: "due_date" } },
                      { kind: "Field", name: { kind: "Name", value: "resolved_at" } },
                      { kind: "Field", name: { kind: "Name", value: "closed_at" } },
                      { kind: "Field", name: { kind: "Name", value: "auto_assign" } },
                      { kind: "Field", name: { kind: "Name", value: "auto_escalate" } },
                      { kind: "Field", name: { kind: "Name", value: "escalation_level" } },
                      { kind: "Field", name: { kind: "Name", value: "last_escalation_at" } },
                      { kind: "Field", name: { kind: "Name", value: "reminder_sent" } },
                      { kind: "Field", name: { kind: "Name", value: "reminder_sent_at" } },
                      { kind: "Field", name: { kind: "Name", value: "tags" } },
                      { kind: "Field", name: { kind: "Name", value: "internal_notes" } },
                      { kind: "Field", name: { kind: "Name", value: "customer_visible_notes" } },
                      { kind: "Field", name: { kind: "Name", value: "is_internal" } },
                      { kind: "Field", name: { kind: "Name", value: "has_time_entries" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "last_follow_up_task_created_at" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "last_activity_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTicketsMutation, CreateTicketsMutationVariables>;
export const UpdateTicketsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateTickets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ticketsUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateticketsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "ticket_number" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "description_preview" } },
                      { kind: "Field", name: { kind: "Name", value: "description_s3_key" } },
                      { kind: "Field", name: { kind: "Name", value: "description_content_type" } },
                      { kind: "Field", name: { kind: "Name", value: "description_byte_size" } },
                      { kind: "Field", name: { kind: "Name", value: "contact_id" } },
                      { kind: "Field", name: { kind: "Name", value: "company_id" } },
                      { kind: "Field", name: { kind: "Name", value: "company_name" } },
                      { kind: "Field", name: { kind: "Name", value: "contact_name" } },
                      { kind: "Field", name: { kind: "Name", value: "is_software" } },
                      { kind: "Field", name: { kind: "Name", value: "assigned_to" } },
                      { kind: "Field", name: { kind: "Name", value: "created_by" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "priority" } },
                      { kind: "Field", name: { kind: "Name", value: "category" } },
                      { kind: "Field", name: { kind: "Name", value: "estimated_hours" } },
                      { kind: "Field", name: { kind: "Name", value: "actual_hours" } },
                      { kind: "Field", name: { kind: "Name", value: "billable_hours" } },
                      { kind: "Field", name: { kind: "Name", value: "non_billable_hours" } },
                      { kind: "Field", name: { kind: "Name", value: "hourly_rate" } },
                      { kind: "Field", name: { kind: "Name", value: "total_cost" } },
                      { kind: "Field", name: { kind: "Name", value: "total_billed" } },
                      { kind: "Field", name: { kind: "Name", value: "discount_amount" } },
                      { kind: "Field", name: { kind: "Name", value: "discount_type" } },
                      { kind: "Field", name: { kind: "Name", value: "discount_percentage" } },
                      { kind: "Field", name: { kind: "Name", value: "sla_hours" } },
                      { kind: "Field", name: { kind: "Name", value: "due_date" } },
                      { kind: "Field", name: { kind: "Name", value: "resolved_at" } },
                      { kind: "Field", name: { kind: "Name", value: "closed_at" } },
                      { kind: "Field", name: { kind: "Name", value: "auto_assign" } },
                      { kind: "Field", name: { kind: "Name", value: "auto_escalate" } },
                      { kind: "Field", name: { kind: "Name", value: "escalation_level" } },
                      { kind: "Field", name: { kind: "Name", value: "last_escalation_at" } },
                      { kind: "Field", name: { kind: "Name", value: "reminder_sent" } },
                      { kind: "Field", name: { kind: "Name", value: "reminder_sent_at" } },
                      { kind: "Field", name: { kind: "Name", value: "tags" } },
                      { kind: "Field", name: { kind: "Name", value: "internal_notes" } },
                      { kind: "Field", name: { kind: "Name", value: "customer_visible_notes" } },
                      { kind: "Field", name: { kind: "Name", value: "is_internal" } },
                      { kind: "Field", name: { kind: "Name", value: "has_time_entries" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "last_follow_up_task_created_at" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "last_activity_at" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTicketsMutation, UpdateTicketsMutationVariables>;
export const DeleteTicketsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteTickets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFromticketsCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteTicketsMutation, DeleteTicketsMutationVariables>;
export const GetTimeEntriessDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTimeEntriess" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "time_entriesFilter" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "time_entriesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "ticket_id" } },
                            { kind: "Field", name: { kind: "Name", value: "ticket_number" } },
                            { kind: "Field", name: { kind: "Name", value: "ticket_title" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_name" } },
                            { kind: "Field", name: { kind: "Name", value: "is_software" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            { kind: "Field", name: { kind: "Name", value: "user_name" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "hours" } },
                            { kind: "Field", name: { kind: "Name", value: "entry_type" } },
                            { kind: "Field", name: { kind: "Name", value: "billable_rate" } },
                            { kind: "Field", name: { kind: "Name", value: "date_worked" } },
                            { kind: "Field", name: { kind: "Name", value: "start_time" } },
                            { kind: "Field", name: { kind: "Name", value: "end_time" } },
                            { kind: "Field", name: { kind: "Name", value: "is_approved" } },
                            { kind: "Field", name: { kind: "Name", value: "approved_by" } },
                            { kind: "Field", name: { kind: "Name", value: "approved_at" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last_follow_up_task_created_at" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "sync_status" } },
                            { kind: "Field", name: { kind: "Name", value: "quickbooks_id" } },
                            { kind: "Field", name: { kind: "Name", value: "synced_at" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_employee_ref" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_customer_ref" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTimeEntriessQuery, GetTimeEntriessQueryVariables>;
export const GetTimeEntriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTimeEntries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "time_entriesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "ticket_id" } },
                            { kind: "Field", name: { kind: "Name", value: "ticket_number" } },
                            { kind: "Field", name: { kind: "Name", value: "ticket_title" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            { kind: "Field", name: { kind: "Name", value: "contact_name" } },
                            { kind: "Field", name: { kind: "Name", value: "is_software" } },
                            { kind: "Field", name: { kind: "Name", value: "user_id" } },
                            { kind: "Field", name: { kind: "Name", value: "user_name" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "hours" } },
                            { kind: "Field", name: { kind: "Name", value: "entry_type" } },
                            { kind: "Field", name: { kind: "Name", value: "billable_rate" } },
                            { kind: "Field", name: { kind: "Name", value: "date_worked" } },
                            { kind: "Field", name: { kind: "Name", value: "start_time" } },
                            { kind: "Field", name: { kind: "Name", value: "end_time" } },
                            { kind: "Field", name: { kind: "Name", value: "is_approved" } },
                            { kind: "Field", name: { kind: "Name", value: "approved_by" } },
                            { kind: "Field", name: { kind: "Name", value: "approved_at" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "last_follow_up_task_created_at" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "sync_status" } },
                            { kind: "Field", name: { kind: "Name", value: "quickbooks_id" } },
                            { kind: "Field", name: { kind: "Name", value: "synced_at" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_employee_ref" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_customer_ref" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTimeEntriesQuery, GetTimeEntriesQueryVariables>;
export const GetClientTimeEntriessDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClientTimeEntriess" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "time_entriesFilter" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "time_entriesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "date_worked" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "ticket_id" } },
                            { kind: "Field", name: { kind: "Name", value: "ticket_number" } },
                            { kind: "Field", name: { kind: "Name", value: "ticket_title" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "hours" } },
                            { kind: "Field", name: { kind: "Name", value: "entry_type" } },
                            { kind: "Field", name: { kind: "Name", value: "date_worked" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClientTimeEntriessQuery, GetClientTimeEntriessQueryVariables>;
export const GetClientTimeEntriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetClientTimeEntries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "time_entriesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "ticket_id" } },
                            { kind: "Field", name: { kind: "Name", value: "ticket_number" } },
                            { kind: "Field", name: { kind: "Name", value: "ticket_title" } },
                            { kind: "Field", name: { kind: "Name", value: "company_id" } },
                            { kind: "Field", name: { kind: "Name", value: "company_name" } },
                            { kind: "Field", name: { kind: "Name", value: "description" } },
                            { kind: "Field", name: { kind: "Name", value: "hours" } },
                            { kind: "Field", name: { kind: "Name", value: "entry_type" } },
                            { kind: "Field", name: { kind: "Name", value: "date_worked" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClientTimeEntriesQuery, GetClientTimeEntriesQueryVariables>;
export const CreateTimeEntriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateTimeEntries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "time_entriesInsertInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntotime_entriesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "Variable", name: { kind: "Name", value: "input" } }],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "ticket_id" } },
                      { kind: "Field", name: { kind: "Name", value: "company_id" } },
                      { kind: "Field", name: { kind: "Name", value: "user_id" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "hours" } },
                      { kind: "Field", name: { kind: "Name", value: "entry_type" } },
                      { kind: "Field", name: { kind: "Name", value: "billable_rate" } },
                      { kind: "Field", name: { kind: "Name", value: "date_worked" } },
                      { kind: "Field", name: { kind: "Name", value: "start_time" } },
                      { kind: "Field", name: { kind: "Name", value: "end_time" } },
                      { kind: "Field", name: { kind: "Name", value: "is_approved" } },
                      { kind: "Field", name: { kind: "Name", value: "approved_by" } },
                      { kind: "Field", name: { kind: "Name", value: "approved_at" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "last_follow_up_task_created_at" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "sync_status" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_id" } },
                      { kind: "Field", name: { kind: "Name", value: "synced_at" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_employee_ref" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_customer_ref" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTimeEntriesMutation, CreateTimeEntriesMutationVariables>;
export const UpdateTimeEntriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateTimeEntries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "time_entriesUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updatetime_entriesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "ticket_id" } },
                      { kind: "Field", name: { kind: "Name", value: "company_id" } },
                      { kind: "Field", name: { kind: "Name", value: "user_id" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "hours" } },
                      { kind: "Field", name: { kind: "Name", value: "entry_type" } },
                      { kind: "Field", name: { kind: "Name", value: "billable_rate" } },
                      { kind: "Field", name: { kind: "Name", value: "date_worked" } },
                      { kind: "Field", name: { kind: "Name", value: "start_time" } },
                      { kind: "Field", name: { kind: "Name", value: "end_time" } },
                      { kind: "Field", name: { kind: "Name", value: "is_approved" } },
                      { kind: "Field", name: { kind: "Name", value: "approved_by" } },
                      { kind: "Field", name: { kind: "Name", value: "approved_at" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "last_follow_up_task_created_at" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "sync_status" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_id" } },
                      { kind: "Field", name: { kind: "Name", value: "synced_at" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_employee_ref" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_customer_ref" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTimeEntriesMutation, UpdateTimeEntriesMutationVariables>;
export const DeleteTimeEntriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteTimeEntries" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFromtime_entriesCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteTimeEntriesMutation, DeleteTimeEntriesMutationVariables>;
export const GetUserssDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserss" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "filter" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "app_usersFilter" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "app_usersCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: { kind: "Variable", name: { kind: "Name", value: "filter" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "created_at" },
                          value: { kind: "EnumValue", value: "DescNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "first_name" } },
                            { kind: "Field", name: { kind: "Name", value: "last_name" } },
                            { kind: "Field", name: { kind: "Name", value: "role_id" } },
                            { kind: "Field", name: { kind: "Name", value: "is_active" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_access_token" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_refresh_token" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "quickbooks_realm_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_environment" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_token_expires_at" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_connected_at" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_last_sync_at" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_employee_ref" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_employee_name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_connections" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_active_realm_id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserssQuery, GetUserssQueryVariables>;
export const SearchUsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchUsers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Cursor" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "search" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "isActive" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "app_usersCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "Variable", name: { kind: "Name", value: "first" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: { kind: "Variable", name: { kind: "Name", value: "after" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "and" },
                      value: {
                        kind: "ListValue",
                        values: [
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "is_active" },
                                value: {
                                  kind: "ObjectValue",
                                  fields: [
                                    {
                                      kind: "ObjectField",
                                      name: { kind: "Name", value: "eq" },
                                      value: {
                                        kind: "Variable",
                                        name: { kind: "Name", value: "isActive" },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: "ObjectValue",
                            fields: [
                              {
                                kind: "ObjectField",
                                name: { kind: "Name", value: "or" },
                                value: {
                                  kind: "ListValue",
                                  values: [
                                    {
                                      kind: "ObjectValue",
                                      fields: [
                                        {
                                          kind: "ObjectField",
                                          name: { kind: "Name", value: "email" },
                                          value: {
                                            kind: "ObjectValue",
                                            fields: [
                                              {
                                                kind: "ObjectField",
                                                name: { kind: "Name", value: "ilike" },
                                                value: {
                                                  kind: "Variable",
                                                  name: { kind: "Name", value: "search" },
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: "ObjectValue",
                                      fields: [
                                        {
                                          kind: "ObjectField",
                                          name: { kind: "Name", value: "first_name" },
                                          value: {
                                            kind: "ObjectValue",
                                            fields: [
                                              {
                                                kind: "ObjectField",
                                                name: { kind: "Name", value: "ilike" },
                                                value: {
                                                  kind: "Variable",
                                                  name: { kind: "Name", value: "search" },
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: "ObjectValue",
                                      fields: [
                                        {
                                          kind: "ObjectField",
                                          name: { kind: "Name", value: "last_name" },
                                          value: {
                                            kind: "ObjectValue",
                                            fields: [
                                              {
                                                kind: "ObjectField",
                                                name: { kind: "Name", value: "ilike" },
                                                value: {
                                                  kind: "Variable",
                                                  name: { kind: "Name", value: "search" },
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderBy" },
                value: {
                  kind: "ListValue",
                  values: [
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "first_name" },
                          value: { kind: "EnumValue", value: "AscNullsLast" },
                        },
                      ],
                    },
                    {
                      kind: "ObjectValue",
                      fields: [
                        {
                          kind: "ObjectField",
                          name: { kind: "Name", value: "last_name" },
                          value: { kind: "EnumValue", value: "AscNullsLast" },
                        },
                      ],
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "first_name" } },
                            { kind: "Field", name: { kind: "Name", value: "last_name" } },
                            { kind: "Field", name: { kind: "Name", value: "role_id" } },
                            { kind: "Field", name: { kind: "Name", value: "is_active" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                      { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchUsersQuery, SearchUsersQueryVariables>;
export const GetUsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUsers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "app_usersCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "email" } },
                            { kind: "Field", name: { kind: "Name", value: "first_name" } },
                            { kind: "Field", name: { kind: "Name", value: "last_name" } },
                            { kind: "Field", name: { kind: "Name", value: "role_id" } },
                            { kind: "Field", name: { kind: "Name", value: "is_active" } },
                            { kind: "Field", name: { kind: "Name", value: "created_at" } },
                            { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_access_token" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_refresh_token" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "quickbooks_realm_id" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_environment" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_token_expires_at" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_connected_at" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_last_sync_at" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_employee_ref" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_employee_name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_connections" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "quickbooks_active_realm_id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "meridian_default_email_connection_id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "meridian_default_email_provider" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUsersQuery, GetUsersQueryVariables>;
export const CreateUsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateUsers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "app_usersInsertInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "insertIntoapp_usersCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "objects" },
                value: {
                  kind: "ListValue",
                  values: [{ kind: "Variable", name: { kind: "Name", value: "input" } }],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "first_name" } },
                      { kind: "Field", name: { kind: "Name", value: "last_name" } },
                      { kind: "Field", name: { kind: "Name", value: "role_id" } },
                      { kind: "Field", name: { kind: "Name", value: "is_active" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_access_token" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_refresh_token" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_realm_id" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_environment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "quickbooks_token_expires_at" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_connected_at" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_last_sync_at" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_employee_ref" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_employee_name" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_connections" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "quickbooks_active_realm_id" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateUsersMutation, CreateUsersMutationVariables>;
export const UpdateUsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateUsers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "app_usersUpdateInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateapp_usersCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "set" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      { kind: "Field", name: { kind: "Name", value: "first_name" } },
                      { kind: "Field", name: { kind: "Name", value: "last_name" } },
                      { kind: "Field", name: { kind: "Name", value: "role_id" } },
                      { kind: "Field", name: { kind: "Name", value: "is_active" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "updated_at" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_access_token" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_refresh_token" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_realm_id" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_environment" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "quickbooks_token_expires_at" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_connected_at" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_last_sync_at" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_employee_ref" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_employee_name" } },
                      { kind: "Field", name: { kind: "Name", value: "quickbooks_connections" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "quickbooks_active_realm_id" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUsersMutation, UpdateUsersMutationVariables>;
export const DeleteUsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteUsers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "UUID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFromapp_usersCollection" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "eq" },
                            value: { kind: "Variable", name: { kind: "Name", value: "id" } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "records" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteUsersMutation, DeleteUsersMutationVariables>;
